module.exports = [
	{
		"type": "R",
		"operator": "CFR",
		"number": "2872",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "12:35",
				"arrivesAt": "12:44",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Drăguţeşti h.",
				"leavesAt": "12:45",
				"arrivesAt": "12:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "12:51",
				"arrivesAt": "12:55",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Vârţ h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vârţ h.",
				"to": "Rogojelu",
				"leavesAt": "13:01",
				"arrivesAt": "13:05",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "13:10",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Rovinari Hm.",
				"to": "Rovinari Sud h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "13:21",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Bâlteni h.",
				"leavesAt": "13:27",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bâlteni h.",
				"to": "Peşteana Jiu h.",
				"leavesAt": "13:32",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Plopşoru",
				"leavesAt": "13:36",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Plopşoru",
				"to": "Sărdăneşti h.",
				"leavesAt": "13:45",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Gârbovu h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Gârbovu h.",
				"to": "Turceni",
				"leavesAt": "13:57",
				"arrivesAt": "14:04",
				"waitsAtSource": 60,
				"distance": 6600
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9473",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Bradu de Sus",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Pârvu Hm.",
				"to": "Pârvu h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Pârvu h.",
				"to": "Suseni h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:55",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Suseni h.",
				"to": "Costeşti",
				"leavesAt": "13:56",
				"arrivesAt": "14:06",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "14:07",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "14:19",
				"arrivesAt": "14:27",
				"waitsAtSource": 240,
				"distance": 8000
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "14:28",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "14:34",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "14:45",
				"arrivesAt": "14:52",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "14:53",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "15:01",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "15:09",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "15:18",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "15:27",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "15:46",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 895
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 895
			},
			{
				"from": "20180526",
				"to": "20180603",
				"daysOfWeek": 895
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 895
			},
			{
				"from": "20180616",
				"to": "20180617",
				"daysOfWeek": 895
			},
			{
				"from": "20180623",
				"to": "20180624",
				"daysOfWeek": 895
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 895
			},
			{
				"from": "20180707",
				"to": "20180708",
				"daysOfWeek": 895
			},
			{
				"from": "20180714",
				"to": "20180715",
				"daysOfWeek": 895
			},
			{
				"from": "20180721",
				"to": "20180722",
				"daysOfWeek": 895
			},
			{
				"from": "20180728",
				"to": "20180729",
				"daysOfWeek": 895
			},
			{
				"from": "20180804",
				"to": "20180805",
				"daysOfWeek": 895
			},
			{
				"from": "20180811",
				"to": "20180819",
				"daysOfWeek": 895
			},
			{
				"from": "20180825",
				"to": "20180826",
				"daysOfWeek": 895
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 895
			},
			{
				"from": "20180908",
				"to": "20180909",
				"daysOfWeek": 895
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 895
			},
			{
				"from": "20180922",
				"to": "20181208",
				"daysOfWeek": 895
			},
			{
				"from": "20171210",
				"to": "20180506",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9008",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "13:05",
				"arrivesAt": "13:08",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:18",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "13:19",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Leu Hm.",
				"leavesAt": "13:26",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Leu Hm.",
				"to": "Ţărţăl h.",
				"leavesAt": "13:36",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ţărţăl h.",
				"to": "Jianca",
				"leavesAt": "13:41",
				"arrivesAt": "13:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jianca",
				"to": "Radomiru hc.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Radomiru hc.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "13:50",
				"arrivesAt": "13:55",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Cezieni h.",
				"leavesAt": "13:56",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Cezieni h.",
				"to": "Caracal",
				"leavesAt": "14:02",
				"arrivesAt": "14:08",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Caracal",
				"to": "Fărcaşele Hm.",
				"leavesAt": "14:10",
				"arrivesAt": "14:16",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Stoeneşti h.",
				"leavesAt": "14:17",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "14:21",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Dăneasa h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dăneasa h.",
				"to": "Radomireşti Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Măldăeni Hm.",
				"leavesAt": "14:53",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "15:04",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:22",
				"waitsAtSource": 180,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "15:32",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "15:38",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "16:08",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "16:28",
				"arrivesAt": "16:33",
				"waitsAtSource": 600,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Zorile h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zorile h.",
				"to": "Grădinari",
				"leavesAt": "16:52",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "17:09",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "17:26",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Carpaţi h.(900)",
				"leavesAt": "17:30",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "17:37",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9403",
		"segments": [
			{
				"from": "Caracal",
				"to": "Romula Hm.",
				"leavesAt": "07:12",
				"arrivesAt": "07:25",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Romula Hm.",
				"to": "Fălcoiu h.",
				"leavesAt": "07:26",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fălcoiu h.",
				"to": "Vlăduleni",
				"leavesAt": "07:36",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni",
				"to": "Şopârliţa hc.",
				"leavesAt": "07:45",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Piatra Olt",
				"leavesAt": "07:50",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:22",
				"waitsAtSource": 660,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "08:39",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5052",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "04:24",
				"arrivesAt": "04:32",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "04:33",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "04:55",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "05:20",
				"arrivesAt": "05:30",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "05:31",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "05:52",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "06:06",
				"arrivesAt": "06:15",
				"waitsAtSource": 120,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "06:16",
				"arrivesAt": "06:21",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "06:37",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "06:53",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "06:58",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "07:04",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "07:07",
				"arrivesAt": "07:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "07:15",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "07:23",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Crivina",
				"leavesAt": "07:32",
				"arrivesAt": "07:53",
				"waitsAtSource": 120,
				"distance": 20500
			},
			{
				"from": "Crivina",
				"to": "Buftea",
				"leavesAt": "07:54",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "08:10",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4205",
		"segments": [
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "04:28",
				"arrivesAt": "04:31",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Roşu Hm.",
				"leavesAt": "04:32",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Roşu Hm.",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "04:40",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Floreni",
				"leavesAt": "04:46",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Floreni",
				"to": "Coşna Hm.",
				"leavesAt": "04:53",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Coşna Hm.",
				"to": "Grădiniţa",
				"leavesAt": "05:03",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Grădiniţa",
				"to": "Larion Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:26",
				"waitsAtSource": 240,
				"distance": 5300
			},
			{
				"from": "Larion Hm.",
				"to": "Silhoasa Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "05:39",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Ilva Mare Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "05:59",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "06:10",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Strâmba h.",
				"leavesAt": "06:29",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Strâmba h.",
				"to": "Ilva Mică",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ilva Mică",
				"to": "Podereia Feldrului h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:48",
				"waitsAtSource": 240,
				"distance": 2900
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Feldru Hm.",
				"leavesAt": "06:49",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Feldru Hm.",
				"to": "Nepos h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:01",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Nepos h.",
				"to": "Rebrişoara Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Năsăud",
				"leavesAt": "07:09",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Năsăud",
				"to": "Năsăud h.",
				"leavesAt": "07:19",
				"arrivesAt": "07:21",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Năsăud h.",
				"to": "Salva",
				"leavesAt": "07:22",
				"arrivesAt": "07:27",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Salva",
				"to": "Mititei h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Mititei h.",
				"to": "Nimigea Hm.",
				"leavesAt": "07:31",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "07:38",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "07:50",
				"arrivesAt": "07:58",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:25",
				"waitsAtSource": 1140,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "08:26",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "08:42",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "08:59",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Nord",
				"leavesAt": "09:03",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4206",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Viişoara h.",
				"leavesAt": "12:20",
				"arrivesAt": "12:26",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Viişoara h.",
				"to": "Sărata h.",
				"leavesAt": "12:27",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "12:31",
				"arrivesAt": "12:36",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "12:37",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "12:42",
				"arrivesAt": "12:47",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "12:54",
				"arrivesAt": "12:57",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "13:03",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "13:40",
				"arrivesAt": "13:48",
				"waitsAtSource": 1680,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "13:49",
				"arrivesAt": "13:52",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "13:53",
				"arrivesAt": "13:57",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "13:58",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "14:09",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Năsăud h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Năsăud h.",
				"to": "Năsăud",
				"leavesAt": "14:18",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Năsăud",
				"to": "Rebrişoara Hm.",
				"leavesAt": "14:26",
				"arrivesAt": "14:31",
				"waitsAtSource": 300,
				"distance": 4800
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Nepos h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Nepos h.",
				"to": "Feldru Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Feldru Hm.",
				"to": "Podereia Feldrului h.",
				"leavesAt": "14:46",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Ilva Mică",
				"leavesAt": "14:50",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Ilva Mică",
				"to": "Strâmba h.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmba h.",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:07",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "15:08",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "15:17",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mare Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "15:35",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Lunca Ilvei",
				"to": "Silhoasa Hm.",
				"leavesAt": "15:45",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Larion Hm.",
				"leavesAt": "15:54",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Larion Hm.",
				"to": "Grădiniţa",
				"leavesAt": "16:05",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Grădiniţa",
				"to": "Coşna Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:31",
				"waitsAtSource": 360,
				"distance": 8000
			},
			{
				"from": "Coşna Hm.",
				"to": "Floreni",
				"leavesAt": "16:32",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Floreni",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:54",
				"waitsAtSource": 540,
				"distance": 3500
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Roşu Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Roşu Hm.",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "17:02",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4335",
		"segments": [
			{
				"from": "Valea lui Mihai",
				"to": "Curtuiuşeni h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:59",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Resighea h.",
				"leavesAt": "13:00",
				"arrivesAt": "13:07",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Resighea h.",
				"to": "Sanislău Hm.",
				"leavesAt": "13:08",
				"arrivesAt": "13:13",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Sanislău Hm.",
				"to": "Marna h.",
				"leavesAt": "13:14",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Marna h.",
				"to": "Carei",
				"leavesAt": "13:20",
				"arrivesAt": "13:28",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "13:39",
				"arrivesAt": "13:43",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "13:44",
				"arrivesAt": "13:48",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "13:49",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "13:59",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "14:07",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4331",
		"segments": [
			{
				"from": "Oradea",
				"to": "Diosig Hm.",
				"leavesAt": "02:53",
				"arrivesAt": "03:25",
				"waitsAtSource": 0,
				"distance": 33700
			},
			{
				"from": "Diosig Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "03:34",
				"arrivesAt": "03:45",
				"waitsAtSource": 540,
				"distance": 10500
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Şilindru Hm.",
				"leavesAt": "03:46",
				"arrivesAt": "03:54",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Şilindru Hm.",
				"to": "Simion h.",
				"leavesAt": "03:55",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Simion h.",
				"to": "Valea lui Mihai",
				"leavesAt": "04:03",
				"arrivesAt": "04:10",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Valea lui Mihai",
				"to": "Curtuiuşeni h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:42",
				"waitsAtSource": 1500,
				"distance": 6300
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Resighea h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Resighea h.",
				"to": "Sanislău Hm.",
				"leavesAt": "04:51",
				"arrivesAt": "04:56",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Sanislău Hm.",
				"to": "Marna h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Marna h.",
				"to": "Carei",
				"leavesAt": "05:03",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:30",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "05:41",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "05:49",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 960,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4074",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:58",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "13:59",
				"arrivesAt": "14:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "14:04",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "14:11",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Zalău Nord",
				"to": "Guruslău h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:38",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Guruslău h.",
				"to": "Borla Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Borla Hm.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:54",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Sărmăşag",
				"leavesAt": "14:55",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180212",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180616",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171223",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4361",
		"segments": [
			{
				"from": "Sărmăşag",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:05",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Borla Hm.",
				"leavesAt": "07:11",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Borla Hm.",
				"to": "Guruslău h.",
				"leavesAt": "07:16",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Guruslău h.",
				"to": "Zalău Nord",
				"leavesAt": "07:22",
				"arrivesAt": "07:30",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "07:32",
				"arrivesAt": "07:49",
				"waitsAtSource": 120,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "08:02",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180616",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4308",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "17:35",
				"arrivesAt": "17:45",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "17:51",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:08",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Jucu de Jos hc.",
				"leavesAt": "18:09",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 1820
			},
			{
				"from": "Jucu de Jos hc.",
				"to": "Răscruci h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 2680
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "18:30",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "18:42",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Nima h.",
				"leavesAt": "18:52",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "19:04",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5101",
		"segments": [
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "04:55",
				"arrivesAt": "05:06",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "05:07",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "05:18",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "05:48",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "06:05",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:32",
				"waitsAtSource": 240,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "06:33",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "06:58",
				"waitsAtSource": 480,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "07:16",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 8400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5110",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "16:00",
				"arrivesAt": "16:08",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "16:09",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "16:25",
				"arrivesAt": "16:33",
				"waitsAtSource": 120,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "16:34",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "17:00",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "17:33",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 11500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7569",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "07:00",
				"arrivesAt": "07:07",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "07:14",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Tecuci",
				"to": "Malul Alb h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 5600
			},
			{
				"from": "Malul Alb h.",
				"to": "Barcea",
				"leavesAt": "07:34",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Barcea",
				"to": "Umbrăreşti h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "07:47",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Iveşti Hm.",
				"to": "Buceşti h.",
				"leavesAt": "07:54",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Buceşti h.",
				"to": "Lieşti",
				"leavesAt": "07:59",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lieşti",
				"to": "Şerbăneşti h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:15",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "08:16",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Vameş h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Vameş h.",
				"to": "Piscu h.",
				"leavesAt": "08:29",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Piscu h.",
				"to": "Independenţa Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Independenţa Hm.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Braniştea h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Braniştea h.",
				"to": "Şendreni Hm.",
				"leavesAt": "08:53",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Şendreni Hm.",
				"to": "Barboşi",
				"leavesAt": "09:03",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "09:15",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "09:22",
				"arrivesAt": "09:33",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1590",
		"segments": [
			{
				"from": "Drobeta Tr. Severin",
				"to": "Balota",
				"leavesAt": "14:25",
				"arrivesAt": "14:58",
				"waitsAtSource": 0,
				"distance": 19000
			},
			{
				"from": "Balota",
				"to": "Strehaia hc.",
				"leavesAt": "14:59",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Strehaia hc.",
				"to": "Filiaşi",
				"leavesAt": "15:30",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "15:55",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "16:28",
				"arrivesAt": "17:08",
				"waitsAtSource": 480,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "17:10",
				"arrivesAt": "17:53",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "17:55",
				"arrivesAt": "18:40",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "18:42",
				"arrivesAt": "19:08",
				"waitsAtSource": 120,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "19:13",
				"arrivesAt": "19:42",
				"waitsAtSource": 300,
				"distance": 25500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9477",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Bradu de Sus",
				"leavesAt": "19:50",
				"arrivesAt": "19:57",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Pârvu Hm.",
				"to": "Pârvu h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Pârvu h.",
				"to": "Costeşti",
				"leavesAt": "20:11",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:33",
				"waitsAtSource": 120,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "20:34",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "20:47",
				"arrivesAt": "20:53",
				"waitsAtSource": 300,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "20:54",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "21:01",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "21:09",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "21:18",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "21:27",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "21:39",
				"arrivesAt": "21:47",
				"waitsAtSource": 300,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Criva h.",
				"leavesAt": "21:48",
				"arrivesAt": "22:01",
				"waitsAtSource": 60,
				"distance": 13000
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "22:02",
				"arrivesAt": "22:09",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9476",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:19",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "16:20",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "16:26",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:51",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "17:04",
				"waitsAtSource": 240,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "17:05",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "17:22",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "17:54",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Pârvu h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:15",
				"waitsAtSource": 360,
				"distance": 7600
			},
			{
				"from": "Pârvu h.",
				"to": "Pârvu Hm.",
				"leavesAt": "18:16",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Pârvu Hm.",
				"to": "Bradu de Sus",
				"leavesAt": "18:25",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "18:34",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "18:40",
				"arrivesAt": "18:42",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "36313",
		"segments": [
			{
				"from": "Tiborszallas",
				"to": "Carei",
				"leavesAt": "15:55",
				"arrivesAt": "16:21",
				"waitsAtSource": 0,
				"distance": 16100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "36329",
		"segments": [
			{
				"from": "Tiborszallas",
				"to": "Carei",
				"leavesAt": "07:20",
				"arrivesAt": "07:46",
				"waitsAtSource": 0,
				"distance": 16100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4084",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "14:35",
				"arrivesAt": "14:40",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "14:41",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "15:07",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Carei",
				"to": "Tiream h.",
				"leavesAt": "15:29",
				"arrivesAt": "15:39",
				"waitsAtSource": 600,
				"distance": 11700
			},
			{
				"from": "Tiream h.",
				"to": "Hotoan h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Hotoan h.",
				"to": "Santău h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Santău h.",
				"to": "Tăşnad",
				"leavesAt": "15:51",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Săcăşeni h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săcăşeni h.",
				"to": "Acâş Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Acâş Hm.",
				"to": "Supur Haltă hc.",
				"leavesAt": "16:13",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Supur h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur h.",
				"to": "Giorocuţa h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Giorocuţa h.",
				"to": "Derşida h.",
				"leavesAt": "16:29",
				"arrivesAt": "16:34",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Derşida h.",
				"to": "Sărmăşag h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Sărmăşag h.",
				"to": "Sărmăşag",
				"leavesAt": "16:39",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Sărmăşag",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Borla Hm.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Borla Hm.",
				"to": "Guruslău h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Guruslău h.",
				"to": "Zalău Nord",
				"leavesAt": "17:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:54",
				"waitsAtSource": 660,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:00",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "18:01",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4321",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "14:45",
				"arrivesAt": "14:51",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "14:59",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171231",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4322",
		"segments": [
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "15:36",
				"arrivesAt": "15:45",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:02",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "16:03",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171231",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4452",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "21:42",
				"arrivesAt": "21:50",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:56",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "21:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "22:05",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "36326",
		"segments": [
			{
				"from": "Carei",
				"to": "Tiborszallas",
				"leavesAt": "17:38",
				"arrivesAt": "18:04",
				"waitsAtSource": 0,
				"distance": 16100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4340",
		"segments": [
			{
				"from": "Valea lui Mihai",
				"to": "Simion h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:55",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Simion h.",
				"to": "Şilindru Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Şilindru Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "06:04",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Cadia h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cadia h.",
				"to": "Diosig Hm.",
				"leavesAt": "06:21",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Diosig Hm.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Tămăşeu h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tămăşeu h.",
				"to": "Biharia Hm.",
				"leavesAt": "06:42",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Biharia Hm.",
				"to": "Episcopia Bihor",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "07:01",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171223",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2611",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "20:08",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:23",
				"waitsAtSource": 360,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "20:24",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "20:31",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Valea Viilor Hm.",
				"leavesAt": "20:50",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Aradu Nou",
				"leavesAt": "21:00",
				"arrivesAt": "21:10",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "21:11",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5311",
		"segments": [
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "19:45",
				"arrivesAt": "19:54",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "19:55",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "20:00",
				"arrivesAt": "20:05",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "20:06",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "20:13",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "20:30",
				"arrivesAt": "20:37",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Viişoara h",
				"leavesAt": "20:38",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "20:59",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "21:09",
				"arrivesAt": "21:14",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "21:21",
				"arrivesAt": "21:26",
				"waitsAtSource": 420,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "21:27",
				"arrivesAt": "21:32",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "21:33",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5213",
		"segments": [
			{
				"from": "Comăneşti",
				"to": "Asău Hm.",
				"leavesAt": "04:15",
				"arrivesAt": "04:20",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Asău Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "04:21",
				"arrivesAt": "04:26",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caraliţa h.",
				"to": "Goioasa Hm.",
				"leavesAt": "04:27",
				"arrivesAt": "04:33",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Goioasa Hm.",
				"to": "Simbrea Hm.",
				"leavesAt": "04:34",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Simbrea Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "04:43",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Palanca Hm.",
				"leavesAt": "04:49",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Palanca Hm.",
				"to": "Ghimeş",
				"leavesAt": "04:55",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghimeş",
				"to": "Bolovăniş h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "05:11",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Tarcău h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "05:23",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Utuşoiu h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Utuşoiu h.",
				"to": "Livezi Ciuc",
				"leavesAt": "05:35",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Caracău h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 180,
				"distance": 2100
			},
			{
				"from": "Caracău h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Mihăileni Hm.",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Siculeni",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "06:14",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4083",
		"segments": [
			{
				"from": "Carei",
				"to": "Tiream h.",
				"leavesAt": "03:51",
				"arrivesAt": "04:02",
				"waitsAtSource": 0,
				"distance": 11700
			},
			{
				"from": "Tiream h.",
				"to": "Hotoan h.",
				"leavesAt": "04:03",
				"arrivesAt": "04:09",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Hotoan h.",
				"to": "Santău h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:15",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Santău h.",
				"to": "Tăşnad",
				"leavesAt": "04:16",
				"arrivesAt": "04:21",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Săcăşeni h.",
				"leavesAt": "04:22",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săcăşeni h.",
				"to": "Acâş Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:37",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Acâş Hm.",
				"to": "Supur Haltă hc.",
				"leavesAt": "04:42",
				"arrivesAt": "04:49",
				"waitsAtSource": 300,
				"distance": 7500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Supur h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:52",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur h.",
				"to": "Giorocuţa h.",
				"leavesAt": "04:53",
				"arrivesAt": "04:56",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Giorocuţa h.",
				"to": "Derşida h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Derşida h.",
				"to": "Sărmăşag h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:05",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Sărmăşag h.",
				"to": "Sărmăşag",
				"leavesAt": "05:06",
				"arrivesAt": "05:12",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Sărmăşag",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Borla Hm.",
				"leavesAt": "05:25",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Borla Hm.",
				"to": "Guruslău h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Guruslău h.",
				"to": "Zalău Nord",
				"leavesAt": "05:36",
				"arrivesAt": "05:43",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "05:44",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:12",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3620",
		"segments": [
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "04:00",
				"arrivesAt": "04:06",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "04:07",
				"arrivesAt": "04:14",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "04:19",
				"arrivesAt": "04:26",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "04:27",
				"arrivesAt": "04:31",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:37",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "04:38",
				"arrivesAt": "04:43",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "04:51",
				"arrivesAt": "04:54",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "04:55",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:00",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "05:01",
				"arrivesAt": "05:06",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "05:07",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180106",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180113",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180120",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180127",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180203",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180210",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180217",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180224",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180303",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180310",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180317",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180324",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180331",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180410",
				"to": "20180414",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180421",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180428",
				"daysOfWeek": 383
			},
			{
				"from": "20180430",
				"to": "20180505",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180512",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180519",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180602",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180609",
				"daysOfWeek": 383
			},
			{
				"from": "20180611",
				"to": "20180616",
				"daysOfWeek": 383
			},
			{
				"from": "20180618",
				"to": "20180623",
				"daysOfWeek": 383
			},
			{
				"from": "20180625",
				"to": "20180630",
				"daysOfWeek": 383
			},
			{
				"from": "20180702",
				"to": "20180707",
				"daysOfWeek": 383
			},
			{
				"from": "20180709",
				"to": "20180714",
				"daysOfWeek": 383
			},
			{
				"from": "20180716",
				"to": "20180721",
				"daysOfWeek": 383
			},
			{
				"from": "20180723",
				"to": "20180728",
				"daysOfWeek": 383
			},
			{
				"from": "20180730",
				"to": "20180804",
				"daysOfWeek": 383
			},
			{
				"from": "20180806",
				"to": "20180811",
				"daysOfWeek": 383
			},
			{
				"from": "20180813",
				"to": "20180818",
				"daysOfWeek": 383
			},
			{
				"from": "20180820",
				"to": "20180825",
				"daysOfWeek": 383
			},
			{
				"from": "20180827",
				"to": "20180901",
				"daysOfWeek": 383
			},
			{
				"from": "20180903",
				"to": "20180908",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180915",
				"daysOfWeek": 383
			},
			{
				"from": "20180917",
				"to": "20180922",
				"daysOfWeek": 383
			},
			{
				"from": "20180924",
				"to": "20180929",
				"daysOfWeek": 383
			},
			{
				"from": "20181001",
				"to": "20181006",
				"daysOfWeek": 383
			},
			{
				"from": "20181008",
				"to": "20181013",
				"daysOfWeek": 383
			},
			{
				"from": "20181015",
				"to": "20181020",
				"daysOfWeek": 383
			},
			{
				"from": "20181022",
				"to": "20181027",
				"daysOfWeek": 383
			},
			{
				"from": "20181029",
				"to": "20181103",
				"daysOfWeek": 383
			},
			{
				"from": "20181105",
				"to": "20181110",
				"daysOfWeek": 383
			},
			{
				"from": "20181112",
				"to": "20181117",
				"daysOfWeek": 383
			},
			{
				"from": "20181119",
				"to": "20181124",
				"daysOfWeek": 383
			},
			{
				"from": "20181126",
				"to": "20181129",
				"daysOfWeek": 383
			},
			{
				"from": "20181203",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171216",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171223",
				"daysOfWeek": 383
			},
			{
				"from": "20171227",
				"to": "20171230",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3628",
		"segments": [
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:32",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "14:33",
				"arrivesAt": "14:41",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "14:46",
				"arrivesAt": "14:53",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "14:54",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "15:16",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "15:26",
				"arrivesAt": "15:31",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "15:32",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3629",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:02",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:07",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "15:08",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "15:14",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "15:18",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "15:32",
				"arrivesAt": "15:34",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "15:35",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Gălăşeni h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Gălăşeni h.",
				"to": "Stana Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Stana Hm.",
				"to": "Jebuc h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Jebuc h.",
				"to": "Huedin",
				"leavesAt": "16:04",
				"arrivesAt": "16:11",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Huedin",
				"to": "Brăişoru Hm.",
				"leavesAt": "16:12",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Bologa h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bologa h.",
				"to": "Poieni",
				"leavesAt": "16:27",
				"arrivesAt": "16:31",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3627",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "12:40",
				"arrivesAt": "12:47",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "12:53",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "12:56",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "13:00",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "13:04",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:20",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "13:21",
				"arrivesAt": "13:24",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Gălăşeni h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:36",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Gălăşeni h.",
				"to": "Stana Hm.",
				"leavesAt": "13:37",
				"arrivesAt": "13:41",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Stana Hm.",
				"to": "Jebuc h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Jebuc h.",
				"to": "Huedin",
				"leavesAt": "13:50",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3637",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "22:45",
				"arrivesAt": "22:51",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "22:52",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "22:57",
				"arrivesAt": "22:59",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "23:00",
				"arrivesAt": "23:03",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "23:04",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "23:08",
				"arrivesAt": "23:14",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "23:15",
				"arrivesAt": "23:20",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "23:21",
				"arrivesAt": "23:23",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "23:24",
				"arrivesAt": "23:27",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "23:28",
				"arrivesAt": "23:31",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Gălăşeni h.",
				"leavesAt": "23:32",
				"arrivesAt": "23:38",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Gălăşeni h.",
				"to": "Stana Hm.",
				"leavesAt": "23:39",
				"arrivesAt": "23:43",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Stana Hm.",
				"to": "Jebuc h.",
				"leavesAt": "23:44",
				"arrivesAt": "23:51",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Jebuc h.",
				"to": "Huedin",
				"leavesAt": "23:52",
				"arrivesAt": "23:59",
				"waitsAtSource": 30,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180105",
				"daysOfWeek": 351
			},
			{
				"from": "20180107",
				"to": "20180112",
				"daysOfWeek": 351
			},
			{
				"from": "20180114",
				"to": "20180119",
				"daysOfWeek": 351
			},
			{
				"from": "20180121",
				"to": "20180126",
				"daysOfWeek": 351
			},
			{
				"from": "20180128",
				"to": "20180202",
				"daysOfWeek": 351
			},
			{
				"from": "20180204",
				"to": "20180209",
				"daysOfWeek": 351
			},
			{
				"from": "20180211",
				"to": "20180216",
				"daysOfWeek": 351
			},
			{
				"from": "20180218",
				"to": "20180223",
				"daysOfWeek": 351
			},
			{
				"from": "20180225",
				"to": "20180302",
				"daysOfWeek": 351
			},
			{
				"from": "20180304",
				"to": "20180309",
				"daysOfWeek": 351
			},
			{
				"from": "20180311",
				"to": "20180316",
				"daysOfWeek": 351
			},
			{
				"from": "20180318",
				"to": "20180323",
				"daysOfWeek": 351
			},
			{
				"from": "20180325",
				"to": "20180330",
				"daysOfWeek": 351
			},
			{
				"from": "20180401",
				"to": "20180406",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20180413",
				"daysOfWeek": 351
			},
			{
				"from": "20180415",
				"to": "20180420",
				"daysOfWeek": 351
			},
			{
				"from": "20180422",
				"to": "20180427",
				"daysOfWeek": 351
			},
			{
				"from": "20180429",
				"to": "20180504",
				"daysOfWeek": 351
			},
			{
				"from": "20180506",
				"to": "20180511",
				"daysOfWeek": 351
			},
			{
				"from": "20180513",
				"to": "20180518",
				"daysOfWeek": 351
			},
			{
				"from": "20180520",
				"to": "20180525",
				"daysOfWeek": 351
			},
			{
				"from": "20180528",
				"to": "20180601",
				"daysOfWeek": 351
			},
			{
				"from": "20180603",
				"to": "20180608",
				"daysOfWeek": 351
			},
			{
				"from": "20180610",
				"to": "20180615",
				"daysOfWeek": 351
			},
			{
				"from": "20180617",
				"to": "20180622",
				"daysOfWeek": 351
			},
			{
				"from": "20180624",
				"to": "20180629",
				"daysOfWeek": 351
			},
			{
				"from": "20180701",
				"to": "20180706",
				"daysOfWeek": 351
			},
			{
				"from": "20180708",
				"to": "20180713",
				"daysOfWeek": 351
			},
			{
				"from": "20180715",
				"to": "20180720",
				"daysOfWeek": 351
			},
			{
				"from": "20180722",
				"to": "20180727",
				"daysOfWeek": 351
			},
			{
				"from": "20180729",
				"to": "20180803",
				"daysOfWeek": 351
			},
			{
				"from": "20180805",
				"to": "20180810",
				"daysOfWeek": 351
			},
			{
				"from": "20180812",
				"to": "20180817",
				"daysOfWeek": 351
			},
			{
				"from": "20180819",
				"to": "20180824",
				"daysOfWeek": 351
			},
			{
				"from": "20180826",
				"to": "20180831",
				"daysOfWeek": 351
			},
			{
				"from": "20180902",
				"to": "20180907",
				"daysOfWeek": 351
			},
			{
				"from": "20180909",
				"to": "20180914",
				"daysOfWeek": 351
			},
			{
				"from": "20180916",
				"to": "20180921",
				"daysOfWeek": 351
			},
			{
				"from": "20180923",
				"to": "20180928",
				"daysOfWeek": 351
			},
			{
				"from": "20180930",
				"to": "20181005",
				"daysOfWeek": 351
			},
			{
				"from": "20181007",
				"to": "20181012",
				"daysOfWeek": 351
			},
			{
				"from": "20181014",
				"to": "20181019",
				"daysOfWeek": 351
			},
			{
				"from": "20181021",
				"to": "20181026",
				"daysOfWeek": 351
			},
			{
				"from": "20181028",
				"to": "20181102",
				"daysOfWeek": 351
			},
			{
				"from": "20181104",
				"to": "20181109",
				"daysOfWeek": 351
			},
			{
				"from": "20181111",
				"to": "20181116",
				"daysOfWeek": 351
			},
			{
				"from": "20181118",
				"to": "20181123",
				"daysOfWeek": 351
			},
			{
				"from": "20181125",
				"to": "20181129",
				"daysOfWeek": 351
			},
			{
				"from": "20181202",
				"to": "20181207",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171215",
				"daysOfWeek": 351
			},
			{
				"from": "20171217",
				"to": "20171222",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171229",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3635",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:05",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:13",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "20:14",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "20:32",
				"arrivesAt": "20:34",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "20:35",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Gălăşeni h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Gălăşeni h.",
				"to": "Stana Hm.",
				"leavesAt": "20:50",
				"arrivesAt": "20:54",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Stana Hm.",
				"to": "Jebuc h.",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Jebuc h.",
				"to": "Huedin",
				"leavesAt": "21:03",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3622",
		"segments": [
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:59",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "06:26",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "06:29",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "06:32",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "06:46",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "06:56",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "07:01",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3640",
		"segments": [
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "04:02",
				"arrivesAt": "04:37",
				"waitsAtSource": 0,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "04:38",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "04:59",
				"arrivesAt": "05:08",
				"waitsAtSource": 300,
				"distance": 6800
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "05:09",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3641",
		"segments": [
			{
				"from": "Bratca",
				"to": "Bălnaca h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 0,
				"distance": 2300
			},
			{
				"from": "Bălnaca h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Butan h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Butan h.",
				"to": "Aleşd h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Aleşd h.",
				"to": "Aleşd",
				"leavesAt": "06:20",
				"arrivesAt": "06:26",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aleşd",
				"to": "Ţeţchea hc.",
				"leavesAt": "06:27",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Telechiu Hm.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Telechiu Hm.",
				"to": "Tileagd",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Tileagd",
				"to": "Săbolciu h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Săbolciu h.",
				"to": "Săcădat h.",
				"leavesAt": "06:49",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săcădat h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "06:59",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea Est Triaj h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Oradea Est Triaj h.",
				"to": "Oradea Est",
				"leavesAt": "07:06",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 700
			},
			{
				"from": "Oradea Est",
				"to": "Oradea",
				"leavesAt": "07:09",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2344",
		"segments": [
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:41",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "06:42",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2047",
		"segments": [
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "19:28",
				"arrivesAt": "19:32",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "19:33",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "19:43",
				"arrivesAt": "19:53",
				"waitsAtSource": 120,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "20:17",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "20:26",
				"arrivesAt": "20:33",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "20:34",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "20:49",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "21:07",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "21:15",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "21:19",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 7400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9576",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "16:27",
				"arrivesAt": "16:33",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Remetea Mare",
				"leavesAt": "16:34",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "17:07",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Jabăr Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Lugoj",
				"leavesAt": "17:29",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lugoj",
				"to": "Tapia Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Tapia Hm.",
				"to": "Găvojdia",
				"leavesAt": "17:43",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Găvojdia",
				"to": "Jena Hm.",
				"leavesAt": "17:48",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Jena Hm.",
				"to": "Sacu h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sacu h.",
				"to": "Căvăran",
				"leavesAt": "18:02",
				"arrivesAt": "18:05",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Căvăran",
				"to": "Zăgujeni Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Tibiscu h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tibiscu h.",
				"to": "Caransebeş",
				"leavesAt": "18:21",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9552",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Caransebeş haltă h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:03",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Balta Sărată",
				"leavesAt": "07:04",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balta Sărată",
				"to": "Valea Timişului Hm.",
				"leavesAt": "07:09",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "07:14",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Petroşniţa h.",
				"to": "Vălişoara Hm.",
				"leavesAt": "07:18",
				"arrivesAt": "07:25",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Slatina Timiş",
				"leavesAt": "07:26",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Slatina Timiş",
				"to": "Armeniş",
				"leavesAt": "07:33",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Armeniş",
				"to": "Teregova Hm.",
				"leavesAt": "07:44",
				"arrivesAt": "07:51",
				"waitsAtSource": 240,
				"distance": 5100
			},
			{
				"from": "Teregova Hm.",
				"to": "Poarta Hm.",
				"leavesAt": "07:52",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Poarta Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Luncaviţa h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Cornea h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cornea h.",
				"to": "Cruşovăţ",
				"leavesAt": "08:19",
				"arrivesAt": "08:25",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cruşovăţ",
				"to": "Iablaniţa",
				"leavesAt": "08:26",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Iablaniţa",
				"to": "Mehadia Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mehadia Hm.",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "08:46",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Băile Herculane",
				"leavesAt": "08:50",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Băile Herculane",
				"to": "Topleţ Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Topleţ Hm.",
				"to": "Valea Cernei Hm.",
				"leavesAt": "09:04",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Valea Cernei Hm.",
				"to": "Orşova",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2436",
		"segments": [
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "13:35",
				"arrivesAt": "13:42",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "13:43",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "13:53",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "13:59",
				"arrivesAt": "14:02",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4044",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "14:59",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "15:06",
				"arrivesAt": "15:12",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "15:13",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Ţicău h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ţicău h.",
				"to": "Benesat Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:30",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Benesat Hm.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Inău h.",
				"leavesAt": "15:35",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Inău h.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "15:44",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4375",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Viişoara h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:39",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Viişoara h.",
				"to": "Sărata h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:49",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "14:50",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "15:07",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "15:16",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "15:48",
				"arrivesAt": "15:58",
				"waitsAtSource": 1380,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "16:06",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Dej Triaj",
				"leavesAt": "16:17",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "16:23",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4376",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "05:28",
				"arrivesAt": "05:35",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Reteag Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "05:53",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "06:02",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:34",
				"waitsAtSource": 840,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "06:35",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "06:52",
				"arrivesAt": "06:55",
				"waitsAtSource": 120,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "06:56",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:10",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "07:11",
				"arrivesAt": "07:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "07:20",
				"arrivesAt": "07:23",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4046",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:52",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "16:59",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Ţicău h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:16",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Ţicău h.",
				"to": "Benesat Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Benesat Hm.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:38",
				"waitsAtSource": 600,
				"distance": 2700
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Inău h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Inău h.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "17:48",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4532",
		"segments": [
			{
				"from": "Războieni",
				"to": "Lunca Mureşului h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:20",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Cheţani h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Cheţani h.",
				"to": "Luduş",
				"leavesAt": "05:26",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Luduş",
				"to": "Bogata Mureş h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Cuci h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cuci h.",
				"to": "Iernut",
				"leavesAt": "05:45",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Iernut",
				"to": "Cipău h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Cipău h.",
				"to": "Ogra h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ogra h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:05",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Chirileu h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chirileu h.",
				"to": "Vidrasău h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vidrasău h.",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "06:16",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "Azomureş h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:49",
				"waitsAtSource": 300,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2423",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(210)",
				"leavesAt": "14:33",
				"arrivesAt": "14:36",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Turnişor Hm.",
				"leavesAt": "14:37",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Cristian Sibiu h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Orlat",
				"leavesAt": "14:56",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Orlat",
				"to": "Sibiel h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sibiel h.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sălişte Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:20",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sălişte Hm.",
				"to": "Aciliu h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Aciliu h.",
				"to": "Tilişca h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tilişca h.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "15:30",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "15:50",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180115",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180212",
				"to": "20180323",
				"daysOfWeek": 799
			},
			{
				"from": "20180326",
				"to": "20180330",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4584",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:51",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "15:07",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 240,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "15:27",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180616",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171231",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4135",
		"segments": [
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:38",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:52",
				"waitsAtSource": 360,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "08:05",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Coşbuc Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:24",
				"waitsAtSource": 120,
				"distance": 9500
			},
			{
				"from": "Coşbuc Hm.",
				"to": "Telciu Hm.",
				"leavesAt": "08:25",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Telciu Hm.",
				"to": "Fiad Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Fiad Hm.",
				"to": "Romuli h.",
				"leavesAt": "08:49",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Romuli h.",
				"to": "Dealu Ştefăniţei",
				"leavesAt": "08:59",
				"arrivesAt": "09:08",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dealu Ştefăniţei",
				"to": "Săcel Hm.",
				"leavesAt": "09:09",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Săcel Hm.",
				"to": "Iza P.M.",
				"leavesAt": "09:21",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Iza P.M.",
				"to": "Vişeu de Jos",
				"leavesAt": "09:32",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Vişeu de Jos",
				"to": "Leordina",
				"leavesAt": "10:00",
				"arrivesAt": "10:17",
				"waitsAtSource": 960,
				"distance": 12400
			},
			{
				"from": "Leordina",
				"to": "Petrova hc.",
				"leavesAt": "10:18",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Petrova hc.",
				"to": "Vişeu Bistra h.",
				"leavesAt": "10:29",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Valea Vişeului",
				"leavesAt": "10:38",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Valea Vişeului",
				"to": "Lunca la Tisa h.",
				"leavesAt": "11:12",
				"arrivesAt": "11:28",
				"waitsAtSource": 1200,
				"distance": 10700
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "11:29",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Crăciuneşti h.",
				"leavesAt": "11:36",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Tisa h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Tisa h.",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "11:47",
				"arrivesAt": "11:54",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Sighetu Marmaţiei",
				"leavesAt": "11:55",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5601",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "04:35",
				"arrivesAt": "04:49",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "04:50",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "04:58",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "05:13",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "05:30",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "05:35",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "05:45",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:22",
				"waitsAtSource": 1080,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "06:40",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "06:59",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "07:06",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "07:13",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "07:20",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "07:28",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3633",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "18:28",
				"arrivesAt": "18:35",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "18:36",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "18:44",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "18:48",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "19:09",
				"arrivesAt": "19:12",
				"waitsAtSource": 30,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9368",
		"segments": [
			{
				"from": "Zimnicea",
				"to": "Ulmuleţ h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:49",
				"waitsAtSource": 0,
				"distance": 9800
			},
			{
				"from": "Ulmuleţ h.",
				"to": "Şoimu h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Şoimu h.",
				"to": "Păuleasa h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Păuleasa h.",
				"to": "Smârdioasa h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Smârdioasa h.",
				"to": "Brânceni h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brânceni h.",
				"to": "Ţigăneşti h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Ţigăneşti h.",
				"to": "Alexandria",
				"leavesAt": "17:22",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:49",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "18:02",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "18:23",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5007",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "17:12",
				"arrivesAt": "17:21",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "17:22",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "17:33",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "17:46",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "17:56",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "18:06",
				"arrivesAt": "18:21",
				"waitsAtSource": 240,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "18:23",
				"arrivesAt": "18:29",
				"waitsAtSource": 120,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "18:30",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "18:40",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "18:45",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "18:49",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "19:00",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "19:19",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "19:27",
				"arrivesAt": "19:32",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "19:33",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "19:39",
				"arrivesAt": "19:51",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9343",
		"segments": [
			{
				"from": "Videle",
				"to": "Răduleşti Hm.",
				"leavesAt": "09:57",
				"arrivesAt": "10:07",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "10:08",
				"arrivesAt": "10:16",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Târnavele Hm.",
				"to": "Vlaşca Hm.",
				"leavesAt": "10:17",
				"arrivesAt": "10:25",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Răsuceni h.",
				"leavesAt": "10:26",
				"arrivesAt": "10:32",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Răsuceni h.",
				"to": "Toporu",
				"leavesAt": "10:33",
				"arrivesAt": "10:37",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Toporu",
				"to": "Chiriacu Hm.",
				"leavesAt": "10:38",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Stăneşti Hm.",
				"leavesAt": "10:50",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Onceşti h.",
				"leavesAt": "10:58",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Onceşti h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "11:03",
				"arrivesAt": "11:09",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Cetatea h.",
				"leavesAt": "11:10",
				"arrivesAt": "11:12",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cetatea h.",
				"to": "Giurgiu Nord",
				"leavesAt": "11:13",
				"arrivesAt": "11:19",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Giurgiu Nord",
				"to": "Giurgiu",
				"leavesAt": "11:20",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7375",
		"segments": [
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:34",
				"waitsAtSource": 0,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "12:35",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "12:43",
				"arrivesAt": "12:49",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "12:50",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "12:55",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "13:03",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "13:12",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "13:23",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "13:35",
				"arrivesAt": "13:42",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "13:43",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "13:49",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "13:54",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "14:02",
				"arrivesAt": "14:09",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "14:10",
				"arrivesAt": "14:22",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2569",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "19:36",
				"arrivesAt": "19:40",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "19:53",
				"arrivesAt": "19:57",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "19:59",
				"arrivesAt": "20:06",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "20:07",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 360,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Veşeud h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Veşeud h.",
				"to": "Şeica Mare h.",
				"leavesAt": "20:33",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "20:39",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "20:56",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8371",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "06:15",
				"arrivesAt": "06:26",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "06:35",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:04",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "07:05",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "07:21",
				"arrivesAt": "07:25",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Pescăruş h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Pescăruş h.",
				"to": "Neptun hc.",
				"leavesAt": "07:34",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "07:49",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180502",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4362",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "06:49",
				"arrivesAt": "06:56",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "07:09",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Zalău Nord",
				"to": "Guruslău h.",
				"leavesAt": "07:31",
				"arrivesAt": "07:40",
				"waitsAtSource": 360,
				"distance": 6700
			},
			{
				"from": "Guruslău h.",
				"to": "Borla Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Borla Hm.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "07:53",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Sărmăşag",
				"leavesAt": "07:59",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sărmăşag",
				"to": "Sărmăşag h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sărmăşag h.",
				"to": "Derşida h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:15",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Derşida h.",
				"to": "Giorocuţa h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Giorocuţa h.",
				"to": "Supur h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:25",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Supur h.",
				"to": "Supur Haltă hc.",
				"leavesAt": "08:26",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Acâş Hm.",
				"leavesAt": "08:29",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Acâş Hm.",
				"to": "Săcăşeni h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:08",
				"waitsAtSource": 1260,
				"distance": 10000
			},
			{
				"from": "Săcăşeni h.",
				"to": "Tăşnad",
				"leavesAt": "09:09",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Santău h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:24",
				"waitsAtSource": 120,
				"distance": 5500
			},
			{
				"from": "Santău h.",
				"to": "Hotoan h.",
				"leavesAt": "09:25",
				"arrivesAt": "09:30",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Hotoan h.",
				"to": "Tiream h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Tiream h.",
				"to": "Carei",
				"leavesAt": "09:38",
				"arrivesAt": "09:53",
				"waitsAtSource": 30,
				"distance": 11700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9578",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "19:39",
				"arrivesAt": "19:45",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Remetea Mare",
				"leavesAt": "19:46",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:13",
				"waitsAtSource": 300,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "20:14",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "20:18",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "20:29",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "20:36",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Jabăr Hm.",
				"leavesAt": "20:41",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Lugoj",
				"leavesAt": "20:47",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lugoj",
				"to": "Găvojdia",
				"leavesAt": "20:54",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Găvojdia",
				"to": "Jena Hm.",
				"leavesAt": "21:11",
				"arrivesAt": "21:21",
				"waitsAtSource": 420,
				"distance": 5800
			},
			{
				"from": "Jena Hm.",
				"to": "Sacu h.",
				"leavesAt": "21:22",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sacu h.",
				"to": "Căvăran",
				"leavesAt": "21:25",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Căvăran",
				"to": "Zăgujeni Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:47",
				"waitsAtSource": 480,
				"distance": 7900
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Tibiscu h.",
				"leavesAt": "21:48",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tibiscu h.",
				"to": "Caransebeş",
				"leavesAt": "21:52",
				"arrivesAt": "21:56",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8121",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "10:05",
				"arrivesAt": "10:11",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "10:12",
				"arrivesAt": "10:16",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Chitila",
				"leavesAt": "10:17",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chitila",
				"to": "Mogoşoaia",
				"leavesAt": "10:24",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Mogoşoaia",
				"to": "P.O. Aeroport h.",
				"leavesAt": "10:42",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "10:50",
				"arrivesAt": "10:53",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "10:54",
				"arrivesAt": "11:00",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "11:01",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "11:08",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "11:15",
				"arrivesAt": "11:22",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "11:29",
				"arrivesAt": "11:36",
				"waitsAtSource": 420,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "11:37",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "11:43",
				"arrivesAt": "11:48",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "11:53",
				"arrivesAt": "12:00",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Urziceni",
				"to": "Alexeni h.",
				"leavesAt": "12:02",
				"arrivesAt": "12:08",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Alexeni h.",
				"to": "Broşteni Hm.",
				"leavesAt": "12:09",
				"arrivesAt": "12:15",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Malu h.",
				"leavesAt": "12:16",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Malu h.",
				"to": "Km. 74+600 h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:26",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "12:27",
				"arrivesAt": "12:31",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "12:32",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Munteni Buzău h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Căzăneşti",
				"leavesAt": "12:41",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Căzăneşti",
				"to": "Ciochina hc.",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ciochina hc.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "12:54",
				"arrivesAt": "13:03",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Fundata h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Fundata h.",
				"to": "Perieţi h.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Perieţi h.",
				"to": "Slobozia Veche",
				"leavesAt": "13:15",
				"arrivesAt": "13:27",
				"waitsAtSource": 30,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6503",
		"segments": [
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "07:05",
				"arrivesAt": "07:13",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:20",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Remiza T Socola h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Remiza T Socola h.",
				"to": "Socola",
				"leavesAt": "07:28",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "07:35",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "07:42",
				"arrivesAt": "07:49",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4544",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "10:55",
				"arrivesAt": "11:03",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "11:04",
				"arrivesAt": "11:16",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "11:17",
				"arrivesAt": "11:21",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:27",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "11:28",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "11:34",
				"arrivesAt": "11:44",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:52",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "11:53",
				"arrivesAt": "11:58",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "11:59",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "12:04",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "12:16",
				"arrivesAt": "12:20",
				"waitsAtSource": 360,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "12:21",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2142",
		"segments": [
			{
				"from": "Hunedoara",
				"to": "Pestişu Mare h.",
				"leavesAt": "05:43",
				"arrivesAt": "05:53",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pestişu Mare h.",
				"to": "Bârcea Mică",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bârcea Mică",
				"to": "Bârcea Mare h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bârcea Mare h.",
				"to": "Simeria",
				"leavesAt": "06:02",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1593",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "17:25",
				"arrivesAt": "18:15",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "18:16",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "19:03",
				"arrivesAt": "19:34",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "19:35",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "19:54",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9448",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "17:54",
				"arrivesAt": "18:00",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "18:01",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:16",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Scârlenţa h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:23",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Scârlenţa h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "18:24",
				"arrivesAt": "18:27",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Doiceşti h.",
				"to": "Doiceşti",
				"leavesAt": "18:31",
				"arrivesAt": "18:33",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Doiceşti",
				"to": "Săteni h.",
				"leavesAt": "18:34",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Săteni h.",
				"to": "Aninoasa Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Aninoasa Hm.",
				"to": "TEIŞ Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "18:48",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1942",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "18:09",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "18:10",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "18:21",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Benesat Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Benesat Hm.",
				"to": "Jibou",
				"leavesAt": "18:39",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Jibou",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "19:09",
				"arrivesAt": "19:17",
				"waitsAtSource": 720,
				"distance": 6800
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Letca Hm.",
				"leavesAt": "19:23",
				"arrivesAt": "19:46",
				"waitsAtSource": 360,
				"distance": 16300
			},
			{
				"from": "Letca Hm.",
				"to": "Ileanda",
				"leavesAt": "19:47",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Ileanda",
				"to": "Gâlgău",
				"leavesAt": "20:05",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Gâlgău",
				"to": "Câţcău h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Câţcău h.",
				"to": "Dej Călători",
				"leavesAt": "20:34",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 12700
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "21:02",
				"arrivesAt": "21:35",
				"waitsAtSource": 840,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Sărăţel Hm.",
				"leavesAt": "21:37",
				"arrivesAt": "22:03",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Deda",
				"leavesAt": "22:04",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Deda",
				"to": "Topliţa",
				"leavesAt": "23:02",
				"arrivesAt": "23:59",
				"waitsAtSource": 240,
				"distance": 43900
			},
			{
				"from": "Topliţa",
				"to": "Gheorgheni",
				"leavesAt": "00:06",
				"arrivesAt": "00:39",
				"waitsAtSource": 420,
				"distance": 34000
			},
			{
				"from": "Gheorgheni",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "00:41",
				"arrivesAt": "00:57",
				"waitsAtSource": 120,
				"distance": 19100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "00:58",
				"arrivesAt": "01:10",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "01:12",
				"arrivesAt": "01:32",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "01:37",
				"arrivesAt": "01:46",
				"waitsAtSource": 300,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "01:48",
				"arrivesAt": "02:11",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "02:13",
				"arrivesAt": "02:45",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "02:47",
				"arrivesAt": "03:17",
				"waitsAtSource": 120,
				"distance": 32100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "03:32",
				"arrivesAt": "04:09",
				"waitsAtSource": 900,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Sinaia",
				"leavesAt": "04:11",
				"arrivesAt": "04:32",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "04:34",
				"arrivesAt": "04:58",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "05:00",
				"arrivesAt": "05:11",
				"waitsAtSource": 120,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Ploieşti Vest",
				"leavesAt": "05:12",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 18600
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "05:29",
				"arrivesAt": "06:14",
				"waitsAtSource": 120,
				"distance": 58900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "06:40",
				"arrivesAt": "07:47",
				"waitsAtSource": 1560,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Perişoru Hm.",
				"leavesAt": "07:48",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Feteşti",
				"leavesAt": "08:02",
				"arrivesAt": "08:19",
				"waitsAtSource": 360,
				"distance": 25200
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "08:20",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "08:39",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "08:57",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "10:05",
				"arrivesAt": "10:28",
				"waitsAtSource": 2040,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "10:30",
				"arrivesAt": "10:37",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "10:39",
				"arrivesAt": "10:55",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "10:57",
				"arrivesAt": "11:01",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "11:03",
				"arrivesAt": "11:16",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "11:18",
				"arrivesAt": "11:28",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180426",
				"to": "20180430",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1588",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Bucureşti Nord",
				"leavesAt": "19:00",
				"arrivesAt": "21:02",
				"waitsAtSource": 0,
				"distance": 225000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8151",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Alexeni h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:11",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Alexeni h.",
				"to": "Broşteni Hm.",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Malu h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Malu h.",
				"to": "Km. 74+600 h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "06:29",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Munteni Buzău h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Căzăneşti",
				"leavesAt": "06:42",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Căzăneşti",
				"to": "Ciochina hc.",
				"leavesAt": "06:48",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ciochina hc.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "06:55",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Fundata h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Fundata h.",
				"to": "Perieţi h.",
				"leavesAt": "07:09",
				"arrivesAt": "07:13",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Perieţi h.",
				"to": "Slobozia Veche",
				"leavesAt": "07:14",
				"arrivesAt": "07:24",
				"waitsAtSource": 30,
				"distance": 8600
			},
			{
				"from": "Slobozia Veche",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:48",
				"waitsAtSource": 840,
				"distance": 4200
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Brâncoveni h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Brâncoveni h.",
				"to": "Ciulniţa",
				"leavesAt": "07:59",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9345",
		"segments": [
			{
				"from": "Videle",
				"to": "Răduleşti Hm.",
				"leavesAt": "13:50",
				"arrivesAt": "14:00",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Târnavele Hm.",
				"to": "Vlaşca Hm.",
				"leavesAt": "14:11",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Răsuceni h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Răsuceni h.",
				"to": "Toporu",
				"leavesAt": "14:27",
				"arrivesAt": "14:31",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Toporu",
				"to": "Chiriacu Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Stăneşti Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Onceşti h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Onceşti h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Cetatea h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cetatea h.",
				"to": "Giurgiu Nord",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Giurgiu Nord",
				"to": "Giurgiu",
				"leavesAt": "15:14",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8804",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "08:50",
				"arrivesAt": "08:57",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "09:05",
				"arrivesAt": "09:10",
				"waitsAtSource": 480,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "09:11",
				"arrivesAt": "09:24",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "09:25",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "09:30",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "09:39",
				"arrivesAt": "09:48",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "09:49",
				"arrivesAt": "09:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "09:58",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "10:08",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3074",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Est",
				"leavesAt": "07:30",
				"arrivesAt": "07:36",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Oradea Est",
				"to": "Oradea Est Triaj h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 700
			},
			{
				"from": "Oradea Est Triaj h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Săcădat h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:55",
				"waitsAtSource": 240,
				"distance": 6000
			},
			{
				"from": "Săcădat h.",
				"to": "Săbolciu h.",
				"leavesAt": "07:56",
				"arrivesAt": "07:58",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbolciu h.",
				"to": "Tileagd",
				"leavesAt": "07:59",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tileagd",
				"to": "Telechiu Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:14",
				"waitsAtSource": 240,
				"distance": 4400
			},
			{
				"from": "Telechiu Hm.",
				"to": "Ţeţchea hc.",
				"leavesAt": "08:15",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Aleşd",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Aleşd",
				"to": "Aleşd h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aleşd h.",
				"to": "Butan h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Butan h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Vadu Crişului h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:45",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Peştera h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:49",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Peştera h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "08:50",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bălnaca h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bălnaca h.",
				"to": "Bratca",
				"leavesAt": "09:00",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 300,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "09:15",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "09:36",
				"arrivesAt": "09:41",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Valea Drăganului h.",
				"leavesAt": "09:42",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Poieni",
				"leavesAt": "09:48",
				"arrivesAt": "09:52",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Bologa h.",
				"leavesAt": "09:53",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bologa h.",
				"to": "Brăişoru Hm.",
				"leavesAt": "09:57",
				"arrivesAt": "10:01",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "10:02",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "10:18",
				"arrivesAt": "10:25",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "10:26",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "10:30",
				"arrivesAt": "10:37",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "10:38",
				"arrivesAt": "10:42",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "10:46",
				"arrivesAt": "10:48",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "10:49",
				"arrivesAt": "10:54",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "10:55",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "11:02",
				"arrivesAt": "11:05",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "11:06",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "11:09",
				"arrivesAt": "11:11",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "11:12",
				"arrivesAt": "11:17",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "11:18",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2083",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "05:44",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "05:52",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "05:56",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:32",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "06:33",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "07:02",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "07:22",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "07:31",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Târgu Jiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:17",
				"waitsAtSource": 600,
				"distance": 800
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "08:18",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ezureni h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ezureni h.",
				"to": "Parângu Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Parângu Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "08:33",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Meri",
				"leavesAt": "08:46",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Meri",
				"to": "Lainici Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lainici Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "09:11",
				"arrivesAt": "09:15",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "09:16",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Livezeni",
				"leavesAt": "09:27",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Lunca Jiului hc.",
				"leavesAt": "09:38",
				"arrivesAt": "09:41",
				"waitsAtSource": 240,
				"distance": 3000
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Petroşani",
				"leavesAt": "09:42",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 863
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7364",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "15:30",
				"arrivesAt": "15:44",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "15:45",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Zagna Vădeni h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Vădeni Hm.",
				"leavesAt": "15:57",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "16:01",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "16:06",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Lacu Sărat",
				"leavesAt": "16:15",
				"arrivesAt": "16:22",
				"waitsAtSource": 120,
				"distance": 9700
			},
			{
				"from": "Lacu Sărat",
				"to": "Traian Sat Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Urleasca Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Urleasca Hm.",
				"to": "Plopu",
				"leavesAt": "16:41",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Plopu",
				"to": "Ianca hc.",
				"leavesAt": "16:50",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ianca hc.",
				"to": "Deduleşti Hm.",
				"leavesAt": "16:54",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Găiseanca h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Găiseanca h.",
				"to": "Făurei",
				"leavesAt": "17:09",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Făurei",
				"to": "CTF Făurei h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:33",
				"waitsAtSource": 840,
				"distance": 4100
			},
			{
				"from": "CTF Făurei h.",
				"to": "Vizireni h.",
				"leavesAt": "17:34",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "17:39",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "17:54",
				"arrivesAt": "18:02",
				"waitsAtSource": 600,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:18",
				"waitsAtSource": 240,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău Sud",
				"leavesAt": "18:27",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Buzău Sud",
				"to": "Buzău",
				"leavesAt": "18:33",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "37656",
		"segments": [
			{
				"from": "Kotegyan",
				"to": "Salonta",
				"leavesAt": "17:45",
				"arrivesAt": "18:05",
				"waitsAtSource": 0,
				"distance": 13200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7575",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "18:40",
				"arrivesAt": "18:47",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "18:48",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "18:54",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Tecuci",
				"to": "Malul Alb h.",
				"leavesAt": "19:17",
				"arrivesAt": "19:22",
				"waitsAtSource": 660,
				"distance": 5600
			},
			{
				"from": "Malul Alb h.",
				"to": "Barcea",
				"leavesAt": "19:23",
				"arrivesAt": "19:27",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Barcea",
				"to": "Umbrăreşti h.",
				"leavesAt": "19:28",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "19:34",
				"arrivesAt": "19:39",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Iveşti Hm.",
				"to": "Buceşti h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Buceşti h.",
				"to": "Lieşti",
				"leavesAt": "19:44",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lieşti",
				"to": "Şerbăneşti h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Vameş h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:10",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Vameş h.",
				"to": "Piscu h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:15",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Piscu h.",
				"to": "Independenţa Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Independenţa Hm.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Braniştea h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Braniştea h.",
				"to": "Şendreni Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Şendreni Hm.",
				"to": "Barboşi",
				"leavesAt": "20:42",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "20:53",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "21:01",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5434",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "10:29",
				"arrivesAt": "10:36",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "10:37",
				"arrivesAt": "10:42",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "10:43",
				"arrivesAt": "10:47",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "10:48",
				"arrivesAt": "10:53",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "10:54",
				"arrivesAt": "10:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "10:59",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "11:06",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "11:17",
				"arrivesAt": "11:24",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "11:25",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "11:30",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "11:39",
				"arrivesAt": "11:44",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "11:45",
				"arrivesAt": "11:50",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "11:51",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5022",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Brazi",
				"leavesAt": "04:40",
				"arrivesAt": "04:55",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "04:56",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "05:13",
				"arrivesAt": "05:18",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "05:28",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "05:33",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "05:43",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "05:46",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "05:50",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "05:57",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5740",
		"segments": [
			{
				"from": "Cacica Hm.",
				"to": "Pârteşti h.",
				"leavesAt": "14:00",
				"arrivesAt": "14:07",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Pârteşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Soloneţ h.",
				"to": "Todireşti h.",
				"leavesAt": "14:15",
				"arrivesAt": "14:22",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Todireşti h.",
				"to": "Părhăuţi h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Părhăuţi h.",
				"to": "Dărmăneşti",
				"leavesAt": "14:32",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "14:41",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "14:49",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4104",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "17:08",
				"arrivesAt": "17:15",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Reteag Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "17:41",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "18:00",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:15",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "18:16",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:36",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "18:37",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "18:42",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 511
			},
			{
				"from": "20180113",
				"to": "20180114",
				"daysOfWeek": 511
			},
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 511
			},
			{
				"from": "20180124",
				"to": "20180124",
				"daysOfWeek": 511
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 511
			},
			{
				"from": "20180203",
				"to": "20180204",
				"daysOfWeek": 511
			},
			{
				"from": "20180210",
				"to": "20180211",
				"daysOfWeek": 511
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 511
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 511
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 511
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 511
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 511
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 511
			},
			{
				"from": "20180331",
				"to": "20180401",
				"daysOfWeek": 511
			},
			{
				"from": "20180407",
				"to": "20180409",
				"daysOfWeek": 511
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 511
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 511
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 511
			},
			{
				"from": "20180501",
				"to": "20180501",
				"daysOfWeek": 511
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 511
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 511
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 511
			},
			{
				"from": "20180526",
				"to": "20180528",
				"daysOfWeek": 511
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 511
			},
			{
				"from": "20180909",
				"to": "20180909",
				"daysOfWeek": 511
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 511
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 511
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 511
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 511
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 511
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 511
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 511
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 511
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 511
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 511
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 511
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 511
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 511
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 511
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 511
			},
			{
				"from": "20171223",
				"to": "20171226",
				"daysOfWeek": 511
			},
			{
				"from": "20171230",
				"to": "20180102",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5449",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "13:29",
				"arrivesAt": "13:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "13:41",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "13:46",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "13:52",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "14:02",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "14:07",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "14:16",
				"arrivesAt": "14:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "14:24",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "14:31",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani Triaj",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Paşcani Triaj",
				"to": "Paşcani",
				"leavesAt": "14:58",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:15",
				"waitsAtSource": 300,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "15:16",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "15:33",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "15:46",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "15:53",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "16:00",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "16:07",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "16:14",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "16:23",
				"arrivesAt": "16:29",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4454",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:17",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "09:23",
				"arrivesAt": "09:29",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "09:30",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "346",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "14:00",
				"arrivesAt": "14:36",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Sinaia",
				"leavesAt": "14:38",
				"arrivesAt": "15:22",
				"waitsAtSource": 120,
				"distance": 62100
			},
			{
				"from": "Sinaia",
				"to": "Predeal",
				"leavesAt": "15:24",
				"arrivesAt": "15:43",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "15:45",
				"arrivesAt": "16:23",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Făgăraş",
				"leavesAt": "16:35",
				"arrivesAt": "17:46",
				"waitsAtSource": 720,
				"distance": 65000
			},
			{
				"from": "Făgăraş",
				"to": "Sibiu",
				"leavesAt": "17:47",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 83900
			},
			{
				"from": "Sibiu",
				"to": "Sălişte Hm.",
				"leavesAt": "19:13",
				"arrivesAt": "19:52",
				"waitsAtSource": 300,
				"distance": 29700
			},
			{
				"from": "Sălişte Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "19:56",
				"arrivesAt": "21:02",
				"waitsAtSource": 240,
				"distance": 53100
			},
			{
				"from": "Vinţu de Jos",
				"to": "Şibot",
				"leavesAt": "21:03",
				"arrivesAt": "21:25",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Şibot",
				"to": "Simeria",
				"leavesAt": "21:26",
				"arrivesAt": "22:02",
				"waitsAtSource": 60,
				"distance": 28800
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "22:14",
				"arrivesAt": "22:24",
				"waitsAtSource": 720,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Arad",
				"leavesAt": "22:26",
				"arrivesAt": "01:14",
				"waitsAtSource": 120,
				"distance": 148200
			},
			{
				"from": "Arad",
				"to": "Curtici",
				"leavesAt": "01:22",
				"arrivesAt": "01:35",
				"waitsAtSource": 480,
				"distance": 17000
			},
			{
				"from": "Curtici",
				"to": "Lokoshaza",
				"leavesAt": "02:10",
				"arrivesAt": "02:20",
				"waitsAtSource": 2100,
				"distance": 11200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2031",
		"segments": [
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "06:18",
				"arrivesAt": "06:31",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "06:32",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "07:00",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "07:16",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "07:24",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "07:30",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "07:48",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "07:56",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "08:00",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Săvârşin",
				"to": "Vărădia h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:19",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Vărădia h.",
				"to": "Vărădia Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Căpruţa h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Căpruţa h.",
				"to": "Bârzava",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bârzava",
				"to": "Nadăş h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nadăş h.",
				"to": "Conop Hm.",
				"leavesAt": "08:58",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Conop Hm.",
				"to": "Corfeni h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Corfeni h.",
				"to": "Milova",
				"leavesAt": "09:11",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Milova",
				"to": "Radna",
				"leavesAt": "09:18",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Radna",
				"to": "Păuliş Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Păuliş Hm.",
				"to": "Păuliş h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş h.",
				"to": "Ghioroc",
				"leavesAt": "09:46",
				"arrivesAt": "09:53",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ghioroc",
				"to": "Glogovăţ",
				"leavesAt": "09:54",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Glogovăţ",
				"to": "Arad",
				"leavesAt": "10:07",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1819",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Iernut",
				"leavesAt": "16:07",
				"arrivesAt": "16:34",
				"waitsAtSource": 0,
				"distance": 28600
			},
			{
				"from": "Iernut",
				"to": "Luduş",
				"leavesAt": "16:35",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Luduş",
				"to": "Războieni",
				"leavesAt": "16:50",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 19200
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "17:09",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "17:31",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "17:49",
				"arrivesAt": "17:57",
				"waitsAtSource": 240,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "17:58",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "18:23",
				"arrivesAt": "18:31",
				"waitsAtSource": 240,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "18:33",
				"arrivesAt": "18:44",
				"waitsAtSource": 120,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "19:00",
				"waitsAtSource": 480,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Şibot",
				"leavesAt": "19:08",
				"arrivesAt": "19:23",
				"waitsAtSource": 480,
				"distance": 9800
			},
			{
				"from": "Şibot",
				"to": "Aurel Vlaicu",
				"leavesAt": "19:25",
				"arrivesAt": "19:34",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Orăştie",
				"leavesAt": "19:35",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Orăştie",
				"to": "Simeria",
				"leavesAt": "19:50",
				"arrivesAt": "20:12",
				"waitsAtSource": 360,
				"distance": 16500
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "20:14",
				"arrivesAt": "20:24",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "20:26",
				"arrivesAt": "20:53",
				"waitsAtSource": 120,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Margina",
				"leavesAt": "20:54",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 35500
			},
			{
				"from": "Margina",
				"to": "Făget",
				"leavesAt": "21:43",
				"arrivesAt": "21:51",
				"waitsAtSource": 660,
				"distance": 7600
			},
			{
				"from": "Făget",
				"to": "Lugoj",
				"leavesAt": "21:53",
				"arrivesAt": "22:35",
				"waitsAtSource": 120,
				"distance": 39700
			},
			{
				"from": "Lugoj",
				"to": "Buziaş",
				"leavesAt": "22:40",
				"arrivesAt": "23:09",
				"waitsAtSource": 300,
				"distance": 27500
			},
			{
				"from": "Buziaş",
				"to": "Timişoara Nord",
				"leavesAt": "23:10",
				"arrivesAt": "23:47",
				"waitsAtSource": 60,
				"distance": 36400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6502",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "04:15",
				"arrivesAt": "04:22",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "04:23",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Holboca Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "04:38",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9553",
		"segments": [
			{
				"from": "Orşova",
				"to": "Valea Cernei Hm.",
				"leavesAt": "13:32",
				"arrivesAt": "13:38",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Valea Cernei Hm.",
				"to": "Topleţ Hm.",
				"leavesAt": "13:39",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Topleţ Hm.",
				"to": "Băile Herculane",
				"leavesAt": "13:45",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Herculane",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "13:55",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Mehadia Hm.",
				"leavesAt": "13:59",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Mehadia Hm.",
				"to": "Iablaniţa",
				"leavesAt": "14:03",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Iablaniţa",
				"to": "Cruşovăţ",
				"leavesAt": "14:14",
				"arrivesAt": "14:22",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cruşovăţ",
				"to": "Cornea h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cornea h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:44",
				"waitsAtSource": 300,
				"distance": 3000
			},
			{
				"from": "Luncaviţa h.",
				"to": "Poarta Hm.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Poarta Hm.",
				"to": "Teregova Hm.",
				"leavesAt": "14:51",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Teregova Hm.",
				"to": "Armeniş",
				"leavesAt": "15:01",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Armeniş",
				"to": "Slatina Timiş",
				"leavesAt": "15:09",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Slatina Timiş",
				"to": "Vălişoara Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 240,
				"distance": 6400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Petroşniţa h.",
				"to": "Valea Timişului Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Balta Sărată",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 240,
				"distance": 3500
			},
			{
				"from": "Balta Sărată",
				"to": "Caransebeş haltă h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Caransebeş",
				"leavesAt": "15:49",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Caransebeş",
				"to": "Tibiscu h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:01",
				"waitsAtSource": 180,
				"distance": 4100
			},
			{
				"from": "Tibiscu h.",
				"to": "Zăgujeni Hm.",
				"leavesAt": "16:02",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Căvăran",
				"leavesAt": "16:06",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Căvăran",
				"to": "Sacu h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Sacu h.",
				"to": "Jena Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Jena Hm.",
				"to": "Găvojdia",
				"leavesAt": "16:25",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Găvojdia",
				"to": "Tapia Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tapia Hm.",
				"to": "Lugoj",
				"leavesAt": "16:41",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lugoj",
				"to": "Jabăr Hm.",
				"leavesAt": "16:52",
				"arrivesAt": "16:58",
				"waitsAtSource": 300,
				"distance": 7600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 300,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "17:19",
				"arrivesAt": "17:25",
				"waitsAtSource": 360,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "17:30",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "17:41",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "17:50",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "18:05",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 375
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9666",
		"segments": [
			{
				"from": "Stamora Moraviţa",
				"to": "Denta h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:56",
				"waitsAtSource": 0,
				"distance": 8400
			},
			{
				"from": "Denta h.",
				"to": "Deta Hm.",
				"leavesAt": "16:57",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Deta Hm.",
				"to": "Voiteni",
				"leavesAt": "17:05",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "17:24",
				"arrivesAt": "17:34",
				"waitsAtSource": 540,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "17:35",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "17:51",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "17:58",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "18:02",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "363",
		"segments": [
			{
				"from": "Biharkeresztes",
				"to": "Episcopia Bihor",
				"leavesAt": "18:57",
				"arrivesAt": "19:12",
				"waitsAtSource": 0,
				"distance": 12500
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "19:36",
				"arrivesAt": "19:44",
				"waitsAtSource": 1440,
				"distance": 5700
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "19:48",
				"arrivesAt": "20:20",
				"waitsAtSource": 240,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "20:21",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "20:42",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Ciucea Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "21:13",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "21:34",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "21:59",
				"arrivesAt": "22:25",
				"waitsAtSource": 60,
				"distance": 27900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2421",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(210)",
				"leavesAt": "12:15",
				"arrivesAt": "12:18",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Turnişor Hm.",
				"leavesAt": "12:19",
				"arrivesAt": "12:24",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Cristian Sibiu h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Orlat",
				"leavesAt": "12:38",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Orlat",
				"to": "Sibiel h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sibiel h.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sălişte Hm.",
				"leavesAt": "12:56",
				"arrivesAt": "13:03",
				"waitsAtSource": 30,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7365",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Sud",
				"leavesAt": "19:29",
				"arrivesAt": "19:34",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Buzău Sud",
				"to": "Tăbărăşti h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:44",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:54",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:09",
				"waitsAtSource": 300,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "20:10",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Vizireni h.",
				"leavesAt": "20:18",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vizireni h.",
				"to": "CTF Făurei h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "CTF Făurei h.",
				"to": "Făurei",
				"leavesAt": "20:27",
				"arrivesAt": "20:34",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:42",
				"waitsAtSource": 300,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "20:50",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "20:56",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "21:07",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "21:14",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "21:23",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "21:33",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "21:45",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "21:50",
				"arrivesAt": "21:57",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "22:06",
				"arrivesAt": "22:18",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8580",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "04:40",
				"arrivesAt": "04:59",
				"waitsAtSource": 0,
				"distance": 12600
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Slobozia Veche",
				"leavesAt": "05:00",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 4200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5426",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "18:40",
				"arrivesAt": "18:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "18:55",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "19:03",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "19:18",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "19:28",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "19:35",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "19:40",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "19:50",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:36",
				"waitsAtSource": 1500,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "20:54",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "20:59",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "21:06",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "21:17",
				"arrivesAt": "21:24",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "21:25",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "21:30",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "21:45",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "21:51",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4546",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:38",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "15:09",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "15:38",
				"arrivesAt": "15:43",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "15:48",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2203",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "07:52",
				"arrivesAt": "08:02",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "08:03",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4525",
		"segments": [
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "00:43",
				"arrivesAt": "01:10",
				"waitsAtSource": 0,
				"distance": 28500
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 382
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 382
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3010",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "16:25",
				"arrivesAt": "16:34",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Jos h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "16:52",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "17:10",
				"arrivesAt": "17:19",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "17:27",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "17:31",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:41",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Posada h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Posada h.",
				"to": "Comarnic",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Bobolia h.",
				"leavesAt": "18:22",
				"arrivesAt": "18:28",
				"waitsAtSource": 120,
				"distance": 5500
			},
			{
				"from": "Bobolia h.",
				"to": "Floreşti Prahova",
				"leavesAt": "18:29",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "18:44",
				"arrivesAt": "18:54",
				"waitsAtSource": 420,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "18:55",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "19:17",
				"arrivesAt": "19:20",
				"waitsAtSource": 840,
				"distance": 2900
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Brazi",
				"leavesAt": "19:21",
				"arrivesAt": "19:26",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:32",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "19:33",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "19:38",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "19:43",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "19:57",
				"arrivesAt": "20:01",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "20:02",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "20:11",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "20:16",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4108",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Apahida",
				"leavesAt": "15:30",
				"arrivesAt": "15:47",
				"waitsAtSource": 0,
				"distance": 12300
			},
			{
				"from": "Apahida",
				"to": "Jucu Hm.",
				"leavesAt": "15:48",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Iclod Hm.",
				"leavesAt": "16:11",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "16:28",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "16:39",
				"arrivesAt": "16:58",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "17:08",
				"arrivesAt": "17:15",
				"waitsAtSource": 600,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Reteag Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "17:41",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "18:00",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:15",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "18:16",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:36",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "18:37",
				"arrivesAt": "18:41",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "18:42",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180105",
				"daysOfWeek": 895
			},
			{
				"from": "20180108",
				"to": "20180112",
				"daysOfWeek": 895
			},
			{
				"from": "20180115",
				"to": "20180119",
				"daysOfWeek": 895
			},
			{
				"from": "20180122",
				"to": "20180123",
				"daysOfWeek": 895
			},
			{
				"from": "20180125",
				"to": "20180126",
				"daysOfWeek": 895
			},
			{
				"from": "20180129",
				"to": "20180202",
				"daysOfWeek": 895
			},
			{
				"from": "20180205",
				"to": "20180209",
				"daysOfWeek": 895
			},
			{
				"from": "20180212",
				"to": "20180216",
				"daysOfWeek": 895
			},
			{
				"from": "20180219",
				"to": "20180223",
				"daysOfWeek": 895
			},
			{
				"from": "20180226",
				"to": "20180302",
				"daysOfWeek": 895
			},
			{
				"from": "20180305",
				"to": "20180309",
				"daysOfWeek": 895
			},
			{
				"from": "20180312",
				"to": "20180316",
				"daysOfWeek": 895
			},
			{
				"from": "20180319",
				"to": "20180323",
				"daysOfWeek": 895
			},
			{
				"from": "20180326",
				"to": "20180330",
				"daysOfWeek": 895
			},
			{
				"from": "20180402",
				"to": "20180406",
				"daysOfWeek": 895
			},
			{
				"from": "20180410",
				"to": "20180413",
				"daysOfWeek": 895
			},
			{
				"from": "20180416",
				"to": "20180420",
				"daysOfWeek": 895
			},
			{
				"from": "20180423",
				"to": "20180427",
				"daysOfWeek": 895
			},
			{
				"from": "20180430",
				"to": "20180430",
				"daysOfWeek": 895
			},
			{
				"from": "20180502",
				"to": "20180504",
				"daysOfWeek": 895
			},
			{
				"from": "20180507",
				"to": "20180511",
				"daysOfWeek": 895
			},
			{
				"from": "20180514",
				"to": "20180518",
				"daysOfWeek": 895
			},
			{
				"from": "20180521",
				"to": "20180525",
				"daysOfWeek": 895
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 895
			},
			{
				"from": "20180604",
				"to": "20180908",
				"daysOfWeek": 895
			},
			{
				"from": "20180910",
				"to": "20180914",
				"daysOfWeek": 895
			},
			{
				"from": "20180917",
				"to": "20180921",
				"daysOfWeek": 895
			},
			{
				"from": "20180924",
				"to": "20180928",
				"daysOfWeek": 895
			},
			{
				"from": "20181001",
				"to": "20181005",
				"daysOfWeek": 895
			},
			{
				"from": "20181008",
				"to": "20181012",
				"daysOfWeek": 895
			},
			{
				"from": "20181015",
				"to": "20181019",
				"daysOfWeek": 895
			},
			{
				"from": "20181022",
				"to": "20181026",
				"daysOfWeek": 895
			},
			{
				"from": "20181029",
				"to": "20181102",
				"daysOfWeek": 895
			},
			{
				"from": "20181105",
				"to": "20181109",
				"daysOfWeek": 895
			},
			{
				"from": "20181112",
				"to": "20181116",
				"daysOfWeek": 895
			},
			{
				"from": "20181119",
				"to": "20181123",
				"daysOfWeek": 895
			},
			{
				"from": "20181126",
				"to": "20181129",
				"daysOfWeek": 895
			},
			{
				"from": "20181203",
				"to": "20181207",
				"daysOfWeek": 895
			},
			{
				"from": "20171211",
				"to": "20171215",
				"daysOfWeek": 895
			},
			{
				"from": "20171218",
				"to": "20171222",
				"daysOfWeek": 895
			},
			{
				"from": "20171227",
				"to": "20171229",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5566",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "18:17",
				"arrivesAt": "18:22",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "18:24",
				"arrivesAt": "18:33",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "18:34",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Bursuceni h.",
				"leavesAt": "18:57",
				"arrivesAt": "19:07",
				"waitsAtSource": 900,
				"distance": 8100
			},
			{
				"from": "Bursuceni h.",
				"to": "Bucecea Hm",
				"leavesAt": "19:08",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "19:26",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "19:58",
				"arrivesAt": "20:22",
				"waitsAtSource": 780,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4653",
		"segments": [
			{
				"from": "Valea Vişeului",
				"to": "Lunca la Tisa h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:28",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "13:29",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Crăciuneşti h.",
				"leavesAt": "13:36",
				"arrivesAt": "13:42",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Tisa h.",
				"leavesAt": "13:43",
				"arrivesAt": "13:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Tisa h.",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "13:47",
				"arrivesAt": "13:54",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Sighetu Marmaţiei",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4334",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:07",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "07:23",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "07:40",
				"arrivesAt": "07:45",
				"waitsAtSource": 720,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "07:53",
				"arrivesAt": "07:59",
				"waitsAtSource": 480,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "08:18",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Carei",
				"to": "Marna h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Marna h.",
				"to": "Sanislău Hm.",
				"leavesAt": "08:38",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Sanislău Hm.",
				"to": "Resighea h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Resighea h.",
				"to": "Curtuiuşeni h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Valea lui Mihai",
				"leavesAt": "08:59",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7373",
		"segments": [
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "07:20",
				"arrivesAt": "07:24",
				"waitsAtSource": 0,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "07:25",
				"arrivesAt": "07:32",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "07:33",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "07:40",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "08:02",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "08:25",
				"arrivesAt": "08:32",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "08:33",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "08:44",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "08:52",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "09:00",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3623",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:26",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "06:35",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "06:56",
				"arrivesAt": "06:59",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Stana Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Stana Hm.",
				"to": "Jebuc h.",
				"leavesAt": "07:16",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Jebuc h.",
				"to": "Huedin",
				"leavesAt": "07:24",
				"arrivesAt": "07:31",
				"waitsAtSource": 30,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5462",
		"segments": [
			{
				"from": "Piatra Neamţ",
				"to": "Dumbrava h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:27",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Săvineşti h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săvineşti h.",
				"to": "Roznov",
				"leavesAt": "14:35",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Roznov",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Podoleni Hm.",
				"leavesAt": "14:47",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Podoleni Hm.",
				"to": "Costişa h.",
				"leavesAt": "14:55",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Costişa h.",
				"to": "Buhuşi",
				"leavesAt": "15:03",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhuşi",
				"to": "Racova h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:24",
				"waitsAtSource": 480,
				"distance": 3800
			},
			{
				"from": "Racova h.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Gârleni Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gârleni Hm.",
				"to": "Hămeiuş P.M.",
				"leavesAt": "15:36",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Bacău",
				"leavesAt": "15:43",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 7900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "79",
		"segments": [
			{
				"from": "Lokoshaza",
				"to": "Curtici",
				"leavesAt": "19:53",
				"arrivesAt": "20:03",
				"waitsAtSource": 0,
				"distance": 11200
			},
			{
				"from": "Curtici",
				"to": "Arad",
				"leavesAt": "20:28",
				"arrivesAt": "20:42",
				"waitsAtSource": 1500,
				"distance": 17000
			},
			{
				"from": "Arad",
				"to": "Timişoara Nord",
				"leavesAt": "20:44",
				"arrivesAt": "21:33",
				"waitsAtSource": 120,
				"distance": 57200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2085",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "14:25",
				"arrivesAt": "14:29",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "14:30",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "14:34",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "14:39",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "14:47",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Bungeţel h.",
				"leavesAt": "15:36",
				"arrivesAt": "15:39",
				"waitsAtSource": 1560,
				"distance": 2300
			},
			{
				"from": "Bungeţel h.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "15:46",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "15:50",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "15:57",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "16:08",
				"arrivesAt": "16:17",
				"waitsAtSource": 300,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "16:18",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "16:37",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "17:06",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "17:11",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Târgu Jiu",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ezureni h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ezureni h.",
				"to": "Parângu Hm.",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Parângu Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Meri",
				"leavesAt": "17:49",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Meri",
				"to": "Lainici Hm.",
				"leavesAt": "17:57",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lainici Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "18:13",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Livezeni",
				"leavesAt": "18:29",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Lunca Jiului hc.",
				"leavesAt": "18:35",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Petroşani",
				"leavesAt": "18:39",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 351
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1832",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "09:14",
				"arrivesAt": "10:11",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "10:12",
				"arrivesAt": "10:31",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "10:34",
				"arrivesAt": "11:07",
				"waitsAtSource": 180,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Salva",
				"leavesAt": "11:08",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Salva",
				"to": "Năsăud",
				"leavesAt": "11:31",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Năsăud",
				"to": "Ilva Mică",
				"leavesAt": "11:40",
				"arrivesAt": "12:02",
				"waitsAtSource": 120,
				"distance": 19800
			},
			{
				"from": "Ilva Mică",
				"to": "Poiana Ilvei",
				"leavesAt": "12:05",
				"arrivesAt": "12:20",
				"waitsAtSource": 180,
				"distance": 12800
			},
			{
				"from": "Poiana Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "12:25",
				"arrivesAt": "12:33",
				"waitsAtSource": 300,
				"distance": 4500
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "12:34",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Lunca Ilvei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "12:52",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 42800
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Iacobeni",
				"leavesAt": "13:50",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "14:06",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Pojorâta Hm.",
				"leavesAt": "14:18",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "14:40",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Vama",
				"leavesAt": "14:57",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Vama",
				"to": "Frasin",
				"leavesAt": "15:12",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "15:24",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Suceava",
				"leavesAt": "15:33",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "16:26",
				"arrivesAt": "16:39",
				"waitsAtSource": 600,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "16:40",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "16:59",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Târgu Frumos",
				"leavesAt": "17:17",
				"arrivesAt": "17:44",
				"waitsAtSource": 120,
				"distance": 30800
			},
			{
				"from": "Târgu Frumos",
				"to": "Iaşi",
				"leavesAt": "17:45",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 44900
			},
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "18:32",
				"arrivesAt": "18:38",
				"waitsAtSource": 720,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "18:39",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "19:01",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "19:24",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "19:43",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "19:58",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tutova",
				"leavesAt": "20:34",
				"arrivesAt": "20:47",
				"waitsAtSource": 180,
				"distance": 15000
			},
			{
				"from": "Tutova",
				"to": "Tecuci",
				"leavesAt": "20:51",
				"arrivesAt": "21:27",
				"waitsAtSource": 240,
				"distance": 35300
			},
			{
				"from": "Tecuci",
				"to": "Lieşti",
				"leavesAt": "21:29",
				"arrivesAt": "21:55",
				"waitsAtSource": 120,
				"distance": 24400
			},
			{
				"from": "Lieşti",
				"to": "Barboşi",
				"leavesAt": "21:56",
				"arrivesAt": "22:47",
				"waitsAtSource": 60,
				"distance": 48300
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "22:48",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9346",
		"segments": [
			{
				"from": "Giurgiu",
				"to": "Giurgiu Nord",
				"leavesAt": "15:35",
				"arrivesAt": "15:40",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Giurgiu Nord",
				"to": "Cetatea h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cetatea h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "15:44",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Onceşti h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Onceşti h.",
				"to": "Stăneşti Hm.",
				"leavesAt": "15:52",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Chiriacu Hm.",
				"leavesAt": "15:58",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Toporu",
				"leavesAt": "16:06",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Toporu",
				"to": "Răsuceni h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Răsuceni h.",
				"to": "Vlaşca Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Târnavele Hm.",
				"to": "Răduleşti Hm.",
				"leavesAt": "16:38",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Videle",
				"leavesAt": "16:57",
				"arrivesAt": "17:07",
				"waitsAtSource": 480,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1643",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "18:00",
				"arrivesAt": "18:42",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "18:44",
				"arrivesAt": "19:08",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "19:09",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Comarnic",
				"leavesAt": "19:15",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "19:24",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "19:39",
				"arrivesAt": "19:47",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "19:54",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "20:05",
				"arrivesAt": "20:42",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "20:54",
				"arrivesAt": "21:23",
				"waitsAtSource": 720,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "21:24",
				"arrivesAt": "21:56",
				"waitsAtSource": 60,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "21:57",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "22:22",
				"arrivesAt": "22:30",
				"waitsAtSource": 360,
				"distance": 7800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "22:31",
				"arrivesAt": "22:39",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Izvoru Oltului",
				"leavesAt": "22:43",
				"arrivesAt": "23:00",
				"waitsAtSource": 240,
				"distance": 17100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "23:01",
				"arrivesAt": "23:12",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Gheorgheni",
				"leavesAt": "23:13",
				"arrivesAt": "23:30",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "23:31",
				"arrivesAt": "00:03",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "00:05",
				"arrivesAt": "01:04",
				"waitsAtSource": 120,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Sărăţel Hm.",
				"leavesAt": "01:09",
				"arrivesAt": "02:07",
				"waitsAtSource": 300,
				"distance": 46800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "02:09",
				"arrivesAt": "02:36",
				"waitsAtSource": 120,
				"distance": 24900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9358",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "02:32",
				"arrivesAt": "02:35",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "02:36",
				"arrivesAt": "02:45",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "02:46",
				"arrivesAt": "02:57",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "02:58",
				"arrivesAt": "03:03",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "03:04",
				"arrivesAt": "03:17",
				"waitsAtSource": 30,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "03:18",
				"arrivesAt": "03:25",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8807",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "20:05",
				"arrivesAt": "20:17",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "20:25",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "20:34",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:58",
				"waitsAtSource": 540,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "20:59",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "21:15",
				"arrivesAt": "21:18",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "21:19",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "21:32",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "21:45",
				"arrivesAt": "21:53",
				"waitsAtSource": 540,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2724",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "14:45",
				"arrivesAt": "14:52",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băcia h.",
				"to": "Băcia Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia Hm.",
				"to": "Batiz h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Batiz h.",
				"to": "Călan Băi",
				"leavesAt": "15:03",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "15:06",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Ruşi h.",
				"leavesAt": "15:11",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ruşi h.",
				"to": "Măceu h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Măceu h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "15:19",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Plopi h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Plopi h.",
				"to": "Covragiu h.",
				"leavesAt": "15:29",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Covragiu h.",
				"to": "Subcetate",
				"leavesAt": "15:33",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20180115",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20180921",
				"daysOfWeek": 799
			},
			{
				"from": "20180924",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1095",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "12:45",
				"arrivesAt": "13:38",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Giurgiu Nord",
				"leavesAt": "13:39",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 63000
			},
			{
				"from": "Giurgiu Nord",
				"to": "Ruse",
				"leavesAt": "15:10",
				"arrivesAt": "15:35",
				"waitsAtSource": 1380,
				"distance": 16000
			}
		],
		"restrictions": [
			{
				"from": "20181002",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180531",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4311",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "04:58",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "04:59",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Apa Hm.",
				"to": "Seini",
				"leavesAt": "05:36",
				"arrivesAt": "05:50",
				"waitsAtSource": 600,
				"distance": 8500
			},
			{
				"from": "Seini",
				"to": "Săbişa h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Săbişa h.",
				"to": "Ilba h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ilba h.",
				"to": "Cicârlău h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cicârlău h.",
				"to": "Buşag Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:19",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Buşag Hm.",
				"to": "Baia Mare",
				"leavesAt": "06:20",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9443",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:37",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Aninoasa Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Aninoasa Hm.",
				"to": "Săteni h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Săteni h.",
				"to": "Doiceşti",
				"leavesAt": "07:48",
				"arrivesAt": "07:51",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Doiceşti",
				"to": "Doiceşti h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Doiceşti h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "07:55",
				"arrivesAt": "07:58",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Scârlenţa h.",
				"leavesAt": "07:59",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Scârlenţa h.",
				"to": "Trainica h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Trainica h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "08:06",
				"arrivesAt": "08:10",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Moţăieni h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Moţăieni h.",
				"to": "Fieni",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Pietroşiţa Hm.",
				"leavesAt": "08:25",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9301",
		"segments": [
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:52",
				"waitsAtSource": 0,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "06:03",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "06:10",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "06:36",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5523",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:57",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "06:58",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "07:07",
				"arrivesAt": "07:14",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:20",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Sfântu Mina h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:24",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Târgu Neamţ",
				"leavesAt": "07:25",
				"arrivesAt": "07:36",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2604",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "13:36",
				"arrivesAt": "13:43",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Valea Viilor Hm.",
				"leavesAt": "13:44",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Şag Hm.",
				"leavesAt": "13:58",
				"arrivesAt": "14:03",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "14:08",
				"arrivesAt": "14:14",
				"waitsAtSource": 300,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "14:15",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "14:26",
				"arrivesAt": "14:32",
				"waitsAtSource": 360,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "14:33",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:57",
				"waitsAtSource": 660,
				"distance": 7400
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "15:02",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3116",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Vest Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:10",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "16:11",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Cefa Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cefa Hm.",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:47",
				"waitsAtSource": 180,
				"distance": 9300
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Salonta",
				"leavesAt": "16:48",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "16:54",
				"arrivesAt": "17:05",
				"waitsAtSource": 120,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Boiu Bihor h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:11",
				"waitsAtSource": 120,
				"distance": 3800
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Tămaşda h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tămaşda h.",
				"to": "Zerind Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:29",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Zerind Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "17:30",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "17:54",
				"arrivesAt": "18:01",
				"waitsAtSource": 1020,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "18:20",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:41",
				"waitsAtSource": 300,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "18:42",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Utvinişu Nou",
				"leavesAt": "18:47",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "18:52",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "19:23",
				"arrivesAt": "19:30",
				"waitsAtSource": 1140,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Şag Hm.",
				"leavesAt": "19:31",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "19:45",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "19:52",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "19:58",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "20:04",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj h",
				"leavesAt": "20:11",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "20:18",
				"arrivesAt": "20:20",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Timişoara Nord",
				"leavesAt": "20:21",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9167",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Valea Păltinişului h.",
				"leavesAt": "13:33",
				"arrivesAt": "13:38",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "13:39",
				"arrivesAt": "13:46",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Brebu",
				"leavesAt": "13:47",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "14:00",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "14:09",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "14:16",
				"arrivesAt": "14:27",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "14:28",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4511",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "15:38",
				"arrivesAt": "15:46",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:11",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:19",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:39",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Şugău h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şugău h.",
				"to": "Valea Strâmbă h.",
				"leavesAt": "16:56",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Gheorgheni",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Gheorgheni",
				"to": "Lăzarea Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Ditrău",
				"leavesAt": "17:11",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ditrău",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "17:34",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Topliţa",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Topliţa",
				"to": "Ciobotani h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ciobotani h.",
				"to": "Stânceni Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Stânceni Hm.",
				"to": "Stânceni h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "18:21",
				"arrivesAt": "18:29",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Andreneasa h.",
				"leavesAt": "18:30",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Andreneasa h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:50",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Borzia h.",
				"leavesAt": "18:51",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Borzia h.",
				"to": "Deda Bistra Hm.",
				"leavesAt": "18:56",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Deda",
				"leavesAt": "19:01",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:25",
				"waitsAtSource": 4200,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "20:26",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:41",
				"waitsAtSource": 360,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "20:52",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:21",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "21:22",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "21:41",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5723",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Vest",
				"leavesAt": "19:26",
				"arrivesAt": "19:34",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Suceava Vest",
				"to": "Stroieşti",
				"leavesAt": "19:35",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Stroieşti",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 240,
				"distance": 7000
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "20:05",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Gura Humorului Hm.",
				"leavesAt": "20:13",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Gura Humorului Oraş",
				"leavesAt": "20:24",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "20:31",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Molid Hm.",
				"leavesAt": "20:41",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Molid Hm.",
				"to": "Vama",
				"leavesAt": "20:49",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vama",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "21:14",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4705",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:55",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "11:56",
				"arrivesAt": "12:07",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "12:08",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "12:15",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "12:25",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "12:31",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "12:35",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "12:54",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "12:58",
				"arrivesAt": "13:06",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "13:07",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "13:13",
				"arrivesAt": "13:18",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180105",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180112",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180209",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180406",
				"daysOfWeek": 383
			},
			{
				"from": "20180410",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180618",
				"to": "20180622",
				"daysOfWeek": 383
			},
			{
				"from": "20180625",
				"to": "20180629",
				"daysOfWeek": 383
			},
			{
				"from": "20180702",
				"to": "20180706",
				"daysOfWeek": 383
			},
			{
				"from": "20180709",
				"to": "20180713",
				"daysOfWeek": 383
			},
			{
				"from": "20180716",
				"to": "20180720",
				"daysOfWeek": 383
			},
			{
				"from": "20180723",
				"to": "20180727",
				"daysOfWeek": 383
			},
			{
				"from": "20180730",
				"to": "20180803",
				"daysOfWeek": 383
			},
			{
				"from": "20180806",
				"to": "20180810",
				"daysOfWeek": 383
			},
			{
				"from": "20180813",
				"to": "20180814",
				"daysOfWeek": 383
			},
			{
				"from": "20180816",
				"to": "20180817",
				"daysOfWeek": 383
			},
			{
				"from": "20180820",
				"to": "20180824",
				"daysOfWeek": 383
			},
			{
				"from": "20180827",
				"to": "20180831",
				"daysOfWeek": 383
			},
			{
				"from": "20180903",
				"to": "20180907",
				"daysOfWeek": 383
			},
			{
				"from": "20171227",
				"to": "20171229",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9168",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "17:58",
				"arrivesAt": "18:07",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "18:25",
				"arrivesAt": "18:37",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "18:47",
				"arrivesAt": "18:59",
				"waitsAtSource": 600,
				"distance": 10500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Valea Păltinişului h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Caransebeş",
				"leavesAt": "19:08",
				"arrivesAt": "19:14",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2235",
		"segments": [
			{
				"from": "Radna",
				"to": "Neudorf h.",
				"leavesAt": "14:15",
				"arrivesAt": "14:22",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Neudorf h.",
				"to": "Zăbrani Hm.",
				"leavesAt": "14:23",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zăbrani Hm.",
				"to": "Aliuş hcv.",
				"leavesAt": "14:30",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Aliuş hcv.",
				"to": "Gomila h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Gomila h.",
				"to": "Şarlota h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şarlota h.",
				"to": "Remetea Mică",
				"leavesAt": "14:57",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180525",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20181228",
				"to": "20181229",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1818",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Buziaş",
				"leavesAt": "06:27",
				"arrivesAt": "07:04",
				"waitsAtSource": 0,
				"distance": 36400
			},
			{
				"from": "Buziaş",
				"to": "Lugoj",
				"leavesAt": "07:06",
				"arrivesAt": "07:37",
				"waitsAtSource": 120,
				"distance": 27500
			},
			{
				"from": "Lugoj",
				"to": "Făget",
				"leavesAt": "07:39",
				"arrivesAt": "08:20",
				"waitsAtSource": 120,
				"distance": 39700
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "08:33",
				"arrivesAt": "08:46",
				"waitsAtSource": 780,
				"distance": 7600
			},
			{
				"from": "Margina",
				"to": "Ilia",
				"leavesAt": "08:48",
				"arrivesAt": "09:28",
				"waitsAtSource": 120,
				"distance": 35500
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "09:29",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "09:58",
				"arrivesAt": "10:09",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Orăştie",
				"leavesAt": "10:12",
				"arrivesAt": "10:33",
				"waitsAtSource": 180,
				"distance": 16500
			},
			{
				"from": "Orăştie",
				"to": "Şibot",
				"leavesAt": "10:45",
				"arrivesAt": "11:00",
				"waitsAtSource": 720,
				"distance": 12300
			},
			{
				"from": "Şibot",
				"to": "Vinţu de Jos",
				"leavesAt": "11:01",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "11:24",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Teiuş",
				"leavesAt": "11:36",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "12:15",
				"arrivesAt": "12:27",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Unirea hc.",
				"leavesAt": "12:28",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Luduş",
				"leavesAt": "12:52",
				"arrivesAt": "13:10",
				"waitsAtSource": 60,
				"distance": 19200
			},
			{
				"from": "Luduş",
				"to": "Iernut",
				"leavesAt": "13:11",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Iernut",
				"to": "Târgu Mureş",
				"leavesAt": "13:26",
				"arrivesAt": "13:55",
				"waitsAtSource": 60,
				"distance": 28600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1667",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "22:55",
				"arrivesAt": "23:44",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "23:46",
				"arrivesAt": "00:20",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "00:21",
				"arrivesAt": "00:58",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "01:00",
				"arrivesAt": "01:31",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "01:33",
				"arrivesAt": "02:11",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Tecuci",
				"leavesAt": "02:13",
				"arrivesAt": "02:56",
				"waitsAtSource": 120,
				"distance": 36500
			},
			{
				"from": "Tecuci",
				"to": "Bârlad",
				"leavesAt": "03:08",
				"arrivesAt": "03:51",
				"waitsAtSource": 720,
				"distance": 50300
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "03:52",
				"arrivesAt": "04:21",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "04:22",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "04:38",
				"arrivesAt": "04:56",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "05:24",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1695",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "21:20",
				"arrivesAt": "22:13",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "22:14",
				"arrivesAt": "22:59",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "23:01",
				"arrivesAt": "23:49",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "23:50",
				"arrivesAt": "00:30",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "00:40",
				"arrivesAt": "01:06",
				"waitsAtSource": 600,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Strehaia hc.",
				"leavesAt": "01:07",
				"arrivesAt": "01:31",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Strehaia hc.",
				"to": "Balota",
				"leavesAt": "01:32",
				"arrivesAt": "02:10",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Balota",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "02:11",
				"arrivesAt": "02:44",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Orşova",
				"leavesAt": "02:48",
				"arrivesAt": "03:19",
				"waitsAtSource": 240,
				"distance": 24000
			},
			{
				"from": "Orşova",
				"to": "Băile Herculane",
				"leavesAt": "03:20",
				"arrivesAt": "03:40",
				"waitsAtSource": 60,
				"distance": 17500
			},
			{
				"from": "Băile Herculane",
				"to": "Caransebeş",
				"leavesAt": "03:42",
				"arrivesAt": "05:05",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "05:16",
				"arrivesAt": "05:50",
				"waitsAtSource": 660,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Belinţ Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "06:02",
				"waitsAtSource": 120,
				"distance": 13200
			},
			{
				"from": "Belinţ Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "06:06",
				"arrivesAt": "06:52",
				"waitsAtSource": 240,
				"distance": 45700
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180427",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1781",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "07:30",
				"arrivesAt": "08:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "08:36",
				"arrivesAt": "08:55",
				"waitsAtSource": 360,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "08:56",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "09:19",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1831",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "05:56",
				"arrivesAt": "06:21",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Lieşti",
				"leavesAt": "06:24",
				"arrivesAt": "07:11",
				"waitsAtSource": 180,
				"distance": 48300
			},
			{
				"from": "Lieşti",
				"to": "Tecuci",
				"leavesAt": "07:12",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 24400
			},
			{
				"from": "Tecuci",
				"to": "Bârlad",
				"leavesAt": "07:44",
				"arrivesAt": "08:27",
				"waitsAtSource": 120,
				"distance": 50300
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "08:28",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "08:58",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "09:14",
				"arrivesAt": "09:32",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "09:33",
				"arrivesAt": "09:59",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "10:00",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "10:17",
				"arrivesAt": "10:24",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Iaşi",
				"to": "Târgu Frumos",
				"leavesAt": "10:49",
				"arrivesAt": "11:25",
				"waitsAtSource": 1500,
				"distance": 44900
			},
			{
				"from": "Târgu Frumos",
				"to": "Paşcani",
				"leavesAt": "11:26",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 30800
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "11:55",
				"arrivesAt": "12:15",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "12:16",
				"arrivesAt": "12:32",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "12:34",
				"arrivesAt": "12:46",
				"waitsAtSource": 120,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Gura Humorului Oraş",
				"leavesAt": "13:03",
				"arrivesAt": "13:49",
				"waitsAtSource": 1020,
				"distance": 46800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "13:50",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Vama",
				"leavesAt": "13:59",
				"arrivesAt": "14:09",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vama",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "14:10",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "14:27",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Sadova Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "14:41",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Sadova Hm.",
				"to": "Pojorâta Hm.",
				"leavesAt": "14:46",
				"arrivesAt": "14:52",
				"waitsAtSource": 300,
				"distance": 3000
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Mestecăniş",
				"leavesAt": "14:53",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Mestecăniş",
				"to": "Vatra Dornei",
				"leavesAt": "15:15",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "15:41",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Floreni",
				"leavesAt": "15:45",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Floreni",
				"to": "Lunca Ilvei",
				"leavesAt": "16:01",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 31900
			},
			{
				"from": "Lunca Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mică",
				"leavesAt": "17:02",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 17300
			},
			{
				"from": "Ilva Mică",
				"to": "Năsăud",
				"leavesAt": "17:28",
				"arrivesAt": "17:49",
				"waitsAtSource": 300,
				"distance": 19800
			},
			{
				"from": "Năsăud",
				"to": "Salva",
				"leavesAt": "17:52",
				"arrivesAt": "17:59",
				"waitsAtSource": 180,
				"distance": 6300
			},
			{
				"from": "Salva",
				"to": "Beclean pe Someş",
				"leavesAt": "18:01",
				"arrivesAt": "18:23",
				"waitsAtSource": 120,
				"distance": 21600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Triaj",
				"leavesAt": "18:25",
				"arrivesAt": "18:53",
				"waitsAtSource": 120,
				"distance": 21900
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "18:54",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "19:06",
				"arrivesAt": "19:25",
				"waitsAtSource": 300,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "19:27",
				"arrivesAt": "20:19",
				"waitsAtSource": 120,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2873",
		"segments": [
			{
				"from": "Turceni",
				"to": "Gârbovu h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:37",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Gârbovu h.",
				"to": "Sărdăneşti h.",
				"leavesAt": "14:38",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Plopşoru",
				"leavesAt": "14:44",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Plopşoru",
				"to": "Peşteana Jiu h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Bâlteni h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bâlteni h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "15:07",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Rovinari Sud h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Rovinari Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Hm.",
				"to": "Km. 49+800 h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:29",
				"waitsAtSource": 480,
				"distance": 1000
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rogojelu",
				"leavesAt": "15:30",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Rogojelu",
				"to": "Vârţ h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Vârţ h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Drăguţeşti h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Amaradia",
				"leavesAt": "15:50",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Amaradia",
				"to": "Târgu Jiu",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1582",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Bucureşti Nord",
				"leavesAt": "13:00",
				"arrivesAt": "15:02",
				"waitsAtSource": 0,
				"distance": 225000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9005",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:07",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureştii Noi",
				"leavesAt": "17:08",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "17:16",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:36",
				"waitsAtSource": 360,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "17:37",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Vadu Lat Hm.",
				"leavesAt": "17:55",
				"arrivesAt": "18:08",
				"waitsAtSource": 480,
				"distance": 10800
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Zăvestreni Hm.",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Videle",
				"leavesAt": "18:21",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "18:39",
				"arrivesAt": "18:46",
				"waitsAtSource": 600,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "18:47",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "18:56",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "19:03",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "19:11",
				"arrivesAt": "19:16",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "19:17",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "19:28",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Roşiori Nord",
				"to": "Mihăeşti Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:56",
				"waitsAtSource": 120,
				"distance": 17300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "19:57",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Dăneasa h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Dăneasa h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "20:14",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Fărcaşele Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Caracal",
				"leavesAt": "20:31",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "20:48",
				"arrivesAt": "20:54",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "21:01",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "21:09",
				"arrivesAt": "21:14",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "21:15",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:29",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "21:30",
				"arrivesAt": "21:34",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "21:35",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4580",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "05:02",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:20",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "05:25",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "05:41",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8806",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "11:10",
				"arrivesAt": "11:18",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "11:26",
				"arrivesAt": "11:30",
				"waitsAtSource": 480,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "11:31",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "11:42",
				"arrivesAt": "11:45",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "11:54",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "12:03",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "12:10",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 14000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1798",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Remetea Mare",
				"leavesAt": "13:52",
				"arrivesAt": "14:11",
				"waitsAtSource": 0,
				"distance": 13300
			},
			{
				"from": "Remetea Mare",
				"to": "Lugoj",
				"leavesAt": "14:15",
				"arrivesAt": "14:50",
				"waitsAtSource": 240,
				"distance": 45600
			},
			{
				"from": "Lugoj",
				"to": "Caransebeş",
				"leavesAt": "14:52",
				"arrivesAt": "15:26",
				"waitsAtSource": 120,
				"distance": 39400
			},
			{
				"from": "Caransebeş",
				"to": "Băile Herculane",
				"leavesAt": "15:28",
				"arrivesAt": "16:51",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Băile Herculane",
				"to": "Valea Cernei Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "17:08",
				"waitsAtSource": 120,
				"distance": 11800
			},
			{
				"from": "Valea Cernei Hm.",
				"to": "Orşova",
				"leavesAt": "17:12",
				"arrivesAt": "17:19",
				"waitsAtSource": 240,
				"distance": 5700
			},
			{
				"from": "Orşova",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "17:20",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Balota",
				"leavesAt": "17:54",
				"arrivesAt": "18:27",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Balota",
				"to": "Strehaia hc.",
				"leavesAt": "18:28",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Strehaia hc.",
				"to": "Filiaşi",
				"leavesAt": "19:00",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "19:28",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "20:00",
				"arrivesAt": "20:39",
				"waitsAtSource": 480,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "20:40",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "21:26",
				"arrivesAt": "22:10",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "22:11",
				"arrivesAt": "23:02",
				"waitsAtSource": 60,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9135",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(913)",
				"leavesAt": "14:18",
				"arrivesAt": "14:21",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Jiu Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Jiu Hm.",
				"to": "Podari",
				"leavesAt": "14:28",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Podari",
				"to": "Sălcuţa Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Dealul Robului h.",
				"leavesAt": "14:55",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dealul Robului h.",
				"to": "Segarcea Nord hc.",
				"leavesAt": "15:01",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Segarcea",
				"leavesAt": "15:09",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea",
				"to": "Cerăt h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:27",
				"waitsAtSource": 540,
				"distance": 3200
			},
			{
				"from": "Cerăt h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "15:28",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Urzica Mare h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Urzica Mare h.",
				"to": "Afumaţi h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Afumaţi h.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Boureni P.M.",
				"leavesAt": "16:06",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Boureni P.M.",
				"to": "Băileşti",
				"leavesAt": "16:11",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1968",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Iaşi",
				"leavesAt": "03:45",
				"arrivesAt": "04:52",
				"waitsAtSource": 0,
				"distance": 75700
			}
		],
		"restrictions": [
			{
				"from": "20181012",
				"to": "20181015",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9485",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "13:45",
				"arrivesAt": "13:53",
				"waitsAtSource": 0,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Balş",
				"leavesAt": "13:54",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Balş",
				"to": "Spineni h.",
				"leavesAt": "14:01",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Spineni h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:14",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "14:15",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Toporaş h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "14:21",
				"arrivesAt": "14:24",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Cârcea h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cârcea h.",
				"to": "Plaiu Vulcăneşti Hm.",
				"leavesAt": "14:33",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Plaiu Vulcăneşti Hm.",
				"to": "Bordei hc.(901)",
				"leavesAt": "14:40",
				"arrivesAt": "14:44",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Craiova",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6412",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "15:47",
				"arrivesAt": "15:54",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:03",
				"waitsAtSource": 120,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "16:14",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "16:24",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "16:32",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "17:17",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 9800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9613",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Boldur h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:54",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Boldur h.",
				"to": "Sinia Hm.",
				"leavesAt": "07:55",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sinia Hm.",
				"to": "Căpăt h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Căpăt h.",
				"to": "Buziaş",
				"leavesAt": "08:07",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Buziaş",
				"to": "Bacova h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Bacova h.",
				"to": "Chevereş h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Chevereş h.",
				"to": "Sacoşu Mic",
				"leavesAt": "08:27",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Sacoşu Mic",
				"to": "Uliuc h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Uliuc h.",
				"to": "Urseni h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Urseni h.",
				"to": "Semenic Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Semenic Hm.",
				"to": "Giroc h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Giroc h.",
				"to": "Timişoara Sud",
				"leavesAt": "08:54",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "09:01",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9351",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "04:25",
				"arrivesAt": "05:16",
				"waitsAtSource": 0,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5631",
		"segments": [
			{
				"from": "Dărmăneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "05:58",
				"arrivesAt": "06:09",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Ţibeni h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ţibeni h.",
				"to": "Dorneşti",
				"leavesAt": "06:19",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1995",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "16:05",
				"arrivesAt": "16:12",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "16:13",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "16:21",
				"arrivesAt": "16:34",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "16:44",
				"arrivesAt": "16:59",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "17:07",
				"arrivesAt": "17:14",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "17:15",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "18:05",
				"arrivesAt": "18:32",
				"waitsAtSource": 1560,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "18:33",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "18:54",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "19:16",
				"arrivesAt": "19:42",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "19:43",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 108900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "21:20",
				"arrivesAt": "22:13",
				"waitsAtSource": 1680,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "22:14",
				"arrivesAt": "22:59",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "23:01",
				"arrivesAt": "23:49",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "23:50",
				"arrivesAt": "00:30",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "00:40",
				"arrivesAt": "01:06",
				"waitsAtSource": 600,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Strehaia hc.",
				"leavesAt": "01:07",
				"arrivesAt": "01:31",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Strehaia hc.",
				"to": "Balota",
				"leavesAt": "01:32",
				"arrivesAt": "02:10",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Balota",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "02:11",
				"arrivesAt": "02:44",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Orşova",
				"leavesAt": "02:48",
				"arrivesAt": "03:19",
				"waitsAtSource": 240,
				"distance": 24000
			},
			{
				"from": "Orşova",
				"to": "Băile Herculane",
				"leavesAt": "03:20",
				"arrivesAt": "03:40",
				"waitsAtSource": 60,
				"distance": 17500
			},
			{
				"from": "Băile Herculane",
				"to": "Caransebeş",
				"leavesAt": "03:42",
				"arrivesAt": "05:05",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "05:16",
				"arrivesAt": "05:50",
				"waitsAtSource": 660,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Belinţ Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "06:02",
				"waitsAtSource": 120,
				"distance": 13200
			},
			{
				"from": "Belinţ Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "06:06",
				"arrivesAt": "06:52",
				"waitsAtSource": 240,
				"distance": 45700
			}
		],
		"restrictions": [
			{
				"from": "20180428",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8375",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "18:39",
				"arrivesAt": "18:51",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "18:59",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "19:15",
				"arrivesAt": "19:21",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "19:22",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "19:30",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "19:39",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "19:44",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "19:55",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "20:00",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1749",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Iernut",
				"leavesAt": "11:46",
				"arrivesAt": "12:12",
				"waitsAtSource": 0,
				"distance": 28600
			},
			{
				"from": "Iernut",
				"to": "Luduş",
				"leavesAt": "12:13",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Luduş",
				"to": "Războieni",
				"leavesAt": "12:28",
				"arrivesAt": "12:46",
				"waitsAtSource": 60,
				"distance": 19200
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "12:56",
				"arrivesAt": "13:11",
				"waitsAtSource": 600,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "13:13",
				"arrivesAt": "14:18",
				"waitsAtSource": 120,
				"distance": 51500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5207",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "14:28",
				"arrivesAt": "14:34",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "14:35",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "14:49",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:12",
				"waitsAtSource": 120,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "15:13",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "15:17",
				"arrivesAt": "15:21",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "15:28",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "15:43",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Viişoara h",
				"leavesAt": "15:51",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:08",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "16:09",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "16:19",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "16:36",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Comăneşti",
				"to": "Asău Hm.",
				"leavesAt": "16:45",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Asău Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caraliţa h.",
				"to": "Goioasa Hm.",
				"leavesAt": "16:57",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Goioasa Hm.",
				"to": "Simbrea Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Simbrea Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 360,
				"distance": 4300
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Palanca Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Palanca Hm.",
				"to": "Ghimeş",
				"leavesAt": "17:29",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghimeş",
				"to": "Bolovăniş h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Tarcău h.",
				"leavesAt": "17:53",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "17:58",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Utuşoiu h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Utuşoiu h.",
				"to": "Livezi Ciuc",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Caracău h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:22",
				"waitsAtSource": 180,
				"distance": 2100
			},
			{
				"from": "Caracău h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Mihăileni Hm.",
				"leavesAt": "18:36",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Siculeni",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "18:48",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4342",
		"segments": [
			{
				"from": "Valea lui Mihai",
				"to": "Simion h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:26",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Simion h.",
				"to": "Şilindru Hm.",
				"leavesAt": "13:27",
				"arrivesAt": "13:33",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Şilindru Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "13:34",
				"arrivesAt": "13:43",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Cadia h.",
				"leavesAt": "13:44",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cadia h.",
				"to": "Diosig Hm.",
				"leavesAt": "13:52",
				"arrivesAt": "13:58",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Diosig Hm.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "13:59",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Tămăşeu h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:13",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tămăşeu h.",
				"to": "Biharia Hm.",
				"leavesAt": "14:14",
				"arrivesAt": "14:22",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Biharia Hm.",
				"to": "Episcopia Bihor",
				"leavesAt": "14:23",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "14:34",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9588",
		"segments": [
			{
				"from": "Jimbolia",
				"to": "Clarii Vii h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:21",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Clarii Vii h.",
				"to": "Cărpiniş",
				"leavesAt": "09:22",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Cărpiniş",
				"to": "Beregsău hcv.",
				"leavesAt": "09:31",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Beregsău hcv.",
				"to": "Săcălaz h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săcălaz h.",
				"to": "Timişoara Nord",
				"leavesAt": "09:47",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1723",
		"segments": [
			{
				"from": "Caracal",
				"to": "Romula Hm.",
				"leavesAt": "18:16",
				"arrivesAt": "18:27",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Romula Hm.",
				"to": "Fălcoiu h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fălcoiu h.",
				"to": "Vlăduleni",
				"leavesAt": "18:35",
				"arrivesAt": "18:42",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vlăduleni",
				"to": "Şopârliţa hc.",
				"leavesAt": "18:43",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Piatra Olt",
				"leavesAt": "18:47",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Piatra Olt",
				"to": "Drăgăşani",
				"leavesAt": "19:00",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 33800
			},
			{
				"from": "Drăgăşani",
				"to": "Băbeni",
				"leavesAt": "19:28",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Băbeni",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "20:02",
				"arrivesAt": "20:23",
				"waitsAtSource": 480,
				"distance": 19600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Călimăneşti",
				"leavesAt": "20:35",
				"arrivesAt": "20:52",
				"waitsAtSource": 720,
				"distance": 16200
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Lotru",
				"leavesAt": "20:59",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Lotru",
				"to": "Câineni",
				"leavesAt": "21:26",
				"arrivesAt": "21:49",
				"waitsAtSource": 540,
				"distance": 21100
			},
			{
				"from": "Câineni",
				"to": "Turnu Roşu hc.",
				"leavesAt": "21:50",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "22:20",
				"arrivesAt": "22:30",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "22:31",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9383",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Măldăeni Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Dăneasa h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Dăneasa h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "06:15",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Fărcaşele Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Caracal",
				"leavesAt": "06:33",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "06:50",
				"arrivesAt": "06:56",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "06:57",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "07:03",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "07:07",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "07:11",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "07:17",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Malu Mare Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:29",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "07:33",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "07:38",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "07:42",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5609",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "16:40",
				"arrivesAt": "16:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "16:55",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "17:03",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "17:10",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "17:18",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "17:50",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:15",
				"waitsAtSource": 360,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "18:16",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "18:33",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "18:46",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "18:53",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "19:07",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "19:14",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "19:23",
				"arrivesAt": "19:29",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9610",
		"segments": [
			{
				"from": "Buziaş",
				"to": "Căpăt h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:25",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Căpăt h.",
				"to": "Sinia Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sinia Hm.",
				"to": "Boldur h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Boldur h.",
				"to": "Lugoj",
				"leavesAt": "05:40",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9109",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "14:07",
				"arrivesAt": "14:15",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "14:16",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "14:20",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "14:54",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "15:13",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "15:18",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "15:36",
				"arrivesAt": "15:40",
				"waitsAtSource": 660,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "15:55",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "16:10",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8691",
		"segments": [
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:25",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "05:26",
				"arrivesAt": "05:30",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "05:46",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "05:52",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "05:58",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180106",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180113",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180120",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180123",
				"daysOfWeek": 383
			},
			{
				"from": "20180125",
				"to": "20180127",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180203",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180210",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180217",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180224",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180303",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180310",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180317",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180324",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180331",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180410",
				"to": "20180414",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180421",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180426",
				"daysOfWeek": 383
			},
			{
				"from": "20180502",
				"to": "20180505",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180512",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180519",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180531",
				"daysOfWeek": 383
			},
			{
				"from": "20180602",
				"to": "20180602",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180915",
				"daysOfWeek": 383
			},
			{
				"from": "20180917",
				"to": "20180922",
				"daysOfWeek": 383
			},
			{
				"from": "20180924",
				"to": "20180929",
				"daysOfWeek": 383
			},
			{
				"from": "20181001",
				"to": "20181006",
				"daysOfWeek": 383
			},
			{
				"from": "20181008",
				"to": "20181013",
				"daysOfWeek": 383
			},
			{
				"from": "20181015",
				"to": "20181020",
				"daysOfWeek": 383
			},
			{
				"from": "20181022",
				"to": "20181027",
				"daysOfWeek": 383
			},
			{
				"from": "20181029",
				"to": "20181103",
				"daysOfWeek": 383
			},
			{
				"from": "20181105",
				"to": "20181110",
				"daysOfWeek": 383
			},
			{
				"from": "20181112",
				"to": "20181117",
				"daysOfWeek": 383
			},
			{
				"from": "20181119",
				"to": "20181124",
				"daysOfWeek": 383
			},
			{
				"from": "20181126",
				"to": "20181129",
				"daysOfWeek": 383
			},
			{
				"from": "20181203",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171216",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171223",
				"daysOfWeek": 383
			},
			{
				"from": "20171227",
				"to": "20171230",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4545",
		"segments": [
			{
				"from": "Topliţa",
				"to": "Ciobotani h.",
				"leavesAt": "10:30",
				"arrivesAt": "10:39",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Ciobotani h.",
				"to": "Stânceni Hm.",
				"leavesAt": "10:40",
				"arrivesAt": "10:46",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Stânceni Hm.",
				"to": "Stânceni h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:54",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "10:55",
				"arrivesAt": "11:00",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "11:01",
				"arrivesAt": "11:09",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Andreneasa h.",
				"leavesAt": "11:10",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Andreneasa h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:30",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Borzia h.",
				"leavesAt": "11:31",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Borzia h.",
				"to": "Deda Bistra Hm.",
				"leavesAt": "11:36",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Deda",
				"leavesAt": "11:41",
				"arrivesAt": "11:50",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "12:04",
				"arrivesAt": "12:10",
				"waitsAtSource": 840,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "12:11",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "12:20",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "12:24",
				"arrivesAt": "12:29",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "12:30",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:48",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "12:49",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "12:55",
				"arrivesAt": "13:00",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "13:01",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "13:07",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "13:20",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4042",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:36",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "07:43",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Ţicău h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ţicău h.",
				"to": "Benesat Hm.",
				"leavesAt": "08:01",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Benesat Hm.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:14",
				"waitsAtSource": 120,
				"distance": 2700
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Inău h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Inău h.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "08:36",
				"arrivesAt": "08:46",
				"waitsAtSource": 660,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1004",
		"segments": [
			{
				"from": "Ruse",
				"to": "Giurgiu Nord",
				"leavesAt": "00:20",
				"arrivesAt": "00:45",
				"waitsAtSource": 0,
				"distance": 16000
			},
			{
				"from": "Giurgiu Nord",
				"to": "Videle",
				"leavesAt": "01:15",
				"arrivesAt": "02:24",
				"waitsAtSource": 1800,
				"distance": 63000
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "02:25",
				"arrivesAt": "03:19",
				"waitsAtSource": 60,
				"distance": 50900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "03:37",
				"arrivesAt": "04:30",
				"waitsAtSource": 1080,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Buzău",
				"leavesAt": "04:33",
				"arrivesAt": "05:43",
				"waitsAtSource": 180,
				"distance": 68600
			},
			{
				"from": "Buzău",
				"to": "Focşani",
				"leavesAt": "05:46",
				"arrivesAt": "06:56",
				"waitsAtSource": 180,
				"distance": 70800
			},
			{
				"from": "Focşani",
				"to": "Adjud",
				"leavesAt": "06:58",
				"arrivesAt": "07:46",
				"waitsAtSource": 120,
				"distance": 45400
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "07:48",
				"arrivesAt": "08:32",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Paşcani",
				"leavesAt": "08:34",
				"arrivesAt": "09:38",
				"waitsAtSource": 120,
				"distance": 84000
			},
			{
				"from": "Paşcani",
				"to": "Suceava",
				"leavesAt": "09:41",
				"arrivesAt": "10:31",
				"waitsAtSource": 180,
				"distance": 60600
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 1140,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "10:56",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "11:07",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dorneşti",
				"leavesAt": "11:18",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Dorneşti",
				"to": "Vicşani",
				"leavesAt": "11:33",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Vicşani",
				"to": "Vadu Siretului",
				"leavesAt": "12:43",
				"arrivesAt": "13:05",
				"waitsAtSource": 3360,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20180613",
				"to": "20180613",
				"daysOfWeek": 383
			},
			{
				"from": "20180618",
				"to": "20180618",
				"daysOfWeek": 383
			},
			{
				"from": "20180625",
				"to": "20180625",
				"daysOfWeek": 383
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 383
			},
			{
				"from": "20180707",
				"to": "20180707",
				"daysOfWeek": 383
			},
			{
				"from": "20180712",
				"to": "20180712",
				"daysOfWeek": 383
			},
			{
				"from": "20180719",
				"to": "20180719",
				"daysOfWeek": 383
			},
			{
				"from": "20180724",
				"to": "20180724",
				"daysOfWeek": 383
			},
			{
				"from": "20180731",
				"to": "20180731",
				"daysOfWeek": 383
			},
			{
				"from": "20180805",
				"to": "20180805",
				"daysOfWeek": 383
			},
			{
				"from": "20180812",
				"to": "20180812",
				"daysOfWeek": 383
			},
			{
				"from": "20180817",
				"to": "20180817",
				"daysOfWeek": 383
			},
			{
				"from": "20180824",
				"to": "20180824",
				"daysOfWeek": 383
			},
			{
				"from": "20180829",
				"to": "20180829",
				"daysOfWeek": 383
			},
			{
				"from": "20180905",
				"to": "20180905",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180910",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9580",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "22:58",
				"arrivesAt": "23:04",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Remetea Mare",
				"leavesAt": "23:05",
				"arrivesAt": "23:19",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "23:20",
				"arrivesAt": "23:27",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "23:28",
				"arrivesAt": "23:31",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "23:32",
				"arrivesAt": "23:38",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "23:39",
				"arrivesAt": "23:42",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "23:43",
				"arrivesAt": "23:49",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "23:50",
				"arrivesAt": "23:54",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Jabăr Hm.",
				"leavesAt": "23:55",
				"arrivesAt": "00:00",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Lugoj",
				"leavesAt": "00:04",
				"arrivesAt": "00:10",
				"waitsAtSource": 240,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7034",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "12:26",
				"arrivesAt": "12:29",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "12:30",
				"arrivesAt": "12:35",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "12:42",
				"arrivesAt": "12:48",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "12:49",
				"arrivesAt": "12:55",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Greci h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Greci h.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "13:02",
				"arrivesAt": "13:08",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "13:15",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:28",
				"waitsAtSource": 300,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Odăile h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Odăile h.",
				"to": "Mogoşoaia",
				"leavesAt": "13:33",
				"arrivesAt": "13:41",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Mogoşoaia",
				"to": "Chitila",
				"leavesAt": "13:42",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Chitila",
				"to": "Pajura Hm. (700)",
				"leavesAt": "13:59",
				"arrivesAt": "14:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Carpaţi h.(700)",
				"leavesAt": "14:05",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Bucureşti Nord",
				"leavesAt": "14:09",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4310",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "22:42",
				"arrivesAt": "22:52",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "22:53",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "22:58",
				"arrivesAt": "23:04",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "23:05",
				"arrivesAt": "23:09",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "23:10",
				"arrivesAt": "23:15",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "23:16",
				"arrivesAt": "23:22",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "23:23",
				"arrivesAt": "23:28",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "23:29",
				"arrivesAt": "23:35",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "23:36",
				"arrivesAt": "23:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "23:41",
				"arrivesAt": "23:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "23:48",
				"arrivesAt": "23:57",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Nima h.",
				"leavesAt": "23:58",
				"arrivesAt": "00:09",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "00:10",
				"arrivesAt": "00:19",
				"waitsAtSource": 30,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180407",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9555",
		"segments": [
			{
				"from": "Orşova",
				"to": "Valea Cernei Hm.",
				"leavesAt": "13:32",
				"arrivesAt": "13:38",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Valea Cernei Hm.",
				"to": "Topleţ Hm.",
				"leavesAt": "13:39",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Topleţ Hm.",
				"to": "Băile Herculane",
				"leavesAt": "13:45",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Herculane",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "13:55",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Mehadia Hm.",
				"leavesAt": "13:59",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Mehadia Hm.",
				"to": "Iablaniţa",
				"leavesAt": "14:03",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Iablaniţa",
				"to": "Cruşovăţ",
				"leavesAt": "14:14",
				"arrivesAt": "14:22",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cruşovăţ",
				"to": "Cornea h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cornea h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:44",
				"waitsAtSource": 300,
				"distance": 3000
			},
			{
				"from": "Luncaviţa h.",
				"to": "Poarta Hm.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Poarta Hm.",
				"to": "Teregova Hm.",
				"leavesAt": "14:51",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Teregova Hm.",
				"to": "Armeniş",
				"leavesAt": "15:01",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Armeniş",
				"to": "Slatina Timiş",
				"leavesAt": "15:09",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Slatina Timiş",
				"to": "Vălişoara Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 240,
				"distance": 6400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Petroşniţa h.",
				"to": "Valea Timişului Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Balta Sărată",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 240,
				"distance": 3500
			},
			{
				"from": "Balta Sărată",
				"to": "Caransebeş haltă h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Caransebeş",
				"leavesAt": "15:49",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Caransebeş",
				"to": "Tibiscu h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:25",
				"waitsAtSource": 1560,
				"distance": 4100
			},
			{
				"from": "Tibiscu h.",
				"to": "Zăgujeni Hm.",
				"leavesAt": "16:26",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Căvăran",
				"leavesAt": "16:31",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Căvăran",
				"to": "Sacu h.",
				"leavesAt": "16:44",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Sacu h.",
				"to": "Jena Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Jena Hm.",
				"to": "Găvojdia",
				"leavesAt": "16:55",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Găvojdia",
				"to": "Tapia Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tapia Hm.",
				"to": "Lugoj",
				"leavesAt": "17:25",
				"arrivesAt": "17:32",
				"waitsAtSource": 660,
				"distance": 6500
			},
			{
				"from": "Lugoj",
				"to": "Jabăr Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:45",
				"waitsAtSource": 300,
				"distance": 7600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "17:59",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "18:12",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "18:25",
				"arrivesAt": "18:33",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "18:34",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "18:49",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 264
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5522",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Sfântu Mina h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Plăieşu h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "08:12",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:25",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "08:26",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4082",
		"segments": [
			{
				"from": "Sărmăşag",
				"to": "Sărmăşag h.",
				"leavesAt": "03:55",
				"arrivesAt": "03:58",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Sărmăşag h.",
				"to": "Derşida h.",
				"leavesAt": "03:59",
				"arrivesAt": "04:02",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Derşida h.",
				"to": "Giorocuţa h.",
				"leavesAt": "04:03",
				"arrivesAt": "04:09",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Giorocuţa h.",
				"to": "Supur h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:13",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Supur h.",
				"to": "Supur Haltă hc.",
				"leavesAt": "04:14",
				"arrivesAt": "04:16",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Acâş Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:25",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Acâş Hm.",
				"to": "Săcăşeni h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:09",
				"waitsAtSource": 1980,
				"distance": 10000
			},
			{
				"from": "Săcăşeni h.",
				"to": "Tăşnad",
				"leavesAt": "05:10",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Santău h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:26",
				"waitsAtSource": 120,
				"distance": 5500
			},
			{
				"from": "Santău h.",
				"to": "Hotoan h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hotoan h.",
				"to": "Tiream h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tiream h.",
				"to": "Carei",
				"leavesAt": "05:43",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:24",
				"waitsAtSource": 840,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "06:32",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:58",
				"waitsAtSource": 600,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "06:59",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "07:15",
				"arrivesAt": "07:22",
				"waitsAtSource": 540,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2311",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "11:53",
				"arrivesAt": "12:01",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "12:05",
				"arrivesAt": "12:16",
				"waitsAtSource": 240,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "12:17",
				"arrivesAt": "12:21",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "12:22",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "12:30",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "12:50",
				"arrivesAt": "13:02",
				"waitsAtSource": 660,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "13:08",
				"arrivesAt": "13:16",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Tărtăria h.",
				"leavesAt": "13:17",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tărtăria h.",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "13:24",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Şibot",
				"leavesAt": "13:31",
				"arrivesAt": "13:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şibot",
				"to": "Geoagiu h.",
				"leavesAt": "13:38",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Geoagiu h.",
				"to": "Orăştie",
				"leavesAt": "13:50",
				"arrivesAt": "13:57",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Orăştie",
				"to": "Pricaz h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pricaz h.",
				"to": "Turdaş Hm.",
				"leavesAt": "14:03",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Turdaş Hm.",
				"to": "Simeria Veche h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Simeria Veche h.",
				"to": "Simeria",
				"leavesAt": "14:18",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5720",
		"segments": [
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Vama",
				"leavesAt": "04:58",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Vama",
				"to": "Molid Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Molid Hm.",
				"to": "Frasin",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "05:19",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Gura Humorului Hm.",
				"leavesAt": "05:33",
				"arrivesAt": "05:41",
				"waitsAtSource": 300,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "05:54",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "06:02",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Stroieşti",
				"leavesAt": "06:11",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Stroieşti",
				"to": "Suceava Vest",
				"leavesAt": "06:19",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Suceava Vest",
				"to": "Suceava",
				"leavesAt": "06:29",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1794",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "17:00",
				"arrivesAt": "17:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "17:21",
				"arrivesAt": "17:44",
				"waitsAtSource": 600,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "17:45",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "18:12",
				"arrivesAt": "18:52",
				"waitsAtSource": 480,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9573",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Tibiscu h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:39",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Tibiscu h.",
				"to": "Zăgujeni Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:43",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Căvăran",
				"leavesAt": "07:44",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Căvăran",
				"to": "Sacu h.",
				"leavesAt": "07:56",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Sacu h.",
				"to": "Jena Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Jena Hm.",
				"to": "Găvojdia",
				"leavesAt": "08:04",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Găvojdia",
				"to": "Tapia Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tapia Hm.",
				"to": "Lugoj",
				"leavesAt": "08:20",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lugoj",
				"to": "Jabăr Hm.",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "08:45",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "08:56",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:13",
				"waitsAtSource": 480,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "09:14",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "09:23",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "09:38",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5492",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "20:40",
				"arrivesAt": "20:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "21:18",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "21:35",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "21:50",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "22:38",
				"arrivesAt": "22:45",
				"waitsAtSource": 2040,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "22:46",
				"arrivesAt": "22:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "22:52",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "22:57",
				"arrivesAt": "23:02",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "23:03",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "23:08",
				"arrivesAt": "23:14",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "23:15",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "23:26",
				"arrivesAt": "23:33",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "23:34",
				"arrivesAt": "23:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "23:39",
				"arrivesAt": "23:47",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "23:48",
				"arrivesAt": "23:53",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "23:54",
				"arrivesAt": "23:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "00:00",
				"arrivesAt": "00:12",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20180531",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6812",
		"segments": [
			{
				"from": "Nyirabrany",
				"to": "Valea lui Mihai",
				"leavesAt": "09:06",
				"arrivesAt": "09:21",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Valea lui Mihai",
				"to": "Simion h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:47",
				"waitsAtSource": 1200,
				"distance": 5900
			},
			{
				"from": "Simion h.",
				"to": "Şilindru Hm.",
				"leavesAt": "09:48",
				"arrivesAt": "09:54",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Şilindru Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "09:55",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Cadia h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cadia h.",
				"to": "Diosig Hm.",
				"leavesAt": "10:14",
				"arrivesAt": "10:20",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Diosig Hm.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "10:21",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Tămăşeu h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:35",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tămăşeu h.",
				"to": "Biharia Hm.",
				"leavesAt": "10:36",
				"arrivesAt": "10:44",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Biharia Hm.",
				"to": "Episcopia Bihor",
				"leavesAt": "10:45",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "10:56",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1861",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "22:20",
				"arrivesAt": "22:45",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "22:46",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "23:05",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "23:26",
				"arrivesAt": "23:43",
				"waitsAtSource": 120,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Ţăndărei",
				"leavesAt": "23:44",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Ţăndărei",
				"to": "Spicu",
				"leavesAt": "23:57",
				"arrivesAt": "00:17",
				"waitsAtSource": 60,
				"distance": 21700
			},
			{
				"from": "Spicu",
				"to": "Făurei",
				"leavesAt": "00:18",
				"arrivesAt": "00:55",
				"waitsAtSource": 60,
				"distance": 36400
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "00:57",
				"arrivesAt": "01:36",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "01:56",
				"arrivesAt": "02:27",
				"waitsAtSource": 1200,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "02:29",
				"arrivesAt": "03:07",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "03:09",
				"arrivesAt": "03:31",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "03:46",
				"arrivesAt": "04:10",
				"waitsAtSource": 900,
				"distance": 17800
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Bârlad",
				"leavesAt": "04:11",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 48600
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "04:55",
				"arrivesAt": "05:24",
				"waitsAtSource": 120,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "05:25",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "05:41",
				"arrivesAt": "05:59",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "06:27",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "06:44",
				"arrivesAt": "06:51",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9440",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:16",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "05:17",
				"arrivesAt": "05:22",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "05:28",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Scârlenţa h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:39",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Scârlenţa h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Doiceşti h.",
				"to": "Doiceşti",
				"leavesAt": "05:47",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Doiceşti",
				"to": "Săteni h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Săteni h.",
				"to": "Aninoasa Hm.",
				"leavesAt": "05:54",
				"arrivesAt": "05:56",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Aninoasa Hm.",
				"to": "TEIŞ Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "06:04",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1691",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "11:05",
				"arrivesAt": "11:56",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "11:57",
				"arrivesAt": "12:42",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "12:44",
				"arrivesAt": "13:14",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "13:15",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "13:33",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "14:20",
				"arrivesAt": "14:46",
				"waitsAtSource": 420,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Strehaia hc.",
				"leavesAt": "14:47",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Strehaia hc.",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Balota",
				"leavesAt": "15:26",
				"arrivesAt": "15:55",
				"waitsAtSource": 300,
				"distance": 26900
			},
			{
				"from": "Balota",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "15:56",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Orşova",
				"leavesAt": "16:32",
				"arrivesAt": "17:04",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Orşova",
				"to": "Băile Herculane",
				"leavesAt": "17:05",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 17500
			},
			{
				"from": "Băile Herculane",
				"to": "Caransebeş",
				"leavesAt": "17:26",
				"arrivesAt": "18:49",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "18:53",
				"arrivesAt": "19:27",
				"waitsAtSource": 240,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Timişoara Nord",
				"leavesAt": "19:28",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5711",
		"segments": [
			{
				"from": "Câmpulung Mold.",
				"to": "Sadova Hm.",
				"leavesAt": "15:18",
				"arrivesAt": "15:23",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Sadova Hm.",
				"to": "Pojorâta Hm.",
				"leavesAt": "15:24",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Valea Putnei P.M.",
				"leavesAt": "15:31",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Mestecăniş",
				"leavesAt": "15:44",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Argestru Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Argestru Hm.",
				"to": "Vatra Dornei",
				"leavesAt": "16:14",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "16:22",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Roşu Hm.",
				"leavesAt": "16:26",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Roşu Hm.",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Floreni",
				"leavesAt": "16:40",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Floreni",
				"to": "Coşna Hm.",
				"leavesAt": "16:48",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Coşna Hm.",
				"to": "Grădiniţa",
				"leavesAt": "17:02",
				"arrivesAt": "17:12",
				"waitsAtSource": 300,
				"distance": 8000
			},
			{
				"from": "Grădiniţa",
				"to": "Larion Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Larion Hm.",
				"to": "Silhoasa Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "17:35",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Ilva Mare Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "17:55",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "18:06",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "18:15",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Strâmba h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Strâmba h.",
				"to": "Ilva Mică",
				"leavesAt": "18:30",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3005",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "14:20",
				"arrivesAt": "14:29",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "14:30",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "14:42",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "14:57",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "15:07",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Ploieşti Vest",
				"leavesAt": "15:21",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "15:29",
				"arrivesAt": "15:36",
				"waitsAtSource": 240,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Bobolia h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Bobolia h.",
				"to": "Câmpina",
				"leavesAt": "15:56",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "16:14",
				"arrivesAt": "16:19",
				"waitsAtSource": 600,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "16:28",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Posada h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Posada h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "16:52",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "16:57",
				"arrivesAt": "17:02",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "17:03",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "17:08",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "17:14",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:41",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Timişu de Jos h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Dârste",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "18:00",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9022",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Ram. Goleşti",
				"leavesAt": "03:50",
				"arrivesAt": "03:56",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Ram. Goleşti",
				"to": "Goleşti",
				"leavesAt": "03:57",
				"arrivesAt": "04:04",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Goleşti",
				"to": "Călineşti Hm.",
				"leavesAt": "04:05",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Călineşti Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "04:15",
				"arrivesAt": "04:21",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Pătroaia Hm.",
				"leavesAt": "04:22",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Găeşti",
				"leavesAt": "04:30",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Găeşti",
				"to": "Găeşti Sud h.",
				"leavesAt": "04:39",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Cojocaru h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Cojocaru h.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Fusea Hm.",
				"leavesAt": "04:54",
				"arrivesAt": "04:59",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Fusea Hm.",
				"to": "Titu",
				"leavesAt": "05:00",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:15",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:19",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "05:41",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "05:50",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "05:58",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "06:07",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "06:15",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1988",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun hc.",
				"leavesAt": "18:10",
				"arrivesAt": "18:20",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "18:23",
				"arrivesAt": "18:36",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "18:39",
				"arrivesAt": "18:43",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "18:46",
				"arrivesAt": "19:01",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "19:04",
				"arrivesAt": "19:11",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "19:13",
				"arrivesAt": "19:22",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "19:23",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "19:31",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "20:00",
				"arrivesAt": "20:26",
				"waitsAtSource": 1080,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "20:27",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "20:47",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "21:10",
				"arrivesAt": "21:36",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "21:37",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 108900
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2492",
		"segments": [
			{
				"from": "Cugir  Hm.",
				"to": "Cugir hc.",
				"leavesAt": "06:17",
				"arrivesAt": "06:20",
				"waitsAtSource": 0,
				"distance": 600
			},
			{
				"from": "Cugir hc.",
				"to": "Vinerea h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vinerea h.",
				"to": "Şibot",
				"leavesAt": "06:34",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Şibot",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:59",
				"waitsAtSource": 360,
				"distance": 3000
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Tărtăria h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Tărtăria h.",
				"to": "Blandiana Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "07:14",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "07:23",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:26",
				"waitsAtSource": 2520,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:38",
				"waitsAtSource": 300,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "08:43",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "08:56",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5201",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "03:50",
				"arrivesAt": "03:57",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "03:58",
				"arrivesAt": "04:01",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "04:02",
				"arrivesAt": "04:08",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "04:09",
				"arrivesAt": "04:12",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "04:13",
				"arrivesAt": "04:25",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "04:38",
				"arrivesAt": "04:48",
				"waitsAtSource": 780,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "04:49",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "04:54",
				"arrivesAt": "04:59",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "05:00",
				"arrivesAt": "05:05",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "05:06",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "05:22",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Trotuş h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:37",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Trotuş h.",
				"to": "Viişoara h",
				"leavesAt": "05:38",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "05:53",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Comăneşti",
				"to": "Asău Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "06:39",
				"waitsAtSource": 600,
				"distance": 5100
			},
			{
				"from": "Asău Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caraliţa h.",
				"to": "Goioasa Hm.",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Goioasa Hm.",
				"to": "Simbrea Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Simbrea Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "07:01",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Palanca Hm.",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Palanca Hm.",
				"to": "Ghimeş",
				"leavesAt": "07:12",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghimeş",
				"to": "Bolovăniş h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "07:28",
				"arrivesAt": "07:34",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Tarcău h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:45",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Utuşoiu h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Utuşoiu h.",
				"to": "Livezi Ciuc",
				"leavesAt": "07:52",
				"arrivesAt": "07:58",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Caracău h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:06",
				"waitsAtSource": 240,
				"distance": 2100
			},
			{
				"from": "Caracău h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "08:07",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Mihăileni Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Siculeni",
				"leavesAt": "08:25",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "08:46",
				"arrivesAt": "08:54",
				"waitsAtSource": 900,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5528",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Sfântu Mina h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Plăieşu h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "17:53",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "18:15",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1521",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "09:24",
				"arrivesAt": "10:17",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "10:18",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "11:05",
				"arrivesAt": "11:36",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "11:37",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Piatra Olt",
				"leavesAt": "11:55",
				"arrivesAt": "12:30",
				"waitsAtSource": 60,
				"distance": 32400
			},
			{
				"from": "Piatra Olt",
				"to": "Drăgăşani",
				"leavesAt": "12:31",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 33800
			},
			{
				"from": "Drăgăşani",
				"to": "Băbeni",
				"leavesAt": "12:58",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Băbeni",
				"to": "Govora",
				"leavesAt": "13:24",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Govora",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "13:33",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 11400
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Călimăneşti",
				"leavesAt": "13:46",
				"arrivesAt": "14:03",
				"waitsAtSource": 120,
				"distance": 16200
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "14:05",
				"arrivesAt": "14:10",
				"waitsAtSource": 120,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7584",
		"segments": [
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "05:10",
				"arrivesAt": "05:18",
				"waitsAtSource": 0,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "05:19",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "05:25",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2039",
		"segments": [
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:31",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "14:32",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Simeria",
				"to": "Turdaş Hm.",
				"leavesAt": "14:40",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Turdaş Hm.",
				"to": "Pricaz h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Pricaz h.",
				"to": "Orăştie",
				"leavesAt": "14:59",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Orăştie",
				"to": "Geoagiu h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Geoagiu h.",
				"to": "Aurel Vlaicu",
				"leavesAt": "15:10",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Şibot",
				"leavesAt": "15:16",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şibot",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Tărtăria h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Tărtăria h.",
				"to": "Blandiana Hm.",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "15:45",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "15:54",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "16:08",
				"arrivesAt": "16:17",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "16:30",
				"arrivesAt": "16:42",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "16:43",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "17:07",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Mirăslău h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mirăslău h.",
				"to": "Decea h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Decea h.",
				"to": "Unirea Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Unirea Hm.",
				"to": "Unirea hc.",
				"leavesAt": "17:24",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "17:28",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Grindeni h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Grindeni h.",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Câmpia Turzii",
				"leavesAt": "17:47",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cânepişti h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Cânepişti h.",
				"to": "Ploscoş h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ploscoş h.",
				"to": "Valea Florilor Hm.",
				"leavesAt": "18:11",
				"arrivesAt": "18:17",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Boju",
				"leavesAt": "18:18",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Boju",
				"to": "Tunel Hm.",
				"leavesAt": "18:31",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Tunel Hm.",
				"to": "Cojocna Hm.",
				"leavesAt": "18:39",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cojocna Hm.",
				"to": "Apahida",
				"leavesAt": "18:47",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "18:58",
				"arrivesAt": "19:05",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "19:12",
				"arrivesAt": "19:17",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5303",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "21:25",
				"arrivesAt": "21:32",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "21:38",
				"arrivesAt": "21:46",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "21:47",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "21:52",
				"arrivesAt": "22:05",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "22:09",
				"arrivesAt": "22:19",
				"waitsAtSource": 240,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "22:20",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "22:25",
				"arrivesAt": "22:30",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "22:31",
				"arrivesAt": "22:37",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "22:38",
				"arrivesAt": "22:49",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "22:50",
				"arrivesAt": "22:54",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "22:55",
				"arrivesAt": "23:02",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Viişoara h",
				"leavesAt": "23:30",
				"arrivesAt": "23:41",
				"waitsAtSource": 1680,
				"distance": 9100
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "23:42",
				"arrivesAt": "23:49",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "23:50",
				"arrivesAt": "23:53",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "23:54",
				"arrivesAt": "23:58",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "23:59",
				"arrivesAt": "00:03",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "00:04",
				"arrivesAt": "00:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Comăneşti",
				"leavesAt": "00:10",
				"arrivesAt": "00:22",
				"waitsAtSource": 30,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3007",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "16:36",
				"arrivesAt": "16:43",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "16:44",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "16:47",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "16:59",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "17:27",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Ploieşti Vest",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "17:53",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "18:02",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "18:14",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:23",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:27",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "18:28",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Posada h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Posada h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "18:39",
				"arrivesAt": "18:44",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "18:50",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "19:00",
				"arrivesAt": "19:04",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "19:05",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "19:11",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "19:21",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Timişu de Jos h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Dârste",
				"leavesAt": "19:45",
				"arrivesAt": "19:53",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "19:54",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9444",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:21",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "09:22",
				"arrivesAt": "09:27",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "09:33",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "09:42",
				"arrivesAt": "09:47",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti",
				"leavesAt": "09:48",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Doiceşti",
				"to": "Săteni h.",
				"leavesAt": "09:53",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Săteni h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "09:57",
				"arrivesAt": "10:01",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "10:02",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "10:05",
				"arrivesAt": "10:09",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1953",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun hc.",
				"leavesAt": "21:35",
				"arrivesAt": "21:45",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "21:48",
				"arrivesAt": "22:01",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "22:04",
				"arrivesAt": "22:08",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "22:11",
				"arrivesAt": "22:26",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "22:29",
				"arrivesAt": "22:36",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "22:38",
				"arrivesAt": "23:01",
				"waitsAtSource": 120,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "23:20",
				"arrivesAt": "23:45",
				"waitsAtSource": 1140,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "23:46",
				"arrivesAt": "00:05",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "00:06",
				"arrivesAt": "00:27",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ţăndărei",
				"leavesAt": "00:29",
				"arrivesAt": "00:56",
				"waitsAtSource": 120,
				"distance": 30600
			},
			{
				"from": "Ţăndărei",
				"to": "Făurei",
				"leavesAt": "00:57",
				"arrivesAt": "01:53",
				"waitsAtSource": 60,
				"distance": 58100
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "01:54",
				"arrivesAt": "02:33",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "02:53",
				"arrivesAt": "03:25",
				"waitsAtSource": 1200,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "03:27",
				"arrivesAt": "04:05",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "04:07",
				"arrivesAt": "04:29",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "04:31",
				"arrivesAt": "04:58",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "05:00",
				"arrivesAt": "05:38",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "05:41",
				"arrivesAt": "06:10",
				"waitsAtSource": 180,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "06:12",
				"arrivesAt": "06:41",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "06:44",
				"arrivesAt": "07:04",
				"waitsAtSource": 180,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "07:05",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "07:23",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "07:36",
				"arrivesAt": "07:42",
				"waitsAtSource": 180,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8586",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Brâncoveni h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Brâncoveni h.",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Slobozia Veche",
				"leavesAt": "15:57",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 4200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4701",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Podereia Feldrului h.",
				"leavesAt": "03:52",
				"arrivesAt": "03:56",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Feldru Hm.",
				"leavesAt": "03:57",
				"arrivesAt": "04:02",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Feldru Hm.",
				"to": "Nepos h.",
				"leavesAt": "04:09",
				"arrivesAt": "04:16",
				"waitsAtSource": 420,
				"distance": 4700
			},
			{
				"from": "Nepos h.",
				"to": "Rebrişoara Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Năsăud",
				"leavesAt": "04:24",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Năsăud",
				"to": "Năsăud h.",
				"leavesAt": "04:31",
				"arrivesAt": "04:34",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Năsăud h.",
				"to": "Salva",
				"leavesAt": "04:35",
				"arrivesAt": "04:40",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2502",
		"segments": [
			{
				"from": "Făgăraş",
				"to": "Mândra Oltului h.",
				"leavesAt": "04:22",
				"arrivesAt": "04:28",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Şercaia h.",
				"leavesAt": "04:29",
				"arrivesAt": "04:36",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Şercaia h.",
				"to": "Şercaia Hm.",
				"leavesAt": "04:37",
				"arrivesAt": "04:39",
				"waitsAtSource": 30,
				"distance": 1200
			},
			{
				"from": "Şercaia Hm.",
				"to": "Perşani h.",
				"leavesAt": "04:40",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Brădet Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:56",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Brădet Hm.",
				"to": "Valea Homorod h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Homorod h.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "05:06",
				"arrivesAt": "05:15",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "05:16",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Codlea Hm.",
				"to": "Ghimbav Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Bartolomeu",
				"leavesAt": "05:43",
				"arrivesAt": "05:50",
				"waitsAtSource": 240,
				"distance": 5400
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8444",
		"segments": [
			{
				"from": "Călăraşi Sud",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "19:50",
				"arrivesAt": "19:57",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Ştefan Vodă h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Ciulniţa",
				"leavesAt": "20:06",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 12600
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "20:41",
				"arrivesAt": "20:49",
				"waitsAtSource": 1140,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "20:50",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "20:55",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "20:59",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "21:11",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "21:17",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1638",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "19:05",
				"arrivesAt": "20:02",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "20:04",
				"arrivesAt": "20:23",
				"waitsAtSource": 120,
				"distance": 13900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9436",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:47",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "19:54",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "19:59",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "20:18",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4520",
		"segments": [
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "14:39",
				"arrivesAt": "14:48",
				"waitsAtSource": 0,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9611",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Boldur h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:25",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Boldur h.",
				"to": "Sinia Hm.",
				"leavesAt": "04:26",
				"arrivesAt": "04:33",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sinia Hm.",
				"to": "Căpăt h.",
				"leavesAt": "04:34",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Căpăt h.",
				"to": "Buziaş",
				"leavesAt": "04:41",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9437",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "12:30",
				"arrivesAt": "12:38",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "12:39",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "12:43",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "12:52",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "13:16",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "13:26",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:38",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "13:39",
				"arrivesAt": "13:46",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:51",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "13:52",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "14:01",
				"arrivesAt": "14:05",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "14:06",
				"arrivesAt": "14:09",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "14:15",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "14:21",
				"arrivesAt": "14:28",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1543",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Ulmeni Sălaj",
				"leavesAt": "17:07",
				"arrivesAt": "17:37",
				"waitsAtSource": 0,
				"distance": 31000
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Benesat Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:55",
				"waitsAtSource": 540,
				"distance": 8800
			},
			{
				"from": "Benesat Hm.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "17:56",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "18:06",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Jibou",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:33",
				"waitsAtSource": 540,
				"distance": 6800
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "18:40",
				"arrivesAt": "18:58",
				"waitsAtSource": 420,
				"distance": 11700
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Ileanda",
				"leavesAt": "19:07",
				"arrivesAt": "19:31",
				"waitsAtSource": 540,
				"distance": 18200
			},
			{
				"from": "Ileanda",
				"to": "Dej Călători",
				"leavesAt": "19:32",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 39500
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "20:11",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "20:31",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8036",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "19:38",
				"arrivesAt": "19:45",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "19:46",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "20:00",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "20:10",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:25",
				"waitsAtSource": 480,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "20:26",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "20:34",
				"arrivesAt": "20:44",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "20:45",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "20:54",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Ramificaţia Borcea",
				"leavesAt": "21:05",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "21:21",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3072",
		"segments": [
			{
				"from": "Oradea",
				"to": "Tileagd",
				"leavesAt": "02:50",
				"arrivesAt": "03:13",
				"waitsAtSource": 0,
				"distance": 23100
			},
			{
				"from": "Tileagd",
				"to": "Aleşd",
				"leavesAt": "03:14",
				"arrivesAt": "03:26",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Aleşd",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "03:27",
				"arrivesAt": "03:47",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "03:48",
				"arrivesAt": "03:56",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "04:00",
				"arrivesAt": "04:05",
				"waitsAtSource": 240,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "04:06",
				"arrivesAt": "04:10",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "04:11",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "04:23",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:32",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Valea Drăganului h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Poieni",
				"leavesAt": "04:39",
				"arrivesAt": "04:43",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Bologa h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bologa h.",
				"to": "Brăişoru Hm.",
				"leavesAt": "04:49",
				"arrivesAt": "04:54",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "04:55",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "05:04",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "05:32",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "06:18",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4045",
		"segments": [
			{
				"from": "Jibou",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "06:01",
				"waitsAtSource": 0,
				"distance": 9300
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Inău h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 540,
				"distance": 3400
			},
			{
				"from": "Inău h.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Benesat Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Benesat Hm.",
				"to": "Ţicău h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ţicău h.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "06:30",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Fersig h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Fersig h.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "06:54",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5521",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "02:40",
				"arrivesAt": "02:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "02:55",
				"arrivesAt": "03:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "03:03",
				"arrivesAt": "03:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "03:10",
				"arrivesAt": "03:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "03:18",
				"arrivesAt": "03:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "03:28",
				"arrivesAt": "03:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "03:35",
				"arrivesAt": "03:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "03:40",
				"arrivesAt": "03:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "03:50",
				"arrivesAt": "04:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:20",
				"waitsAtSource": 660,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "04:21",
				"arrivesAt": "04:29",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "04:30",
				"arrivesAt": "04:37",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "04:38",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Târgu Neamţ",
				"leavesAt": "04:44",
				"arrivesAt": "04:58",
				"waitsAtSource": 30,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3535",
		"segments": [
			{
				"from": "Braşov",
				"to": "Stupini Hm.",
				"leavesAt": "20:09",
				"arrivesAt": "20:18",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Stupini Hm.",
				"to": "Bod Hm.",
				"leavesAt": "20:19",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Bod Hm.",
				"to": "Feldioara Hm.",
				"leavesAt": "20:28",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Rotbav h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Rotbav h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Măieruş h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Măieruş h.",
				"to": "Apaţa",
				"leavesAt": "20:52",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Apaţa",
				"to": "Ormeniş h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ormeniş h.",
				"to": "Augustin Hm.",
				"leavesAt": "21:12",
				"arrivesAt": "21:25",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Augustin Hm.",
				"to": "Racoş Hm.",
				"leavesAt": "21:26",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Racoş Hm.",
				"to": "Mateiaş h.",
				"leavesAt": "21:43",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mateiaş h.",
				"to": "Rupea",
				"leavesAt": "21:48",
				"arrivesAt": "22:02",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Rupea",
				"to": "Caţa Hm.",
				"leavesAt": "22:03",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Caţa Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "22:13",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Beia Hm.",
				"leavesAt": "22:18",
				"arrivesAt": "22:29",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Beia Hm.",
				"to": "Archita h",
				"leavesAt": "22:30",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Archita h",
				"to": "Mureni Hm.",
				"leavesAt": "22:42",
				"arrivesAt": "22:56",
				"waitsAtSource": 30,
				"distance": 9600
			},
			{
				"from": "Mureni Hm.",
				"to": "Saschiz h.",
				"leavesAt": "22:57",
				"arrivesAt": "23:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Vânători",
				"leavesAt": "23:02",
				"arrivesAt": "23:06",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "23:07",
				"arrivesAt": "23:14",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "23:15",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2602",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "04:42",
				"arrivesAt": "04:49",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Şag Hm.",
				"leavesAt": "04:50",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "05:20",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 360,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "05:39",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Timişoara Nord",
				"leavesAt": "05:48",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9122",
		"segments": [
			{
				"from": "Parcul Kreţulescu h.",
				"to": "Câmpulung",
				"leavesAt": "15:30",
				"arrivesAt": "15:33",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Câmpulung",
				"to": "Schitu Goleşti",
				"leavesAt": "15:35",
				"arrivesAt": "15:46",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Schitu Goleşti",
				"to": "Lăzăreşti Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lăzăreşti Hm.",
				"to": "Drăghici h.",
				"leavesAt": "15:55",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Drăghici h.",
				"to": "Stâlpeni Hm.",
				"leavesAt": "16:02",
				"arrivesAt": "16:13",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Stâlpeni Hm.",
				"to": "Clucereasa h.",
				"leavesAt": "16:14",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Clucereasa h.",
				"to": "Ciumeşti",
				"leavesAt": "16:23",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Ciumeşti",
				"to": "Gropeni h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Gropeni h.",
				"to": "Ştefăneşti Argeş Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ştefăneşti Argeş Hm.",
				"to": "Goleşti",
				"leavesAt": "16:49",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2700",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "04:03",
				"arrivesAt": "04:10",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia h.",
				"leavesAt": "04:11",
				"arrivesAt": "04:13",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băcia h.",
				"to": "Băcia Hm.",
				"leavesAt": "04:14",
				"arrivesAt": "04:16",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Băcia Hm.",
				"to": "Batiz h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:19",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Batiz h.",
				"to": "Călan Băi",
				"leavesAt": "04:20",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Ruşi h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:32",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ruşi h.",
				"to": "Măceu h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Măceu h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "04:36",
				"arrivesAt": "04:41",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Plopi h.",
				"leavesAt": "04:42",
				"arrivesAt": "04:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Plopi h.",
				"to": "Covragiu h.",
				"leavesAt": "04:45",
				"arrivesAt": "04:47",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Covragiu h.",
				"to": "Subcetate",
				"leavesAt": "04:48",
				"arrivesAt": "04:52",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Subcetate",
				"to": "Ciopea h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:12",
				"waitsAtSource": 900,
				"distance": 3800
			},
			{
				"from": "Ciopea h.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Băeşti Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ruşor h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ruşor h.",
				"to": "Pui",
				"leavesAt": "05:25",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Pui",
				"to": "Ponor h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ponor h.",
				"to": "Livadia h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Livadia h.",
				"to": "Baru Mare",
				"leavesAt": "05:39",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Baru Mare",
				"to": "Baru Mare h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Baru Mare h.",
				"to": "Crivadia Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Crivadia Hm.",
				"to": "Merişor Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Merişor Hm.",
				"to": "Băniţa",
				"leavesAt": "06:11",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băniţa",
				"to": "Peştera Bolii h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Dep Petroşani h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:38",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani",
				"leavesAt": "06:39",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 287
			},
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 287
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 287
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 287
			},
			{
				"from": "20180411",
				"to": "20180617",
				"daysOfWeek": 287
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 287
			},
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 287
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 287
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8656",
		"segments": [
			{
				"from": "Tulcea Oraş",
				"to": "Tulcea Mărfuri",
				"leavesAt": "16:12",
				"arrivesAt": "16:21",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Cataloi Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Cataloi Hm.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Zebil h.",
				"leavesAt": "16:54",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Zebil h.",
				"to": "Babadag",
				"leavesAt": "17:09",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Babadag",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Baia Dobrogea",
				"leavesAt": "17:43",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baia Dobrogea",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Cogealac",
				"leavesAt": "18:09",
				"arrivesAt": "18:28",
				"waitsAtSource": 480,
				"distance": 17400
			},
			{
				"from": "Cogealac",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "18:50",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Nicolae Bălcescu",
				"leavesAt": "19:01",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Medgidia",
				"leavesAt": "19:08",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 19100
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1996",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Lugoj",
				"leavesAt": "22:40",
				"arrivesAt": "23:34",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Lugoj",
				"to": "Găvojdia",
				"leavesAt": "23:36",
				"arrivesAt": "23:45",
				"waitsAtSource": 120,
				"distance": 11900
			},
			{
				"from": "Găvojdia",
				"to": "Caransebeş",
				"leavesAt": "23:49",
				"arrivesAt": "00:16",
				"waitsAtSource": 240,
				"distance": 27500
			},
			{
				"from": "Caransebeş",
				"to": "Băile Herculane",
				"leavesAt": "00:30",
				"arrivesAt": "01:53",
				"waitsAtSource": 840,
				"distance": 70800
			},
			{
				"from": "Băile Herculane",
				"to": "Orşova",
				"leavesAt": "01:55",
				"arrivesAt": "02:15",
				"waitsAtSource": 120,
				"distance": 17500
			},
			{
				"from": "Orşova",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "02:16",
				"arrivesAt": "02:47",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Balota",
				"leavesAt": "02:53",
				"arrivesAt": "03:27",
				"waitsAtSource": 360,
				"distance": 19000
			},
			{
				"from": "Balota",
				"to": "Strehaia hc.",
				"leavesAt": "03:28",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Strehaia hc.",
				"to": "Filiaşi",
				"leavesAt": "04:04",
				"arrivesAt": "04:33",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "04:35",
				"arrivesAt": "05:00",
				"waitsAtSource": 120,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "05:10",
				"arrivesAt": "05:51",
				"waitsAtSource": 600,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "05:52",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "06:08",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "06:40",
				"arrivesAt": "07:24",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "07:26",
				"arrivesAt": "07:51",
				"waitsAtSource": 120,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "07:56",
				"arrivesAt": "08:26",
				"waitsAtSource": 300,
				"distance": 25500
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "08:50",
				"arrivesAt": "09:58",
				"waitsAtSource": 1440,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "09:59",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "10:25",
				"arrivesAt": "10:44",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "10:45",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "11:04",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 34600
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "11:55",
				"arrivesAt": "12:18",
				"waitsAtSource": 1560,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "12:20",
				"arrivesAt": "12:27",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "12:29",
				"arrivesAt": "12:45",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "12:47",
				"arrivesAt": "12:51",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "12:53",
				"arrivesAt": "13:06",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "13:08",
				"arrivesAt": "13:18",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180430",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180527",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4043",
		"segments": [
			{
				"from": "Jibou",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "05:09",
				"arrivesAt": "05:19",
				"waitsAtSource": 0,
				"distance": 9300
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Inău h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Inău h.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Benesat Hm.",
				"leavesAt": "05:28",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Benesat Hm.",
				"to": "Ţicău h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ţicău h.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "05:39",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 540,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Fersig h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Fersig h.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "06:11",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9159",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "03:28",
				"arrivesAt": "03:40",
				"waitsAtSource": 0,
				"distance": 10400
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Brebu",
				"leavesAt": "03:41",
				"arrivesAt": "03:53",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "03:54",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "04:03",
				"arrivesAt": "04:09",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "04:10",
				"arrivesAt": "04:20",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "04:21",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4314",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Buşag Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:46",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Buşag Hm.",
				"to": "Cicârlău h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cicârlău h.",
				"to": "Ilba h.",
				"leavesAt": "12:54",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ilba h.",
				"to": "Săbişa h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Săbişa h.",
				"to": "Seini",
				"leavesAt": "13:10",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Seini",
				"to": "Apa Hm.",
				"leavesAt": "13:17",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "13:41",
				"arrivesAt": "13:52",
				"waitsAtSource": 600,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "13:53",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "14:02",
				"arrivesAt": "14:08",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "14:09",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1821",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "20:50",
				"arrivesAt": "21:14",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "21:15",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "21:33",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "21:55",
				"arrivesAt": "22:18",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Lehliu",
				"leavesAt": "22:19",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Lehliu",
				"to": "Bucureşti Nord",
				"leavesAt": "22:41",
				"arrivesAt": "23:21",
				"waitsAtSource": 60,
				"distance": 69600
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "23:45",
				"arrivesAt": "00:37",
				"waitsAtSource": 1440,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "00:38",
				"arrivesAt": "01:23",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "01:25",
				"arrivesAt": "01:56",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "01:57",
				"arrivesAt": "02:14",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "02:15",
				"arrivesAt": "02:55",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "03:05",
				"arrivesAt": "03:32",
				"waitsAtSource": 600,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Cărbuneşti",
				"leavesAt": "03:33",
				"arrivesAt": "04:19",
				"waitsAtSource": 60,
				"distance": 46500
			},
			{
				"from": "Cărbuneşti",
				"to": "Târgu Jiu",
				"leavesAt": "04:20",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 23800
			},
			{
				"from": "Târgu Jiu",
				"to": "Valea Sadului Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "05:09",
				"waitsAtSource": 120,
				"distance": 19600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Petroşani",
				"leavesAt": "05:10",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 31700
			},
			{
				"from": "Petroşani",
				"to": "Băniţa",
				"leavesAt": "06:02",
				"arrivesAt": "06:17",
				"waitsAtSource": 300,
				"distance": 11300
			},
			{
				"from": "Băniţa",
				"to": "Subcetate",
				"leavesAt": "06:18",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 38500
			},
			{
				"from": "Subcetate",
				"to": "Călan Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:34",
				"waitsAtSource": 120,
				"distance": 15600
			},
			{
				"from": "Călan Hm.",
				"to": "Simeria",
				"leavesAt": "07:36",
				"arrivesAt": "07:51",
				"waitsAtSource": 120,
				"distance": 14600
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "07:57",
				"arrivesAt": "08:08",
				"waitsAtSource": 360,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "08:10",
				"arrivesAt": "08:38",
				"waitsAtSource": 120,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Săvârşin",
				"leavesAt": "08:39",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Săvârşin",
				"to": "Radna",
				"leavesAt": "09:28",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Radna",
				"to": "Arad",
				"leavesAt": "10:28",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 34500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1992",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Topolovăţ",
				"leavesAt": "19:09",
				"arrivesAt": "19:44",
				"waitsAtSource": 0,
				"distance": 34400
			},
			{
				"from": "Topolovăţ",
				"to": "Lugoj",
				"leavesAt": "19:48",
				"arrivesAt": "20:06",
				"waitsAtSource": 240,
				"distance": 24500
			},
			{
				"from": "Lugoj",
				"to": "Caransebeş",
				"leavesAt": "20:10",
				"arrivesAt": "20:43",
				"waitsAtSource": 240,
				"distance": 39400
			},
			{
				"from": "Caransebeş",
				"to": "Iablaniţa",
				"leavesAt": "21:00",
				"arrivesAt": "22:10",
				"waitsAtSource": 1020,
				"distance": 59800
			},
			{
				"from": "Iablaniţa",
				"to": "Băile Herculane",
				"leavesAt": "22:14",
				"arrivesAt": "22:30",
				"waitsAtSource": 240,
				"distance": 11000
			},
			{
				"from": "Băile Herculane",
				"to": "Orşova",
				"leavesAt": "22:32",
				"arrivesAt": "22:52",
				"waitsAtSource": 120,
				"distance": 17500
			},
			{
				"from": "Orşova",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "22:54",
				"arrivesAt": "23:25",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Balota",
				"leavesAt": "23:35",
				"arrivesAt": "00:07",
				"waitsAtSource": 600,
				"distance": 19000
			},
			{
				"from": "Balota",
				"to": "Strehaia hc.",
				"leavesAt": "00:17",
				"arrivesAt": "00:50",
				"waitsAtSource": 600,
				"distance": 32600
			},
			{
				"from": "Strehaia hc.",
				"to": "Craiova",
				"leavesAt": "00:52",
				"arrivesAt": "01:42",
				"waitsAtSource": 120,
				"distance": 62100
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "01:55",
				"arrivesAt": "02:36",
				"waitsAtSource": 780,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "02:38",
				"arrivesAt": "03:23",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "03:25",
				"arrivesAt": "04:11",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Băneasa",
				"leavesAt": "04:13",
				"arrivesAt": "05:13",
				"waitsAtSource": 120,
				"distance": 51000
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Ciulniţa",
				"leavesAt": "05:23",
				"arrivesAt": "06:20",
				"waitsAtSource": 600,
				"distance": 102300
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "06:22",
				"arrivesAt": "06:45",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Medgidia",
				"leavesAt": "06:47",
				"arrivesAt": "07:23",
				"waitsAtSource": 120,
				"distance": 44000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "07:25",
				"arrivesAt": "07:57",
				"waitsAtSource": 120,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "08:28",
				"arrivesAt": "08:55",
				"waitsAtSource": 1860,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "08:58",
				"arrivesAt": "09:05",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "09:08",
				"arrivesAt": "09:24",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "09:33",
				"arrivesAt": "09:37",
				"waitsAtSource": 540,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "09:40",
				"arrivesAt": "09:53",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "09:56",
				"arrivesAt": "10:06",
				"waitsAtSource": 180,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4411",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "19:55",
				"arrivesAt": "20:01",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "20:02",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "20:12",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2182",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Balinţ h.",
				"leavesAt": "03:58",
				"arrivesAt": "04:12",
				"waitsAtSource": 0,
				"distance": 14400
			},
			{
				"from": "Balinţ h.",
				"to": "Cliciova",
				"leavesAt": "04:13",
				"arrivesAt": "04:20",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Cliciova",
				"to": "Susani Bega h.",
				"leavesAt": "04:21",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Susani Bega h.",
				"to": "Traian Vuia h.",
				"leavesAt": "04:25",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:32",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Răchita h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Răchita h.",
				"to": "Făget",
				"leavesAt": "04:37",
				"arrivesAt": "04:42",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "04:43",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Margina",
				"to": "Nemeşeşti h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:12",
				"waitsAtSource": 720,
				"distance": 5400
			},
			{
				"from": "Nemeşeşti h.",
				"to": "Coşteiu h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Coşteiu h.",
				"to": "Holdea Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Holdea Hm.",
				"to": "Ohaba hc.",
				"leavesAt": "05:24",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ohaba hc.",
				"to": "Lăpugiu h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Lăpugiu h.",
				"to": "Dobra Hm.",
				"leavesAt": "05:37",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Dobra Hm.",
				"to": "Ilia",
				"leavesAt": "05:44",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "06:04",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "06:27",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:47",
				"waitsAtSource": 180,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "06:48",
				"arrivesAt": "06:54",
				"waitsAtSource": 30,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2044",
		"segments": [
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "06:12",
				"arrivesAt": "06:19",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "06:20",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "06:47",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "06:59",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Nadăş h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Nadăş h.",
				"to": "Bârzava",
				"leavesAt": "07:27",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "08:02",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "08:19",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "08:30",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "09:03",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "09:16",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "09:23",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia",
				"leavesAt": "09:28",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "09:35",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "09:52",
				"arrivesAt": "09:58",
				"waitsAtSource": 30,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2608",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "16:34",
				"arrivesAt": "16:41",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Şag Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "16:57",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "17:04",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "17:10",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj h",
				"leavesAt": "17:27",
				"arrivesAt": "17:34",
				"waitsAtSource": 300,
				"distance": 7400
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "17:35",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Timişoara Nord",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5520",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Sfântu Mina h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Plăieşu h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:26",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "05:48",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9530",
		"segments": [
			{
				"from": "Curtea de Argeş",
				"to": "Băiculeşti h.",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Băiculeşti h.",
				"to": "Merişani h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Merişani h.",
				"to": "Bascov Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Bascov Hm.",
				"to": "C.I.L. h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "C.I.L. h.",
				"to": "Piteşti Nord",
				"leavesAt": "07:30",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Piteşti Nord",
				"to": "Piteşti",
				"leavesAt": "07:35",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2567",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "17:35",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:54",
				"waitsAtSource": 300,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Şeica Mare h.",
				"leavesAt": "18:16",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "18:27",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "18:44",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "18:56",
				"arrivesAt": "19:03",
				"waitsAtSource": 420,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "19:04",
				"arrivesAt": "19:11",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Bratei h.",
				"leavesAt": "19:25",
				"arrivesAt": "19:33",
				"waitsAtSource": 840,
				"distance": 5100
			},
			{
				"from": "Bratei h.",
				"to": "Aţel Hm.",
				"leavesAt": "19:34",
				"arrivesAt": "19:42",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Aţel Hm.",
				"to": "Dumbrăveni",
				"leavesAt": "19:43",
				"arrivesAt": "19:53",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Dumbrăveni",
				"to": "Luna h.",
				"leavesAt": "19:54",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Luna h.",
				"to": "Daneş Hm.",
				"leavesAt": "20:02",
				"arrivesAt": "20:09",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Daneş Hm.",
				"to": "Sighişoara",
				"leavesAt": "20:10",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1538",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "13:30",
				"arrivesAt": "14:38",
				"waitsAtSource": 0,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "14:39",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "15:18",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Blaj",
				"leavesAt": "15:36",
				"arrivesAt": "16:04",
				"waitsAtSource": 240,
				"distance": 21300
			},
			{
				"from": "Blaj",
				"to": "Valea Lungă Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Copşa Mică",
				"leavesAt": "16:17",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 17900
			},
			{
				"from": "Copşa Mică",
				"to": "Mediaş",
				"leavesAt": "16:44",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Mediaş",
				"to": "Sighişoara",
				"leavesAt": "16:58",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 38400
			},
			{
				"from": "Sighişoara",
				"to": "Braşov",
				"leavesAt": "17:51",
				"arrivesAt": "20:26",
				"waitsAtSource": 180,
				"distance": 127400
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "20:34",
				"arrivesAt": "21:09",
				"waitsAtSource": 480,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "21:11",
				"arrivesAt": "21:20",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "21:21",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "21:28",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "21:37",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "22:01",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "22:24",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3076",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Est",
				"leavesAt": "15:30",
				"arrivesAt": "15:36",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Oradea Est",
				"to": "Oşorhei Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Săcădat h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săcădat h.",
				"to": "Săbolciu h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbolciu h.",
				"to": "Tileagd",
				"leavesAt": "15:55",
				"arrivesAt": "16:02",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tileagd",
				"to": "Telechiu Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Telechiu Hm.",
				"to": "Ţeţchea hc.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Aleşd",
				"leavesAt": "16:16",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Aleşd",
				"to": "Aleşd h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aleşd h.",
				"to": "Butan h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:32",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Butan h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Vadu Crişului h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:49",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Peştera h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Peştera h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bălnaca h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:09",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Bălnaca h.",
				"to": "Bratca",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:22",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:31",
				"waitsAtSource": 240,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Valea Drăganului h.",
				"leavesAt": "17:53",
				"arrivesAt": "17:57",
				"waitsAtSource": 420,
				"distance": 4100
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Poieni",
				"leavesAt": "17:58",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Bologa h.",
				"leavesAt": "18:03",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bologa h.",
				"to": "Brăişoru Hm.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "18:12",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:34",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:46",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "18:47",
				"arrivesAt": "18:51",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "18:52",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "18:55",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "19:03",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "19:09",
				"arrivesAt": "19:12",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:18",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "19:24",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9063",
		"segments": [
			{
				"from": "Caracal",
				"to": "Canton 239+700 h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:22",
				"waitsAtSource": 0,
				"distance": 1400
			},
			{
				"from": "Canton 239+700 h.",
				"to": "Deveselu h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:32",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Deveselu h.",
				"to": "Frăsinet hc.",
				"leavesAt": "14:33",
				"arrivesAt": "14:41",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Frăsinet hc.",
				"to": "Studiniţa h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:46",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Studiniţa h.",
				"to": "Studina hc.",
				"leavesAt": "14:47",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Studina hc.",
				"to": "Vişina h.",
				"leavesAt": "14:53",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Vişina h.",
				"to": "Vişina Veche hc.",
				"leavesAt": "15:01",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vişina Veche hc.",
				"to": "Corabia",
				"leavesAt": "15:05",
				"arrivesAt": "15:20",
				"waitsAtSource": 30,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4085",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:42",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "19:57",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Zalău Nord",
				"to": "Guruslău h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:23",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Guruslău h.",
				"to": "Borla Hm.",
				"leavesAt": "20:24",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Borla Hm.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Sărmăşag",
				"leavesAt": "20:39",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sărmăşag",
				"to": "Sărmăşag h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sărmăşag h.",
				"to": "Derşida h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Derşida h.",
				"to": "Giorocuţa h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:01",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Giorocuţa h.",
				"to": "Supur h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Supur h.",
				"to": "Supur Haltă hc.",
				"leavesAt": "21:06",
				"arrivesAt": "21:08",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Acâş Hm.",
				"leavesAt": "21:09",
				"arrivesAt": "21:16",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Acâş Hm.",
				"to": "Săcăşeni h.",
				"leavesAt": "21:37",
				"arrivesAt": "21:48",
				"waitsAtSource": 1260,
				"distance": 10000
			},
			{
				"from": "Săcăşeni h.",
				"to": "Tăşnad",
				"leavesAt": "21:49",
				"arrivesAt": "21:56",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Santău h.",
				"leavesAt": "21:57",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Santău h.",
				"to": "Hotoan h.",
				"leavesAt": "22:04",
				"arrivesAt": "22:10",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Hotoan h.",
				"to": "Tiream h.",
				"leavesAt": "22:11",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tiream h.",
				"to": "Carei",
				"leavesAt": "22:18",
				"arrivesAt": "22:32",
				"waitsAtSource": 30,
				"distance": 11700
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "22:42",
				"arrivesAt": "22:49",
				"waitsAtSource": 600,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "22:50",
				"arrivesAt": "22:53",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "22:54",
				"arrivesAt": "22:57",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "22:58",
				"arrivesAt": "23:06",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "23:07",
				"arrivesAt": "23:14",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "23:15",
				"arrivesAt": "23:22",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4543",
		"segments": [
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "05:04",
				"arrivesAt": "05:10",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "05:11",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "05:15",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "05:30",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:48",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "06:31",
				"arrivesAt": "06:39",
				"waitsAtSource": 720,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9480",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:45",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Slatina",
				"leavesAt": "05:53",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "06:08",
				"arrivesAt": "06:17",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "06:18",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "06:28",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9024",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "03:50",
				"arrivesAt": "03:54",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "03:55",
				"arrivesAt": "04:00",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "04:01",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "04:10",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:25",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "04:26",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "04:35",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "04:44",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "04:51",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:10",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "05:11",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "05:29",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Pârvu h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Pârvu h.",
				"to": "Pârvu Hm.",
				"leavesAt": "05:47",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Pârvu Hm.",
				"to": "Bradu de Sus",
				"leavesAt": "05:57",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "06:12",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Piteşti",
				"to": "Km. 107+000 h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 1500,
				"distance": 1000
			},
			{
				"from": "Km. 107+000 h.",
				"to": "Ram. Goleşti",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ram. Goleşti",
				"to": "Goleşti",
				"leavesAt": "06:50",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Goleşti",
				"to": "Canton 97+770 h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:03",
				"waitsAtSource": 120,
				"distance": 2600
			},
			{
				"from": "Canton 97+770 h.",
				"to": "Călineşti Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Călineşti Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "07:11",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Pătroaia Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Găeşti",
				"leavesAt": "07:28",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Găeşti",
				"to": "Găeşti Sud h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 600,
				"distance": 4000
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Cojocaru h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Cojocaru h.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Fusea Hm.",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Fusea Hm.",
				"to": "Titu",
				"leavesAt": "08:09",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "08:51",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "09:00",
				"arrivesAt": "09:06",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "09:07",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "09:12",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7401",
		"segments": [
			{
				"from": "Buzău",
				"to": "Tăbărăşti h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:20",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "05:39",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Vizireni h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vizireni h.",
				"to": "Făurei",
				"leavesAt": "05:50",
				"arrivesAt": "05:59",
				"waitsAtSource": 30,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2088",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Lunca Jiului hc.",
				"leavesAt": "19:10",
				"arrivesAt": "19:13",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Livezeni",
				"leavesAt": "19:14",
				"arrivesAt": "19:19",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "19:20",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Lainici Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:49",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Lainici Hm.",
				"to": "Meri",
				"leavesAt": "19:50",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Meri",
				"to": "Valea Sadului Hm.",
				"leavesAt": "20:00",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Parângu Hm.",
				"leavesAt": "20:13",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Parângu Hm.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "20:21",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Târgu Jiu",
				"leavesAt": "20:32",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 800
			},
			{
				"from": "Târgu Jiu",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:51",
				"waitsAtSource": 480,
				"distance": 6800
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Budieni h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Budieni h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "20:57",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:10",
				"waitsAtSource": 300,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Pojogeni Hm.",
				"leavesAt": "21:11",
				"arrivesAt": "21:14",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "21:15",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "21:23",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "21:36",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:52",
				"waitsAtSource": 300,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "21:53",
				"arrivesAt": "22:01",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "22:02",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "22:09",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "22:13",
				"arrivesAt": "22:18",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Filiaşi",
				"leavesAt": "22:19",
				"arrivesAt": "22:25",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "22:26",
				"arrivesAt": "22:29",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "22:30",
				"arrivesAt": "22:34",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "22:35",
				"arrivesAt": "22:39",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "22:40",
				"arrivesAt": "22:45",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "22:46",
				"arrivesAt": "22:49",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "22:50",
				"arrivesAt": "22:55",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "22:56",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Craiova Triaj hc.",
				"leavesAt": "22:59",
				"arrivesAt": "23:05",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "23:06",
				"arrivesAt": "23:10",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 351
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3514",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "14:12",
				"arrivesAt": "14:19",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Mihalţ h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:23",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Mihalţ h.",
				"to": "Cistei h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cistei h.",
				"to": "Crăciunel Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:40",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Blaj",
				"leavesAt": "14:41",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Blaj",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 120,
				"distance": 3500
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Mănărade h.",
				"leavesAt": "14:56",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mănărade h.",
				"to": "Glogoveţ h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Glogoveţ h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Lunca h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca h.",
				"to": "Micăsasa h.",
				"leavesAt": "15:14",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Micăsasa h.",
				"to": "Copşa Mică",
				"leavesAt": "15:24",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 10200
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "15:50",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2233",
		"segments": [
			{
				"from": "Remetea Mică",
				"to": "Fibiş h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:26",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Bencei h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bencei h.",
				"to": "Pişchia h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pişchia h.",
				"to": "Cerneteaz h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Cerneteaz h.",
				"to": "Giarmata Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Giarmata Hm.",
				"to": "Viile Giarmata h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Timişoara Est",
				"leavesAt": "07:01",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "07:12",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5502",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "08:00",
				"arrivesAt": "08:05",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "08:07",
				"arrivesAt": "08:14",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "08:15",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "08:43",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "09:05",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "09:11",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1744",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Seini",
				"leavesAt": "00:45",
				"arrivesAt": "01:21",
				"waitsAtSource": 0,
				"distance": 24600
			},
			{
				"from": "Seini",
				"to": "Satu Mare",
				"leavesAt": "01:22",
				"arrivesAt": "02:01",
				"waitsAtSource": 60,
				"distance": 34800
			},
			{
				"from": "Satu Mare",
				"to": "Carei",
				"leavesAt": "02:06",
				"arrivesAt": "02:36",
				"waitsAtSource": 300,
				"distance": 36000
			},
			{
				"from": "Carei",
				"to": "Valea lui Mihai",
				"leavesAt": "02:37",
				"arrivesAt": "03:00",
				"waitsAtSource": 60,
				"distance": 31200
			},
			{
				"from": "Valea lui Mihai",
				"to": "Săcuieni Bihor",
				"leavesAt": "03:01",
				"arrivesAt": "03:18",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Oradea",
				"leavesAt": "03:19",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 44200
			},
			{
				"from": "Oradea",
				"to": "Salonta",
				"leavesAt": "04:16",
				"arrivesAt": "04:57",
				"waitsAtSource": 660,
				"distance": 39200
			},
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "04:59",
				"arrivesAt": "05:12",
				"waitsAtSource": 120,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "05:19",
				"arrivesAt": "05:42",
				"waitsAtSource": 420,
				"distance": 23700
			},
			{
				"from": "Chişineu Criş",
				"to": "Sântana",
				"leavesAt": "05:43",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Sântana",
				"to": "Arad",
				"leavesAt": "06:02",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "06:31",
				"arrivesAt": "06:38",
				"waitsAtSource": 240,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Vinga Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 18400
			},
			{
				"from": "Vinga Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "07:03",
				"arrivesAt": "07:28",
				"waitsAtSource": 300,
				"distance": 32600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9575",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Tibiscu h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:09",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Tibiscu h.",
				"to": "Zăgujeni Hm.",
				"leavesAt": "13:10",
				"arrivesAt": "13:13",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Căvăran",
				"leavesAt": "13:14",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Căvăran",
				"to": "Sacu h.",
				"leavesAt": "13:26",
				"arrivesAt": "13:29",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Sacu h.",
				"to": "Jena Hm.",
				"leavesAt": "13:30",
				"arrivesAt": "13:34",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Jena Hm.",
				"to": "Găvojdia",
				"leavesAt": "13:35",
				"arrivesAt": "13:46",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Găvojdia",
				"to": "Tapia Hm.",
				"leavesAt": "13:47",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tapia Hm.",
				"to": "Lugoj",
				"leavesAt": "13:52",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lugoj",
				"to": "Jabăr Hm.",
				"leavesAt": "13:59",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "14:13",
				"arrivesAt": "14:18",
				"waitsAtSource": 480,
				"distance": 5600
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "14:19",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "14:24",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:37",
				"waitsAtSource": 240,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "14:38",
				"arrivesAt": "14:44",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:00",
				"waitsAtSource": 780,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "15:01",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "15:10",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "15:25",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9347",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureştii Noi",
				"leavesAt": "15:28",
				"arrivesAt": "15:35",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "15:36",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "15:53",
				"arrivesAt": "16:03",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Zorile h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Zorile h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "16:09",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:31",
				"waitsAtSource": 540,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Zăvestreni Hm.",
				"leavesAt": "16:32",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Videle",
				"leavesAt": "16:38",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Videle",
				"to": "Răduleşti Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Târnavele Hm.",
				"to": "Vlaşca Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Răsuceni h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Răsuceni h.",
				"to": "Toporu",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Toporu",
				"to": "Chiriacu Hm.",
				"leavesAt": "17:34",
				"arrivesAt": "17:45",
				"waitsAtSource": 540,
				"distance": 10600
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Stăneşti Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Onceşti h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Onceşti h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Cetatea h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cetatea h.",
				"to": "Giurgiu Nord",
				"leavesAt": "18:11",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Giurgiu Nord",
				"to": "Giurgiu",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1384",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "10:56",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "11:07",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dorneşti",
				"leavesAt": "11:18",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Dorneşti",
				"to": "Vicşani",
				"leavesAt": "11:33",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Vicşani",
				"to": "Vadu Siretului",
				"leavesAt": "12:43",
				"arrivesAt": "13:05",
				"waitsAtSource": 3360,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20180614",
				"to": "20180617",
				"daysOfWeek": 383
			},
			{
				"from": "20180619",
				"to": "20180624",
				"daysOfWeek": 383
			},
			{
				"from": "20180626",
				"to": "20180629",
				"daysOfWeek": 383
			},
			{
				"from": "20180701",
				"to": "20180706",
				"daysOfWeek": 383
			},
			{
				"from": "20180708",
				"to": "20180711",
				"daysOfWeek": 383
			},
			{
				"from": "20180713",
				"to": "20180718",
				"daysOfWeek": 383
			},
			{
				"from": "20180720",
				"to": "20180723",
				"daysOfWeek": 383
			},
			{
				"from": "20180725",
				"to": "20180730",
				"daysOfWeek": 383
			},
			{
				"from": "20180801",
				"to": "20180804",
				"daysOfWeek": 383
			},
			{
				"from": "20180806",
				"to": "20180811",
				"daysOfWeek": 383
			},
			{
				"from": "20180813",
				"to": "20180816",
				"daysOfWeek": 383
			},
			{
				"from": "20180818",
				"to": "20180823",
				"daysOfWeek": 383
			},
			{
				"from": "20180825",
				"to": "20180828",
				"daysOfWeek": 383
			},
			{
				"from": "20180830",
				"to": "20180904",
				"daysOfWeek": 383
			},
			{
				"from": "20180906",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180911",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180612",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4501",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "03:58",
				"arrivesAt": "04:02",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "04:03",
				"arrivesAt": "04:08",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Prejmer Hm.",
				"leavesAt": "04:09",
				"arrivesAt": "04:17",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ozun Hm.",
				"leavesAt": "04:18",
				"arrivesAt": "04:26",
				"waitsAtSource": 30,
				"distance": 8600
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "04:27",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Arcuş h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:17",
				"waitsAtSource": 2160,
				"distance": 5000
			},
			{
				"from": "Arcuş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Bodoc Hm.",
				"to": "Malnaş h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Malnaş h.",
				"to": "Malnaş Băi",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş Băi",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "05:39",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "05:58",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Vrabia h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Vrabia h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:16",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "06:26",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "07:28",
				"arrivesAt": "07:37",
				"waitsAtSource": 3240,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:45",
				"waitsAtSource": 300,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "07:46",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:06",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "08:07",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:26",
				"waitsAtSource": 180,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "08:27",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Şugău h.",
				"leavesAt": "08:49",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şugău h.",
				"to": "Valea Strâmbă h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Gheorgheni",
				"leavesAt": "08:57",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5209",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:20",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "17:35",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "17:56",
				"arrivesAt": "18:05",
				"waitsAtSource": 600,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "18:15",
				"arrivesAt": "18:19",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "18:20",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "18:30",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "18:34",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Trotuş h.",
				"leavesAt": "18:42",
				"arrivesAt": "18:49",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Trotuş h.",
				"to": "Viişoara h",
				"leavesAt": "18:50",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "19:06",
				"arrivesAt": "19:08",
				"waitsAtSource": 420,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "19:16",
				"arrivesAt": "19:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "19:23",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:35",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "19:36",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Comăneşti",
				"to": "Asău Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 1140,
				"distance": 5100
			},
			{
				"from": "Asău Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caraliţa h.",
				"to": "Goioasa Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Goioasa Hm.",
				"to": "Simbrea Hm.",
				"leavesAt": "20:21",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Simbrea Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "20:30",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Palanca Hm.",
				"leavesAt": "20:36",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Palanca Hm.",
				"to": "Ghimeş",
				"leavesAt": "20:42",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghimeş",
				"to": "Bolovăniş h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "20:58",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Tarcău h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Utuşoiu h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Utuşoiu h.",
				"to": "Livezi Ciuc",
				"leavesAt": "21:22",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Caracău h.",
				"leavesAt": "21:31",
				"arrivesAt": "21:34",
				"waitsAtSource": 180,
				"distance": 2100
			},
			{
				"from": "Caracău h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:42",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "21:43",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Mihăileni Hm.",
				"leavesAt": "21:48",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Siculeni",
				"leavesAt": "21:53",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1756",
		"segments": [
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "22:16",
				"arrivesAt": "22:29",
				"waitsAtSource": 0,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "22:44",
				"arrivesAt": "23:03",
				"waitsAtSource": 900,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "23:04",
				"arrivesAt": "23:20",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "23:23",
				"arrivesAt": "23:50",
				"waitsAtSource": 180,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "23:51",
				"arrivesAt": "00:20",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "00:35",
				"arrivesAt": "01:15",
				"waitsAtSource": 900,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "01:16",
				"arrivesAt": "01:43",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "01:45",
				"arrivesAt": "02:06",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "02:08",
				"arrivesAt": "02:45",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "02:47",
				"arrivesAt": "03:18",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "03:20",
				"arrivesAt": "03:52",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "03:53",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "04:31",
				"arrivesAt": "05:23",
				"waitsAtSource": 180,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9475",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Bradu de Sus",
				"leavesAt": "16:25",
				"arrivesAt": "16:30",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Pârvu Hm.",
				"to": "Pârvu h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Pârvu h.",
				"to": "Suseni h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Suseni h.",
				"to": "Costeşti",
				"leavesAt": "16:46",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "17:31",
				"arrivesAt": "17:37",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "17:38",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 300,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "18:08",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "18:17",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "18:35",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9344",
		"segments": [
			{
				"from": "Giurgiu",
				"to": "Giurgiu Nord",
				"leavesAt": "11:40",
				"arrivesAt": "11:45",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Giurgiu Nord",
				"to": "Cetatea h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:49",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cetatea h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "11:50",
				"arrivesAt": "11:53",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Onceşti h.",
				"leavesAt": "11:54",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Onceşti h.",
				"to": "Stăneşti Hm.",
				"leavesAt": "11:58",
				"arrivesAt": "12:03",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Chiriacu Hm.",
				"leavesAt": "12:04",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Toporu",
				"leavesAt": "12:12",
				"arrivesAt": "12:22",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Toporu",
				"to": "Răsuceni h.",
				"leavesAt": "12:23",
				"arrivesAt": "12:25",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Răsuceni h.",
				"to": "Vlaşca Hm.",
				"leavesAt": "12:26",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "12:34",
				"arrivesAt": "12:42",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Târnavele Hm.",
				"to": "Răduleşti Hm.",
				"leavesAt": "12:43",
				"arrivesAt": "12:54",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Videle",
				"leavesAt": "12:55",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5026",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Brazi",
				"leavesAt": "14:40",
				"arrivesAt": "14:54",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "14:55",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "15:02",
				"arrivesAt": "15:07",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:19",
				"waitsAtSource": 480,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "15:20",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "15:39",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "15:49",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "15:53",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "16:02",
				"arrivesAt": "16:04",
				"waitsAtSource": 300,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Nord",
				"leavesAt": "16:05",
				"arrivesAt": "16:11",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9696",
		"segments": [
			{
				"from": "Anina",
				"to": "Gârlişte Hm.",
				"leavesAt": "14:40",
				"arrivesAt": "15:09",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Gârlişte Hm.",
				"to": "Ciudanoviţa Pam.",
				"leavesAt": "15:10",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Ciudanoviţa Pam.",
				"to": "Lişava Hm.",
				"leavesAt": "15:36",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Lişava Hm.",
				"to": "Dobrei hcv.",
				"leavesAt": "15:42",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dobrei hcv.",
				"to": "Brădişoru de Jos h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Brădişoru de Jos h.",
				"to": "Oraviţa",
				"leavesAt": "16:19",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20180401",
				"to": "20180930",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2713",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Dep Petroşani h.",
				"leavesAt": "18:50",
				"arrivesAt": "18:53",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Peştera Bolii h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Băniţa",
				"leavesAt": "19:00",
				"arrivesAt": "19:07",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Băniţa",
				"to": "Merişor Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Merişor Hm.",
				"to": "Crivadia Hm.",
				"leavesAt": "19:20",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Crivadia Hm.",
				"to": "Baru Mare h.",
				"leavesAt": "19:30",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Baru Mare h.",
				"to": "Baru Mare",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Baru Mare",
				"to": "Livadia h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Livadia h.",
				"to": "Ponor h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ponor h.",
				"to": "Pui",
				"leavesAt": "19:51",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Pui",
				"to": "Ruşor h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Ruşor h.",
				"to": "Băeşti Hm.",
				"leavesAt": "20:02",
				"arrivesAt": "20:05",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Ciopea h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ciopea h.",
				"to": "Subcetate",
				"leavesAt": "20:12",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Subcetate",
				"to": "Covragiu h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Covragiu h.",
				"to": "Plopi h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Plopi h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "20:23",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Măceu h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măceu h.",
				"to": "Ruşi h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ruşi h.",
				"to": "Călan Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Călan Hm.",
				"to": "Călan Băi",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Batiz h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Batiz h.",
				"to": "Băcia Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Băcia Hm.",
				"to": "Băcia h.",
				"leavesAt": "20:54",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia h.",
				"to": "Simeria Triaj",
				"leavesAt": "20:57",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Simeria Triaj",
				"to": "Simeria",
				"leavesAt": "21:01",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "21:09",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8025",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "13:20",
				"arrivesAt": "13:29",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "13:30",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "13:36",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:46",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "13:47",
				"arrivesAt": "13:50",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "14:07",
				"arrivesAt": "14:12",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "14:19",
				"arrivesAt": "14:27",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:33",
				"waitsAtSource": 120,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:37",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:49",
				"waitsAtSource": 420,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ivăneşti h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ivăneşti h.",
				"to": "Ciulniţa",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:21",
				"waitsAtSource": 120,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "15:26",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "15:30",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "15:44",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "16:12",
				"arrivesAt": "16:18",
				"waitsAtSource": 1140,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Cernavodă Pod",
				"leavesAt": "16:19",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "16:37",
				"arrivesAt": "16:45",
				"waitsAtSource": 180,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "16:53",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:08",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 540,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "17:28",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "17:34",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "17:39",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 600,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "17:59",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6313",
		"segments": [
			{
				"from": "Tecuci",
				"to": "Tecuci Nord hc.(600)",
				"leavesAt": "13:38",
				"arrivesAt": "13:41",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Tecuci Nord hc.(600)",
				"to": "Frunzeasca Hm.",
				"leavesAt": "13:42",
				"arrivesAt": "13:47",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Frunzeasca Hm.",
				"to": "Rateş Munteni h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Rateş Munteni h.",
				"to": "Berheci Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Berheci Hm.",
				"to": "Nichişeni",
				"leavesAt": "14:01",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Nichişeni",
				"to": "Ghidigeni Hm.",
				"leavesAt": "14:12",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ghidigeni Hm.",
				"to": "Tutova",
				"leavesAt": "14:18",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tutova",
				"to": "Dragalina h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Dragalina h.",
				"to": "Bârlad",
				"leavesAt": "14:39",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bârlad",
				"to": "Zorleni",
				"leavesAt": "14:52",
				"arrivesAt": "15:00",
				"waitsAtSource": 180,
				"distance": 7300
			},
			{
				"from": "Zorleni",
				"to": "Banca Hm.",
				"leavesAt": "15:01",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Banca Hm.",
				"to": "Dodeşti hc.",
				"leavesAt": "15:10",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dodeşti hc.",
				"to": "Roşieşti hc.",
				"leavesAt": "15:16",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Roşieşti hc.",
				"to": "Crasna",
				"leavesAt": "15:23",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Crasna",
				"to": "Bulboaca h.",
				"leavesAt": "15:32",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Bulboaca h.",
				"to": "Munteni Hm.",
				"leavesAt": "15:41",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Munteni Hm.",
				"to": "Vaslui",
				"leavesAt": "15:48",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "15:57",
				"arrivesAt": "16:07",
				"waitsAtSource": 180,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "16:14",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "16:19",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 300,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "16:48",
				"arrivesAt": "16:54",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "16:55",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "17:28",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "17:35",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9003",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "12:05",
				"arrivesAt": "12:08",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h.(900)",
				"leavesAt": "12:09",
				"arrivesAt": "12:12",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureştii Noi",
				"leavesAt": "12:13",
				"arrivesAt": "12:17",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "12:18",
				"arrivesAt": "12:22",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "12:23",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "12:35",
				"arrivesAt": "12:45",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Vadu Lat Hm.",
				"leavesAt": "12:46",
				"arrivesAt": "12:59",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Videle",
				"leavesAt": "13:00",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 14600
			},
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "13:15",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "13:22",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "13:31",
				"arrivesAt": "13:36",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "13:37",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "13:45",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "13:51",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "14:02",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Roşiori Nord",
				"to": "Mihăeşti Hm.",
				"leavesAt": "14:15",
				"arrivesAt": "14:28",
				"waitsAtSource": 120,
				"distance": 17300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "14:29",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "14:41",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Caracal",
				"leavesAt": "14:58",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Caracal",
				"to": "Radomiru hc.",
				"leavesAt": "15:11",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 18800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "15:26",
				"arrivesAt": "15:30",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Leu Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "15:40",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Bordei hc.(900)",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "16:05",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3023",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "04:36",
				"arrivesAt": "04:41",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "04:42",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "04:48",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "04:58",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "05:11",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "05:25",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Posada h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Posada h.",
				"to": "Sinaia Sud h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "05:45",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "05:49",
				"arrivesAt": "05:53",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "05:59",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "06:05",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "06:17",
				"arrivesAt": "06:32",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Timişu de Jos h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Dârste",
				"leavesAt": "06:41",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5737",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "15:46",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Părhăuţi h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:08",
				"waitsAtSource": 360,
				"distance": 4400
			},
			{
				"from": "Părhăuţi h.",
				"to": "Todireşti h.",
				"leavesAt": "16:09",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Todireşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Soloneţ h.",
				"to": "Pârteşti h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pârteşti h.",
				"to": "Cacica Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3533",
		"segments": [
			{
				"from": "Braşov",
				"to": "Stupini Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:19",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Stupini Hm.",
				"to": "Bod Hm.",
				"leavesAt": "16:20",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Bod Hm.",
				"to": "Feldioara Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Rotbav h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Rotbav h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "16:44",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Măieruş h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Măieruş h.",
				"to": "Apaţa",
				"leavesAt": "16:53",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Apaţa",
				"to": "Ormeniş h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ormeniş h.",
				"to": "Augustin Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Augustin Hm.",
				"to": "Racoş Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Racoş Hm.",
				"to": "Mateiaş h.",
				"leavesAt": "17:44",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mateiaş h.",
				"to": "Rupea",
				"leavesAt": "17:49",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Rupea",
				"to": "Caţa Hm.",
				"leavesAt": "18:04",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Caţa Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Beia Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Beia Hm.",
				"to": "Archita h",
				"leavesAt": "18:31",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Archita h",
				"to": "Mureni Hm.",
				"leavesAt": "18:43",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 9600
			},
			{
				"from": "Mureni Hm.",
				"to": "Saschiz h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Vânători",
				"leavesAt": "19:03",
				"arrivesAt": "19:07",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "19:16",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1944",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "13:28",
				"arrivesAt": "13:46",
				"waitsAtSource": 0,
				"distance": 21200
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Seini",
				"leavesAt": "13:56",
				"arrivesAt": "14:15",
				"waitsAtSource": 600,
				"distance": 13600
			},
			{
				"from": "Seini",
				"to": "Baia Mare",
				"leavesAt": "14:16",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Baia Mare",
				"to": "Ulmeni Sălaj",
				"leavesAt": "15:06",
				"arrivesAt": "15:36",
				"waitsAtSource": 840,
				"distance": 31000
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Benesat Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Benesat Hm.",
				"to": "Jibou",
				"leavesAt": "15:47",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Jibou",
				"to": "Cuciulat Hm.",
				"leavesAt": "16:06",
				"arrivesAt": "16:30",
				"waitsAtSource": 120,
				"distance": 18500
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Ileanda",
				"leavesAt": "16:36",
				"arrivesAt": "17:01",
				"waitsAtSource": 360,
				"distance": 18200
			},
			{
				"from": "Ileanda",
				"to": "Gâlgău",
				"leavesAt": "17:03",
				"arrivesAt": "17:20",
				"waitsAtSource": 120,
				"distance": 16100
			},
			{
				"from": "Gâlgău",
				"to": "Dej Călători",
				"leavesAt": "17:22",
				"arrivesAt": "17:46",
				"waitsAtSource": 120,
				"distance": 23400
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "18:02",
				"arrivesAt": "18:35",
				"waitsAtSource": 960,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Sărăţel Hm.",
				"leavesAt": "18:51",
				"arrivesAt": "19:17",
				"waitsAtSource": 960,
				"distance": 24900
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Deda",
				"leavesAt": "19:20",
				"arrivesAt": "20:16",
				"waitsAtSource": 180,
				"distance": 46800
			},
			{
				"from": "Deda",
				"to": "Topliţa",
				"leavesAt": "20:38",
				"arrivesAt": "21:35",
				"waitsAtSource": 1320,
				"distance": 43900
			},
			{
				"from": "Topliţa",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Gheorgheni",
				"leavesAt": "21:51",
				"arrivesAt": "22:19",
				"waitsAtSource": 420,
				"distance": 28000
			},
			{
				"from": "Gheorgheni",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "22:22",
				"arrivesAt": "22:38",
				"waitsAtSource": 180,
				"distance": 19100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "22:41",
				"arrivesAt": "22:54",
				"waitsAtSource": 180,
				"distance": 10900
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "23:02",
				"arrivesAt": "23:22",
				"waitsAtSource": 480,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "23:26",
				"arrivesAt": "23:34",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "23:36",
				"arrivesAt": "23:59",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bodoc Hm.",
				"leavesAt": "00:01",
				"arrivesAt": "00:28",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Bodoc Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "00:38",
				"arrivesAt": "00:47",
				"waitsAtSource": 600,
				"distance": 9500
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "00:50",
				"arrivesAt": "01:20",
				"waitsAtSource": 180,
				"distance": 32100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "01:40",
				"arrivesAt": "02:15",
				"waitsAtSource": 1200,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "02:25",
				"arrivesAt": "02:34",
				"waitsAtSource": 600,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "02:36",
				"arrivesAt": "02:42",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "02:44",
				"arrivesAt": "02:53",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "02:55",
				"arrivesAt": "03:19",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "03:21",
				"arrivesAt": "03:46",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Băneasa",
				"leavesAt": "03:49",
				"arrivesAt": "04:38",
				"waitsAtSource": 180,
				"distance": 58100
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Feteşti",
				"leavesAt": "04:48",
				"arrivesAt": "06:04",
				"waitsAtSource": 600,
				"distance": 139800
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "06:07",
				"arrivesAt": "06:27",
				"waitsAtSource": 180,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "06:28",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "06:46",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:55",
				"waitsAtSource": 1200,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "08:07",
				"arrivesAt": "08:14",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:25",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "08:26",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "08:35",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "08:41",
				"arrivesAt": "08:54",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "09:02",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2071",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Găneasa h.",
				"leavesAt": "03:45",
				"arrivesAt": "03:49",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Găneasa h.",
				"to": "Găneasa Olt h.",
				"leavesAt": "03:50",
				"arrivesAt": "03:53",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Arceşti Hm.",
				"leavesAt": "03:54",
				"arrivesAt": "03:59",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Colibaşi h.",
				"leavesAt": "04:00",
				"arrivesAt": "04:07",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Strejeşti",
				"leavesAt": "04:08",
				"arrivesAt": "04:15",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Strejeşti",
				"to": "Zlătărei Hm.",
				"leavesAt": "04:16",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Drăgăşani",
				"leavesAt": "04:23",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Drăgăşani",
				"to": "Călina h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Călina h.",
				"to": "Zăvideni Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "04:45",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Orleşti hc.",
				"to": "Fişcălia Hm.",
				"leavesAt": "04:51",
				"arrivesAt": "04:54",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "04:55",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Ioneşti Hm.",
				"leavesAt": "04:59",
				"arrivesAt": "05:03",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Slăviteşti hc.",
				"leavesAt": "05:04",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Băbeni",
				"leavesAt": "05:11",
				"arrivesAt": "05:20",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:45",
				"waitsAtSource": 1320,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "05:46",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "05:54",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "05:59",
				"arrivesAt": "06:08",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:20",
				"waitsAtSource": 600,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "06:25",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:32",
				"waitsAtSource": 180,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "06:38",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Cozia Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cozia Hm.",
				"to": "Lotru",
				"leavesAt": "07:12",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lotru",
				"to": "Beţel h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Beţel h.",
				"to": "Cornet Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cornet Hm.",
				"to": "Balota h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Balota h.",
				"to": "Robeşti h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:45",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Robeşti h.",
				"to": "Câineni",
				"leavesAt": "07:46",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Râu Vadului h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:10",
				"waitsAtSource": 540,
				"distance": 5400
			},
			{
				"from": "Râu Vadului h.",
				"to": "Valea Fratelui h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:15",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "08:16",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "08:39",
				"arrivesAt": "08:49",
				"waitsAtSource": 660,
				"distance": 6400
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "08:50",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1736",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "16:30",
				"arrivesAt": "17:36",
				"waitsAtSource": 0,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "17:37",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "17:58",
				"arrivesAt": "18:03",
				"waitsAtSource": 300,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "18:04",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "18:20",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Blaj",
				"leavesAt": "18:38",
				"arrivesAt": "19:05",
				"waitsAtSource": 240,
				"distance": 21300
			},
			{
				"from": "Blaj",
				"to": "Valea Lungă Hm.",
				"leavesAt": "19:06",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Copşa Mică",
				"leavesAt": "19:22",
				"arrivesAt": "19:48",
				"waitsAtSource": 240,
				"distance": 17900
			},
			{
				"from": "Copşa Mică",
				"to": "Şeica Mare",
				"leavesAt": "19:53",
				"arrivesAt": "20:04",
				"waitsAtSource": 300,
				"distance": 11100
			},
			{
				"from": "Şeica Mare",
				"to": "Loamneş Hm.",
				"leavesAt": "20:05",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 13100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:28",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Sibiu",
				"leavesAt": "20:29",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 12500
			},
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "21:03",
				"waitsAtSource": 120,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "21:04",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Câineni",
				"leavesAt": "21:14",
				"arrivesAt": "21:44",
				"waitsAtSource": 30,
				"distance": 21600
			},
			{
				"from": "Câineni",
				"to": "Călimăneşti",
				"leavesAt": "21:53",
				"arrivesAt": "22:36",
				"waitsAtSource": 540,
				"distance": 36700
			},
			{
				"from": "Călimăneşti",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "22:37",
				"arrivesAt": "22:55",
				"waitsAtSource": 60,
				"distance": 16200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8204",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "16:42",
				"arrivesAt": "16:48",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "16:49",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:19",
				"waitsAtSource": 480,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "17:29",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:50",
				"waitsAtSource": 300,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "17:51",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "17:57",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Ramificaţia Borcea",
				"leavesAt": "18:08",
				"arrivesAt": "18:28",
				"waitsAtSource": 120,
				"distance": 16000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "18:29",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "18:46",
				"arrivesAt": "19:04",
				"waitsAtSource": 600,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Platoneşti h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Platoneşti h.",
				"to": "Ţăndărei",
				"leavesAt": "19:14",
				"arrivesAt": "19:22",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ţăndărei",
				"to": "Murgeanca Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:37",
				"waitsAtSource": 180,
				"distance": 12200
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Spicu",
				"leavesAt": "19:38",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spicu",
				"to": "Dudeşti Hm.",
				"leavesAt": "19:48",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Cireşu Hm.",
				"leavesAt": "20:07",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cireşu Hm.",
				"to": "Făurei",
				"leavesAt": "20:15",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 15700
			},
			{
				"from": "Făurei",
				"to": "Vizireni h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:42",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 480,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "21:01",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:14",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "21:15",
				"arrivesAt": "21:19",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "21:20",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău Sud",
				"leavesAt": "21:24",
				"arrivesAt": "21:30",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Buzău Sud",
				"to": "Buzău",
				"leavesAt": "21:31",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8034",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "19:38",
				"arrivesAt": "19:45",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "19:46",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "20:00",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "20:10",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "20:19",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "20:26",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "20:37",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "20:46",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Ramificaţia Borcea",
				"leavesAt": "20:57",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "21:13",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8654",
		"segments": [
			{
				"from": "Tulcea Oraş",
				"to": "Tulcea Mărfuri",
				"leavesAt": "16:12",
				"arrivesAt": "16:21",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Cataloi Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Cataloi Hm.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Zebil h.",
				"leavesAt": "16:54",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Zebil h.",
				"to": "Babadag",
				"leavesAt": "17:09",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Babadag",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Baia Dobrogea",
				"leavesAt": "17:43",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baia Dobrogea",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Cogealac",
				"leavesAt": "18:09",
				"arrivesAt": "18:28",
				"waitsAtSource": 480,
				"distance": 17400
			},
			{
				"from": "Cogealac",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "18:50",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Nicolae Bălcescu",
				"leavesAt": "19:01",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Medgidia",
				"leavesAt": "19:08",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Medgidia",
				"to": "Poarta Albă h.",
				"leavesAt": "19:30",
				"arrivesAt": "19:39",
				"waitsAtSource": 120,
				"distance": 12300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "19:40",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Constanţa",
				"leavesAt": "19:45",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 17400
			}
		],
		"restrictions": [
			{
				"from": "20180101",
				"to": "20180104",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180111",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180118",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180125",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180201",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180208",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180215",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180222",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180301",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180308",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180315",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180322",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180329",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180405",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180412",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180419",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180426",
				"daysOfWeek": 383
			},
			{
				"from": "20180430",
				"to": "20180503",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180510",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180517",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20180531",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180607",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180913",
				"daysOfWeek": 383
			},
			{
				"from": "20180917",
				"to": "20180920",
				"daysOfWeek": 383
			},
			{
				"from": "20180924",
				"to": "20180927",
				"daysOfWeek": 383
			},
			{
				"from": "20181001",
				"to": "20181004",
				"daysOfWeek": 383
			},
			{
				"from": "20181008",
				"to": "20181011",
				"daysOfWeek": 383
			},
			{
				"from": "20181015",
				"to": "20181018",
				"daysOfWeek": 383
			},
			{
				"from": "20181022",
				"to": "20181025",
				"daysOfWeek": 383
			},
			{
				"from": "20181029",
				"to": "20181101",
				"daysOfWeek": 383
			},
			{
				"from": "20181105",
				"to": "20181108",
				"daysOfWeek": 383
			},
			{
				"from": "20181112",
				"to": "20181115",
				"daysOfWeek": 383
			},
			{
				"from": "20181119",
				"to": "20181122",
				"daysOfWeek": 383
			},
			{
				"from": "20181126",
				"to": "20181129",
				"daysOfWeek": 383
			},
			{
				"from": "20181203",
				"to": "20181206",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171214",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171221",
				"daysOfWeek": 383
			},
			{
				"from": "20171225",
				"to": "20171228",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5002",
		"segments": [
			{
				"from": "Buzău",
				"to": "Ulmeni",
				"leavesAt": "03:50",
				"arrivesAt": "04:04",
				"waitsAtSource": 0,
				"distance": 15400
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "04:05",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "04:10",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "04:20",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "04:44",
				"arrivesAt": "04:49",
				"waitsAtSource": 420,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Muru hc.",
				"leavesAt": "04:50",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "04:58",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "05:06",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "05:14",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Brazi",
				"leavesAt": "05:24",
				"arrivesAt": "05:39",
				"waitsAtSource": 120,
				"distance": 8800
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "05:47",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 360,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "06:03",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "06:25",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "06:36",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "06:44",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "06:51",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4531",
		"segments": [
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "07:04",
				"arrivesAt": "07:12",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş",
				"to": "Azomureş h.",
				"leavesAt": "07:14",
				"arrivesAt": "07:18",
				"waitsAtSource": 120,
				"distance": 3700
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "07:19",
				"arrivesAt": "07:22",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "07:23",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Vidrasău h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vidrasău h.",
				"to": "Chirileu h.",
				"leavesAt": "07:33",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Chirileu h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Ogra h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ogra h.",
				"to": "Cipău h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:51",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cipău h.",
				"to": "Iernut",
				"leavesAt": "07:52",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iernut",
				"to": "Cuci h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cuci h.",
				"to": "Bogata Mureş h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:10",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Luduş",
				"leavesAt": "08:11",
				"arrivesAt": "08:15",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Luduş",
				"to": "Cheţani h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Cheţani h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Gura Arieşului h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Lunca Mureşului h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:37",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Războieni",
				"leavesAt": "08:38",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4301",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "03:50",
				"arrivesAt": "03:58",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Buneşti h.",
				"leavesAt": "03:59",
				"arrivesAt": "04:02",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Buneşti h.",
				"to": "Gherla",
				"leavesAt": "04:03",
				"arrivesAt": "04:11",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "04:12",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "04:19",
				"arrivesAt": "04:24",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "04:25",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:34",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "04:45",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "05:02",
				"arrivesAt": "05:09",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "05:16",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9388",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "20:05",
				"arrivesAt": "20:08",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "20:09",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Leu Hm.",
				"leavesAt": "20:27",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Leu Hm.",
				"to": "Ţărţăl h.",
				"leavesAt": "20:37",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ţărţăl h.",
				"to": "Jianca",
				"leavesAt": "20:42",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jianca",
				"to": "Radomiru hc.",
				"leavesAt": "20:47",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Radomiru hc.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Cezieni h.",
				"leavesAt": "20:57",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Cezieni h.",
				"to": "Caracal",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Caracal",
				"to": "Fărcaşele Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Stoeneşti h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "21:22",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Dăneasa h.",
				"leavesAt": "21:30",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dăneasa h.",
				"to": "Radomireşti Hm.",
				"leavesAt": "21:34",
				"arrivesAt": "21:41",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "21:42",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "21:52",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 17300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2312",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Veche h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:20",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Simeria Veche h.",
				"to": "Turdaş Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Turdaş Hm.",
				"to": "Pricaz h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Pricaz h.",
				"to": "Orăştie",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Orăştie",
				"to": "Geoagiu h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Geoagiu h.",
				"to": "Aurel Vlaicu",
				"leavesAt": "16:51",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Şibot",
				"leavesAt": "16:57",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şibot",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Tărtăria h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Tărtăria h.",
				"to": "Blandiana Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "17:28",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "17:37",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "18:00",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "18:01",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:16",
				"waitsAtSource": 300,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "18:17",
				"arrivesAt": "18:28",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "18:29",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9446",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:55",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "13:56",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "14:07",
				"arrivesAt": "14:11",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Scârlenţa h.",
				"leavesAt": "14:16",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Scârlenţa h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "14:19",
				"arrivesAt": "14:22",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Doiceşti h.",
				"to": "Doiceşti",
				"leavesAt": "14:26",
				"arrivesAt": "14:28",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Doiceşti",
				"to": "Săteni h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Săteni h.",
				"to": "Aninoasa Hm.",
				"leavesAt": "14:33",
				"arrivesAt": "14:35",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Aninoasa Hm.",
				"to": "TEIŞ Hm.",
				"leavesAt": "14:36",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "14:43",
				"arrivesAt": "14:47",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1594",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "04:28",
				"arrivesAt": "05:07",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "05:08",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Radomireşti Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "05:36",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 25600
			},
			{
				"from": "Roşiori Nord",
				"to": "Olteni",
				"leavesAt": "06:00",
				"arrivesAt": "06:26",
				"waitsAtSource": 120,
				"distance": 26800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Videle",
				"leavesAt": "06:36",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 15800
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "06:50",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "07:16",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 25500
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2493",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "12:55",
				"arrivesAt": "13:03",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "13:16",
				"arrivesAt": "13:20",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "13:21",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "13:33",
				"arrivesAt": "13:42",
				"waitsAtSource": 300,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "13:44",
				"arrivesAt": "13:56",
				"waitsAtSource": 120,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "13:57",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Tărtăria h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tărtăria h.",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Şibot",
				"leavesAt": "14:20",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şibot",
				"to": "Vinerea h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Vinerea h.",
				"to": "Cugir hc.",
				"leavesAt": "14:41",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Cugir hc.",
				"to": "Cugir  Hm.",
				"leavesAt": "14:54",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5530",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Plăieşu h.",
				"leavesAt": "21:35",
				"arrivesAt": "21:42",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "21:43",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "21:50",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "22:05",
				"arrivesAt": "22:15",
				"waitsAtSource": 60,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9615",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Boldur h.",
				"leavesAt": "12:17",
				"arrivesAt": "12:26",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Boldur h.",
				"to": "Sinia Hm.",
				"leavesAt": "12:27",
				"arrivesAt": "12:34",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Sinia Hm.",
				"to": "Căpăt h.",
				"leavesAt": "12:35",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Căpăt h.",
				"to": "Buziaş",
				"leavesAt": "12:41",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Buziaş",
				"to": "Bacova h.",
				"leavesAt": "12:55",
				"arrivesAt": "12:58",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Bacova h.",
				"to": "Chevereş h.",
				"leavesAt": "12:59",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Chevereş h.",
				"to": "Sacoşu Mic",
				"leavesAt": "13:05",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Sacoşu Mic",
				"to": "Uliuc h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Uliuc h.",
				"to": "Urseni h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:23",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Urseni h.",
				"to": "Semenic Hm.",
				"leavesAt": "13:24",
				"arrivesAt": "13:28",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Semenic Hm.",
				"to": "Giroc h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Giroc h.",
				"to": "Timişoara Sud",
				"leavesAt": "13:33",
				"arrivesAt": "13:39",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "13:40",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7038",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:33",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "16:53",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Greci h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Greci h.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:36",
				"waitsAtSource": 420,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Mogoşoaia",
				"leavesAt": "17:37",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Mogoşoaia",
				"to": "Pajura Hm. (700)",
				"leavesAt": "17:55",
				"arrivesAt": "18:18",
				"waitsAtSource": 420,
				"distance": 15000
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Carpaţi h.(700)",
				"leavesAt": "18:19",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Bucureşti Nord",
				"leavesAt": "18:23",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5561",
		"segments": [
			{
				"from": "Botoşani",
				"to": "Leorda Hm.",
				"leavesAt": "04:54",
				"arrivesAt": "05:18",
				"waitsAtSource": 0,
				"distance": 15500
			},
			{
				"from": "Leorda Hm.",
				"to": "Bucecea Hm",
				"leavesAt": "05:19",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bucecea Hm",
				"to": "Bursuceni h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bursuceni h.",
				"to": "Vereşti",
				"leavesAt": "05:55",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "06:08",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "06:16",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "06:28",
				"arrivesAt": "06:34",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6510",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "18:45",
				"arrivesAt": "18:52",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "18:53",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Remiza T Socola h.",
				"leavesAt": "18:59",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Remiza T Socola h.",
				"to": "Holboca Hm.",
				"leavesAt": "19:04",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "19:11",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "19:20",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2704",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "10:35",
				"arrivesAt": "10:42",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băcia h.",
				"to": "Băcia Hm.",
				"leavesAt": "10:46",
				"arrivesAt": "10:48",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Băcia Hm.",
				"to": "Batiz h.",
				"leavesAt": "10:49",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Batiz h.",
				"to": "Călan Băi",
				"leavesAt": "10:52",
				"arrivesAt": "10:54",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "10:55",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Ruşi h.",
				"leavesAt": "11:00",
				"arrivesAt": "11:04",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ruşi h.",
				"to": "Măceu h.",
				"leavesAt": "11:05",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Măceu h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "11:09",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Plopi h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Plopi h.",
				"to": "Covragiu h.",
				"leavesAt": "11:19",
				"arrivesAt": "11:22",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Covragiu h.",
				"to": "Subcetate",
				"leavesAt": "11:23",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Subcetate",
				"to": "Ciopea h.",
				"leavesAt": "11:28",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciopea h.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "11:33",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Băeşti Hm.",
				"leavesAt": "11:36",
				"arrivesAt": "11:39",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ruşor h.",
				"leavesAt": "11:40",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ruşor h.",
				"to": "Pui",
				"leavesAt": "11:43",
				"arrivesAt": "11:48",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Pui",
				"to": "Ponor h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ponor h.",
				"to": "Livadia h.",
				"leavesAt": "11:55",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Livadia h.",
				"to": "Baru Mare",
				"leavesAt": "11:59",
				"arrivesAt": "12:07",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Baru Mare",
				"to": "Baru Mare h.",
				"leavesAt": "12:08",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Baru Mare h.",
				"to": "Crivadia Hm.",
				"leavesAt": "12:13",
				"arrivesAt": "12:20",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Crivadia Hm.",
				"to": "Merişor Hm.",
				"leavesAt": "12:21",
				"arrivesAt": "12:30",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Merişor Hm.",
				"to": "Băniţa",
				"leavesAt": "12:31",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băniţa",
				"to": "Peştera Bolii h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Dep Petroşani h.",
				"leavesAt": "12:57",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani",
				"leavesAt": "13:00",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8014",
		"segments": [
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:31",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "05:36",
				"arrivesAt": "05:40",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "05:41",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "05:53",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Ivăneşti h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 1320,
				"distance": 6700
			},
			{
				"from": "Ivăneşti h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Bogdana h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bogdana h.",
				"to": "Dâlga h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Dâlga h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Lehliu",
				"leavesAt": "06:58",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lehliu",
				"to": "Preasna h.",
				"leavesAt": "07:04",
				"arrivesAt": "07:09",
				"waitsAtSource": 120,
				"distance": 8800
			},
			{
				"from": "Preasna h.",
				"to": "Săruleşti",
				"leavesAt": "07:10",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Săruleşti",
				"to": "Mostiştea h.",
				"leavesAt": "07:25",
				"arrivesAt": "07:29",
				"waitsAtSource": 540,
				"distance": 5900
			},
			{
				"from": "Mostiştea h.",
				"to": "Fundulea Hm.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Fundulea Hm.",
				"to": "Islaz h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Islaz h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "07:43",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Brăneşti Sat h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Pasărea",
				"leavesAt": "07:51",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pasărea",
				"to": "Pantelimon",
				"leavesAt": "07:58",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "08:05",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "08:08",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9061",
		"segments": [
			{
				"from": "Caracal",
				"to": "Deveselu h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:59",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Deveselu h.",
				"to": "Frăsinet hc.",
				"leavesAt": "05:00",
				"arrivesAt": "05:08",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Frăsinet hc.",
				"to": "Studiniţa h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Studiniţa h.",
				"to": "Studina hc.",
				"leavesAt": "05:14",
				"arrivesAt": "05:19",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Studina hc.",
				"to": "Vişina h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Vişina h.",
				"to": "Vişina Veche hc.",
				"leavesAt": "05:28",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vişina Veche hc.",
				"to": "Corabia",
				"leavesAt": "05:32",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20181130",
				"daysOfWeek": 319
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7361",
		"segments": [
			{
				"from": "Buzău",
				"to": "Tăbărăşti h.",
				"leavesAt": "03:52",
				"arrivesAt": "04:00",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:03",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "04:04",
				"arrivesAt": "04:08",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "04:09",
				"arrivesAt": "04:13",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "04:14",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "04:19",
				"arrivesAt": "04:25",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Vizireni h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vizireni h.",
				"to": "Făurei",
				"leavesAt": "04:30",
				"arrivesAt": "04:39",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 2700,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:35",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "05:42",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "06:00",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "06:10",
				"arrivesAt": "06:19",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:35",
				"waitsAtSource": 660,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "06:36",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "06:45",
				"arrivesAt": "06:51",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "07:01",
				"arrivesAt": "07:13",
				"waitsAtSource": 180,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6445",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "21:40",
				"arrivesAt": "21:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "21:55",
				"arrivesAt": "22:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "22:03",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "22:10",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "22:18",
				"arrivesAt": "22:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "22:28",
				"arrivesAt": "22:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "22:35",
				"arrivesAt": "22:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "22:40",
				"arrivesAt": "22:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "22:50",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 14700
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1579",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "18:22",
				"arrivesAt": "19:11",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "19:13",
				"arrivesAt": "19:46",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "19:47",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "20:24",
				"arrivesAt": "21:02",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Ianca hc.",
				"leavesAt": "21:03",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "21:18",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "21:52",
				"arrivesAt": "22:10",
				"waitsAtSource": 120,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "22:11",
				"arrivesAt": "22:30",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9694",
		"segments": [
			{
				"from": "Anina",
				"to": "Gârlişte Hm.",
				"leavesAt": "13:30",
				"arrivesAt": "13:59",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Gârlişte Hm.",
				"to": "Ciudanoviţa Pam.",
				"leavesAt": "14:00",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Ciudanoviţa Pam.",
				"to": "Lişava Hm.",
				"leavesAt": "14:26",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Lişava Hm.",
				"to": "Dobrei hcv.",
				"leavesAt": "14:32",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dobrei hcv.",
				"to": "Brădişoru de Jos h.",
				"leavesAt": "14:46",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Brădişoru de Jos h.",
				"to": "Oraviţa",
				"leavesAt": "15:09",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20181001",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180331",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4146",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Sărăţel Hm.",
				"leavesAt": "19:38",
				"arrivesAt": "19:51",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Domneşti pe Şieu h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:11",
				"waitsAtSource": 720,
				"distance": 6600
			},
			{
				"from": "Domneşti pe Şieu h.",
				"to": "Mărişelu Hm.",
				"leavesAt": "20:12",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Bârla pe Şieu h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bârla pe Şieu h.",
				"to": "Şieu Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:28",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Şieu Hm.",
				"to": "Şieuţ h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Şieuţ h.",
				"to": "Monor Gledin",
				"leavesAt": "20:35",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Monor Gledin",
				"to": "Râpa de Jos Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Râpa de Jos Hm.",
				"to": "Morăreni h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Morăreni h.",
				"to": "Deda",
				"leavesAt": "21:01",
				"arrivesAt": "21:09",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:30",
				"waitsAtSource": 900,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "21:31",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "21:35",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "21:40",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "21:47",
				"arrivesAt": "21:56",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "21:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:10",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "22:11",
				"arrivesAt": "22:20",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "22:21",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "22:34",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4094",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "05:30",
				"arrivesAt": "05:40",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "05:46",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "05:53",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "05:58",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Jucu de Jos hc.",
				"leavesAt": "06:04",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 1820
			},
			{
				"from": "Jucu de Jos hc.",
				"to": "Răscruci h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 2680
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "06:37",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Nima h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "06:58",
				"arrivesAt": "07:07",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dej Călători",
				"to": "Căşeiu Hm.",
				"leavesAt": "07:09",
				"arrivesAt": "07:18",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Căşeiu Hm.",
				"to": "Coplean h.",
				"leavesAt": "07:19",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coplean h.",
				"to": "Câţcău h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:27",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Câţcău h.",
				"to": "Căpâlna pe Someş h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:33",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Căpâlna pe Someş h.",
				"to": "Gâlgău",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Gâlgău",
				"to": "Gâlgău h.",
				"leavesAt": "07:41",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Gâlgău h.",
				"to": "Glodu Someşului h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Glodu Someşului h.",
				"to": "Rus h.",
				"leavesAt": "07:51",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Rus h.",
				"to": "Ileanda",
				"leavesAt": "07:57",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Ileanda",
				"to": "Bizuşa h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Bizuşa h.",
				"to": "Răstoci Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Răstoci Hm.",
				"to": "Letca Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Letca Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Ciocmani h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciocmani h.",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Var h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Var h.",
				"to": "Jibou",
				"leavesAt": "09:01",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 2800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3084",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "15:20",
				"arrivesAt": "15:30",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "15:36",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "15:43",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "15:58",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "16:07",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:31",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "16:32",
				"arrivesAt": "16:40",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "16:41",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "16:57",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "17:15",
				"arrivesAt": "17:19",
				"waitsAtSource": 840,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "17:44",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 13100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1662",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "14:02",
				"arrivesAt": "14:08",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "14:09",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "14:32",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "14:55",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "15:15",
				"arrivesAt": "15:29",
				"waitsAtSource": 120,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "15:30",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "16:04",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 48600
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Mărăşeşti",
				"leavesAt": "16:48",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 17800
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "17:27",
				"arrivesAt": "17:48",
				"waitsAtSource": 900,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "17:49",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "18:27",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "19:00",
				"arrivesAt": "19:32",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "19:33",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "20:11",
				"arrivesAt": "21:02",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2491",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Sântimbru h.",
				"leavesAt": "04:12",
				"arrivesAt": "04:29",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Sântimbru h.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "04:30",
				"arrivesAt": "04:41",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "04:42",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "04:55",
				"arrivesAt": "05:07",
				"waitsAtSource": 240,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "05:08",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Tărtăria h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tărtăria h.",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Şibot",
				"leavesAt": "05:31",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şibot",
				"to": "Vinerea h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Vinerea h.",
				"to": "Cugir hc.",
				"leavesAt": "05:52",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Cugir hc.",
				"to": "Cugir  Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:07",
				"waitsAtSource": 30,
				"distance": 600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1811",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "03:38",
				"arrivesAt": "04:43",
				"waitsAtSource": 0,
				"distance": 52800
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Sebeş Alba",
				"leavesAt": "04:49",
				"arrivesAt": "05:18",
				"waitsAtSource": 360,
				"distance": 20900
			},
			{
				"from": "Sebeş Alba",
				"to": "Vinţu de Jos",
				"leavesAt": "05:19",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vinţu de Jos",
				"to": "Şibot",
				"leavesAt": "05:30",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Şibot",
				"to": "Aurel Vlaicu",
				"leavesAt": "05:53",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Orăştie",
				"leavesAt": "06:02",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Orăştie",
				"to": "Pricaz h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pricaz h.",
				"to": "Turdaş Hm.",
				"leavesAt": "06:16",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Turdaş Hm.",
				"to": "Simeria",
				"leavesAt": "06:25",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "06:39",
				"arrivesAt": "06:49",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Mintia h.",
				"leavesAt": "06:51",
				"arrivesAt": "07:02",
				"waitsAtSource": 120,
				"distance": 8500
			},
			{
				"from": "Mintia h.",
				"to": "Ilia",
				"leavesAt": "07:03",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Ilia",
				"to": "Dobra Hm.",
				"leavesAt": "07:25",
				"arrivesAt": "07:36",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Dobra Hm.",
				"to": "Holdea Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Holdea Hm.",
				"to": "Margina",
				"leavesAt": "07:56",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Margina",
				"to": "Făget",
				"leavesAt": "08:16",
				"arrivesAt": "08:25",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Făget",
				"to": "Lugoj",
				"leavesAt": "08:27",
				"arrivesAt": "09:11",
				"waitsAtSource": 120,
				"distance": 39700
			},
			{
				"from": "Lugoj",
				"to": "Buziaş",
				"leavesAt": "09:15",
				"arrivesAt": "09:45",
				"waitsAtSource": 240,
				"distance": 27500
			},
			{
				"from": "Buziaş",
				"to": "Timişoara Nord",
				"leavesAt": "09:46",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 36400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6447",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "19:30",
				"arrivesAt": "19:44",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "19:45",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "19:53",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "20:00",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "20:08",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "20:18",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "20:25",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "20:30",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "20:40",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 14700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20180531",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1665",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "16:05",
				"arrivesAt": "16:54",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "16:57",
				"arrivesAt": "17:30",
				"waitsAtSource": 180,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "17:32",
				"arrivesAt": "18:09",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "18:11",
				"arrivesAt": "18:42",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "18:43",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Tecuci",
				"leavesAt": "19:22",
				"arrivesAt": "20:05",
				"waitsAtSource": 120,
				"distance": 36500
			},
			{
				"from": "Tecuci",
				"to": "Bârlad",
				"leavesAt": "20:17",
				"arrivesAt": "21:00",
				"waitsAtSource": 720,
				"distance": 50300
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "21:02",
				"arrivesAt": "21:31",
				"waitsAtSource": 120,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "21:32",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "21:47",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "22:06",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "22:33",
				"arrivesAt": "22:48",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "22:49",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5461",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "05:11",
				"arrivesAt": "05:20",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "05:21",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Racova h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Racova h.",
				"to": "Buhuşi",
				"leavesAt": "05:42",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Buhuşi",
				"to": "Costişa h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:06",
				"waitsAtSource": 600,
				"distance": 6300
			},
			{
				"from": "Costişa h.",
				"to": "Podoleni Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Podoleni Hm.",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Roznov",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Roznov",
				"to": "Săvineşti h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Săvineşti h.",
				"to": "Dumbrava h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Piatra Neamţ",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1789",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "16:30",
				"arrivesAt": "17:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "17:35",
				"arrivesAt": "17:54",
				"waitsAtSource": 300,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "17:55",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "18:23",
				"arrivesAt": "18:34",
				"waitsAtSource": 300,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4365",
		"segments": [
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "07:32",
				"arrivesAt": "07:49",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "08:02",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180114",
				"daysOfWeek": 383
			},
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180124",
				"to": "20180124",
				"daysOfWeek": 383
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180331",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180410",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181202",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171227",
				"to": "20171230",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9504",
		"segments": [
			{
				"from": "Orşova",
				"to": "Şantier Naval h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:17",
				"waitsAtSource": 0,
				"distance": 1300
			},
			{
				"from": "Şantier Naval h.",
				"to": "Iloviţa h.",
				"leavesAt": "07:18",
				"arrivesAt": "07:23",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iloviţa h.",
				"to": "Vârciorova Hm.",
				"leavesAt": "07:24",
				"arrivesAt": "07:31",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Vârciorova Hm.",
				"to": "Jidoştiţa h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Jidoştiţa h.",
				"to": "Gura Văii Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Gura Văii Hm.",
				"to": "Dinamica h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dinamica h.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "07:50",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Ergheviţa h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ergheviţa h.",
				"to": "Valea Albă Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Balota",
				"leavesAt": "08:25",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Balota",
				"to": "Gârniţa Hm.",
				"leavesAt": "08:38",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Prunişor Hm.",
				"to": "Igiroasa Hm.",
				"leavesAt": "08:50",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Tâmna",
				"leavesAt": "08:57",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Tâmna",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Strehaia hc.",
				"leavesAt": "09:14",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strehaia hc.",
				"to": "Strehaia",
				"leavesAt": "09:20",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia",
				"to": "Lunca Banului h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Lunca Banului h.",
				"to": "Butoieşti Hm.",
				"leavesAt": "09:33",
				"arrivesAt": "09:40",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Gura Motrului Hm.",
				"leavesAt": "09:41",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Filiaşi",
				"leavesAt": "09:48",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4517",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:14",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "12:15",
				"arrivesAt": "12:21",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "12:33",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "12:38",
				"arrivesAt": "12:44",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "12:51",
				"arrivesAt": "13:00",
				"waitsAtSource": 420,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Arcuş h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:08",
				"waitsAtSource": 240,
				"distance": 5000
			},
			{
				"from": "Arcuş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Bodoc Hm.",
				"to": "Malnaş h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Malnaş h.",
				"to": "Malnaş Băi",
				"leavesAt": "13:23",
				"arrivesAt": "13:29",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş Băi",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "13:30",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "13:49",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Vrabia h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Vrabia h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:07",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "14:12",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "14:17",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "14:28",
				"arrivesAt": "14:36",
				"waitsAtSource": 180,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1836",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Apahida",
				"leavesAt": "07:00",
				"arrivesAt": "07:17",
				"waitsAtSource": 0,
				"distance": 12300
			},
			{
				"from": "Apahida",
				"to": "Câmpia Turzii",
				"leavesAt": "07:18",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 39200
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "08:11",
				"arrivesAt": "08:27",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "08:29",
				"arrivesAt": "08:34",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "08:52",
				"arrivesAt": "09:06",
				"waitsAtSource": 120,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Alba Iulia",
				"leavesAt": "09:12",
				"arrivesAt": "09:47",
				"waitsAtSource": 360,
				"distance": 19100
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "09:51",
				"arrivesAt": "10:03",
				"waitsAtSource": 240,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Şibot",
				"leavesAt": "10:05",
				"arrivesAt": "10:27",
				"waitsAtSource": 120,
				"distance": 15000
			},
			{
				"from": "Şibot",
				"to": "Orăştie",
				"leavesAt": "10:28",
				"arrivesAt": "10:43",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Orăştie",
				"to": "Simeria",
				"leavesAt": "10:44",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 16500
			},
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "11:28",
				"arrivesAt": "11:34",
				"waitsAtSource": 1260,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Călan Băi",
				"leavesAt": "11:35",
				"arrivesAt": "11:44",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "11:45",
				"arrivesAt": "11:49",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Subcetate",
				"leavesAt": "11:50",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Subcetate",
				"to": "Pui",
				"leavesAt": "12:07",
				"arrivesAt": "12:23",
				"waitsAtSource": 120,
				"distance": 14300
			},
			{
				"from": "Pui",
				"to": "Băniţa",
				"leavesAt": "12:24",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 24200
			},
			{
				"from": "Băniţa",
				"to": "Petroşani",
				"leavesAt": "13:09",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Petroşani",
				"to": "Livezeni",
				"leavesAt": "13:30",
				"arrivesAt": "13:38",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Livezeni",
				"to": "Valea Sadului Hm.",
				"leavesAt": "13:39",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 26500
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "14:20",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Târgu Jiu",
				"to": "Cărbuneşti",
				"leavesAt": "15:05",
				"arrivesAt": "15:33",
				"waitsAtSource": 1380,
				"distance": 23800
			},
			{
				"from": "Cărbuneşti",
				"to": "Musculeşti",
				"leavesAt": "15:34",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "15:57",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Filiaşi",
				"leavesAt": "16:07",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "16:26",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 900,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "17:14",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Radomiru hc.",
				"leavesAt": "17:27",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 21300
			},
			{
				"from": "Radomiru hc.",
				"to": "Caracal",
				"leavesAt": "17:44",
				"arrivesAt": "18:00",
				"waitsAtSource": 30,
				"distance": 18800
			},
			{
				"from": "Caracal",
				"to": "Stoeneşti h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:10",
				"waitsAtSource": 120,
				"distance": 11100
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "18:11",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Radomireşti Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "18:30",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 25600
			},
			{
				"from": "Roşiori Nord",
				"to": "Vârtoapele hc.",
				"leavesAt": "18:55",
				"arrivesAt": "19:14",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "19:15",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Videle",
				"leavesAt": "19:35",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 15800
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "19:50",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "20:17",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 25500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5564",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "12:54",
				"arrivesAt": "12:59",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "13:00",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "13:10",
				"arrivesAt": "13:18",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Bursuceni h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:30",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Bursuceni h.",
				"to": "Bucecea Hm",
				"leavesAt": "13:31",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "13:49",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "14:09",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4048",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:41",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "19:48",
				"arrivesAt": "19:54",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "19:55",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Ţicău h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:13",
				"waitsAtSource": 600,
				"distance": 2200
			},
			{
				"from": "Ţicău h.",
				"to": "Benesat Hm.",
				"leavesAt": "20:14",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Benesat Hm.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Inău h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Inău h.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:35",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "20:36",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9163",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Valea Păltinişului h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:20",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "07:21",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Valeadeni h.",
				"leavesAt": "07:29",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valeadeni h.",
				"to": "Brebu",
				"leavesAt": "07:36",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:58",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "07:59",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4106",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "19:35",
				"arrivesAt": "19:45",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:21",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "20:29",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "20:41",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Buneşti h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Buneşti h.",
				"to": "Nima h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "21:05",
				"arrivesAt": "21:14",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "21:26",
				"arrivesAt": "21:33",
				"waitsAtSource": 720,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "21:34",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Reteag Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:45",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "21:46",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:54",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "21:55",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "22:00",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "22:19",
				"arrivesAt": "22:27",
				"waitsAtSource": 600,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "22:28",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "22:33",
				"arrivesAt": "22:36",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "22:37",
				"arrivesAt": "22:43",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "22:44",
				"arrivesAt": "22:46",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "22:47",
				"arrivesAt": "22:54",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "22:55",
				"arrivesAt": "23:00",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "23:01",
				"arrivesAt": "23:04",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "23:05",
				"arrivesAt": "23:09",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "23:10",
				"arrivesAt": "23:13",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9572",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "08:34",
				"arrivesAt": "08:40",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Ghiroda h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghiroda h.",
				"to": "Remetea Mare",
				"leavesAt": "08:47",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "09:05",
				"arrivesAt": "09:08",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "09:09",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "09:15",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "09:26",
				"arrivesAt": "09:32",
				"waitsAtSource": 480,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "09:33",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Jabăr Hm.",
				"leavesAt": "09:38",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Lugoj",
				"leavesAt": "09:44",
				"arrivesAt": "09:50",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lugoj",
				"to": "Tapia Hm.",
				"leavesAt": "09:51",
				"arrivesAt": "09:57",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Tapia Hm.",
				"to": "Găvojdia",
				"leavesAt": "09:58",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Găvojdia",
				"to": "Jena Hm.",
				"leavesAt": "10:03",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Jena Hm.",
				"to": "Sacu h.",
				"leavesAt": "10:14",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sacu h.",
				"to": "Căvăran",
				"leavesAt": "10:18",
				"arrivesAt": "10:21",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Căvăran",
				"to": "Zăgujeni Hm.",
				"leavesAt": "10:22",
				"arrivesAt": "10:32",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Tibiscu h.",
				"leavesAt": "10:33",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tibiscu h.",
				"to": "Caransebeş",
				"leavesAt": "10:37",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 375
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1688",
		"segments": [
			{
				"from": "Tulcea Oraş",
				"to": "Tulcea Mărfuri",
				"leavesAt": "13:10",
				"arrivesAt": "13:19",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Cataloi Hm.",
				"leavesAt": "13:20",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Cataloi Hm.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "13:36",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Zebil h.",
				"leavesAt": "13:49",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Zebil h.",
				"to": "Babadag",
				"leavesAt": "14:03",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Babadag",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "14:19",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Baia Dobrogea",
				"leavesAt": "14:36",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baia Dobrogea",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Cogealac",
				"leavesAt": "14:56",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 17400
			},
			{
				"from": "Cogealac",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "15:36",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Nicolae Bălcescu",
				"leavesAt": "15:47",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Medgidia",
				"leavesAt": "15:54",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "16:33",
				"arrivesAt": "16:52",
				"waitsAtSource": 1260,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "16:53",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "17:15",
				"arrivesAt": "17:42",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Lehliu",
				"leavesAt": "17:43",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Lehliu",
				"to": "Bucureşti Nord",
				"leavesAt": "18:07",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 69600
			}
		],
		"restrictions": [
			{
				"from": "20180105",
				"to": "20180107",
				"daysOfWeek": 383
			},
			{
				"from": "20180112",
				"to": "20180114",
				"daysOfWeek": 383
			},
			{
				"from": "20180119",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180126",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180202",
				"to": "20180204",
				"daysOfWeek": 383
			},
			{
				"from": "20180209",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180216",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180223",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180302",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180309",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180316",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180323",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180330",
				"to": "20180401",
				"daysOfWeek": 383
			},
			{
				"from": "20180406",
				"to": "20180408",
				"daysOfWeek": 383
			},
			{
				"from": "20180413",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180420",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180427",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180504",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180511",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180518",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180527",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180608",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180914",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180921",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180928",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181005",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181012",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181019",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181026",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181102",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181109",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181116",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181123",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181207",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171215",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171222",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171229",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1984",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun hc.",
				"leavesAt": "17:41",
				"arrivesAt": "17:51",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "17:54",
				"arrivesAt": "18:07",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "18:16",
				"arrivesAt": "18:31",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "18:34",
				"arrivesAt": "18:41",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "18:44",
				"arrivesAt": "19:07",
				"waitsAtSource": 180,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "19:30",
				"arrivesAt": "19:54",
				"waitsAtSource": 1380,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Feteşti",
				"leavesAt": "19:55",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 44000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "20:31",
				"arrivesAt": "20:54",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "20:55",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 108900
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2068",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:45",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "07:49",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Mohu h.",
				"leavesAt": "07:53",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "08:02",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "08:12",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Valea Fratelui h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Râu Vadului h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "08:52",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Balota h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:13",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Balota h.",
				"to": "Cornet Hm.",
				"leavesAt": "09:14",
				"arrivesAt": "09:19",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cornet Hm.",
				"to": "Beţel h.",
				"leavesAt": "09:20",
				"arrivesAt": "09:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Beţel h.",
				"to": "Lotru",
				"leavesAt": "09:25",
				"arrivesAt": "09:34",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "09:35",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "09:52",
				"arrivesAt": "09:57",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "09:59",
				"arrivesAt": "10:04",
				"waitsAtSource": 120,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "10:06",
				"arrivesAt": "10:13",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "10:14",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "10:24",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "10:30",
				"arrivesAt": "10:32",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4537",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Azomureş h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:21",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "19:22",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "19:26",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Vidrasău h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vidrasău h.",
				"to": "Chirileu h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Chirileu h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Ogra h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ogra h.",
				"to": "Cipău h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cipău h.",
				"to": "Iernut",
				"leavesAt": "19:57",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iernut",
				"to": "Cuci h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cuci h.",
				"to": "Bogata Mureş h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:15",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Luduş",
				"leavesAt": "20:16",
				"arrivesAt": "20:20",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Luduş",
				"to": "Cheţani h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Cheţani h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "20:29",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Gura Arieşului h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Lunca Mureşului h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Războieni",
				"leavesAt": "20:44",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8389",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "16:34",
				"arrivesAt": "16:47",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "16:48",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "16:57",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "17:10",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "17:18",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "17:22",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "17:36",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1061",
		"segments": [
			{
				"from": "Ungheni",
				"to": "Ungheni Prut Fr.",
				"leavesAt": "07:06",
				"arrivesAt": "07:10",
				"waitsAtSource": 0,
				"distance": 800
			},
			{
				"from": "Ungheni Prut Fr.",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "07:13",
				"arrivesAt": "07:15",
				"waitsAtSource": 180,
				"distance": 600
			},
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "08:04",
				"arrivesAt": "08:12",
				"waitsAtSource": 2940,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "08:13",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Socola",
				"leavesAt": "08:20",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "08:38",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "362",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "06:44",
				"arrivesAt": "07:12",
				"waitsAtSource": 0,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "07:13",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Bratca",
				"leavesAt": "08:02",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Aleşd",
				"leavesAt": "08:33",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Aleşd",
				"to": "Oradea",
				"leavesAt": "08:53",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 34300
			},
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "09:26",
				"arrivesAt": "09:34",
				"waitsAtSource": 180,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharkeresztes",
				"leavesAt": "09:49",
				"arrivesAt": "10:04",
				"waitsAtSource": 900,
				"distance": 12500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1584",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "14:00",
				"arrivesAt": "14:24",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "14:25",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "14:43",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "15:04",
				"arrivesAt": "15:27",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "15:28",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 108900
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2307",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "19:54",
				"arrivesAt": "20:02",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "20:20",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "20:28",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "20:45",
				"arrivesAt": "20:57",
				"waitsAtSource": 480,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:18",
				"waitsAtSource": 780,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Tărtăria h.",
				"leavesAt": "21:19",
				"arrivesAt": "21:25",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tărtăria h.",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "21:26",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Şibot",
				"leavesAt": "21:33",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şibot",
				"to": "Aurel Vlaicu",
				"leavesAt": "21:40",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Geoagiu h.",
				"leavesAt": "21:53",
				"arrivesAt": "21:56",
				"waitsAtSource": 300,
				"distance": 2400
			},
			{
				"from": "Geoagiu h.",
				"to": "Orăştie",
				"leavesAt": "21:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Orăştie",
				"to": "Pricaz h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pricaz h.",
				"to": "Turdaş Hm.",
				"leavesAt": "22:10",
				"arrivesAt": "22:18",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Turdaş Hm.",
				"to": "Simeria Veche h.",
				"leavesAt": "22:19",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Simeria Veche h.",
				"to": "Simeria",
				"leavesAt": "22:25",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5442",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "05:00",
				"arrivesAt": "05:05",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "05:06",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "05:16",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 660,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "05:55",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "06:21",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Paşcani Triaj",
				"leavesAt": "06:28",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Paşcani Triaj",
				"to": "Stolniceni h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "06:45",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "06:50",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "06:56",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "07:08",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "07:18",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "07:31",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "07:52",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2183",
		"segments": [
			{
				"from": "Margina",
				"to": "Făget",
				"leavesAt": "12:08",
				"arrivesAt": "12:16",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Făget",
				"to": "Răchita h.",
				"leavesAt": "12:17",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răchita h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "12:24",
				"arrivesAt": "12:29",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Traian Vuia h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Susani Bega h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Susani Bega h.",
				"to": "Cliciova",
				"leavesAt": "12:41",
				"arrivesAt": "12:47",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cliciova",
				"to": "Nevrincea h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:54",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Nevrincea h.",
				"to": "Balinţ h.",
				"leavesAt": "12:55",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Balinţ h.",
				"to": "Păru h.",
				"leavesAt": "13:01",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Păru h.",
				"to": "Coşteiu Mare Hm.",
				"leavesAt": "13:07",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Coşteiu Mare Hm.",
				"to": "Lugoj Nord h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Lugoj Nord h.",
				"to": "Lugoj",
				"leavesAt": "13:20",
				"arrivesAt": "13:30",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4092",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:41",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "15:48",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "15:55",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Ţicău h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ţicău h.",
				"to": "Benesat Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Benesat Hm.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Inău h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Inău h.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "16:26",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1630",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "04:55",
				"arrivesAt": "05:30",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "05:31",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "05:40",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "05:46",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "05:56",
				"arrivesAt": "06:10",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Breaza hc.",
				"leavesAt": "06:11",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "06:25",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Ploieşti Vest",
				"leavesAt": "06:36",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 18600
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "06:53",
				"arrivesAt": "07:36",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2063",
		"segments": [
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:28",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "15:29",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "15:44",
				"arrivesAt": "15:47",
				"waitsAtSource": 420,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "15:49",
				"arrivesAt": "15:56",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "15:57",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:03",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "16:04",
				"arrivesAt": "16:06",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:10",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "16:11",
				"arrivesAt": "16:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "16:17",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "16:23",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Cozia Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cozia Hm.",
				"to": "Lotru",
				"leavesAt": "16:48",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lotru",
				"to": "Beţel h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Beţel h.",
				"to": "Cornet Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cornet Hm.",
				"to": "Balota h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Balota h.",
				"to": "Robeşti h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Robeşti h.",
				"to": "Câineni",
				"leavesAt": "17:21",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Râu Vadului h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Râu Vadului h.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:55",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "17:56",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "18:30",
				"arrivesAt": "18:33",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "18:34",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "18:48",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2215",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "23:50",
				"arrivesAt": "00:00",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "00:01",
				"arrivesAt": "00:10",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1986",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "06:59",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "07:13",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "07:18",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "07:50",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "07:58",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "08:30",
				"arrivesAt": "08:54",
				"waitsAtSource": 1260,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "08:55",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "09:13",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "09:34",
				"arrivesAt": "09:57",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "09:58",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 108900
			}
		],
		"restrictions": [
			{
				"from": "20180428",
				"to": "20180502",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1555",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "19:22",
				"arrivesAt": "19:32",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "19:33",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Crivina",
				"leavesAt": "19:40",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "19:55",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Ploieşti Triaj",
				"leavesAt": "20:00",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 12100
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Ploieşti Sud",
				"leavesAt": "20:18",
				"arrivesAt": "20:25",
				"waitsAtSource": 240,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4302",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "07:35",
				"arrivesAt": "07:45",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "07:51",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "07:59",
				"arrivesAt": "08:03",
				"waitsAtSource": 120,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "08:42",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Buneşti h.",
				"leavesAt": "08:53",
				"arrivesAt": "09:01",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Buneşti h.",
				"to": "Nima h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "09:06",
				"arrivesAt": "09:15",
				"waitsAtSource": 30,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9307",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:18",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h.(900)",
				"leavesAt": "20:19",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureştii Noi",
				"leavesAt": "20:23",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "20:28",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "20:37",
				"arrivesAt": "20:47",
				"waitsAtSource": 300,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "20:48",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Zorile h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Zorile h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "21:04",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Zăvestreni Hm.",
				"leavesAt": "21:18",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Videle",
				"leavesAt": "21:24",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "21:32",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "21:50",
				"arrivesAt": "21:56",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "21:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "22:11",
				"arrivesAt": "22:21",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "22:22",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8653",
		"segments": [
			{
				"from": "Medgidia",
				"to": "Nicolae Bălcescu",
				"leavesAt": "09:05",
				"arrivesAt": "09:23",
				"waitsAtSource": 0,
				"distance": 19100
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "09:24",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Cogealac",
				"leavesAt": "09:41",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cogealac",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "10:02",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 17400
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Baia Dobrogea",
				"leavesAt": "10:21",
				"arrivesAt": "10:32",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Baia Dobrogea",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "10:33",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Babadag",
				"leavesAt": "10:40",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Babadag",
				"to": "Zebil h.",
				"leavesAt": "10:58",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Zebil h.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Cataloi Hm.",
				"leavesAt": "11:30",
				"arrivesAt": "11:44",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Cataloi Hm.",
				"to": "Tulcea Mărfuri",
				"leavesAt": "11:45",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Tulcea Oraş",
				"leavesAt": "12:01",
				"arrivesAt": "12:10",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180101",
				"to": "20180104",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180111",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180118",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180125",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180201",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180208",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180215",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180222",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180301",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180308",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180315",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180322",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180329",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180405",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180412",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180419",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180426",
				"daysOfWeek": 383
			},
			{
				"from": "20180430",
				"to": "20180503",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180510",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180517",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20180531",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180607",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180913",
				"daysOfWeek": 383
			},
			{
				"from": "20180917",
				"to": "20180920",
				"daysOfWeek": 383
			},
			{
				"from": "20180924",
				"to": "20180927",
				"daysOfWeek": 383
			},
			{
				"from": "20181001",
				"to": "20181004",
				"daysOfWeek": 383
			},
			{
				"from": "20181008",
				"to": "20181011",
				"daysOfWeek": 383
			},
			{
				"from": "20181015",
				"to": "20181018",
				"daysOfWeek": 383
			},
			{
				"from": "20181022",
				"to": "20181025",
				"daysOfWeek": 383
			},
			{
				"from": "20181029",
				"to": "20181101",
				"daysOfWeek": 383
			},
			{
				"from": "20181105",
				"to": "20181108",
				"daysOfWeek": 383
			},
			{
				"from": "20181112",
				"to": "20181115",
				"daysOfWeek": 383
			},
			{
				"from": "20181119",
				"to": "20181122",
				"daysOfWeek": 383
			},
			{
				"from": "20181126",
				"to": "20181129",
				"daysOfWeek": 383
			},
			{
				"from": "20181203",
				"to": "20181206",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171214",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171221",
				"daysOfWeek": 383
			},
			{
				"from": "20171225",
				"to": "20171228",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9026",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Km. 107+000 h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Km. 107+000 h.",
				"to": "Ram. Goleşti",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ram. Goleşti",
				"to": "Goleşti",
				"leavesAt": "06:50",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Goleşti",
				"to": "Canton 97+770 h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:03",
				"waitsAtSource": 120,
				"distance": 2600
			},
			{
				"from": "Canton 97+770 h.",
				"to": "Călineşti Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Călineşti Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "07:11",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Pătroaia Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Găeşti",
				"leavesAt": "07:28",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Găeşti",
				"to": "Găeşti Sud h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 600,
				"distance": 4000
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Cojocaru h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Cojocaru h.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Fusea Hm.",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Fusea Hm.",
				"to": "Titu",
				"leavesAt": "08:09",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "08:51",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "09:00",
				"arrivesAt": "09:06",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "09:07",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "09:12",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 384
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5208",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "16:10",
				"arrivesAt": "16:18",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Mihăileni Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:30",
				"waitsAtSource": 360,
				"distance": 6200
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Caracău h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Caracău h.",
				"to": "Livezi Ciuc",
				"leavesAt": "16:48",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Utuşoiu h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:01",
				"waitsAtSource": 180,
				"distance": 4100
			},
			{
				"from": "Utuşoiu h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Tarcău h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Bolovăniş h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Ghimeş",
				"leavesAt": "17:25",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Ghimeş",
				"to": "Palanca Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 840,
				"distance": 5200
			},
			{
				"from": "Palanca Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "17:50",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Simbrea Hm.",
				"leavesAt": "17:55",
				"arrivesAt": "17:59",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Simbrea Hm.",
				"to": "Goioasa Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Goioasa Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Caraliţa h.",
				"to": "Asău Hm.",
				"leavesAt": "18:13",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Asău Hm.",
				"to": "Comăneşti",
				"leavesAt": "18:19",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "18:41",
				"arrivesAt": "18:46",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "18:47",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "18:53",
				"arrivesAt": "18:58",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "18:59",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "19:03",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Oneşti",
				"leavesAt": "19:07",
				"arrivesAt": "19:19",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "19:30",
				"arrivesAt": "19:35",
				"waitsAtSource": 660,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "19:36",
				"arrivesAt": "19:45",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "19:46",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "19:55",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "20:12",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "20:24",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "20:37",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "20:49",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Mărăşeşti",
				"to": "Tecuci",
				"leavesAt": "21:01",
				"arrivesAt": "21:22",
				"waitsAtSource": 120,
				"distance": 19000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2141",
		"segments": [
			{
				"from": "Simeria",
				"to": "Bârcea Mare h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:42",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Bârcea Mare h.",
				"to": "Bârcea Mică",
				"leavesAt": "04:43",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Bârcea Mică",
				"to": "Pestişu Mare h.",
				"leavesAt": "04:47",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Pestişu Mare h.",
				"to": "Hunedoara",
				"leavesAt": "04:52",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9557",
		"segments": [
			{
				"from": "Orşova",
				"to": "Valea Cernei Hm.",
				"leavesAt": "16:11",
				"arrivesAt": "16:17",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Valea Cernei Hm.",
				"to": "Topleţ Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Topleţ Hm.",
				"to": "Băile Herculane",
				"leavesAt": "16:24",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Herculane",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:43",
				"waitsAtSource": 420,
				"distance": 1900
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Mehadia Hm.",
				"leavesAt": "16:49",
				"arrivesAt": "16:52",
				"waitsAtSource": 360,
				"distance": 2400
			},
			{
				"from": "Mehadia Hm.",
				"to": "Iablaniţa",
				"leavesAt": "16:53",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Iablaniţa",
				"to": "Cruşovăţ",
				"leavesAt": "17:04",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cruşovăţ",
				"to": "Cornea h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cornea h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 2160,
				"distance": 3000
			},
			{
				"from": "Luncaviţa h.",
				"to": "Poarta Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Poarta Hm.",
				"to": "Teregova Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Teregova Hm.",
				"to": "Armeniş",
				"leavesAt": "18:22",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Armeniş",
				"to": "Slatina Timiş",
				"leavesAt": "18:30",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Slatina Timiş",
				"to": "Vălişoara Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Petroşniţa h.",
				"to": "Valea Timişului Hm.",
				"leavesAt": "18:49",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Balta Sărată",
				"leavesAt": "18:53",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Balta Sărată",
				"to": "Caransebeş haltă h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Caransebeş",
				"leavesAt": "19:03",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1748",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "16:02",
				"arrivesAt": "17:10",
				"waitsAtSource": 0,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "17:12",
				"arrivesAt": "17:29",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Luduş",
				"leavesAt": "17:47",
				"arrivesAt": "18:05",
				"waitsAtSource": 1080,
				"distance": 19200
			},
			{
				"from": "Luduş",
				"to": "Iernut",
				"leavesAt": "18:06",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Iernut",
				"to": "Târgu Mureş",
				"leavesAt": "18:21",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 28600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4586",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:59",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "19:05",
				"arrivesAt": "19:11",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "19:17",
				"arrivesAt": "19:21",
				"waitsAtSource": 360,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "19:22",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1632",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "08:40",
				"arrivesAt": "09:15",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Buşteni",
				"leavesAt": "09:17",
				"arrivesAt": "09:29",
				"waitsAtSource": 120,
				"distance": 11400
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "09:30",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "09:40",
				"arrivesAt": "10:03",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "10:04",
				"arrivesAt": "10:25",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "10:26",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5738",
		"segments": [
			{
				"from": "Cacica Hm.",
				"to": "Pârteşti h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:59",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Pârteşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Soloneţ h.",
				"to": "Todireşti h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Todireşti h.",
				"to": "Părhăuţi h.",
				"leavesAt": "21:15",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Părhăuţi h.",
				"to": "Dărmăneşti",
				"leavesAt": "21:24",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "21:33",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "21:41",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9372",
		"segments": [
			{
				"from": "Zimnicea",
				"to": "Ulmuleţ h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:07",
				"waitsAtSource": 0,
				"distance": 9800
			},
			{
				"from": "Ulmuleţ h.",
				"to": "Şoimu h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:18",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Şoimu h.",
				"to": "Păuleasa h.",
				"leavesAt": "07:19",
				"arrivesAt": "07:24",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Păuleasa h.",
				"to": "Smârdioasa h.",
				"leavesAt": "07:25",
				"arrivesAt": "07:30",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Smârdioasa h.",
				"to": "Brânceni h.",
				"leavesAt": "07:31",
				"arrivesAt": "07:36",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brânceni h.",
				"to": "Ţigăneşti h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Ţigăneşti h.",
				"to": "Alexandria",
				"leavesAt": "07:41",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:17",
				"waitsAtSource": 1200,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "08:29",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "08:50",
				"arrivesAt": "08:56",
				"waitsAtSource": 540,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "09:12",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4507",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "12:00",
				"arrivesAt": "12:08",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "12:13",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "12:26",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "12:34",
				"arrivesAt": "12:38",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "12:39",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "12:44",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "12:54",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Şugău h.",
				"leavesAt": "13:13",
				"arrivesAt": "13:17",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Şugău h.",
				"to": "Valea Strâmbă h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:21",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Gheorgheni",
				"leavesAt": "13:22",
				"arrivesAt": "13:26",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Gheorgheni",
				"to": "Lăzarea Hm.",
				"leavesAt": "13:31",
				"arrivesAt": "13:36",
				"waitsAtSource": 300,
				"distance": 4400
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Ditrău",
				"leavesAt": "13:37",
				"arrivesAt": "13:43",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ditrău",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "13:44",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "13:53",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "14:00",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Topliţa",
				"leavesAt": "14:08",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Topliţa",
				"to": "Ciobotani h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:37",
				"waitsAtSource": 660,
				"distance": 6600
			},
			{
				"from": "Ciobotani h.",
				"to": "Stânceni Hm.",
				"leavesAt": "14:38",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Stânceni Hm.",
				"to": "Stânceni h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "14:59",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Andreneasa h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:26",
				"waitsAtSource": 420,
				"distance": 7000
			},
			{
				"from": "Andreneasa h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "15:27",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Borzia h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Borzia h.",
				"to": "Deda Bistra Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Deda",
				"leavesAt": "15:47",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:44",
				"waitsAtSource": 2460,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "16:45",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:01",
				"waitsAtSource": 360,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "17:14",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "17:34",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "17:48",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "17:55",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "18:09",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2038",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "05:23",
				"arrivesAt": "05:32",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "05:38",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "05:51",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "06:00",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "06:09",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "06:34",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "06:59",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "07:19",
				"arrivesAt": "07:23",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "07:24",
				"arrivesAt": "07:31",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "07:32",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "07:57",
				"arrivesAt": "08:05",
				"waitsAtSource": 660,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "08:30",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "08:40",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "08:58",
				"arrivesAt": "09:06",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Tărtăria h.",
				"leavesAt": "09:07",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tărtăria h.",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:19",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Şibot",
				"leavesAt": "09:20",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şibot",
				"to": "Aurel Vlaicu",
				"leavesAt": "09:27",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Geoagiu h.",
				"leavesAt": "09:35",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Geoagiu h.",
				"to": "Orăştie",
				"leavesAt": "09:38",
				"arrivesAt": "09:44",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Orăştie",
				"to": "Pricaz h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pricaz h.",
				"to": "Turdaş Hm.",
				"leavesAt": "09:50",
				"arrivesAt": "09:58",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Turdaş Hm.",
				"to": "Simeria",
				"leavesAt": "09:59",
				"arrivesAt": "10:11",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "10:14",
				"arrivesAt": "10:18",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "10:19",
				"arrivesAt": "10:27",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5736",
		"segments": [
			{
				"from": "Cacica Hm.",
				"to": "Pârteşti h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:08",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Pârteşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Soloneţ h.",
				"to": "Todireşti h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Todireşti h.",
				"to": "Părhăuţi h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Părhăuţi h.",
				"to": "Dărmăneşti",
				"leavesAt": "17:33",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "17:50",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5072",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "04:30",
				"arrivesAt": "04:40",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "04:41",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "04:47",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "05:02",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "05:10",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "05:23",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "05:29",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "05:44",
				"arrivesAt": "05:51",
				"waitsAtSource": 360,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "05:52",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 1200,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Brazi",
				"leavesAt": "06:28",
				"arrivesAt": "06:36",
				"waitsAtSource": 240,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9486",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(901)",
				"leavesAt": "16:50",
				"arrivesAt": "16:53",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Plaiu Vulcăneşti Hm.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plaiu Vulcăneşti Hm.",
				"to": "Cârcea h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cârcea h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Toporaş h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Spineni h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Spineni h.",
				"to": "Balş",
				"leavesAt": "17:33",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balş",
				"to": "Canton 217 h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:53",
				"waitsAtSource": 540,
				"distance": 1800
			},
			{
				"from": "Canton 217 h.",
				"to": "Brăneţ h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Brăneţ h.",
				"to": "Piatra Olt",
				"leavesAt": "18:00",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 7700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2703",
		"segments": [
			{
				"from": "Subcetate",
				"to": "Covragiu h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Covragiu h.",
				"to": "Plopi h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Plopi h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Măceu h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măceu h.",
				"to": "Ruşi h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ruşi h.",
				"to": "Călan Hm.",
				"leavesAt": "06:26",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Călan Hm.",
				"to": "Călan Băi",
				"leavesAt": "06:37",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Batiz h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Batiz h.",
				"to": "Băcia Hm.",
				"leavesAt": "06:45",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Băcia Hm.",
				"to": "Băcia h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia h.",
				"to": "Simeria Triaj",
				"leavesAt": "06:51",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Simeria Triaj",
				"to": "Simeria",
				"leavesAt": "06:55",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 287
			},
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 287
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 287
			},
			{
				"from": "20180411",
				"to": "20180601",
				"daysOfWeek": 287
			},
			{
				"from": "20180604",
				"to": "20180608",
				"daysOfWeek": 287
			},
			{
				"from": "20180611",
				"to": "20180615",
				"daysOfWeek": 287
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 287
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 287
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5636",
		"segments": [
			{
				"from": "Dorneşti",
				"to": "Ţibeni h.",
				"leavesAt": "21:15",
				"arrivesAt": "21:24",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Ţibeni h.",
				"to": "Milişăuţi Hm.",
				"leavesAt": "21:25",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dărmăneşti",
				"leavesAt": "21:34",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "21:46",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "21:58",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3532",
		"segments": [
			{
				"from": "Rupea",
				"to": "Mateiaş h.",
				"leavesAt": "04:59",
				"arrivesAt": "05:13",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Mateiaş h.",
				"to": "Racoş Hm.",
				"leavesAt": "05:14",
				"arrivesAt": "05:20",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "05:21",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Ormeniş h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ormeniş h.",
				"to": "Apaţa",
				"leavesAt": "05:47",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Apaţa",
				"to": "Măieruş h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Măieruş h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Rotbav h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Rotbav h.",
				"to": "Feldioara Hm.",
				"leavesAt": "06:16",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Bod Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Bod Hm.",
				"to": "Stupini Hm.",
				"leavesAt": "06:40",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Stupini Hm.",
				"to": "Braşov",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1720",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "07:12",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "07:13",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "07:20",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Lotru",
				"leavesAt": "07:27",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 42700
			},
			{
				"from": "Lotru",
				"to": "Păuşa h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "08:40",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "08:46",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 16200
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Băbeni",
				"leavesAt": "09:05",
				"arrivesAt": "09:24",
				"waitsAtSource": 120,
				"distance": 19600
			},
			{
				"from": "Băbeni",
				"to": "Fişcălia Hm.",
				"leavesAt": "09:25",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Drăgăşani",
				"leavesAt": "09:45",
				"arrivesAt": "09:57",
				"waitsAtSource": 480,
				"distance": 17200
			},
			{
				"from": "Drăgăşani",
				"to": "Piatra Olt",
				"leavesAt": "09:58",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 33800
			},
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:34",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Balş",
				"leavesAt": "10:35",
				"arrivesAt": "10:40",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Balş",
				"to": "Toporaş h.",
				"leavesAt": "10:41",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Toporaş h.",
				"to": "Bordei hc.(901)",
				"leavesAt": "10:56",
				"arrivesAt": "11:11",
				"waitsAtSource": 30,
				"distance": 15700
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Craiova",
				"leavesAt": "11:12",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9616",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "14:21",
				"arrivesAt": "14:30",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Giroc h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Giroc h.",
				"to": "Urseni h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:40",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Urseni h.",
				"to": "Uliuc h.",
				"leavesAt": "14:41",
				"arrivesAt": "14:46",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Uliuc h.",
				"to": "Sacoşu Mic",
				"leavesAt": "14:47",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Sacoşu Mic",
				"to": "Chevereş h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Chevereş h.",
				"to": "Bacova h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bacova h.",
				"to": "Buziaş",
				"leavesAt": "15:04",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Buziaş",
				"to": "Căpăt h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Căpăt h.",
				"to": "Sinia Hm.",
				"leavesAt": "15:17",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Sinia Hm.",
				"to": "Boldur h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Boldur h.",
				"to": "Lugoj",
				"leavesAt": "15:29",
				"arrivesAt": "15:43",
				"waitsAtSource": 30,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4101",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Viişoara h.",
				"leavesAt": "03:20",
				"arrivesAt": "03:26",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Viişoara h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "03:27",
				"arrivesAt": "03:34",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "03:35",
				"arrivesAt": "03:39",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "03:40",
				"arrivesAt": "03:45",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "03:46",
				"arrivesAt": "03:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "03:52",
				"arrivesAt": "03:55",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "03:56",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "04:01",
				"arrivesAt": "04:10",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "04:12",
				"arrivesAt": "04:22",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "04:23",
				"arrivesAt": "04:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "04:27",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "04:36",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "04:47",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:22",
				"waitsAtSource": 1200,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Buneşti h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Buneşti h.",
				"to": "Gherla",
				"leavesAt": "05:28",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:44",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3120",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Vest Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:22",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "07:23",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Cefa Hm.",
				"leavesAt": "07:35",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cefa Hm.",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Salonta",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2043",
		"segments": [
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "12:20",
				"arrivesAt": "12:25",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "12:26",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "12:36",
				"arrivesAt": "12:45",
				"waitsAtSource": 120,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Veţel h.",
				"leavesAt": "12:46",
				"arrivesAt": "12:50",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "12:51",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "13:02",
				"arrivesAt": "13:09",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "13:10",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "13:18",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "13:26",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "13:32",
				"arrivesAt": "13:44",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "13:45",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "13:50",
				"arrivesAt": "13:57",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "14:02",
				"arrivesAt": "14:09",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Săvârşin",
				"to": "Vărădia h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vărădia h.",
				"to": "Vărădia Hm.",
				"leavesAt": "14:17",
				"arrivesAt": "14:22",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărădia Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "14:28",
				"arrivesAt": "14:35",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Căpruţa h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Căpruţa h.",
				"to": "Bârzava",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bârzava",
				"to": "Conop Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Conop Hm.",
				"to": "Corfeni h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Corfeni h.",
				"to": "Milova",
				"leavesAt": "15:06",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Milova",
				"to": "Radna",
				"leavesAt": "15:13",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Radna",
				"to": "Păuliş Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:38",
				"waitsAtSource": 240,
				"distance": 6900
			},
			{
				"from": "Păuliş Hm.",
				"to": "Păuliş h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş h.",
				"to": "Ghioroc",
				"leavesAt": "15:44",
				"arrivesAt": "15:51",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ghioroc",
				"to": "Glogovăţ",
				"leavesAt": "15:52",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Glogovăţ",
				"to": "Arad",
				"leavesAt": "16:04",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2603",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "08:21",
				"arrivesAt": "08:25",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Ronaţ Triaj h",
				"leavesAt": "08:26",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "08:29",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "08:43",
				"arrivesAt": "08:49",
				"waitsAtSource": 300,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "08:50",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:11",
				"waitsAtSource": 240,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Valea Viilor Hm.",
				"leavesAt": "09:15",
				"arrivesAt": "09:20",
				"waitsAtSource": 240,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Aradu Nou",
				"leavesAt": "09:21",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "09:31",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2101",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "06:06",
				"arrivesAt": "06:12",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "06:21",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "07:10",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "07:20",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:30",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "07:31",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Făgăraş",
				"to": "Beclean pe Olt h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:44",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Beclean pe Olt h.",
				"to": "Dridif h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Dridif h.",
				"to": "Voila Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Voila Hm.",
				"to": "Olteţ h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:07",
				"waitsAtSource": 300,
				"distance": 6100
			},
			{
				"from": "Olteţ h.",
				"to": "Viştea h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Viştea h.",
				"to": "Ucea",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "08:18",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:35",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:39",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:45",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "08:46",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "09:00",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:07",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "09:08",
				"arrivesAt": "09:13",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "09:14",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "09:22",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:35",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "09:36",
				"arrivesAt": "09:43",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "09:44",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "09:48",
				"arrivesAt": "09:52",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2852",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "08:10",
				"arrivesAt": "08:17",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Drăguţeşti h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Vârţ h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 420,
				"distance": 4100
			},
			{
				"from": "Vârţ h.",
				"to": "Rogojelu",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "08:44",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Rovinari Hm.",
				"to": "Rovinari Sud h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "08:54",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Bâlteni h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Bâlteni h.",
				"to": "Peşteana Jiu h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Plopşoru",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Plopşoru",
				"to": "Sărdăneşti h.",
				"leavesAt": "09:19",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Gârbovu h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Gârbovu h.",
				"to": "Turceni",
				"leavesAt": "09:29",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Turceni",
				"to": "Termo Turceni h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 900
			},
			{
				"from": "Termo Turceni h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Filiaşi",
				"leavesAt": "09:49",
				"arrivesAt": "10:04",
				"waitsAtSource": 30,
				"distance": 12400
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "10:06",
				"arrivesAt": "10:09",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "10:10",
				"arrivesAt": "10:14",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "10:15",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "10:20",
				"arrivesAt": "10:25",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "10:26",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "10:30",
				"arrivesAt": "10:35",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "10:36",
				"arrivesAt": "10:38",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "10:39",
				"arrivesAt": "10:43",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "10:44",
				"arrivesAt": "10:47",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "10:48",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180107",
				"to": "20180107",
				"daysOfWeek": 319
			},
			{
				"from": "20180115",
				"to": "20180202",
				"daysOfWeek": 319
			},
			{
				"from": "20180212",
				"to": "20180330",
				"daysOfWeek": 319
			},
			{
				"from": "20180411",
				"to": "20180615",
				"daysOfWeek": 319
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9164",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "13:17",
				"arrivesAt": "13:26",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "13:27",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:41",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "13:42",
				"arrivesAt": "13:54",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "14:04",
				"arrivesAt": "14:15",
				"waitsAtSource": 600,
				"distance": 10500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Valea Păltinişului h.",
				"leavesAt": "14:16",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Caransebeş",
				"leavesAt": "14:24",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8011",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "07:30",
				"arrivesAt": "07:39",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "07:40",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "08:17",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "08:28",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "08:58",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ivăneşti h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ivăneşti h.",
				"to": "Ciulniţa",
				"leavesAt": "09:07",
				"arrivesAt": "09:12",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "09:20",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "09:24",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "09:27",
				"arrivesAt": "09:31",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "09:37",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "09:42",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1639",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "06:31",
				"arrivesAt": "06:50",
				"waitsAtSource": 0,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "06:51",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1863",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "07:59",
				"arrivesAt": "08:05",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "08:06",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "08:28",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "08:51",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "09:13",
				"arrivesAt": "09:27",
				"waitsAtSource": 240,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "09:28",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tutova",
				"leavesAt": "10:02",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Tutova",
				"to": "Tecuci",
				"leavesAt": "10:20",
				"arrivesAt": "10:54",
				"waitsAtSource": 300,
				"distance": 35300
			},
			{
				"from": "Tecuci",
				"to": "Lieşti",
				"leavesAt": "10:55",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 24400
			},
			{
				"from": "Lieşti",
				"to": "Barboşi",
				"leavesAt": "11:21",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 48300
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "12:13",
				"arrivesAt": "12:32",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2416",
		"segments": [
			{
				"from": "Vinţu de Jos",
				"to": "Sebeş Glod h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:05",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Sebeş Glod h.",
				"to": "Sebeş Alba",
				"leavesAt": "16:06",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sebeş Alba",
				"to": "Rahău h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Rahău h.",
				"to": "Cut h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cut h.",
				"to": "Cunţa Hm.",
				"leavesAt": "16:25",
				"arrivesAt": "16:32",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cunţa Hm.",
				"to": "Băile Miercurea h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băile Miercurea h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 900,
				"distance": 3700
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Tilişca h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Tilişca h.",
				"to": "Aciliu h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:33",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Aciliu h.",
				"to": "Sălişte Hm.",
				"leavesAt": "17:34",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Sălişte Hm.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sibiel h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sibiel h.",
				"to": "Orlat",
				"leavesAt": "17:49",
				"arrivesAt": "17:55",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Orlat",
				"to": "Cristian Sibiu h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Turnişor Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:16",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Sibiu h.(210)",
				"leavesAt": "18:17",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Sibiu",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8033",
		"segments": [
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "04:53",
				"arrivesAt": "05:00",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Cernavodă Pod",
				"leavesAt": "05:01",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "05:21",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "05:39",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:56",
				"waitsAtSource": 180,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 540,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "06:15",
				"arrivesAt": "06:21",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "06:28",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "06:33",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "06:39",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9381",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Mihăeşti Hm.",
				"leavesAt": "04:12",
				"arrivesAt": "04:30",
				"waitsAtSource": 0,
				"distance": 17300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "04:43",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Fărcaşele Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Caracal",
				"leavesAt": "05:11",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:35",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "05:36",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "05:43",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "06:02",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Malu Mare Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "06:23",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "06:28",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9432",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "07:03",
				"arrivesAt": "07:09",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "07:16",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "07:24",
				"arrivesAt": "07:27",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:32",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "07:33",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "07:38",
				"arrivesAt": "07:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:49",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:52",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "08:12",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "08:20",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "08:27",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "08:31",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "08:35",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5474",
		"segments": [
			{
				"from": "Bicaz",
				"to": "Tarcău Neamţ Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:26",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Tarcău Neamţ Hm.",
				"to": "Stejaru h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stejaru h.",
				"to": "Pângăraţi Hm.",
				"leavesAt": "19:34",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pângăraţi Hm.",
				"to": "Vaduri h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Vaduri h.",
				"to": "Piatra Neamţ",
				"leavesAt": "19:45",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Piatra Neamţ",
				"to": "Dumbrava h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:05",
				"waitsAtSource": 120,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Săvineşti h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săvineşti h.",
				"to": "Roznov",
				"leavesAt": "20:13",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Roznov",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Podoleni Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Podoleni Hm.",
				"to": "Costişa h.",
				"leavesAt": "20:33",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Costişa h.",
				"to": "Buhuşi",
				"leavesAt": "20:41",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhuşi",
				"to": "Racova h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Racova h.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Gârleni Hm.",
				"leavesAt": "21:02",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gârleni Hm.",
				"to": "Hămeiuş P.M.",
				"leavesAt": "21:07",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Bacău",
				"leavesAt": "21:14",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 7900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9139",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(913)",
				"leavesAt": "19:40",
				"arrivesAt": "19:43",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Jiu Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Jiu Hm.",
				"to": "Podari",
				"leavesAt": "19:50",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Podari",
				"to": "Sălcuţa Hm.",
				"leavesAt": "20:01",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Dealul Robului h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dealul Robului h.",
				"to": "Segarcea Nord hc.",
				"leavesAt": "20:22",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Segarcea",
				"leavesAt": "20:30",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea",
				"to": "Cerăt h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cerăt h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "20:41",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Urzica Mare h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Urzica Mare h.",
				"to": "Afumaţi h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:08",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Afumaţi h.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "21:09",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Boureni P.M.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Boureni P.M.",
				"to": "Băileşti",
				"leavesAt": "21:23",
				"arrivesAt": "21:36",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Băileşti",
				"to": "Moţăţei Hm.",
				"leavesAt": "21:37",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 12800
			},
			{
				"from": "Moţăţei Hm.",
				"to": "Maglavit h.",
				"leavesAt": "22:00",
				"arrivesAt": "22:14",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Maglavit h.",
				"to": "Golenţi Hm.",
				"leavesAt": "22:15",
				"arrivesAt": "22:30",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Golenţi Hm.",
				"to": "Calafat",
				"leavesAt": "22:31",
				"arrivesAt": "22:49",
				"waitsAtSource": 60,
				"distance": 11800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1921",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "19:00",
				"arrivesAt": "19:07",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "19:08",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "19:15",
				"arrivesAt": "19:28",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "19:30",
				"arrivesAt": "19:34",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:50",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "19:51",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "20:02",
				"arrivesAt": "20:09",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "20:11",
				"arrivesAt": "20:34",
				"waitsAtSource": 120,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "20:50",
				"arrivesAt": "21:14",
				"waitsAtSource": 960,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "21:15",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "21:33",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "21:55",
				"arrivesAt": "22:18",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Lehliu",
				"leavesAt": "22:19",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Lehliu",
				"to": "Bucureşti Nord",
				"leavesAt": "22:41",
				"arrivesAt": "23:21",
				"waitsAtSource": 60,
				"distance": 69600
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "23:45",
				"arrivesAt": "00:37",
				"waitsAtSource": 1440,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "00:38",
				"arrivesAt": "01:23",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "01:25",
				"arrivesAt": "01:56",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "01:57",
				"arrivesAt": "02:14",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "02:15",
				"arrivesAt": "02:55",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "03:05",
				"arrivesAt": "03:32",
				"waitsAtSource": 600,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Cărbuneşti",
				"leavesAt": "03:33",
				"arrivesAt": "04:19",
				"waitsAtSource": 60,
				"distance": 46500
			},
			{
				"from": "Cărbuneşti",
				"to": "Târgu Jiu",
				"leavesAt": "04:20",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 23800
			},
			{
				"from": "Târgu Jiu",
				"to": "Valea Sadului Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "05:09",
				"waitsAtSource": 120,
				"distance": 19600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Petroşani",
				"leavesAt": "05:10",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 31700
			},
			{
				"from": "Petroşani",
				"to": "Băniţa",
				"leavesAt": "06:02",
				"arrivesAt": "06:17",
				"waitsAtSource": 300,
				"distance": 11300
			},
			{
				"from": "Băniţa",
				"to": "Subcetate",
				"leavesAt": "06:18",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 38500
			},
			{
				"from": "Subcetate",
				"to": "Călan Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:34",
				"waitsAtSource": 120,
				"distance": 15600
			},
			{
				"from": "Călan Hm.",
				"to": "Simeria",
				"leavesAt": "07:36",
				"arrivesAt": "07:51",
				"waitsAtSource": 120,
				"distance": 14600
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "07:57",
				"arrivesAt": "08:08",
				"waitsAtSource": 360,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "08:10",
				"arrivesAt": "08:38",
				"waitsAtSource": 120,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Săvârşin",
				"leavesAt": "08:39",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Săvârşin",
				"to": "Radna",
				"leavesAt": "09:28",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Radna",
				"to": "Arad",
				"leavesAt": "10:28",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 34500
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1790",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "14:00",
				"arrivesAt": "14:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "14:12",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "14:36",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "14:56",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2437",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:22",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "14:23",
				"arrivesAt": "14:28",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "14:29",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "14:36",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Cozia Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cozia Hm.",
				"to": "Lotru",
				"leavesAt": "15:03",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3612",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "11:45",
				"arrivesAt": "11:55",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "11:56",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "12:01",
				"arrivesAt": "12:06",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "12:07",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "12:13",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "12:22",
				"arrivesAt": "12:30",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "12:31",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:48",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "12:49",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "12:56",
				"arrivesAt": "13:04",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "13:05",
				"arrivesAt": "13:13",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "13:14",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "13:21",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "13:26",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "13:31",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "13:36",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "13:40",
				"arrivesAt": "13:44",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "13:45",
				"arrivesAt": "13:52",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "13:53",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 13100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5432",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "04:45",
				"arrivesAt": "04:52",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "04:53",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "04:59",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "05:04",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "05:22",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "05:46",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "06:07",
				"arrivesAt": "06:19",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2095",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "20:20",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "20:24",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "20:29",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "20:33",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "20:47",
				"arrivesAt": "20:52",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "20:57",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "21:04",
				"arrivesAt": "21:11",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "21:12",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "21:16",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "21:23",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "21:30",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "21:40",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "21:46",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "21:52",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "21:58",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "22:07",
				"arrivesAt": "22:14",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "22:15",
				"arrivesAt": "22:21",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "22:22",
				"arrivesAt": "22:26",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Târgu Jiu",
				"leavesAt": "22:27",
				"arrivesAt": "22:39",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5005",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "13:17",
				"arrivesAt": "13:26",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "13:27",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "13:34",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "13:39",
				"arrivesAt": "13:46",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "13:47",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "13:52",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "14:02",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "14:11",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "14:27",
				"arrivesAt": "14:33",
				"waitsAtSource": 120,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "14:34",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "14:44",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "15:00",
				"arrivesAt": "15:05",
				"waitsAtSource": 480,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "15:06",
				"arrivesAt": "15:11",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "15:12",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "15:21",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "15:32",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "15:46",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "15:52",
				"arrivesAt": "16:04",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5712",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Strâmba h.",
				"leavesAt": "18:55",
				"arrivesAt": "19:00",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Strâmba h.",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "19:01",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "19:07",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "19:16",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mare Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "19:34",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Lunca Ilvei",
				"to": "Silhoasa Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Larion Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Larion Hm.",
				"to": "Grădiniţa",
				"leavesAt": "20:04",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Grădiniţa",
				"to": "Coşna Hm.",
				"leavesAt": "20:14",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Coşna Hm.",
				"to": "Floreni",
				"leavesAt": "20:29",
				"arrivesAt": "20:37",
				"waitsAtSource": 360,
				"distance": 5700
			},
			{
				"from": "Floreni",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Roşu Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Roşu Hm.",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "20:51",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "20:59",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1924",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun hc.",
				"leavesAt": "18:10",
				"arrivesAt": "18:20",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "18:23",
				"arrivesAt": "18:36",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "18:39",
				"arrivesAt": "18:43",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "18:46",
				"arrivesAt": "19:01",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "19:04",
				"arrivesAt": "19:11",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "19:13",
				"arrivesAt": "19:22",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "19:23",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "19:31",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "20:00",
				"arrivesAt": "20:26",
				"waitsAtSource": 1080,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "20:27",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "20:47",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "21:10",
				"arrivesAt": "21:36",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "21:37",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 108900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "23:04",
				"arrivesAt": "00:02",
				"waitsAtSource": 1140,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "00:03",
				"arrivesAt": "00:23",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "00:24",
				"arrivesAt": "00:48",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "00:49",
				"arrivesAt": "01:00",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Piteşti",
				"to": "Costeşti",
				"leavesAt": "01:25",
				"arrivesAt": "01:48",
				"waitsAtSource": 1500,
				"distance": 21800
			},
			{
				"from": "Costeşti",
				"to": "Stolnici Hm.",
				"leavesAt": "01:50",
				"arrivesAt": "02:05",
				"waitsAtSource": 120,
				"distance": 15900
			},
			{
				"from": "Stolnici Hm.",
				"to": "Slatina",
				"leavesAt": "02:07",
				"arrivesAt": "02:48",
				"waitsAtSource": 120,
				"distance": 43300
			},
			{
				"from": "Slatina",
				"to": "Piatra Olt",
				"leavesAt": "02:50",
				"arrivesAt": "03:08",
				"waitsAtSource": 120,
				"distance": 17000
			},
			{
				"from": "Piatra Olt",
				"to": "Drăgăşani",
				"leavesAt": "03:30",
				"arrivesAt": "03:58",
				"waitsAtSource": 1320,
				"distance": 33800
			},
			{
				"from": "Drăgăşani",
				"to": "Băbeni",
				"leavesAt": "04:00",
				"arrivesAt": "04:26",
				"waitsAtSource": 120,
				"distance": 33200
			},
			{
				"from": "Băbeni",
				"to": "Govora",
				"leavesAt": "04:27",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Govora",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "04:36",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 11400
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Călimăneşti",
				"leavesAt": "04:50",
				"arrivesAt": "05:08",
				"waitsAtSource": 180,
				"distance": 16200
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:15",
				"waitsAtSource": 120,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Lotru",
				"leavesAt": "05:17",
				"arrivesAt": "05:36",
				"waitsAtSource": 120,
				"distance": 11500
			},
			{
				"from": "Lotru",
				"to": "Câineni",
				"leavesAt": "05:37",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 21100
			},
			{
				"from": "Câineni",
				"to": "Turnu Roşu hc.",
				"leavesAt": "06:03",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "06:36",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "06:51",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4103",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Viişoara h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:43",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Viişoara h.",
				"to": "Sărata h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "07:48",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "07:54",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "07:59",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "08:11",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "08:27",
				"arrivesAt": "08:36",
				"waitsAtSource": 420,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "09:01",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "09:12",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "09:29",
				"arrivesAt": "09:37",
				"waitsAtSource": 600,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "09:38",
				"arrivesAt": "09:49",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "09:51",
				"arrivesAt": "09:57",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "09:58",
				"arrivesAt": "10:03",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "10:04",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "10:08",
				"arrivesAt": "10:13",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "10:14",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "10:18",
				"arrivesAt": "10:23",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "10:24",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "10:31",
				"arrivesAt": "10:36",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "10:37",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "10:41",
				"arrivesAt": "10:48",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "10:49",
				"arrivesAt": "10:54",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "10:55",
				"arrivesAt": "11:00",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5464",
		"segments": [
			{
				"from": "Piatra Neamţ",
				"to": "Dumbrava h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:31",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Săvineşti h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săvineşti h.",
				"to": "Roznov",
				"leavesAt": "16:39",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Roznov",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Podoleni Hm.",
				"leavesAt": "16:51",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Podoleni Hm.",
				"to": "Costişa h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Costişa h.",
				"to": "Buhuşi",
				"leavesAt": "17:07",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhuşi",
				"to": "Racova h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Racova h.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Gârleni Hm.",
				"leavesAt": "17:28",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gârleni Hm.",
				"to": "Hămeiuş P.M.",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Bacău",
				"leavesAt": "17:40",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 7900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7040",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Armăşeşti Hm.",
				"leavesAt": "21:24",
				"arrivesAt": "21:32",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "21:39",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "21:46",
				"arrivesAt": "21:52",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "21:53",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 12500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "22:11",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "22:17",
				"arrivesAt": "22:20",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Mogoşoaia",
				"leavesAt": "22:21",
				"arrivesAt": "22:31",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Mogoşoaia",
				"to": "Pajura Hm. (700)",
				"leavesAt": "22:32",
				"arrivesAt": "22:53",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Carpaţi h.(700)",
				"leavesAt": "22:54",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Bucureşti Nord",
				"leavesAt": "22:58",
				"arrivesAt": "23:06",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8212",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "03:30",
				"arrivesAt": "03:36",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Murfatlar h.",
				"leavesAt": "03:37",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "03:46",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "03:51",
				"arrivesAt": "03:56",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Castelu h.",
				"leavesAt": "03:57",
				"arrivesAt": "04:03",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "04:04",
				"arrivesAt": "04:12",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "04:27",
				"arrivesAt": "04:46",
				"waitsAtSource": 900,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "04:47",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:33",
				"waitsAtSource": 480,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Platoneşti h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Platoneşti h.",
				"to": "Ţăndărei",
				"leavesAt": "05:42",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ţăndărei",
				"to": "Murgeanca Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Spicu",
				"leavesAt": "06:02",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spicu",
				"to": "Dudeşti Hm.",
				"leavesAt": "06:12",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "06:23",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Cireşu Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Cireşu Hm.",
				"to": "Făurei",
				"leavesAt": "06:38",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 15700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7585",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "09:03",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "09:09",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 7400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2046",
		"segments": [
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "16:20",
				"arrivesAt": "16:28",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "16:29",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "16:44",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "16:56",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "17:09",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Nadăş h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Nadăş h.",
				"to": "Bârzava",
				"leavesAt": "17:39",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "18:04",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "18:16",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "18:26",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "18:34",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "18:46",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "18:53",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "19:05",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "19:14",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "19:22",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "19:53",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "19:58",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:16",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "20:17",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1591",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "06:32",
				"arrivesAt": "07:24",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "07:25",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "08:10",
				"arrivesAt": "08:57",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "08:58",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "09:45",
				"arrivesAt": "10:12",
				"waitsAtSource": 300,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Strehaia hc.",
				"leavesAt": "10:13",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Strehaia hc.",
				"to": "Balota",
				"leavesAt": "10:38",
				"arrivesAt": "11:13",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Balota",
				"to": "Ergheviţa h.",
				"leavesAt": "11:14",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Ergheviţa h.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "11:30",
				"arrivesAt": "11:49",
				"waitsAtSource": 30,
				"distance": 11600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2441",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Sud",
				"leavesAt": "03:14",
				"arrivesAt": "03:20",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "03:21",
				"arrivesAt": "03:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Sânpaul Hm.",
				"leavesAt": "03:26",
				"arrivesAt": "03:39",
				"waitsAtSource": 30,
				"distance": 11200
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Iernut",
				"leavesAt": "03:40",
				"arrivesAt": "03:49",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Iernut",
				"to": "Cuci h.",
				"leavesAt": "03:50",
				"arrivesAt": "03:55",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cuci h.",
				"to": "Bogata Mureş h.",
				"leavesAt": "03:56",
				"arrivesAt": "04:02",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Luduş",
				"leavesAt": "04:03",
				"arrivesAt": "04:07",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Luduş",
				"to": "Cheţani h.",
				"leavesAt": "04:08",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Cheţani h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "04:15",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Gura Arieşului h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Lunca Mureşului h.",
				"leavesAt": "04:25",
				"arrivesAt": "04:29",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Războieni",
				"leavesAt": "04:30",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "04:36",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "04:52",
				"arrivesAt": "04:56",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:04",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "05:05",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "05:23",
				"arrivesAt": "05:31",
				"waitsAtSource": 240,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "05:57",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "06:40",
				"arrivesAt": "06:52",
				"waitsAtSource": 2040,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Sebeş Glod h.",
				"leavesAt": "07:14",
				"arrivesAt": "07:21",
				"waitsAtSource": 1320,
				"distance": 6500
			},
			{
				"from": "Sebeş Glod h.",
				"to": "Sebeş Alba",
				"leavesAt": "07:22",
				"arrivesAt": "07:26",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sebeş Alba",
				"to": "Rahău h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Rahău h.",
				"to": "Cut h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cut h.",
				"to": "Cunţa Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:48",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cunţa Hm.",
				"to": "Băile Miercurea h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băile Miercurea h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "08:07",
				"arrivesAt": "08:16",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Tilişca h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:33",
				"waitsAtSource": 300,
				"distance": 7800
			},
			{
				"from": "Tilişca h.",
				"to": "Aciliu h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Aciliu h.",
				"to": "Sălişte Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Sălişte Hm.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sibiel h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sibiel h.",
				"to": "Orlat",
				"leavesAt": "08:55",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Orlat",
				"to": "Cristian Sibiu h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Turnişor Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Sibiu h.(210)",
				"leavesAt": "09:23",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Sibiu",
				"leavesAt": "09:27",
				"arrivesAt": "09:32",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4050",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "22:46",
				"arrivesAt": "23:03",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "23:04",
				"arrivesAt": "23:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "23:10",
				"arrivesAt": "23:16",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "23:17",
				"arrivesAt": "23:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Ţicău h.",
				"leavesAt": "23:24",
				"arrivesAt": "23:26",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ţicău h.",
				"to": "Benesat Hm.",
				"leavesAt": "23:27",
				"arrivesAt": "23:35",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Benesat Hm.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "23:36",
				"arrivesAt": "23:39",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Inău h.",
				"leavesAt": "23:40",
				"arrivesAt": "23:43",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Inău h.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "23:44",
				"arrivesAt": "23:48",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "23:49",
				"arrivesAt": "23:59",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7381",
		"segments": [
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "05:51",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "05:56",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "06:00",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "06:14",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7572",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:54",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "15:55",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Barboşi Triaj h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Barboşi Triaj h.",
				"to": "Şendreni Hm.",
				"leavesAt": "16:08",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Şendreni Hm.",
				"to": "Şerbeştii Vechi h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Şerbeştii Vechi h.",
				"to": "Braniştea h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Braniştea h.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "16:23",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Independenţa Hm.",
				"leavesAt": "16:27",
				"arrivesAt": "16:32",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Independenţa Hm.",
				"to": "Piscu h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Piscu h.",
				"to": "Vameş h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vameş h.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "16:45",
				"arrivesAt": "16:51",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "16:52",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Şerbăneşti h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Lieşti",
				"leavesAt": "17:04",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lieşti",
				"to": "Buceşti h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Buceşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Iveşti Hm.",
				"to": "Umbrăreşti h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Barcea",
				"leavesAt": "17:24",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Barcea",
				"to": "Malul Alb h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Malul Alb h.",
				"to": "Tecuci",
				"leavesAt": "17:35",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "18:00",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1724",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(901)",
				"leavesAt": "08:00",
				"arrivesAt": "08:03",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Cârcea h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Cârcea h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "08:12",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Toporaş h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Spineni h.",
				"leavesAt": "08:30",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Spineni h.",
				"to": "Balş",
				"leavesAt": "08:36",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balş",
				"to": "Brăneţ h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Brăneţ h.",
				"to": "Piatra Olt",
				"leavesAt": "08:49",
				"arrivesAt": "08:59",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Piatra Olt",
				"to": "Drăgăşani",
				"leavesAt": "09:04",
				"arrivesAt": "09:30",
				"waitsAtSource": 300,
				"distance": 33800
			},
			{
				"from": "Drăgăşani",
				"to": "Băbeni",
				"leavesAt": "09:31",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Băbeni",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "09:56",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Călimăneşti",
				"leavesAt": "10:15",
				"arrivesAt": "10:30",
				"waitsAtSource": 120,
				"distance": 16200
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Câineni",
				"leavesAt": "10:37",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Câineni",
				"to": "Turnu Roşu hc.",
				"leavesAt": "11:19",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "11:53",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "11:59",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "12:08",
				"arrivesAt": "12:27",
				"waitsAtSource": 120,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6314",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "12:50",
				"arrivesAt": "12:57",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "12:58",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "13:16",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "13:26",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "13:34",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "13:42",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "13:49",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "14:01",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "14:13",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "14:24",
				"arrivesAt": "14:32",
				"waitsAtSource": 360,
				"distance": 9800
			},
			{
				"from": "Vaslui",
				"to": "Munteni Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:39",
				"waitsAtSource": 120,
				"distance": 4600
			},
			{
				"from": "Munteni Hm.",
				"to": "Bulboaca h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bulboaca h.",
				"to": "Crasna",
				"leavesAt": "14:46",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Crasna",
				"to": "Roşieşti hc.",
				"leavesAt": "14:54",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Roşieşti hc.",
				"to": "Dodeşti hc.",
				"leavesAt": "15:03",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Dodeşti hc.",
				"to": "Banca Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Banca Hm.",
				"to": "Zorleni",
				"leavesAt": "15:17",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Zorleni",
				"to": "Bârlad",
				"leavesAt": "15:28",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bârlad",
				"to": "Dragalina h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:56",
				"waitsAtSource": 660,
				"distance": 8200
			},
			{
				"from": "Dragalina h.",
				"to": "Tutova",
				"leavesAt": "15:57",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Tutova",
				"to": "Ghidigeni Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ghidigeni Hm.",
				"to": "Nichişeni",
				"leavesAt": "16:17",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nichişeni",
				"to": "Berheci Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:42",
				"waitsAtSource": 660,
				"distance": 8400
			},
			{
				"from": "Berheci Hm.",
				"to": "Rateş Munteni h.",
				"leavesAt": "16:43",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Rateş Munteni h.",
				"to": "Frunzeasca Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Frunzeasca Hm.",
				"to": "Tecuci Nord hc.(600)",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tecuci Nord hc.(600)",
				"to": "Tecuci",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8809",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "21:15",
				"arrivesAt": "21:29",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "21:30",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "21:45",
				"arrivesAt": "21:50",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "21:58",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "22:13",
				"arrivesAt": "22:16",
				"waitsAtSource": 540,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "22:17",
				"arrivesAt": "22:26",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "22:27",
				"arrivesAt": "22:36",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180909",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5463",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "07:18",
				"arrivesAt": "07:27",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "07:28",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Racova h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Racova h.",
				"to": "Buhuşi",
				"leavesAt": "07:49",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Buhuşi",
				"to": "Costişa h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Costişa h.",
				"to": "Podoleni Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Podoleni Hm.",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:32",
				"waitsAtSource": 720,
				"distance": 5800
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Roznov",
				"leavesAt": "08:33",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Roznov",
				"to": "Săvineşti h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Săvineşti h.",
				"to": "Dumbrava h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Piatra Neamţ",
				"leavesAt": "08:54",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1833",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Târgu Frumos",
				"leavesAt": "06:10",
				"arrivesAt": "06:46",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Târgu Frumos",
				"to": "Paşcani",
				"leavesAt": "06:47",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 30800
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "07:16",
				"arrivesAt": "07:36",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "07:37",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "07:54",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Gura Humorului Oraş",
				"leavesAt": "08:23",
				"arrivesAt": "09:09",
				"waitsAtSource": 1020,
				"distance": 46800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Vama",
				"leavesAt": "09:19",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vama",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "09:30",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "09:49",
				"arrivesAt": "09:55",
				"waitsAtSource": 180,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Pojorâta Hm.",
				"leavesAt": "09:56",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Mestecăniş",
				"leavesAt": "10:07",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "10:29",
				"arrivesAt": "10:38",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Vatra Dornei",
				"leavesAt": "10:39",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "10:56",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Lunca Ilvei",
				"leavesAt": "11:00",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 42800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "11:56",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mică",
				"leavesAt": "12:15",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 17300
			},
			{
				"from": "Ilva Mică",
				"to": "Năsăud",
				"leavesAt": "12:38",
				"arrivesAt": "12:59",
				"waitsAtSource": 60,
				"distance": 19800
			},
			{
				"from": "Năsăud",
				"to": "Salva",
				"leavesAt": "13:01",
				"arrivesAt": "13:08",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Salva",
				"to": "Beclean pe Someş",
				"leavesAt": "13:09",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "13:33",
				"arrivesAt": "14:08",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "14:13",
				"arrivesAt": "14:32",
				"waitsAtSource": 300,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "14:34",
				"arrivesAt": "15:26",
				"waitsAtSource": 120,
				"distance": 44900
			},
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "15:48",
				"arrivesAt": "16:18",
				"waitsAtSource": 1320,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "16:19",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "16:48",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Bratca",
				"leavesAt": "17:11",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Aleşd",
				"leavesAt": "17:54",
				"arrivesAt": "18:07",
				"waitsAtSource": 240,
				"distance": 12200
			},
			{
				"from": "Aleşd",
				"to": "Oradea",
				"leavesAt": "18:08",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 34300
			},
			{
				"from": "Oradea",
				"to": "Salonta",
				"leavesAt": "18:50",
				"arrivesAt": "19:33",
				"waitsAtSource": 540,
				"distance": 39200
			},
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "19:34",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "19:48",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 23700
			},
			{
				"from": "Chişineu Criş",
				"to": "Sântana",
				"leavesAt": "20:16",
				"arrivesAt": "20:36",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Sântana",
				"to": "Arad",
				"leavesAt": "20:38",
				"arrivesAt": "21:04",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "21:22",
				"arrivesAt": "21:30",
				"waitsAtSource": 1080,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Timişoara Nord",
				"leavesAt": "21:31",
				"arrivesAt": "22:14",
				"waitsAtSource": 60,
				"distance": 51000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1693",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "15:45",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "16:37",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "17:24",
				"arrivesAt": "18:11",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "18:12",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "19:00",
				"arrivesAt": "19:26",
				"waitsAtSource": 480,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Strehaia hc.",
				"leavesAt": "19:27",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Strehaia hc.",
				"to": "Balota",
				"leavesAt": "19:52",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Balota",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "20:29",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Orşova",
				"leavesAt": "21:04",
				"arrivesAt": "21:35",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Orşova",
				"to": "Băile Herculane",
				"leavesAt": "21:36",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 17500
			},
			{
				"from": "Băile Herculane",
				"to": "Caransebeş",
				"leavesAt": "21:57",
				"arrivesAt": "23:20",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "23:22",
				"arrivesAt": "23:56",
				"waitsAtSource": 120,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Timişoara Nord",
				"leavesAt": "23:57",
				"arrivesAt": "00:50",
				"waitsAtSource": 60,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4506",
		"segments": [
			{
				"from": "Deda",
				"to": "Deda Bistra Hm.",
				"leavesAt": "06:02",
				"arrivesAt": "06:08",
				"waitsAtSource": 0,
				"distance": 3900
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Borzia h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Borzia h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 12700
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Stânceni h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Stânceni Hm.",
				"to": "Ciobotani h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ciobotani h.",
				"to": "Topliţa",
				"leavesAt": "07:07",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Topliţa",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:26",
				"waitsAtSource": 120,
				"distance": 6000
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Ditrău",
				"leavesAt": "07:41",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ditrău",
				"to": "Lăzarea Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Gheorgheni",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Gheorgheni",
				"to": "Valea Strâmbă h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 180,
				"distance": 3400
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Şugău h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Şugău h.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "08:18",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Sândominic h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:47",
				"waitsAtSource": 540,
				"distance": 7800
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Oltului",
				"leavesAt": "08:48",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Tomeşti h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:10",
				"waitsAtSource": 720,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Cârţani h.",
				"leavesAt": "09:11",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Cârţani h.",
				"to": "Dăneşti h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Dăneşti h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:25",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Racu h.",
				"leavesAt": "09:26",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Racu h.",
				"to": "Siculeni",
				"leavesAt": "09:32",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "09:38",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1595",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "13:45",
				"arrivesAt": "14:37",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "14:38",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "15:25",
				"arrivesAt": "15:56",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "15:57",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "16:16",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2076",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:08",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "13:09",
				"arrivesAt": "13:12",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "13:13",
				"arrivesAt": "13:16",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "13:17",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "13:22",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:40",
				"waitsAtSource": 480,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "13:41",
				"arrivesAt": "13:48",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Băbeni",
				"to": "Slăviteşti hc.",
				"leavesAt": "13:49",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Ioneşti Hm.",
				"leavesAt": "13:55",
				"arrivesAt": "14:02",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "14:03",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Fişcălia Hm.",
				"leavesAt": "14:08",
				"arrivesAt": "14:12",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "14:13",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Orleşti hc.",
				"to": "Zăvideni Hm.",
				"leavesAt": "14:17",
				"arrivesAt": "14:22",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Călina h.",
				"leavesAt": "14:23",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Călina h.",
				"to": "Drăgăşani",
				"leavesAt": "14:28",
				"arrivesAt": "14:36",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Drăgăşani",
				"to": "Zlătărei Hm.",
				"leavesAt": "14:38",
				"arrivesAt": "14:45",
				"waitsAtSource": 120,
				"distance": 6600
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Strejeşti",
				"leavesAt": "14:46",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Strejeşti",
				"to": "Colibaşi h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Arceşti Hm.",
				"leavesAt": "15:00",
				"arrivesAt": "15:07",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Găneasa Olt h.",
				"leavesAt": "15:08",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Găneasa h.",
				"leavesAt": "15:14",
				"arrivesAt": "15:16",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa h.",
				"to": "Piatra Olt",
				"leavesAt": "15:17",
				"arrivesAt": "15:24",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5571",
		"segments": [
			{
				"from": "Botoşani",
				"to": "Leorda Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:21",
				"waitsAtSource": 0,
				"distance": 15500
			},
			{
				"from": "Leorda Hm.",
				"to": "Bucecea Hm",
				"leavesAt": "15:22",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bucecea Hm",
				"to": "Bursuceni h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bursuceni h.",
				"to": "Vereşti",
				"leavesAt": "15:58",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "16:12",
				"arrivesAt": "16:18",
				"waitsAtSource": 120,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "16:19",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9002",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "04:45",
				"arrivesAt": "04:47",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Malu Mare Hm.",
				"leavesAt": "04:58",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "05:02",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Leu Hm.",
				"leavesAt": "05:06",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Leu Hm.",
				"to": "Ţărţăl h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ţărţăl h.",
				"to": "Jianca",
				"leavesAt": "05:19",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jianca",
				"to": "Radomiru hc.",
				"leavesAt": "05:24",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Radomiru hc.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "05:28",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Cezieni h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Cezieni h.",
				"to": "Caracal",
				"leavesAt": "05:40",
				"arrivesAt": "05:46",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Caracal",
				"to": "Fărcaşele Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:02",
				"waitsAtSource": 600,
				"distance": 7800
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Stoeneşti h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "06:07",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Dăneasa h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dăneasa h.",
				"to": "Radomireşti Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Măldăeni Hm.",
				"leavesAt": "06:38",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "06:48",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "07:00",
				"arrivesAt": "07:08",
				"waitsAtSource": 180,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "07:09",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "07:23",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "07:33",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "07:49",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:05",
				"waitsAtSource": 120,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Grădinari",
				"leavesAt": "08:20",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:43",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "08:44",
				"arrivesAt": "09:00",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "09:09",
				"arrivesAt": "09:12",
				"waitsAtSource": 540,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Bucureşti Basarab",
				"leavesAt": "09:13",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2209",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "16:32",
				"arrivesAt": "16:42",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "16:43",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4305",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:33",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "14:34",
				"arrivesAt": "14:45",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:53",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "14:54",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "15:04",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:20",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "15:29",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "15:35",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "15:39",
				"arrivesAt": "15:46",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180910",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4486",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "19:50",
				"arrivesAt": "19:57",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Reteag Hm.",
				"leavesAt": "20:04",
				"arrivesAt": "20:09",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "20:10",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "20:19",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "20:23",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:43",
				"waitsAtSource": 180,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "20:53",
				"arrivesAt": "20:56",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "20:57",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "21:04",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Năsăud h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 600,
				"distance": 4100
			},
			{
				"from": "Năsăud h.",
				"to": "Năsăud",
				"leavesAt": "21:23",
				"arrivesAt": "21:26",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Năsăud",
				"to": "Rebrişoara Hm.",
				"leavesAt": "21:27",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Nepos h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Nepos h.",
				"to": "Feldru Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Feldru Hm.",
				"to": "Podereia Feldrului h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:54",
				"waitsAtSource": 300,
				"distance": 2200
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Ilva Mică",
				"leavesAt": "21:55",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1064",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "18:09",
				"arrivesAt": "18:16",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "18:17",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Holboca Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "18:33",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "18:42",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ungheni Prut Hm.",
				"to": "Ungheni Prut Fr.",
				"leavesAt": "19:32",
				"arrivesAt": "19:34",
				"waitsAtSource": 2520,
				"distance": 600
			},
			{
				"from": "Ungheni Prut Fr.",
				"to": "Ungheni",
				"leavesAt": "19:54",
				"arrivesAt": "19:58",
				"waitsAtSource": 1200,
				"distance": 800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1925",
		"segments": [
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "03:42",
				"arrivesAt": "04:08",
				"waitsAtSource": 0,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Turceni",
				"leavesAt": "04:09",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Turceni",
				"to": "Rovinari Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 35300
			},
			{
				"from": "Rovinari Hm.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "05:04",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "05:23",
				"arrivesAt": "05:40",
				"waitsAtSource": 360,
				"distance": 12500
			},
			{
				"from": "Târgu Jiu",
				"to": "Parângu Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:54",
				"waitsAtSource": 120,
				"distance": 10200
			},
			{
				"from": "Parângu Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "05:59",
				"arrivesAt": "06:10",
				"waitsAtSource": 300,
				"distance": 9400
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Petroşani",
				"leavesAt": "06:11",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 31700
			},
			{
				"from": "Petroşani",
				"to": "Băeşti Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "08:09",
				"waitsAtSource": 600,
				"distance": 42100
			},
			{
				"from": "Băeşti Hm.",
				"to": "Subcetate",
				"leavesAt": "08:16",
				"arrivesAt": "08:25",
				"waitsAtSource": 420,
				"distance": 7700
			},
			{
				"from": "Subcetate",
				"to": "Călan Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Călan Hm.",
				"to": "Simeria",
				"leavesAt": "08:46",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 14600
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "09:03",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20180610",
				"to": "20180910",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5054",
		"segments": [
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:17",
				"waitsAtSource": 0,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "05:34",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:54",
				"waitsAtSource": 120,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "05:55",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:18",
				"waitsAtSource": 120,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "06:19",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:45",
				"waitsAtSource": 600,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "06:54",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "07:05",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "07:17",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "07:28",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "07:43",
				"arrivesAt": "07:52",
				"waitsAtSource": 120,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "07:53",
				"arrivesAt": "07:58",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "07:59",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "08:14",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "08:30",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "08:41",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "08:45",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "08:53",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "09:01",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9377",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Ţigăneşti h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:57",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Ţigăneşti h.",
				"to": "Brânceni h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Brânceni h.",
				"to": "Smârdioasa h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:07",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Smârdioasa h.",
				"to": "Păuleasa h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:13",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Păuleasa h.",
				"to": "Şoimu h.",
				"leavesAt": "06:14",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Şoimu h.",
				"to": "Ulmuleţ h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Ulmuleţ h.",
				"to": "Zimnicea",
				"leavesAt": "06:31",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 9800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5304",
		"segments": [
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "10:00",
				"arrivesAt": "10:09",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:12",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "10:13",
				"arrivesAt": "10:19",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:25",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "10:26",
				"arrivesAt": "10:32",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "10:33",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "10:44",
				"arrivesAt": "10:49",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Oneşti",
				"leavesAt": "10:50",
				"arrivesAt": "11:03",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "11:05",
				"arrivesAt": "11:10",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "11:11",
				"arrivesAt": "11:20",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "11:31",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "11:36",
				"arrivesAt": "11:40",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "11:41",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "11:45",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:06",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "12:07",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "12:11",
				"arrivesAt": "12:18",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "12:19",
				"arrivesAt": "12:23",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "12:24",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9375",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "21:30",
				"arrivesAt": "21:35",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "21:36",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "21:49",
				"arrivesAt": "21:57",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "21:58",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:16",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "22:17",
				"arrivesAt": "22:22",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4316",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Buşag Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:57",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Buşag Hm.",
				"to": "Cicârlău h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cicârlău h.",
				"to": "Ilba h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ilba h.",
				"to": "Săbişa h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:17",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbişa h.",
				"to": "Seini",
				"leavesAt": "16:18",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Seini",
				"to": "Apa Hm.",
				"leavesAt": "16:25",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:58",
				"waitsAtSource": 600,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "17:10",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "17:18",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1624",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:30",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "15:31",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Avrig Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Avrig Hm.",
				"to": "Ucea",
				"leavesAt": "15:53",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 26100
			},
			{
				"from": "Ucea",
				"to": "Făgăraş",
				"leavesAt": "16:20",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Făgăraş",
				"to": "Brădet Hm.",
				"leavesAt": "16:45",
				"arrivesAt": "17:12",
				"waitsAtSource": 120,
				"distance": 26100
			},
			{
				"from": "Brădet Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:47",
				"waitsAtSource": 300,
				"distance": 25100
			},
			{
				"from": "Codlea Hm.",
				"to": "Braşov",
				"leavesAt": "17:48",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "18:20",
				"arrivesAt": "18:56",
				"waitsAtSource": 900,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "18:58",
				"arrivesAt": "19:07",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "19:08",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "19:16",
				"arrivesAt": "19:25",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "19:27",
				"arrivesAt": "19:41",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Câmpina",
				"leavesAt": "19:42",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "19:55",
				"arrivesAt": "20:20",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buftea",
				"leavesAt": "20:22",
				"arrivesAt": "20:51",
				"waitsAtSource": 120,
				"distance": 42000
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "20:52",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9133",
		"segments": [
			{
				"from": "Golenţi Hm.",
				"to": "Calafat",
				"leavesAt": "11:18",
				"arrivesAt": "11:33",
				"waitsAtSource": 0,
				"distance": 11800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2708",
		"segments": [
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:22",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "15:37",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "15:42",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "15:59",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "16:08",
				"arrivesAt": "16:14",
				"waitsAtSource": 180,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băcia h.",
				"to": "Băcia Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Băcia Hm.",
				"to": "Batiz h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Batiz h.",
				"to": "Călan Băi",
				"leavesAt": "16:24",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "16:27",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Ruşi h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ruşi h.",
				"to": "Măceu h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Măceu h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Plopi h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Plopi h.",
				"to": "Covragiu h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Covragiu h.",
				"to": "Subcetate",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Subcetate",
				"to": "Ciopea h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciopea h.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Băeşti Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ruşor h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ruşor h.",
				"to": "Pui",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Pui",
				"to": "Ponor h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ponor h.",
				"to": "Livadia h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Livadia h.",
				"to": "Baru Mare",
				"leavesAt": "17:26",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Baru Mare",
				"to": "Baru Mare h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Baru Mare h.",
				"to": "Crivadia Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Crivadia Hm.",
				"to": "Merişor Hm.",
				"leavesAt": "17:48",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Merişor Hm.",
				"to": "Băniţa",
				"leavesAt": "17:57",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băniţa",
				"to": "Peştera Bolii h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Dep Petroşani h.",
				"leavesAt": "18:22",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani",
				"leavesAt": "18:25",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9386",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "16:38",
				"arrivesAt": "16:41",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Malu Mare Hm.",
				"leavesAt": "16:52",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "16:56",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Leu Hm.",
				"leavesAt": "17:01",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Leu Hm.",
				"to": "Ţărţăl h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ţărţăl h.",
				"to": "Jianca",
				"leavesAt": "17:16",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jianca",
				"to": "Radomiru hc.",
				"leavesAt": "17:21",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Radomiru hc.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Cezieni h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Cezieni h.",
				"to": "Caracal",
				"leavesAt": "17:37",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Caracal",
				"to": "Fărcaşele Hm.",
				"leavesAt": "17:45",
				"arrivesAt": "17:51",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Stoeneşti h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "17:56",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Dăneasa h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dăneasa h.",
				"to": "Radomireşti Hm.",
				"leavesAt": "18:08",
				"arrivesAt": "18:15",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "18:16",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Măldăeni Hm.",
				"leavesAt": "18:26",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "18:37",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4136",
		"segments": [
			{
				"from": "Sighetu Marmaţiei",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "17:35",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Tisa h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tisa h.",
				"to": "Crăciuneşti h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "17:49",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Lunca la Tisa h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Valea Vişeului",
				"leavesAt": "18:02",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Valea Vişeului",
				"to": "Vişeu Bistra h.",
				"leavesAt": "18:36",
				"arrivesAt": "18:50",
				"waitsAtSource": 960,
				"distance": 8500
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Petrova hc.",
				"leavesAt": "18:51",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Petrova hc.",
				"to": "Leordina",
				"leavesAt": "19:01",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Leordina",
				"to": "Leordina h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Leordina h.",
				"to": "Bocicoel h.",
				"leavesAt": "19:19",
				"arrivesAt": "19:27",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Bocicoel h.",
				"to": "Vişeu de Jos",
				"leavesAt": "19:28",
				"arrivesAt": "19:33",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Vişeu de Jos",
				"to": "Iza P.M.",
				"leavesAt": "19:41",
				"arrivesAt": "19:53",
				"waitsAtSource": 480,
				"distance": 8600
			},
			{
				"from": "Iza P.M.",
				"to": "Săcel Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săcel Hm.",
				"to": "Dealu Ştefăniţei",
				"leavesAt": "20:05",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dealu Ştefăniţei",
				"to": "Romuli h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Romuli h.",
				"to": "Fiad Hm.",
				"leavesAt": "20:27",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Fiad Hm.",
				"to": "Telciu Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Telciu Hm.",
				"to": "Coşbuc Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Coşbuc Hm.",
				"to": "Salva",
				"leavesAt": "21:00",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Salva",
				"to": "Mititei h.",
				"leavesAt": "21:14",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Mititei h.",
				"to": "Nimigea Hm.",
				"leavesAt": "21:18",
				"arrivesAt": "21:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:34",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "21:35",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "21:39",
				"arrivesAt": "21:48",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Beclean pe Someş",
				"to": "Ciceu Cristur h.",
				"leavesAt": "21:59",
				"arrivesAt": "22:12",
				"waitsAtSource": 660,
				"distance": 7600
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "22:13",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "22:17",
				"arrivesAt": "22:21",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "22:22",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "22:33",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "22:52",
				"arrivesAt": "23:11",
				"waitsAtSource": 720,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Iclod Hm.",
				"leavesAt": "23:12",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Iclod Hm.",
				"to": "Bonţida Hm.",
				"leavesAt": "23:25",
				"arrivesAt": "23:33",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Bonţida Hm.",
				"to": "Jucu Hm.",
				"leavesAt": "23:34",
				"arrivesAt": "23:42",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida",
				"leavesAt": "23:43",
				"arrivesAt": "23:53",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca Est",
				"leavesAt": "23:54",
				"arrivesAt": "00:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "00:04",
				"arrivesAt": "00:09",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "00:10",
				"arrivesAt": "00:15",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1689",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Lehliu",
				"leavesAt": "06:10",
				"arrivesAt": "06:56",
				"waitsAtSource": 0,
				"distance": 69600
			},
			{
				"from": "Lehliu",
				"to": "Ciulniţa",
				"leavesAt": "07:05",
				"arrivesAt": "07:29",
				"waitsAtSource": 540,
				"distance": 39300
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "07:31",
				"arrivesAt": "07:54",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "07:56",
				"arrivesAt": "08:15",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "08:16",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Nicolae Bălcescu",
				"leavesAt": "09:05",
				"arrivesAt": "09:23",
				"waitsAtSource": 1800,
				"distance": 19100
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "09:24",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Cogealac",
				"leavesAt": "09:41",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cogealac",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "10:02",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 17400
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Baia Dobrogea",
				"leavesAt": "10:21",
				"arrivesAt": "10:32",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Baia Dobrogea",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "10:33",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Babadag",
				"leavesAt": "10:40",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Babadag",
				"to": "Zebil h.",
				"leavesAt": "10:58",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Zebil h.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Cataloi Hm.",
				"leavesAt": "11:30",
				"arrivesAt": "11:44",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Cataloi Hm.",
				"to": "Tulcea Mărfuri",
				"leavesAt": "11:45",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Tulcea Oraş",
				"leavesAt": "12:01",
				"arrivesAt": "12:10",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180105",
				"to": "20180107",
				"daysOfWeek": 383
			},
			{
				"from": "20180112",
				"to": "20180114",
				"daysOfWeek": 383
			},
			{
				"from": "20180119",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180126",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180202",
				"to": "20180204",
				"daysOfWeek": 383
			},
			{
				"from": "20180209",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180216",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180223",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180302",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180309",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180316",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180323",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180330",
				"to": "20180401",
				"daysOfWeek": 383
			},
			{
				"from": "20180406",
				"to": "20180408",
				"daysOfWeek": 383
			},
			{
				"from": "20180413",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180420",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180427",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180504",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180511",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180518",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180527",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180608",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180914",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180921",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180928",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181005",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181012",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181019",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181026",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181102",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181109",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181116",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181123",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181207",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171215",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20171225",
				"daysOfWeek": 383
			},
			{
				"from": "20171229",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4070",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:10",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:15",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "05:16",
				"arrivesAt": "05:22",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "05:23",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180114",
				"daysOfWeek": 383
			},
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180124",
				"to": "20180124",
				"daysOfWeek": 383
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180331",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180410",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181202",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171227",
				"to": "20171230",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9472",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "10:56",
				"arrivesAt": "11:01",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "11:02",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "11:11",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "11:20",
				"arrivesAt": "11:29",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "11:30",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "11:38",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "11:47",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "11:55",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "12:07",
				"arrivesAt": "12:13",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "12:14",
				"arrivesAt": "12:20",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "12:21",
				"arrivesAt": "12:30",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "12:31",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Pârvu h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:49",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Pârvu h.",
				"to": "Bradu de Sus",
				"leavesAt": "12:50",
				"arrivesAt": "13:06",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "13:07",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "13:13",
				"arrivesAt": "13:15",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180617",
				"daysOfWeek": 383
			},
			{
				"from": "20180623",
				"to": "20180624",
				"daysOfWeek": 383
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 383
			},
			{
				"from": "20180707",
				"to": "20180708",
				"daysOfWeek": 383
			},
			{
				"from": "20180714",
				"to": "20180715",
				"daysOfWeek": 383
			},
			{
				"from": "20180721",
				"to": "20180722",
				"daysOfWeek": 383
			},
			{
				"from": "20180728",
				"to": "20180729",
				"daysOfWeek": 383
			},
			{
				"from": "20180804",
				"to": "20180805",
				"daysOfWeek": 383
			},
			{
				"from": "20180811",
				"to": "20180819",
				"daysOfWeek": 383
			},
			{
				"from": "20180825",
				"to": "20180826",
				"daysOfWeek": 383
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 383
			},
			{
				"from": "20180908",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180506",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9608",
		"segments": [
			{
				"from": "Buziaş",
				"to": "Bacova h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:11",
				"waitsAtSource": 0,
				"distance": 2300
			},
			{
				"from": "Bacova h.",
				"to": "Chevereş h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Chevereş h.",
				"to": "Sacoşu Mic",
				"leavesAt": "05:18",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Sacoşu Mic",
				"to": "Uliuc h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Uliuc h.",
				"to": "Urseni h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Urseni h.",
				"to": "Semenic Hm.",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Semenic Hm.",
				"to": "Giroc h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Giroc h.",
				"to": "Timişoara Sud",
				"leavesAt": "05:45",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "05:52",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3012",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "18:30",
				"arrivesAt": "18:40",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Jos h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "18:48",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "18:58",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "19:17",
				"arrivesAt": "19:26",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "19:34",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "19:38",
				"arrivesAt": "19:44",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:49",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "19:50",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Posada h.",
				"leavesAt": "19:56",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Posada h.",
				"to": "Comarnic",
				"leavesAt": "20:02",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "20:17",
				"arrivesAt": "20:20",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "20:21",
				"arrivesAt": "20:27",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Bobolia h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:34",
				"waitsAtSource": 120,
				"distance": 5500
			},
			{
				"from": "Bobolia h.",
				"to": "Floreşti Prahova",
				"leavesAt": "20:35",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "20:49",
				"arrivesAt": "20:59",
				"waitsAtSource": 360,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "21:00",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "21:13",
				"arrivesAt": "21:20",
				"waitsAtSource": 240,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "21:21",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "21:27",
				"arrivesAt": "21:32",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Periş",
				"leavesAt": "21:33",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Periş",
				"to": "Buftea",
				"leavesAt": "21:42",
				"arrivesAt": "21:52",
				"waitsAtSource": 60,
				"distance": 13300
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "21:53",
				"arrivesAt": "22:01",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Nord",
				"leavesAt": "22:02",
				"arrivesAt": "22:14",
				"waitsAtSource": 60,
				"distance": 9400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1834",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Vinga Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "07:01",
				"waitsAtSource": 0,
				"distance": 32600
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Aradu Nou",
				"leavesAt": "07:09",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "07:25",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Sântana",
				"leavesAt": "07:47",
				"arrivesAt": "08:13",
				"waitsAtSource": 900,
				"distance": 23500
			},
			{
				"from": "Sântana",
				"to": "Chişineu Criş",
				"leavesAt": "08:14",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Chişineu Criş",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 23700
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "09:00",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Oradea",
				"leavesAt": "09:14",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 39200
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "09:57",
				"arrivesAt": "10:28",
				"waitsAtSource": 240,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "10:29",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "10:50",
				"arrivesAt": "10:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Ciucea Hm.",
				"leavesAt": "10:59",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "11:21",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "11:42",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "12:07",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 27900
			},
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "12:47",
				"arrivesAt": "13:45",
				"waitsAtSource": 840,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "13:46",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "14:10",
				"arrivesAt": "14:43",
				"waitsAtSource": 300,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Salva",
				"leavesAt": "14:45",
				"arrivesAt": "15:07",
				"waitsAtSource": 120,
				"distance": 21600
			},
			{
				"from": "Salva",
				"to": "Năsăud",
				"leavesAt": "15:09",
				"arrivesAt": "15:16",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Năsăud",
				"to": "Ilva Mică",
				"leavesAt": "15:18",
				"arrivesAt": "15:40",
				"waitsAtSource": 120,
				"distance": 19800
			},
			{
				"from": "Ilva Mică",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "16:03",
				"waitsAtSource": 120,
				"distance": 17300
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "16:04",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Lunca Ilvei",
				"to": "Silhoasa Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "16:36",
				"arrivesAt": "17:25",
				"waitsAtSource": 300,
				"distance": 37000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "17:27",
				"arrivesAt": "17:30",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Iacobeni",
				"leavesAt": "17:33",
				"arrivesAt": "17:48",
				"waitsAtSource": 180,
				"distance": 10200
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "17:49",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Pojorâta Hm.",
				"leavesAt": "18:01",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "18:23",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "18:33",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Vama",
				"leavesAt": "18:40",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Vama",
				"to": "Frasin",
				"leavesAt": "18:55",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "19:07",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Suceava",
				"leavesAt": "19:18",
				"arrivesAt": "20:01",
				"waitsAtSource": 180,
				"distance": 46800
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "20:15",
				"arrivesAt": "20:28",
				"waitsAtSource": 840,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "20:29",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "20:48",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Târgu Frumos",
				"leavesAt": "21:06",
				"arrivesAt": "21:33",
				"waitsAtSource": 120,
				"distance": 30800
			},
			{
				"from": "Târgu Frumos",
				"to": "Iaşi",
				"leavesAt": "21:34",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5401",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "04:40",
				"arrivesAt": "04:46",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "04:47",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "04:58",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "04:59",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "05:03",
				"arrivesAt": "05:15",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Adjudu Vechi h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:21",
				"waitsAtSource": 120,
				"distance": 4100
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Şişcani h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Şişcani h.",
				"to": "Sascut Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:33",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sascut Hm.",
				"to": "Orbeni Hm.",
				"leavesAt": "05:34",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Orbeni Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Răcăciuni h.",
				"to": "Faraoani Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Faraoani Hm.",
				"to": "Siretu Bacău h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Valea Seacă",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Valea Seacă",
				"to": "Letea h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Letea h.",
				"to": "Bacău",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "37630",
		"segments": [
			{
				"from": "Kotegyan",
				"to": "Salonta",
				"leavesAt": "08:40",
				"arrivesAt": "09:00",
				"waitsAtSource": 0,
				"distance": 13200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5471",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "04:09",
				"arrivesAt": "04:18",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "04:19",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:33",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Racova h.",
				"leavesAt": "04:34",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Racova h.",
				"to": "Buhuşi",
				"leavesAt": "04:40",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Buhuşi",
				"to": "Costişa h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Costişa h.",
				"to": "Podoleni Hm.",
				"leavesAt": "04:56",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Podoleni Hm.",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Roznov",
				"leavesAt": "05:13",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Roznov",
				"to": "Săvineşti h.",
				"leavesAt": "05:28",
				"arrivesAt": "05:33",
				"waitsAtSource": 600,
				"distance": 4200
			},
			{
				"from": "Săvineşti h.",
				"to": "Dumbrava h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Piatra Neamţ",
				"leavesAt": "05:43",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Piatra Neamţ",
				"to": "Vaduri h.",
				"leavesAt": "05:51",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Vaduri h.",
				"to": "Pângăraţi Hm.",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pângăraţi Hm.",
				"to": "Stejaru h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Stejaru h.",
				"to": "Tarcău Neamţ Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tarcău Neamţ Hm.",
				"to": "Bicaz",
				"leavesAt": "06:23",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9352",
		"segments": [
			{
				"from": "Giurgiu",
				"to": "Giurgiu Nord",
				"leavesAt": "19:00",
				"arrivesAt": "19:05",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Giurgiu Nord",
				"to": "Cetatea h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cetatea h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:13",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Onceşti h.",
				"leavesAt": "19:14",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Onceşti h.",
				"to": "Stăneşti Hm.",
				"leavesAt": "19:18",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Chiriacu Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Toporu",
				"leavesAt": "19:32",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Toporu",
				"to": "Răsuceni h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Răsuceni h.",
				"to": "Vlaşca Hm.",
				"leavesAt": "19:46",
				"arrivesAt": "19:53",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Târnavele Hm.",
				"to": "Răduleşti Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Videle",
				"leavesAt": "20:15",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7587",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "13:02",
				"arrivesAt": "13:09",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "13:10",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "13:16",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 7400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8002",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "05:52",
				"arrivesAt": "05:58",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "05:59",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "06:12",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "06:23",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "06:32",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "06:40",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "06:50",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "06:57",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Dunărea Hm.",
				"leavesAt": "07:07",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Dunărea Hm.",
				"to": "Ovidiu",
				"leavesAt": "07:22",
				"arrivesAt": "07:28",
				"waitsAtSource": 360,
				"distance": 7600
			},
			{
				"from": "Ovidiu",
				"to": "Ramificaţia Borcea",
				"leavesAt": "07:29",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "07:51",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "08:01",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "08:13",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Ivăneşti h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ivăneşti h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Bogdana h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bogdana h.",
				"to": "Dâlga h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Dâlga h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Lehliu",
				"leavesAt": "08:55",
				"arrivesAt": "08:59",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Lehliu",
				"to": "Preasna h.",
				"leavesAt": "09:00",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Preasna h.",
				"to": "Săruleşti",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săruleşti",
				"to": "Mostiştea h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mostiştea h.",
				"to": "Fundulea Hm.",
				"leavesAt": "09:21",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Fundulea Hm.",
				"to": "Islaz h.",
				"leavesAt": "09:27",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Islaz h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "09:35",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Brăneşti Sat h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Pasărea",
				"leavesAt": "09:42",
				"arrivesAt": "09:48",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pasărea",
				"to": "Pantelimon",
				"leavesAt": "09:49",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "09:56",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "09:59",
				"arrivesAt": "10:11",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4528",
		"segments": [
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "01:21",
				"arrivesAt": "01:42",
				"waitsAtSource": 0,
				"distance": 20900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Siculeni",
				"leavesAt": "01:49",
				"arrivesAt": "01:59",
				"waitsAtSource": 420,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 382
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3642",
		"segments": [
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 240,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Valea Drăganului h.",
				"leavesAt": "07:04",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Poieni",
				"leavesAt": "07:09",
				"arrivesAt": "07:13",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Bologa h.",
				"leavesAt": "07:14",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bologa h.",
				"to": "Brăişoru Hm.",
				"leavesAt": "07:18",
				"arrivesAt": "07:22",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "07:23",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 799
			},
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4441",
		"segments": [
			{
				"from": "Carei",
				"to": "Tiream h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:57",
				"waitsAtSource": 0,
				"distance": 11700
			},
			{
				"from": "Tiream h.",
				"to": "Hotoan h.",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Hotoan h.",
				"to": "Santău h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:09",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Santău h.",
				"to": "Tăşnad",
				"leavesAt": "21:10",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Acâş Hm.",
				"leavesAt": "21:16",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Acâş Hm.",
				"to": "Supur h.",
				"leavesAt": "21:31",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Supur h.",
				"to": "Giorocuţa h.",
				"leavesAt": "21:40",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Giorocuţa h.",
				"to": "Derşida h.",
				"leavesAt": "21:44",
				"arrivesAt": "21:49",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Derşida h.",
				"to": "Sărmăşag",
				"leavesAt": "21:50",
				"arrivesAt": "21:58",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Sărmăşag",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "21:59",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "22:06",
				"arrivesAt": "22:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Borla Hm.",
				"leavesAt": "22:10",
				"arrivesAt": "22:14",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Borla Hm.",
				"to": "Guruslău h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Guruslău h.",
				"to": "Zalău Nord",
				"leavesAt": "22:20",
				"arrivesAt": "22:27",
				"waitsAtSource": 30,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3543",
		"segments": [
			{
				"from": "Odorhei",
				"to": "Odorhei Sud hc.",
				"leavesAt": "08:00",
				"arrivesAt": "08:04",
				"waitsAtSource": 0,
				"distance": 1200
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Feliceni h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:13",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Feliceni h.",
				"to": "Dobeni h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Lutiţa h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lutiţa h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Beteşti h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Beteşti h.",
				"to": "Cristur Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:48",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Cristur Hm.",
				"to": "Sântămaria h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:59",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Sântămaria h.",
				"to": "Săcuienii Noi h.",
				"leavesAt": "09:00",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Săcuienii Noi h.",
				"to": "Vânători",
				"leavesAt": "09:06",
				"arrivesAt": "09:13",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "09:14",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "09:22",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9506",
		"segments": [
			{
				"from": "Orşova",
				"to": "Şantier Naval h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:17",
				"waitsAtSource": 0,
				"distance": 1300
			},
			{
				"from": "Şantier Naval h.",
				"to": "Iloviţa h.",
				"leavesAt": "07:18",
				"arrivesAt": "07:23",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iloviţa h.",
				"to": "Vârciorova Hm.",
				"leavesAt": "07:24",
				"arrivesAt": "07:31",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Vârciorova Hm.",
				"to": "Jidoştiţa h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Jidoştiţa h.",
				"to": "Gura Văii Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Gura Văii Hm.",
				"to": "Dinamica h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dinamica h.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "07:50",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 288
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9006",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Malu Mare Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "08:24",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Leu Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:35",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Leu Hm.",
				"to": "Ţărţăl h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ţărţăl h.",
				"to": "Jianca",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jianca",
				"to": "Radomiru hc.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Radomiru hc.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "08:51",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Cezieni h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Cezieni h.",
				"to": "Caracal",
				"leavesAt": "09:03",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Caracal",
				"to": "Fărcaşele Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Stoeneşti h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "09:21",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Dăneasa h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dăneasa h.",
				"to": "Radomireşti Hm.",
				"leavesAt": "09:32",
				"arrivesAt": "09:39",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "09:40",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Măldăeni Hm.",
				"leavesAt": "09:50",
				"arrivesAt": "09:59",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "10:00",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "10:18",
				"arrivesAt": "10:25",
				"waitsAtSource": 660,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "10:26",
				"arrivesAt": "10:34",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "10:35",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "10:41",
				"arrivesAt": "10:50",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "10:51",
				"arrivesAt": "11:00",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "11:01",
				"arrivesAt": "11:09",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "11:10",
				"arrivesAt": "11:19",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:26",
				"waitsAtSource": 120,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "11:27",
				"arrivesAt": "11:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "11:32",
				"arrivesAt": "11:40",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Grădinari",
				"leavesAt": "11:41",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "11:54",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "12:01",
				"arrivesAt": "12:17",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "12:18",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:26",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "12:27",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9593",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Săcălaz h.",
				"leavesAt": "19:36",
				"arrivesAt": "19:46",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Săcălaz h.",
				"to": "Beregsău hcv.",
				"leavesAt": "19:47",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Beregsău hcv.",
				"to": "Cărpiniş",
				"leavesAt": "19:55",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Cărpiniş",
				"to": "Clarii Vii h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Clarii Vii h.",
				"to": "Jimbolia",
				"leavesAt": "20:11",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7588",
		"segments": [
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:18",
				"waitsAtSource": 0,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "15:19",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "15:25",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4330",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "23:31",
				"arrivesAt": "23:36",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "23:37",
				"arrivesAt": "23:43",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "23:44",
				"arrivesAt": "23:52",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "23:53",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "23:57",
				"arrivesAt": "00:01",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "00:02",
				"arrivesAt": "00:14",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1783",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "09:30",
				"arrivesAt": "10:31",
				"waitsAtSource": 0,
				"distance": 48100
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "10:36",
				"arrivesAt": "10:55",
				"waitsAtSource": 300,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "10:56",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "11:26",
				"arrivesAt": "11:37",
				"waitsAtSource": 360,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6504",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "06:17",
				"arrivesAt": "06:24",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Remiza T Socola h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Remiza T Socola h.",
				"to": "Holboca Hm.",
				"leavesAt": "06:36",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "06:43",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8201",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Sud",
				"leavesAt": "07:50",
				"arrivesAt": "07:55",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Buzău Sud",
				"to": "Tăbărăşti h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "08:12",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Vizireni h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vizireni h.",
				"to": "CTF Făurei h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "CTF Făurei h.",
				"to": "Făurei",
				"leavesAt": "08:40",
				"arrivesAt": "08:47",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Făurei",
				"to": "Cireşu Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "09:02",
				"waitsAtSource": 120,
				"distance": 15700
			},
			{
				"from": "Cireşu Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "09:03",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Dudeşti Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Spicu",
				"leavesAt": "09:14",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Spicu",
				"to": "Murgeanca Hm.",
				"leavesAt": "09:22",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Ţăndărei",
				"leavesAt": "09:30",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Ţăndărei",
				"to": "Platoneşti h.",
				"leavesAt": "09:43",
				"arrivesAt": "09:51",
				"waitsAtSource": 120,
				"distance": 6000
			},
			{
				"from": "Platoneşti h.",
				"to": "Movila Hm.",
				"leavesAt": "09:52",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "10:05",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "10:25",
				"arrivesAt": "10:32",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Cernavodă Pod",
				"leavesAt": "10:33",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "10:49",
				"arrivesAt": "10:56",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "10:57",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "11:03",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "11:12",
				"arrivesAt": "11:17",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "11:18",
				"arrivesAt": "11:21",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:26",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "11:27",
				"arrivesAt": "11:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "11:41",
				"arrivesAt": "11:44",
				"waitsAtSource": 600,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "11:45",
				"arrivesAt": "11:49",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "11:50",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "11:56",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1552",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "06:50",
				"arrivesAt": "06:57",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Crivina",
				"leavesAt": "07:01",
				"arrivesAt": "07:17",
				"waitsAtSource": 240,
				"distance": 16900
			},
			{
				"from": "Crivina",
				"to": "Buftea",
				"leavesAt": "07:18",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "07:35",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5460",
		"segments": [
			{
				"from": "Piatra Neamţ",
				"to": "Dumbrava h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Săvineşti h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săvineşti h.",
				"to": "Roznov",
				"leavesAt": "05:17",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Roznov",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Podoleni Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Podoleni Hm.",
				"to": "Costişa h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Costişa h.",
				"to": "Buhuşi",
				"leavesAt": "05:45",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhuşi",
				"to": "Racova h.",
				"leavesAt": "05:55",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Racova h.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Gârleni Hm.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gârleni Hm.",
				"to": "Hămeiuş P.M.",
				"leavesAt": "06:11",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Bacău",
				"leavesAt": "06:18",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 7900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7033",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "07:10",
				"arrivesAt": "07:16",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "07:17",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Chitila",
				"leavesAt": "07:21",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chitila",
				"to": "Mogoşoaia",
				"leavesAt": "07:27",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Mogoşoaia",
				"to": "P.O. Aeroport h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "07:55",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "08:01",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "08:07",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "08:13",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "08:33",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "08:44",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3011",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "20:16",
				"arrivesAt": "20:24",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "20:29",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Periş",
				"leavesAt": "20:36",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 13300
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "20:53",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "20:58",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "21:03",
				"arrivesAt": "21:11",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Vest",
				"leavesAt": "21:12",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Ploieşti Vest",
				"to": "Floreşti Prahova",
				"leavesAt": "21:21",
				"arrivesAt": "21:35",
				"waitsAtSource": 120,
				"distance": 18600
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "21:36",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "21:49",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Comarnic",
				"leavesAt": "21:55",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "22:12",
				"arrivesAt": "22:27",
				"waitsAtSource": 540,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "22:29",
				"arrivesAt": "22:34",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "22:35",
				"arrivesAt": "22:39",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "22:40",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "22:46",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "22:58",
				"arrivesAt": "23:13",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Dârste",
				"leavesAt": "23:14",
				"arrivesAt": "23:29",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "23:30",
				"arrivesAt": "23:40",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9369",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Ţigăneşti h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:32",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Ţigăneşti h.",
				"to": "Brânceni h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Brânceni h.",
				"to": "Smârdioasa h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Smârdioasa h.",
				"to": "Păuleasa h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Păuleasa h.",
				"to": "Şoimu h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Şoimu h.",
				"to": "Ulmuleţ h.",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Ulmuleţ h.",
				"to": "Zimnicea",
				"leavesAt": "16:05",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 9800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "472",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "17:45",
				"arrivesAt": "18:23",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Sinaia",
				"leavesAt": "18:25",
				"arrivesAt": "19:09",
				"waitsAtSource": 120,
				"distance": 62100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "19:10",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Predeal",
				"leavesAt": "19:18",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 11400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "19:33",
				"arrivesAt": "20:11",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Codlea Hm.",
				"leavesAt": "20:23",
				"arrivesAt": "20:39",
				"waitsAtSource": 720,
				"distance": 13800
			},
			{
				"from": "Codlea Hm.",
				"to": "Făgăraş",
				"leavesAt": "20:40",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 51200
			},
			{
				"from": "Făgăraş",
				"to": "Sibiu",
				"leavesAt": "21:39",
				"arrivesAt": "22:57",
				"waitsAtSource": 240,
				"distance": 83900
			},
			{
				"from": "Sibiu",
				"to": "Sebeş Alba",
				"leavesAt": "23:02",
				"arrivesAt": "00:36",
				"waitsAtSource": 300,
				"distance": 73700
			},
			{
				"from": "Sebeş Alba",
				"to": "Vinţu de Jos",
				"leavesAt": "00:37",
				"arrivesAt": "00:47",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vinţu de Jos",
				"to": "Orăştie",
				"leavesAt": "00:48",
				"arrivesAt": "01:26",
				"waitsAtSource": 60,
				"distance": 27300
			},
			{
				"from": "Orăştie",
				"to": "Simeria",
				"leavesAt": "01:30",
				"arrivesAt": "01:53",
				"waitsAtSource": 240,
				"distance": 16500
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "02:05",
				"arrivesAt": "02:16",
				"waitsAtSource": 720,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Arad",
				"leavesAt": "02:18",
				"arrivesAt": "05:06",
				"waitsAtSource": 120,
				"distance": 148200
			},
			{
				"from": "Arad",
				"to": "Curtici",
				"leavesAt": "05:11",
				"arrivesAt": "05:24",
				"waitsAtSource": 300,
				"distance": 17000
			},
			{
				"from": "Curtici",
				"to": "Lokoshaza",
				"leavesAt": "05:59",
				"arrivesAt": "06:09",
				"waitsAtSource": 2100,
				"distance": 11200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9412",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:10",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "07:11",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "07:20",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "07:52",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "08:14",
				"arrivesAt": "08:25",
				"waitsAtSource": 360,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Suseni h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 540,
				"distance": 4400
			},
			{
				"from": "Suseni h.",
				"to": "Pârvu h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pârvu h.",
				"to": "Pârvu Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Pârvu Hm.",
				"to": "Bradu de Sus",
				"leavesAt": "08:54",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "09:08",
				"arrivesAt": "09:10",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			},
			{
				"from": "18991230",
				"to": "20171225",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2853",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "06:10",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "06:19",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "06:47",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "06:54",
				"arrivesAt": "07:07",
				"waitsAtSource": 120,
				"distance": 11500
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Termo Turceni h.",
				"leavesAt": "07:13",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Termo Turceni h.",
				"to": "Turceni",
				"leavesAt": "07:19",
				"arrivesAt": "07:22",
				"waitsAtSource": 120,
				"distance": 900
			},
			{
				"from": "Turceni",
				"to": "Gârbovu h.",
				"leavesAt": "07:24",
				"arrivesAt": "07:29",
				"waitsAtSource": 120,
				"distance": 6600
			},
			{
				"from": "Gârbovu h.",
				"to": "Sărdăneşti h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Plopşoru",
				"leavesAt": "07:36",
				"arrivesAt": "07:41",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Plopşoru",
				"to": "Peşteana Jiu h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Bâlteni h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:52",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bâlteni h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "07:53",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Rovinari Sud h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Rovinari Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Hm.",
				"to": "Km. 49+800 h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rogojelu",
				"leavesAt": "08:14",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Rogojelu",
				"to": "Vârţ h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Vârţ h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Drăguţeşti h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Amaradia",
				"leavesAt": "08:37",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Amaradia",
				"to": "Târgu Jiu",
				"leavesAt": "08:42",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2075",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Găneasa h.",
				"leavesAt": "12:42",
				"arrivesAt": "12:46",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Găneasa h.",
				"to": "Găneasa Olt h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:50",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Arceşti Hm.",
				"leavesAt": "12:51",
				"arrivesAt": "12:56",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Colibaşi h.",
				"leavesAt": "12:57",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Strejeşti",
				"leavesAt": "13:04",
				"arrivesAt": "13:10",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Strejeşti",
				"to": "Zlătărei Hm.",
				"leavesAt": "13:11",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Drăgăşani",
				"leavesAt": "13:18",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Drăgăşani",
				"to": "Călina h.",
				"leavesAt": "13:27",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Călina h.",
				"to": "Zăvideni Hm.",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "13:40",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Orleşti hc.",
				"to": "Fişcălia Hm.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Ioneşti Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "13:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Slăviteşti hc.",
				"leavesAt": "14:05",
				"arrivesAt": "14:11",
				"waitsAtSource": 420,
				"distance": 6400
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Băbeni",
				"leavesAt": "14:12",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "14:21",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "14:25",
				"arrivesAt": "14:33",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "14:34",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "14:38",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:54",
				"waitsAtSource": 420,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "14:55",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "15:00",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4503",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "05:00",
				"arrivesAt": "05:08",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:15",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "05:16",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "05:37",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 420,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:04",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "06:06",
				"arrivesAt": "06:17",
				"waitsAtSource": 120,
				"distance": 10100
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Şugău h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şugău h.",
				"to": "Valea Strâmbă h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Gheorgheni",
				"leavesAt": "06:26",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Gheorgheni",
				"to": "Lăzarea Hm.",
				"leavesAt": "06:35",
				"arrivesAt": "06:40",
				"waitsAtSource": 300,
				"distance": 4400
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Ditrău",
				"leavesAt": "06:41",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ditrău",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:12",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "07:13",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Topliţa",
				"leavesAt": "07:28",
				"arrivesAt": "07:36",
				"waitsAtSource": 420,
				"distance": 6000
			},
			{
				"from": "Topliţa",
				"to": "Ciobotani h.",
				"leavesAt": "07:38",
				"arrivesAt": "07:47",
				"waitsAtSource": 120,
				"distance": 6600
			},
			{
				"from": "Ciobotani h.",
				"to": "Stânceni Hm.",
				"leavesAt": "07:48",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Stânceni Hm.",
				"to": "Stânceni h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Andreneasa h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Andreneasa h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "08:29",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Borzia h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Borzia h.",
				"to": "Deda Bistra Hm.",
				"leavesAt": "08:44",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Deda",
				"leavesAt": "08:56",
				"arrivesAt": "09:06",
				"waitsAtSource": 420,
				"distance": 3900
			},
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "09:21",
				"arrivesAt": "09:26",
				"waitsAtSource": 900,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "09:27",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "09:30",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "09:35",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:44",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "09:45",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "09:55",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:08",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "10:09",
				"arrivesAt": "10:14",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "10:15",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "10:21",
				"arrivesAt": "10:33",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "10:34",
				"arrivesAt": "10:42",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7586",
		"segments": [
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "14:01",
				"waitsAtSource": 0,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "14:02",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "14:09",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9373",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "19:45",
				"arrivesAt": "19:50",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:13",
				"waitsAtSource": 540,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "20:14",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "20:24",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:45",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "20:46",
				"arrivesAt": "20:52",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9589",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Săcălaz h.",
				"leavesAt": "13:40",
				"arrivesAt": "13:50",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Săcălaz h.",
				"to": "Beregsău hcv.",
				"leavesAt": "13:51",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Beregsău hcv.",
				"to": "Cărpiniş",
				"leavesAt": "13:59",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Cărpiniş",
				"to": "Clarii Vii h.",
				"leavesAt": "14:07",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Clarii Vii h.",
				"to": "Jimbolia",
				"leavesAt": "14:15",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4654",
		"segments": [
			{
				"from": "Sighetu Marmaţiei",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "23:40",
				"arrivesAt": "23:45",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Tisa h.",
				"leavesAt": "23:46",
				"arrivesAt": "23:53",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tisa h.",
				"to": "Crăciuneşti h.",
				"leavesAt": "23:54",
				"arrivesAt": "23:57",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "23:58",
				"arrivesAt": "00:04",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Lunca la Tisa h.",
				"leavesAt": "00:05",
				"arrivesAt": "00:09",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Valea Vişeului",
				"leavesAt": "00:10",
				"arrivesAt": "00:28",
				"waitsAtSource": 30,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 863
			},
			{
				"from": "20180125",
				"to": "20180407",
				"daysOfWeek": 863
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 863
			},
			{
				"from": "20180502",
				"to": "20180526",
				"daysOfWeek": 863
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 863
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 863
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 863
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 863
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 863
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 863
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9137",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(913)",
				"leavesAt": "17:00",
				"arrivesAt": "17:03",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Jiu Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Jiu Hm.",
				"to": "R. 1 Jiu",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "R. 1 Jiu",
				"to": "Podari",
				"leavesAt": "17:14",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Podari",
				"to": "Sălcuţa Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Dealul Robului h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dealul Robului h.",
				"to": "Segarcea Nord hc.",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Segarcea",
				"leavesAt": "17:51",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea",
				"to": "Cerăt h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cerăt h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Urzica Mare h.",
				"leavesAt": "18:11",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Urzica Mare h.",
				"to": "Afumaţi h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:29",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Afumaţi h.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "18:30",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Boureni P.M.",
				"leavesAt": "18:39",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Boureni P.M.",
				"to": "Băileşti",
				"leavesAt": "18:44",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Băileşti",
				"to": "Moţăţei Hm.",
				"leavesAt": "18:58",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 12800
			},
			{
				"from": "Moţăţei Hm.",
				"to": "Maglavit h.",
				"leavesAt": "19:21",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Maglavit h.",
				"to": "Golenţi Hm.",
				"leavesAt": "19:36",
				"arrivesAt": "19:51",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Golenţi Hm.",
				"to": "Calafat",
				"leavesAt": "19:52",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 11800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1654",
		"segments": [
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "21:48",
				"arrivesAt": "21:51",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Iacobeni",
				"leavesAt": "21:54",
				"arrivesAt": "22:09",
				"waitsAtSource": 180,
				"distance": 10200
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "22:10",
				"arrivesAt": "22:21",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Pojorâta Hm.",
				"leavesAt": "22:22",
				"arrivesAt": "22:43",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "22:44",
				"arrivesAt": "22:53",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "22:54",
				"arrivesAt": "23:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Vama",
				"leavesAt": "23:02",
				"arrivesAt": "23:16",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Vama",
				"to": "Frasin",
				"leavesAt": "23:17",
				"arrivesAt": "23:28",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "23:29",
				"arrivesAt": "23:37",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Suceava",
				"leavesAt": "23:38",
				"arrivesAt": "00:22",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "00:36",
				"arrivesAt": "00:49",
				"waitsAtSource": 840,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "00:50",
				"arrivesAt": "01:08",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "01:09",
				"arrivesAt": "01:25",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "01:27",
				"arrivesAt": "01:54",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "01:56",
				"arrivesAt": "02:25",
				"waitsAtSource": 120,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "02:37",
				"arrivesAt": "03:16",
				"waitsAtSource": 720,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "03:17",
				"arrivesAt": "03:44",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "03:48",
				"arrivesAt": "04:09",
				"waitsAtSource": 240,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "04:10",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "04:48",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "05:21",
				"arrivesAt": "05:54",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "05:56",
				"arrivesAt": "06:32",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "06:35",
				"arrivesAt": "07:28",
				"waitsAtSource": 180,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8657",
		"segments": [
			{
				"from": "Medgidia",
				"to": "Nicolae Bălcescu",
				"leavesAt": "16:45",
				"arrivesAt": "17:06",
				"waitsAtSource": 0,
				"distance": 19100
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Cogealac",
				"leavesAt": "17:25",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cogealac",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 17400
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Baia Dobrogea",
				"leavesAt": "18:06",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Baia Dobrogea",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Babadag",
				"leavesAt": "18:25",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Babadag",
				"to": "Zebil h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Zebil h.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Cataloi Hm.",
				"leavesAt": "19:15",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Cataloi Hm.",
				"to": "Tulcea Mărfuri",
				"leavesAt": "19:30",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Tulcea Oraş",
				"leavesAt": "19:44",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180610",
				"to": "20180910",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1699",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Recaş",
				"leavesAt": "16:23",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 23200
			},
			{
				"from": "Recaş",
				"to": "Lugoj",
				"leavesAt": "16:52",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 35700
			},
			{
				"from": "Lugoj",
				"to": "Caransebeş",
				"leavesAt": "17:19",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 39400
			},
			{
				"from": "Caransebeş",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:31",
				"waitsAtSource": 1380,
				"distance": 10400
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "18:32",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 29000
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9445",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:17",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "12:18",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Aninoasa Hm.",
				"leavesAt": "12:21",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Aninoasa Hm.",
				"to": "Săteni h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Săteni h.",
				"to": "Doiceşti",
				"leavesAt": "12:28",
				"arrivesAt": "12:31",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Doiceşti",
				"to": "Doiceşti h.",
				"leavesAt": "12:32",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Doiceşti h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "12:34",
				"arrivesAt": "12:37",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Scârlenţa h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Scârlenţa h.",
				"to": "Trainica h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:43",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Trainica h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "12:44",
				"arrivesAt": "12:48",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Moţăieni h.",
				"leavesAt": "12:49",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Moţăieni h.",
				"to": "Fieni",
				"leavesAt": "12:53",
				"arrivesAt": "12:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "12:59",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Pietroşiţa Hm.",
				"leavesAt": "13:03",
				"arrivesAt": "13:10",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9669",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "19:01",
				"arrivesAt": "19:11",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "19:12",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "19:16",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "19:24",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "19:32",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "19:39",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Deta Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Deta Hm.",
				"to": "Denta h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Denta h.",
				"to": "Stamora Moraviţa",
				"leavesAt": "20:08",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 8400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1535",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "20:30",
				"arrivesAt": "20:56",
				"waitsAtSource": 0,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "20:57",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "21:22",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "21:50",
				"arrivesAt": "22:00",
				"waitsAtSource": 420,
				"distance": 10800
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bratca",
				"leavesAt": "22:01",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "22:23",
				"arrivesAt": "22:30",
				"waitsAtSource": 720,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Aleşd",
				"leavesAt": "22:31",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Aleşd",
				"to": "Tileagd",
				"leavesAt": "22:51",
				"arrivesAt": "23:02",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Tileagd",
				"to": "Oradea",
				"leavesAt": "23:03",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 23100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4134",
		"segments": [
			{
				"from": "Sighetu Marmaţiei",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Tisa h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tisa h.",
				"to": "Crăciuneşti h.",
				"leavesAt": "15:55",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Lunca la Tisa h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Valea Vişeului",
				"leavesAt": "16:12",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Valea Vişeului",
				"to": "Vişeu Bistra h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:59",
				"waitsAtSource": 900,
				"distance": 8500
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Petrova hc.",
				"leavesAt": "17:00",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Petrova hc.",
				"to": "Leordina",
				"leavesAt": "17:10",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Leordina",
				"to": "Leordina h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Leordina h.",
				"to": "Bocicoel h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Bocicoel h.",
				"to": "Vişeu de Jos",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Vişeu de Jos",
				"to": "Iza P.M.",
				"leavesAt": "17:44",
				"arrivesAt": "17:56",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Iza P.M.",
				"to": "Săcel Hm.",
				"leavesAt": "17:57",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săcel Hm.",
				"to": "Dealu Ştefăniţei",
				"leavesAt": "18:08",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dealu Ştefăniţei",
				"to": "Romuli h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Romuli h.",
				"to": "Fiad Hm.",
				"leavesAt": "18:30",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Fiad Hm.",
				"to": "Telciu Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Telciu Hm.",
				"to": "Coşbuc Hm.",
				"leavesAt": "18:56",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Coşbuc Hm.",
				"to": "Salva",
				"leavesAt": "19:06",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Salva",
				"to": "Nimigea Hm.",
				"leavesAt": "19:23",
				"arrivesAt": "19:32",
				"waitsAtSource": 180,
				"distance": 7300
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "19:33",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "19:38",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "19:49",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Beclean pe Someş",
				"to": "Ciceu Cristur h.",
				"leavesAt": "20:00",
				"arrivesAt": "20:13",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "20:23",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "20:34",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "20:43",
				"arrivesAt": "21:02",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Iclod Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Iclod Hm.",
				"to": "Bonţida Hm.",
				"leavesAt": "21:16",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Bonţida Hm.",
				"to": "Apahida",
				"leavesAt": "21:25",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca Est",
				"leavesAt": "21:44",
				"arrivesAt": "21:52",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "21:53",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "21:59",
				"arrivesAt": "22:03",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1597",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "19:45",
				"arrivesAt": "20:36",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Gălăteni Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 15800
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "20:52",
				"arrivesAt": "21:25",
				"waitsAtSource": 60,
				"distance": 33400
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "21:27",
				"arrivesAt": "21:58",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "21:59",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "22:18",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4704",
		"segments": [
			{
				"from": "Salva",
				"to": "Năsăud h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:09",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Năsăud h.",
				"to": "Năsăud",
				"leavesAt": "18:10",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Năsăud",
				"to": "Rebrişoara Hm.",
				"leavesAt": "18:14",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Nepos h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Nepos h.",
				"to": "Feldru Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Feldru Hm.",
				"to": "Podereia Feldrului h.",
				"leavesAt": "18:34",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Ilva Mică",
				"leavesAt": "18:38",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5053",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "13:46",
				"arrivesAt": "13:52",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "13:53",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "14:02",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:09",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "14:10",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "14:16",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "14:22",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "14:50",
				"arrivesAt": "14:57",
				"waitsAtSource": 540,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "14:58",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "15:04",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "15:09",
				"arrivesAt": "15:21",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:33",
				"waitsAtSource": 120,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "15:45",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "16:07",
				"arrivesAt": "16:14",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "16:15",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "16:32",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "16:44",
				"arrivesAt": "16:57",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "16:58",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2594",
		"segments": [
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:01",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "16:09",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Hăşag h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:29",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:57",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "16:58",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 799
			},
			{
				"from": "20180114",
				"to": "20180203",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180616",
				"daysOfWeek": 799
			},
			{
				"from": "20180618",
				"to": "20180624",
				"daysOfWeek": 799
			},
			{
				"from": "20180806",
				"to": "20180806",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			},
			{
				"from": "18991230",
				"to": "20180617",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1668",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "23:08",
				"arrivesAt": "23:14",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "23:16",
				"arrivesAt": "23:38",
				"waitsAtSource": 120,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "23:39",
				"arrivesAt": "00:01",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "00:02",
				"arrivesAt": "00:20",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "00:30",
				"arrivesAt": "00:44",
				"waitsAtSource": 600,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "00:45",
				"arrivesAt": "01:18",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tecuci",
				"leavesAt": "01:22",
				"arrivesAt": "02:07",
				"waitsAtSource": 240,
				"distance": 50300
			},
			{
				"from": "Tecuci",
				"to": "Focşani",
				"leavesAt": "02:20",
				"arrivesAt": "03:07",
				"waitsAtSource": 780,
				"distance": 36500
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "03:09",
				"arrivesAt": "03:46",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "03:47",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "04:20",
				"arrivesAt": "04:53",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "04:55",
				"arrivesAt": "05:31",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "05:34",
				"arrivesAt": "06:28",
				"waitsAtSource": 180,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9609",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Buziaş",
				"leavesAt": "04:16",
				"arrivesAt": "04:56",
				"waitsAtSource": 0,
				"distance": 36400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2045",
		"segments": [
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:46",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "15:47",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "15:54",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "16:07",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "16:21",
				"arrivesAt": "16:28",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "16:44",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "16:49",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "17:17",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Săvârşin",
				"to": "Vărădia h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vărădia h.",
				"to": "Vărădia Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărădia Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Căpruţa h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Căpruţa h.",
				"to": "Bârzava",
				"leavesAt": "17:55",
				"arrivesAt": "18:00",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Bârzava",
				"to": "Nadăş h.",
				"leavesAt": "18:01",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nadăş h.",
				"to": "Conop Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Conop Hm.",
				"to": "Corfeni h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Corfeni h.",
				"to": "Milova",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Milova",
				"to": "Radna",
				"leavesAt": "18:24",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Radna",
				"to": "Păuliş Hm.",
				"leavesAt": "18:35",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Păuliş Hm.",
				"to": "Păuliş h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş h.",
				"to": "Ghioroc",
				"leavesAt": "18:50",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ghioroc",
				"to": "Glogovăţ",
				"leavesAt": "19:01",
				"arrivesAt": "19:13",
				"waitsAtSource": 240,
				"distance": 14200
			},
			{
				"from": "Glogovăţ",
				"to": "Arad",
				"leavesAt": "19:14",
				"arrivesAt": "19:22",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5563",
		"segments": [
			{
				"from": "Botoşani",
				"to": "Leorda Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "09:07",
				"waitsAtSource": 0,
				"distance": 15500
			},
			{
				"from": "Leorda Hm.",
				"to": "Bucecea Hm",
				"leavesAt": "09:08",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bucecea Hm",
				"to": "Bursuceni h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bursuceni h.",
				"to": "Vereşti",
				"leavesAt": "09:44",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "09:57",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "10:05",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "10:16",
				"arrivesAt": "10:22",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5406",
		"segments": [
			{
				"from": "Bacău",
				"to": "Letea h.",
				"leavesAt": "20:57",
				"arrivesAt": "21:03",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Letea h.",
				"to": "Valea Seacă",
				"leavesAt": "21:04",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Seacă",
				"to": "Siretu Bacău h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Faraoani Hm.",
				"leavesAt": "21:15",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Faraoani Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "21:21",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Răcăciuni h.",
				"to": "Orbeni Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Orbeni Hm.",
				"to": "Sascut Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Sascut Hm.",
				"to": "Şişcani h.",
				"leavesAt": "21:48",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Şişcani h.",
				"to": "Adjudu Vechi h.",
				"leavesAt": "21:55",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Adjud",
				"leavesAt": "22:00",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "22:06",
				"arrivesAt": "22:14",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "22:15",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "22:20",
				"arrivesAt": "22:25",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "22:26",
				"arrivesAt": "22:30",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "22:31",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5112",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:49",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "16:50",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:18",
				"waitsAtSource": 120,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "17:19",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "17:29",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "17:46",
				"arrivesAt": "17:56",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "17:57",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "18:20",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 11500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9389",
		"segments": [
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:45",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "16:59",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "17:07",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "17:13",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Malu Mare Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "17:40",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5570",
		"segments": [
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "06:23",
				"arrivesAt": "06:32",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "06:33",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Bursuceni h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:53",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Bursuceni h.",
				"to": "Bucecea Hm",
				"leavesAt": "06:54",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "07:12",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "07:32",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9501",
		"segments": [
			{
				"from": "Filiaşi",
				"to": "Gura Motrului Hm.",
				"leavesAt": "04:22",
				"arrivesAt": "04:30",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Butoieşti Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Lunca Banului h.",
				"leavesAt": "04:38",
				"arrivesAt": "04:44",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lunca Banului h.",
				"to": "Strehaia",
				"leavesAt": "04:45",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Strehaia",
				"to": "Strehaia hc.",
				"leavesAt": "04:51",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia hc.",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "04:55",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Tâmna",
				"leavesAt": "05:04",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Tâmna",
				"to": "Igiroasa Hm.",
				"leavesAt": "05:13",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "05:19",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prunişor Hm.",
				"to": "Gârniţa Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:33",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Balota",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Balota",
				"to": "Valea Albă Hm.",
				"leavesAt": "05:39",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Ergheviţa h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ergheviţa h.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "05:57",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Dinamica h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:22",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Dinamica h.",
				"to": "Gura Văii Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Gura Văii Hm.",
				"to": "Jidoştiţa h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Jidoştiţa h.",
				"to": "Vârciorova Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Vârciorova Hm.",
				"to": "Iloviţa h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Iloviţa h.",
				"to": "Şantier Naval h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Şantier Naval h.",
				"to": "Orşova",
				"leavesAt": "06:51",
				"arrivesAt": "06:57",
				"waitsAtSource": 30,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1589",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "17:00",
				"arrivesAt": "17:55",
				"waitsAtSource": 0,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "17:56",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "18:20",
				"arrivesAt": "18:38",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "18:39",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "18:56",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5001",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "04:50",
				"arrivesAt": "04:58",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "04:59",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "05:03",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "05:14",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "05:27",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "05:37",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "05:49",
				"arrivesAt": "06:02",
				"waitsAtSource": 240,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "06:05",
				"arrivesAt": "06:10",
				"waitsAtSource": 180,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "06:11",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "06:21",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:28",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "06:29",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:39",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "06:40",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "07:07",
				"arrivesAt": "07:14",
				"waitsAtSource": 540,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "07:15",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "07:21",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "07:26",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8592",
		"segments": [
			{
				"from": "Călăraşi Sud",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:43",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Ştefan Vodă h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Ciulniţa",
				"leavesAt": "07:52",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 12600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5412",
		"segments": [
			{
				"from": "Bacău",
				"to": "Letea h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:46",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Letea h.",
				"to": "Valea Seacă",
				"leavesAt": "06:47",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Seacă",
				"to": "Siretu Bacău h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Faraoani Hm.",
				"leavesAt": "06:58",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Faraoani Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "07:04",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Răcăciuni h.",
				"to": "Orbeni Hm.",
				"leavesAt": "07:11",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Orbeni Hm.",
				"to": "Sascut Hm.",
				"leavesAt": "07:32",
				"arrivesAt": "07:39",
				"waitsAtSource": 600,
				"distance": 9200
			},
			{
				"from": "Sascut Hm.",
				"to": "Şişcani h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Şişcani h.",
				"to": "Adjudu Vechi h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Adjud",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1931",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "16:05",
				"arrivesAt": "16:12",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "16:13",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "16:21",
				"arrivesAt": "16:34",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "16:44",
				"arrivesAt": "16:59",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "17:07",
				"arrivesAt": "17:14",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "17:15",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "18:05",
				"arrivesAt": "18:32",
				"waitsAtSource": 1560,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "18:33",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "18:53",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "19:16",
				"arrivesAt": "19:41",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Băneasa",
				"leavesAt": "19:42",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 102300
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Ploieşti Vest",
				"leavesAt": "20:39",
				"arrivesAt": "21:27",
				"waitsAtSource": 180,
				"distance": 58100
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "21:29",
				"arrivesAt": "21:54",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Comarnic",
				"leavesAt": "21:55",
				"arrivesAt": "22:07",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "22:08",
				"arrivesAt": "22:21",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "22:23",
				"arrivesAt": "22:31",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "22:32",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "22:38",
				"arrivesAt": "22:48",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "22:50",
				"arrivesAt": "23:30",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Rupea",
				"leavesAt": "23:50",
				"arrivesAt": "01:26",
				"waitsAtSource": 1200,
				"distance": 73800
			},
			{
				"from": "Rupea",
				"to": "Sighişoara",
				"leavesAt": "01:28",
				"arrivesAt": "02:37",
				"waitsAtSource": 120,
				"distance": 53600
			},
			{
				"from": "Sighişoara",
				"to": "Mediaş",
				"leavesAt": "02:44",
				"arrivesAt": "03:38",
				"waitsAtSource": 420,
				"distance": 38400
			},
			{
				"from": "Mediaş",
				"to": "Copşa Mică",
				"leavesAt": "03:40",
				"arrivesAt": "03:54",
				"waitsAtSource": 120,
				"distance": 10400
			},
			{
				"from": "Copşa Mică",
				"to": "Blaj",
				"leavesAt": "03:55",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Blaj",
				"to": "Teiuş",
				"leavesAt": "04:35",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 21300
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "05:09",
				"arrivesAt": "05:24",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Războieni",
				"leavesAt": "05:25",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "05:48",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "06:05",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 51500
			},
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "07:28",
				"arrivesAt": "07:58",
				"waitsAtSource": 1020,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "07:59",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:56",
				"waitsAtSource": 120,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "09:09",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Bratca",
				"leavesAt": "09:20",
				"arrivesAt": "09:28",
				"waitsAtSource": 300,
				"distance": 5900
			},
			{
				"from": "Bratca",
				"to": "Aleşd",
				"leavesAt": "09:29",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 25300
			},
			{
				"from": "Aleşd",
				"to": "Tileagd",
				"leavesAt": "09:59",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Tileagd",
				"to": "Oradea",
				"leavesAt": "10:19",
				"arrivesAt": "10:40",
				"waitsAtSource": 360,
				"distance": 23100
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4533",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Azomureş h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:42",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "14:43",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "14:47",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Vidrasău h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vidrasău h.",
				"to": "Chirileu h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Chirileu h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "15:03",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Ogra h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ogra h.",
				"to": "Cipău h.",
				"leavesAt": "15:13",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cipău h.",
				"to": "Iernut",
				"leavesAt": "15:18",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iernut",
				"to": "Cuci h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:30",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Cuci h.",
				"to": "Bogata Mureş h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Luduş",
				"leavesAt": "15:38",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Luduş",
				"to": "Cheţani h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Cheţani h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Gura Arieşului h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Lunca Mureşului h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Războieni",
				"leavesAt": "16:06",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5429",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:54",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "20:55",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "21:00",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "21:16",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "21:21",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "21:30",
				"arrivesAt": "21:37",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "21:38",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "21:45",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "21:50",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "21:56",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "22:01",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "22:06",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "22:41",
				"arrivesAt": "22:55",
				"waitsAtSource": 1500,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "22:56",
				"arrivesAt": "23:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "23:04",
				"arrivesAt": "23:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "23:10",
				"arrivesAt": "23:18",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "23:19",
				"arrivesAt": "23:29",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "23:30",
				"arrivesAt": "23:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "23:37",
				"arrivesAt": "23:43",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "23:44",
				"arrivesAt": "23:51",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "23:52",
				"arrivesAt": "00:07",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9512",
		"segments": [
			{
				"from": "Drobeta Tr. Severin",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Ergheviţa h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ergheviţa h.",
				"to": "Valea Albă Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Balota",
				"leavesAt": "08:25",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Balota",
				"to": "Gârniţa Hm.",
				"leavesAt": "08:38",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Prunişor Hm.",
				"to": "Igiroasa Hm.",
				"leavesAt": "08:50",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Tâmna",
				"leavesAt": "08:57",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Tâmna",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Strehaia hc.",
				"leavesAt": "09:14",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strehaia hc.",
				"to": "Strehaia",
				"leavesAt": "09:20",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia",
				"to": "Lunca Banului h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Lunca Banului h.",
				"to": "Butoieşti Hm.",
				"leavesAt": "09:33",
				"arrivesAt": "09:40",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Gura Motrului Hm.",
				"leavesAt": "09:41",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Filiaşi",
				"leavesAt": "09:48",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 448
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9064",
		"segments": [
			{
				"from": "Corabia",
				"to": "Vişina Veche hc.",
				"leavesAt": "15:30",
				"arrivesAt": "15:44",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Vişina Veche hc.",
				"to": "Vişina h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vişina h.",
				"to": "Studina hc.",
				"leavesAt": "15:49",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Studina hc.",
				"to": "Studiniţa h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:02",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Studiniţa h.",
				"to": "Frăsinet hc.",
				"leavesAt": "16:03",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Frăsinet hc.",
				"to": "Deveselu h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:16",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Deveselu h.",
				"to": "Grupa Tehnică Caracal Hm.",
				"leavesAt": "16:17",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Grupa Tehnică Caracal Hm.",
				"to": "Canton 239+700 h.",
				"leavesAt": "16:23",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Canton 239+700 h.",
				"to": "Caracal",
				"leavesAt": "16:27",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 1400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8224",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "16:42",
				"arrivesAt": "16:48",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "16:49",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:19",
				"waitsAtSource": 480,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "17:29",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "17:46",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "18:00",
				"arrivesAt": "18:09",
				"waitsAtSource": 540,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Dunărea Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Dunărea Hm.",
				"to": "Ramificaţia Borcea",
				"leavesAt": "18:20",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "18:33",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "18:46",
				"arrivesAt": "19:04",
				"waitsAtSource": 420,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Platoneşti h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Platoneşti h.",
				"to": "Ţăndărei",
				"leavesAt": "19:14",
				"arrivesAt": "19:22",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ţăndărei",
				"to": "Murgeanca Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:37",
				"waitsAtSource": 180,
				"distance": 12200
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Spicu",
				"leavesAt": "19:38",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spicu",
				"to": "Dudeşti Hm.",
				"leavesAt": "19:48",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Cireşu Hm.",
				"leavesAt": "20:07",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cireşu Hm.",
				"to": "Făurei",
				"leavesAt": "20:15",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 15700
			},
			{
				"from": "Făurei",
				"to": "Vizireni h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:42",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 480,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "21:01",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:14",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "21:15",
				"arrivesAt": "21:19",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "21:20",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău Sud",
				"leavesAt": "21:24",
				"arrivesAt": "21:30",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Buzău Sud",
				"to": "Buzău",
				"leavesAt": "21:31",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2211",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "18:25",
				"arrivesAt": "18:35",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "18:36",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6509",
		"segments": [
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "19:42",
				"arrivesAt": "19:50",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Socola",
				"leavesAt": "19:58",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "20:09",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "20:15",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1891",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "05:55",
				"arrivesAt": "06:54",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "06:55",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "07:15",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "07:39",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Piteşti",
				"to": "Costeşti",
				"leavesAt": "08:08",
				"arrivesAt": "08:31",
				"waitsAtSource": 1080,
				"distance": 21800
			},
			{
				"from": "Costeşti",
				"to": "Stolnici Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Stolnici Hm.",
				"to": "Corbu",
				"leavesAt": "08:47",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Corbu",
				"to": "Slatina",
				"leavesAt": "09:03",
				"arrivesAt": "09:34",
				"waitsAtSource": 240,
				"distance": 33500
			},
			{
				"from": "Slatina",
				"to": "Piatra Olt",
				"leavesAt": "09:36",
				"arrivesAt": "09:54",
				"waitsAtSource": 120,
				"distance": 17000
			},
			{
				"from": "Piatra Olt",
				"to": "Balş",
				"leavesAt": "09:55",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Balş",
				"to": "Craiova",
				"leavesAt": "10:07",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 31200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9401",
		"segments": [
			{
				"from": "Caracal",
				"to": "Romula Hm.",
				"leavesAt": "05:34",
				"arrivesAt": "05:46",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Romula Hm.",
				"to": "Fălcoiu h.",
				"leavesAt": "05:47",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fălcoiu h.",
				"to": "Vlăduleni",
				"leavesAt": "05:56",
				"arrivesAt": "06:04",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vlăduleni",
				"to": "Şopârliţa hc.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Piatra Olt",
				"leavesAt": "06:10",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 420,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:10",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "07:11",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "07:20",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "07:52",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "08:14",
				"arrivesAt": "08:25",
				"waitsAtSource": 360,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Suseni h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 540,
				"distance": 4400
			},
			{
				"from": "Suseni h.",
				"to": "Pârvu h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pârvu h.",
				"to": "Pârvu Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Pârvu Hm.",
				"to": "Bradu de Sus",
				"leavesAt": "08:54",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "09:08",
				"arrivesAt": "09:10",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20181130",
				"daysOfWeek": 319
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "37647",
		"segments": [
			{
				"from": "Salonta",
				"to": "Kotegyan",
				"leavesAt": "09:40",
				"arrivesAt": "10:00",
				"waitsAtSource": 0,
				"distance": 13200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8031",
		"segments": [
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "04:53",
				"arrivesAt": "05:00",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Cernavodă Pod",
				"leavesAt": "05:01",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "05:22",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "05:41",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "06:07",
				"arrivesAt": "06:12",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "06:23",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "06:29",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181209",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5204",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "12:07",
				"arrivesAt": "12:15",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Mihăileni Hm.",
				"leavesAt": "12:16",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "12:24",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:34",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Caracău h.",
				"leavesAt": "12:35",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Caracău h.",
				"to": "Livezi Ciuc",
				"leavesAt": "12:41",
				"arrivesAt": "12:45",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Utuşoiu h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:54",
				"waitsAtSource": 180,
				"distance": 4100
			},
			{
				"from": "Utuşoiu h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "12:55",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Tarcău h.",
				"leavesAt": "13:02",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "13:07",
				"arrivesAt": "13:12",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Bolovăniş h.",
				"leavesAt": "13:13",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Ghimeş",
				"leavesAt": "13:20",
				"arrivesAt": "13:26",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Ghimeş",
				"to": "Palanca Hm.",
				"leavesAt": "13:31",
				"arrivesAt": "13:38",
				"waitsAtSource": 300,
				"distance": 5200
			},
			{
				"from": "Palanca Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "13:39",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Simbrea Hm.",
				"leavesAt": "13:46",
				"arrivesAt": "13:52",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Simbrea Hm.",
				"to": "Goioasa Hm.",
				"leavesAt": "13:53",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Goioasa Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "14:03",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Caraliţa h.",
				"to": "Asău Hm.",
				"leavesAt": "14:09",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Asău Hm.",
				"to": "Comăneşti",
				"leavesAt": "14:16",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:42",
				"waitsAtSource": 300,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:52",
				"waitsAtSource": 480,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "14:53",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "15:18",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Oneşti",
				"leavesAt": "15:23",
				"arrivesAt": "15:35",
				"waitsAtSource": 30,
				"distance": 9100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5739",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "19:37",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Părhăuţi h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:59",
				"waitsAtSource": 360,
				"distance": 4400
			},
			{
				"from": "Părhăuţi h.",
				"to": "Todireşti h.",
				"leavesAt": "20:00",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Todireşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Soloneţ h.",
				"to": "Pârteşti h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pârteşti h.",
				"to": "Cacica Hm.",
				"leavesAt": "20:24",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3003",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:47",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "07:48",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "07:51",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "07:55",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "07:58",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "08:02",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "08:14",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "08:27",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:41",
				"waitsAtSource": 360,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "08:42",
				"arrivesAt": "08:49",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "08:53",
				"arrivesAt": "08:57",
				"waitsAtSource": 240,
				"distance": 4600
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Ploieşti Vest",
				"leavesAt": "08:58",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "09:11",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Bobolia h.",
				"leavesAt": "09:21",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Bobolia h.",
				"to": "Câmpina",
				"leavesAt": "09:29",
				"arrivesAt": "09:36",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "09:37",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "09:43",
				"arrivesAt": "09:46",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "09:47",
				"arrivesAt": "09:50",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "09:51",
				"arrivesAt": "09:55",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Posada h.",
				"leavesAt": "09:56",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Posada h.",
				"to": "Sinaia Sud h.",
				"leavesAt": "10:02",
				"arrivesAt": "10:11",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "10:12",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "10:17",
				"arrivesAt": "10:22",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "10:23",
				"arrivesAt": "10:27",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "10:28",
				"arrivesAt": "10:33",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "10:34",
				"arrivesAt": "10:44",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "10:46",
				"arrivesAt": "11:01",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Timişu de Jos h.",
				"leavesAt": "11:02",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Dârste",
				"leavesAt": "11:11",
				"arrivesAt": "11:19",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "11:20",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2513",
		"segments": [
			{
				"from": "Făgăraş",
				"to": "Dridif h.",
				"leavesAt": "03:33",
				"arrivesAt": "03:43",
				"waitsAtSource": 0,
				"distance": 8500
			},
			{
				"from": "Dridif h.",
				"to": "Voila Hm.",
				"leavesAt": "03:44",
				"arrivesAt": "03:48",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Voila Hm.",
				"to": "Olteţ h.",
				"leavesAt": "03:49",
				"arrivesAt": "03:55",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Olteţ h.",
				"to": "Viştea h.",
				"leavesAt": "03:56",
				"arrivesAt": "04:00",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Viştea h.",
				"to": "Ucea",
				"leavesAt": "04:01",
				"arrivesAt": "04:05",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "04:06",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "04:19",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:33",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "04:34",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:53",
				"waitsAtSource": 300,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "05:08",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:34",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1655",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Triaj",
				"leavesAt": "07:10",
				"arrivesAt": "07:55",
				"waitsAtSource": 0,
				"distance": 56600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Ploieşti Sud",
				"leavesAt": "07:59",
				"arrivesAt": "08:06",
				"waitsAtSource": 240,
				"distance": 3600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Cricov Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:26",
				"waitsAtSource": 120,
				"distance": 16700
			},
			{
				"from": "Cricov Hm.",
				"to": "Mizil",
				"leavesAt": "08:27",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 16900
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "08:43",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "09:20",
				"arrivesAt": "09:51",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "09:52",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "10:32",
				"arrivesAt": "10:54",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "10:56",
				"arrivesAt": "11:22",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "11:24",
				"arrivesAt": "12:01",
				"waitsAtSource": 120,
				"distance": 58200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9105",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:43",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "16:44",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "16:55",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "16:59",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "17:56",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:12",
				"waitsAtSource": 300,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "18:22",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "18:26",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "18:36",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "18:41",
				"arrivesAt": "18:49",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3115",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "13:06",
				"arrivesAt": "13:14",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "13:15",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "13:25",
				"arrivesAt": "13:31",
				"waitsAtSource": 240,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "13:32",
				"arrivesAt": "13:37",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "13:38",
				"arrivesAt": "13:43",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "13:44",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Valea Viilor Hm.",
				"leavesAt": "13:51",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Aradu Nou",
				"leavesAt": "13:57",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "14:07",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Utviniş h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:43",
				"waitsAtSource": 1020,
				"distance": 9600
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "14:49",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Comlăuş h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Comlăuş h.",
				"to": "Şimand Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şimand Hm.",
				"to": "Nădab",
				"leavesAt": "15:13",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Nădab",
				"to": "Chişineu Criş",
				"leavesAt": "15:21",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Chişineu Criş",
				"to": "Zerind Hm.",
				"leavesAt": "15:28",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Zerind Hm.",
				"to": "Tămaşda h.",
				"leavesAt": "15:36",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Tămaşda h.",
				"to": "Boiu Bihor h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Cefa Hm.",
				"leavesAt": "16:16",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 9300
			},
			{
				"from": "Cefa Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "16:34",
				"arrivesAt": "16:45",
				"waitsAtSource": 480,
				"distance": 10400
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Oradea Vest Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Oradea",
				"leavesAt": "16:58",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3004",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "06:04",
				"arrivesAt": "06:12",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Jos h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "06:28",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "06:45",
				"arrivesAt": "06:54",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "06:55",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "07:02",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "07:06",
				"arrivesAt": "07:12",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "07:13",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Posada h.",
				"leavesAt": "07:16",
				"arrivesAt": "07:25",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Posada h.",
				"to": "Comarnic",
				"leavesAt": "07:26",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "07:41",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Bobolia h.",
				"leavesAt": "07:51",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Bobolia h.",
				"to": "Floreşti Prahova",
				"leavesAt": "07:57",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "08:05",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "08:15",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "08:35",
				"arrivesAt": "08:38",
				"waitsAtSource": 720,
				"distance": 2900
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Brazi",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "08:51",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:06",
				"waitsAtSource": 360,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "09:07",
				"arrivesAt": "09:12",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "09:20",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "09:29",
				"arrivesAt": "09:36",
				"waitsAtSource": 300,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "09:37",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "09:42",
				"arrivesAt": "09:51",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1752",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "08:44",
				"arrivesAt": "08:49",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "08:52",
				"arrivesAt": "09:04",
				"waitsAtSource": 180,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "09:05",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "09:24",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "09:42",
				"arrivesAt": "10:09",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "10:10",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "10:53",
				"arrivesAt": "11:33",
				"waitsAtSource": 840,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "11:35",
				"arrivesAt": "12:02",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "12:04",
				"arrivesAt": "12:25",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "12:27",
				"arrivesAt": "13:04",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "13:06",
				"arrivesAt": "13:37",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "13:39",
				"arrivesAt": "14:10",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "14:12",
				"arrivesAt": "14:48",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "14:51",
				"arrivesAt": "15:44",
				"waitsAtSource": 180,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2501",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "07:05",
				"arrivesAt": "07:11",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:23",
				"waitsAtSource": 240,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "07:24",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "07:31",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "07:41",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "07:54",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:30",
				"waitsAtSource": 240,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "08:39",
				"arrivesAt": "08:45",
				"waitsAtSource": 30,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1743",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Aradu Nou",
				"leavesAt": "15:55",
				"arrivesAt": "16:38",
				"waitsAtSource": 0,
				"distance": 51000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "16:43",
				"arrivesAt": "16:50",
				"waitsAtSource": 300,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Sântana",
				"leavesAt": "17:00",
				"arrivesAt": "17:24",
				"waitsAtSource": 600,
				"distance": 23500
			},
			{
				"from": "Sântana",
				"to": "Chişineu Criş",
				"leavesAt": "17:26",
				"arrivesAt": "17:44",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Chişineu Criş",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "18:09",
				"waitsAtSource": 120,
				"distance": 23700
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "18:10",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Oradea Vest Hm.",
				"leavesAt": "18:22",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 33700
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Oradea",
				"leavesAt": "19:00",
				"arrivesAt": "19:08",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Oradea",
				"to": "Săcuieni Bihor",
				"leavesAt": "19:14",
				"arrivesAt": "19:58",
				"waitsAtSource": 360,
				"distance": 44200
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Valea lui Mihai",
				"leavesAt": "19:59",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Valea lui Mihai",
				"to": "Carei",
				"leavesAt": "20:18",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 31200
			},
			{
				"from": "Carei",
				"to": "Satu Mare",
				"leavesAt": "20:43",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Satu Mare",
				"to": "Seini",
				"leavesAt": "21:19",
				"arrivesAt": "21:55",
				"waitsAtSource": 420,
				"distance": 34800
			},
			{
				"from": "Seini",
				"to": "Baia Mare",
				"leavesAt": "21:56",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 24600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9123",
		"segments": [
			{
				"from": "Goleşti",
				"to": "Ştefăneşti Argeş Hm.",
				"leavesAt": "18:30",
				"arrivesAt": "18:40",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Ştefăneşti Argeş Hm.",
				"to": "Gropeni h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gropeni h.",
				"to": "Ciumeşti",
				"leavesAt": "18:46",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Ciumeşti",
				"to": "Clucereasa h.",
				"leavesAt": "18:53",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Clucereasa h.",
				"to": "Stâlpeni Hm.",
				"leavesAt": "19:05",
				"arrivesAt": "19:15",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Stâlpeni Hm.",
				"to": "Drăghici h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăghici h.",
				"to": "Lăzăreşti Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:34",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Lăzăreşti Hm.",
				"to": "Schitu Goleşti",
				"leavesAt": "19:35",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Schitu Goleşti",
				"to": "Câmpulung",
				"leavesAt": "19:44",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Câmpulung",
				"to": "Parcul Kreţulescu h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4097",
		"segments": [
			{
				"from": "Jibou",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "17:10",
				"arrivesAt": "17:19",
				"waitsAtSource": 0,
				"distance": 9300
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Inău h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Inău h.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Benesat Hm.",
				"leavesAt": "17:28",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Benesat Hm.",
				"to": "Ţicău h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ţicău h.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "17:39",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "17:43",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Fersig h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Fersig h.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "17:57",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "18:13",
				"arrivesAt": "18:29",
				"waitsAtSource": 660,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6506",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "14:23",
				"arrivesAt": "14:30",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "14:31",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Holboca Hm.",
				"leavesAt": "14:37",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "14:46",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20170107",
				"to": "20170205",
				"daysOfWeek": 799
			},
			{
				"from": "20170211",
				"to": "20170418",
				"daysOfWeek": 799
			},
			{
				"from": "20170422",
				"to": "20170423",
				"daysOfWeek": 799
			},
			{
				"from": "20170429",
				"to": "20170618",
				"daysOfWeek": 799
			},
			{
				"from": "20170624",
				"to": "20170625",
				"daysOfWeek": 799
			},
			{
				"from": "20170701",
				"to": "20170702",
				"daysOfWeek": 799
			},
			{
				"from": "20170708",
				"to": "20170709",
				"daysOfWeek": 799
			},
			{
				"from": "20170715",
				"to": "20170716",
				"daysOfWeek": 799
			},
			{
				"from": "20170722",
				"to": "20170723",
				"daysOfWeek": 799
			},
			{
				"from": "20170729",
				"to": "20170730",
				"daysOfWeek": 799
			},
			{
				"from": "20170805",
				"to": "20170806",
				"daysOfWeek": 799
			},
			{
				"from": "20170812",
				"to": "20170813",
				"daysOfWeek": 799
			},
			{
				"from": "20170819",
				"to": "20170820",
				"daysOfWeek": 799
			},
			{
				"from": "20170826",
				"to": "20170827",
				"daysOfWeek": 799
			},
			{
				"from": "20170902",
				"to": "20170903",
				"daysOfWeek": 799
			},
			{
				"from": "20170909",
				"to": "20171209",
				"daysOfWeek": 799
			},
			{
				"from": "20161211",
				"to": "20161225",
				"daysOfWeek": 799
			},
			{
				"from": "20161231",
				"to": "20170101",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9051",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "05:00",
				"arrivesAt": "05:05",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Km. 200+400 P.aj.m",
				"leavesAt": "05:06",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Km. 200+400 P.aj.m",
				"to": "Troian h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Troian h.",
				"to": "Salcia Teleorman Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:38",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Salcia Teleorman Hm.",
				"to": "Km. 231+600 h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 14500
			},
			{
				"from": "Km. 231+600 h.",
				"to": "Turnu Măgurele",
				"leavesAt": "05:56",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2857",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "17:25",
				"arrivesAt": "17:29",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "17:30",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "17:34",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "17:39",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "17:47",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "17:57",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "18:03",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "18:07",
				"arrivesAt": "18:13",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:50",
				"waitsAtSource": 1320,
				"distance": 11500
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "18:51",
				"arrivesAt": "18:55",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Termo Turceni h.",
				"leavesAt": "18:56",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Termo Turceni h.",
				"to": "Turceni",
				"leavesAt": "19:01",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 900
			},
			{
				"from": "Turceni",
				"to": "Gârbovu h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:12",
				"waitsAtSource": 180,
				"distance": 6600
			},
			{
				"from": "Gârbovu h.",
				"to": "Sărdăneşti h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:19",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Plopşoru",
				"leavesAt": "19:20",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Plopşoru",
				"to": "Peşteana Jiu h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Bâlteni h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bâlteni h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Rovinari Sud h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Rovinari Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Hm.",
				"to": "Km. 49+800 h.",
				"leavesAt": "19:57",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rogojelu",
				"leavesAt": "20:00",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Rogojelu",
				"to": "Vârţ h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Vârţ h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Drăguţeşti h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Amaradia",
				"leavesAt": "20:20",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Amaradia",
				"to": "Târgu Jiu",
				"leavesAt": "20:25",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4423",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Căşeiu Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:44",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Căşeiu Hm.",
				"to": "Coplean h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coplean h.",
				"to": "Câţcău h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Câţcău h.",
				"to": "Căpâlna pe Someş h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Căpâlna pe Someş h.",
				"to": "Gâlgău",
				"leavesAt": "17:02",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Gâlgău",
				"to": "Gâlgău h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:15",
				"waitsAtSource": 120,
				"distance": 3100
			},
			{
				"from": "Gâlgău h.",
				"to": "Glodu Someşului h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Glodu Someşului h.",
				"to": "Rus h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Rus h.",
				"to": "Ileanda",
				"leavesAt": "17:29",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Ileanda",
				"to": "Bizuşa h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:51",
				"waitsAtSource": 600,
				"distance": 1800
			},
			{
				"from": "Bizuşa h.",
				"to": "Răstoci Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Răstoci Hm.",
				"to": "Letca Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Letca Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "18:11",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Ciocmani h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciocmani h.",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "18:31",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Var h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Var h.",
				"to": "Jibou",
				"leavesAt": "18:45",
				"arrivesAt": "18:50",
				"waitsAtSource": 30,
				"distance": 2800
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20180429",
				"daysOfWeek": 351
			},
			{
				"from": "20180501",
				"to": "20180526",
				"daysOfWeek": 351
			},
			{
				"from": "20180528",
				"to": "20180530",
				"daysOfWeek": 351
			},
			{
				"from": "20180601",
				"to": "20181128",
				"daysOfWeek": 351
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171223",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171230",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5447",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "12:46",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "12:52",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "13:02",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "13:07",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "13:16",
				"arrivesAt": "13:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "13:24",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "13:31",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "13:36",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "13:42",
				"arrivesAt": "13:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "13:47",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "13:52",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:15",
				"waitsAtSource": 480,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "14:16",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "14:33",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "14:46",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "14:53",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "15:00",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "15:14",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "15:23",
				"arrivesAt": "15:29",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8374",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "11:35",
				"arrivesAt": "11:43",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "11:44",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Pescăruş h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăruş h.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "11:56",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "12:03",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "12:16",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "12:30",
				"arrivesAt": "12:36",
				"waitsAtSource": 420,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "12:37",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 14000
			}
		],
		"restrictions": [
			{
				"from": "20180428",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6443",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "11:40",
				"arrivesAt": "11:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "11:55",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "12:03",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "12:10",
				"arrivesAt": "12:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "12:18",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "12:28",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "12:35",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "12:40",
				"arrivesAt": "12:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "12:50",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 14700
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1063",
		"segments": [
			{
				"from": "Ungheni",
				"to": "Ungheni Prut Fr.",
				"leavesAt": "16:14",
				"arrivesAt": "16:18",
				"waitsAtSource": 0,
				"distance": 800
			},
			{
				"from": "Ungheni Prut Fr.",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:23",
				"waitsAtSource": 180,
				"distance": 600
			},
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "17:06",
				"arrivesAt": "17:14",
				"waitsAtSource": 2580,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Socola",
				"leavesAt": "17:22",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "17:34",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 240,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1574",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "08:20",
				"arrivesAt": "08:39",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "08:40",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "08:59",
				"arrivesAt": "09:29",
				"waitsAtSource": 120,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Făurei",
				"leavesAt": "09:30",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "09:48",
				"arrivesAt": "10:27",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "10:29",
				"arrivesAt": "11:01",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "11:02",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "11:40",
				"arrivesAt": "12:30",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2481",
		"segments": [
			{
				"from": "Câineni",
				"to": "Râu Vadului h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:53",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Râu Vadului h.",
				"to": "Valea Fratelui h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "05:59",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "06:12",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:51",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:02",
				"waitsAtSource": 240,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "07:03",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "07:07",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3122",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Vest Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:24",
				"waitsAtSource": 420,
				"distance": 10800
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Cefa Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cefa Hm.",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Salonta",
				"leavesAt": "20:52",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:17",
				"waitsAtSource": 480,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Boiu Bihor h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Tămaşda h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tămaşda h.",
				"to": "Zerind Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Zerind Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "21:43",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "22:02",
				"arrivesAt": "22:08",
				"waitsAtSource": 720,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "22:09",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "22:18",
				"arrivesAt": "22:26",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "22:27",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "22:33",
				"arrivesAt": "22:44",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "22:45",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Arad",
				"leavesAt": "22:51",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 9600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 288
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4143",
		"segments": [
			{
				"from": "Deda",
				"to": "Morăreni h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:10",
				"waitsAtSource": 0,
				"distance": 4200
			},
			{
				"from": "Morăreni h.",
				"to": "Râpa de Jos Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Râpa de Jos Hm.",
				"to": "Monor Gledin",
				"leavesAt": "06:18",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Monor Gledin",
				"to": "Şieuţ h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Şieuţ h.",
				"to": "Şieu Hm.",
				"leavesAt": "06:38",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Şieu Hm.",
				"to": "Bârla pe Şieu h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Bârla pe Şieu h.",
				"to": "Mărişelu Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "06:56",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Domneşti pe Şieu h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Domneşti pe Şieu h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:09",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:31",
				"waitsAtSource": 720,
				"distance": 9800
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "07:32",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7566",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "04:24",
				"arrivesAt": "04:37",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "04:38",
				"arrivesAt": "04:44",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Independenţa Hm.",
				"leavesAt": "04:45",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 20900
			},
			{
				"from": "Independenţa Hm.",
				"to": "Piscu h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Piscu h.",
				"to": "Vameş h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:18",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vameş h.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "05:19",
				"arrivesAt": "05:25",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Şerbăneşti h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Lieşti",
				"leavesAt": "05:38",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lieşti",
				"to": "Buceşti h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Buceşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Iveşti Hm.",
				"to": "Umbrăreşti h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Barcea",
				"leavesAt": "05:57",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Barcea",
				"to": "Malul Alb h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Malul Alb h.",
				"to": "Tecuci",
				"leavesAt": "06:07",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "06:18",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "06:26",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "06:32",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1887",
		"segments": [
			{
				"from": "Titu",
				"to": "Nucet",
				"leavesAt": "17:40",
				"arrivesAt": "17:51",
				"waitsAtSource": 0,
				"distance": 15400
			},
			{
				"from": "Nucet",
				"to": "Târgovişte",
				"leavesAt": "17:52",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 16300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8443",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Ştefan Vodă h.",
				"leavesAt": "06:39",
				"arrivesAt": "06:53",
				"waitsAtSource": 0,
				"distance": 12600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "06:54",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Km. 25+700 h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Sud",
				"leavesAt": "07:08",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2027",
		"segments": [
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "01:45",
				"arrivesAt": "01:57",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "01:58",
				"arrivesAt": "02:08",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Brănişca Hm.",
				"leavesAt": "02:09",
				"arrivesAt": "02:17",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Ilia",
				"leavesAt": "02:18",
				"arrivesAt": "02:31",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "02:32",
				"arrivesAt": "02:39",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "02:40",
				"arrivesAt": "02:47",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Zam",
				"leavesAt": "02:48",
				"arrivesAt": "03:04",
				"waitsAtSource": 60,
				"distance": 12600
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "03:16",
				"arrivesAt": "03:20",
				"waitsAtSource": 720,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "03:21",
				"arrivesAt": "03:28",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "03:29",
				"arrivesAt": "03:32",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "03:33",
				"arrivesAt": "03:42",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Săvârşin",
				"to": "Vărădia h.",
				"leavesAt": "03:43",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vărădia h.",
				"to": "Vărădia Hm.",
				"leavesAt": "03:51",
				"arrivesAt": "03:56",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "03:57",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "04:03",
				"arrivesAt": "04:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Căpruţa h.",
				"leavesAt": "04:11",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Căpruţa h.",
				"to": "Bârzava",
				"leavesAt": "04:17",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bârzava",
				"to": "Conop Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Conop Hm.",
				"to": "Corfeni h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Corfeni h.",
				"to": "Milova",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Milova",
				"to": "Radna",
				"leavesAt": "04:48",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Radna",
				"to": "Păuliş Hm.",
				"leavesAt": "05:01",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Păuliş Hm.",
				"to": "Păuliş h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:19",
				"waitsAtSource": 300,
				"distance": 3000
			},
			{
				"from": "Păuliş h.",
				"to": "Ghioroc",
				"leavesAt": "05:20",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Ghioroc",
				"to": "Glogovăţ",
				"leavesAt": "05:28",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Glogovăţ",
				"to": "Arad",
				"leavesAt": "05:41",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 1080,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Valea Viilor Hm.",
				"leavesAt": "06:14",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Şag Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "06:31",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "06:59",
				"waitsAtSource": 240,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "07:00",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h",
				"leavesAt": "07:07",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "07:10",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Timişoara Nord",
				"leavesAt": "07:13",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3547",
		"segments": [
			{
				"from": "Odorhei",
				"to": "Odorhei Sud hc.",
				"leavesAt": "16:45",
				"arrivesAt": "16:49",
				"waitsAtSource": 0,
				"distance": 1200
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Feliceni h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Feliceni h.",
				"to": "Dobeni h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Lutiţa h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lutiţa h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Beteşti h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Beteşti h.",
				"to": "Cristur Hm.",
				"leavesAt": "17:29",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Cristur Hm.",
				"to": "Sântămaria h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:43",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Sântămaria h.",
				"to": "Săcuienii Noi h.",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Săcuienii Noi h.",
				"to": "Vânători",
				"leavesAt": "17:50",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "17:58",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "18:06",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6415",
		"segments": [
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:39",
				"waitsAtSource": 0,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "18:46",
				"arrivesAt": "18:51",
				"waitsAtSource": 420,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "18:52",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "18:57",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:11",
				"waitsAtSource": 120,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "19:12",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "19:26",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "19:36",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "19:59",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "20:06",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2709",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Dep Petroşani h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:21",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "15:22",
				"arrivesAt": "15:24",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Peştera Bolii h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Băniţa",
				"leavesAt": "15:30",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Băniţa",
				"to": "Merişor Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Merişor Hm.",
				"to": "Crivadia Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Crivadia Hm.",
				"to": "Baru Mare h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Baru Mare h.",
				"to": "Baru Mare",
				"leavesAt": "16:08",
				"arrivesAt": "16:14",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Baru Mare",
				"to": "Livadia h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Livadia h.",
				"to": "Ponor h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ponor h.",
				"to": "Pui",
				"leavesAt": "16:22",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Pui",
				"to": "Ruşor h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Ruşor h.",
				"to": "Băeşti Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Ciopea h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ciopea h.",
				"to": "Subcetate",
				"leavesAt": "16:43",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Subcetate",
				"to": "Covragiu h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:11",
				"waitsAtSource": 1260,
				"distance": 2600
			},
			{
				"from": "Covragiu h.",
				"to": "Plopi h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Plopi h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Măceu h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măceu h.",
				"to": "Ruşi h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ruşi h.",
				"to": "Călan Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Călan Hm.",
				"to": "Călan Băi",
				"leavesAt": "17:36",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Batiz h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Batiz h.",
				"to": "Băcia Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Băcia Hm.",
				"to": "Băcia h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia h.",
				"to": "Simeria Triaj",
				"leavesAt": "17:50",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Simeria Triaj",
				"to": "Simeria",
				"leavesAt": "17:54",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180203",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180616",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9021",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "06:30",
				"arrivesAt": "06:40",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "06:41",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "06:45",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "06:54",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:29",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "07:43",
				"arrivesAt": "07:50",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Fusea Hm.",
				"leavesAt": "07:52",
				"arrivesAt": "08:00",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Fusea Hm.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Cojocaru h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Cojocaru h.",
				"to": "Găeşti Sud h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Găeşti",
				"leavesAt": "08:20",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Găeşti",
				"to": "Pătroaia Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:36",
				"waitsAtSource": 120,
				"distance": 8300
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "08:37",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Călineşti Hm.",
				"leavesAt": "08:46",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Călineşti Hm.",
				"to": "Goleşti",
				"leavesAt": "08:54",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Goleşti",
				"to": "Ram. Goleşti",
				"leavesAt": "09:05",
				"arrivesAt": "09:09",
				"waitsAtSource": 120,
				"distance": 3200
			},
			{
				"from": "Ram. Goleşti",
				"to": "Piteşti",
				"leavesAt": "09:10",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5584",
		"segments": [
			{
				"from": "Botoşani",
				"to": "Leorda Hm.",
				"leavesAt": "21:04",
				"arrivesAt": "21:28",
				"waitsAtSource": 0,
				"distance": 15500
			},
			{
				"from": "Leorda Hm.",
				"to": "Bucecea Hm",
				"leavesAt": "21:40",
				"arrivesAt": "21:59",
				"waitsAtSource": 720,
				"distance": 9900
			},
			{
				"from": "Bucecea Hm",
				"to": "Vereşti",
				"leavesAt": "22:00",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 19100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8024",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "14:57",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "15:11",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "15:21",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "15:29",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "15:55",
				"arrivesAt": "16:02",
				"waitsAtSource": 540,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "16:03",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Ramificaţia Borcea",
				"leavesAt": "16:13",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "16:32",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "17:00",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:19",
				"waitsAtSource": 540,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "17:20",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Ivăneşti h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ivăneşti h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "17:35",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Bogdana h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bogdana h.",
				"to": "Dâlga h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Dâlga h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:07",
				"waitsAtSource": 420,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Lehliu",
				"leavesAt": "18:08",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lehliu",
				"to": "Preasna h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:19",
				"waitsAtSource": 120,
				"distance": 8800
			},
			{
				"from": "Preasna h.",
				"to": "Săruleşti",
				"leavesAt": "18:20",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Săruleşti",
				"to": "Mostiştea h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:37",
				"waitsAtSource": 420,
				"distance": 5900
			},
			{
				"from": "Mostiştea h.",
				"to": "Fundulea Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Fundulea Hm.",
				"to": "Islaz h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Islaz h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "18:51",
				"arrivesAt": "18:54",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Brăneşti Sat h.",
				"leavesAt": "18:55",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Pasărea",
				"leavesAt": "18:58",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pasărea",
				"to": "Pantelimon",
				"leavesAt": "19:11",
				"arrivesAt": "19:17",
				"waitsAtSource": 420,
				"distance": 6000
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "19:18",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "19:21",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20180420",
				"to": "20180915",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2103",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "14:35",
				"arrivesAt": "14:41",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "15:07",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "15:13",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "16:00",
				"arrivesAt": "16:06",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Făgăraş",
				"to": "Beclean pe Olt h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 240,
				"distance": 5200
			},
			{
				"from": "Beclean pe Olt h.",
				"to": "Dridif h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Dridif h.",
				"to": "Voila Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Voila Hm.",
				"to": "Olteţ h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:52",
				"waitsAtSource": 1140,
				"distance": 6100
			},
			{
				"from": "Olteţ h.",
				"to": "Viştea h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Viştea h.",
				"to": "Ucea",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:17",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "17:31",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "17:55",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "18:05",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "18:37",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5423",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "04:46",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "05:11",
				"arrivesAt": "05:15",
				"waitsAtSource": 600,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "05:16",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "05:39",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "05:43",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani Triaj",
				"leavesAt": "05:59",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Paşcani Triaj",
				"to": "Paşcani",
				"leavesAt": "06:05",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "06:31",
				"arrivesAt": "06:45",
				"waitsAtSource": 1140,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "06:46",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "07:03",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Podu Iloaiei",
				"leavesAt": "07:14",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "07:25",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "07:33",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1786",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "11:00",
				"arrivesAt": "11:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "11:12",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "11:36",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "11:57",
				"arrivesAt": "12:37",
				"waitsAtSource": 120,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3086",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "16:42",
				"arrivesAt": "16:52",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "17:20",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "17:29",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "17:54",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "18:11",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "18:18",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "18:23",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "18:28",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "18:44",
				"arrivesAt": "18:51",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "18:52",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "19:11",
				"arrivesAt": "19:18",
				"waitsAtSource": 300,
				"distance": 3400
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Mihalţ h.",
				"leavesAt": "19:19",
				"arrivesAt": "19:21",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Mihalţ h.",
				"to": "Cistei h.",
				"leavesAt": "19:22",
				"arrivesAt": "19:27",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cistei h.",
				"to": "Crăciunel Hm.",
				"leavesAt": "19:28",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Blaj",
				"leavesAt": "19:42",
				"arrivesAt": "19:50",
				"waitsAtSource": 240,
				"distance": 5300
			},
			{
				"from": "Blaj",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "20:00",
				"arrivesAt": "20:04",
				"waitsAtSource": 600,
				"distance": 3500
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Mănărade h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mănărade h.",
				"to": "Glogoveţ h.",
				"leavesAt": "20:10",
				"arrivesAt": "20:13",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Glogoveţ h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "20:14",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Lunca h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 300,
				"distance": 2100
			},
			{
				"from": "Lunca h.",
				"to": "Micăsasa h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Micăsasa h.",
				"to": "Copşa Mică",
				"leavesAt": "20:37",
				"arrivesAt": "20:54",
				"waitsAtSource": 30,
				"distance": 10200
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "21:03",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Bratei h.",
				"leavesAt": "21:22",
				"arrivesAt": "21:30",
				"waitsAtSource": 720,
				"distance": 5100
			},
			{
				"from": "Bratei h.",
				"to": "Aţel Hm.",
				"leavesAt": "21:31",
				"arrivesAt": "21:39",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Aţel Hm.",
				"to": "Dumbrăveni",
				"leavesAt": "21:40",
				"arrivesAt": "21:50",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Dumbrăveni",
				"to": "Luna h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Luna h.",
				"to": "Daneş Hm.",
				"leavesAt": "21:59",
				"arrivesAt": "22:06",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Daneş Hm.",
				"to": "Sighişoara",
				"leavesAt": "22:07",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2564",
		"segments": [
			{
				"from": "Beia Hm.",
				"to": "Archita h",
				"leavesAt": "05:30",
				"arrivesAt": "05:41",
				"waitsAtSource": 0,
				"distance": 8700
			},
			{
				"from": "Archita h",
				"to": "Mureni Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:56",
				"waitsAtSource": 30,
				"distance": 9600
			},
			{
				"from": "Mureni Hm.",
				"to": "Saschiz h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Vânători",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "06:15",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sighişoara",
				"to": "Daneş Hm.",
				"leavesAt": "06:29",
				"arrivesAt": "06:45",
				"waitsAtSource": 300,
				"distance": 9500
			},
			{
				"from": "Daneş Hm.",
				"to": "Luna h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:57",
				"waitsAtSource": 300,
				"distance": 4900
			},
			{
				"from": "Luna h.",
				"to": "Dumbrăveni",
				"leavesAt": "06:58",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dumbrăveni",
				"to": "Aţel Hm.",
				"leavesAt": "07:06",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Aţel Hm.",
				"to": "Bratei h.",
				"leavesAt": "07:16",
				"arrivesAt": "07:25",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Bratei h.",
				"to": "Mediaş",
				"leavesAt": "07:26",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:45",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "07:46",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:00",
				"waitsAtSource": 120,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "08:08",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:22",
				"waitsAtSource": 360,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Veşeud h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Veşeud h.",
				"to": "Hăşag h.",
				"leavesAt": "08:29",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "09:03",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "09:13",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5076",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "19:34",
				"arrivesAt": "19:44",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "19:45",
				"arrivesAt": "19:50",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "19:51",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "19:56",
				"arrivesAt": "20:06",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "20:07",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:33",
				"waitsAtSource": 600,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "20:34",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "20:39",
				"arrivesAt": "20:44",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "20:45",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "20:48",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "20:56",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "21:04",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8370",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "06:59",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "07:13",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "07:18",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "07:30",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "07:50",
				"arrivesAt": "08:05",
				"waitsAtSource": 300,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180427",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5706",
		"segments": [
			{
				"from": "Vatra Dornei",
				"to": "Argestru Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:01",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Argestru Hm.",
				"to": "Iacobeni",
				"leavesAt": "15:02",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "15:13",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Valea Putnei P.M.",
				"leavesAt": "15:24",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Pojorâta Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Sadova Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sadova Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "16:06",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Vama",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Vama",
				"to": "Molid Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Molid Hm.",
				"to": "Frasin",
				"leavesAt": "16:29",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "16:37",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Gura Humorului Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:14",
				"waitsAtSource": 480,
				"distance": 7900
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Stroieşti",
				"leavesAt": "17:32",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Stroieşti",
				"to": "Suceava Vest",
				"leavesAt": "17:45",
				"arrivesAt": "17:54",
				"waitsAtSource": 300,
				"distance": 9400
			},
			{
				"from": "Suceava Vest",
				"to": "Suceava",
				"leavesAt": "17:55",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9160",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "05:45",
				"arrivesAt": "05:54",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "06:11",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Valea Păltinişului h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Caransebeş",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5404",
		"segments": [
			{
				"from": "Bacău",
				"to": "Letea h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Letea h.",
				"to": "Valea Seacă",
				"leavesAt": "16:52",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Seacă",
				"to": "Siretu Bacău h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Faraoani Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Faraoani Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Răcăciuni h.",
				"to": "Orbeni Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Orbeni Hm.",
				"to": "Sascut Hm.",
				"leavesAt": "17:28",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Sascut Hm.",
				"to": "Şişcani h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Şişcani h.",
				"to": "Adjudu Vechi h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Adjud",
				"leavesAt": "17:47",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "17:52",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "18:01",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:16",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "18:17",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4412",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:46",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "21:55",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "22:04",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "380",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "06:15",
				"arrivesAt": "07:06",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "07:08",
				"arrivesAt": "07:41",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "07:43",
				"arrivesAt": "08:19",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "08:22",
				"arrivesAt": "08:53",
				"waitsAtSource": 180,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "08:55",
				"arrivesAt": "09:33",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "09:36",
				"arrivesAt": "09:58",
				"waitsAtSource": 180,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "10:00",
				"arrivesAt": "10:26",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "10:29",
				"arrivesAt": "11:07",
				"waitsAtSource": 180,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "11:22",
				"arrivesAt": "11:51",
				"waitsAtSource": 900,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "11:52",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "12:23",
				"arrivesAt": "12:43",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "12:44",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "13:02",
				"arrivesAt": "13:14",
				"waitsAtSource": 120,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "13:17",
				"arrivesAt": "13:22",
				"waitsAtSource": 180,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dorneşti",
				"leavesAt": "13:40",
				"arrivesAt": "14:10",
				"waitsAtSource": 1080,
				"distance": 30000
			},
			{
				"from": "Dorneşti",
				"to": "Vicşani",
				"leavesAt": "14:11",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Vicşani",
				"to": "Vadu Siretului",
				"leavesAt": "15:19",
				"arrivesAt": "15:41",
				"waitsAtSource": 3240,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9190",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "14:18",
				"arrivesAt": "14:24",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Remetea Mare",
				"leavesAt": "14:28",
				"arrivesAt": "14:42",
				"waitsAtSource": 240,
				"distance": 9600
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "14:52",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "14:56",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "15:03",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Lugoj",
				"leavesAt": "15:19",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 13200
			},
			{
				"from": "Lugoj",
				"to": "Găvojdia",
				"leavesAt": "15:31",
				"arrivesAt": "15:40",
				"waitsAtSource": 120,
				"distance": 11900
			},
			{
				"from": "Găvojdia",
				"to": "Jena Hm.",
				"leavesAt": "15:41",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Jena Hm.",
				"to": "Sacu h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sacu h.",
				"to": "Căvăran",
				"leavesAt": "15:56",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Căvăran",
				"to": "Zăgujeni Hm.",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Tibiscu h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tibiscu h.",
				"to": "Caransebeş",
				"leavesAt": "16:15",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2184",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Lugoj Nord h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:08",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lugoj Nord h.",
				"to": "Coşteiu Mare Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:16",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Coşteiu Mare Hm.",
				"to": "Păru h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Păru h.",
				"to": "Balinţ h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Balinţ h.",
				"to": "Nevrincea h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Nevrincea h.",
				"to": "Cliciova",
				"leavesAt": "08:33",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Cliciova",
				"to": "Susani Bega h.",
				"leavesAt": "08:54",
				"arrivesAt": "09:00",
				"waitsAtSource": 900,
				"distance": 3500
			},
			{
				"from": "Susani Bega h.",
				"to": "Traian Vuia h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "09:06",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Răchita h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Răchita h.",
				"to": "Făget",
				"leavesAt": "09:19",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "09:38",
				"arrivesAt": "09:51",
				"waitsAtSource": 720,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1642",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "18:09",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "18:10",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "18:21",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Benesat Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Benesat Hm.",
				"to": "Jibou",
				"leavesAt": "18:39",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Jibou",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "19:09",
				"arrivesAt": "19:17",
				"waitsAtSource": 720,
				"distance": 6800
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Letca Hm.",
				"leavesAt": "19:23",
				"arrivesAt": "19:46",
				"waitsAtSource": 360,
				"distance": 16300
			},
			{
				"from": "Letca Hm.",
				"to": "Ileanda",
				"leavesAt": "19:47",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Ileanda",
				"to": "Gâlgău",
				"leavesAt": "20:05",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Gâlgău",
				"to": "Câţcău h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Câţcău h.",
				"to": "Dej Călători",
				"leavesAt": "20:34",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 12700
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "21:02",
				"arrivesAt": "21:35",
				"waitsAtSource": 840,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Sărăţel Hm.",
				"leavesAt": "21:37",
				"arrivesAt": "22:03",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Deda",
				"leavesAt": "22:04",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Deda",
				"to": "Topliţa",
				"leavesAt": "23:02",
				"arrivesAt": "23:59",
				"waitsAtSource": 240,
				"distance": 43900
			},
			{
				"from": "Topliţa",
				"to": "Gheorgheni",
				"leavesAt": "00:06",
				"arrivesAt": "00:39",
				"waitsAtSource": 420,
				"distance": 34000
			},
			{
				"from": "Gheorgheni",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "00:41",
				"arrivesAt": "00:57",
				"waitsAtSource": 120,
				"distance": 19100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "00:58",
				"arrivesAt": "01:10",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "01:12",
				"arrivesAt": "01:32",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "01:37",
				"arrivesAt": "01:46",
				"waitsAtSource": 300,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "01:48",
				"arrivesAt": "02:11",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "02:13",
				"arrivesAt": "02:45",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "02:47",
				"arrivesAt": "03:17",
				"waitsAtSource": 120,
				"distance": 32100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "03:32",
				"arrivesAt": "04:09",
				"waitsAtSource": 900,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Sinaia",
				"leavesAt": "04:11",
				"arrivesAt": "04:32",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "04:34",
				"arrivesAt": "04:58",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "05:00",
				"arrivesAt": "05:11",
				"waitsAtSource": 120,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Ploieşti Vest",
				"leavesAt": "05:12",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 18600
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "05:29",
				"arrivesAt": "06:14",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20180501",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180425",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6827",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Buşag Hm.",
				"leavesAt": "04:33",
				"arrivesAt": "04:50",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Buşag Hm.",
				"to": "Cicârlău h.",
				"leavesAt": "04:51",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cicârlău h.",
				"to": "Ilba h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ilba h.",
				"to": "Săbişa h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:12",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbişa h.",
				"to": "Seini",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Seini",
				"to": "Apa Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "05:33",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "05:54",
				"arrivesAt": "05:59",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "06:00",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "06:21",
				"arrivesAt": "06:26",
				"waitsAtSource": 900,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "06:56",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Carei",
				"to": "Marna h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:18",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Marna h.",
				"to": "Sanislău Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Sanislău Hm.",
				"to": "Resighea h.",
				"leavesAt": "07:25",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Resighea h.",
				"to": "Curtuiuşeni h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Valea lui Mihai",
				"leavesAt": "07:41",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Valea lui Mihai",
				"to": "Nyirabrany",
				"leavesAt": "08:15",
				"arrivesAt": "08:30",
				"waitsAtSource": 1560,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4548",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "19:18",
				"arrivesAt": "19:26",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:50",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "19:57",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:16",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "20:29",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "20:39",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1890",
		"segments": [
			{
				"from": "Craiova",
				"to": "Balş",
				"leavesAt": "04:25",
				"arrivesAt": "04:55",
				"waitsAtSource": 0,
				"distance": 31200
			},
			{
				"from": "Balş",
				"to": "Piatra Olt",
				"leavesAt": "04:56",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Piatra Olt",
				"to": "Slatina",
				"leavesAt": "05:09",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Slatina",
				"to": "Stolnici Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "06:10",
				"waitsAtSource": 120,
				"distance": 43300
			},
			{
				"from": "Stolnici Hm.",
				"to": "Costeşti",
				"leavesAt": "06:11",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Costeşti",
				"to": "Piteşti",
				"leavesAt": "06:26",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "07:00",
				"arrivesAt": "07:11",
				"waitsAtSource": 600,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "07:19",
				"arrivesAt": "07:42",
				"waitsAtSource": 480,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "07:43",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "08:03",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5021",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "12:22",
				"arrivesAt": "12:31",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "12:32",
				"arrivesAt": "12:38",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "12:39",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "13:08",
				"arrivesAt": "13:16",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "13:17",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8385",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "12:20",
				"arrivesAt": "12:33",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "12:39",
				"arrivesAt": "12:46",
				"waitsAtSource": 360,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "12:47",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "12:53",
				"arrivesAt": "12:59",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "13:00",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "13:08",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "13:12",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "13:21",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "13:26",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180427",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1859",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "21:50",
				"arrivesAt": "21:59",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "22:00",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Buhuşi",
				"leavesAt": "22:07",
				"arrivesAt": "22:20",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Buhuşi",
				"to": "Podoleni Hm.",
				"leavesAt": "22:21",
				"arrivesAt": "22:34",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Podoleni Hm.",
				"to": "Roznov",
				"leavesAt": "22:35",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Roznov",
				"to": "Piatra Neamţ",
				"leavesAt": "22:53",
				"arrivesAt": "23:09",
				"waitsAtSource": 480,
				"distance": 15200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9531",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Piteşti Nord",
				"leavesAt": "13:40",
				"arrivesAt": "13:48",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Piteşti Nord",
				"to": "C.I.L. h.",
				"leavesAt": "13:49",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "C.I.L. h.",
				"to": "Bascov Hm.",
				"leavesAt": "13:53",
				"arrivesAt": "13:55",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Bascov Hm.",
				"to": "Merişani h.",
				"leavesAt": "13:56",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Merişani h.",
				"to": "Băiculeşti h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:17",
				"waitsAtSource": 30,
				"distance": 11300
			},
			{
				"from": "Băiculeşti h.",
				"to": "Curtea de Argeş",
				"leavesAt": "14:18",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2070",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "16:07",
				"arrivesAt": "16:10",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "16:14",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Mohu h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "16:26",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "16:36",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "16:44",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Râu Vadului h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "17:14",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:38",
				"waitsAtSource": 540,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Balota h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Balota h.",
				"to": "Cornet Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cornet Hm.",
				"to": "Beţel h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Beţel h.",
				"to": "Lotru",
				"leavesAt": "17:54",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:23",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "18:24",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "18:30",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "18:47",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "18:53",
				"arrivesAt": "18:56",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "19:10",
				"arrivesAt": "19:12",
				"waitsAtSource": 840,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "19:17",
				"arrivesAt": "19:20",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "19:21",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "19:25",
				"arrivesAt": "19:30",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "19:37",
				"arrivesAt": "19:44",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Băbeni",
				"to": "Slăviteşti hc.",
				"leavesAt": "20:10",
				"arrivesAt": "20:15",
				"waitsAtSource": 1560,
				"distance": 3200
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Ioneşti Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Fişcălia Hm.",
				"leavesAt": "20:28",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "20:33",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Orleşti hc.",
				"to": "Zăvideni Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Călina h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Călina h.",
				"to": "Drăgăşani",
				"leavesAt": "20:49",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Drăgăşani",
				"to": "Zlătărei Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:07",
				"waitsAtSource": 120,
				"distance": 6600
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Strejeşti",
				"leavesAt": "21:08",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Strejeşti",
				"to": "Colibaşi h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:32",
				"waitsAtSource": 660,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Arceşti Hm.",
				"leavesAt": "21:33",
				"arrivesAt": "21:40",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Găneasa Olt h.",
				"leavesAt": "21:41",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Găneasa h.",
				"leavesAt": "21:48",
				"arrivesAt": "21:51",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa h.",
				"to": "Piatra Olt",
				"leavesAt": "21:52",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "22:14",
				"arrivesAt": "22:21",
				"waitsAtSource": 840,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Canton 217 h.",
				"leavesAt": "22:22",
				"arrivesAt": "22:26",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Canton 217 h.",
				"to": "Balş",
				"leavesAt": "22:27",
				"arrivesAt": "22:30",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Balş",
				"to": "Spineni h.",
				"leavesAt": "22:31",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Spineni h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "22:36",
				"arrivesAt": "22:44",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "22:45",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Toporaş h.",
				"to": "Cârcea h.",
				"leavesAt": "22:51",
				"arrivesAt": "23:01",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Cârcea h.",
				"to": "Bordei hc.(901)",
				"leavesAt": "23:02",
				"arrivesAt": "23:09",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Craiova",
				"leavesAt": "23:10",
				"arrivesAt": "23:15",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9192",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "14:18",
				"arrivesAt": "14:24",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Remetea Mare",
				"leavesAt": "14:28",
				"arrivesAt": "14:42",
				"waitsAtSource": 240,
				"distance": 9600
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "14:52",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "14:56",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "15:03",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Lugoj",
				"leavesAt": "15:19",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 13200
			},
			{
				"from": "Lugoj",
				"to": "Găvojdia",
				"leavesAt": "15:31",
				"arrivesAt": "15:40",
				"waitsAtSource": 120,
				"distance": 11900
			},
			{
				"from": "Găvojdia",
				"to": "Jena Hm.",
				"leavesAt": "15:41",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Jena Hm.",
				"to": "Sacu h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sacu h.",
				"to": "Căvăran",
				"leavesAt": "15:56",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Căvăran",
				"to": "Zăgujeni Hm.",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Tibiscu h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tibiscu h.",
				"to": "Caransebeş",
				"leavesAt": "16:15",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caransebeş",
				"to": "Caransebeş haltă h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:25",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Balta Sărată",
				"leavesAt": "16:26",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balta Sărată",
				"to": "Valea Timişului Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Petroşniţa h.",
				"to": "Vălişoara Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Slatina Timiş",
				"leavesAt": "16:48",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Slatina Timiş",
				"to": "Armeniş",
				"leavesAt": "16:55",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Armeniş",
				"to": "Teregova Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Teregova Hm.",
				"to": "Poarta Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Poarta Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Luncaviţa h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2086",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:17",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Budieni h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Budieni h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Pojogeni Hm.",
				"leavesAt": "16:28",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "16:35",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 300,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "17:01",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "17:38",
				"arrivesAt": "17:41",
				"waitsAtSource": 360,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Bungeţel h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bungeţel h.",
				"to": "Filiaşi",
				"leavesAt": "17:53",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "18:23",
				"arrivesAt": "18:28",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "18:29",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "18:32",
				"arrivesAt": "18:36",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "18:37",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 416
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5024",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Brazi",
				"leavesAt": "06:03",
				"arrivesAt": "06:16",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "06:35",
				"arrivesAt": "06:40",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:54",
				"waitsAtSource": 360,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "06:55",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "07:00",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Basarab",
				"leavesAt": "07:10",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "402",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "19:15",
				"arrivesAt": "20:10",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Buzău",
				"leavesAt": "20:13",
				"arrivesAt": "21:21",
				"waitsAtSource": 180,
				"distance": 68600
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "21:29",
				"arrivesAt": "22:02",
				"waitsAtSource": 480,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "22:03",
				"arrivesAt": "22:43",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "22:45",
				"arrivesAt": "23:12",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "23:13",
				"arrivesAt": "23:41",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "23:43",
				"arrivesAt": "00:28",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "00:36",
				"arrivesAt": "01:10",
				"waitsAtSource": 480,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani Triaj",
				"leavesAt": "01:11",
				"arrivesAt": "01:43",
				"waitsAtSource": 60,
				"distance": 37900
			},
			{
				"from": "Paşcani Triaj",
				"to": "Iaşi",
				"leavesAt": "01:46",
				"arrivesAt": "02:50",
				"waitsAtSource": 180,
				"distance": 76200
			},
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "03:10",
				"arrivesAt": "03:17",
				"waitsAtSource": 1200,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "03:19",
				"arrivesAt": "03:47",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Ungheni Prut Hm.",
				"to": "Ungheni Prut Fr.",
				"leavesAt": "04:37",
				"arrivesAt": "04:39",
				"waitsAtSource": 3000,
				"distance": 600
			},
			{
				"from": "Ungheni Prut Fr.",
				"to": "Ungheni",
				"leavesAt": "04:59",
				"arrivesAt": "05:02",
				"waitsAtSource": 1200,
				"distance": 800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5210",
		"segments": [
			{
				"from": "Ghimeş",
				"to": "Palanca Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:16",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Palanca Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "16:17",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Simbrea Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:28",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Simbrea Hm.",
				"to": "Goioasa Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Goioasa Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Caraliţa h.",
				"to": "Asău Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Asău Hm.",
				"to": "Comăneşti",
				"leavesAt": "16:54",
				"arrivesAt": "17:03",
				"waitsAtSource": 360,
				"distance": 5100
			},
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "17:18",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "17:31",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Trotuş h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Trotuş h.",
				"to": "Oneşti",
				"leavesAt": "17:54",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "18:26",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "18:39",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "18:44",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "19:17",
				"arrivesAt": "19:24",
				"waitsAtSource": 1260,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:28",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "19:29",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "19:37",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "19:42",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "20:09",
				"arrivesAt": "20:18",
				"waitsAtSource": 1020,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "20:19",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "20:35",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "20:43",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "20:52",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "21:07",
				"arrivesAt": "21:16",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "21:17",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "21:38",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 11500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1782",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "06:00",
				"arrivesAt": "06:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "06:12",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "06:37",
				"arrivesAt": "06:56",
				"waitsAtSource": 120,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "07:04",
				"arrivesAt": "07:43",
				"waitsAtSource": 480,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4076",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:58",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "13:59",
				"arrivesAt": "14:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "14:04",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "14:11",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180124",
				"to": "20180124",
				"daysOfWeek": 383
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180331",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180501",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180528",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20180114",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5611",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "05:04",
				"arrivesAt": "05:18",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "05:19",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "05:27",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "05:41",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "06:03",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "06:13",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:33",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "06:51",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "07:11",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "07:18",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "07:25",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "07:32",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "07:41",
				"arrivesAt": "07:47",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20180531",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9056",
		"segments": [
			{
				"from": "Turnu Măgurele",
				"to": "Km. 231+600 h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:52",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Km. 231+600 h.",
				"to": "Salcia Teleorman Hm.",
				"leavesAt": "14:53",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 14500
			},
			{
				"from": "Salcia Teleorman Hm.",
				"to": "Roşiori Hm.",
				"leavesAt": "15:18",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 22700
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "15:47",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 320
			},
			{
				"from": "20171210",
				"to": "20180407",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9618",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "16:27",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Giroc h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Giroc h.",
				"to": "Semenic Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Semenic Hm.",
				"to": "Urseni h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Urseni h.",
				"to": "Uliuc h.",
				"leavesAt": "16:51",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Uliuc h.",
				"to": "Sacoşu Mic",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Sacoşu Mic",
				"to": "Chevereş h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Chevereş h.",
				"to": "Bacova h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bacova h.",
				"to": "Buziaş",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Buziaş",
				"to": "Căpăt h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Căpăt h.",
				"to": "Sinia Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Sinia Hm.",
				"to": "Boldur h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Boldur h.",
				"to": "Lugoj",
				"leavesAt": "17:42",
				"arrivesAt": "17:56",
				"waitsAtSource": 30,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2707",
		"segments": [
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:15",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "14:16",
				"arrivesAt": "14:23",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "14:24",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "14:40",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "14:51",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4403",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "07:41",
				"arrivesAt": "07:47",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "07:48",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "08:06",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5465",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "14:38",
				"arrivesAt": "14:47",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Racova h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Racova h.",
				"to": "Buhuşi",
				"leavesAt": "15:09",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Buhuşi",
				"to": "Costişa h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Costişa h.",
				"to": "Podoleni Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Podoleni Hm.",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Roznov",
				"leavesAt": "15:42",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Roznov",
				"to": "Săvineşti h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Săvineşti h.",
				"to": "Dumbrava h.",
				"leavesAt": "15:54",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Piatra Neamţ",
				"leavesAt": "16:03",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1982",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "11:30",
				"arrivesAt": "11:54",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Feteşti",
				"leavesAt": "11:55",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 44000
			},
			{
				"from": "Feteşti",
				"to": "Bucureşti Nord",
				"leavesAt": "12:31",
				"arrivesAt": "13:50",
				"waitsAtSource": 120,
				"distance": 146400
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9134",
		"segments": [
			{
				"from": "Calafat",
				"to": "Golenţi Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:26",
				"waitsAtSource": 0,
				"distance": 11800
			},
			{
				"from": "Golenţi Hm.",
				"to": "Maglavit h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Maglavit h.",
				"to": "Moţăţei Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Moţăţei Hm.",
				"to": "Băileşti",
				"leavesAt": "06:59",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 12800
			},
			{
				"from": "Băileşti",
				"to": "Boureni P.M.",
				"leavesAt": "07:22",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Boureni P.M.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Afumaţi h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:48",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Afumaţi h.",
				"to": "Urzica Mare h.",
				"leavesAt": "07:49",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Urzica Mare h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "08:02",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Cerăt h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cerăt h.",
				"to": "Segarcea",
				"leavesAt": "08:18",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Segarcea",
				"to": "Segarcea Nord hc.",
				"leavesAt": "08:25",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Sălcuţa Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Podari",
				"leavesAt": "08:49",
				"arrivesAt": "09:03",
				"waitsAtSource": 540,
				"distance": 13800
			},
			{
				"from": "Podari",
				"to": "R. 1 Jiu",
				"leavesAt": "09:04",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "R. 1 Jiu",
				"to": "Jiu Hm.",
				"leavesAt": "09:12",
				"arrivesAt": "09:15",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Jiu Hm.",
				"to": "Bordei hc.(913)",
				"leavesAt": "09:16",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Craiova",
				"leavesAt": "09:20",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5583",
		"segments": [
			{
				"from": "Vereşti",
				"to": "Bucecea Hm",
				"leavesAt": "18:03",
				"arrivesAt": "18:27",
				"waitsAtSource": 0,
				"distance": 19100
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "18:28",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "18:46",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1862",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "22:29",
				"arrivesAt": "22:35",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "22:37",
				"arrivesAt": "22:59",
				"waitsAtSource": 120,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "23:00",
				"arrivesAt": "23:22",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "23:23",
				"arrivesAt": "23:41",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "23:46",
				"arrivesAt": "00:00",
				"waitsAtSource": 300,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "00:01",
				"arrivesAt": "00:34",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "00:39",
				"arrivesAt": "01:24",
				"waitsAtSource": 300,
				"distance": 48600
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Mărăşeşti",
				"leavesAt": "01:26",
				"arrivesAt": "01:52",
				"waitsAtSource": 120,
				"distance": 17800
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "02:10",
				"arrivesAt": "02:34",
				"waitsAtSource": 1080,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "02:36",
				"arrivesAt": "03:13",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "03:15",
				"arrivesAt": "03:47",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "04:07",
				"arrivesAt": "04:45",
				"waitsAtSource": 1200,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Spicu",
				"leavesAt": "04:47",
				"arrivesAt": "05:12",
				"waitsAtSource": 120,
				"distance": 36400
			},
			{
				"from": "Spicu",
				"to": "Ţăndărei",
				"leavesAt": "05:13",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 21700
			},
			{
				"from": "Ţăndărei",
				"to": "Platoneşti h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:37",
				"waitsAtSource": 120,
				"distance": 6000
			},
			{
				"from": "Platoneşti h.",
				"to": "Movila Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "05:48",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "06:07",
				"arrivesAt": "06:27",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "06:28",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Palas",
				"leavesAt": "06:46",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 30600
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "07:04",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180501",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180607",
				"daysOfWeek": 383
			},
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180425",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6505",
		"segments": [
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "15:11",
				"arrivesAt": "15:19",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Remiza T Socola h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Remiza T Socola h.",
				"to": "Socola",
				"leavesAt": "15:34",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "15:41",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "15:47",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20170107",
				"to": "20170205",
				"daysOfWeek": 799
			},
			{
				"from": "20170211",
				"to": "20170418",
				"daysOfWeek": 799
			},
			{
				"from": "20170422",
				"to": "20170423",
				"daysOfWeek": 799
			},
			{
				"from": "20170429",
				"to": "20170618",
				"daysOfWeek": 799
			},
			{
				"from": "20170624",
				"to": "20170625",
				"daysOfWeek": 799
			},
			{
				"from": "20170701",
				"to": "20170702",
				"daysOfWeek": 799
			},
			{
				"from": "20170709",
				"to": "20170709",
				"daysOfWeek": 799
			},
			{
				"from": "20170715",
				"to": "20170716",
				"daysOfWeek": 799
			},
			{
				"from": "20170722",
				"to": "20170723",
				"daysOfWeek": 799
			},
			{
				"from": "20170729",
				"to": "20170730",
				"daysOfWeek": 799
			},
			{
				"from": "20170805",
				"to": "20170806",
				"daysOfWeek": 799
			},
			{
				"from": "20170812",
				"to": "20170813",
				"daysOfWeek": 799
			},
			{
				"from": "20170819",
				"to": "20170820",
				"daysOfWeek": 799
			},
			{
				"from": "20170826",
				"to": "20170827",
				"daysOfWeek": 799
			},
			{
				"from": "20170902",
				"to": "20170903",
				"daysOfWeek": 799
			},
			{
				"from": "20170909",
				"to": "20171209",
				"daysOfWeek": 799
			},
			{
				"from": "20161211",
				"to": "20161223",
				"daysOfWeek": 799
			},
			{
				"from": "20161225",
				"to": "20161225",
				"daysOfWeek": 799
			},
			{
				"from": "20161231",
				"to": "20170101",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3085",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Daneş Hm.",
				"leavesAt": "04:54",
				"arrivesAt": "05:10",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Daneş Hm.",
				"to": "Luna h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Luna h.",
				"to": "Dumbrăveni",
				"leavesAt": "05:19",
				"arrivesAt": "05:26",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dumbrăveni",
				"to": "Aţel Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Aţel Hm.",
				"to": "Bratei h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:46",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Bratei h.",
				"to": "Mediaş",
				"leavesAt": "05:47",
				"arrivesAt": "05:56",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:08",
				"waitsAtSource": 240,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "06:09",
				"arrivesAt": "06:16",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Micăsasa h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Micăsasa h.",
				"to": "Lunca h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lunca h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Glogoveţ h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Glogoveţ h.",
				"to": "Mănărade h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Mănărade h.",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Blaj",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Blaj",
				"to": "Crăciunel Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:23",
				"waitsAtSource": 240,
				"distance": 5300
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Cistei h.",
				"leavesAt": "07:24",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cistei h.",
				"to": "Mihalţ h.",
				"leavesAt": "07:34",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mihalţ h.",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "07:40",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Teiuş",
				"leavesAt": "07:45",
				"arrivesAt": "07:52",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:12",
				"waitsAtSource": 480,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Mirăslău h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mirăslău h.",
				"to": "Decea h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Decea h.",
				"to": "Unirea Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Unirea Hm.",
				"to": "Unirea hc.",
				"leavesAt": "08:29",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "08:33",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Grindeni h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:18",
				"waitsAtSource": 2100,
				"distance": 2800
			},
			{
				"from": "Grindeni h.",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:25",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Câmpia Turzii",
				"leavesAt": "09:26",
				"arrivesAt": "09:33",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cânepişti h.",
				"leavesAt": "09:34",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Cânepişti h.",
				"to": "Ploscoş h.",
				"leavesAt": "09:43",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ploscoş h.",
				"to": "Valea Florilor Hm.",
				"leavesAt": "09:49",
				"arrivesAt": "09:55",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Boju",
				"leavesAt": "09:56",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Boju",
				"to": "Tunel Hm.",
				"leavesAt": "10:08",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Tunel Hm.",
				"to": "Cojocna Hm.",
				"leavesAt": "10:16",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cojocna Hm.",
				"to": "Apahida",
				"leavesAt": "10:24",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:34",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "10:35",
				"arrivesAt": "10:42",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "10:49",
				"arrivesAt": "10:54",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9052",
		"segments": [
			{
				"from": "Turnu Măgurele",
				"to": "Km. 231+600 h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:51",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Km. 231+600 h.",
				"to": "Salcia Teleorman Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 14500
			},
			{
				"from": "Salcia Teleorman Hm.",
				"to": "Troian h.",
				"leavesAt": "07:17",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Troian h.",
				"to": "Km. 200+400 P.aj.m",
				"leavesAt": "07:29",
				"arrivesAt": "07:38",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Km. 200+400 P.aj.m",
				"to": "Roşiori Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "07:48",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1941",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "15:20",
				"arrivesAt": "15:27",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "15:35",
				"arrivesAt": "15:40",
				"waitsAtSource": 480,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "15:42",
				"arrivesAt": "15:54",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "16:10",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "16:20",
				"arrivesAt": "16:27",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:38",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "16:39",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "17:45",
				"arrivesAt": "18:12",
				"waitsAtSource": 2760,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "18:13",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "18:32",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "18:53",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Băneasa",
				"leavesAt": "19:20",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 102300
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Bucureşti Nord",
				"leavesAt": "20:24",
				"arrivesAt": "20:34",
				"waitsAtSource": 300,
				"distance": 6600
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "21:10",
				"arrivesAt": "21:50",
				"waitsAtSource": 2160,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Floreşti Prahova",
				"leavesAt": "21:52",
				"arrivesAt": "22:05",
				"waitsAtSource": 120,
				"distance": 18600
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "22:06",
				"arrivesAt": "22:18",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "22:19",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "22:43",
				"arrivesAt": "22:51",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "22:52",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "22:58",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "23:09",
				"arrivesAt": "23:46",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "23:58",
				"arrivesAt": "00:27",
				"waitsAtSource": 720,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "00:29",
				"arrivesAt": "01:01",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "01:03",
				"arrivesAt": "01:26",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "01:28",
				"arrivesAt": "01:36",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Izvoru Oltului",
				"leavesAt": "01:40",
				"arrivesAt": "01:56",
				"waitsAtSource": 240,
				"distance": 17100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "01:57",
				"arrivesAt": "02:08",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Gheorgheni",
				"leavesAt": "02:09",
				"arrivesAt": "02:26",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "02:27",
				"arrivesAt": "02:59",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "03:00",
				"arrivesAt": "03:58",
				"waitsAtSource": 60,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Sărăţel Hm.",
				"leavesAt": "03:59",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "05:08",
				"arrivesAt": "05:37",
				"waitsAtSource": 900,
				"distance": 24900
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "05:40",
				"arrivesAt": "06:15",
				"waitsAtSource": 180,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Câţcău h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:56",
				"waitsAtSource": 1560,
				"distance": 12700
			},
			{
				"from": "Câţcău h.",
				"to": "Gâlgău",
				"leavesAt": "06:57",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Gâlgău",
				"to": "Ileanda",
				"leavesAt": "07:09",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Ileanda",
				"to": "Răstoci Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Răstoci Hm.",
				"to": "Letca Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Letca Hm.",
				"to": "Jibou",
				"leavesAt": "07:49",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 23100
			},
			{
				"from": "Jibou",
				"to": "Benesat Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:40",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Benesat Hm.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "08:51",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "09:11",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8801",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "14:15",
				"arrivesAt": "14:32",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "14:33",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "14:42",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "14:49",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "14:58",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "15:07",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Pescăruş h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Pescăruş h.",
				"to": "Neptun hc.",
				"leavesAt": "15:19",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "15:27",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "15:40",
				"arrivesAt": "15:48",
				"waitsAtSource": 540,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8380",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "05:23",
				"arrivesAt": "05:30",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "05:31",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "05:35",
				"arrivesAt": "05:46",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "05:47",
				"arrivesAt": "05:50",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "05:58",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "06:14",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "06:23",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "06:30",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4338",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "19:20",
				"arrivesAt": "19:26",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "19:34",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "19:42",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "19:59",
				"arrivesAt": "20:04",
				"waitsAtSource": 780,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "20:12",
				"arrivesAt": "20:20",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "20:29",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Carei",
				"to": "Marna h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:53",
				"waitsAtSource": 420,
				"distance": 6800
			},
			{
				"from": "Marna h.",
				"to": "Sanislău Hm.",
				"leavesAt": "20:54",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Sanislău Hm.",
				"to": "Resighea h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Resighea h.",
				"to": "Curtuiuşeni h.",
				"leavesAt": "21:08",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Valea lui Mihai",
				"leavesAt": "21:16",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Valea lui Mihai",
				"to": "Simion h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Simion h.",
				"to": "Şilindru Hm.",
				"leavesAt": "21:31",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Şilindru Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "21:38",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Cadia h.",
				"leavesAt": "21:47",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cadia h.",
				"to": "Diosig Hm.",
				"leavesAt": "21:55",
				"arrivesAt": "22:01",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Diosig Hm.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "22:02",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Tămăşeu h.",
				"leavesAt": "22:09",
				"arrivesAt": "22:16",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tămăşeu h.",
				"to": "Biharia Hm.",
				"leavesAt": "22:17",
				"arrivesAt": "22:25",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Biharia Hm.",
				"to": "Episcopia Bihor",
				"leavesAt": "22:26",
				"arrivesAt": "22:36",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "22:37",
				"arrivesAt": "22:46",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5608",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "14:06",
				"arrivesAt": "14:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "14:13",
				"arrivesAt": "14:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "14:21",
				"arrivesAt": "14:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "14:29",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "14:36",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "14:49",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "15:11",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "15:17",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:45",
				"waitsAtSource": 480,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "15:46",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "16:00",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "16:09",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "16:20",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "16:27",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "16:34",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "16:42",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8588",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Brâncoveni h.",
				"leavesAt": "18:51",
				"arrivesAt": "19:00",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Brâncoveni h.",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "19:01",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Slobozia Veche",
				"leavesAt": "19:11",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 4200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2871",
		"segments": [
			{
				"from": "Rovinari Hm.",
				"to": "Km. 49+800 h.",
				"leavesAt": "07:20",
				"arrivesAt": "07:22",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rogojelu",
				"leavesAt": "07:24",
				"arrivesAt": "07:27",
				"waitsAtSource": 120,
				"distance": 1800
			},
			{
				"from": "Rogojelu",
				"to": "Vârţ h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Vârţ h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "07:33",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Drăguţeşti h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Amaradia",
				"leavesAt": "07:44",
				"arrivesAt": "07:48",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Amaradia",
				"to": "Târgu Jiu",
				"leavesAt": "07:49",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9302",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "03:30",
				"arrivesAt": "03:37",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "03:38",
				"arrivesAt": "03:46",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "03:47",
				"arrivesAt": "03:52",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "03:53",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "04:03",
				"arrivesAt": "04:11",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "04:12",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "04:19",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:33",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "04:34",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Zorile h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:58",
				"waitsAtSource": 480,
				"distance": 5100
			},
			{
				"from": "Zorile h.",
				"to": "Grădinari",
				"leavesAt": "04:59",
				"arrivesAt": "05:08",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "05:15",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "05:29",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Carpaţi h.(900)",
				"leavesAt": "05:33",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8001",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:39",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "06:40",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "06:46",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "06:57",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 480,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "07:36",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ciulniţa",
				"leavesAt": "08:22",
				"arrivesAt": "08:31",
				"waitsAtSource": 600,
				"distance": 13100
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "08:43",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "08:47",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "09:02",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "09:12",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Ovidiu",
				"leavesAt": "09:19",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ovidiu",
				"to": "Dunărea Hm.",
				"leavesAt": "09:24",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Dunărea Hm.",
				"to": "Cernavodă Pod",
				"leavesAt": "09:31",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "09:41",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "09:50",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "09:56",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "10:10",
				"arrivesAt": "10:13",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "10:14",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "10:19",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "10:25",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "10:29",
				"arrivesAt": "10:33",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "10:34",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "10:40",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8383",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:34",
				"arrivesAt": "07:47",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "07:48",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "07:56",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "08:09",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "08:17",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Pescăruş h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Pescăruş h.",
				"to": "Neptun hc.",
				"leavesAt": "08:26",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "08:32",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "08:37",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180503",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9193",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Tibiscu h.",
				"leavesAt": "04:53",
				"arrivesAt": "04:57",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Tibiscu h.",
				"to": "Zăgujeni Hm.",
				"leavesAt": "04:58",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Căvăran",
				"leavesAt": "05:02",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Căvăran",
				"to": "Sacu h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Sacu h.",
				"to": "Jena Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Jena Hm.",
				"to": "Găvojdia",
				"leavesAt": "05:21",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Găvojdia",
				"to": "Tapia Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tapia Hm.",
				"to": "Lugoj",
				"leavesAt": "05:37",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lugoj",
				"to": "Belinţ Hm.",
				"leavesAt": "05:44",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 13200
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "06:02",
				"arrivesAt": "06:08",
				"waitsAtSource": 240,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "06:13",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:31",
				"waitsAtSource": 540,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "06:32",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "06:41",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "06:56",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7036",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "14:58",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "15:17",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Greci h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:38",
				"waitsAtSource": 540,
				"distance": 6100
			},
			{
				"from": "Greci h.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "15:46",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "15:52",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Mogoşoaia",
				"leavesAt": "16:02",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Mogoşoaia",
				"to": "Pajura Hm. (700)",
				"leavesAt": "16:12",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Carpaţi h.(700)",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Bucureşti Nord",
				"leavesAt": "16:37",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2372",
		"segments": [
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "07:59",
				"arrivesAt": "08:06",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "08:07",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "08:34",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "08:47",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "08:59",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Nadăş h.",
				"leavesAt": "09:11",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Nadăş h.",
				"to": "Bârzava",
				"leavesAt": "09:17",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "09:26",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "09:30",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "09:35",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "09:41",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "09:48",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "09:52",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "10:02",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "10:10",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "10:16",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "10:21",
				"arrivesAt": "10:27",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "10:37",
				"arrivesAt": "10:44",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "10:45",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "10:53",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "11:00",
				"arrivesAt": "11:04",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "11:05",
				"arrivesAt": "11:11",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "11:12",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia",
				"leavesAt": "11:16",
				"arrivesAt": "11:22",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "11:23",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "11:33",
				"arrivesAt": "11:39",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "11:40",
				"arrivesAt": "11:46",
				"waitsAtSource": 30,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2442",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:33",
				"waitsAtSource": 0,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Mirăslău h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mirăslău h.",
				"to": "Decea h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Decea h.",
				"to": "Unirea Hm.",
				"leavesAt": "06:46",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Unirea Hm.",
				"to": "Unirea hc.",
				"leavesAt": "06:53",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "06:58",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Lunca Mureşului h.",
				"leavesAt": "07:07",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "07:17",
				"arrivesAt": "07:21",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Cheţani h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:26",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Cheţani h.",
				"to": "Luduş",
				"leavesAt": "07:27",
				"arrivesAt": "07:34",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Luduş",
				"to": "Bogata Mureş h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Cuci h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cuci h.",
				"to": "Iernut",
				"leavesAt": "07:47",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Iernut",
				"to": "Cipău h.",
				"leavesAt": "07:59",
				"arrivesAt": "08:04",
				"waitsAtSource": 360,
				"distance": 4100
			},
			{
				"from": "Cipău h.",
				"to": "Ogra h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ogra h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Chirileu h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chirileu h.",
				"to": "Vidrasău h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vidrasău h.",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "08:30",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "Azomureş h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2146",
		"segments": [
			{
				"from": "Hunedoara",
				"to": "Pestişu Mare h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:15",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pestişu Mare h.",
				"to": "Bârcea Mică",
				"leavesAt": "18:16",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bârcea Mică",
				"to": "Bârcea Mare h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bârcea Mare h.",
				"to": "Simeria",
				"leavesAt": "18:24",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2851",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "04:30",
				"arrivesAt": "04:34",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "04:35",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "04:39",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "04:44",
				"arrivesAt": "04:47",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "04:53",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:08",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Filiaşi",
				"leavesAt": "05:09",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Filiaşi",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Termo Turceni h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Termo Turceni h.",
				"to": "Turceni",
				"leavesAt": "05:39",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 900
			},
			{
				"from": "Turceni",
				"to": "Gârbovu h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gârbovu h.",
				"to": "Sărdăneşti h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Plopşoru",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Plopşoru",
				"to": "Peşteana Jiu h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Bâlteni h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bâlteni h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Rovinari Sud h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Rovinari Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:31",
				"waitsAtSource": 120,
				"distance": 1400
			},
			{
				"from": "Rovinari Hm.",
				"to": "Km. 49+800 h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rogojelu",
				"leavesAt": "06:36",
				"arrivesAt": "06:39",
				"waitsAtSource": 120,
				"distance": 1800
			},
			{
				"from": "Rogojelu",
				"to": "Vârţ h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:47",
				"waitsAtSource": 300,
				"distance": 2400
			},
			{
				"from": "Vârţ h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:54",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Drăguţeşti h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Amaradia",
				"leavesAt": "06:59",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Amaradia",
				"to": "Târgu Jiu",
				"leavesAt": "07:04",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9303",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:18",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureştii Noi",
				"leavesAt": "07:19",
				"arrivesAt": "07:24",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "07:25",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "07:34",
				"arrivesAt": "07:43",
				"waitsAtSource": 300,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "07:44",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Vadu Lat Hm.",
				"leavesAt": "07:55",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Zăvestreni Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Videle",
				"leavesAt": "08:20",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:37",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "08:38",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "08:48",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "09:03",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "09:09",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "09:20",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5206",
		"segments": [
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:49",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "15:50",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "16:08",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "16:27",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:07",
				"waitsAtSource": 1260,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "17:25",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2302",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Veche h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:04",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Simeria Veche h.",
				"to": "Turdaş Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Turdaş Hm.",
				"to": "Pricaz h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Pricaz h.",
				"to": "Orăştie",
				"leavesAt": "05:19",
				"arrivesAt": "05:25",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Orăştie",
				"to": "Geoagiu h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Geoagiu h.",
				"to": "Aurel Vlaicu",
				"leavesAt": "05:31",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Şibot",
				"leavesAt": "05:37",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şibot",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "05:54",
				"arrivesAt": "06:00",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Tărtăria h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Tărtăria h.",
				"to": "Blandiana Hm.",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "06:27",
				"arrivesAt": "06:39",
				"waitsAtSource": 240,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:50",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "07:03",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "07:16",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3536",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "15:30",
				"arrivesAt": "15:38",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "15:39",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Saschiz h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Mureni Hm.",
				"leavesAt": "15:52",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mureni Hm.",
				"to": "Archita h",
				"leavesAt": "15:59",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Archita h",
				"to": "Beia Hm.",
				"leavesAt": "16:13",
				"arrivesAt": "16:28",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Beia Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "16:29",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Caţa Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Caţa Hm.",
				"to": "Rupea",
				"leavesAt": "16:44",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Rupea",
				"to": "Mateiaş h.",
				"leavesAt": "16:54",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Mateiaş h.",
				"to": "Racoş Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Ormeniş h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ormeniş h.",
				"to": "Apaţa",
				"leavesAt": "17:42",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Apaţa",
				"to": "Măieruş h.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Măieruş h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Rotbav h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Rotbav h.",
				"to": "Feldioara Hm.",
				"leavesAt": "18:11",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Bod Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Bod Hm.",
				"to": "Stupini Hm.",
				"leavesAt": "18:35",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Stupini Hm.",
				"to": "Braşov",
				"leavesAt": "18:45",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9619",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Boldur h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:50",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Boldur h.",
				"to": "Sinia Hm.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sinia Hm.",
				"to": "Căpăt h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Căpăt h.",
				"to": "Buziaş",
				"leavesAt": "20:03",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Buziaş",
				"to": "Bacova h.",
				"leavesAt": "20:24",
				"arrivesAt": "20:26",
				"waitsAtSource": 600,
				"distance": 2300
			},
			{
				"from": "Bacova h.",
				"to": "Chevereş h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Chevereş h.",
				"to": "Sacoşu Mic",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Sacoşu Mic",
				"to": "Uliuc h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Uliuc h.",
				"to": "Urseni h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Urseni h.",
				"to": "Giroc h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:54",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Giroc h.",
				"to": "Timişoara Sud",
				"leavesAt": "20:55",
				"arrivesAt": "21:01",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "21:02",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2506",
		"segments": [
			{
				"from": "Făgăraş",
				"to": "Mândra Oltului h.",
				"leavesAt": "11:56",
				"arrivesAt": "12:02",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Şercaia h.",
				"leavesAt": "12:03",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Şercaia h.",
				"to": "Şercaia Hm.",
				"leavesAt": "12:11",
				"arrivesAt": "12:13",
				"waitsAtSource": 30,
				"distance": 1200
			},
			{
				"from": "Şercaia Hm.",
				"to": "Perşani h.",
				"leavesAt": "12:14",
				"arrivesAt": "12:20",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Brădet Hm.",
				"leavesAt": "12:21",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Brădet Hm.",
				"to": "Valea Homorod h.",
				"leavesAt": "12:31",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Homorod h.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "12:40",
				"arrivesAt": "12:49",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "12:50",
				"arrivesAt": "12:55",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "12:56",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Codlea Hm.",
				"to": "Ghimbav Hm.",
				"leavesAt": "13:18",
				"arrivesAt": "13:24",
				"waitsAtSource": 720,
				"distance": 5300
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Bartolomeu",
				"leavesAt": "13:25",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "13:32",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1823",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Grădinari",
				"leavesAt": "08:55",
				"arrivesAt": "09:27",
				"waitsAtSource": 0,
				"distance": 25500
			},
			{
				"from": "Grădinari",
				"to": "Videle",
				"leavesAt": "09:28",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Videle",
				"to": "Gălăteni Hm.",
				"leavesAt": "09:53",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 15800
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "10:07",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "10:14",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Roşiori Nord",
				"leavesAt": "10:21",
				"arrivesAt": "10:45",
				"waitsAtSource": 30,
				"distance": 20000
			},
			{
				"from": "Roşiori Nord",
				"to": "Radomireşti Hm.",
				"leavesAt": "10:47",
				"arrivesAt": "11:10",
				"waitsAtSource": 120,
				"distance": 25600
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "11:11",
				"arrivesAt": "11:21",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Caracal",
				"leavesAt": "11:28",
				"arrivesAt": "11:41",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Caracal",
				"to": "Bordei hc.(900)",
				"leavesAt": "11:42",
				"arrivesAt": "12:20",
				"waitsAtSource": 60,
				"distance": 51900
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "12:21",
				"arrivesAt": "12:26",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "12:30",
				"arrivesAt": "12:33",
				"waitsAtSource": 240,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Filiaşi",
				"leavesAt": "12:34",
				"arrivesAt": "12:57",
				"waitsAtSource": 30,
				"distance": 32100
			},
			{
				"from": "Filiaşi",
				"to": "Turceni",
				"leavesAt": "12:58",
				"arrivesAt": "13:18",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Turceni",
				"to": "Rovinari Hm.",
				"leavesAt": "13:19",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 35300
			},
			{
				"from": "Rovinari Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "13:57",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 21800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4524",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "23:30",
				"arrivesAt": "23:38",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "23:39",
				"arrivesAt": "23:42",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "23:43",
				"arrivesAt": "23:47",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Vrabia h.",
				"leavesAt": "23:48",
				"arrivesAt": "23:53",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vrabia h.",
				"to": "Tuşnad Sat",
				"leavesAt": "23:54",
				"arrivesAt": "23:58",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "23:59",
				"arrivesAt": "00:07",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20180607",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8594",
		"segments": [
			{
				"from": "Călăraşi Sud",
				"to": "Km. 25+700 h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:16",
				"waitsAtSource": 0,
				"distance": 1300
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "14:17",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Ştefan Vodă h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Ciulniţa",
				"leavesAt": "14:32",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 12600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9171",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Valea Păltinişului h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:40",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Brebu",
				"leavesAt": "19:58",
				"arrivesAt": "20:10",
				"waitsAtSource": 600,
				"distance": 10500
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "20:27",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "20:39",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1894",
		"segments": [
			{
				"from": "Craiova",
				"to": "Balş",
				"leavesAt": "12:25",
				"arrivesAt": "12:55",
				"waitsAtSource": 0,
				"distance": 31200
			},
			{
				"from": "Balş",
				"to": "Piatra Olt",
				"leavesAt": "12:56",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Piatra Olt",
				"to": "Slatina",
				"leavesAt": "13:12",
				"arrivesAt": "13:31",
				"waitsAtSource": 240,
				"distance": 17000
			},
			{
				"from": "Slatina",
				"to": "Costeşti",
				"leavesAt": "13:32",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 59200
			},
			{
				"from": "Costeşti",
				"to": "Piteşti",
				"leavesAt": "14:26",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "15:00",
				"arrivesAt": "15:10",
				"waitsAtSource": 600,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "15:11",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "15:36",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "15:57",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9132",
		"segments": [
			{
				"from": "Calafat",
				"to": "Golenţi Hm.",
				"leavesAt": "03:25",
				"arrivesAt": "03:40",
				"waitsAtSource": 0,
				"distance": 11800
			},
			{
				"from": "Golenţi Hm.",
				"to": "Maglavit h.",
				"leavesAt": "03:41",
				"arrivesAt": "03:56",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Maglavit h.",
				"to": "Moţăţei Hm.",
				"leavesAt": "03:57",
				"arrivesAt": "04:11",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Moţăţei Hm.",
				"to": "Băileşti",
				"leavesAt": "04:12",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 12800
			},
			{
				"from": "Băileşti",
				"to": "Boureni P.M.",
				"leavesAt": "04:35",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Boureni P.M.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:52",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Afumaţi h.",
				"leavesAt": "04:53",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Afumaţi h.",
				"to": "Urzica Mare h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Urzica Mare h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Cerăt h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cerăt h.",
				"to": "Segarcea",
				"leavesAt": "05:31",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Segarcea",
				"to": "Segarcea Nord hc.",
				"leavesAt": "05:38",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Dealul Robului h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dealul Robului h.",
				"to": "Sălcuţa Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:54",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Podari",
				"leavesAt": "05:55",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Podari",
				"to": "Jiu Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Jiu Hm.",
				"to": "Bordei hc.(913)",
				"leavesAt": "06:21",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Craiova",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2231",
		"segments": [
			{
				"from": "Remetea Mică",
				"to": "Fibiş h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Bencei h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bencei h.",
				"to": "Pişchia h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pişchia h.",
				"to": "Cerneteaz h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Cerneteaz h.",
				"to": "Giarmata Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Giarmata Hm.",
				"to": "Viile Giarmata h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Timişoara Est",
				"leavesAt": "05:36",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "05:47",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1822",
		"segments": [
			{
				"from": "Arad",
				"to": "Radna",
				"leavesAt": "18:40",
				"arrivesAt": "19:20",
				"waitsAtSource": 0,
				"distance": 34500
			},
			{
				"from": "Radna",
				"to": "Săvârşin",
				"leavesAt": "19:21",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Săvârşin",
				"to": "Ilia",
				"leavesAt": "20:19",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "21:08",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "21:36",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Călan Hm.",
				"leavesAt": "21:50",
				"arrivesAt": "22:06",
				"waitsAtSource": 120,
				"distance": 14600
			},
			{
				"from": "Călan Hm.",
				"to": "Subcetate",
				"leavesAt": "22:07",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Subcetate",
				"to": "Petroşani",
				"leavesAt": "22:23",
				"arrivesAt": "23:32",
				"waitsAtSource": 60,
				"distance": 49800
			},
			{
				"from": "Petroşani",
				"to": "Valea Sadului Hm.",
				"leavesAt": "23:37",
				"arrivesAt": "00:22",
				"waitsAtSource": 300,
				"distance": 31700
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "00:23",
				"arrivesAt": "00:44",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Târgu Jiu",
				"to": "Cărbuneşti",
				"leavesAt": "00:46",
				"arrivesAt": "01:14",
				"waitsAtSource": 120,
				"distance": 23800
			},
			{
				"from": "Cărbuneşti",
				"to": "Filiaşi",
				"leavesAt": "01:15",
				"arrivesAt": "01:59",
				"waitsAtSource": 60,
				"distance": 46500
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "02:00",
				"arrivesAt": "02:25",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "02:35",
				"arrivesAt": "03:14",
				"waitsAtSource": 600,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "03:16",
				"arrivesAt": "03:31",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "03:32",
				"arrivesAt": "04:03",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "04:05",
				"arrivesAt": "04:54",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Chiajna",
				"leavesAt": "04:56",
				"arrivesAt": "05:38",
				"waitsAtSource": 120,
				"distance": 41900
			},
			{
				"from": "Chiajna",
				"to": "Bucureşti Nord",
				"leavesAt": "05:42",
				"arrivesAt": "05:55",
				"waitsAtSource": 240,
				"distance": 9000
			},
			{
				"from": "Bucureşti Nord",
				"to": "Lehliu",
				"leavesAt": "06:20",
				"arrivesAt": "07:01",
				"waitsAtSource": 1500,
				"distance": 69600
			},
			{
				"from": "Lehliu",
				"to": "Ciulniţa",
				"leavesAt": "07:02",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "07:23",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "07:47",
				"arrivesAt": "08:07",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "08:08",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "08:26",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180501",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180607",
				"daysOfWeek": 383
			},
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180425",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8582",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Brâncoveni h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:09",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Brâncoveni h.",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "07:10",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Slobozia Veche",
				"leavesAt": "07:20",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 4200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2438",
		"segments": [
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:41",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "15:56",
				"arrivesAt": "16:01",
				"waitsAtSource": 120,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:11",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "16:12",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "16:27",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5413",
		"segments": [
			{
				"from": "Adjud",
				"to": "Adjudu Vechi h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:14",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Şişcani h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Şişcani h.",
				"to": "Sascut Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sascut Hm.",
				"to": "Orbeni Hm.",
				"leavesAt": "15:36",
				"arrivesAt": "15:43",
				"waitsAtSource": 600,
				"distance": 9200
			},
			{
				"from": "Orbeni Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Răcăciuni h.",
				"to": "Faraoani Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Faraoani Hm.",
				"to": "Siretu Bacău h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Valea Seacă",
				"leavesAt": "16:06",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Valea Seacă",
				"to": "Letea h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Letea h.",
				"to": "Bacău",
				"leavesAt": "16:18",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9104",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:16",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "06:35",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "06:56",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "07:05",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "07:12",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "07:16",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "07:20",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:26",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "07:27",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4485",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Podereia Feldrului h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:39",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Feldru Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Feldru Hm.",
				"to": "Nepos h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Nepos h.",
				"to": "Rebrişoara Hm.",
				"leavesAt": "16:51",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Năsăud",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Năsăud",
				"to": "Năsăud h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Năsăud h.",
				"to": "Salva",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Salva",
				"to": "Mititei h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Mititei h.",
				"to": "Nimigea Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "17:36",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "17:47",
				"arrivesAt": "17:57",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Dej Triaj",
				"leavesAt": "18:16",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "18:22",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4523",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "23:37",
				"arrivesAt": "23:45",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "23:46",
				"arrivesAt": "23:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "23:50",
				"arrivesAt": "23:57",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "23:58",
				"arrivesAt": "00:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "00:03",
				"arrivesAt": "00:06",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "00:07",
				"arrivesAt": "00:10",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "00:11",
				"arrivesAt": "00:15",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "00:16",
				"arrivesAt": "00:20",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "00:21",
				"arrivesAt": "00:31",
				"waitsAtSource": 30,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1728",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Lainici Hm.",
				"leavesAt": "12:42",
				"arrivesAt": "13:12",
				"waitsAtSource": 0,
				"distance": 20400
			},
			{
				"from": "Lainici Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "13:13",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "13:31",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Târgu Jiu",
				"to": "Cărbuneşti",
				"leavesAt": "13:55",
				"arrivesAt": "14:21",
				"waitsAtSource": 120,
				"distance": 23800
			},
			{
				"from": "Cărbuneşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "14:52",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Filiaşi",
				"leavesAt": "15:00",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 12400
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "15:15",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "15:45",
				"arrivesAt": "16:24",
				"waitsAtSource": 300,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 496
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9664",
		"segments": [
			{
				"from": "Stamora Moraviţa",
				"to": "Denta h.",
				"leavesAt": "12:29",
				"arrivesAt": "12:37",
				"waitsAtSource": 0,
				"distance": 8400
			},
			{
				"from": "Denta h.",
				"to": "Deta Hm.",
				"leavesAt": "12:38",
				"arrivesAt": "12:45",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Deta Hm.",
				"to": "Voiteni",
				"leavesAt": "12:46",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "12:57",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "13:08",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "13:15",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara Sud",
				"leavesAt": "13:24",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "13:33",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2855",
		"segments": [
			{
				"from": "Filiaşi",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "15:22",
				"arrivesAt": "15:34",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "15:35",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Termo Turceni h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Termo Turceni h.",
				"to": "Turceni",
				"leavesAt": "15:44",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 900
			},
			{
				"from": "Turceni",
				"to": "Gârbovu h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:28",
				"waitsAtSource": 2100,
				"distance": 6600
			},
			{
				"from": "Gârbovu h.",
				"to": "Sărdăneşti h.",
				"leavesAt": "16:29",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Plopşoru",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Plopşoru",
				"to": "Peşteana Jiu h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Bâlteni h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Bâlteni h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Rovinari Sud h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Rovinari Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 120,
				"distance": 1400
			},
			{
				"from": "Rovinari Hm.",
				"to": "Km. 49+800 h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rogojelu",
				"leavesAt": "17:16",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Rogojelu",
				"to": "Vârţ h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Vârţ h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "17:24",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Drăguţeşti h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Amaradia",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Amaradia",
				"to": "Târgu Jiu",
				"leavesAt": "17:44",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8345",
		"segments": [
			{
				"from": "Călăraşi Sud",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:38",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Ştefan Vodă h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Ciulniţa",
				"leavesAt": "05:47",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 12600
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:12",
				"waitsAtSource": 120,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "06:24",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:38",
				"waitsAtSource": 420,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "06:51",
				"arrivesAt": "07:01",
				"waitsAtSource": 420,
				"distance": 9900
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "07:02",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Ovidiu",
				"leavesAt": "07:09",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ovidiu",
				"to": "Dunărea Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:20",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Dunărea Hm.",
				"to": "Cernavodă Pod",
				"leavesAt": "07:21",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "07:30",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "07:47",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "08:02",
				"arrivesAt": "08:06",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:16",
				"waitsAtSource": 420,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "08:17",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "08:27",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "08:38",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180916",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5422",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "12:40",
				"arrivesAt": "12:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "12:55",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "13:03",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "13:10",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "13:18",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "13:28",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "13:35",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "13:50",
				"arrivesAt": "14:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Paşcani Triaj",
				"leavesAt": "14:24",
				"arrivesAt": "14:28",
				"waitsAtSource": 1200,
				"distance": 2300
			},
			{
				"from": "Paşcani Triaj",
				"to": "Stolniceni h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "14:41",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "14:46",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "15:04",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "15:15",
				"arrivesAt": "15:22",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "15:28",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "15:43",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "15:49",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9107",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:24",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "19:25",
				"arrivesAt": "19:28",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "19:29",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "19:34",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "19:39",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "19:44",
				"arrivesAt": "19:52",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:27",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:40",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "20:41",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "20:58",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "21:07",
				"arrivesAt": "21:11",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "21:12",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:21",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "21:22",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2701",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Dep Petroşani h.",
				"leavesAt": "03:35",
				"arrivesAt": "03:38",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Peştera Bolii h.",
				"leavesAt": "03:39",
				"arrivesAt": "03:44",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Băniţa",
				"leavesAt": "03:45",
				"arrivesAt": "03:53",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Băniţa",
				"to": "Merişor Hm.",
				"leavesAt": "03:54",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Merişor Hm.",
				"to": "Crivadia Hm.",
				"leavesAt": "04:06",
				"arrivesAt": "04:15",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Crivadia Hm.",
				"to": "Baru Mare h.",
				"leavesAt": "04:16",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Baru Mare h.",
				"to": "Baru Mare",
				"leavesAt": "04:23",
				"arrivesAt": "04:29",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Baru Mare",
				"to": "Livadia h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:33",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Livadia h.",
				"to": "Ponor h.",
				"leavesAt": "04:34",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ponor h.",
				"to": "Pui",
				"leavesAt": "04:37",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Pui",
				"to": "Ruşor h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Ruşor h.",
				"to": "Băeşti Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:51",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "04:52",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Ciopea h.",
				"leavesAt": "04:55",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ciopea h.",
				"to": "Subcetate",
				"leavesAt": "04:58",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Subcetate",
				"to": "Covragiu h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Covragiu h.",
				"to": "Plopi h.",
				"leavesAt": "05:06",
				"arrivesAt": "05:08",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Plopi h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "05:09",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Măceu h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măceu h.",
				"to": "Ruşi h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ruşi h.",
				"to": "Călan Hm.",
				"leavesAt": "05:19",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Călan Hm.",
				"to": "Călan Băi",
				"leavesAt": "05:30",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Batiz h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Batiz h.",
				"to": "Băcia Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Băcia Hm.",
				"to": "Băcia h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia h.",
				"to": "Simeria Triaj",
				"leavesAt": "05:44",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Simeria Triaj",
				"to": "Simeria",
				"leavesAt": "05:48",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "06:01",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1696",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Lugoj",
				"leavesAt": "22:40",
				"arrivesAt": "23:34",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Lugoj",
				"to": "Găvojdia",
				"leavesAt": "23:36",
				"arrivesAt": "23:45",
				"waitsAtSource": 120,
				"distance": 11900
			},
			{
				"from": "Găvojdia",
				"to": "Caransebeş",
				"leavesAt": "23:49",
				"arrivesAt": "00:16",
				"waitsAtSource": 240,
				"distance": 27500
			},
			{
				"from": "Caransebeş",
				"to": "Băile Herculane",
				"leavesAt": "00:30",
				"arrivesAt": "01:53",
				"waitsAtSource": 840,
				"distance": 70800
			},
			{
				"from": "Băile Herculane",
				"to": "Orşova",
				"leavesAt": "01:55",
				"arrivesAt": "02:15",
				"waitsAtSource": 120,
				"distance": 17500
			},
			{
				"from": "Orşova",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "02:16",
				"arrivesAt": "02:47",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Balota",
				"leavesAt": "02:53",
				"arrivesAt": "03:27",
				"waitsAtSource": 360,
				"distance": 19000
			},
			{
				"from": "Balota",
				"to": "Strehaia hc.",
				"leavesAt": "03:28",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Strehaia hc.",
				"to": "Filiaşi",
				"leavesAt": "04:04",
				"arrivesAt": "04:33",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "04:35",
				"arrivesAt": "05:00",
				"waitsAtSource": 120,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "05:10",
				"arrivesAt": "05:51",
				"waitsAtSource": 600,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "05:52",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "06:08",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "06:40",
				"arrivesAt": "07:24",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "07:26",
				"arrivesAt": "07:51",
				"waitsAtSource": 120,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "07:56",
				"arrivesAt": "08:26",
				"waitsAtSource": 300,
				"distance": 25500
			}
		],
		"restrictions": [
			{
				"from": "20180501",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3544",
		"segments": [
			{
				"from": "Cristur Hm.",
				"to": "Beteşti h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:45",
				"waitsAtSource": 0,
				"distance": 1300
			},
			{
				"from": "Beteşti h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Lutiţa h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Lutiţa h.",
				"to": "Dobeni h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Feliceni h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Feliceni h.",
				"to": "Odorhei Sud hc.",
				"leavesAt": "07:17",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Odorhei",
				"leavesAt": "07:27",
				"arrivesAt": "07:31",
				"waitsAtSource": 120,
				"distance": 1200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4142",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:43",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Domneşti pe Şieu h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:09",
				"waitsAtSource": 360,
				"distance": 6600
			},
			{
				"from": "Domneşti pe Şieu h.",
				"to": "Mărişelu Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Bârla pe Şieu h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bârla pe Şieu h.",
				"to": "Şieu Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Şieu Hm.",
				"to": "Şieuţ h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Şieuţ h.",
				"to": "Monor Gledin",
				"leavesAt": "15:33",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Monor Gledin",
				"to": "Râpa de Jos Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Râpa de Jos Hm.",
				"to": "Morăreni h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Morăreni h.",
				"to": "Deda",
				"leavesAt": "15:59",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 4200
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3078",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "14:37",
				"arrivesAt": "14:47",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "14:53",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "15:00",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "15:06",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "15:15",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "15:24",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 7700
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180203",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8003",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "13:20",
				"arrivesAt": "13:29",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "13:30",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "13:36",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:46",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "13:47",
				"arrivesAt": "13:50",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "14:07",
				"arrivesAt": "14:12",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "14:19",
				"arrivesAt": "14:27",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:33",
				"waitsAtSource": 120,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:37",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:49",
				"waitsAtSource": 420,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ivăneşti h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ivăneşti h.",
				"to": "Ciulniţa",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:21",
				"waitsAtSource": 120,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "15:26",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "15:30",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "15:44",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "16:12",
				"arrivesAt": "16:18",
				"waitsAtSource": 1140,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Cernavodă Pod",
				"leavesAt": "16:19",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "16:37",
				"arrivesAt": "16:45",
				"waitsAtSource": 180,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "16:53",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:09",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "17:10",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "17:35",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "17:41",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2091",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "05:44",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "05:52",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "05:56",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:32",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "06:33",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "07:02",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "07:22",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "07:31",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 416
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4091",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "16:12",
				"arrivesAt": "16:18",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "16:25",
				"arrivesAt": "16:34",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Apa Hm.",
				"to": "Seini",
				"leavesAt": "16:44",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Seini",
				"to": "Săbişa h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Săbişa h.",
				"to": "Ilba h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ilba h.",
				"to": "Cicârlău h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Cicârlău h.",
				"to": "Buşag Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Buşag Hm.",
				"to": "Baia Mare",
				"leavesAt": "17:24",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8392",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "18:34",
				"arrivesAt": "18:40",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "18:46",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "18:56",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "19:07",
				"arrivesAt": "19:13",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "19:14",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "19:21",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "19:36",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "19:42",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9406",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "13:15",
				"arrivesAt": "13:26",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "13:27",
				"arrivesAt": "13:33",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "13:53",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Caracal",
				"to": "Fărcaşele Hm.",
				"leavesAt": "14:25",
				"arrivesAt": "14:34",
				"waitsAtSource": 1200,
				"distance": 7800
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Stoeneşti h.",
				"leavesAt": "14:35",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "14:40",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Dăneasa h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dăneasa h.",
				"to": "Radomireşti Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "15:27",
				"arrivesAt": "15:48",
				"waitsAtSource": 660,
				"distance": 17300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2306",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Veche h.",
				"leavesAt": "11:51",
				"arrivesAt": "11:56",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Simeria Veche h.",
				"to": "Turdaş Hm.",
				"leavesAt": "11:57",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Turdaş Hm.",
				"to": "Pricaz h.",
				"leavesAt": "12:03",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Pricaz h.",
				"to": "Orăştie",
				"leavesAt": "12:12",
				"arrivesAt": "12:18",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Orăştie",
				"to": "Geoagiu h.",
				"leavesAt": "12:19",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Geoagiu h.",
				"to": "Şibot",
				"leavesAt": "12:24",
				"arrivesAt": "12:36",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Şibot",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Tărtăria h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Tărtăria h.",
				"to": "Blandiana Hm.",
				"leavesAt": "12:52",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "12:58",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "13:07",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "13:22",
				"arrivesAt": "13:31",
				"waitsAtSource": 180,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "13:32",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "13:40",
				"arrivesAt": "13:43",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "13:44",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "13:57",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3545",
		"segments": [
			{
				"from": "Odorhei",
				"to": "Odorhei Sud hc.",
				"leavesAt": "14:30",
				"arrivesAt": "14:34",
				"waitsAtSource": 0,
				"distance": 1200
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Feliceni h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:44",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Feliceni h.",
				"to": "Dobeni h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Lutiţa h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lutiţa h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Beteşti Est h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Beteşti Est h.",
				"to": "Beteşti h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beteşti h.",
				"to": "Cristur Hm.",
				"leavesAt": "15:19",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5056",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "13:10",
				"arrivesAt": "13:19",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "13:20",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "13:26",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "13:31",
				"arrivesAt": "13:40",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "13:41",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "13:49",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "13:57",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "14:02",
				"arrivesAt": "14:07",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "14:08",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "14:12",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "14:20",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "14:27",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5453",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "18:46",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "19:02",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "19:07",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:34",
				"waitsAtSource": 780,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "19:35",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "19:42",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "19:47",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "20:03",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:25",
				"waitsAtSource": 420,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "20:26",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "20:37",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "20:56",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "21:10",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "21:17",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "21:24",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "21:33",
				"arrivesAt": "21:39",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1753",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "13:45",
				"arrivesAt": "14:36",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "14:38",
				"arrivesAt": "15:11",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "15:12",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "15:50",
				"arrivesAt": "16:21",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "16:22",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "17:02",
				"arrivesAt": "17:24",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "17:25",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "17:54",
				"arrivesAt": "18:34",
				"waitsAtSource": 180,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "18:51",
				"arrivesAt": "19:21",
				"waitsAtSource": 1020,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "19:23",
				"arrivesAt": "19:52",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "19:54",
				"arrivesAt": "20:14",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "20:15",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "20:32",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1529",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "16:43",
				"arrivesAt": "16:58",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Crivina",
				"leavesAt": "16:59",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Crivina",
				"to": "Ploieşti Vest",
				"leavesAt": "17:16",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 19200
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "17:33",
				"arrivesAt": "17:56",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "17:57",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Comarnic",
				"leavesAt": "18:02",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "18:10",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "18:24",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "18:32",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "18:38",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "18:48",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 720,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "19:59",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "20:09",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "20:40",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "20:53",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "21:01",
				"arrivesAt": "21:07",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Făgăraş",
				"to": "Ucea",
				"leavesAt": "21:08",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Ucea",
				"to": "Porumbacu Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:55",
				"waitsAtSource": 300,
				"distance": 18700
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 15400
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "22:23",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2474",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "23:20",
				"arrivesAt": "23:22",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "23:23",
				"arrivesAt": "23:27",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "23:28",
				"arrivesAt": "23:30",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "23:39",
				"arrivesAt": "23:43",
				"waitsAtSource": 540,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "23:44",
				"arrivesAt": "23:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "23:50",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "23:57",
				"arrivesAt": "00:04",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Băbeni",
				"to": "Slăviteşti hc.",
				"leavesAt": "00:05",
				"arrivesAt": "00:10",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Ioneşti Hm.",
				"leavesAt": "00:11",
				"arrivesAt": "00:18",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "00:19",
				"arrivesAt": "00:23",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Fişcălia Hm.",
				"leavesAt": "00:24",
				"arrivesAt": "00:28",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "00:29",
				"arrivesAt": "00:32",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Orleşti hc.",
				"to": "Zăvideni Hm.",
				"leavesAt": "00:33",
				"arrivesAt": "00:39",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Călina h.",
				"leavesAt": "00:40",
				"arrivesAt": "00:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Călina h.",
				"to": "Drăgăşani",
				"leavesAt": "00:45",
				"arrivesAt": "00:53",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Drăgăşani",
				"to": "Zlătărei Hm.",
				"leavesAt": "00:54",
				"arrivesAt": "01:01",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Strejeşti",
				"leavesAt": "01:02",
				"arrivesAt": "01:08",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Strejeşti",
				"to": "Piatra Olt",
				"leavesAt": "01:09",
				"arrivesAt": "01:35",
				"waitsAtSource": 60,
				"distance": 21900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1889",
		"segments": [
			{
				"from": "Titu",
				"to": "Nucet",
				"leavesAt": "18:41",
				"arrivesAt": "18:52",
				"waitsAtSource": 0,
				"distance": 15400
			},
			{
				"from": "Nucet",
				"to": "Târgovişte",
				"leavesAt": "18:53",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 16300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4651",
		"segments": [
			{
				"from": "Vişeu de Jos",
				"to": "Bocicoel h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:34",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Bocicoel h.",
				"to": "Leordina h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:43",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Leordina h.",
				"to": "Leordina",
				"leavesAt": "04:44",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Leordina",
				"to": "Petrova hc.",
				"leavesAt": "04:51",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Petrova hc.",
				"to": "Vişeu Bistra h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Valea Vişeului",
				"leavesAt": "05:11",
				"arrivesAt": "05:25",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Valea Vişeului",
				"to": "Lunca la Tisa h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:56",
				"waitsAtSource": 900,
				"distance": 10700
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Crăciuneşti h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Tisa h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Tisa h.",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Sighetu Marmaţiei",
				"leavesAt": "06:23",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2069",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "02:45",
				"arrivesAt": "02:48",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "02:49",
				"arrivesAt": "02:54",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "02:55",
				"arrivesAt": "03:01",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "03:02",
				"arrivesAt": "03:09",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "03:10",
				"arrivesAt": "03:15",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "03:16",
				"arrivesAt": "03:20",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Lotru",
				"leavesAt": "03:21",
				"arrivesAt": "03:36",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Lotru",
				"to": "Beţel h.",
				"leavesAt": "03:46",
				"arrivesAt": "03:53",
				"waitsAtSource": 600,
				"distance": 5700
			},
			{
				"from": "Beţel h.",
				"to": "Cornet Hm.",
				"leavesAt": "03:54",
				"arrivesAt": "04:01",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cornet Hm.",
				"to": "Balota h.",
				"leavesAt": "04:11",
				"arrivesAt": "04:17",
				"waitsAtSource": 600,
				"distance": 4000
			},
			{
				"from": "Balota h.",
				"to": "Robeşti h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:21",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Robeşti h.",
				"to": "Câineni",
				"leavesAt": "04:22",
				"arrivesAt": "04:29",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Râu Vadului h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Râu Vadului h.",
				"to": "Valea Fratelui h.",
				"leavesAt": "04:39",
				"arrivesAt": "04:43",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "04:44",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "04:58",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "05:09",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "05:47",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "05:52",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2496",
		"segments": [
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "23:50",
				"arrivesAt": "23:59",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "00:00",
				"arrivesAt": "00:07",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "00:08",
				"arrivesAt": "00:11",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "00:12",
				"arrivesAt": "00:24",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "00:25",
				"arrivesAt": "00:33",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4405",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "12:40",
				"arrivesAt": "12:46",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "12:47",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "12:57",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "13:05",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9620",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "19:22",
				"arrivesAt": "19:32",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Giroc h.",
				"leavesAt": "19:33",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Giroc h.",
				"to": "Semenic Hm.",
				"leavesAt": "19:37",
				"arrivesAt": "19:40",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Semenic Hm.",
				"to": "Urseni h.",
				"leavesAt": "19:41",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Urseni h.",
				"to": "Uliuc h.",
				"leavesAt": "19:47",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Uliuc h.",
				"to": "Sacoşu Mic",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Sacoşu Mic",
				"to": "Chevereş h.",
				"leavesAt": "20:01",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Chevereş h.",
				"to": "Bacova h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bacova h.",
				"to": "Buziaş",
				"leavesAt": "20:14",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Buziaş",
				"to": "Căpăt h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:29",
				"waitsAtSource": 120,
				"distance": 7300
			},
			{
				"from": "Căpăt h.",
				"to": "Sinia Hm.",
				"leavesAt": "20:30",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sinia Hm.",
				"to": "Boldur h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Boldur h.",
				"to": "Lugoj",
				"leavesAt": "20:43",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3114",
		"segments": [
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:56",
				"waitsAtSource": 0,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Boiu Bihor h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:05",
				"waitsAtSource": 360,
				"distance": 3800
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Tămaşda h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:10",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Tămaşda h.",
				"to": "Zerind Hm.",
				"leavesAt": "09:11",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Zerind Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "09:24",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "09:32",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "09:39",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "09:47",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "09:55",
				"arrivesAt": "09:59",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "10:00",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:14",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Arad",
				"leavesAt": "10:15",
				"arrivesAt": "10:31",
				"waitsAtSource": 60,
				"distance": 9600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9362",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:38",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "06:02",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "06:24",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5212",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "19:51",
				"arrivesAt": "19:59",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Mihăileni Hm.",
				"leavesAt": "20:05",
				"arrivesAt": "20:11",
				"waitsAtSource": 360,
				"distance": 6200
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Caracău h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Caracău h.",
				"to": "Livezi Ciuc",
				"leavesAt": "20:29",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Utuşoiu h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:42",
				"waitsAtSource": 180,
				"distance": 4100
			},
			{
				"from": "Utuşoiu h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Tarcău h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "20:54",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Bolovăniş h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:13",
				"waitsAtSource": 480,
				"distance": 4900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Ghimeş",
				"leavesAt": "21:14",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ghimeş",
				"to": "Palanca Hm.",
				"leavesAt": "21:20",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Palanca Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "21:27",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Simbrea Hm.",
				"leavesAt": "21:33",
				"arrivesAt": "21:39",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Simbrea Hm.",
				"to": "Goioasa Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Goioasa Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "21:49",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Caraliţa h.",
				"to": "Asău Hm.",
				"leavesAt": "21:54",
				"arrivesAt": "21:59",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Asău Hm.",
				"to": "Comăneşti",
				"leavesAt": "22:00",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "22:16",
				"arrivesAt": "22:26",
				"waitsAtSource": 360,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "22:27",
				"arrivesAt": "22:29",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "22:30",
				"arrivesAt": "22:36",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "22:37",
				"arrivesAt": "22:44",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "22:45",
				"arrivesAt": "22:52",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "22:53",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "22:58",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Oneşti",
				"leavesAt": "23:05",
				"arrivesAt": "23:19",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "23:25",
				"arrivesAt": "23:30",
				"waitsAtSource": 360,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "23:31",
				"arrivesAt": "23:39",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "23:40",
				"arrivesAt": "23:47",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "23:48",
				"arrivesAt": "23:53",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "23:54",
				"arrivesAt": "00:00",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "00:01",
				"arrivesAt": "00:06",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "00:07",
				"arrivesAt": "00:18",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "00:20",
				"arrivesAt": "00:28",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "00:29",
				"arrivesAt": "00:32",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "00:33",
				"arrivesAt": "00:40",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "00:41",
				"arrivesAt": "00:45",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "00:46",
				"arrivesAt": "00:56",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5427",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "16:41",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "16:46",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "16:52",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "17:02",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "17:07",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "17:24",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "17:36",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani Triaj",
				"leavesAt": "17:52",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Paşcani Triaj",
				"to": "Paşcani",
				"leavesAt": "17:58",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "18:31",
				"arrivesAt": "18:45",
				"waitsAtSource": 1560,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "18:46",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "19:00",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "19:09",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "19:20",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "19:34",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "19:42",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5532",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Plăieşu h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:45",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "20:46",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "20:53",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "21:08",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6414",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "19:28",
				"arrivesAt": "19:35",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "19:36",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "20:04",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "20:12",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "20:33",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "20:57",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 9800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5701",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Vest",
				"leavesAt": "05:28",
				"arrivesAt": "05:36",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Suceava Vest",
				"to": "Stroieşti",
				"leavesAt": "05:40",
				"arrivesAt": "05:49",
				"waitsAtSource": 240,
				"distance": 9400
			},
			{
				"from": "Stroieşti",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:19",
				"waitsAtSource": 900,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Gura Humorului Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Gura Humorului Oraş",
				"leavesAt": "06:39",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "06:47",
				"arrivesAt": "06:56",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Molid Hm.",
				"leavesAt": "06:57",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Molid Hm.",
				"to": "Vama",
				"leavesAt": "07:05",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vama",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "07:18",
				"arrivesAt": "07:25",
				"waitsAtSource": 480,
				"distance": 4300
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "07:38",
				"arrivesAt": "07:45",
				"waitsAtSource": 120,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Sadova Hm.",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Sadova Hm.",
				"to": "Pojorâta Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Valea Putnei P.M.",
				"leavesAt": "08:00",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Mestecăniş",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "08:25",
				"arrivesAt": "08:34",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Argestru Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Argestru Hm.",
				"to": "Vatra Dornei",
				"leavesAt": "08:44",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "08:53",
				"arrivesAt": "08:56",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Roşu Hm.",
				"leavesAt": "08:58",
				"arrivesAt": "09:05",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Roşu Hm.",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Floreni",
				"leavesAt": "09:12",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Floreni",
				"to": "Coşna Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Coşna Hm.",
				"to": "Grădiniţa",
				"leavesAt": "09:29",
				"arrivesAt": "09:39",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Grădiniţa",
				"to": "Larion Hm.",
				"leavesAt": "09:40",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Larion Hm.",
				"to": "Silhoasa Hm.",
				"leavesAt": "09:50",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "10:02",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Ilva Mare Hm.",
				"leavesAt": "10:11",
				"arrivesAt": "10:21",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "10:22",
				"arrivesAt": "10:32",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "10:33",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "10:42",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Strâmba h.",
				"leavesAt": "10:52",
				"arrivesAt": "10:56",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Strâmba h.",
				"to": "Ilva Mică",
				"leavesAt": "10:57",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "473",
		"segments": [
			{
				"from": "Lokoshaza",
				"to": "Curtici",
				"leavesAt": "23:51",
				"arrivesAt": "00:01",
				"waitsAtSource": 0,
				"distance": 11200
			},
			{
				"from": "Curtici",
				"to": "Arad",
				"leavesAt": "00:31",
				"arrivesAt": "00:45",
				"waitsAtSource": 1800,
				"distance": 17000
			},
			{
				"from": "Arad",
				"to": "Deva",
				"leavesAt": "00:47",
				"arrivesAt": "03:30",
				"waitsAtSource": 120,
				"distance": 148200
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "03:32",
				"arrivesAt": "03:44",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Vinţu de Jos",
				"leavesAt": "03:56",
				"arrivesAt": "04:53",
				"waitsAtSource": 720,
				"distance": 43800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Sebeş Alba",
				"leavesAt": "04:54",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Sebeş Alba",
				"to": "Sibiu",
				"leavesAt": "05:05",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 73700
			},
			{
				"from": "Sibiu",
				"to": "Porumbacu Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "07:27",
				"waitsAtSource": 480,
				"distance": 40600
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Făgăraş",
				"leavesAt": "07:31",
				"arrivesAt": "08:11",
				"waitsAtSource": 240,
				"distance": 43300
			},
			{
				"from": "Făgăraş",
				"to": "Codlea Hm.",
				"leavesAt": "08:13",
				"arrivesAt": "09:08",
				"waitsAtSource": 120,
				"distance": 51200
			},
			{
				"from": "Codlea Hm.",
				"to": "Braşov",
				"leavesAt": "09:09",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "09:38",
				"arrivesAt": "10:13",
				"waitsAtSource": 720,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Buşteni",
				"leavesAt": "10:15",
				"arrivesAt": "10:27",
				"waitsAtSource": 120,
				"distance": 11400
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "10:28",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Ploieşti Vest",
				"leavesAt": "10:39",
				"arrivesAt": "11:22",
				"waitsAtSource": 120,
				"distance": 62100
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "11:24",
				"arrivesAt": "12:05",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3001",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "06:22",
				"arrivesAt": "06:30",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "06:31",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "06:35",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "06:47",
				"arrivesAt": "06:54",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "07:00",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:14",
				"waitsAtSource": 360,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "07:15",
				"arrivesAt": "07:23",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "07:24",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Ploieşti Vest",
				"leavesAt": "07:30",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "07:46",
				"arrivesAt": "07:53",
				"waitsAtSource": 720,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "07:54",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Bobolia h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Bobolia h.",
				"to": "Câmpina",
				"leavesAt": "08:12",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "08:30",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Posada h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Posada h.",
				"to": "Sinaia Sud h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "08:55",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "09:00",
				"arrivesAt": "09:05",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "09:06",
				"arrivesAt": "09:10",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "09:11",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "09:17",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "09:29",
				"arrivesAt": "09:44",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Timişu de Jos h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Dârste",
				"leavesAt": "09:54",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "10:03",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1948",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "18:42",
				"arrivesAt": "18:49",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Reghin",
				"leavesAt": "18:55",
				"arrivesAt": "19:26",
				"waitsAtSource": 360,
				"distance": 28200
			},
			{
				"from": "Reghin",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "19:28",
				"arrivesAt": "19:43",
				"waitsAtSource": 120,
				"distance": 16100
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Deda",
				"leavesAt": "19:48",
				"arrivesAt": "19:54",
				"waitsAtSource": 300,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2213",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "19:45",
				"arrivesAt": "19:55",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "19:56",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3112",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Vest Hm.",
				"leavesAt": "05:02",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "05:10",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Cefa Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cefa Hm.",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Salonta",
				"leavesAt": "05:43",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Boiu Bihor h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Tămaşda h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tămaşda h.",
				"to": "Zerind Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Zerind Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "06:23",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "06:53",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Utvinişu Nou",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "07:17",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "07:42",
				"arrivesAt": "07:49",
				"waitsAtSource": 900,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Valea Viilor Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Şag Hm.",
				"leavesAt": "08:10",
				"arrivesAt": "08:15",
				"waitsAtSource": 600,
				"distance": 5500
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "08:16",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "08:23",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "08:29",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "08:53",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1934",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Carei",
				"leavesAt": "17:55",
				"arrivesAt": "18:28",
				"waitsAtSource": 0,
				"distance": 36000
			},
			{
				"from": "Carei",
				"to": "Valea lui Mihai",
				"leavesAt": "18:40",
				"arrivesAt": "19:08",
				"waitsAtSource": 720,
				"distance": 31200
			},
			{
				"from": "Valea lui Mihai",
				"to": "Săcuieni Bihor",
				"leavesAt": "19:09",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Diosig Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Diosig Hm.",
				"to": "Oradea",
				"leavesAt": "19:49",
				"arrivesAt": "20:24",
				"waitsAtSource": 600,
				"distance": 33700
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "20:38",
				"arrivesAt": "21:12",
				"waitsAtSource": 840,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Bratca",
				"leavesAt": "21:13",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 25300
			},
			{
				"from": "Bratca",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "21:43",
				"arrivesAt": "21:56",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Ciucea Hm.",
				"leavesAt": "22:02",
				"arrivesAt": "22:13",
				"waitsAtSource": 360,
				"distance": 10800
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "22:14",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "22:37",
				"arrivesAt": "23:01",
				"waitsAtSource": 120,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "23:02",
				"arrivesAt": "23:30",
				"waitsAtSource": 60,
				"distance": 27900
			},
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "23:49",
				"arrivesAt": "00:56",
				"waitsAtSource": 1140,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "00:57",
				"arrivesAt": "01:13",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Aiud Hm.",
				"leavesAt": "01:14",
				"arrivesAt": "01:32",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "01:33",
				"arrivesAt": "01:47",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Crăciunel Hm.",
				"leavesAt": "01:53",
				"arrivesAt": "02:16",
				"waitsAtSource": 360,
				"distance": 16000
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Blaj",
				"leavesAt": "02:21",
				"arrivesAt": "02:29",
				"waitsAtSource": 300,
				"distance": 5300
			},
			{
				"from": "Blaj",
				"to": "Copşa Mică",
				"leavesAt": "02:31",
				"arrivesAt": "03:09",
				"waitsAtSource": 120,
				"distance": 30000
			},
			{
				"from": "Copşa Mică",
				"to": "Mediaş",
				"leavesAt": "03:14",
				"arrivesAt": "03:27",
				"waitsAtSource": 300,
				"distance": 10400
			},
			{
				"from": "Mediaş",
				"to": "Dumbrăveni",
				"leavesAt": "03:39",
				"arrivesAt": "04:05",
				"waitsAtSource": 720,
				"distance": 18000
			},
			{
				"from": "Dumbrăveni",
				"to": "Sighişoara",
				"leavesAt": "04:07",
				"arrivesAt": "04:34",
				"waitsAtSource": 120,
				"distance": 20400
			},
			{
				"from": "Sighişoara",
				"to": "Rupea",
				"leavesAt": "04:38",
				"arrivesAt": "05:39",
				"waitsAtSource": 240,
				"distance": 53600
			},
			{
				"from": "Rupea",
				"to": "Braşov",
				"leavesAt": "05:41",
				"arrivesAt": "07:16",
				"waitsAtSource": 120,
				"distance": 73800
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "07:25",
				"arrivesAt": "08:00",
				"waitsAtSource": 540,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "08:02",
				"arrivesAt": "08:11",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "08:12",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "08:19",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "08:30",
				"arrivesAt": "08:54",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "08:55",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "09:21",
				"arrivesAt": "10:06",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1788",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "13:00",
				"arrivesAt": "13:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "13:16",
				"arrivesAt": "13:39",
				"waitsAtSource": 300,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "13:40",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "14:07",
				"arrivesAt": "14:47",
				"waitsAtSource": 480,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1726",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Cărbuneşti",
				"leavesAt": "13:55",
				"arrivesAt": "14:21",
				"waitsAtSource": 0,
				"distance": 23800
			},
			{
				"from": "Cărbuneşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "14:52",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Filiaşi",
				"leavesAt": "15:00",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 12400
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "15:15",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "15:45",
				"arrivesAt": "16:24",
				"waitsAtSource": 300,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20180807",
				"to": "20181208",
				"daysOfWeek": 783
			},
			{
				"from": "20171210",
				"to": "20180802",
				"daysOfWeek": 783
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5450",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "19:50",
				"arrivesAt": "19:55",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "19:57",
				"arrivesAt": "20:04",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "20:05",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "20:13",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "20:33",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 600,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "21:10",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:40",
				"waitsAtSource": 1020,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "21:41",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "21:47",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "21:52",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "21:58",
				"arrivesAt": "22:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "22:03",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "22:10",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "22:21",
				"arrivesAt": "22:28",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "22:29",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "22:34",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "22:43",
				"arrivesAt": "22:48",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "22:49",
				"arrivesAt": "22:54",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "22:55",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9028",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "13:40",
				"arrivesAt": "13:45",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slatina",
				"leavesAt": "13:46",
				"arrivesAt": "14:03",
				"waitsAtSource": 30,
				"distance": 13000
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "14:05",
				"arrivesAt": "14:13",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "14:14",
				"arrivesAt": "14:21",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "14:22",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "14:37",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "14:51",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "15:07",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Suseni h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:22",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Suseni h.",
				"to": "Pârvu h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pârvu h.",
				"to": "Bradu de Sus",
				"leavesAt": "15:27",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:49",
				"waitsAtSource": 240,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "15:50",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Piteşti",
				"to": "Ram. Goleşti",
				"leavesAt": "16:10",
				"arrivesAt": "16:16",
				"waitsAtSource": 1080,
				"distance": 4600
			},
			{
				"from": "Ram. Goleşti",
				"to": "Goleşti",
				"leavesAt": "16:17",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Goleşti",
				"to": "Călineşti Hm.",
				"leavesAt": "16:25",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Călineşti Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Pătroaia Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Găeşti",
				"leavesAt": "16:47",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Găeşti",
				"to": "Găeşti Sud h.",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Cojocaru h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Cojocaru h.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Fusea Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Fusea Hm.",
				"to": "Titu",
				"leavesAt": "17:14",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:28",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "17:45",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "17:52",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "18:00",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "18:07",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "18:19",
				"arrivesAt": "18:21",
				"waitsAtSource": 300,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "18:22",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "18:26",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180617",
				"daysOfWeek": 383
			},
			{
				"from": "20180623",
				"to": "20180624",
				"daysOfWeek": 383
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 383
			},
			{
				"from": "20180707",
				"to": "20180708",
				"daysOfWeek": 383
			},
			{
				"from": "20180714",
				"to": "20180715",
				"daysOfWeek": 383
			},
			{
				"from": "20180721",
				"to": "20180722",
				"daysOfWeek": 383
			},
			{
				"from": "20180728",
				"to": "20180729",
				"daysOfWeek": 383
			},
			{
				"from": "20180804",
				"to": "20180805",
				"daysOfWeek": 383
			},
			{
				"from": "20180811",
				"to": "20180819",
				"daysOfWeek": 383
			},
			{
				"from": "20180825",
				"to": "20180826",
				"daysOfWeek": 383
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 383
			},
			{
				"from": "20180908",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180506",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2511",
		"segments": [
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "04:06",
				"arrivesAt": "04:14",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "04:19",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:33",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "04:34",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:53",
				"waitsAtSource": 300,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "05:08",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:34",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9586",
		"segments": [
			{
				"from": "Jimbolia",
				"to": "Clarii Vii h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:14",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Clarii Vii h.",
				"to": "Cărpiniş",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Cărpiniş",
				"to": "Beregsău hcv.",
				"leavesAt": "06:24",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Beregsău hcv.",
				"to": "Săcălaz h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săcălaz h.",
				"to": "Timişoara Nord",
				"leavesAt": "06:40",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1926",
		"segments": [
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "20:02",
				"arrivesAt": "20:15",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Călan Hm.",
				"leavesAt": "20:24",
				"arrivesAt": "20:40",
				"waitsAtSource": 540,
				"distance": 14600
			},
			{
				"from": "Călan Hm.",
				"to": "Subcetate",
				"leavesAt": "20:41",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Subcetate",
				"to": "Petroşani",
				"leavesAt": "20:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 49800
			},
			{
				"from": "Petroşani",
				"to": "Livezeni",
				"leavesAt": "22:08",
				"arrivesAt": "22:15",
				"waitsAtSource": 240,
				"distance": 5200
			},
			{
				"from": "Livezeni",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "22:16",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "22:26",
				"arrivesAt": "23:02",
				"waitsAtSource": 240,
				"distance": 23500
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "23:04",
				"arrivesAt": "23:27",
				"waitsAtSource": 120,
				"distance": 19600
			},
			{
				"from": "Târgu Jiu",
				"to": "Rovinari Hm.",
				"leavesAt": "23:30",
				"arrivesAt": "23:59",
				"waitsAtSource": 180,
				"distance": 21800
			},
			{
				"from": "Rovinari Hm.",
				"to": "Turceni",
				"leavesAt": "00:00",
				"arrivesAt": "00:35",
				"waitsAtSource": 60,
				"distance": 35300
			},
			{
				"from": "Turceni",
				"to": "Filiaşi",
				"leavesAt": "00:36",
				"arrivesAt": "01:02",
				"waitsAtSource": 60,
				"distance": 19900
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "01:04",
				"arrivesAt": "01:30",
				"waitsAtSource": 120,
				"distance": 35800
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "347",
		"segments": [
			{
				"from": "Lokoshaza",
				"to": "Curtici",
				"leavesAt": "03:39",
				"arrivesAt": "03:49",
				"waitsAtSource": 0,
				"distance": 11200
			},
			{
				"from": "Curtici",
				"to": "Arad",
				"leavesAt": "04:19",
				"arrivesAt": "04:33",
				"waitsAtSource": 1800,
				"distance": 17000
			},
			{
				"from": "Arad",
				"to": "Deva",
				"leavesAt": "04:47",
				"arrivesAt": "07:28",
				"waitsAtSource": 840,
				"distance": 148200
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "07:30",
				"arrivesAt": "07:42",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Şibot",
				"leavesAt": "07:54",
				"arrivesAt": "08:33",
				"waitsAtSource": 720,
				"distance": 28800
			},
			{
				"from": "Şibot",
				"to": "Vinţu de Jos",
				"leavesAt": "08:34",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Vinţu de Jos",
				"to": "Cunţa Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 22100
			},
			{
				"from": "Cunţa Hm.",
				"to": "Sibiu",
				"leavesAt": "09:30",
				"arrivesAt": "10:44",
				"waitsAtSource": 240,
				"distance": 60700
			},
			{
				"from": "Sibiu",
				"to": "Făgăraş",
				"leavesAt": "10:54",
				"arrivesAt": "12:18",
				"waitsAtSource": 600,
				"distance": 83900
			},
			{
				"from": "Făgăraş",
				"to": "Braşov",
				"leavesAt": "12:20",
				"arrivesAt": "13:30",
				"waitsAtSource": 120,
				"distance": 65000
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "13:42",
				"arrivesAt": "14:17",
				"waitsAtSource": 720,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Sinaia",
				"leavesAt": "14:19",
				"arrivesAt": "14:38",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Sinaia",
				"to": "Ploieşti Vest",
				"leavesAt": "14:39",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 62100
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "15:24",
				"arrivesAt": "16:05",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9359",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "04:16",
				"arrivesAt": "04:21",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "04:22",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "04:36",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "04:45",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "04:55",
				"arrivesAt": "05:05",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "05:06",
				"arrivesAt": "05:12",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4515",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:54",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "20:01",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "20:23",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Arcuş h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:40",
				"waitsAtSource": 300,
				"distance": 5000
			},
			{
				"from": "Arcuş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "20:41",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Bodoc Hm.",
				"to": "Malnaş h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Malnaş h.",
				"to": "Malnaş Băi",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş Băi",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:20",
				"waitsAtSource": 480,
				"distance": 7800
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "21:21",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "21:31",
				"arrivesAt": "21:38",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Vrabia h.",
				"leavesAt": "21:39",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Vrabia h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "21:43",
				"arrivesAt": "21:49",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "21:50",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "21:54",
				"arrivesAt": "21:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "21:59",
				"arrivesAt": "22:07",
				"waitsAtSource": 60,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8015",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "20:00",
				"arrivesAt": "20:09",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "20:10",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "20:16",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "20:28",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:41",
				"waitsAtSource": 480,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "20:42",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "21:07",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "21:21",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "21:31",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "21:38",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ivăneşti h.",
				"leavesAt": "21:42",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ivăneşti h.",
				"to": "Ciulniţa",
				"leavesAt": "21:47",
				"arrivesAt": "21:53",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "21:54",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "22:01",
				"arrivesAt": "22:04",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "22:05",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "22:09",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "22:13",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "22:18",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "22:23",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8393",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "19:39",
				"arrivesAt": "19:50",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "19:58",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "20:07",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "20:21",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:37",
				"arrivesAt": "20:39",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "20:40",
				"arrivesAt": "20:50",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "20:51",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "20:56",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9306",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "16:32",
				"arrivesAt": "16:39",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "16:49",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "16:55",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "17:22",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:38",
				"waitsAtSource": 120,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Zorile h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zorile h.",
				"to": "Grădinari",
				"leavesAt": "17:57",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:15",
				"waitsAtSource": 240,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "18:16",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "18:33",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Carpaţi h.(900)",
				"leavesAt": "18:37",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "18:44",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9400",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "03:40",
				"arrivesAt": "03:51",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "03:52",
				"arrivesAt": "03:58",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "03:59",
				"arrivesAt": "04:03",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "04:04",
				"arrivesAt": "04:16",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "04:17",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20181130",
				"daysOfWeek": 319
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1784",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "08:00",
				"arrivesAt": "08:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "08:12",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "08:36",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "08:56",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1949",
		"segments": [
			{
				"from": "Deda",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "03:25",
				"arrivesAt": "03:32",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Reghin",
				"leavesAt": "03:39",
				"arrivesAt": "03:56",
				"waitsAtSource": 420,
				"distance": 16100
			},
			{
				"from": "Reghin",
				"to": "Târgu Mureş",
				"leavesAt": "03:58",
				"arrivesAt": "04:32",
				"waitsAtSource": 120,
				"distance": 32300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1994",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "04:28",
				"arrivesAt": "05:07",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "05:08",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Radomireşti Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "05:36",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 25600
			},
			{
				"from": "Roşiori Nord",
				"to": "Olteni",
				"leavesAt": "06:00",
				"arrivesAt": "06:26",
				"waitsAtSource": 120,
				"distance": 26800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Videle",
				"leavesAt": "06:36",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 15800
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "06:50",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "07:16",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 25500
			},
			{
				"from": "Bucureşti Nord",
				"to": "Feteşti",
				"leavesAt": "08:05",
				"arrivesAt": "09:20",
				"waitsAtSource": 1260,
				"distance": 146400
			},
			{
				"from": "Feteşti",
				"to": "Constanţa",
				"leavesAt": "09:21",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 78600
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "10:45",
				"arrivesAt": "11:11",
				"waitsAtSource": 1620,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "11:14",
				"arrivesAt": "11:22",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "11:25",
				"arrivesAt": "11:41",
				"waitsAtSource": 180,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "11:49",
				"arrivesAt": "11:53",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "11:56",
				"arrivesAt": "12:09",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "12:12",
				"arrivesAt": "12:22",
				"waitsAtSource": 180,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8203",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Sud",
				"leavesAt": "16:20",
				"arrivesAt": "16:26",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Buzău Sud",
				"to": "Tăbărăşti h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:40",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "16:41",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "16:58",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Făurei",
				"leavesAt": "17:06",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Făurei",
				"to": "Cireşu Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 15700
			},
			{
				"from": "Cireşu Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "17:33",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Dudeşti Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Spicu",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Spicu",
				"to": "Murgeanca Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Ţăndărei",
				"leavesAt": "17:59",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Ţăndărei",
				"to": "Platoneşti h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Platoneşti h.",
				"to": "Movila Hm.",
				"leavesAt": "18:17",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "18:26",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "18:47",
				"arrivesAt": "18:54",
				"waitsAtSource": 240,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Ovidiu",
				"leavesAt": "18:55",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ovidiu",
				"to": "Dunărea Hm.",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Dunărea Hm.",
				"to": "Cernavodă Pod",
				"leavesAt": "19:07",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "19:18",
				"arrivesAt": "19:26",
				"waitsAtSource": 180,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "19:34",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:49",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "19:50",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "19:55",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "20:00",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:09",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "20:10",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "20:15",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "20:21",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3511",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:33",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "13:34",
				"arrivesAt": "13:41",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Şeica Mică h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:51",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Şeica Mică h.",
				"to": "Micăsasa h.",
				"leavesAt": "13:52",
				"arrivesAt": "14:04",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Micăsasa h.",
				"to": "Lunca h.",
				"leavesAt": "14:05",
				"arrivesAt": "14:14",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lunca h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "14:15",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Glogoveţ h.",
				"leavesAt": "14:21",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Glogoveţ h.",
				"to": "Mănărade h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Mănărade h.",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Blaj",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Blaj",
				"to": "Crăciunel Hm.",
				"leavesAt": "14:50",
				"arrivesAt": "14:58",
				"waitsAtSource": 540,
				"distance": 5300
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Cistei h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cistei h.",
				"to": "Mihalţ h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mihalţ h.",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "15:15",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Teiuş",
				"leavesAt": "15:20",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9341",
		"segments": [
			{
				"from": "Videle",
				"to": "Răduleşti Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "06:02",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "06:03",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Târnavele Hm.",
				"to": "Vlaşca Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Răsuceni h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Răsuceni h.",
				"to": "Toporu",
				"leavesAt": "06:29",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Toporu",
				"to": "Chiriacu Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Stăneşti Hm.",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Onceşti h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Onceşti h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Cetatea h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cetatea h.",
				"to": "Giurgiu Nord",
				"leavesAt": "07:09",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Giurgiu Nord",
				"to": "Giurgiu",
				"leavesAt": "07:16",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3083",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:29",
				"waitsAtSource": 0,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Mirăslău h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mirăslău h.",
				"to": "Decea h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:39",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Decea h.",
				"to": "Unirea Hm.",
				"leavesAt": "04:40",
				"arrivesAt": "04:45",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Unirea Hm.",
				"to": "Unirea hc.",
				"leavesAt": "04:46",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "04:50",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Grindeni h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Grindeni h.",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "05:04",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Câmpia Turzii",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cânepişti h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:30",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Cânepişti h.",
				"to": "Ploscoş h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Ploscoş h.",
				"to": "Valea Florilor Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Boju",
				"leavesAt": "05:44",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Boju",
				"to": "Tunel Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Tunel Hm.",
				"to": "Cojocna Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cojocna Hm.",
				"to": "Apahida",
				"leavesAt": "06:13",
				"arrivesAt": "06:19",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "06:24",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1971",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "18:40",
				"arrivesAt": "19:04",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "19:05",
				"arrivesAt": "19:22",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "19:23",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "20:01",
				"waitsAtSource": 120,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Platoneşti h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Platoneşti h.",
				"to": "Ţăndărei",
				"leavesAt": "20:09",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ţăndărei",
				"to": "Ianca hc.",
				"leavesAt": "20:18",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 72100
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "21:28",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "22:02",
				"arrivesAt": "22:20",
				"waitsAtSource": 120,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "22:21",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3538",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "18:25",
				"arrivesAt": "18:33",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "18:34",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Saschiz h.",
				"leavesAt": "18:42",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Mureni Hm.",
				"leavesAt": "18:47",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mureni Hm.",
				"to": "Archita h",
				"leavesAt": "18:54",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Archita h",
				"to": "Beia Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Beia Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Caţa Hm.",
				"leavesAt": "19:32",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Caţa Hm.",
				"to": "Rupea",
				"leavesAt": "19:39",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Rupea",
				"to": "Mateiaş h.",
				"leavesAt": "19:49",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Mateiaş h.",
				"to": "Racoş Hm.",
				"leavesAt": "20:04",
				"arrivesAt": "20:10",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Ormeniş h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ormeniş h.",
				"to": "Apaţa",
				"leavesAt": "20:37",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Apaţa",
				"to": "Măieruş h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Măieruş h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "20:54",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Rotbav h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Rotbav h.",
				"to": "Feldioara Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:13",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Bod Hm.",
				"leavesAt": "21:14",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Bod Hm.",
				"to": "Stupini Hm.",
				"leavesAt": "21:30",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Stupini Hm.",
				"to": "Braşov",
				"leavesAt": "21:40",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2205",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "12:50",
				"arrivesAt": "13:00",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "13:01",
				"arrivesAt": "13:10",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9120",
		"segments": [
			{
				"from": "Parcul Kreţulescu h.",
				"to": "Câmpulung",
				"leavesAt": "05:35",
				"arrivesAt": "05:38",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Câmpulung",
				"to": "Schitu Goleşti",
				"leavesAt": "05:40",
				"arrivesAt": "05:51",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Schitu Goleşti",
				"to": "Lăzăreşti Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lăzăreşti Hm.",
				"to": "Drăghici h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Drăghici h.",
				"to": "Stâlpeni Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Stâlpeni Hm.",
				"to": "Clucereasa h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Clucereasa h.",
				"to": "Ciumeşti",
				"leavesAt": "06:28",
				"arrivesAt": "06:40",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Ciumeşti",
				"to": "Gropeni h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Gropeni h.",
				"to": "Ştefăneşti Argeş Hm.",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ştefăneşti Argeş Hm.",
				"to": "Goleşti",
				"leavesAt": "06:54",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4456",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:33",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "17:34",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "17:47",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5414",
		"segments": [
			{
				"from": "Bacău",
				"to": "Letea h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:41",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Letea h.",
				"to": "Valea Seacă",
				"leavesAt": "13:42",
				"arrivesAt": "13:47",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Seacă",
				"to": "Siretu Bacău h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Faraoani Hm.",
				"leavesAt": "13:53",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Faraoani Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "13:59",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Răcăciuni h.",
				"to": "Orbeni Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Orbeni Hm.",
				"to": "Sascut Hm.",
				"leavesAt": "14:18",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Sascut Hm.",
				"to": "Şişcani h.",
				"leavesAt": "14:26",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Şişcani h.",
				"to": "Adjudu Vechi h.",
				"leavesAt": "14:33",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Adjud",
				"leavesAt": "14:38",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5634",
		"segments": [
			{
				"from": "Dorneşti",
				"to": "Ţibeni h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:37",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Ţibeni h.",
				"to": "Milişăuţi Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dărmăneşti",
				"leavesAt": "17:47",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "17:59",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "18:11",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "367",
		"segments": [
			{
				"from": "Biharkeresztes",
				"to": "Episcopia Bihor",
				"leavesAt": "12:28",
				"arrivesAt": "12:43",
				"waitsAtSource": 0,
				"distance": 12500
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "12:58",
				"arrivesAt": "13:06",
				"waitsAtSource": 900,
				"distance": 5700
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "13:13",
				"arrivesAt": "13:44",
				"waitsAtSource": 420,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Bratca",
				"leavesAt": "13:45",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 25300
			},
			{
				"from": "Bratca",
				"to": "Ciucea Hm.",
				"leavesAt": "14:12",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "14:34",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "14:55",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "15:20",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 27900
			},
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "16:08",
				"arrivesAt": "17:06",
				"waitsAtSource": 1260,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "17:08",
				"arrivesAt": "17:27",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "17:31",
				"arrivesAt": "18:04",
				"waitsAtSource": 240,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Sărăţel Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:32",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Deda",
				"leavesAt": "18:33",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Deda",
				"to": "Topliţa",
				"leavesAt": "19:29",
				"arrivesAt": "20:26",
				"waitsAtSource": 120,
				"distance": 43900
			},
			{
				"from": "Topliţa",
				"to": "Gheorgheni",
				"leavesAt": "20:28",
				"arrivesAt": "21:00",
				"waitsAtSource": 120,
				"distance": 34000
			},
			{
				"from": "Gheorgheni",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "21:02",
				"arrivesAt": "21:11",
				"waitsAtSource": 120,
				"distance": 9000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "21:17",
				"arrivesAt": "21:41",
				"waitsAtSource": 360,
				"distance": 21000
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "21:43",
				"arrivesAt": "22:02",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "22:04",
				"arrivesAt": "22:12",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "22:14",
				"arrivesAt": "22:37",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bodoc Hm.",
				"leavesAt": "22:39",
				"arrivesAt": "23:06",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Bodoc Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "23:13",
				"arrivesAt": "23:22",
				"waitsAtSource": 420,
				"distance": 9500
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "23:24",
				"arrivesAt": "23:54",
				"waitsAtSource": 120,
				"distance": 32100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9367",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "14:20",
				"arrivesAt": "14:25",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "14:26",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "14:41",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "14:51",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:12",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "15:13",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Alexandria",
				"to": "Ţigăneşti h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:32",
				"waitsAtSource": 120,
				"distance": 9500
			},
			{
				"from": "Ţigăneşti h.",
				"to": "Brânceni h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Brânceni h.",
				"to": "Smârdioasa h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Smârdioasa h.",
				"to": "Păuleasa h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Păuleasa h.",
				"to": "Şoimu h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Şoimu h.",
				"to": "Ulmuleţ h.",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Ulmuleţ h.",
				"to": "Zimnicea",
				"leavesAt": "16:05",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 9800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8595",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Ştefan Vodă h.",
				"leavesAt": "18:52",
				"arrivesAt": "19:05",
				"waitsAtSource": 0,
				"distance": 12600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "19:06",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Km. 25+700 h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Sud",
				"leavesAt": "19:20",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5443",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "09:29",
				"arrivesAt": "09:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "09:46",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "09:52",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "10:02",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "10:07",
				"arrivesAt": "10:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "10:16",
				"arrivesAt": "10:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "10:24",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "10:31",
				"arrivesAt": "10:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "10:36",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "10:42",
				"arrivesAt": "10:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "10:52",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "11:10",
				"arrivesAt": "11:15",
				"waitsAtSource": 480,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "11:16",
				"arrivesAt": "11:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "11:27",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "11:33",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "11:39",
				"arrivesAt": "11:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "11:46",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "11:53",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "12:00",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "12:07",
				"arrivesAt": "12:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "12:14",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "12:23",
				"arrivesAt": "12:29",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8032",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "11:55",
				"arrivesAt": "12:01",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "12:02",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "12:10",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "12:16",
				"arrivesAt": "12:20",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:25",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "12:26",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "12:31",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "12:35",
				"arrivesAt": "12:41",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "12:42",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "12:52",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "12:58",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Dunărea Hm.",
				"leavesAt": "13:08",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Dunărea Hm.",
				"to": "Ovidiu",
				"leavesAt": "13:18",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ovidiu",
				"to": "Ramificaţia Borcea",
				"leavesAt": "13:25",
				"arrivesAt": "13:29",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "13:30",
				"arrivesAt": "13:37",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1866",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "16:40",
				"arrivesAt": "16:59",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Lieşti",
				"leavesAt": "17:04",
				"arrivesAt": "17:50",
				"waitsAtSource": 300,
				"distance": 48300
			},
			{
				"from": "Lieşti",
				"to": "Tecuci",
				"leavesAt": "17:51",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 24400
			},
			{
				"from": "Tecuci",
				"to": "Nichişeni",
				"leavesAt": "18:24",
				"arrivesAt": "18:47",
				"waitsAtSource": 180,
				"distance": 24400
			},
			{
				"from": "Nichişeni",
				"to": "Bârlad",
				"leavesAt": "18:52",
				"arrivesAt": "19:15",
				"waitsAtSource": 300,
				"distance": 25900
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "19:17",
				"arrivesAt": "19:46",
				"waitsAtSource": 120,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "19:47",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "20:03",
				"arrivesAt": "20:21",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "20:49",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "21:05",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8016",
		"segments": [
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "14:20",
				"arrivesAt": "14:30",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "14:36",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "14:41",
				"arrivesAt": "14:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "14:45",
				"arrivesAt": "14:48",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "14:49",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "14:53",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Bogdana h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bogdana h.",
				"to": "Dâlga h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Dâlga h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "15:29",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Lehliu",
				"leavesAt": "15:33",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Lehliu",
				"to": "Preasna h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Preasna h.",
				"to": "Săruleşti",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Săruleşti",
				"to": "Mostiştea h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:01",
				"waitsAtSource": 420,
				"distance": 5900
			},
			{
				"from": "Mostiştea h.",
				"to": "Fundulea Hm.",
				"leavesAt": "16:02",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Fundulea Hm.",
				"to": "Islaz h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Islaz h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "16:15",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Brăneşti Sat h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Pasărea",
				"leavesAt": "16:22",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pasărea",
				"to": "Pantelimon",
				"leavesAt": "16:29",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "16:36",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "16:39",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4504",
		"segments": [
			{
				"from": "Topliţa",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:31",
				"waitsAtSource": 0,
				"distance": 6000
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Ditrău",
				"leavesAt": "04:46",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ditrău",
				"to": "Lăzarea Hm.",
				"leavesAt": "04:55",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Gheorgheni",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Gheorgheni",
				"to": "Valea Strâmbă h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:12",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Şugău h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Şugău h.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Sândominic h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Oltului",
				"leavesAt": "05:42",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Tomeşti h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Cârţani h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Cârţani h.",
				"to": "Dăneşti h.",
				"leavesAt": "05:56",
				"arrivesAt": "05:59",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Dăneşti h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Racu h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Racu h.",
				"to": "Siculeni",
				"leavesAt": "06:13",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "06:22",
				"arrivesAt": "06:30",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:44",
				"waitsAtSource": 3960,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "07:51",
				"arrivesAt": "07:55",
				"waitsAtSource": 420,
				"distance": 3400
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Vrabia h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vrabia h.",
				"to": "Tuşnad Sat",
				"leavesAt": "08:07",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:27",
				"waitsAtSource": 480,
				"distance": 5700
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Malnaş Băi",
				"leavesAt": "08:36",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Malnaş Băi",
				"to": "Malnaş h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "08:51",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Bodoc Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "08:59",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "09:20",
				"arrivesAt": "09:25",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "09:26",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "09:30",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1838",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Buziaş",
				"leavesAt": "17:36",
				"arrivesAt": "18:13",
				"waitsAtSource": 0,
				"distance": 36400
			},
			{
				"from": "Buziaş",
				"to": "Lugoj",
				"leavesAt": "18:14",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 27500
			},
			{
				"from": "Lugoj",
				"to": "Mănăştur Hm.",
				"leavesAt": "18:45",
				"arrivesAt": "19:16",
				"waitsAtSource": 60,
				"distance": 31200
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Făget",
				"leavesAt": "19:17",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "19:27",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Margina",
				"to": "Ilia",
				"leavesAt": "19:41",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 35500
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "20:22",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "20:51",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Orăştie",
				"leavesAt": "21:15",
				"arrivesAt": "21:37",
				"waitsAtSource": 720,
				"distance": 16500
			},
			{
				"from": "Orăştie",
				"to": "Şibot",
				"leavesAt": "21:42",
				"arrivesAt": "22:00",
				"waitsAtSource": 300,
				"distance": 12300
			},
			{
				"from": "Şibot",
				"to": "Vinţu de Jos",
				"leavesAt": "22:01",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "22:24",
				"arrivesAt": "22:36",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Teiuş",
				"leavesAt": "22:38",
				"arrivesAt": "23:13",
				"waitsAtSource": 120,
				"distance": 19100
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "23:14",
				"arrivesAt": "23:26",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Unirea hc.",
				"leavesAt": "23:27",
				"arrivesAt": "23:41",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "23:42",
				"arrivesAt": "23:49",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "23:50",
				"arrivesAt": "00:06",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "00:07",
				"arrivesAt": "01:13",
				"waitsAtSource": 60,
				"distance": 51500
			},
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "01:26",
				"arrivesAt": "02:24",
				"waitsAtSource": 780,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "02:25",
				"arrivesAt": "02:44",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "02:46",
				"arrivesAt": "03:19",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Salva",
				"leavesAt": "03:21",
				"arrivesAt": "03:43",
				"waitsAtSource": 120,
				"distance": 21600
			},
			{
				"from": "Salva",
				"to": "Năsăud",
				"leavesAt": "03:44",
				"arrivesAt": "03:51",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Năsăud",
				"to": "Ilva Mică",
				"leavesAt": "03:52",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 19800
			},
			{
				"from": "Ilva Mică",
				"to": "Lunca Ilvei",
				"leavesAt": "04:15",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 31600
			},
			{
				"from": "Lunca Ilvei",
				"to": "Floreni",
				"leavesAt": "04:52",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 31900
			},
			{
				"from": "Floreni",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "05:33",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "05:50",
				"arrivesAt": "05:53",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Iacobeni",
				"leavesAt": "05:54",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "06:10",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Pojorâta Hm.",
				"leavesAt": "06:22",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "06:44",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "06:54",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Vama",
				"leavesAt": "07:02",
				"arrivesAt": "07:16",
				"waitsAtSource": 180,
				"distance": 11800
			},
			{
				"from": "Vama",
				"to": "Frasin",
				"leavesAt": "07:17",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "07:29",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Suceava",
				"leavesAt": "07:38",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "08:33",
				"arrivesAt": "08:46",
				"waitsAtSource": 720,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "08:47",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "09:06",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Târgu Frumos",
				"leavesAt": "09:24",
				"arrivesAt": "09:51",
				"waitsAtSource": 120,
				"distance": 30800
			},
			{
				"from": "Târgu Frumos",
				"to": "Iaşi",
				"leavesAt": "09:52",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1385",
		"segments": [
			{
				"from": "Vadu Siretului",
				"to": "Vicşani",
				"leavesAt": "16:25",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Vicşani",
				"to": "Dorneşti",
				"leavesAt": "17:35",
				"arrivesAt": "17:49",
				"waitsAtSource": 2640,
				"distance": 8300
			},
			{
				"from": "Dorneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dărmăneşti",
				"leavesAt": "18:03",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "18:23",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20180612",
				"to": "20180615",
				"daysOfWeek": 383
			},
			{
				"from": "20180617",
				"to": "20180622",
				"daysOfWeek": 383
			},
			{
				"from": "20180624",
				"to": "20180627",
				"daysOfWeek": 383
			},
			{
				"from": "20180629",
				"to": "20180704",
				"daysOfWeek": 383
			},
			{
				"from": "20180706",
				"to": "20180709",
				"daysOfWeek": 383
			},
			{
				"from": "20180711",
				"to": "20180716",
				"daysOfWeek": 383
			},
			{
				"from": "20180718",
				"to": "20180721",
				"daysOfWeek": 383
			},
			{
				"from": "20180723",
				"to": "20180728",
				"daysOfWeek": 383
			},
			{
				"from": "20180730",
				"to": "20180802",
				"daysOfWeek": 383
			},
			{
				"from": "20180804",
				"to": "20180809",
				"daysOfWeek": 383
			},
			{
				"from": "20180811",
				"to": "20180814",
				"daysOfWeek": 383
			},
			{
				"from": "20180816",
				"to": "20180821",
				"daysOfWeek": 383
			},
			{
				"from": "20180823",
				"to": "20180826",
				"daysOfWeek": 383
			},
			{
				"from": "20180828",
				"to": "20180904",
				"daysOfWeek": 383
			},
			{
				"from": "20180906",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180911",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180610",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3082",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "07:52",
				"arrivesAt": "08:02",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "08:08",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "08:21",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "08:30",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "09:04",
				"arrivesAt": "09:12",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "09:13",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "09:22",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "09:29",
				"arrivesAt": "09:33",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "09:34",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "09:39",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "09:46",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "09:50",
				"arrivesAt": "09:54",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "09:55",
				"arrivesAt": "10:02",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "10:03",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 13100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2079",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Găneasa h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Găneasa h.",
				"to": "Arceşti Hm.",
				"leavesAt": "20:58",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Strejeşti",
				"leavesAt": "21:07",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 11600
			},
			{
				"from": "Strejeşti",
				"to": "Zlătărei Hm.",
				"leavesAt": "21:22",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Drăgăşani",
				"leavesAt": "21:29",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Drăgăşani",
				"to": "Călina h.",
				"leavesAt": "21:39",
				"arrivesAt": "21:46",
				"waitsAtSource": 120,
				"distance": 6400
			},
			{
				"from": "Călina h.",
				"to": "Zăvideni Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "21:53",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Orleşti hc.",
				"to": "Fişcălia Hm.",
				"leavesAt": "22:00",
				"arrivesAt": "22:03",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "22:04",
				"arrivesAt": "22:07",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Ioneşti Hm.",
				"leavesAt": "22:08",
				"arrivesAt": "22:12",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Slăviteşti hc.",
				"leavesAt": "22:13",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Băbeni",
				"leavesAt": "22:20",
				"arrivesAt": "22:29",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "22:30",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "22:34",
				"arrivesAt": "22:43",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "22:44",
				"arrivesAt": "22:47",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "22:48",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "22:57",
				"arrivesAt": "22:59",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "23:00",
				"arrivesAt": "23:04",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "23:05",
				"arrivesAt": "23:07",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9551",
		"segments": [
			{
				"from": "Orşova",
				"to": "Topleţ Hm.",
				"leavesAt": "04:00",
				"arrivesAt": "04:10",
				"waitsAtSource": 0,
				"distance": 10300
			},
			{
				"from": "Topleţ Hm.",
				"to": "Băile Herculane",
				"leavesAt": "04:11",
				"arrivesAt": "04:20",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Herculane",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "04:21",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Mehadia Hm.",
				"leavesAt": "04:25",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Mehadia Hm.",
				"to": "Iablaniţa",
				"leavesAt": "04:29",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Iablaniţa",
				"to": "Cruşovăţ",
				"leavesAt": "04:40",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cruşovăţ",
				"to": "Cornea h.",
				"leavesAt": "04:49",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cornea h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "04:56",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Luncaviţa h.",
				"to": "Poarta Hm.",
				"leavesAt": "05:06",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Poarta Hm.",
				"to": "Teregova Hm.",
				"leavesAt": "05:12",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Teregova Hm.",
				"to": "Armeniş",
				"leavesAt": "05:22",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Armeniş",
				"to": "Slatina Timiş",
				"leavesAt": "05:30",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Slatina Timiş",
				"to": "Vălişoara Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Petroşniţa h.",
				"to": "Valea Timişului Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Balta Sărată",
				"leavesAt": "05:53",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Balta Sărată",
				"to": "Caransebeş haltă h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Caransebeş",
				"leavesAt": "06:03",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4319",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "23:27",
				"arrivesAt": "23:33",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "23:34",
				"arrivesAt": "23:39",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "23:40",
				"arrivesAt": "23:51",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "23:52",
				"arrivesAt": "23:59",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20181129",
				"daysOfWeek": 319
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2239",
		"segments": [
			{
				"from": "Remetea Mică",
				"to": "Fibiş h.",
				"leavesAt": "18:01",
				"arrivesAt": "18:06",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Bencei h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bencei h.",
				"to": "Pişchia h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pişchia h.",
				"to": "Cerneteaz h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Cerneteaz h.",
				"to": "Giarmata Hm.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Giarmata Hm.",
				"to": "Viile Giarmata h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Timişoara Est",
				"leavesAt": "18:41",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "18:54",
				"arrivesAt": "19:00",
				"waitsAtSource": 180,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4306",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "16:35",
				"arrivesAt": "16:45",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "16:51",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:03",
				"waitsAtSource": 120,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:42",
				"waitsAtSource": 120,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "17:43",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Nima h.",
				"leavesAt": "17:53",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "18:05",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6811",
		"segments": [
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "16:39",
				"arrivesAt": "16:46",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharia Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Biharia Hm.",
				"to": "Tămăşeu h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tămăşeu h.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Diosig Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Diosig Hm.",
				"to": "Cadia h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cadia h.",
				"to": "Săcuieni Bihor",
				"leavesAt": "17:25",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Şilindru Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:47",
				"waitsAtSource": 420,
				"distance": 9400
			},
			{
				"from": "Şilindru Hm.",
				"to": "Simion h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:12",
				"waitsAtSource": 1140,
				"distance": 6300
			},
			{
				"from": "Simion h.",
				"to": "Valea lui Mihai",
				"leavesAt": "18:13",
				"arrivesAt": "18:19",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Valea lui Mihai",
				"to": "Nyirabrany",
				"leavesAt": "18:39",
				"arrivesAt": "18:54",
				"waitsAtSource": 1200,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1985",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Constanţa",
				"leavesAt": "09:00",
				"arrivesAt": "11:00",
				"waitsAtSource": 0,
				"distance": 225000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1653",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Brazi",
				"leavesAt": "21:30",
				"arrivesAt": "22:08",
				"waitsAtSource": 0,
				"distance": 51400
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "22:12",
				"arrivesAt": "22:26",
				"waitsAtSource": 240,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "22:28",
				"arrivesAt": "23:01",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "23:02",
				"arrivesAt": "23:37",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "23:39",
				"arrivesAt": "00:11",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "00:12",
				"arrivesAt": "00:50",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "00:52",
				"arrivesAt": "01:16",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "01:17",
				"arrivesAt": "01:43",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "01:45",
				"arrivesAt": "02:22",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "02:34",
				"arrivesAt": "03:03",
				"waitsAtSource": 720,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "03:05",
				"arrivesAt": "03:34",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "03:36",
				"arrivesAt": "03:56",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "03:57",
				"arrivesAt": "04:13",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "04:14",
				"arrivesAt": "04:26",
				"waitsAtSource": 60,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Berchişeşti Hm.",
				"leavesAt": "04:38",
				"arrivesAt": "05:12",
				"waitsAtSource": 720,
				"distance": 34400
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Gura Humorului Oraş",
				"leavesAt": "05:16",
				"arrivesAt": "05:31",
				"waitsAtSource": 240,
				"distance": 12400
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "05:32",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Vama",
				"leavesAt": "05:41",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vama",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "06:08",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Pojorâta Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Mestecăniş",
				"leavesAt": "06:26",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "06:48",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Vatra Dornei",
				"leavesAt": "06:58",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "07:16",
				"arrivesAt": "07:19",
				"waitsAtSource": 120,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2343",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "14:51",
				"arrivesAt": "14:59",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "15:12",
				"arrivesAt": "15:16",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "15:17",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "15:25",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "15:36",
				"arrivesAt": "15:48",
				"waitsAtSource": 120,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Blandiana Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:04",
				"waitsAtSource": 480,
				"distance": 5200
			},
			{
				"from": "Blandiana Hm.",
				"to": "Tărtăria h.",
				"leavesAt": "16:05",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tărtăria h.",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Şibot",
				"leavesAt": "16:19",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şibot",
				"to": "Geoagiu h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Geoagiu h.",
				"to": "Orăştie",
				"leavesAt": "16:37",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Orăştie",
				"to": "Pricaz h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pricaz h.",
				"to": "Turdaş Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Turdaş Hm.",
				"to": "Simeria Veche h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Simeria Veche h.",
				"to": "Simeria",
				"leavesAt": "17:05",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 300,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "17:23",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "17:33",
				"arrivesAt": "17:42",
				"waitsAtSource": 120,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "18:03",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "18:11",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "18:34",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "18:47",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "18:52",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "19:04",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 7400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9025",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:54",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "15:55",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "15:58",
				"arrivesAt": "16:01",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "16:03",
				"arrivesAt": "16:06",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "16:07",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "16:11",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "16:20",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "16:44",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "16:53",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Fusea Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Fusea Hm.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Cojocaru h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Cojocaru h.",
				"to": "Găeşti Sud h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Găeşti",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Găeşti",
				"to": "Pătroaia Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "17:48",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Călineşti Hm.",
				"leavesAt": "17:55",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Călineşti Hm.",
				"to": "Canton 97+770 h.",
				"leavesAt": "18:01",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Canton 97+770 h.",
				"to": "Goleşti",
				"leavesAt": "18:06",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Goleşti",
				"to": "Ram. Goleşti",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ram. Goleşti",
				"to": "Piteşti",
				"leavesAt": "18:15",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9595",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Săcălaz h.",
				"leavesAt": "23:12",
				"arrivesAt": "23:22",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Săcălaz h.",
				"to": "Beregsău hcv.",
				"leavesAt": "23:23",
				"arrivesAt": "23:30",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Beregsău hcv.",
				"to": "Cărpiniş",
				"leavesAt": "23:31",
				"arrivesAt": "23:38",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Cărpiniş",
				"to": "Clarii Vii h.",
				"leavesAt": "23:39",
				"arrivesAt": "23:46",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Clarii Vii h.",
				"to": "Jimbolia",
				"leavesAt": "23:47",
				"arrivesAt": "23:55",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2593",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "10:10",
				"arrivesAt": "10:14",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "10:15",
				"arrivesAt": "10:25",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "10:26",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "10:32",
				"arrivesAt": "10:39",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "10:40",
				"arrivesAt": "10:46",
				"waitsAtSource": 30,
				"distance": 2000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1856",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "22:48",
				"arrivesAt": "22:53",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "22:55",
				"arrivesAt": "23:07",
				"waitsAtSource": 120,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "23:08",
				"arrivesAt": "23:26",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "23:27",
				"arrivesAt": "23:43",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "23:44",
				"arrivesAt": "00:12",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "00:14",
				"arrivesAt": "00:43",
				"waitsAtSource": 120,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "00:45",
				"arrivesAt": "01:25",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "01:27",
				"arrivesAt": "01:54",
				"waitsAtSource": 120,
				"distance": 25700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9614",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "07:17",
				"arrivesAt": "07:27",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Giroc h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Giroc h.",
				"to": "Semenic Hm.",
				"leavesAt": "07:32",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Semenic Hm.",
				"to": "Urseni h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Urseni h.",
				"to": "Uliuc h.",
				"leavesAt": "07:41",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Uliuc h.",
				"to": "Sacoşu Mic",
				"leavesAt": "07:48",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Sacoşu Mic",
				"to": "Chevereş h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Chevereş h.",
				"to": "Bacova h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:07",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bacova h.",
				"to": "Buziaş",
				"leavesAt": "08:08",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Buziaş",
				"to": "Căpăt h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:30",
				"waitsAtSource": 600,
				"distance": 7300
			},
			{
				"from": "Căpăt h.",
				"to": "Sinia Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Sinia Hm.",
				"to": "Boldur h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Boldur h.",
				"to": "Lugoj",
				"leavesAt": "08:45",
				"arrivesAt": "08:59",
				"waitsAtSource": 30,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1983",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "07:30",
				"arrivesAt": "08:25",
				"waitsAtSource": 0,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "08:26",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Medgidia",
				"leavesAt": "08:49",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 44000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "09:21",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 34600
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "10:05",
				"arrivesAt": "10:28",
				"waitsAtSource": 1200,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "10:30",
				"arrivesAt": "10:37",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "10:39",
				"arrivesAt": "10:55",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "10:57",
				"arrivesAt": "11:01",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "11:03",
				"arrivesAt": "11:16",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "11:18",
				"arrivesAt": "11:28",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5710",
		"segments": [
			{
				"from": "Vatra Dornei",
				"to": "Argestru Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:11",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Argestru Hm.",
				"to": "Iacobeni",
				"leavesAt": "06:12",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "06:23",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Valea Putnei P.M.",
				"leavesAt": "06:34",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Pojorâta Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Sadova Hm.",
				"leavesAt": "06:57",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sadova Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "07:03",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2850",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "05:55",
				"arrivesAt": "06:02",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Drăguţeşti h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Vârţ h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vârţ h.",
				"to": "Rogojelu",
				"leavesAt": "06:17",
				"arrivesAt": "06:21",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "06:26",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Rovinari Hm.",
				"to": "Rovinari Sud h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Bâlteni h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bâlteni h.",
				"to": "Peşteana Jiu h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Plopşoru",
				"leavesAt": "06:49",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Plopşoru",
				"to": "Sărdăneşti h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Gârbovu h.",
				"leavesAt": "07:04",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Gârbovu h.",
				"to": "Turceni",
				"leavesAt": "07:10",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turceni",
				"to": "Termo Turceni h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:47",
				"waitsAtSource": 1620,
				"distance": 900
			},
			{
				"from": "Termo Turceni h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:53",
				"waitsAtSource": 120,
				"distance": 3000
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "07:54",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Filiaşi",
				"leavesAt": "07:58",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 12400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4527",
		"segments": [
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "01:15",
				"arrivesAt": "01:42",
				"waitsAtSource": 0,
				"distance": 28500
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 382
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5109",
		"segments": [
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "11:05",
				"arrivesAt": "11:16",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "11:17",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "11:28",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "11:52",
				"arrivesAt": "11:59",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "12:00",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "12:09",
				"arrivesAt": "12:17",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "12:18",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "12:30",
				"arrivesAt": "12:45",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "12:46",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9370",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "19:10",
				"arrivesAt": "19:12",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:22",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "19:23",
				"arrivesAt": "19:34",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "19:35",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "19:56",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1895",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "15:30",
				"arrivesAt": "16:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "16:32",
				"arrivesAt": "16:51",
				"waitsAtSource": 120,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "16:52",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "17:16",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Piteşti",
				"to": "Costeşti",
				"leavesAt": "17:40",
				"arrivesAt": "18:05",
				"waitsAtSource": 720,
				"distance": 21800
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Slatina",
				"leavesAt": "18:19",
				"arrivesAt": "19:06",
				"waitsAtSource": 240,
				"distance": 51300
			},
			{
				"from": "Slatina",
				"to": "Piatra Olt",
				"leavesAt": "19:08",
				"arrivesAt": "19:26",
				"waitsAtSource": 120,
				"distance": 17000
			},
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:32",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Balş",
				"leavesAt": "19:33",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Balş",
				"to": "Craiova",
				"leavesAt": "19:39",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 31200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9055",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "13:05",
				"arrivesAt": "13:10",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Troian h.",
				"leavesAt": "13:22",
				"arrivesAt": "13:38",
				"waitsAtSource": 720,
				"distance": 13000
			},
			{
				"from": "Troian h.",
				"to": "Salcia Teleorman Hm.",
				"leavesAt": "13:39",
				"arrivesAt": "13:52",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Salcia Teleorman Hm.",
				"to": "Km. 231+600 h.",
				"leavesAt": "13:53",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 14500
			},
			{
				"from": "Km. 231+600 h.",
				"to": "Turnu Măgurele",
				"leavesAt": "14:11",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 320
			},
			{
				"from": "20171210",
				"to": "20180407",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9592",
		"segments": [
			{
				"from": "Jimbolia",
				"to": "Clarii Vii h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:46",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Clarii Vii h.",
				"to": "Cărpiniş",
				"leavesAt": "14:47",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Cărpiniş",
				"to": "Beregsău hcv.",
				"leavesAt": "14:56",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Beregsău hcv.",
				"to": "Săcălaz h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săcălaz h.",
				"to": "Timişoara Nord",
				"leavesAt": "15:12",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2562",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:32",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 900,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "06:08",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Hăşag h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:28",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "06:29",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 480,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "06:56",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "07:04",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "07:14",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5003",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "09:20",
				"arrivesAt": "09:30",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "09:31",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Periş",
				"leavesAt": "09:43",
				"arrivesAt": "09:54",
				"waitsAtSource": 360,
				"distance": 13300
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "09:55",
				"arrivesAt": "09:59",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "10:00",
				"arrivesAt": "10:04",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "10:11",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "10:20",
				"arrivesAt": "10:35",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "10:38",
				"arrivesAt": "10:44",
				"waitsAtSource": 180,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "10:45",
				"arrivesAt": "10:54",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "10:55",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "11:00",
				"arrivesAt": "11:04",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "11:05",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "11:11",
				"arrivesAt": "11:16",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "11:17",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "11:26",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "11:37",
				"arrivesAt": "11:45",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "11:46",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "11:52",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "11:58",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4072",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:10",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:15",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "05:16",
				"arrivesAt": "05:22",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "05:23",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Zalău Nord",
				"to": "Guruslău h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:55",
				"waitsAtSource": 360,
				"distance": 6700
			},
			{
				"from": "Guruslău h.",
				"to": "Borla Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Borla Hm.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Sărmăşag",
				"leavesAt": "06:12",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 799
			},
			{
				"from": "20180113",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2568",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Daneş Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:38",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Daneş Hm.",
				"to": "Luna h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Luna h.",
				"to": "Dumbrăveni",
				"leavesAt": "15:47",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dumbrăveni",
				"to": "Aţel Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Aţel Hm.",
				"to": "Bratei h.",
				"leavesAt": "16:05",
				"arrivesAt": "16:14",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Bratei h.",
				"to": "Mediaş",
				"leavesAt": "16:15",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:32",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "16:33",
				"arrivesAt": "16:40",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 480,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "16:54",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "17:01",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Hăşag h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "17:51",
				"arrivesAt": "18:00",
				"waitsAtSource": 120,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "18:01",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5524",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Sfântu Mina h.",
				"leavesAt": "10:41",
				"arrivesAt": "10:46",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Plăieşu h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:50",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "10:51",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "10:58",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "11:04",
				"arrivesAt": "11:12",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "11:13",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "11:31",
				"arrivesAt": "11:45",
				"waitsAtSource": 480,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "11:46",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "11:54",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "12:00",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "12:09",
				"arrivesAt": "12:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "12:20",
				"arrivesAt": "12:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "12:27",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "12:34",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "12:42",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5632",
		"segments": [
			{
				"from": "Dorneşti",
				"to": "Ţibeni h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:15",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Ţibeni h.",
				"to": "Milişăuţi Hm.",
				"leavesAt": "10:16",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dărmăneşti",
				"leavesAt": "10:25",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "10:37",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "10:49",
				"arrivesAt": "10:54",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1663",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Brazi",
				"leavesAt": "11:50",
				"arrivesAt": "12:25",
				"waitsAtSource": 0,
				"distance": 51400
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "12:29",
				"arrivesAt": "12:43",
				"waitsAtSource": 240,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "12:45",
				"arrivesAt": "13:18",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "13:19",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "13:56",
				"arrivesAt": "14:27",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "14:28",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Tecuci",
				"leavesAt": "15:08",
				"arrivesAt": "15:51",
				"waitsAtSource": 120,
				"distance": 36500
			},
			{
				"from": "Tecuci",
				"to": "Nichişeni",
				"leavesAt": "16:02",
				"arrivesAt": "16:25",
				"waitsAtSource": 660,
				"distance": 24400
			},
			{
				"from": "Nichişeni",
				"to": "Bârlad",
				"leavesAt": "16:29",
				"arrivesAt": "16:51",
				"waitsAtSource": 240,
				"distance": 25900
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "16:53",
				"arrivesAt": "17:22",
				"waitsAtSource": 120,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "17:23",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "17:44",
				"arrivesAt": "18:02",
				"waitsAtSource": 420,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "18:30",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "18:47",
				"arrivesAt": "18:54",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2201",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "06:21",
				"arrivesAt": "06:31",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "06:32",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9695",
		"segments": [
			{
				"from": "Oraviţa",
				"to": "Brădişoru de Jos h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:28",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Brădişoru de Jos h.",
				"to": "Dobrei hcv.",
				"leavesAt": "11:29",
				"arrivesAt": "11:52",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Dobrei hcv.",
				"to": "Lişava Hm.",
				"leavesAt": "11:53",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Lişava Hm.",
				"to": "Ciudanoviţa Pam.",
				"leavesAt": "12:07",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Ciudanoviţa Pam.",
				"to": "Gârlişte Hm.",
				"leavesAt": "12:12",
				"arrivesAt": "12:37",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Gârlişte Hm.",
				"to": "Anina",
				"leavesAt": "12:38",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3091",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:42",
				"waitsAtSource": 0,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Mirăslău h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mirăslău h.",
				"to": "Decea h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:52",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Decea h.",
				"to": "Unirea Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Unirea Hm.",
				"to": "Unirea hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "20:03",
				"arrivesAt": "20:10",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Grindeni h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Grindeni h.",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Câmpia Turzii",
				"leavesAt": "20:22",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cânepişti h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Cânepişti h.",
				"to": "Ploscoş h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:44",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ploscoş h.",
				"to": "Valea Florilor Hm.",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Boju",
				"leavesAt": "20:52",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Boju",
				"to": "Tunel Hm.",
				"leavesAt": "21:05",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Tunel Hm.",
				"to": "Cojocna Hm.",
				"leavesAt": "21:13",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cojocna Hm.",
				"to": "Apahida",
				"leavesAt": "21:21",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca Est",
				"leavesAt": "21:27",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "21:36",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "21:42",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1725",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:24",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "17:25",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "17:32",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Câineni",
				"leavesAt": "17:59",
				"arrivesAt": "18:23",
				"waitsAtSource": 540,
				"distance": 15200
			},
			{
				"from": "Câineni",
				"to": "Păuşa h.",
				"leavesAt": "18:33",
				"arrivesAt": "19:14",
				"waitsAtSource": 600,
				"distance": 32600
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "19:15",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "19:20",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 16200
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Băbeni",
				"leavesAt": "19:40",
				"arrivesAt": "19:59",
				"waitsAtSource": 180,
				"distance": 19600
			},
			{
				"from": "Băbeni",
				"to": "Drăgăşani",
				"leavesAt": "20:00",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Drăgăşani",
				"to": "Piatra Olt",
				"leavesAt": "20:23",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 33800
			},
			{
				"from": "Piatra Olt",
				"to": "Balş",
				"leavesAt": "20:50",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Balş",
				"to": "Craiova",
				"leavesAt": "21:02",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 31200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3728",
		"segments": [
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:36",
				"waitsAtSource": 0,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "04:37",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "04:46",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "04:53",
				"arrivesAt": "05:04",
				"waitsAtSource": 120,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Arad",
				"leavesAt": "05:10",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 9600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6311",
		"segments": [
			{
				"from": "Tecuci",
				"to": "Tecuci Nord hc.(600)",
				"leavesAt": "04:52",
				"arrivesAt": "04:55",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Tecuci Nord hc.(600)",
				"to": "Frunzeasca Hm.",
				"leavesAt": "04:56",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Frunzeasca Hm.",
				"to": "Rateş Munteni h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Rateş Munteni h.",
				"to": "Berheci Hm.",
				"leavesAt": "05:08",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Berheci Hm.",
				"to": "Nichişeni",
				"leavesAt": "05:15",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Nichişeni",
				"to": "Ghidigeni Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ghidigeni Hm.",
				"to": "Tutova",
				"leavesAt": "05:32",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tutova",
				"to": "Dragalina h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Dragalina h.",
				"to": "Bârlad",
				"leavesAt": "05:53",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bârlad",
				"to": "Zorleni",
				"leavesAt": "06:06",
				"arrivesAt": "06:14",
				"waitsAtSource": 180,
				"distance": 7300
			},
			{
				"from": "Zorleni",
				"to": "Banca Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Banca Hm.",
				"to": "Dodeşti hc.",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dodeşti hc.",
				"to": "Roşieşti hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Roşieşti hc.",
				"to": "Crasna",
				"leavesAt": "06:37",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Crasna",
				"to": "Bulboaca h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Bulboaca h.",
				"to": "Munteni Hm.",
				"leavesAt": "06:55",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Munteni Hm.",
				"to": "Vaslui",
				"leavesAt": "07:02",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:24",
				"waitsAtSource": 360,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "07:25",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "07:31",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "07:36",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "08:04",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "08:37",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "08:44",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5630",
		"segments": [
			{
				"from": "Dorneşti",
				"to": "Ţibeni h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:55",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Ţibeni h.",
				"to": "Milişăuţi Hm.",
				"leavesAt": "06:56",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dărmăneşti",
				"leavesAt": "07:05",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "07:17",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "07:29",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1793",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "19:30",
				"arrivesAt": "20:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "20:32",
				"arrivesAt": "20:51",
				"waitsAtSource": 120,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "20:52",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "21:16",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6315",
		"segments": [
			{
				"from": "Tecuci",
				"to": "Tecuci Nord hc.(600)",
				"leavesAt": "18:53",
				"arrivesAt": "18:56",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Tecuci Nord hc.(600)",
				"to": "Frunzeasca Hm.",
				"leavesAt": "18:57",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Frunzeasca Hm.",
				"to": "Rateş Munteni h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:11",
				"waitsAtSource": 240,
				"distance": 3200
			},
			{
				"from": "Rateş Munteni h.",
				"to": "Berheci Hm.",
				"leavesAt": "19:12",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Berheci Hm.",
				"to": "Nichişeni",
				"leavesAt": "19:19",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Nichişeni",
				"to": "Ghidigeni Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ghidigeni Hm.",
				"to": "Tutova",
				"leavesAt": "19:36",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tutova",
				"to": "Dragalina h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Dragalina h.",
				"to": "Bârlad",
				"leavesAt": "19:57",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bârlad",
				"to": "Zorleni",
				"leavesAt": "20:08",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Zorleni",
				"to": "Banca Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:25",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Banca Hm.",
				"to": "Dodeşti hc.",
				"leavesAt": "20:26",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dodeşti hc.",
				"to": "Roşieşti hc.",
				"leavesAt": "20:32",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Roşieşti hc.",
				"to": "Crasna",
				"leavesAt": "20:39",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Crasna",
				"to": "Bulboaca h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Bulboaca h.",
				"to": "Munteni Hm.",
				"leavesAt": "20:57",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Munteni Hm.",
				"to": "Vaslui",
				"leavesAt": "21:04",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "21:11",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "21:22",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "21:33",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "21:41",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "21:54",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "22:01",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "22:11",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "22:20",
				"arrivesAt": "22:26",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "22:27",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "22:34",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "22:41",
				"arrivesAt": "22:48",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9577",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Tibiscu h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:23",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Tibiscu h.",
				"to": "Zăgujeni Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:27",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Căvăran",
				"leavesAt": "19:28",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Căvăran",
				"to": "Sacu h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Sacu h.",
				"to": "Jena Hm.",
				"leavesAt": "19:43",
				"arrivesAt": "19:46",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Jena Hm.",
				"to": "Găvojdia",
				"leavesAt": "19:47",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Găvojdia",
				"to": "Tapia Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tapia Hm.",
				"to": "Lugoj",
				"leavesAt": "20:03",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lugoj",
				"to": "Jabăr Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 360,
				"distance": 7600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "20:28",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "20:37",
				"arrivesAt": "20:43",
				"waitsAtSource": 300,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:52",
				"waitsAtSource": 360,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "20:53",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "21:04",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "21:13",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "21:28",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "401",
		"segments": [
			{
				"from": "Ungheni",
				"to": "Ungheni Prut Fr.",
				"leavesAt": "20:45",
				"arrivesAt": "20:47",
				"waitsAtSource": 0,
				"distance": 800
			},
			{
				"from": "Ungheni Prut Fr.",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "20:48",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Ungheni Prut Hm.",
				"to": "Nicolina",
				"leavesAt": "21:44",
				"arrivesAt": "22:12",
				"waitsAtSource": 3240,
				"distance": 19000
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "22:14",
				"arrivesAt": "22:21",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Iaşi",
				"to": "Paşcani Triaj",
				"leavesAt": "22:43",
				"arrivesAt": "23:51",
				"waitsAtSource": 1320,
				"distance": 76200
			},
			{
				"from": "Paşcani Triaj",
				"to": "Roman",
				"leavesAt": "23:53",
				"arrivesAt": "00:24",
				"waitsAtSource": 120,
				"distance": 37900
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "00:25",
				"arrivesAt": "01:02",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "01:04",
				"arrivesAt": "01:50",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "01:51",
				"arrivesAt": "02:18",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "02:19",
				"arrivesAt": "02:44",
				"waitsAtSource": 60,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "02:46",
				"arrivesAt": "03:23",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "03:24",
				"arrivesAt": "03:55",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Ploieşti Sud",
				"leavesAt": "04:03",
				"arrivesAt": "05:09",
				"waitsAtSource": 480,
				"distance": 68600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "05:11",
				"arrivesAt": "06:07",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8154",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Perieţi h.",
				"leavesAt": "19:10",
				"arrivesAt": "19:18",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Perieţi h.",
				"to": "Fundata h.",
				"leavesAt": "19:19",
				"arrivesAt": "19:24",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Fundata h.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Ciochina hc.",
				"leavesAt": "19:32",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciochina hc.",
				"to": "Căzăneşti",
				"leavesAt": "19:40",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Căzăneşti",
				"to": "Munteni Buzău h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "20:01",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Km. 74+600 h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Malu h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Malu h.",
				"to": "Broşteni Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Alexeni h.",
				"leavesAt": "20:24",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Alexeni h.",
				"to": "Urziceni",
				"leavesAt": "20:30",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9410",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "17:45",
				"arrivesAt": "17:56",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "17:57",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "18:31",
				"arrivesAt": "18:43",
				"waitsAtSource": 540,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 351
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9066",
		"segments": [
			{
				"from": "Corabia",
				"to": "Vişina Veche hc.",
				"leavesAt": "19:30",
				"arrivesAt": "19:44",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Vişina Veche hc.",
				"to": "Vişina h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vişina h.",
				"to": "Studina hc.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Studina hc.",
				"to": "Studiniţa h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Studiniţa h.",
				"to": "Frăsinet hc.",
				"leavesAt": "20:03",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Frăsinet hc.",
				"to": "Deveselu h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Deveselu h.",
				"to": "Grupa Tehnică Caracal Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Grupa Tehnică Caracal Hm.",
				"to": "Canton 239+700 h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Canton 239+700 h.",
				"to": "Caracal",
				"leavesAt": "20:27",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 1400
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3546",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "12:00",
				"arrivesAt": "12:07",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "12:08",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Săcuienii Noi h.",
				"leavesAt": "12:16",
				"arrivesAt": "12:22",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Săcuienii Noi h.",
				"to": "Sântămaria h.",
				"leavesAt": "12:23",
				"arrivesAt": "12:28",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Sântămaria h.",
				"to": "Cristur Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cristur Hm.",
				"to": "Beteşti h.",
				"leavesAt": "12:40",
				"arrivesAt": "12:43",
				"waitsAtSource": 420,
				"distance": 1300
			},
			{
				"from": "Beteşti h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "12:53",
				"arrivesAt": "12:58",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Lutiţa h.",
				"leavesAt": "12:59",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Lutiţa h.",
				"to": "Dobeni h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:10",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Feliceni h.",
				"leavesAt": "13:11",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Feliceni h.",
				"to": "Odorhei Sud hc.",
				"leavesAt": "13:16",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Odorhei",
				"leavesAt": "13:26",
				"arrivesAt": "13:30",
				"waitsAtSource": 120,
				"distance": 1200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8651",
		"segments": [
			{
				"from": "Medgidia",
				"to": "Nicolae Bălcescu",
				"leavesAt": "05:56",
				"arrivesAt": "06:14",
				"waitsAtSource": 0,
				"distance": 19100
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "06:15",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "06:22",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Cogealac",
				"leavesAt": "06:32",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cogealac",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 17400
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Baia Dobrogea",
				"leavesAt": "07:12",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Baia Dobrogea",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "07:24",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Babadag",
				"leavesAt": "07:31",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Babadag",
				"to": "Zebil h.",
				"leavesAt": "07:49",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Zebil h.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Cataloi Hm.",
				"leavesAt": "08:21",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Cataloi Hm.",
				"to": "Tulcea Mărfuri",
				"leavesAt": "08:36",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Tulcea Oraş",
				"leavesAt": "08:50",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2048",
		"segments": [
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "18:45",
				"arrivesAt": "18:53",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "18:54",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "19:15",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "19:21",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "19:34",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Bârzava",
				"leavesAt": "19:58",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "20:27",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "20:39",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:25",
				"waitsAtSource": 1800,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "21:26",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "21:38",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "21:45",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "22:13",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "22:20",
				"arrivesAt": "22:25",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "22:26",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "22:33",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "22:38",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "22:42",
				"arrivesAt": "22:46",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "22:47",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "22:58",
				"arrivesAt": "23:05",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "23:06",
				"arrivesAt": "23:12",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9102",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "03:47",
				"arrivesAt": "03:54",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "03:55",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "04:01",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "04:06",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:19",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "04:25",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:38",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "04:39",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "04:43",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "05:05",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "05:21",
				"arrivesAt": "05:26",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "05:27",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8800",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "05:00",
				"arrivesAt": "05:07",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "05:08",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "05:14",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "05:28",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:48",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "05:49",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "05:59",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "06:17",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "06:25",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4105",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Viişoara h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Viişoara h.",
				"to": "Sărata h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "15:48",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "16:05",
				"arrivesAt": "16:08",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "16:09",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "16:14",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "16:39",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "16:48",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "16:59",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Buneşti h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:19",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Buneşti h.",
				"to": "Gherla",
				"leavesAt": "17:20",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "17:56",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "18:09",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "18:19",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "18:33",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4110",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "14:30",
				"arrivesAt": "14:40",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "14:41",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "14:46",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "14:58",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "15:12",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Buneşti h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Buneşti h.",
				"to": "Nima h.",
				"leavesAt": "15:56",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "16:00",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "16:12",
				"arrivesAt": "16:19",
				"waitsAtSource": 180,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Reteag Hm.",
				"leavesAt": "16:20",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Reteag Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "16:38",
				"arrivesAt": "16:42",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "16:43",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 180,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:30",
				"waitsAtSource": 360,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Coşbuc Hm.",
				"leavesAt": "17:49",
				"arrivesAt": "18:03",
				"waitsAtSource": 840,
				"distance": 9500
			},
			{
				"from": "Coşbuc Hm.",
				"to": "Bichigiu h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Bichigiu h.",
				"to": "Telciu Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Telciu Hm.",
				"to": "Fiezel h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fiezel h.",
				"to": "Fiad Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Fiad Hm.",
				"to": "Romuli h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:53",
				"waitsAtSource": 720,
				"distance": 6700
			},
			{
				"from": "Romuli h.",
				"to": "Dealu Ştefăniţei",
				"leavesAt": "18:54",
				"arrivesAt": "19:03",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dealu Ştefăniţei",
				"to": "Săcel Hm.",
				"leavesAt": "19:04",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Săcel Hm.",
				"to": "Iza P.M.",
				"leavesAt": "19:16",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Iza P.M.",
				"to": "Vişeu de Jos",
				"leavesAt": "19:27",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Vişeu de Jos",
				"to": "Bocicoel h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:47",
				"waitsAtSource": 240,
				"distance": 2700
			},
			{
				"from": "Bocicoel h.",
				"to": "Leordina h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Leordina h.",
				"to": "Leordina",
				"leavesAt": "19:57",
				"arrivesAt": "20:03",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Leordina",
				"to": "Petrova hc.",
				"leavesAt": "20:04",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Petrova hc.",
				"to": "Vişeu Bistra h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Valea Vişeului",
				"leavesAt": "20:24",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Valea Vişeului",
				"to": "Lunca la Tisa h.",
				"leavesAt": "20:53",
				"arrivesAt": "21:09",
				"waitsAtSource": 900,
				"distance": 10700
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Crăciuneşti h.",
				"leavesAt": "21:17",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Tisa h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Tisa h.",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:35",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Sighetu Marmaţiei",
				"leavesAt": "21:36",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1729",
		"segments": [
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "07:15",
				"arrivesAt": "07:55",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "08:00",
				"arrivesAt": "08:25",
				"waitsAtSource": 300,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Gilort Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 12400
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "08:50",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "09:00",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cărbuneşti",
				"to": "Târgu Jiu",
				"leavesAt": "09:21",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 23800
			},
			{
				"from": "Târgu Jiu",
				"to": "Valea Sadului Hm.",
				"leavesAt": "09:52",
				"arrivesAt": "10:12",
				"waitsAtSource": 180,
				"distance": 19600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Lainici Hm.",
				"leavesAt": "10:17",
				"arrivesAt": "10:34",
				"waitsAtSource": 300,
				"distance": 11300
			},
			{
				"from": "Lainici Hm.",
				"to": "Petroşani",
				"leavesAt": "10:35",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 20400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 496
			},
			{
				"from": "18991230",
				"to": "20180806",
				"daysOfWeek": 496
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4332",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Carei",
				"leavesAt": "03:30",
				"arrivesAt": "03:59",
				"waitsAtSource": 0,
				"distance": 36000
			},
			{
				"from": "Carei",
				"to": "Sanislău Hm.",
				"leavesAt": "04:00",
				"arrivesAt": "04:10",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Sanislău Hm.",
				"to": "Resighea h.",
				"leavesAt": "04:11",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Resighea h.",
				"to": "Curtuiuşeni h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Valea lui Mihai",
				"leavesAt": "04:24",
				"arrivesAt": "04:31",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Valea lui Mihai",
				"to": "Simion h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Simion h.",
				"to": "Şilindru Hm.",
				"leavesAt": "04:40",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Şilindru Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "04:47",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Cadia h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cadia h.",
				"to": "Diosig Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Diosig Hm.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Tămăşeu h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:26",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tămăşeu h.",
				"to": "Biharia Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:34",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Biharia Hm.",
				"to": "Episcopia Bihor",
				"leavesAt": "05:35",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "05:46",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9342",
		"segments": [
			{
				"from": "Giurgiu",
				"to": "Giurgiu Nord",
				"leavesAt": "07:31",
				"arrivesAt": "07:36",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Giurgiu Nord",
				"to": "Cetatea h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cetatea h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Onceşti h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Onceşti h.",
				"to": "Stăneşti Hm.",
				"leavesAt": "07:49",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Chiriacu Hm.",
				"leavesAt": "07:55",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Toporu",
				"leavesAt": "08:03",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Toporu",
				"to": "Răsuceni h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Răsuceni h.",
				"to": "Vlaşca Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "08:25",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Târnavele Hm.",
				"to": "Răduleşti Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Videle",
				"leavesAt": "08:46",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9062",
		"segments": [
			{
				"from": "Corabia",
				"to": "Vişina Veche hc.",
				"leavesAt": "05:55",
				"arrivesAt": "06:10",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Vişina Veche hc.",
				"to": "Vişina h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vişina h.",
				"to": "Studina hc.",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Studina hc.",
				"to": "Studiniţa h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Studiniţa h.",
				"to": "Frăsinet hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Frăsinet hc.",
				"to": "Deveselu h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Deveselu h.",
				"to": "Grupa Tehnică Caracal Hm.",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Grupa Tehnică Caracal Hm.",
				"to": "Canton 239+700 h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Canton 239+700 h.",
				"to": "Caracal",
				"leavesAt": "06:54",
				"arrivesAt": "06:57",
				"waitsAtSource": 30,
				"distance": 1400
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20181130",
				"daysOfWeek": 319
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9481",
		"segments": [
			{
				"from": "Slatina",
				"to": "Slătioara Hm.",
				"leavesAt": "13:04",
				"arrivesAt": "13:17",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "13:21",
				"arrivesAt": "13:25",
				"waitsAtSource": 240,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "13:26",
				"arrivesAt": "13:33",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4041",
		"segments": [
			{
				"from": "Jibou",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "03:55",
				"arrivesAt": "04:05",
				"waitsAtSource": 0,
				"distance": 9300
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Inău h.",
				"leavesAt": "04:06",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Inău h.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:13",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Benesat Hm.",
				"leavesAt": "04:14",
				"arrivesAt": "04:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Benesat Hm.",
				"to": "Ţicău h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ţicău h.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "04:25",
				"arrivesAt": "04:28",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "04:29",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Fersig h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Fersig h.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "04:43",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "04:49",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1922",
		"segments": [
			{
				"from": "Arad",
				"to": "Radna",
				"leavesAt": "18:40",
				"arrivesAt": "19:20",
				"waitsAtSource": 0,
				"distance": 34500
			},
			{
				"from": "Radna",
				"to": "Săvârşin",
				"leavesAt": "19:21",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Săvârşin",
				"to": "Ilia",
				"leavesAt": "20:19",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "21:08",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "21:36",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Călan Hm.",
				"leavesAt": "21:50",
				"arrivesAt": "22:06",
				"waitsAtSource": 120,
				"distance": 14600
			},
			{
				"from": "Călan Hm.",
				"to": "Subcetate",
				"leavesAt": "22:07",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Subcetate",
				"to": "Petroşani",
				"leavesAt": "22:23",
				"arrivesAt": "23:32",
				"waitsAtSource": 60,
				"distance": 49800
			},
			{
				"from": "Petroşani",
				"to": "Valea Sadului Hm.",
				"leavesAt": "23:37",
				"arrivesAt": "00:22",
				"waitsAtSource": 300,
				"distance": 31700
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "00:23",
				"arrivesAt": "00:44",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Târgu Jiu",
				"to": "Cărbuneşti",
				"leavesAt": "00:46",
				"arrivesAt": "01:14",
				"waitsAtSource": 120,
				"distance": 23800
			},
			{
				"from": "Cărbuneşti",
				"to": "Filiaşi",
				"leavesAt": "01:15",
				"arrivesAt": "01:59",
				"waitsAtSource": 60,
				"distance": 46500
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "02:00",
				"arrivesAt": "02:25",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "02:35",
				"arrivesAt": "03:14",
				"waitsAtSource": 600,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "03:16",
				"arrivesAt": "03:31",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "03:32",
				"arrivesAt": "04:03",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "04:05",
				"arrivesAt": "04:54",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Chiajna",
				"leavesAt": "04:56",
				"arrivesAt": "05:38",
				"waitsAtSource": 120,
				"distance": 41900
			},
			{
				"from": "Chiajna",
				"to": "Bucureşti Nord",
				"leavesAt": "05:42",
				"arrivesAt": "05:55",
				"waitsAtSource": 240,
				"distance": 9000
			},
			{
				"from": "Bucureşti Nord",
				"to": "Lehliu",
				"leavesAt": "06:20",
				"arrivesAt": "07:01",
				"waitsAtSource": 1500,
				"distance": 69600
			},
			{
				"from": "Lehliu",
				"to": "Ciulniţa",
				"leavesAt": "07:02",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "07:23",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "07:47",
				"arrivesAt": "08:07",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "08:08",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "08:26",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "09:30",
				"arrivesAt": "09:53",
				"waitsAtSource": 1800,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "10:01",
				"arrivesAt": "10:08",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "10:10",
				"arrivesAt": "10:26",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "10:28",
				"arrivesAt": "10:32",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "10:34",
				"arrivesAt": "10:47",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "10:49",
				"arrivesAt": "10:59",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180426",
				"to": "20180430",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180528",
				"daysOfWeek": 383
			},
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4333",
		"segments": [
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "07:31",
				"arrivesAt": "07:39",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharia Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Biharia Hm.",
				"to": "Tămăşeu h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tămăşeu h.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Diosig Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Diosig Hm.",
				"to": "Cadia h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cadia h.",
				"to": "Săcuieni Bihor",
				"leavesAt": "08:21",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Şilindru Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Şilindru Hm.",
				"to": "Simion h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Simion h.",
				"to": "Valea lui Mihai",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8376",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "20:08",
				"arrivesAt": "20:14",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:20",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "20:30",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:54",
				"waitsAtSource": 900,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "20:55",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "21:02",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "21:15",
				"arrivesAt": "21:23",
				"waitsAtSource": 480,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "21:24",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180524",
				"to": "20180524",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4312",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Buşag Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "08:03",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Buşag Hm.",
				"to": "Cicârlău h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cicârlău h.",
				"to": "Ilba h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ilba h.",
				"to": "Săbişa h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbişa h.",
				"to": "Seini",
				"leavesAt": "08:24",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Seini",
				"to": "Apa Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:53",
				"waitsAtSource": 600,
				"distance": 8500
			},
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "09:05",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "09:15",
				"arrivesAt": "09:21",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "09:22",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2711",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Dep Petroşani h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:21",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "15:22",
				"arrivesAt": "15:24",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Peştera Bolii h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Băniţa",
				"leavesAt": "15:30",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Băniţa",
				"to": "Merişor Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Merişor Hm.",
				"to": "Crivadia Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Crivadia Hm.",
				"to": "Baru Mare h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Baru Mare h.",
				"to": "Baru Mare",
				"leavesAt": "16:08",
				"arrivesAt": "16:14",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Baru Mare",
				"to": "Livadia h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Livadia h.",
				"to": "Ponor h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ponor h.",
				"to": "Pui",
				"leavesAt": "16:22",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Pui",
				"to": "Ruşor h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Ruşor h.",
				"to": "Băeşti Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Ciopea h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ciopea h.",
				"to": "Subcetate",
				"leavesAt": "16:43",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Subcetate",
				"to": "Covragiu h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Covragiu h.",
				"to": "Plopi h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Plopi h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Măceu h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măceu h.",
				"to": "Ruşi h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ruşi h.",
				"to": "Călan Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Călan Hm.",
				"to": "Călan Băi",
				"leavesAt": "17:16",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Batiz h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Batiz h.",
				"to": "Băcia Hm.",
				"leavesAt": "17:24",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Băcia Hm.",
				"to": "Băcia h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia h.",
				"to": "Simeria Triaj",
				"leavesAt": "17:30",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Simeria Triaj",
				"to": "Simeria",
				"leavesAt": "17:34",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180124",
				"to": "20180124",
				"daysOfWeek": 383
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180331",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180501",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180528",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20180114",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1937",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "10:15",
				"arrivesAt": "10:39",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "10:40",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "10:58",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "11:19",
				"arrivesAt": "11:42",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "11:43",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 108900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "13:00",
				"arrivesAt": "13:38",
				"waitsAtSource": 1260,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Sinaia",
				"leavesAt": "13:40",
				"arrivesAt": "14:23",
				"waitsAtSource": 120,
				"distance": 62100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "14:25",
				"arrivesAt": "14:33",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Predeal",
				"leavesAt": "14:34",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 11400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "14:49",
				"arrivesAt": "15:27",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2202",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "05:42",
				"arrivesAt": "05:50",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "05:51",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "74",
		"segments": [
			{
				"from": "Braşov",
				"to": "Codlea Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:48",
				"waitsAtSource": 0,
				"distance": 13800
			},
			{
				"from": "Codlea Hm.",
				"to": "Brădet Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 25100
			},
			{
				"from": "Brădet Hm.",
				"to": "Făgăraş",
				"leavesAt": "06:22",
				"arrivesAt": "06:50",
				"waitsAtSource": 300,
				"distance": 26100
			},
			{
				"from": "Făgăraş",
				"to": "Sibiu",
				"leavesAt": "06:52",
				"arrivesAt": "08:10",
				"waitsAtSource": 120,
				"distance": 83900
			},
			{
				"from": "Sibiu",
				"to": "Sebeş Alba",
				"leavesAt": "08:15",
				"arrivesAt": "09:47",
				"waitsAtSource": 300,
				"distance": 73700
			},
			{
				"from": "Sebeş Alba",
				"to": "Vinţu de Jos",
				"leavesAt": "09:48",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vinţu de Jos",
				"to": "Simeria",
				"leavesAt": "09:59",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "11:12",
				"arrivesAt": "11:22",
				"waitsAtSource": 780,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "11:23",
				"arrivesAt": "11:50",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Săvârşin",
				"leavesAt": "11:51",
				"arrivesAt": "12:38",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Săvârşin",
				"to": "Radna",
				"leavesAt": "12:39",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Radna",
				"to": "Arad",
				"leavesAt": "13:41",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 34500
			},
			{
				"from": "Arad",
				"to": "Curtici",
				"leavesAt": "14:20",
				"arrivesAt": "14:33",
				"waitsAtSource": 120,
				"distance": 17000
			},
			{
				"from": "Curtici",
				"to": "Lokoshaza",
				"leavesAt": "14:58",
				"arrivesAt": "15:08",
				"waitsAtSource": 1500,
				"distance": 11200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9112",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "12:00",
				"arrivesAt": "12:06",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "12:12",
				"arrivesAt": "12:16",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "12:17",
				"arrivesAt": "12:19",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "12:20",
				"arrivesAt": "12:23",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "12:24",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "12:28",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "12:33",
				"arrivesAt": "12:38",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "12:40",
				"arrivesAt": "12:44",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "12:45",
				"arrivesAt": "12:48",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "12:49",
				"arrivesAt": "12:54",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "12:55",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "13:01",
				"arrivesAt": "13:07",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "13:08",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "13:16",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "13:23",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "13:29",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4324",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Buşag Hm.",
				"leavesAt": "20:20",
				"arrivesAt": "20:37",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Buşag Hm.",
				"to": "Cicârlău h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cicârlău h.",
				"to": "Ilba h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:52",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ilba h.",
				"to": "Săbişa h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbişa h.",
				"to": "Seini",
				"leavesAt": "20:58",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Seini",
				"to": "Apa Hm.",
				"leavesAt": "21:05",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "21:19",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "21:40",
				"arrivesAt": "21:47",
				"waitsAtSource": 600,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "21:48",
				"arrivesAt": "21:53",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "21:54",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "406",
		"segments": [
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "19:00",
				"arrivesAt": "19:29",
				"waitsAtSource": 0,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "20:03",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 28500
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "20:28",
				"arrivesAt": "20:36",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Izvoru Oltului",
				"leavesAt": "20:37",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Gheorgheni",
				"leavesAt": "20:54",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "21:23",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "21:56",
				"arrivesAt": "22:55",
				"waitsAtSource": 60,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Sărăţel Hm.",
				"leavesAt": "22:59",
				"arrivesAt": "23:53",
				"waitsAtSource": 240,
				"distance": 46800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "23:55",
				"arrivesAt": "00:21",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "00:23",
				"arrivesAt": "00:58",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "01:02",
				"arrivesAt": "01:21",
				"waitsAtSource": 240,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "01:22",
				"arrivesAt": "02:14",
				"waitsAtSource": 60,
				"distance": 44900
			},
			{
				"from": "Cluj Napoca",
				"to": "Huedin",
				"leavesAt": "02:26",
				"arrivesAt": "03:19",
				"waitsAtSource": 720,
				"distance": 49400
			},
			{
				"from": "Huedin",
				"to": "Aleşd",
				"leavesAt": "03:20",
				"arrivesAt": "04:26",
				"waitsAtSource": 60,
				"distance": 68400
			},
			{
				"from": "Aleşd",
				"to": "Oradea",
				"leavesAt": "04:27",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 34300
			},
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "05:03",
				"arrivesAt": "05:11",
				"waitsAtSource": 360,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharkeresztes",
				"leavesAt": "05:33",
				"arrivesAt": "05:48",
				"waitsAtSource": 1320,
				"distance": 12500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8346",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "17:50",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "18:04",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:31",
				"waitsAtSource": 480,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "18:32",
				"arrivesAt": "18:39",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "18:40",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "18:50",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "18:57",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Dunărea Hm.",
				"leavesAt": "19:06",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Dunărea Hm.",
				"to": "Ovidiu",
				"leavesAt": "19:15",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ovidiu",
				"to": "Ramificaţia Borcea",
				"leavesAt": "19:22",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "19:34",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "19:50",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "20:04",
				"arrivesAt": "20:07",
				"waitsAtSource": 480,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "20:18",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Ştefan Vodă h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:43",
				"waitsAtSource": 120,
				"distance": 12600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Km. 25+700 h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Sud",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180916",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9471",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Bradu de Sus",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Pârvu Hm.",
				"to": "Pârvu h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Pârvu h.",
				"to": "Costeşti",
				"leavesAt": "07:49",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "08:03",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "08:12",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "08:21",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "08:41",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "08:52",
				"arrivesAt": "09:00",
				"waitsAtSource": 240,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "09:01",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "09:20",
				"arrivesAt": "09:26",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "09:27",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "09:35",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "09:39",
				"arrivesAt": "09:45",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5055",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "17:27",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "17:37",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "17:47",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "17:59",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "18:07",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "18:18",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "18:26",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "18:32",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "18:38",
				"arrivesAt": "18:50",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "19:05",
				"arrivesAt": "19:16",
				"waitsAtSource": 900,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "19:17",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "19:28",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "19:51",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "20:00",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "20:17",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "20:28",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "20:42",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2214",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "19:04",
				"arrivesAt": "19:12",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "19:13",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8124",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Perieţi h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:59",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Perieţi h.",
				"to": "Fundata h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Fundata h.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "17:06",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Ciochina hc.",
				"leavesAt": "17:14",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciochina hc.",
				"to": "Căzăneşti",
				"leavesAt": "17:24",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Căzăneşti",
				"to": "Munteni Buzău h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Km. 74+600 h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Malu h.",
				"leavesAt": "17:55",
				"arrivesAt": "17:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Malu h.",
				"to": "Broşteni Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Alexeni h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Alexeni h.",
				"to": "Urziceni",
				"leavesAt": "18:15",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:32",
				"waitsAtSource": 240,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "18:33",
				"arrivesAt": "18:37",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "18:44",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "18:51",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Greci h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Greci h.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "19:05",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "19:12",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Odăile h.",
				"leavesAt": "19:30",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Odăile h.",
				"to": "Mogoşoaia",
				"leavesAt": "19:35",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Mogoşoaia",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "19:43",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "20:05",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4650",
		"segments": [
			{
				"from": "Sighetu Marmaţiei",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:25",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Tisa h.",
				"leavesAt": "07:26",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tisa h.",
				"to": "Crăciuneşti h.",
				"leavesAt": "07:34",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Lunca la Tisa h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Valea Vişeului",
				"leavesAt": "07:51",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Valea Vişeului",
				"to": "Vişeu Bistra h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:40",
				"waitsAtSource": 1020,
				"distance": 8500
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Petrova hc.",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Petrova hc.",
				"to": "Leordina",
				"leavesAt": "08:51",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Leordina",
				"to": "Leordina h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Leordina h.",
				"to": "Bocicoel h.",
				"leavesAt": "09:09",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Bocicoel h.",
				"to": "Vişeu de Jos",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9622",
		"segments": [
			{
				"from": "Buziaş",
				"to": "Căpăt h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:27",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Căpăt h.",
				"to": "Sinia Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Sinia Hm.",
				"to": "Boldur h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Boldur h.",
				"to": "Lugoj",
				"leavesAt": "06:41",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7567",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "03:51",
				"arrivesAt": "03:59",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "04:00",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "04:06",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Tecuci",
				"to": "Malul Alb h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:34",
				"waitsAtSource": 600,
				"distance": 5600
			},
			{
				"from": "Malul Alb h.",
				"to": "Barcea",
				"leavesAt": "04:35",
				"arrivesAt": "04:39",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Barcea",
				"to": "Umbrăreşti h.",
				"leavesAt": "04:40",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "04:46",
				"arrivesAt": "04:51",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Iveşti Hm.",
				"to": "Buceşti h.",
				"leavesAt": "04:52",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Buceşti h.",
				"to": "Lieşti",
				"leavesAt": "04:57",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lieşti",
				"to": "Şerbăneşti h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "05:06",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "05:12",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Vameş h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Vameş h.",
				"to": "Piscu h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Piscu h.",
				"to": "Independenţa Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Independenţa Hm.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Braniştea h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:46",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Braniştea h.",
				"to": "Şerbeştii Vechi h.",
				"leavesAt": "05:47",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şerbeştii Vechi h.",
				"to": "Şendreni Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şendreni Hm.",
				"to": "Barboşi Triaj h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Barboşi Triaj h.",
				"to": "Barboşi",
				"leavesAt": "06:02",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "06:18",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4505",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "06:15",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "06:34",
				"arrivesAt": "06:38",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "06:39",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Bodoc Hm.",
				"leavesAt": "06:49",
				"arrivesAt": "06:56",
				"waitsAtSource": 120,
				"distance": 9500
			},
			{
				"from": "Bodoc Hm.",
				"to": "Malnaş h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Malnaş h.",
				"to": "Malnaş Băi",
				"leavesAt": "07:04",
				"arrivesAt": "07:09",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş Băi",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "07:10",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Vrabia h.",
				"leavesAt": "07:34",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Vrabia h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "07:46",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "07:57",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1644",
		"segments": [
			{
				"from": "Beclean pe Someş",
				"to": "Sărăţel Hm.",
				"leavesAt": "22:40",
				"arrivesAt": "23:06",
				"waitsAtSource": 0,
				"distance": 24900
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Mărişelu Hm.",
				"leavesAt": "23:24",
				"arrivesAt": "23:37",
				"waitsAtSource": 1080,
				"distance": 9300
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Deda",
				"leavesAt": "23:42",
				"arrivesAt": "00:29",
				"waitsAtSource": 300,
				"distance": 37500
			},
			{
				"from": "Deda",
				"to": "Răstoliţa Hm.",
				"leavesAt": "00:33",
				"arrivesAt": "00:46",
				"waitsAtSource": 240,
				"distance": 9200
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Topliţa",
				"leavesAt": "00:54",
				"arrivesAt": "01:45",
				"waitsAtSource": 480,
				"distance": 34700
			},
			{
				"from": "Topliţa",
				"to": "Lăzarea Hm.",
				"leavesAt": "01:53",
				"arrivesAt": "02:24",
				"waitsAtSource": 480,
				"distance": 29600
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Gheorgheni",
				"leavesAt": "02:32",
				"arrivesAt": "02:38",
				"waitsAtSource": 480,
				"distance": 4400
			},
			{
				"from": "Gheorgheni",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "02:40",
				"arrivesAt": "02:56",
				"waitsAtSource": 120,
				"distance": 19100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "02:57",
				"arrivesAt": "03:09",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "03:10",
				"arrivesAt": "03:29",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "03:33",
				"arrivesAt": "03:41",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "03:43",
				"arrivesAt": "04:06",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "04:08",
				"arrivesAt": "04:40",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "04:42",
				"arrivesAt": "05:12",
				"waitsAtSource": 120,
				"distance": 32100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "05:27",
				"arrivesAt": "06:05",
				"waitsAtSource": 900,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "06:07",
				"arrivesAt": "06:16",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "06:25",
				"arrivesAt": "06:34",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "06:36",
				"arrivesAt": "06:50",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Breaza hc.",
				"leavesAt": "06:51",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "07:00",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "07:06",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Ploieşti Vest",
				"leavesAt": "07:17",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 18600
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "07:34",
				"arrivesAt": "08:19",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2050",
		"segments": [
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "18:45",
				"arrivesAt": "18:53",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "18:54",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "19:15",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "19:21",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "19:34",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Bârzava",
				"leavesAt": "19:58",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "20:27",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "20:39",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "20:57",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "21:09",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "21:27",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "21:44",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "21:52",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "22:06",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "22:11",
				"arrivesAt": "22:14",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "22:15",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "22:20",
				"arrivesAt": "22:29",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "22:31",
				"arrivesAt": "22:38",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "22:39",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 352
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1963",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun hc.",
				"leavesAt": "20:15",
				"arrivesAt": "20:25",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:27",
				"arrivesAt": "20:40",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "20:42",
				"arrivesAt": "20:46",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:57",
				"waitsAtSource": 180,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "20:58",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "21:20",
				"arrivesAt": "21:43",
				"waitsAtSource": 180,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "22:20",
				"arrivesAt": "22:45",
				"waitsAtSource": 2220,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "22:46",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "23:05",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "23:26",
				"arrivesAt": "23:43",
				"waitsAtSource": 120,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Ţăndărei",
				"leavesAt": "23:44",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Ţăndărei",
				"to": "Spicu",
				"leavesAt": "23:57",
				"arrivesAt": "00:17",
				"waitsAtSource": 60,
				"distance": 21700
			},
			{
				"from": "Spicu",
				"to": "Făurei",
				"leavesAt": "00:18",
				"arrivesAt": "00:55",
				"waitsAtSource": 60,
				"distance": 36400
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "00:57",
				"arrivesAt": "01:36",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "01:56",
				"arrivesAt": "02:27",
				"waitsAtSource": 1200,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "02:29",
				"arrivesAt": "03:07",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "03:09",
				"arrivesAt": "03:31",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "03:46",
				"arrivesAt": "04:10",
				"waitsAtSource": 900,
				"distance": 17800
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Bârlad",
				"leavesAt": "04:11",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 48600
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "04:55",
				"arrivesAt": "05:24",
				"waitsAtSource": 120,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "05:25",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "05:41",
				"arrivesAt": "05:59",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "06:27",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "06:44",
				"arrivesAt": "06:51",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6316",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Dragalina h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:09",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Dragalina h.",
				"to": "Tutova",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Tutova",
				"to": "Ghidigeni Hm.",
				"leavesAt": "21:18",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ghidigeni Hm.",
				"to": "Nichişeni",
				"leavesAt": "21:30",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nichişeni",
				"to": "Berheci Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Berheci Hm.",
				"to": "Rateş Munteni h.",
				"leavesAt": "21:46",
				"arrivesAt": "21:52",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Rateş Munteni h.",
				"to": "Frunzeasca Hm.",
				"leavesAt": "21:53",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Frunzeasca Hm.",
				"to": "Tecuci Nord hc.(600)",
				"leavesAt": "21:59",
				"arrivesAt": "22:07",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tecuci Nord hc.(600)",
				"to": "Tecuci",
				"leavesAt": "22:08",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9418",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "13:15",
				"arrivesAt": "13:26",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "13:27",
				"arrivesAt": "13:33",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "13:53",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 480
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5481",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "19:07",
				"arrivesAt": "19:16",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "19:17",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Racova h.",
				"leavesAt": "19:32",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Racova h.",
				"to": "Buhuşi",
				"leavesAt": "19:38",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Buhuşi",
				"to": "Costişa h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Costişa h.",
				"to": "Podoleni Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Podoleni Hm.",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Roznov",
				"leavesAt": "20:11",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Roznov",
				"to": "Săvineşti h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:28",
				"waitsAtSource": 420,
				"distance": 4200
			},
			{
				"from": "Săvineşti h.",
				"to": "Dumbrava h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Piatra Neamţ",
				"leavesAt": "20:38",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Piatra Neamţ",
				"to": "Vaduri h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:59",
				"waitsAtSource": 120,
				"distance": 9600
			},
			{
				"from": "Vaduri h.",
				"to": "Pângăraţi Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pângăraţi Hm.",
				"to": "Stejaru h.",
				"leavesAt": "21:06",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Stejaru h.",
				"to": "Tarcău Neamţ Hm.",
				"leavesAt": "21:11",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tarcău Neamţ Hm.",
				"to": "Bicaz",
				"leavesAt": "21:19",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6442",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "04:21",
				"arrivesAt": "04:35",
				"waitsAtSource": 0,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "04:36",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "04:50",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "04:59",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "05:10",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "05:17",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "05:24",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "05:32",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4372",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "05:05",
				"arrivesAt": "05:12",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Reteag Hm.",
				"leavesAt": "05:13",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "05:33",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "05:38",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:57",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "06:14",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "06:17",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:38",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "06:39",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3088",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "19:43",
				"arrivesAt": "19:53",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "19:59",
				"arrivesAt": "20:05",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "20:06",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "20:12",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "20:21",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "20:30",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:53",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "20:54",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "21:35",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "21:39",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "21:44",
				"arrivesAt": "21:51",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "21:52",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "22:07",
				"arrivesAt": "22:15",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "22:16",
				"arrivesAt": "22:27",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "22:28",
				"arrivesAt": "22:32",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "22:36",
				"arrivesAt": "22:43",
				"waitsAtSource": 240,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "22:47",
				"arrivesAt": "22:56",
				"waitsAtSource": 240,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8584",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Brâncoveni h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:47",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Brâncoveni h.",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "08:48",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Slobozia Veche",
				"leavesAt": "08:58",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 4200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5431",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "21:39",
				"arrivesAt": "21:50",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "21:56",
				"arrivesAt": "22:01",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "22:02",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "22:12",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "22:17",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "22:26",
				"arrivesAt": "22:33",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "22:34",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "22:41",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "22:46",
				"arrivesAt": "22:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "22:52",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "22:57",
				"arrivesAt": "23:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani Triaj",
				"leavesAt": "23:02",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Paşcani Triaj",
				"to": "Paşcani",
				"leavesAt": "23:08",
				"arrivesAt": "23:15",
				"waitsAtSource": 60,
				"distance": 2300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7571",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "11:10",
				"arrivesAt": "11:17",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "11:18",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "11:24",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Tecuci",
				"to": "Malul Alb h.",
				"leavesAt": "11:37",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Malul Alb h.",
				"to": "Barcea",
				"leavesAt": "11:43",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Barcea",
				"to": "Umbrăreşti h.",
				"leavesAt": "11:48",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "11:54",
				"arrivesAt": "11:59",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Iveşti Hm.",
				"to": "Buceşti h.",
				"leavesAt": "12:00",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Buceşti h.",
				"to": "Lieşti",
				"leavesAt": "12:04",
				"arrivesAt": "12:08",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lieşti",
				"to": "Şerbăneşti h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "12:13",
				"arrivesAt": "12:18",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "12:19",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Vameş h.",
				"leavesAt": "12:24",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Vameş h.",
				"to": "Piscu h.",
				"leavesAt": "12:31",
				"arrivesAt": "12:35",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Piscu h.",
				"to": "Independenţa Hm.",
				"leavesAt": "12:36",
				"arrivesAt": "12:43",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Independenţa Hm.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:49",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Braniştea h.",
				"leavesAt": "12:50",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Braniştea h.",
				"to": "Şendreni Hm.",
				"leavesAt": "12:55",
				"arrivesAt": "13:04",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Şendreni Hm.",
				"to": "Barboşi",
				"leavesAt": "13:05",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "13:17",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "13:24",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1826",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Rovinari Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:35",
				"waitsAtSource": 0,
				"distance": 21800
			},
			{
				"from": "Rovinari Hm.",
				"to": "Turceni",
				"leavesAt": "05:36",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 35300
			},
			{
				"from": "Turceni",
				"to": "Filiaşi",
				"leavesAt": "06:13",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 19900
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "06:39",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "07:13",
				"arrivesAt": "07:53",
				"waitsAtSource": 480,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "07:55",
				"arrivesAt": "08:10",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Radomireşti Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "08:23",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 25600
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "08:48",
				"arrivesAt": "09:33",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "09:35",
				"arrivesAt": "10:27",
				"waitsAtSource": 120,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4109",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Sărăţel Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:53",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "18:01",
				"arrivesAt": "18:05",
				"waitsAtSource": 480,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:11",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:30",
				"waitsAtSource": 840,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "18:35",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "18:40",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Ciceu Cristur h.",
				"leavesAt": "18:50",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "19:03",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "19:07",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Călători",
				"leavesAt": "19:12",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "19:31",
				"arrivesAt": "19:50",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:03",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:13",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:23",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida",
				"leavesAt": "20:24",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "20:39",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "20:53",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180114",
				"daysOfWeek": 895
			},
			{
				"from": "20180121",
				"to": "20180121",
				"daysOfWeek": 895
			},
			{
				"from": "20180128",
				"to": "20180128",
				"daysOfWeek": 895
			},
			{
				"from": "20180211",
				"to": "20180211",
				"daysOfWeek": 895
			},
			{
				"from": "20180218",
				"to": "20180218",
				"daysOfWeek": 895
			},
			{
				"from": "20180225",
				"to": "20180225",
				"daysOfWeek": 895
			},
			{
				"from": "20180304",
				"to": "20180304",
				"daysOfWeek": 895
			},
			{
				"from": "20180311",
				"to": "20180311",
				"daysOfWeek": 895
			},
			{
				"from": "20180318",
				"to": "20180318",
				"daysOfWeek": 895
			},
			{
				"from": "20180325",
				"to": "20180325",
				"daysOfWeek": 895
			},
			{
				"from": "20180410",
				"to": "20180410",
				"daysOfWeek": 895
			},
			{
				"from": "20180415",
				"to": "20180415",
				"daysOfWeek": 895
			},
			{
				"from": "20180422",
				"to": "20180422",
				"daysOfWeek": 895
			},
			{
				"from": "20180429",
				"to": "20180429",
				"daysOfWeek": 895
			},
			{
				"from": "20180506",
				"to": "20180506",
				"daysOfWeek": 895
			},
			{
				"from": "20180513",
				"to": "20180513",
				"daysOfWeek": 895
			},
			{
				"from": "20180520",
				"to": "20180520",
				"daysOfWeek": 895
			},
			{
				"from": "20180527",
				"to": "20180527",
				"daysOfWeek": 895
			},
			{
				"from": "20180603",
				"to": "20180603",
				"daysOfWeek": 895
			},
			{
				"from": "20180610",
				"to": "20180610",
				"daysOfWeek": 895
			},
			{
				"from": "20180909",
				"to": "20180909",
				"daysOfWeek": 895
			},
			{
				"from": "20180916",
				"to": "20180916",
				"daysOfWeek": 895
			},
			{
				"from": "20180923",
				"to": "20180923",
				"daysOfWeek": 895
			},
			{
				"from": "20180930",
				"to": "20180930",
				"daysOfWeek": 895
			},
			{
				"from": "20181007",
				"to": "20181007",
				"daysOfWeek": 895
			},
			{
				"from": "20181014",
				"to": "20181014",
				"daysOfWeek": 895
			},
			{
				"from": "20181021",
				"to": "20181021",
				"daysOfWeek": 895
			},
			{
				"from": "20181028",
				"to": "20181028",
				"daysOfWeek": 895
			},
			{
				"from": "20181104",
				"to": "20181104",
				"daysOfWeek": 895
			},
			{
				"from": "20181111",
				"to": "20181111",
				"daysOfWeek": 895
			},
			{
				"from": "20181118",
				"to": "20181118",
				"daysOfWeek": 895
			},
			{
				"from": "20181125",
				"to": "20181125",
				"daysOfWeek": 895
			},
			{
				"from": "20181202",
				"to": "20181202",
				"daysOfWeek": 895
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 895
			},
			{
				"from": "20171217",
				"to": "20171217",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1656",
		"segments": [
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "16:06",
				"arrivesAt": "16:46",
				"waitsAtSource": 0,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "16:47",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 25700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6822",
		"segments": [
			{
				"from": "Nyirabrany",
				"to": "Valea lui Mihai",
				"leavesAt": "11:06",
				"arrivesAt": "11:21",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Valea lui Mihai",
				"to": "Curtuiuşeni h.",
				"leavesAt": "11:41",
				"arrivesAt": "11:48",
				"waitsAtSource": 1200,
				"distance": 6300
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Resighea h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:56",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Resighea h.",
				"to": "Sanislău Hm.",
				"leavesAt": "11:57",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Sanislău Hm.",
				"to": "Marna h.",
				"leavesAt": "12:03",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Marna h.",
				"to": "Carei",
				"leavesAt": "12:09",
				"arrivesAt": "12:16",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "12:17",
				"arrivesAt": "12:25",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "12:26",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "12:31",
				"arrivesAt": "12:35",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:44",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "12:45",
				"arrivesAt": "12:52",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "12:53",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6823",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "15:00",
				"arrivesAt": "15:05",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "15:13",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "15:33",
				"arrivesAt": "15:43",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Carei",
				"to": "Marna h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Marna h.",
				"to": "Sanislău Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Sanislău Hm.",
				"to": "Resighea h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Resighea h.",
				"to": "Curtuiuşeni h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Valea lui Mihai",
				"leavesAt": "16:10",
				"arrivesAt": "16:17",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Valea lui Mihai",
				"to": "Nyirabrany",
				"leavesAt": "16:39",
				"arrivesAt": "16:54",
				"waitsAtSource": 1320,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1631",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "07:00",
				"arrivesAt": "07:40",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "07:42",
				"arrivesAt": "08:06",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "08:07",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "08:32",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "08:40",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "08:46",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "08:57",
				"arrivesAt": "09:35",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8202",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "07:57",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "08:11",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "08:21",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "08:30",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "08:46",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "08:52",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Ramificaţia Borcea",
				"leavesAt": "09:02",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "09:20",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "09:27",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Platoneşti h.",
				"leavesAt": "09:47",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Platoneşti h.",
				"to": "Ţăndărei",
				"leavesAt": "09:57",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ţăndărei",
				"to": "Murgeanca Hm.",
				"leavesAt": "10:07",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Spicu",
				"leavesAt": "10:20",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spicu",
				"to": "Dudeşti Hm.",
				"leavesAt": "10:30",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "10:41",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Cireşu Hm.",
				"leavesAt": "10:49",
				"arrivesAt": "10:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cireşu Hm.",
				"to": "Făurei",
				"leavesAt": "10:57",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 15700
			},
			{
				"from": "Făurei",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "11:17",
				"arrivesAt": "11:28",
				"waitsAtSource": 120,
				"distance": 10000
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "11:29",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "11:37",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "11:55",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău",
				"leavesAt": "11:59",
				"arrivesAt": "12:11",
				"waitsAtSource": 30,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8153",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Alexeni h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Alexeni h.",
				"to": "Broşteni Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Malu h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Malu h.",
				"to": "Km. 74+600 h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Munteni Buzău h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Căzăneşti",
				"leavesAt": "17:19",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Căzăneşti",
				"to": "Ciochina hc.",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ciochina hc.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Fundata h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Fundata h.",
				"to": "Perieţi h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Perieţi h.",
				"to": "Slobozia Veche",
				"leavesAt": "17:54",
				"arrivesAt": "18:05",
				"waitsAtSource": 30,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5114",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:48",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "17:49",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "18:15",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "18:40",
				"arrivesAt": "18:49",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "18:50",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "19:01",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "19:12",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 11500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1727",
		"segments": [
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "07:15",
				"arrivesAt": "07:55",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "08:00",
				"arrivesAt": "08:25",
				"waitsAtSource": 300,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Gilort Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 12400
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "08:50",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "09:00",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cărbuneşti",
				"to": "Târgu Jiu",
				"leavesAt": "09:21",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 23800
			}
		],
		"restrictions": [
			{
				"from": "20180807",
				"to": "20181208",
				"daysOfWeek": 783
			},
			{
				"from": "20171210",
				"to": "20180805",
				"daysOfWeek": 783
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1835",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "16:25",
				"arrivesAt": "17:16",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "17:17",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "18:05",
				"arrivesAt": "18:35",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "18:36",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "18:55",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "19:42",
				"arrivesAt": "20:08",
				"waitsAtSource": 480,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Cărbuneşti",
				"leavesAt": "20:09",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 46500
			},
			{
				"from": "Cărbuneşti",
				"to": "Târgu Jiu",
				"leavesAt": "20:55",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 23800
			},
			{
				"from": "Târgu Jiu",
				"to": "Valea Sadului Hm.",
				"leavesAt": "21:30",
				"arrivesAt": "21:50",
				"waitsAtSource": 480,
				"distance": 19600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Petroşani",
				"leavesAt": "21:51",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 31700
			},
			{
				"from": "Petroşani",
				"to": "Subcetate",
				"leavesAt": "22:41",
				"arrivesAt": "23:47",
				"waitsAtSource": 240,
				"distance": 49800
			},
			{
				"from": "Subcetate",
				"to": "Călan Hm.",
				"leavesAt": "23:48",
				"arrivesAt": "00:07",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Călan Hm.",
				"to": "Simeria",
				"leavesAt": "00:08",
				"arrivesAt": "00:23",
				"waitsAtSource": 60,
				"distance": 14600
			},
			{
				"from": "Simeria",
				"to": "Orăştie",
				"leavesAt": "00:43",
				"arrivesAt": "01:05",
				"waitsAtSource": 1200,
				"distance": 16500
			},
			{
				"from": "Orăştie",
				"to": "Aurel Vlaicu",
				"leavesAt": "01:06",
				"arrivesAt": "01:15",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Şibot",
				"leavesAt": "01:20",
				"arrivesAt": "01:28",
				"waitsAtSource": 300,
				"distance": 5900
			},
			{
				"from": "Şibot",
				"to": "Vinţu de Jos",
				"leavesAt": "01:29",
				"arrivesAt": "01:51",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "01:52",
				"arrivesAt": "02:04",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Teiuş",
				"leavesAt": "02:05",
				"arrivesAt": "02:40",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "02:44",
				"arrivesAt": "02:56",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Războieni",
				"leavesAt": "02:57",
				"arrivesAt": "03:18",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "03:20",
				"arrivesAt": "03:36",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Apahida",
				"leavesAt": "03:37",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 39200
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca",
				"leavesAt": "04:28",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 12300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1657",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "15:00",
				"arrivesAt": "15:51",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "15:53",
				"arrivesAt": "16:26",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "16:27",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "17:05",
				"arrivesAt": "17:36",
				"waitsAtSource": 180,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "17:37",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "18:17",
				"arrivesAt": "18:39",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "18:41",
				"arrivesAt": "19:07",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "19:08",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 58200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9405",
		"segments": [
			{
				"from": "Caracal",
				"to": "Romula Hm.",
				"leavesAt": "14:18",
				"arrivesAt": "14:31",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Romula Hm.",
				"to": "Fălcoiu h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fălcoiu h.",
				"to": "Vlăduleni",
				"leavesAt": "14:42",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni",
				"to": "Şopârliţa hc.",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Pârşcoveni hc.",
				"leavesAt": "14:57",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Pârşcoveni hc.",
				"to": "Piatra Olt",
				"leavesAt": "15:04",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20180115",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180212",
				"to": "20180330",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4484",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "14:20",
				"arrivesAt": "14:27",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Reteag Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:44",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:48",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "14:49",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "14:53",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:12",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "15:13",
				"arrivesAt": "15:16",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "15:33",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Năsăud h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Năsăud h.",
				"to": "Năsăud",
				"leavesAt": "15:42",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Năsăud",
				"to": "Rebrişoara Hm.",
				"leavesAt": "15:46",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Nepos h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Nepos h.",
				"to": "Feldru Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Feldru Hm.",
				"to": "Podereia Feldrului h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Ilva Mică",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3747",
		"segments": [
			{
				"from": "Arad",
				"to": "Utviniş h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:16",
				"waitsAtSource": 0,
				"distance": 9600
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "16:22",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Comlăuş h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Comlăuş h.",
				"to": "Şimand Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Şimand Hm.",
				"to": "Nădab",
				"leavesAt": "16:49",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Nădab",
				"to": "Chişineu Criş",
				"leavesAt": "16:58",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9587",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Săcălaz h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:22",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Săcălaz h.",
				"to": "Beregsău hcv.",
				"leavesAt": "08:23",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Beregsău hcv.",
				"to": "Cărpiniş",
				"leavesAt": "08:31",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Cărpiniş",
				"to": "Clarii Vii h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Clarii Vii h.",
				"to": "Jimbolia",
				"leavesAt": "08:47",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5436",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "11:28",
				"arrivesAt": "11:35",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "11:36",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "11:42",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "11:47",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "11:53",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "11:58",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "12:05",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "12:16",
				"arrivesAt": "12:23",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "12:24",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "12:29",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "12:44",
				"arrivesAt": "12:49",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "12:50",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9402",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "05:42",
				"arrivesAt": "05:53",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "05:54",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:13",
				"waitsAtSource": 540,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "06:14",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "06:26",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1648",
		"segments": [
			{
				"from": "Sărăţel Hm.",
				"to": "Bistriţa Nord",
				"leavesAt": "05:12",
				"arrivesAt": "05:26",
				"waitsAtSource": 0,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1928",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "04:08",
				"arrivesAt": "04:27",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 15400
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Cârţa h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cârţa h.",
				"to": "Ucea",
				"leavesAt": "05:09",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Ucea",
				"to": "Făgăraş",
				"leavesAt": "05:21",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Făgăraş",
				"to": "Mândra Oltului h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:52",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Şercaia h.",
				"leavesAt": "05:53",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Şercaia h.",
				"to": "Şercaia Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 1200
			},
			{
				"from": "Şercaia Hm.",
				"to": "Perşani h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Brădet Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Brădet Hm.",
				"to": "Valea Homorod h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Homorod h.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "06:30",
				"arrivesAt": "06:40",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 300,
				"distance": 4600
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Codlea Hm.",
				"to": "Ghimbav Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Bartolomeu",
				"leavesAt": "07:08",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "07:16",
				"arrivesAt": "07:22",
				"waitsAtSource": 120,
				"distance": 3100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "07:40",
				"arrivesAt": "08:18",
				"waitsAtSource": 1080,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "08:20",
				"arrivesAt": "08:29",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "08:31",
				"arrivesAt": "08:37",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "08:38",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Valea Largă Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "08:55",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "08:56",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Câmpina",
				"leavesAt": "09:06",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "09:20",
				"arrivesAt": "09:44",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "09:46",
				"arrivesAt": "10:32",
				"waitsAtSource": 120,
				"distance": 58900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Feteşti",
				"leavesAt": "11:00",
				"arrivesAt": "12:16",
				"waitsAtSource": 1680,
				"distance": 146400
			},
			{
				"from": "Feteşti",
				"to": "Constanţa",
				"leavesAt": "12:18",
				"arrivesAt": "13:14",
				"waitsAtSource": 120,
				"distance": 78600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5466",
		"segments": [
			{
				"from": "Piatra Neamţ",
				"to": "Dumbrava h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:32",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Săvineşti h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săvineşti h.",
				"to": "Roznov",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Roznov",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "17:53",
				"arrivesAt": "17:57",
				"waitsAtSource": 420,
				"distance": 3600
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Podoleni Hm.",
				"leavesAt": "17:58",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Podoleni Hm.",
				"to": "Costişa h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Costişa h.",
				"to": "Buhuşi",
				"leavesAt": "18:14",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhuşi",
				"to": "Racova h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Racova h.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "18:29",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Gârleni Hm.",
				"leavesAt": "18:35",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gârleni Hm.",
				"to": "Hămeiuş P.M.",
				"leavesAt": "18:40",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Bacău",
				"leavesAt": "18:47",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 7900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4483",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Podereia Feldrului h.",
				"leavesAt": "13:56",
				"arrivesAt": "14:00",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Feldru Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:05",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Feldru Hm.",
				"to": "Nepos h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Nepos h.",
				"to": "Rebrişoara Hm.",
				"leavesAt": "14:12",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Năsăud",
				"leavesAt": "14:19",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Năsăud",
				"to": "Năsăud h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:35",
				"waitsAtSource": 480,
				"distance": 2200
			},
			{
				"from": "Năsăud h.",
				"to": "Salva",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Salva",
				"to": "Mititei h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:46",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Mititei h.",
				"to": "Nimigea Hm.",
				"leavesAt": "14:47",
				"arrivesAt": "14:54",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:04",
				"waitsAtSource": 420,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:20",
				"waitsAtSource": 420,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "15:21",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4510",
		"segments": [
			{
				"from": "Deda",
				"to": "Deda Bistra Hm.",
				"leavesAt": "13:06",
				"arrivesAt": "13:12",
				"waitsAtSource": 0,
				"distance": 3900
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Borzia h.",
				"leavesAt": "13:13",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Borzia h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "13:18",
				"arrivesAt": "13:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "13:23",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 12700
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Stânceni h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Hm.",
				"leavesAt": "13:57",
				"arrivesAt": "14:04",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Stânceni Hm.",
				"to": "Ciobotani h.",
				"leavesAt": "14:05",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ciobotani h.",
				"to": "Topliţa",
				"leavesAt": "14:11",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Topliţa",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "14:37",
				"arrivesAt": "14:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Ditrău",
				"leavesAt": "14:44",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ditrău",
				"to": "Lăzarea Hm.",
				"leavesAt": "14:53",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Gheorgheni",
				"leavesAt": "15:00",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Gheorgheni",
				"to": "Valea Strâmbă h.",
				"leavesAt": "15:07",
				"arrivesAt": "15:10",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Şugău h.",
				"leavesAt": "15:11",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Şugău h.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Sândominic h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Oltului",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Tomeşti h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Cârţani h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Cârţani h.",
				"to": "Dăneşti h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Dăneşti h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "15:58",
				"arrivesAt": "16:04",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Racu h.",
				"leavesAt": "16:05",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Racu h.",
				"to": "Siculeni",
				"leavesAt": "16:11",
				"arrivesAt": "16:16",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "16:20",
				"arrivesAt": "16:29",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:50",
				"waitsAtSource": 780,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "16:51",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Vrabia h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vrabia h.",
				"to": "Tuşnad Sat",
				"leavesAt": "17:06",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Malnaş Băi",
				"leavesAt": "17:27",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Malnaş Băi",
				"to": "Malnaş h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Malnaş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Bodoc Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:19",
				"waitsAtSource": 420,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "18:20",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "18:26",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "18:30",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "18:45",
				"arrivesAt": "18:51",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9108",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:47",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "16:53",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "17:13",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:36",
				"waitsAtSource": 840,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "17:53",
				"arrivesAt": "18:00",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "18:01",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "18:09",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "18:21",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2374",
		"segments": [
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "19:48",
				"arrivesAt": "19:56",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "19:57",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "20:24",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "20:36",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "20:52",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Nadăş h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Nadăş h.",
				"to": "Bârzava",
				"leavesAt": "21:05",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "21:17",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "21:37",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "21:41",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 6000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4131",
		"segments": [
			{
				"from": "Vişeu de Jos",
				"to": "Bocicoel h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Bocicoel h.",
				"to": "Leordina h.",
				"leavesAt": "16:51",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Leordina h.",
				"to": "Leordina",
				"leavesAt": "17:00",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Leordina",
				"to": "Petrova hc.",
				"leavesAt": "17:26",
				"arrivesAt": "17:36",
				"waitsAtSource": 1200,
				"distance": 6400
			},
			{
				"from": "Petrova hc.",
				"to": "Vişeu Bistra h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Valea Vişeului",
				"leavesAt": "17:47",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Valea Vişeului",
				"to": "Lunca la Tisa h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:40",
				"waitsAtSource": 1380,
				"distance": 10700
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Crăciuneşti h.",
				"leavesAt": "18:48",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Tisa h.",
				"leavesAt": "18:55",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Tisa h.",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "18:59",
				"arrivesAt": "19:06",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Sighetu Marmaţiei",
				"leavesAt": "19:07",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1825",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "14:45",
				"arrivesAt": "15:36",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "15:37",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "16:24",
				"arrivesAt": "16:55",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "16:56",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "17:15",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "18:00",
				"arrivesAt": "18:26",
				"waitsAtSource": 300,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Turceni",
				"leavesAt": "18:28",
				"arrivesAt": "18:49",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Turceni",
				"to": "Rovinari Hm.",
				"leavesAt": "18:50",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 35300
			},
			{
				"from": "Rovinari Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "19:25",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 21800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1575",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "13:10",
				"arrivesAt": "14:00",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "14:02",
				"arrivesAt": "14:35",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "14:36",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "15:13",
				"arrivesAt": "15:50",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Ianca hc.",
				"leavesAt": "15:51",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "16:06",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "16:40",
				"arrivesAt": "16:58",
				"waitsAtSource": 120,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "16:59",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4413",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "23:29",
				"arrivesAt": "23:35",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "23:36",
				"arrivesAt": "23:44",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "23:45",
				"arrivesAt": "23:52",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "23:53",
				"arrivesAt": "23:59",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20180101",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20180429",
				"daysOfWeek": 351
			},
			{
				"from": "20180501",
				"to": "20180526",
				"daysOfWeek": 351
			},
			{
				"from": "20180528",
				"to": "20180530",
				"daysOfWeek": 351
			},
			{
				"from": "20180601",
				"to": "20181128",
				"daysOfWeek": 351
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171223",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171230",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5454",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "05:00",
				"arrivesAt": "05:05",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "05:06",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "05:16",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 660,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "05:55",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "06:21",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Paşcani Triaj",
				"leavesAt": "07:25",
				"arrivesAt": "07:29",
				"waitsAtSource": 3480,
				"distance": 2300
			},
			{
				"from": "Paşcani Triaj",
				"to": "Stolniceni h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "07:53",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "08:05",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "08:16",
				"arrivesAt": "08:23",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "08:29",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "08:44",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "08:50",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20180531",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2212",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "17:18",
				"arrivesAt": "17:26",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "17:27",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2571",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "23:17",
				"arrivesAt": "23:21",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "23:22",
				"arrivesAt": "23:32",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "23:33",
				"arrivesAt": "23:37",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "23:38",
				"arrivesAt": "23:45",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "23:46",
				"arrivesAt": "23:52",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "23:53",
				"arrivesAt": "23:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Şeica Mare h.",
				"leavesAt": "23:59",
				"arrivesAt": "00:09",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "00:10",
				"arrivesAt": "00:13",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "00:14",
				"arrivesAt": "00:20",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "00:21",
				"arrivesAt": "00:26",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "00:27",
				"arrivesAt": "00:32",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "00:33",
				"arrivesAt": "00:40",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "00:41",
				"arrivesAt": "00:48",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5430",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "02:28",
				"arrivesAt": "02:35",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "02:36",
				"arrivesAt": "02:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "02:42",
				"arrivesAt": "02:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "02:47",
				"arrivesAt": "02:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "02:53",
				"arrivesAt": "02:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "02:58",
				"arrivesAt": "03:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "03:05",
				"arrivesAt": "03:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "03:16",
				"arrivesAt": "03:23",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "03:24",
				"arrivesAt": "03:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "03:29",
				"arrivesAt": "03:37",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "03:38",
				"arrivesAt": "03:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "03:44",
				"arrivesAt": "03:49",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "03:50",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3090",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "22:35",
				"arrivesAt": "22:45",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "22:46",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "22:51",
				"arrivesAt": "22:57",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Cojocna Hm.",
				"leavesAt": "22:58",
				"arrivesAt": "23:03",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cojocna Hm.",
				"to": "Tunel Hm.",
				"leavesAt": "23:04",
				"arrivesAt": "23:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tunel Hm.",
				"to": "Boju",
				"leavesAt": "23:13",
				"arrivesAt": "23:21",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Boju",
				"to": "Valea Florilor Hm.",
				"leavesAt": "23:22",
				"arrivesAt": "23:34",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Ploscoş h.",
				"leavesAt": "23:35",
				"arrivesAt": "23:39",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ploscoş h.",
				"to": "Cânepişti h.",
				"leavesAt": "23:40",
				"arrivesAt": "23:46",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cânepişti h.",
				"to": "Câmpia Turzii",
				"leavesAt": "23:47",
				"arrivesAt": "23:55",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Câmpia Turzii",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "23:56",
				"arrivesAt": "00:04",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Grindeni h.",
				"leavesAt": "00:05",
				"arrivesAt": "00:11",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Grindeni h.",
				"to": "Războieni",
				"leavesAt": "00:12",
				"arrivesAt": "00:16",
				"waitsAtSource": 30,
				"distance": 2800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8387",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:35",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "14:36",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "14:51",
				"arrivesAt": "14:56",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "15:04",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "15:12",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Pescăruş h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Pescăruş h.",
				"to": "Neptun hc.",
				"leavesAt": "15:21",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "15:27",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "15:32",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2081",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "03:10",
				"arrivesAt": "03:13",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "03:14",
				"arrivesAt": "03:17",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "03:18",
				"arrivesAt": "03:21",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "03:22",
				"arrivesAt": "03:25",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "03:26",
				"arrivesAt": "03:29",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "03:30",
				"arrivesAt": "03:33",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "03:34",
				"arrivesAt": "03:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "03:39",
				"arrivesAt": "03:44",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "03:45",
				"arrivesAt": "03:47",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "03:48",
				"arrivesAt": "03:54",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Bungeţel h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:13",
				"waitsAtSource": 960,
				"distance": 2300
			},
			{
				"from": "Bungeţel h.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "04:14",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "04:20",
				"arrivesAt": "04:23",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "04:24",
				"arrivesAt": "04:30",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "04:38",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "04:47",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 300,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "05:09",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "05:43",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Târgu Jiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "05:56",
				"arrivesAt": "05:58",
				"waitsAtSource": 360,
				"distance": 800
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "05:59",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ezureni h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:12",
				"waitsAtSource": 300,
				"distance": 3800
			},
			{
				"from": "Ezureni h.",
				"to": "Parângu Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Parângu Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Meri",
				"leavesAt": "06:31",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Meri",
				"to": "Lainici Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lainici Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "06:49",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "06:56",
				"arrivesAt": "07:01",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Livezeni",
				"leavesAt": "07:12",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Lunca Jiului hc.",
				"leavesAt": "07:20",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Petroşani",
				"leavesAt": "07:24",
				"arrivesAt": "07:30",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9404",
		"segments": [
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "06:50",
				"arrivesAt": "06:58",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "07:12",
				"arrivesAt": "07:20",
				"waitsAtSource": 300,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "07:22",
				"arrivesAt": "07:28",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "08:15",
				"arrivesAt": "08:26",
				"waitsAtSource": 1620,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "08:52",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5582",
		"segments": [
			{
				"from": "Botoşani",
				"to": "Leorda Hm.",
				"leavesAt": "11:19",
				"arrivesAt": "11:43",
				"waitsAtSource": 0,
				"distance": 15500
			},
			{
				"from": "Leorda Hm.",
				"to": "Bucecea Hm",
				"leavesAt": "11:44",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bucecea Hm",
				"to": "Vereşti",
				"leavesAt": "12:04",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 19100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2601",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:38",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:49",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "04:50",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "05:12",
				"arrivesAt": "05:18",
				"waitsAtSource": 240,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Aradu Nou",
				"leavesAt": "05:19",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "05:35",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7037",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "19:07",
				"arrivesAt": "19:11",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Chitila",
				"leavesAt": "19:12",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chitila",
				"to": "Mogoşoaia",
				"leavesAt": "19:19",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Mogoşoaia",
				"to": "Odăile h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:48",
				"waitsAtSource": 360,
				"distance": 3900
			},
			{
				"from": "Odăile h.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:52",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "19:57",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "20:10",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "20:16",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "20:23",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "20:36",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "20:47",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9533",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Piteşti Nord",
				"leavesAt": "20:40",
				"arrivesAt": "20:48",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Piteşti Nord",
				"to": "C.I.L. h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "C.I.L. h.",
				"to": "Bascov Hm.",
				"leavesAt": "20:53",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Bascov Hm.",
				"to": "Merişani h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Merişani h.",
				"to": "Băiculeşti h.",
				"leavesAt": "21:06",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 11300
			},
			{
				"from": "Băiculeşti h.",
				"to": "Curtea de Argeş",
				"leavesAt": "21:18",
				"arrivesAt": "21:29",
				"waitsAtSource": 30,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1812",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Buziaş",
				"leavesAt": "16:00",
				"arrivesAt": "16:37",
				"waitsAtSource": 0,
				"distance": 36400
			},
			{
				"from": "Buziaş",
				"to": "Lugoj",
				"leavesAt": "16:38",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 27500
			},
			{
				"from": "Lugoj",
				"to": "Făget",
				"leavesAt": "17:10",
				"arrivesAt": "17:49",
				"waitsAtSource": 120,
				"distance": 39700
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "17:50",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Margina",
				"to": "Ilia",
				"leavesAt": "18:03",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 35500
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "18:43",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "19:10",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Turdaş Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:34",
				"waitsAtSource": 180,
				"distance": 7400
			},
			{
				"from": "Turdaş Hm.",
				"to": "Pricaz h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Pricaz h.",
				"to": "Orăştie",
				"leavesAt": "19:43",
				"arrivesAt": "19:49",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Orăştie",
				"to": "Aurel Vlaicu",
				"leavesAt": "19:51",
				"arrivesAt": "20:00",
				"waitsAtSource": 120,
				"distance": 6400
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Şibot",
				"leavesAt": "20:01",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şibot",
				"to": "Blandiana Hm.",
				"leavesAt": "20:10",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "20:27",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Sebeş Alba",
				"leavesAt": "20:36",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Sebeş Alba",
				"to": "Cunţa Hm.",
				"leavesAt": "20:48",
				"arrivesAt": "21:07",
				"waitsAtSource": 120,
				"distance": 13000
			},
			{
				"from": "Cunţa Hm.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "21:12",
				"arrivesAt": "21:23",
				"waitsAtSource": 300,
				"distance": 7900
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "21:24",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Sălişte Hm.",
				"leavesAt": "21:37",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 13000
			},
			{
				"from": "Sălişte Hm.",
				"to": "Orlat",
				"leavesAt": "21:58",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Orlat",
				"to": "Sibiu",
				"leavesAt": "22:12",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1528",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "04:08",
				"arrivesAt": "04:27",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "04:28",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 15400
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Cârţa h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cârţa h.",
				"to": "Ucea",
				"leavesAt": "05:09",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Ucea",
				"to": "Făgăraş",
				"leavesAt": "05:21",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Făgăraş",
				"to": "Mândra Oltului h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:52",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Şercaia h.",
				"leavesAt": "05:53",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Şercaia h.",
				"to": "Şercaia Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 1200
			},
			{
				"from": "Şercaia Hm.",
				"to": "Perşani h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Brădet Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Brădet Hm.",
				"to": "Valea Homorod h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Homorod h.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "06:30",
				"arrivesAt": "06:40",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 300,
				"distance": 4600
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Codlea Hm.",
				"to": "Ghimbav Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Bartolomeu",
				"leavesAt": "07:08",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "07:16",
				"arrivesAt": "07:22",
				"waitsAtSource": 120,
				"distance": 3100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "07:40",
				"arrivesAt": "08:18",
				"waitsAtSource": 1080,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "08:20",
				"arrivesAt": "08:29",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "08:31",
				"arrivesAt": "08:37",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "08:38",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Valea Largă Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "08:55",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "08:56",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Câmpina",
				"leavesAt": "09:06",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "09:20",
				"arrivesAt": "09:44",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "09:46",
				"arrivesAt": "10:32",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9011",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Km. 109+000 h.",
				"leavesAt": "04:00",
				"arrivesAt": "04:02",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Bradu de Sus",
				"leavesAt": "04:03",
				"arrivesAt": "04:07",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu h.",
				"leavesAt": "04:08",
				"arrivesAt": "04:17",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Pârvu h.",
				"to": "Costeşti",
				"leavesAt": "04:18",
				"arrivesAt": "04:30",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "04:40",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "04:55",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "05:02",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "05:10",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "05:38",
				"arrivesAt": "05:48",
				"waitsAtSource": 240,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:57",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:07",
				"waitsAtSource": 240,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 600,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Canton 217 h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Canton 217 h.",
				"to": "Balş",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Balş",
				"to": "Spineni h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Spineni h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Toporaş h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "07:07",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Cârcea h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cârcea h.",
				"to": "Plaiu Vulcăneşti Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:24",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Plaiu Vulcăneşti Hm.",
				"to": "Bordei hc.(901)",
				"leavesAt": "07:31",
				"arrivesAt": "07:34",
				"waitsAtSource": 420,
				"distance": 1900
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Craiova",
				"leavesAt": "07:35",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171225",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20180101",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4307",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:45",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "16:46",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "17:44",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "17:48",
				"arrivesAt": "17:55",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "18:02",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7371",
		"segments": [
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 0,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "06:37",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "06:42",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "06:49",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "06:57",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "07:07",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:25",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "07:46",
				"arrivesAt": "07:52",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "07:53",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5010",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "15:05",
				"arrivesAt": "15:15",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "15:16",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "15:23",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "15:40",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "15:58",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "16:04",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "16:10",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "16:14",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "16:22",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "16:30",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "16:39",
				"arrivesAt": "16:45",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Brazi",
				"leavesAt": "16:49",
				"arrivesAt": "16:57",
				"waitsAtSource": 240,
				"distance": 5200
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "17:15",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:33",
				"waitsAtSource": 360,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "17:34",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "17:39",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "17:48",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "17:51",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "17:55",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:00",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "18:01",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4336",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Satu Mare Sud",
				"leavesAt": "15:45",
				"arrivesAt": "15:50",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Satu Mare Sud",
				"to": "Sătmărel h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Sătmărel h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Moftin h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Moftin h.",
				"to": "Domăneşti h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:19",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Domăneşti h.",
				"to": "Carei",
				"leavesAt": "16:20",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 9900
			},
			{
				"from": "Carei",
				"to": "Marna h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Marna h.",
				"to": "Sanislău Hm.",
				"leavesAt": "16:38",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Sanislău Hm.",
				"to": "Resighea h.",
				"leavesAt": "16:44",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Resighea h.",
				"to": "Curtuiuşeni h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Valea lui Mihai",
				"leavesAt": "16:57",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Valea lui Mihai",
				"to": "Simion h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:19",
				"waitsAtSource": 600,
				"distance": 5900
			},
			{
				"from": "Simion h.",
				"to": "Şilindru Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Şilindru Hm.",
				"to": "Săcuieni Bihor",
				"leavesAt": "17:27",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Cadia h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cadia h.",
				"to": "Diosig Hm.",
				"leavesAt": "17:45",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Diosig Hm.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Tămăşeu h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:05",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tămăşeu h.",
				"to": "Biharia Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Biharia Hm.",
				"to": "Episcopia Bihor",
				"leavesAt": "18:15",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "18:26",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5051",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "04:45",
				"arrivesAt": "04:51",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "04:52",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Cricov Hm.",
				"leavesAt": "05:02",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "05:11",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:22",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "05:23",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "05:31",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "05:42",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "05:50",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "05:56",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "06:02",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:39",
				"waitsAtSource": 840,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "06:40",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "06:51",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "07:13",
				"arrivesAt": "07:21",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "07:22",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "07:30",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "07:39",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "08:04",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "08:05",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6403",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Zorleni",
				"leavesAt": "13:49",
				"arrivesAt": "13:57",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Zorleni",
				"to": "Banca Hm.",
				"leavesAt": "13:58",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Banca Hm.",
				"to": "Dodeşti hc.",
				"leavesAt": "14:07",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dodeşti hc.",
				"to": "Roşieşti hc.",
				"leavesAt": "14:12",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Roşieşti hc.",
				"to": "Crasna",
				"leavesAt": "14:19",
				"arrivesAt": "14:27",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Crasna",
				"to": "Bulboaca h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Bulboaca h.",
				"to": "Munteni Hm.",
				"leavesAt": "14:37",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Munteni Hm.",
				"to": "Vaslui",
				"leavesAt": "14:44",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "14:51",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "15:08",
				"arrivesAt": "15:12",
				"waitsAtSource": 420,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "15:13",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "15:18",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "15:45",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "16:11",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "16:18",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "16:25",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7568",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:50",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "07:51",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Barboşi Triaj h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Barboşi Triaj h.",
				"to": "Şendreni Hm.",
				"leavesAt": "08:03",
				"arrivesAt": "08:07",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Şendreni Hm.",
				"to": "Şerbeştii Vechi h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Şerbeştii Vechi h.",
				"to": "Braniştea h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Braniştea h.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Independenţa Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Independenţa Hm.",
				"to": "Piscu h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Piscu h.",
				"to": "Vameş h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:39",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vameş h.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "08:40",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Şerbăneşti h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Lieşti",
				"leavesAt": "08:59",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lieşti",
				"to": "Buceşti h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Buceşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "09:09",
				"arrivesAt": "09:13",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Iveşti Hm.",
				"to": "Umbrăreşti h.",
				"leavesAt": "09:14",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Barcea",
				"leavesAt": "09:20",
				"arrivesAt": "09:26",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Barcea",
				"to": "Malul Alb h.",
				"leavesAt": "09:27",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Malul Alb h.",
				"to": "Tecuci",
				"leavesAt": "09:31",
				"arrivesAt": "09:41",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "09:44",
				"arrivesAt": "09:51",
				"waitsAtSource": 180,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "09:52",
				"arrivesAt": "09:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "09:58",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2074",
		"segments": [
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:04",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "06:16",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "06:22",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "06:39",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "06:45",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:57",
				"waitsAtSource": 420,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "07:03",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "07:06",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "07:11",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "07:23",
				"arrivesAt": "07:30",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Băbeni",
				"to": "Slăviteşti hc.",
				"leavesAt": "07:31",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Ioneşti Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Fişcălia Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "07:55",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Orleşti hc.",
				"to": "Zăvideni Hm.",
				"leavesAt": "07:59",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Călina h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Călina h.",
				"to": "Drăgăşani",
				"leavesAt": "08:10",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Drăgăşani",
				"to": "Zlătărei Hm.",
				"leavesAt": "08:19",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Strejeşti",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Strejeşti",
				"to": "Arceşti Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 11600
			},
			{
				"from": "Arceşti Hm.",
				"to": "Găneasa h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găneasa h.",
				"to": "Piatra Olt",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5306",
		"segments": [
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "12:52",
				"arrivesAt": "13:00",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "13:01",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "13:04",
				"arrivesAt": "13:09",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "13:15",
				"arrivesAt": "13:20",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "13:21",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "13:24",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Trotuş h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:32",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Trotuş h.",
				"to": "Oneşti",
				"leavesAt": "13:33",
				"arrivesAt": "13:42",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:13",
				"waitsAtSource": 1680,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "14:14",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:28",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "14:29",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:38",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:43",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "14:44",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:10",
				"waitsAtSource": 420,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "15:27",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1633",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "15:10",
				"arrivesAt": "15:47",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "15:48",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "16:11",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "16:34",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Predeal",
				"leavesAt": "16:42",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 11400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "16:57",
				"arrivesAt": "17:35",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9507",
		"segments": [
			{
				"from": "Filiaşi",
				"to": "Gura Motrului Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:40",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Butoieşti Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Lunca Banului h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lunca Banului h.",
				"to": "Strehaia",
				"leavesAt": "17:56",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Strehaia",
				"to": "Strehaia hc.",
				"leavesAt": "18:03",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia hc.",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "18:08",
				"arrivesAt": "18:16",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Tâmna",
				"leavesAt": "18:20",
				"arrivesAt": "18:29",
				"waitsAtSource": 240,
				"distance": 7000
			},
			{
				"from": "Tâmna",
				"to": "Igiroasa Hm.",
				"leavesAt": "18:30",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "18:43",
				"arrivesAt": "18:50",
				"waitsAtSource": 360,
				"distance": 4800
			},
			{
				"from": "Prunişor Hm.",
				"to": "Gârniţa Hm.",
				"leavesAt": "18:51",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Balota",
				"leavesAt": "18:59",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Balota",
				"to": "Valea Albă Hm.",
				"leavesAt": "19:04",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Ergheviţa h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ergheviţa h.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "19:22",
				"arrivesAt": "19:32",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "19:33",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "19:40",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5424",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "14:40",
				"arrivesAt": "14:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "14:55",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "15:03",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "15:18",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "15:35",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "15:50",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:35",
				"waitsAtSource": 1440,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "16:42",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "16:53",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "17:05",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "17:26",
				"arrivesAt": "17:33",
				"waitsAtSource": 720,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "17:34",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "17:39",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "18:00",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2516",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "23:35",
				"arrivesAt": "23:38",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "23:39",
				"arrivesAt": "23:41",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Mohu h.",
				"leavesAt": "23:42",
				"arrivesAt": "23:48",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "23:49",
				"arrivesAt": "23:52",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "23:53",
				"arrivesAt": "00:02",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "00:03",
				"arrivesAt": "00:10",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Sebeş Olt h.",
				"leavesAt": "00:11",
				"arrivesAt": "00:14",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Racoviţa h.",
				"leavesAt": "00:15",
				"arrivesAt": "00:18",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Racoviţa h.",
				"to": "Mârşa h.",
				"leavesAt": "00:19",
				"arrivesAt": "00:22",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Mârşa h.",
				"to": "Avrig Hm.",
				"leavesAt": "00:23",
				"arrivesAt": "00:28",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "00:29",
				"arrivesAt": "00:38",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Sărata Colun h.",
				"leavesAt": "00:39",
				"arrivesAt": "00:43",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sărata Colun h.",
				"to": "Scoreiu h.",
				"leavesAt": "00:44",
				"arrivesAt": "00:47",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Scoreiu h.",
				"to": "Cârţa h.",
				"leavesAt": "00:48",
				"arrivesAt": "00:53",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârţa h.",
				"to": "Arpaş Hm.",
				"leavesAt": "00:54",
				"arrivesAt": "00:58",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Arpaş Hm.",
				"to": "Ucea",
				"leavesAt": "00:59",
				"arrivesAt": "01:06",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9004",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "07:00",
				"arrivesAt": "07:08",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "07:09",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "07:23",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "07:33",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "07:49",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:05",
				"waitsAtSource": 120,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Grădinari",
				"leavesAt": "08:20",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:43",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "08:44",
				"arrivesAt": "09:00",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "09:09",
				"arrivesAt": "09:12",
				"waitsAtSource": 540,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Bucureşti Basarab",
				"leavesAt": "09:13",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 448
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5735",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "08:28",
				"arrivesAt": "08:33",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "08:34",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Părhăuţi h.",
				"leavesAt": "08:49",
				"arrivesAt": "08:56",
				"waitsAtSource": 360,
				"distance": 4400
			},
			{
				"from": "Părhăuţi h.",
				"to": "Todireşti h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Todireşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Soloneţ h.",
				"to": "Pârteşti h.",
				"leavesAt": "09:14",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pârteşti h.",
				"to": "Cacica Hm.",
				"leavesAt": "09:21",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1932",
		"segments": [
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "19:12",
				"arrivesAt": "19:46",
				"waitsAtSource": 0,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Bratca",
				"leavesAt": "19:47",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 25300
			},
			{
				"from": "Bratca",
				"to": "Ciucea Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "20:38",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "21:00",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "21:25",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 27900
			},
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "22:09",
				"arrivesAt": "23:16",
				"waitsAtSource": 960,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "23:17",
				"arrivesAt": "23:33",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Aiud Hm.",
				"leavesAt": "23:34",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "23:57",
				"arrivesAt": "00:11",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Blaj",
				"leavesAt": "00:15",
				"arrivesAt": "00:46",
				"waitsAtSource": 240,
				"distance": 21300
			},
			{
				"from": "Blaj",
				"to": "Copşa Mică",
				"leavesAt": "00:48",
				"arrivesAt": "01:27",
				"waitsAtSource": 120,
				"distance": 30000
			},
			{
				"from": "Copşa Mică",
				"to": "Mediaş",
				"leavesAt": "01:33",
				"arrivesAt": "01:47",
				"waitsAtSource": 360,
				"distance": 10400
			},
			{
				"from": "Mediaş",
				"to": "Dumbrăveni",
				"leavesAt": "01:48",
				"arrivesAt": "02:14",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Dumbrăveni",
				"to": "Sighişoara",
				"leavesAt": "02:15",
				"arrivesAt": "02:42",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Sighişoara",
				"to": "Rupea",
				"leavesAt": "02:46",
				"arrivesAt": "03:49",
				"waitsAtSource": 240,
				"distance": 53600
			},
			{
				"from": "Rupea",
				"to": "Braşov",
				"leavesAt": "03:50",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 73800
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "05:45",
				"arrivesAt": "06:23",
				"waitsAtSource": 840,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "06:31",
				"arrivesAt": "06:40",
				"waitsAtSource": 480,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "06:41",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "06:48",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "06:59",
				"arrivesAt": "07:13",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Câmpina",
				"leavesAt": "07:14",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "07:26",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Băneasa",
				"leavesAt": "07:52",
				"arrivesAt": "08:38",
				"waitsAtSource": 120,
				"distance": 58100
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Feteşti",
				"leavesAt": "08:41",
				"arrivesAt": "09:53",
				"waitsAtSource": 180,
				"distance": 139800
			},
			{
				"from": "Feteşti",
				"to": "Medgidia",
				"leavesAt": "09:54",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 44000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "10:29",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "11:25",
				"arrivesAt": "11:48",
				"waitsAtSource": 1440,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "11:50",
				"arrivesAt": "11:57",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:16",
				"waitsAtSource": 600,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "12:17",
				"arrivesAt": "12:25",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "12:27",
				"arrivesAt": "12:31",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "12:33",
				"arrivesAt": "12:46",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "13:01",
				"arrivesAt": "13:08",
				"waitsAtSource": 480,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8021",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:39",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "06:40",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "06:46",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "06:57",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 480,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "07:36",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ciulniţa",
				"leavesAt": "08:22",
				"arrivesAt": "08:31",
				"waitsAtSource": 600,
				"distance": 13100
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "08:43",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "08:47",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "09:02",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "09:12",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Ovidiu",
				"leavesAt": "09:19",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ovidiu",
				"to": "Dunărea Hm.",
				"leavesAt": "09:24",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Dunărea Hm.",
				"to": "Cernavodă Pod",
				"leavesAt": "09:37",
				"arrivesAt": "09:46",
				"waitsAtSource": 420,
				"distance": 4800
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "09:47",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "09:56",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "10:02",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:15",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "10:16",
				"arrivesAt": "10:19",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "10:25",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "10:30",
				"arrivesAt": "10:33",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "10:34",
				"arrivesAt": "10:38",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "10:53",
				"arrivesAt": "10:58",
				"waitsAtSource": 900,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "10:59",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4521",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "10:36",
				"arrivesAt": "10:45",
				"waitsAtSource": 0,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1635",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "17:15",
				"arrivesAt": "17:50",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "17:52",
				"arrivesAt": "18:01",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "18:02",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "18:09",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "18:20",
				"arrivesAt": "18:44",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "18:45",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "19:11",
				"arrivesAt": "19:53",
				"waitsAtSource": 120,
				"distance": 58900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Lehliu",
				"leavesAt": "20:15",
				"arrivesAt": "20:54",
				"waitsAtSource": 1320,
				"distance": 69600
			},
			{
				"from": "Lehliu",
				"to": "Ciulniţa",
				"leavesAt": "20:55",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "21:14",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "21:38",
				"arrivesAt": "21:56",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "21:57",
				"arrivesAt": "22:13",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "22:14",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1858",
		"segments": [
			{
				"from": "Piatra Neamţ",
				"to": "Roznov",
				"leavesAt": "09:10",
				"arrivesAt": "09:26",
				"waitsAtSource": 0,
				"distance": 15200
			},
			{
				"from": "Roznov",
				"to": "Podoleni Hm.",
				"leavesAt": "09:27",
				"arrivesAt": "09:39",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Podoleni Hm.",
				"to": "Buhuşi",
				"leavesAt": "09:40",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Buhuşi",
				"to": "Bacău",
				"leavesAt": "09:55",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 23600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3550",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "19:57",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Săcuienii Noi h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Săcuienii Noi h.",
				"to": "Sântămaria h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Sântămaria h.",
				"to": "Cristur Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cristur Hm.",
				"to": "Beteşti h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:32",
				"waitsAtSource": 420,
				"distance": 1300
			},
			{
				"from": "Beteşti h.",
				"to": "Beteşti Est h.",
				"leavesAt": "20:33",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Beteşti Est h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "20:37",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Lutiţa h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Lutiţa h.",
				"to": "Dobeni h.",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Feliceni h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Feliceni h.",
				"to": "Odorhei Sud hc.",
				"leavesAt": "21:06",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Odorhei",
				"leavesAt": "21:16",
				"arrivesAt": "21:20",
				"waitsAtSource": 120,
				"distance": 1200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2860",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "08:10",
				"arrivesAt": "08:17",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Drăguţeşti h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Vârţ h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 420,
				"distance": 4100
			},
			{
				"from": "Vârţ h.",
				"to": "Rogojelu",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "08:44",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Rovinari Hm.",
				"to": "Rovinari Sud h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "08:54",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Bâlteni h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Bâlteni h.",
				"to": "Peşteana Jiu h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Plopşoru",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Plopşoru",
				"to": "Sărdăneşti h.",
				"leavesAt": "09:19",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Gârbovu h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Gârbovu h.",
				"to": "Turceni",
				"leavesAt": "09:29",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Turceni",
				"to": "Termo Turceni h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 900
			},
			{
				"from": "Termo Turceni h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Filiaşi",
				"leavesAt": "09:49",
				"arrivesAt": "10:04",
				"waitsAtSource": 30,
				"distance": 12400
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "10:22",
				"arrivesAt": "10:25",
				"waitsAtSource": 1080,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "10:26",
				"arrivesAt": "10:30",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:35",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "10:36",
				"arrivesAt": "10:41",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "10:42",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "10:46",
				"arrivesAt": "10:51",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "10:52",
				"arrivesAt": "10:54",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "10:55",
				"arrivesAt": "10:59",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "11:00",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "11:04",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 319
			},
			{
				"from": "20180331",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 319
			},
			{
				"from": "20171223",
				"to": "20171223",
				"daysOfWeek": 319
			},
			{
				"from": "20171225",
				"to": "20180114",
				"daysOfWeek": 319
			},
			{
				"from": "18991230",
				"to": "20180618",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3501",
		"segments": [
			{
				"from": "Braşov",
				"to": "Stupini Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:19",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Stupini Hm.",
				"to": "Bod Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Bod Hm.",
				"to": "Feldioara Hm.",
				"leavesAt": "06:29",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Rotbav h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Rotbav h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Măieruş h.",
				"leavesAt": "06:49",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Măieruş h.",
				"to": "Apaţa",
				"leavesAt": "06:53",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Apaţa",
				"to": "Ormeniş h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ormeniş h.",
				"to": "Augustin Hm.",
				"leavesAt": "07:13",
				"arrivesAt": "07:26",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Augustin Hm.",
				"to": "Racoş Hm.",
				"leavesAt": "07:27",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Racoş Hm.",
				"to": "Mateiaş h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mateiaş h.",
				"to": "Rupea",
				"leavesAt": "07:49",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Rupea",
				"to": "Caţa Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Caţa Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Beia Hm.",
				"leavesAt": "08:19",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Beia Hm.",
				"to": "Archita h",
				"leavesAt": "08:31",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Archita h",
				"to": "Mureni Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "08:57",
				"waitsAtSource": 30,
				"distance": 9600
			},
			{
				"from": "Mureni Hm.",
				"to": "Saschiz h.",
				"leavesAt": "08:58",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Vânători",
				"leavesAt": "09:03",
				"arrivesAt": "09:07",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "09:16",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sighişoara",
				"to": "Daneş Hm.",
				"leavesAt": "09:36",
				"arrivesAt": "09:52",
				"waitsAtSource": 660,
				"distance": 9500
			},
			{
				"from": "Daneş Hm.",
				"to": "Luna h.",
				"leavesAt": "09:53",
				"arrivesAt": "10:00",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Luna h.",
				"to": "Dumbrăveni",
				"leavesAt": "10:01",
				"arrivesAt": "10:08",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dumbrăveni",
				"to": "Aţel Hm.",
				"leavesAt": "10:09",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Aţel Hm.",
				"to": "Bratei h.",
				"leavesAt": "10:19",
				"arrivesAt": "10:28",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Bratei h.",
				"to": "Mediaş",
				"leavesAt": "10:29",
				"arrivesAt": "10:38",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4583",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "13:44",
				"arrivesAt": "13:48",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "13:49",
				"arrivesAt": "13:54",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:03",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "14:09",
				"arrivesAt": "14:13",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "14:14",
				"arrivesAt": "14:21",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180212",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180608",
				"daysOfWeek": 799
			},
			{
				"from": "20180611",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180811",
				"to": "20180811",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1970",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "05:30",
				"arrivesAt": "05:49",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "05:50",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "06:10",
				"arrivesAt": "06:40",
				"waitsAtSource": 180,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Ţăndărei",
				"leavesAt": "06:41",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 72100
			},
			{
				"from": "Ţăndărei",
				"to": "Movila Hm.",
				"leavesAt": "07:35",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "07:49",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "08:20",
				"arrivesAt": "08:38",
				"waitsAtSource": 840,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "08:39",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "08:57",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3530",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "04:20",
				"arrivesAt": "04:27",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "04:28",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Saschiz h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Mureni Hm.",
				"leavesAt": "04:41",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mureni Hm.",
				"to": "Archita h",
				"leavesAt": "04:47",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Archita h",
				"to": "Beia Hm.",
				"leavesAt": "05:01",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2412",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu",
				"leavesAt": "01:52",
				"arrivesAt": "02:00",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Coşlariu",
				"to": "Sântimbru h.",
				"leavesAt": "02:01",
				"arrivesAt": "02:11",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântimbru h.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "02:12",
				"arrivesAt": "02:16",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "02:20",
				"arrivesAt": "02:27",
				"waitsAtSource": 240,
				"distance": 4800
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "02:33",
				"arrivesAt": "02:42",
				"waitsAtSource": 360,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "02:45",
				"arrivesAt": "02:57",
				"waitsAtSource": 180,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Sebeş Glod h.",
				"leavesAt": "03:25",
				"arrivesAt": "03:32",
				"waitsAtSource": 1680,
				"distance": 6500
			},
			{
				"from": "Sebeş Glod h.",
				"to": "Sebeş Alba",
				"leavesAt": "03:33",
				"arrivesAt": "03:37",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sebeş Alba",
				"to": "Rahău h.",
				"leavesAt": "03:38",
				"arrivesAt": "03:46",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Rahău h.",
				"to": "Cut h.",
				"leavesAt": "03:47",
				"arrivesAt": "03:51",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cut h.",
				"to": "Cunţa Hm.",
				"leavesAt": "03:52",
				"arrivesAt": "03:59",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cunţa Hm.",
				"to": "Băile Miercurea h.",
				"leavesAt": "04:00",
				"arrivesAt": "04:03",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băile Miercurea h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "04:04",
				"arrivesAt": "04:13",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "04:14",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "04:19",
				"arrivesAt": "04:28",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Tilişca h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:45",
				"waitsAtSource": 300,
				"distance": 7800
			},
			{
				"from": "Tilişca h.",
				"to": "Aciliu h.",
				"leavesAt": "04:46",
				"arrivesAt": "04:51",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Aciliu h.",
				"to": "Sălişte Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "04:56",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Sălişte Hm.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sibiel h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:06",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sibiel h.",
				"to": "Orlat",
				"leavesAt": "05:07",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Orlat",
				"to": "Cristian Sibiu h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Turnişor Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:34",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Sibiu h.(210)",
				"leavesAt": "05:35",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Sibiu",
				"leavesAt": "05:39",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9121",
		"segments": [
			{
				"from": "Goleşti",
				"to": "Ştefăneşti Argeş Hm.",
				"leavesAt": "11:35",
				"arrivesAt": "11:45",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Ştefăneşti Argeş Hm.",
				"to": "Gropeni h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:50",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gropeni h.",
				"to": "Ciumeşti",
				"leavesAt": "11:51",
				"arrivesAt": "11:57",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Ciumeşti",
				"to": "Clucereasa h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Clucereasa h.",
				"to": "Stâlpeni Hm.",
				"leavesAt": "12:10",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Stâlpeni Hm.",
				"to": "Drăghici h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:31",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Drăghici h.",
				"to": "Lăzăreşti Hm.",
				"leavesAt": "12:32",
				"arrivesAt": "12:39",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Lăzăreşti Hm.",
				"to": "Schitu Goleşti",
				"leavesAt": "12:40",
				"arrivesAt": "12:48",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Schitu Goleşti",
				"to": "Câmpulung",
				"leavesAt": "12:49",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Câmpulung",
				"to": "Parcul Kreţulescu h.",
				"leavesAt": "13:02",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2595",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "14:21",
				"arrivesAt": "14:25",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "14:26",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Veşeud h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Veşeud h.",
				"to": "Şeica Mare h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "15:15",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "15:19",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "15:32",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180203",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "18991230",
				"to": "20180717",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3542",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "03:52",
				"arrivesAt": "03:59",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "04:00",
				"arrivesAt": "04:07",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Săcuienii Noi h.",
				"leavesAt": "04:08",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Săcuienii Noi h.",
				"to": "Sântămaria h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:20",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Sântămaria h.",
				"to": "Cristur Hm.",
				"leavesAt": "04:21",
				"arrivesAt": "04:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cristur Hm.",
				"to": "Beteşti h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:35",
				"waitsAtSource": 420,
				"distance": 1300
			},
			{
				"from": "Beteşti h.",
				"to": "Beteşti Est h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Beteşti Est h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "04:40",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "04:46",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Lutiţa h.",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Lutiţa h.",
				"to": "Dobeni h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Feliceni h.",
				"leavesAt": "05:04",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Feliceni h.",
				"to": "Odorhei Sud hc.",
				"leavesAt": "05:09",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Odorhei",
				"leavesAt": "05:19",
				"arrivesAt": "05:23",
				"waitsAtSource": 120,
				"distance": 1200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1929",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "14:00",
				"arrivesAt": "14:24",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "14:25",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "14:43",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "15:04",
				"arrivesAt": "15:27",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "15:28",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 108900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "16:43",
				"arrivesAt": "16:58",
				"waitsAtSource": 1140,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Crivina",
				"leavesAt": "16:59",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Crivina",
				"to": "Ploieşti Vest",
				"leavesAt": "17:16",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 19200
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "17:33",
				"arrivesAt": "17:56",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "17:57",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Comarnic",
				"leavesAt": "18:02",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "18:10",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "18:24",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "18:32",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "18:38",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "18:48",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 720,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "19:59",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "20:09",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "20:40",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "20:53",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "21:01",
				"arrivesAt": "21:07",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Făgăraş",
				"to": "Ucea",
				"leavesAt": "21:08",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Ucea",
				"to": "Porumbacu Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:55",
				"waitsAtSource": 300,
				"distance": 18700
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 15400
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "22:23",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5411",
		"segments": [
			{
				"from": "Adjud",
				"to": "Adjudu Vechi h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:21",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Şişcani h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Şişcani h.",
				"to": "Sascut Hm.",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sascut Hm.",
				"to": "Orbeni Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Orbeni Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Răcăciuni h.",
				"to": "Faraoani Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Faraoani Hm.",
				"to": "Siretu Bacău h.",
				"leavesAt": "08:58",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Valea Seacă",
				"leavesAt": "09:04",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Valea Seacă",
				"to": "Letea h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Letea h.",
				"to": "Bacău",
				"leavesAt": "09:17",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2188",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Lugoj Nord h.",
				"leavesAt": "19:50",
				"arrivesAt": "19:54",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lugoj Nord h.",
				"to": "Coşteiu Mare Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Coşteiu Mare Hm.",
				"to": "Păru h.",
				"leavesAt": "20:01",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Păru h.",
				"to": "Balinţ h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:08",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Balinţ h.",
				"to": "Nevrincea h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Nevrincea h.",
				"to": "Cliciova",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Cliciova",
				"to": "Susani Bega h.",
				"leavesAt": "20:18",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Susani Bega h.",
				"to": "Traian Vuia h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Răchita h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Răchita h.",
				"to": "Făget",
				"leavesAt": "20:35",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "20:41",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4415",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "06:34",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1586",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "17:00",
				"arrivesAt": "17:24",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "17:25",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "17:43",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "18:04",
				"arrivesAt": "18:27",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "18:28",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 108900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9138",
		"segments": [
			{
				"from": "Băileşti",
				"to": "Boureni P.M.",
				"leavesAt": "16:45",
				"arrivesAt": "16:57",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Boureni P.M.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Afumaţi h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Afumaţi h.",
				"to": "Urzica Mare h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Urzica Mare h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Cerăt h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cerăt h.",
				"to": "Segarcea",
				"leavesAt": "17:42",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Segarcea",
				"to": "Segarcea Nord hc.",
				"leavesAt": "17:57",
				"arrivesAt": "17:59",
				"waitsAtSource": 540,
				"distance": 1100
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Dealul Robului h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dealul Robului h.",
				"to": "Sălcuţa Hm.",
				"leavesAt": "18:07",
				"arrivesAt": "18:13",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Podari",
				"leavesAt": "18:14",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Podari",
				"to": "R. 1 Jiu",
				"leavesAt": "18:30",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "R. 1 Jiu",
				"to": "Jiu Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:41",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Jiu Hm.",
				"to": "Bordei hc.(913)",
				"leavesAt": "18:42",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Craiova",
				"leavesAt": "18:46",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9617",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Boldur h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:06",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Boldur h.",
				"to": "Sinia Hm.",
				"leavesAt": "16:07",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sinia Hm.",
				"to": "Căpăt h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Căpăt h.",
				"to": "Buziaş",
				"leavesAt": "16:21",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Buziaş",
				"to": "Bacova h.",
				"leavesAt": "16:43",
				"arrivesAt": "16:46",
				"waitsAtSource": 600,
				"distance": 2300
			},
			{
				"from": "Bacova h.",
				"to": "Chevereş h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Chevereş h.",
				"to": "Sacoşu Mic",
				"leavesAt": "16:53",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Sacoşu Mic",
				"to": "Uliuc h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:17",
				"waitsAtSource": 720,
				"distance": 5000
			},
			{
				"from": "Uliuc h.",
				"to": "Urseni h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Urseni h.",
				"to": "Semenic Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Semenic Hm.",
				"to": "Giroc h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Giroc h.",
				"to": "Timişoara Sud",
				"leavesAt": "17:34",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "17:45",
				"arrivesAt": "17:54",
				"waitsAtSource": 300,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1880",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Nucet",
				"leavesAt": "05:22",
				"arrivesAt": "05:34",
				"waitsAtSource": 0,
				"distance": 16300
			},
			{
				"from": "Nucet",
				"to": "Titu",
				"leavesAt": "05:35",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 15400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1852",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Târgu Frumos",
				"leavesAt": "19:10",
				"arrivesAt": "19:46",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Târgu Frumos",
				"to": "Roman",
				"leavesAt": "19:47",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 69200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "20:42",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 43800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9450",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:06",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "21:07",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "21:27",
				"arrivesAt": "21:32",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti",
				"leavesAt": "21:33",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Doiceşti",
				"to": "Săteni h.",
				"leavesAt": "21:38",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Săteni h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "21:42",
				"arrivesAt": "21:46",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "21:47",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "21:50",
				"arrivesAt": "21:54",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9585",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Săcălaz h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:15",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Săcălaz h.",
				"to": "Beregsău hcv.",
				"leavesAt": "07:16",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Beregsău hcv.",
				"to": "Cărpiniş",
				"leavesAt": "07:24",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Cărpiniş",
				"to": "Clarii Vii h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Clarii Vii h.",
				"to": "Jimbolia",
				"leavesAt": "07:40",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5533",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "19:34",
				"arrivesAt": "19:39",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "19:40",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "19:49",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Sfântu Mina h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:06",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Târgu Neamţ",
				"leavesAt": "20:07",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3503",
		"segments": [
			{
				"from": "Braşov",
				"to": "Stupini Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:39",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Stupini Hm.",
				"to": "Bod Hm.",
				"leavesAt": "14:40",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Bod Hm.",
				"to": "Feldioara Hm.",
				"leavesAt": "14:49",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Rotbav h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Rotbav h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Măieruş h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:12",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Măieruş h.",
				"to": "Apaţa",
				"leavesAt": "15:13",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Apaţa",
				"to": "Ormeniş h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ormeniş h.",
				"to": "Augustin Hm.",
				"leavesAt": "15:33",
				"arrivesAt": "15:46",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Augustin Hm.",
				"to": "Racoş Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Racoş Hm.",
				"to": "Mateiaş h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mateiaş h.",
				"to": "Rupea",
				"leavesAt": "16:09",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Rupea",
				"to": "Caţa Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Caţa Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Beia Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:50",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Beia Hm.",
				"to": "Archita h",
				"leavesAt": "16:51",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Archita h",
				"to": "Mureni Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 9600
			},
			{
				"from": "Mureni Hm.",
				"to": "Saschiz h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:36",
				"waitsAtSource": 780,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Vânători",
				"leavesAt": "17:37",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "17:50",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sighişoara",
				"to": "Daneş Hm.",
				"leavesAt": "18:22",
				"arrivesAt": "18:38",
				"waitsAtSource": 1380,
				"distance": 9500
			},
			{
				"from": "Daneş Hm.",
				"to": "Luna h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Luna h.",
				"to": "Dumbrăveni",
				"leavesAt": "18:47",
				"arrivesAt": "18:54",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dumbrăveni",
				"to": "Aţel Hm.",
				"leavesAt": "18:55",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Aţel Hm.",
				"to": "Bratei h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:14",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Bratei h.",
				"to": "Mediaş",
				"leavesAt": "19:15",
				"arrivesAt": "19:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "19:29",
				"arrivesAt": "19:37",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "19:38",
				"arrivesAt": "19:45",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Micăsasa h.",
				"leavesAt": "19:49",
				"arrivesAt": "20:06",
				"waitsAtSource": 240,
				"distance": 10200
			},
			{
				"from": "Micăsasa h.",
				"to": "Lunca h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lunca h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:21",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Glogoveţ h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Glogoveţ h.",
				"to": "Mănărade h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Mănărade h.",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Blaj",
				"leavesAt": "20:36",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Blaj",
				"to": "Crăciunel Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:51",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Cistei h.",
				"leavesAt": "20:52",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cistei h.",
				"to": "Mihalţ h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:07",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mihalţ h.",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "21:08",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Teiuş",
				"leavesAt": "21:13",
				"arrivesAt": "21:20",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5527",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:30",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "14:31",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "14:40",
				"arrivesAt": "14:47",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Sfântu Mina h.",
				"leavesAt": "14:54",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Târgu Neamţ",
				"leavesAt": "14:58",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 863
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4073",
		"segments": [
			{
				"from": "Sărmăşag",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:28",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "15:29",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Borla Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:39",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Borla Hm.",
				"to": "Guruslău h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Guruslău h.",
				"to": "Zalău Nord",
				"leavesAt": "15:46",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "16:25",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5445",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "10:29",
				"arrivesAt": "10:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "10:41",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "10:46",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "10:52",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "11:02",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "11:07",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "11:16",
				"arrivesAt": "11:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "11:24",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "11:31",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "11:36",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "11:42",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "11:52",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:12",
				"waitsAtSource": 300,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "12:13",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "12:24",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "12:30",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:54",
				"waitsAtSource": 780,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "12:55",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "13:02",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "13:09",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "13:21",
				"arrivesAt": "13:29",
				"waitsAtSource": 360,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "13:30",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "13:41",
				"arrivesAt": "13:47",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1961",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "20:35",
				"arrivesAt": "20:42",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:51",
				"arrivesAt": "21:04",
				"waitsAtSource": 180,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "21:07",
				"arrivesAt": "21:11",
				"waitsAtSource": 180,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:21",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "21:22",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "21:34",
				"arrivesAt": "21:41",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "21:43",
				"arrivesAt": "22:06",
				"waitsAtSource": 120,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "22:40",
				"arrivesAt": "23:05",
				"waitsAtSource": 2040,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "23:06",
				"arrivesAt": "23:24",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "23:25",
				"arrivesAt": "23:44",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Movila Hm.",
				"leavesAt": "23:54",
				"arrivesAt": "00:10",
				"waitsAtSource": 600,
				"distance": 16700
			},
			{
				"from": "Movila Hm.",
				"to": "Ţăndărei",
				"leavesAt": "00:11",
				"arrivesAt": "00:25",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Ţăndărei",
				"to": "Ianca hc.",
				"leavesAt": "00:26",
				"arrivesAt": "01:36",
				"waitsAtSource": 60,
				"distance": 72100
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "01:37",
				"arrivesAt": "02:09",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "02:10",
				"arrivesAt": "02:29",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Lieşti",
				"leavesAt": "02:49",
				"arrivesAt": "03:38",
				"waitsAtSource": 1200,
				"distance": 48300
			},
			{
				"from": "Lieşti",
				"to": "Tecuci",
				"leavesAt": "03:39",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 24400
			},
			{
				"from": "Tecuci",
				"to": "Bârlad",
				"leavesAt": "04:10",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 50300
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "04:55",
				"arrivesAt": "05:24",
				"waitsAtSource": 120,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "05:25",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "05:41",
				"arrivesAt": "05:59",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "06:27",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "06:44",
				"arrivesAt": "06:51",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9030",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Ram. Goleşti",
				"leavesAt": "20:00",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Ram. Goleşti",
				"to": "Goleşti",
				"leavesAt": "20:05",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Goleşti",
				"to": "Canton 97+770 h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:21",
				"waitsAtSource": 300,
				"distance": 2600
			},
			{
				"from": "Canton 97+770 h.",
				"to": "Călineşti Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Călineşti Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "20:29",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Pătroaia Hm.",
				"leavesAt": "20:36",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Găeşti",
				"leavesAt": "20:44",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Găeşti",
				"to": "Cojocaru h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Cojocaru h.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Fusea Hm.",
				"leavesAt": "21:07",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Fusea Hm.",
				"to": "Titu",
				"leavesAt": "21:14",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:30",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "21:31",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "21:41",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "21:48",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "22:05",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "22:13",
				"arrivesAt": "22:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Basarab",
				"leavesAt": "22:19",
				"arrivesAt": "22:27",
				"waitsAtSource": 30,
				"distance": 4700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9574",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "08:34",
				"arrivesAt": "08:40",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Ghiroda h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghiroda h.",
				"to": "Remetea Mare",
				"leavesAt": "08:47",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Remetea Mare",
				"to": "Izvin h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Izvin h.",
				"to": "Recaş",
				"leavesAt": "09:05",
				"arrivesAt": "09:08",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Recaş",
				"to": "Şuştra h.",
				"leavesAt": "09:09",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Şuştra h.",
				"to": "Topolovăţ",
				"leavesAt": "09:17",
				"arrivesAt": "09:21",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Topolovăţ",
				"to": "Chizătău Hm.",
				"leavesAt": "09:26",
				"arrivesAt": "09:34",
				"waitsAtSource": 300,
				"distance": 7200
			},
			{
				"from": "Chizătău Hm.",
				"to": "Belinţ Hm.",
				"leavesAt": "09:35",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Belinţ Hm.",
				"to": "Jabăr Hm.",
				"leavesAt": "09:41",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Jabăr Hm.",
				"to": "Lugoj",
				"leavesAt": "09:48",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lugoj",
				"to": "Tapia Hm.",
				"leavesAt": "09:57",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Tapia Hm.",
				"to": "Găvojdia",
				"leavesAt": "10:05",
				"arrivesAt": "10:11",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Găvojdia",
				"to": "Jena Hm.",
				"leavesAt": "10:12",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Jena Hm.",
				"to": "Sacu h.",
				"leavesAt": "10:25",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sacu h.",
				"to": "Căvăran",
				"leavesAt": "10:30",
				"arrivesAt": "10:34",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Căvăran",
				"to": "Zăgujeni Hm.",
				"leavesAt": "10:35",
				"arrivesAt": "10:47",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Zăgujeni Hm.",
				"to": "Tibiscu h.",
				"leavesAt": "10:48",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Tibiscu h.",
				"to": "Caransebeş",
				"leavesAt": "10:53",
				"arrivesAt": "10:58",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 264
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2592",
		"segments": [
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "11:05",
				"arrivesAt": "11:08",
				"waitsAtSource": 0,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "11:09",
				"arrivesAt": "11:17",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "11:18",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "11:26",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "11:36",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3746",
		"segments": [
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "14:17",
				"arrivesAt": "14:23",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "14:24",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "14:33",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Utvinişu Nou",
				"leavesAt": "15:03",
				"arrivesAt": "15:07",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "15:08",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1062",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "13:10",
				"arrivesAt": "13:17",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "13:18",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Holboca Hm.",
				"leavesAt": "13:24",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "13:34",
				"arrivesAt": "13:42",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "13:43",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ungheni Prut Hm.",
				"to": "Ungheni Prut Fr.",
				"leavesAt": "14:39",
				"arrivesAt": "14:41",
				"waitsAtSource": 2880,
				"distance": 600
			},
			{
				"from": "Ungheni Prut Fr.",
				"to": "Ungheni",
				"leavesAt": "15:01",
				"arrivesAt": "15:05",
				"waitsAtSource": 1200,
				"distance": 800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5428",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "20:40",
				"arrivesAt": "20:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "21:18",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "21:35",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "21:50",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "22:28",
				"arrivesAt": "22:35",
				"waitsAtSource": 1440,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "22:36",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "22:42",
				"arrivesAt": "22:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "22:47",
				"arrivesAt": "22:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "22:53",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "22:58",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "23:05",
				"arrivesAt": "23:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "23:16",
				"arrivesAt": "23:23",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "23:24",
				"arrivesAt": "23:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "23:29",
				"arrivesAt": "23:37",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "23:38",
				"arrivesAt": "23:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "23:44",
				"arrivesAt": "23:49",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "23:50",
				"arrivesAt": "00:02",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4406",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:46",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "13:47",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "13:55",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "14:04",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4585",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "17:45",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "17:58",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "18:07",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "18:13",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1592",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "03:00",
				"arrivesAt": "03:03",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "03:04",
				"arrivesAt": "03:19",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Caracal",
				"leavesAt": "03:20",
				"arrivesAt": "03:49",
				"waitsAtSource": 60,
				"distance": 40100
			},
			{
				"from": "Caracal",
				"to": "Stoeneşti h.",
				"leavesAt": "03:50",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Stoeneşti h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "04:01",
				"arrivesAt": "04:11",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Radomireşti Hm.",
				"leavesAt": "04:12",
				"arrivesAt": "04:23",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "04:24",
				"arrivesAt": "04:32",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "04:33",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 17300
			},
			{
				"from": "Roşiori Nord",
				"to": "Vârtoapele hc.",
				"leavesAt": "04:50",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "05:10",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:33",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Videle",
				"leavesAt": "05:34",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 15800
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "05:48",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureştii Noi",
				"leavesAt": "06:14",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 19700
			},
			{
				"from": "Bucureştii Noi",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:43",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Nord",
				"leavesAt": "06:44",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3081",
		"segments": [
			{
				"from": "Războieni",
				"to": "Grindeni h.",
				"leavesAt": "03:50",
				"arrivesAt": "03:54",
				"waitsAtSource": 0,
				"distance": 2800
			},
			{
				"from": "Grindeni h.",
				"to": "Călăraşi Turda Hm.",
				"leavesAt": "03:55",
				"arrivesAt": "04:01",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Călăraşi Turda Hm.",
				"to": "Câmpia Turzii",
				"leavesAt": "04:02",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cânepişti h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:19",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Cânepişti h.",
				"to": "Ploscoş h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:25",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ploscoş h.",
				"to": "Valea Florilor Hm.",
				"leavesAt": "04:26",
				"arrivesAt": "04:31",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Boju",
				"leavesAt": "04:32",
				"arrivesAt": "04:44",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Boju",
				"to": "Tunel Hm.",
				"leavesAt": "04:45",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Tunel Hm.",
				"to": "Cojocna Hm.",
				"leavesAt": "04:53",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cojocna Hm.",
				"to": "Apahida",
				"leavesAt": "05:01",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "05:12",
				"arrivesAt": "05:19",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3646",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Est",
				"leavesAt": "19:30",
				"arrivesAt": "19:35",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Oradea Est",
				"to": "Oradea Est Triaj h.",
				"leavesAt": "19:36",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 700
			},
			{
				"from": "Oradea Est Triaj h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "19:39",
				"arrivesAt": "19:45",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Săcădat h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săcădat h.",
				"to": "Săbolciu h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:54",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbolciu h.",
				"to": "Tileagd",
				"leavesAt": "19:55",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tileagd",
				"to": "Telechiu Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Telechiu Hm.",
				"to": "Ţeţchea hc.",
				"leavesAt": "20:08",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Aleşd",
				"leavesAt": "20:12",
				"arrivesAt": "20:15",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Aleşd",
				"to": "Aleşd h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:33",
				"waitsAtSource": 840,
				"distance": 2600
			},
			{
				"from": "Aleşd h.",
				"to": "Butan h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Butan h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "20:40",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Vadu Crişului h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Peştera h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:56",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Peştera h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "20:57",
				"arrivesAt": "21:01",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bălnaca h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bălnaca h.",
				"to": "Bratca",
				"leavesAt": "21:07",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 2300
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1576",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "14:30",
				"arrivesAt": "14:49",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "14:50",
				"arrivesAt": "15:07",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "15:09",
				"arrivesAt": "15:39",
				"waitsAtSource": 120,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Făurei",
				"leavesAt": "15:40",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "15:58",
				"arrivesAt": "16:37",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "16:39",
				"arrivesAt": "17:11",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "17:12",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "17:51",
				"arrivesAt": "18:43",
				"waitsAtSource": 180,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4313",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:52",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "07:53",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "08:12",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Apa Hm.",
				"to": "Seini",
				"leavesAt": "08:21",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Seini",
				"to": "Săbişa h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Săbişa h.",
				"to": "Ilba h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:47",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ilba h.",
				"to": "Cicârlău h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Cicârlău h.",
				"to": "Buşag Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Buşag Hm.",
				"to": "Baia Mare",
				"leavesAt": "09:04",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20180911",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180609",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1780",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "05:00",
				"arrivesAt": "05:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "05:12",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "05:36",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "06:03",
				"arrivesAt": "06:43",
				"waitsAtSource": 480,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9365",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "10:56",
				"arrivesAt": "11:09",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "11:10",
				"arrivesAt": "11:18",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "11:19",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "11:28",
				"arrivesAt": "11:39",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "11:40",
				"arrivesAt": "11:46",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180506",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9584",
		"segments": [
			{
				"from": "Jimbolia",
				"to": "Clarii Vii h.",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Clarii Vii h.",
				"to": "Cărpiniş",
				"leavesAt": "05:22",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Cărpiniş",
				"to": "Beregsău hcv.",
				"leavesAt": "05:31",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Beregsău hcv.",
				"to": "Săcălaz h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săcălaz h.",
				"to": "Timişoara Nord",
				"leavesAt": "05:47",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3117",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj h",
				"leavesAt": "17:50",
				"arrivesAt": "17:56",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "17:57",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "18:06",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "18:13",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "18:25",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Valea Viilor Hm.",
				"leavesAt": "18:32",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Aradu Nou",
				"leavesAt": "18:38",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "18:49",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "19:11",
				"arrivesAt": "19:21",
				"waitsAtSource": 900,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Utviniş h.",
				"leavesAt": "19:22",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:30",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "19:31",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Comlăuş h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Comlăuş h.",
				"to": "Şimand Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şimand Hm.",
				"to": "Nădab",
				"leavesAt": "19:55",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Nădab",
				"to": "Chişineu Criş",
				"leavesAt": "20:03",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Chişineu Criş",
				"to": "Zerind Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:29",
				"waitsAtSource": 780,
				"distance": 8000
			},
			{
				"from": "Zerind Hm.",
				"to": "Tămaşda h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Tămaşda h.",
				"to": "Boiu Bihor h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:53",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "20:54",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:12",
				"waitsAtSource": 120,
				"distance": 3200
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Cefa Hm.",
				"leavesAt": "21:13",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Cefa Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "21:24",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Oradea Vest Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Oradea",
				"leavesAt": "21:47",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5565",
		"segments": [
			{
				"from": "Botoşani",
				"to": "Leorda Hm.",
				"leavesAt": "19:29",
				"arrivesAt": "19:53",
				"waitsAtSource": 0,
				"distance": 15500
			},
			{
				"from": "Leorda Hm.",
				"to": "Bucecea Hm",
				"leavesAt": "19:54",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bucecea Hm",
				"to": "Bursuceni h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bursuceni h.",
				"to": "Vereşti",
				"leavesAt": "20:30",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "20:43",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "20:51",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "21:02",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5107",
		"segments": [
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:16",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "08:28",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "08:51",
				"arrivesAt": "08:59",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "09:00",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "09:21",
				"arrivesAt": "09:29",
				"waitsAtSource": 720,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "09:30",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "10:04",
				"arrivesAt": "10:16",
				"waitsAtSource": 1320,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "10:17",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8343",
		"segments": [
			{
				"from": "Călăraşi Sud",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:48",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Ştefan Vodă h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Ciulniţa",
				"leavesAt": "05:57",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 12600
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "06:27",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "06:47",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Feteşti",
				"to": "Ramificaţia Borcea",
				"leavesAt": "06:58",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Ovidiu",
				"leavesAt": "07:05",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ovidiu",
				"to": "Dunărea Hm.",
				"leavesAt": "07:10",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Dunărea Hm.",
				"to": "Cernavodă Pod",
				"leavesAt": "07:17",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Cernavodă Pod",
				"to": "Saligny",
				"leavesAt": "07:26",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Saligny",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "07:35",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Medgidia",
				"leavesAt": "07:42",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "08:06",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "08:16",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "08:21",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "08:27",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180917",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9054",
		"segments": [
			{
				"from": "Turnu Măgurele",
				"to": "Km. 231+600 h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:41",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Km. 231+600 h.",
				"to": "Salcia Teleorman Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "18:05",
				"waitsAtSource": 30,
				"distance": 14500
			},
			{
				"from": "Salcia Teleorman Hm.",
				"to": "Troian h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Troian h.",
				"to": "Km. 200+400 P.aj.m",
				"leavesAt": "18:18",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Km. 200+400 P.aj.m",
				"to": "Roşiori Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:35",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "18:36",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2443",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(210)",
				"leavesAt": "15:48",
				"arrivesAt": "15:51",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Turnişor Hm.",
				"leavesAt": "15:52",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Cristian Sibiu h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Orlat",
				"leavesAt": "16:11",
				"arrivesAt": "16:19",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Orlat",
				"to": "Sibiel h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sibiel h.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:28",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sălişte Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sălişte Hm.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 13000
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Băile Miercurea h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Băile Miercurea h.",
				"to": "Cunţa Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cunţa Hm.",
				"to": "Rahău h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Rahău h.",
				"to": "Sebeş Alba",
				"leavesAt": "17:33",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sebeş Alba",
				"to": "Vinţu de Jos",
				"leavesAt": "17:43",
				"arrivesAt": "17:54",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "18:00",
				"arrivesAt": "18:12",
				"waitsAtSource": 360,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:31",
				"waitsAtSource": 120,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "18:36",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "18:49",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "19:01",
				"arrivesAt": "19:13",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Mirăslău h.",
				"leavesAt": "19:14",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mirăslău h.",
				"to": "Decea h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Decea h.",
				"to": "Unirea Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:29",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Unirea Hm.",
				"to": "Unirea hc.",
				"leavesAt": "19:30",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "19:34",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Lunca Mureşului h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:53",
				"waitsAtSource": 480,
				"distance": 3000
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "19:59",
				"arrivesAt": "20:03",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Cheţani h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:08",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Cheţani h.",
				"to": "Luduş",
				"leavesAt": "20:09",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Luduş",
				"to": "Bogata Mureş h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:26",
				"waitsAtSource": 360,
				"distance": 2700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Cuci h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cuci h.",
				"to": "Iernut",
				"leavesAt": "20:34",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Iernut",
				"to": "Cipău h.",
				"leavesAt": "20:41",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Cipău h.",
				"to": "Ogra h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ogra h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "20:50",
				"arrivesAt": "20:54",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Chirileu h.",
				"leavesAt": "20:55",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chirileu h.",
				"to": "Vidrasău h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vidrasău h.",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "21:05",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "21:11",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "Azomureş h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş",
				"leavesAt": "21:20",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8589",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:40",
				"waitsAtSource": 0,
				"distance": 4200
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Brâncoveni h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Brâncoveni h.",
				"to": "Ciulniţa",
				"leavesAt": "05:50",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9449",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:18",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:21",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Aninoasa Hm.",
				"leavesAt": "19:22",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Aninoasa Hm.",
				"to": "Săteni h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Săteni h.",
				"to": "Doiceşti",
				"leavesAt": "19:29",
				"arrivesAt": "19:32",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Doiceşti",
				"to": "Doiceşti h.",
				"leavesAt": "19:33",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Doiceşti h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "19:36",
				"arrivesAt": "19:39",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Scârlenţa h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Scârlenţa h.",
				"to": "Trainica h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Trainica h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:51",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Moţăieni h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Moţăieni h.",
				"to": "Fieni",
				"leavesAt": "19:56",
				"arrivesAt": "20:01",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Pietroşiţa Hm.",
				"leavesAt": "20:06",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1587",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Constanţa",
				"leavesAt": "16:00",
				"arrivesAt": "18:00",
				"waitsAtSource": 0,
				"distance": 225000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2230",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "03:45",
				"arrivesAt": "03:51",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Viile Giarmata h.",
				"leavesAt": "03:52",
				"arrivesAt": "03:58",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Giarmata Hm.",
				"leavesAt": "03:59",
				"arrivesAt": "04:04",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Giarmata Hm.",
				"to": "Cerneteaz h.",
				"leavesAt": "04:05",
				"arrivesAt": "04:07",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Cerneteaz h.",
				"to": "Pişchia h.",
				"leavesAt": "04:08",
				"arrivesAt": "04:16",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Pişchia h.",
				"to": "Bencei h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Bencei h.",
				"to": "Fibiş h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:28",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Remetea Mică",
				"leavesAt": "04:29",
				"arrivesAt": "04:37",
				"waitsAtSource": 30,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5529",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "16:39",
				"arrivesAt": "16:44",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "16:45",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "16:54",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Sfântu Mina h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Târgu Neamţ",
				"leavesAt": "17:12",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8122",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Perieţi h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:13",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Perieţi h.",
				"to": "Fundata h.",
				"leavesAt": "06:14",
				"arrivesAt": "06:19",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Fundata h.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Ciochina hc.",
				"leavesAt": "06:27",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciochina hc.",
				"to": "Căzăneşti",
				"leavesAt": "06:36",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Căzăneşti",
				"to": "Munteni Buzău h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:56",
				"waitsAtSource": 480,
				"distance": 3000
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Km. 74+600 h.",
				"leavesAt": "07:07",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Malu h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Malu h.",
				"to": "Broşteni Hm.",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Alexeni h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Alexeni h.",
				"to": "Urziceni",
				"leavesAt": "07:30",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 300,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "07:49",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "08:02",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "08:09",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Greci h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 420,
				"distance": 6100
			},
			{
				"from": "Greci h.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "08:44",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Odăile h.",
				"leavesAt": "08:54",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Odăile h.",
				"to": "Mogoşoaia",
				"leavesAt": "08:58",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Mogoşoaia",
				"to": "Chitila",
				"leavesAt": "09:07",
				"arrivesAt": "09:24",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Chitila",
				"to": "Pajura Hm. (700)",
				"leavesAt": "09:25",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Bucureşti Nord",
				"leavesAt": "09:32",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8381",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "06:15",
				"arrivesAt": "06:24",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "06:31",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "06:39",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "06:52",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "06:59",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "07:17",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4102",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Cluj Napoca Est",
				"leavesAt": "11:10",
				"arrivesAt": "11:20",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Dezmir h.",
				"leavesAt": "11:21",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dezmir h.",
				"to": "Apahida",
				"leavesAt": "11:26",
				"arrivesAt": "11:32",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Apahida",
				"to": "Apahida h.",
				"leavesAt": "11:33",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Apahida h.",
				"to": "Jucu Hm.",
				"leavesAt": "11:38",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Jucu Hm.",
				"to": "Răscruci h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Răscruci h.",
				"to": "Bonţida Hm.",
				"leavesAt": "11:52",
				"arrivesAt": "11:57",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bonţida Hm.",
				"to": "Fundătura h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Fundătura h.",
				"to": "Iclod Hm.",
				"leavesAt": "12:05",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Iclod Hm.",
				"to": "Livada Someş h.",
				"leavesAt": "12:10",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Livada Someş h.",
				"to": "Gherla",
				"leavesAt": "12:17",
				"arrivesAt": "12:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Gherla",
				"to": "Nima h.",
				"leavesAt": "12:28",
				"arrivesAt": "12:39",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Nima h.",
				"to": "Dej Călători",
				"leavesAt": "12:40",
				"arrivesAt": "12:49",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "12:51",
				"arrivesAt": "12:58",
				"waitsAtSource": 120,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Reteag Hm.",
				"leavesAt": "12:59",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "13:19",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "13:24",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Beclean pe Someş",
				"to": "Şintereag Hm.",
				"leavesAt": "13:36",
				"arrivesAt": "13:44",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Şintereag Hm.",
				"to": "Caila hc.",
				"leavesAt": "13:45",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Caila hc.",
				"to": "Sfântu h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sfântu h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "14:01",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel Hm.",
				"leavesAt": "14:04",
				"arrivesAt": "14:11",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Sărata h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Viişoara h.",
				"leavesAt": "14:18",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Viişoara h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "14:22",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "14:27",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5301",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:51",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:04",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "09:05",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "09:09",
				"arrivesAt": "09:21",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "09:22",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "09:33",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "09:38",
				"arrivesAt": "09:43",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "09:44",
				"arrivesAt": "09:50",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "09:51",
				"arrivesAt": "10:03",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "10:04",
				"arrivesAt": "10:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "10:09",
				"arrivesAt": "10:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Viişoara h",
				"leavesAt": "10:19",
				"arrivesAt": "10:31",
				"waitsAtSource": 180,
				"distance": 9100
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "10:32",
				"arrivesAt": "10:40",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "10:41",
				"arrivesAt": "10:44",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "10:45",
				"arrivesAt": "10:50",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "10:51",
				"arrivesAt": "10:56",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "10:57",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "11:03",
				"arrivesAt": "11:08",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "11:09",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2561",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "07:20",
				"arrivesAt": "07:24",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "07:25",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:49",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Veşeud h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Veşeud h.",
				"to": "Şeica Mare h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "08:15",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "08:46",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1580",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "08:30",
				"arrivesAt": "08:54",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "08:55",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "09:13",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "09:34",
				"arrivesAt": "09:57",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "09:58",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 108900
			}
		],
		"restrictions": [
			{
				"from": "20180503",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180427",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8012",
		"segments": [
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "03:35",
				"arrivesAt": "03:46",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "03:47",
				"arrivesAt": "03:51",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "03:52",
				"arrivesAt": "03:56",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "03:57",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "04:01",
				"arrivesAt": "04:04",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "04:05",
				"arrivesAt": "04:08",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "04:09",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "04:34",
				"arrivesAt": "04:42",
				"waitsAtSource": 900,
				"distance": 13100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Bogdana h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bogdana h.",
				"to": "Dâlga h.",
				"leavesAt": "04:47",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Dâlga h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "04:54",
				"arrivesAt": "04:59",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Lehliu",
				"leavesAt": "05:04",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lehliu",
				"to": "Preasna h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Preasna h.",
				"to": "Săruleşti",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Săruleşti",
				"to": "Mostiştea h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mostiştea h.",
				"to": "Fundulea Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Fundulea Hm.",
				"to": "Islaz h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Islaz h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "05:41",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Brăneşti Sat h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Pasărea",
				"leavesAt": "05:48",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pasărea",
				"to": "Pantelimon",
				"leavesAt": "05:54",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "06:01",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "06:04",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2464",
		"segments": [
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "20:10",
				"arrivesAt": "20:15",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Râu Vadului h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "20:41",
				"arrivesAt": "20:50",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Balota h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Balota h.",
				"to": "Cornet Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cornet Hm.",
				"to": "Beţel h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Beţel h.",
				"to": "Lotru",
				"leavesAt": "21:15",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "21:23",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "21:38",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "21:44",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "21:50",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "22:13",
				"arrivesAt": "22:16",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "22:18",
				"arrivesAt": "22:20",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "22:21",
				"arrivesAt": "22:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "22:25",
				"arrivesAt": "22:28",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "22:29",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "22:34",
				"arrivesAt": "22:39",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "22:47",
				"arrivesAt": "22:52",
				"waitsAtSource": 480,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "22:53",
				"arrivesAt": "23:00",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1641",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "21:10",
				"arrivesAt": "21:50",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Floreşti Prahova",
				"leavesAt": "21:52",
				"arrivesAt": "22:05",
				"waitsAtSource": 120,
				"distance": 18600
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "22:06",
				"arrivesAt": "22:18",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "22:19",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "22:43",
				"arrivesAt": "22:51",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "22:52",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "22:58",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "23:09",
				"arrivesAt": "23:46",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "23:58",
				"arrivesAt": "00:27",
				"waitsAtSource": 720,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "00:29",
				"arrivesAt": "01:01",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "01:03",
				"arrivesAt": "01:26",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "01:28",
				"arrivesAt": "01:36",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Izvoru Oltului",
				"leavesAt": "01:40",
				"arrivesAt": "01:56",
				"waitsAtSource": 240,
				"distance": 17100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "01:57",
				"arrivesAt": "02:08",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Gheorgheni",
				"leavesAt": "02:09",
				"arrivesAt": "02:26",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "02:27",
				"arrivesAt": "02:59",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "03:00",
				"arrivesAt": "03:58",
				"waitsAtSource": 60,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Sărăţel Hm.",
				"leavesAt": "03:59",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "05:08",
				"arrivesAt": "05:37",
				"waitsAtSource": 900,
				"distance": 24900
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "05:40",
				"arrivesAt": "06:15",
				"waitsAtSource": 180,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Câţcău h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:56",
				"waitsAtSource": 1560,
				"distance": 12700
			},
			{
				"from": "Câţcău h.",
				"to": "Gâlgău",
				"leavesAt": "06:57",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Gâlgău",
				"to": "Ileanda",
				"leavesAt": "07:09",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Ileanda",
				"to": "Răstoci Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Răstoci Hm.",
				"to": "Letca Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Letca Hm.",
				"to": "Jibou",
				"leavesAt": "07:49",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 23100
			},
			{
				"from": "Jibou",
				"to": "Benesat Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:40",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Benesat Hm.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "08:51",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "09:11",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5202",
		"segments": [
			{
				"from": "Siculeni",
				"to": "Mihăileni Hm.",
				"leavesAt": "04:18",
				"arrivesAt": "04:25",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Caracău h.",
				"leavesAt": "04:37",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Caracău h.",
				"to": "Livezi Ciuc",
				"leavesAt": "04:43",
				"arrivesAt": "04:47",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Utuşoiu h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:56",
				"waitsAtSource": 180,
				"distance": 4100
			},
			{
				"from": "Utuşoiu h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Tarcău h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "05:08",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Bolovăniş h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:28",
				"waitsAtSource": 480,
				"distance": 4900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Ghimeş",
				"leavesAt": "05:29",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ghimeş",
				"to": "Palanca Hm.",
				"leavesAt": "05:36",
				"arrivesAt": "05:43",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Palanca Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "05:44",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Simbrea Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Simbrea Hm.",
				"to": "Goioasa Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Goioasa Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Caraliţa h.",
				"to": "Asău Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:16",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Asău Hm.",
				"to": "Comăneşti",
				"leavesAt": "06:17",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:37",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "07:02",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Oneşti",
				"leavesAt": "07:07",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:26",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "07:27",
				"arrivesAt": "07:36",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "07:45",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "08:01",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:23",
				"waitsAtSource": 180,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "08:39",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "08:51",
				"arrivesAt": "08:59",
				"waitsAtSource": 120,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "09:00",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 11700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4702",
		"segments": [
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:45",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "06:46",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "06:55",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "07:05",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Năsăud h.",
				"leavesAt": "07:09",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Năsăud h.",
				"to": "Năsăud",
				"leavesAt": "07:14",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Năsăud",
				"to": "Rebrişoara Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:25",
				"waitsAtSource": 180,
				"distance": 4800
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Nepos h.",
				"leavesAt": "07:26",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Nepos h.",
				"to": "Feldru Hm.",
				"leavesAt": "07:33",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Feldru Hm.",
				"to": "Podereia Feldrului h.",
				"leavesAt": "07:41",
				"arrivesAt": "07:44",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Ilva Mică",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "460",
		"segments": [
			{
				"from": "Ruse",
				"to": "Giurgiu Nord",
				"leavesAt": "16:10",
				"arrivesAt": "16:35",
				"waitsAtSource": 0,
				"distance": 16000
			},
			{
				"from": "Giurgiu Nord",
				"to": "Videle",
				"leavesAt": "16:58",
				"arrivesAt": "18:07",
				"waitsAtSource": 1380,
				"distance": 63000
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "18:08",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181001",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6404",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "10:42",
				"arrivesAt": "10:49",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "10:50",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "10:58",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "11:08",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "11:18",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "11:26",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "11:38",
				"arrivesAt": "11:44",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:50",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "11:51",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "11:57",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "12:04",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "12:09",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "12:15",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Vaslui",
				"to": "Munteni Hm.",
				"leavesAt": "12:24",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Munteni Hm.",
				"to": "Bulboaca h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bulboaca h.",
				"to": "Crasna",
				"leavesAt": "12:36",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Crasna",
				"to": "Roşieşti hc.",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Roşieşti hc.",
				"to": "Dodeşti hc.",
				"leavesAt": "12:52",
				"arrivesAt": "12:58",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Dodeşti hc.",
				"to": "Banca Hm.",
				"leavesAt": "12:59",
				"arrivesAt": "13:05",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Banca Hm.",
				"to": "Zorleni",
				"leavesAt": "13:06",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Zorleni",
				"to": "Bârlad",
				"leavesAt": "13:17",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1551",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "17:37",
				"arrivesAt": "17:51",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Periş",
				"leavesAt": "17:52",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 13300
			},
			{
				"from": "Periş",
				"to": "Crivina",
				"leavesAt": "18:07",
				"arrivesAt": "18:14",
				"waitsAtSource": 360,
				"distance": 9500
			},
			{
				"from": "Crivina",
				"to": "Ploieşti Sud",
				"leavesAt": "18:15",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 20500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1585",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "14:00",
				"arrivesAt": "14:55",
				"waitsAtSource": 0,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "14:56",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "15:20",
				"arrivesAt": "15:38",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "15:39",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "15:56",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "381",
		"segments": [
			{
				"from": "Vadu Siretului",
				"to": "Vicşani",
				"leavesAt": "13:40",
				"arrivesAt": "14:02",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Vicşani",
				"to": "Dorneşti",
				"leavesAt": "14:52",
				"arrivesAt": "15:06",
				"waitsAtSource": 3000,
				"distance": 8300
			},
			{
				"from": "Dorneşti",
				"to": "Suceava Nord",
				"leavesAt": "15:07",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 1020,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "16:01",
				"arrivesAt": "16:14",
				"waitsAtSource": 180,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "16:15",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "16:35",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "16:52",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "17:22",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "17:59",
				"arrivesAt": "18:40",
				"waitsAtSource": 420,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "18:41",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "19:09",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "19:36",
				"arrivesAt": "20:13",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "20:14",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "20:47",
				"arrivesAt": "21:19",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "21:20",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "21:57",
				"arrivesAt": "22:47",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5302",
		"segments": [
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "04:25",
				"arrivesAt": "04:35",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "04:39",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "04:45",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "04:51",
				"arrivesAt": "04:56",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "05:01",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Trotuş h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Trotuş h.",
				"to": "Oneşti",
				"leavesAt": "05:15",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "05:29",
				"arrivesAt": "05:35",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "05:42",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "05:54",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "05:58",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:18",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "06:35",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "06:50",
				"arrivesAt": "06:58",
				"waitsAtSource": 300,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "06:59",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "07:23",
				"arrivesAt": "07:30",
				"waitsAtSource": 480,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "07:31",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "08:07",
				"arrivesAt": "08:17",
				"waitsAtSource": 120,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "08:18",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "08:28",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 11500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2042",
		"segments": [
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "04:42",
				"arrivesAt": "04:49",
				"waitsAtSource": 0,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "04:50",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "04:56",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "05:01",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "05:35",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "05:47",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "06:07",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "06:24",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1546",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "14:00",
				"arrivesAt": "14:58",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "14:59",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Câţcău h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:36",
				"waitsAtSource": 120,
				"distance": 12700
			},
			{
				"from": "Câţcău h.",
				"to": "Gâlgău",
				"leavesAt": "15:37",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Gâlgău",
				"to": "Ileanda",
				"leavesAt": "15:49",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Ileanda",
				"to": "Letca Hm.",
				"leavesAt": "16:09",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Letca Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "16:27",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Jibou",
				"leavesAt": "16:55",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Jibou",
				"to": "Mirşid Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:33",
				"waitsAtSource": 780,
				"distance": 11700
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "17:38",
				"arrivesAt": "17:55",
				"waitsAtSource": 300,
				"distance": 12000
			},
			{
				"from": "Zalău Nord",
				"to": "Sărmăşag",
				"leavesAt": "17:57",
				"arrivesAt": "18:16",
				"waitsAtSource": 120,
				"distance": 22300
			},
			{
				"from": "Sărmăşag",
				"to": "Acâş Hm.",
				"leavesAt": "18:17",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 22500
			},
			{
				"from": "Acâş Hm.",
				"to": "Tăşnad",
				"leavesAt": "18:37",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Tăşnad",
				"to": "Carei",
				"leavesAt": "18:49",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 27800
			},
			{
				"from": "Carei",
				"to": "Satu Mare",
				"leavesAt": "19:21",
				"arrivesAt": "19:49",
				"waitsAtSource": 600,
				"distance": 36000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "364",
		"segments": [
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "11:30",
				"arrivesAt": "11:38",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharkeresztes",
				"leavesAt": "11:53",
				"arrivesAt": "12:08",
				"waitsAtSource": 900,
				"distance": 12500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3534",
		"segments": [
			{
				"from": "Rupea",
				"to": "Mateiaş h.",
				"leavesAt": "11:49",
				"arrivesAt": "12:03",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Mateiaş h.",
				"to": "Racoş Hm.",
				"leavesAt": "12:04",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "12:11",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Ormeniş h.",
				"leavesAt": "12:28",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ormeniş h.",
				"to": "Apaţa",
				"leavesAt": "12:37",
				"arrivesAt": "12:47",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Apaţa",
				"to": "Măieruş h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Măieruş h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "12:54",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Rotbav h.",
				"leavesAt": "13:00",
				"arrivesAt": "13:05",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Rotbav h.",
				"to": "Feldioara Hm.",
				"leavesAt": "13:06",
				"arrivesAt": "13:13",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Bod Hm.",
				"leavesAt": "13:14",
				"arrivesAt": "13:29",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Bod Hm.",
				"to": "Stupini Hm.",
				"leavesAt": "13:30",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Stupini Hm.",
				"to": "Braşov",
				"leavesAt": "13:40",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2444",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Azomureş h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:20",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "22:21",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "22:25",
				"arrivesAt": "22:29",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Vidrasău h.",
				"leavesAt": "22:30",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vidrasău h.",
				"to": "Chirileu h.",
				"leavesAt": "22:36",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Chirileu h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "22:41",
				"arrivesAt": "22:46",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Ogra h.",
				"leavesAt": "22:47",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ogra h.",
				"to": "Cipău h.",
				"leavesAt": "22:51",
				"arrivesAt": "22:55",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cipău h.",
				"to": "Iernut",
				"leavesAt": "22:56",
				"arrivesAt": "23:01",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iernut",
				"to": "Cuci h.",
				"leavesAt": "23:02",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cuci h.",
				"to": "Bogata Mureş h.",
				"leavesAt": "23:08",
				"arrivesAt": "23:14",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Luduş",
				"leavesAt": "23:15",
				"arrivesAt": "23:19",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Luduş",
				"to": "Cheţani h.",
				"leavesAt": "23:20",
				"arrivesAt": "23:26",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Cheţani h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "23:27",
				"arrivesAt": "23:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Lunca Mureşului h.",
				"leavesAt": "23:34",
				"arrivesAt": "23:38",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Războieni",
				"leavesAt": "23:39",
				"arrivesAt": "23:44",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "23:45",
				"arrivesAt": "23:49",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Unirea Hm.",
				"leavesAt": "23:50",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Unirea Hm.",
				"to": "Decea h.",
				"leavesAt": "23:57",
				"arrivesAt": "00:00",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Decea h.",
				"to": "Mirăslău h.",
				"leavesAt": "00:01",
				"arrivesAt": "00:05",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Mirăslău h.",
				"to": "Aiud Hm.",
				"leavesAt": "00:06",
				"arrivesAt": "00:13",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "00:14",
				"arrivesAt": "00:28",
				"waitsAtSource": 60,
				"distance": 13100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7372",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "17:00",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "17:01",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Zagna Vădeni h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Vădeni Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "17:23",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Lacu Sărat",
				"leavesAt": "17:32",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Lacu Sărat",
				"to": "Traian Sat Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Urleasca Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Urleasca Hm.",
				"to": "Plopu",
				"leavesAt": "17:58",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Plopu",
				"to": "Ianca hc.",
				"leavesAt": "18:06",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ianca hc.",
				"to": "Deduleşti Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Găiseanca h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Găiseanca h.",
				"to": "Făurei",
				"leavesAt": "18:24",
				"arrivesAt": "18:29",
				"waitsAtSource": 30,
				"distance": 3900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3516",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Bratei h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:34",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Bratei h.",
				"to": "Aţel Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Aţel Hm.",
				"to": "Dumbrăveni",
				"leavesAt": "16:44",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Dumbrăveni",
				"to": "Luna h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Luna h.",
				"to": "Daneş Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Daneş Hm.",
				"to": "Sighişoara",
				"leavesAt": "17:11",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1522",
		"segments": [
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "14:16",
				"arrivesAt": "14:21",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "14:22",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 16200
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Govora",
				"leavesAt": "14:45",
				"arrivesAt": "14:55",
				"waitsAtSource": 300,
				"distance": 11400
			},
			{
				"from": "Govora",
				"to": "Băbeni",
				"leavesAt": "14:56",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Băbeni",
				"to": "Drăgăşani",
				"leavesAt": "15:06",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Drăgăşani",
				"to": "Piatra Olt",
				"leavesAt": "15:30",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 33800
			},
			{
				"from": "Piatra Olt",
				"to": "Caracal",
				"leavesAt": "15:58",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 32400
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "16:33",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "16:49",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "17:23",
				"arrivesAt": "18:06",
				"waitsAtSource": 240,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "18:14",
				"arrivesAt": "19:06",
				"waitsAtSource": 480,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3118",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Vest Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:24",
				"waitsAtSource": 420,
				"distance": 10800
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Cefa Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cefa Hm.",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Salonta",
				"leavesAt": "20:52",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Salonta",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:17",
				"waitsAtSource": 480,
				"distance": 10200
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Boiu Bihor h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Tămaşda h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tămaşda h.",
				"to": "Zerind Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Zerind Hm.",
				"to": "Chişineu Criş",
				"leavesAt": "21:43",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "22:02",
				"arrivesAt": "22:08",
				"waitsAtSource": 720,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Şimand Hm.",
				"leavesAt": "22:09",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şimand Hm.",
				"to": "Comlăuş h.",
				"leavesAt": "22:18",
				"arrivesAt": "22:26",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Comlăuş h.",
				"to": "Sântana",
				"leavesAt": "22:27",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "22:33",
				"arrivesAt": "22:44",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "22:45",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Arad",
				"leavesAt": "22:51",
				"arrivesAt": "23:07",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "23:34",
				"arrivesAt": "23:41",
				"waitsAtSource": 1620,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Şag Hm.",
				"leavesAt": "23:43",
				"arrivesAt": "23:57",
				"waitsAtSource": 120,
				"distance": 11000
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "23:58",
				"arrivesAt": "00:05",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "00:06",
				"arrivesAt": "00:11",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "00:12",
				"arrivesAt": "00:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "00:18",
				"arrivesAt": "00:24",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "00:25",
				"arrivesAt": "00:31",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h",
				"leavesAt": "00:32",
				"arrivesAt": "00:34",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "00:35",
				"arrivesAt": "00:37",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Timişoara Nord",
				"leavesAt": "00:38",
				"arrivesAt": "00:43",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9414",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:22",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "08:39",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9349",
		"segments": [
			{
				"from": "Videle",
				"to": "Răduleşti Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:46",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Târnavele Hm.",
				"to": "Vlaşca Hm.",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Răsuceni h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Răsuceni h.",
				"to": "Toporu",
				"leavesAt": "22:12",
				"arrivesAt": "22:16",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Toporu",
				"to": "Chiriacu Hm.",
				"leavesAt": "22:17",
				"arrivesAt": "22:28",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Stăneşti Hm.",
				"leavesAt": "22:29",
				"arrivesAt": "22:36",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Onceşti h.",
				"leavesAt": "22:37",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Onceşti h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "22:42",
				"arrivesAt": "22:48",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Cetatea h.",
				"leavesAt": "22:49",
				"arrivesAt": "22:51",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cetatea h.",
				"to": "Giurgiu Nord",
				"leavesAt": "22:52",
				"arrivesAt": "22:58",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Giurgiu Nord",
				"to": "Giurgiu",
				"leavesAt": "22:59",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2208",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "13:45",
				"arrivesAt": "13:53",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "13:54",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "368",
		"segments": [
			{
				"from": "Salonta",
				"to": "Cefa Hm.",
				"leavesAt": "13:42",
				"arrivesAt": "13:54",
				"waitsAtSource": 0,
				"distance": 12500
			},
			{
				"from": "Cefa Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "13:55",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Oradea Vest Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Oradea",
				"leavesAt": "14:18",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "14:41",
				"arrivesAt": "14:49",
				"waitsAtSource": 960,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharkeresztes",
				"leavesAt": "15:04",
				"arrivesAt": "15:19",
				"waitsAtSource": 900,
				"distance": 12500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1843",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "05:18",
				"arrivesAt": "06:15",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "06:16",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "06:37",
				"arrivesAt": "06:44",
				"waitsAtSource": 120,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Beclean pe Someş",
				"leavesAt": "06:45",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 21900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4535",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Azomureş h.",
				"leavesAt": "16:14",
				"arrivesAt": "16:19",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "16:20",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Vidrasău h.",
				"leavesAt": "16:29",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vidrasău h.",
				"to": "Chirileu h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Chirileu h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Ogra h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ogra h.",
				"to": "Cipău h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cipău h.",
				"to": "Iernut",
				"leavesAt": "16:55",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iernut",
				"to": "Cuci h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Cuci h.",
				"to": "Bogata Mureş h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Luduş",
				"leavesAt": "17:14",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Luduş",
				"to": "Cheţani h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Cheţani h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Gura Arieşului h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Lunca Mureşului h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Războieni",
				"leavesAt": "17:41",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5506",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "23:06",
				"arrivesAt": "23:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "23:13",
				"arrivesAt": "23:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "23:21",
				"arrivesAt": "23:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "23:29",
				"arrivesAt": "23:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "23:36",
				"arrivesAt": "23:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "23:43",
				"arrivesAt": "23:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "23:49",
				"arrivesAt": "23:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "23:59",
				"arrivesAt": "00:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "00:05",
				"arrivesAt": "00:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "00:11",
				"arrivesAt": "00:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "00:17",
				"arrivesAt": "00:23",
				"waitsAtSource": 60,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4455",
		"segments": [
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "18:22",
				"arrivesAt": "18:39",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "18:47",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "18:53",
				"arrivesAt": "19:01",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5525",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:33",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "09:34",
				"arrivesAt": "09:42",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "09:43",
				"arrivesAt": "09:50",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "09:51",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Sfântu Mina h.",
				"leavesAt": "09:57",
				"arrivesAt": "10:00",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Târgu Neamţ",
				"leavesAt": "10:01",
				"arrivesAt": "10:12",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5732",
		"segments": [
			{
				"from": "Cacica Hm.",
				"to": "Pârteşti h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:59",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Pârteşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Soloneţ h.",
				"to": "Todireşti h.",
				"leavesAt": "07:07",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Todireşti h.",
				"to": "Părhăuţi h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Părhăuţi h.",
				"to": "Dărmăneşti",
				"leavesAt": "07:24",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "07:33",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "07:41",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7360",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:43",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "04:44",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Zagna Vădeni h.",
				"leavesAt": "04:52",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Vădeni Hm.",
				"leavesAt": "04:56",
				"arrivesAt": "05:00",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "05:01",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "05:08",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Lacu Sărat",
				"leavesAt": "05:44",
				"arrivesAt": "05:52",
				"waitsAtSource": 1620,
				"distance": 9700
			},
			{
				"from": "Lacu Sărat",
				"to": "Traian Sat Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Urleasca Hm.",
				"leavesAt": "06:03",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Urleasca Hm.",
				"to": "Plopu",
				"leavesAt": "06:11",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Plopu",
				"to": "Ianca hc.",
				"leavesAt": "06:19",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ianca hc.",
				"to": "Deduleşti Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Găiseanca h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Găiseanca h.",
				"to": "Făurei",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Făurei",
				"to": "CTF Făurei h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "CTF Făurei h.",
				"to": "Vizireni h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:51",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "06:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "07:03",
				"arrivesAt": "07:07",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "07:13",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "07:18",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău Sud",
				"leavesAt": "07:21",
				"arrivesAt": "07:26",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Buzău Sud",
				"to": "Buzău",
				"leavesAt": "07:27",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3006",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "13:10",
				"arrivesAt": "13:17",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Jos h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "13:25",
				"arrivesAt": "13:32",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "13:33",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "13:52",
				"arrivesAt": "14:01",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "14:02",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "14:08",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "14:12",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "14:17",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "14:20",
				"arrivesAt": "14:24",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "14:25",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Breaza hc.",
				"leavesAt": "14:34",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "14:48",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "14:59",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "15:09",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "15:28",
				"arrivesAt": "15:31",
				"waitsAtSource": 660,
				"distance": 2900
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Brazi",
				"leavesAt": "15:32",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "15:44",
				"arrivesAt": "15:48",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "15:54",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Buftea",
				"leavesAt": "16:00",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 13300
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "16:10",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "16:19",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "16:24",
				"arrivesAt": "16:32",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5203",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:17",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "06:36",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 120,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "07:06",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "07:11",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "07:17",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "07:34",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Viişoara h",
				"leavesAt": "07:46",
				"arrivesAt": "07:56",
				"waitsAtSource": 300,
				"distance": 9100
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "08:04",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "08:13",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "08:25",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "08:31",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Comăneşti",
				"to": "Asău Hm.",
				"leavesAt": "08:41",
				"arrivesAt": "08:47",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Asău Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caraliţa h.",
				"to": "Goioasa Hm.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Goioasa Hm.",
				"to": "Simbrea Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Simbrea Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "09:08",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Palanca Hm.",
				"leavesAt": "09:13",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Palanca Hm.",
				"to": "Ghimeş",
				"leavesAt": "09:19",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Ghimeş",
				"to": "Bolovăniş h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:36",
				"waitsAtSource": 120,
				"distance": 3900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "09:37",
				"arrivesAt": "09:43",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Tarcău h.",
				"leavesAt": "09:44",
				"arrivesAt": "09:48",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "09:49",
				"arrivesAt": "09:54",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Utuşoiu h.",
				"leavesAt": "09:55",
				"arrivesAt": "10:00",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Utuşoiu h.",
				"to": "Livezi Ciuc",
				"leavesAt": "10:01",
				"arrivesAt": "10:07",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Caracău h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:14",
				"waitsAtSource": 180,
				"distance": 2100
			},
			{
				"from": "Caracău h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "10:15",
				"arrivesAt": "10:22",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "10:23",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Mihăileni Hm.",
				"leavesAt": "10:28",
				"arrivesAt": "10:32",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Siculeni",
				"leavesAt": "10:33",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "10:46",
				"arrivesAt": "10:54",
				"waitsAtSource": 420,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2082",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Lunca Jiului hc.",
				"leavesAt": "08:00",
				"arrivesAt": "08:03",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Livezeni",
				"leavesAt": "08:04",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "08:10",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "08:18",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Lainici Hm.",
				"leavesAt": "08:33",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Lainici Hm.",
				"to": "Meri",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Meri",
				"to": "Valea Sadului Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 300,
				"distance": 4900
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "09:03",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Parângu Hm.",
				"leavesAt": "09:09",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Parângu Hm.",
				"to": "Ezureni h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ezureni h.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "09:21",
				"arrivesAt": "09:25",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "09:26",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Târgu Jiu",
				"leavesAt": "09:30",
				"arrivesAt": "09:34",
				"waitsAtSource": 30,
				"distance": 800
			},
			{
				"from": "Târgu Jiu",
				"to": "Budieni h.",
				"leavesAt": "09:50",
				"arrivesAt": "10:02",
				"waitsAtSource": 960,
				"distance": 9900
			},
			{
				"from": "Budieni h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "10:03",
				"arrivesAt": "10:09",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Pojogeni Hm.",
				"leavesAt": "10:14",
				"arrivesAt": "10:17",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "10:18",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "10:25",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "10:31",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "10:38",
				"arrivesAt": "10:44",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "10:45",
				"arrivesAt": "10:50",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "10:51",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "11:00",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "11:07",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "11:11",
				"arrivesAt": "11:16",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Bungeţel h.",
				"leavesAt": "11:17",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bungeţel h.",
				"to": "Filiaşi",
				"leavesAt": "11:21",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "11:26",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "11:30",
				"arrivesAt": "11:34",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "11:35",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "11:39",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "11:49",
				"arrivesAt": "11:54",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "11:55",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "11:58",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "12:03",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "12:06",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1596",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "14:10",
				"arrivesAt": "14:49",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "14:50",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "15:05",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "15:38",
				"arrivesAt": "16:23",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "16:24",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "16:53",
				"arrivesAt": "17:21",
				"waitsAtSource": 240,
				"distance": 25500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5581",
		"segments": [
			{
				"from": "Vereşti",
				"to": "Bucecea Hm",
				"leavesAt": "06:14",
				"arrivesAt": "06:38",
				"waitsAtSource": 0,
				"distance": 19100
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "06:57",
				"arrivesAt": "07:20",
				"waitsAtSource": 60,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8082",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "08:50",
				"arrivesAt": "09:01",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "09:03",
				"arrivesAt": "09:10",
				"waitsAtSource": 120,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Bucureşti Băneasa",
				"leavesAt": "09:28",
				"arrivesAt": "09:37",
				"waitsAtSource": 1080,
				"distance": 9500
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Bucureşti Nord",
				"leavesAt": "09:39",
				"arrivesAt": "09:52",
				"waitsAtSource": 120,
				"distance": 6600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4518",
		"segments": [
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "11:00",
				"arrivesAt": "11:09",
				"waitsAtSource": 0,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1791",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "18:30",
				"arrivesAt": "19:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "19:32",
				"arrivesAt": "19:51",
				"waitsAtSource": 120,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "19:52",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "20:16",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5441",
		"segments": [
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "02:39",
				"arrivesAt": "03:12",
				"waitsAtSource": 0,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "03:15",
				"arrivesAt": "03:22",
				"waitsAtSource": 180,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "03:23",
				"arrivesAt": "03:29",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "03:30",
				"arrivesAt": "03:34",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "03:35",
				"arrivesAt": "03:40",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "03:41",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "03:46",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "03:51",
				"arrivesAt": "04:01",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "04:09",
				"arrivesAt": "04:14",
				"waitsAtSource": 480,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "04:15",
				"arrivesAt": "04:25",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "04:32",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "04:38",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "04:44",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "04:51",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "04:58",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "05:05",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "05:12",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "05:21",
				"arrivesAt": "05:27",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2181",
		"segments": [
			{
				"from": "Margina",
				"to": "Făget",
				"leavesAt": "05:01",
				"arrivesAt": "05:08",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Făget",
				"to": "Răchita h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răchita h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Traian Vuia h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Susani Bega h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Susani Bega h.",
				"to": "Cliciova",
				"leavesAt": "05:29",
				"arrivesAt": "05:33",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Cliciova",
				"to": "Nevrincea h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Nevrincea h.",
				"to": "Balinţ h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Balinţ h.",
				"to": "Păru h.",
				"leavesAt": "05:43",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Păru h.",
				"to": "Coşteiu Mare Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Coşteiu Mare Hm.",
				"to": "Lugoj Nord h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Lugoj Nord h.",
				"to": "Lugoj",
				"leavesAt": "05:58",
				"arrivesAt": "06:07",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5635",
		"segments": [
			{
				"from": "Dărmăneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "16:07",
				"arrivesAt": "16:18",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Ţibeni h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ţibeni h.",
				"to": "Dorneşti",
				"leavesAt": "16:28",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5420",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "10:54",
				"arrivesAt": "11:08",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "11:09",
				"arrivesAt": "11:16",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "11:17",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "11:24",
				"arrivesAt": "11:31",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "11:32",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "11:42",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "11:49",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "11:54",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "12:04",
				"arrivesAt": "12:18",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:45",
				"waitsAtSource": 1200,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "12:46",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "12:52",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "12:57",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "13:03",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "13:08",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "13:15",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "13:26",
				"arrivesAt": "13:33",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "13:34",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "13:39",
				"arrivesAt": "13:47",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "14:00",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1837",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Târgu Frumos",
				"leavesAt": "18:10",
				"arrivesAt": "18:46",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Târgu Frumos",
				"to": "Paşcani",
				"leavesAt": "18:47",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 30800
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "19:16",
				"arrivesAt": "19:36",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "19:37",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "19:54",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Gura Humorului Oraş",
				"leavesAt": "20:21",
				"arrivesAt": "21:07",
				"waitsAtSource": 900,
				"distance": 46800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "21:08",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Vama",
				"leavesAt": "21:17",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vama",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "21:45",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Pojorâta Hm.",
				"leavesAt": "21:53",
				"arrivesAt": "22:03",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Mestecăniş",
				"leavesAt": "22:04",
				"arrivesAt": "22:25",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "22:26",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Vatra Dornei",
				"leavesAt": "22:36",
				"arrivesAt": "22:52",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "22:54",
				"arrivesAt": "22:57",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Lunca Ilvei",
				"leavesAt": "22:58",
				"arrivesAt": "23:50",
				"waitsAtSource": 60,
				"distance": 42800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Ilva Mică",
				"leavesAt": "23:51",
				"arrivesAt": "00:28",
				"waitsAtSource": 60,
				"distance": 31600
			},
			{
				"from": "Ilva Mică",
				"to": "Năsăud",
				"leavesAt": "00:30",
				"arrivesAt": "00:51",
				"waitsAtSource": 120,
				"distance": 19800
			},
			{
				"from": "Năsăud",
				"to": "Salva",
				"leavesAt": "00:52",
				"arrivesAt": "00:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Salva",
				"to": "Beclean pe Someş",
				"leavesAt": "01:00",
				"arrivesAt": "01:22",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "01:24",
				"arrivesAt": "01:59",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "02:03",
				"arrivesAt": "02:22",
				"waitsAtSource": 240,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "02:23",
				"arrivesAt": "03:15",
				"waitsAtSource": 60,
				"distance": 44900
			},
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "03:28",
				"arrivesAt": "04:35",
				"waitsAtSource": 780,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "04:36",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "04:54",
				"arrivesAt": "04:59",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "05:01",
				"arrivesAt": "05:16",
				"waitsAtSource": 120,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "05:18",
				"arrivesAt": "05:32",
				"waitsAtSource": 120,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Alba Iulia",
				"leavesAt": "05:37",
				"arrivesAt": "06:12",
				"waitsAtSource": 300,
				"distance": 19100
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "06:14",
				"arrivesAt": "06:26",
				"waitsAtSource": 120,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Şibot",
				"leavesAt": "06:28",
				"arrivesAt": "06:50",
				"waitsAtSource": 120,
				"distance": 15000
			},
			{
				"from": "Şibot",
				"to": "Aurel Vlaicu",
				"leavesAt": "06:52",
				"arrivesAt": "07:00",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Aurel Vlaicu",
				"to": "Orăştie",
				"leavesAt": "07:01",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Orăştie",
				"to": "Simeria",
				"leavesAt": "07:10",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 16500
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "07:46",
				"arrivesAt": "07:58",
				"waitsAtSource": 720,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "08:00",
				"arrivesAt": "08:30",
				"waitsAtSource": 120,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Holdea Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 23800
			},
			{
				"from": "Holdea Hm.",
				"to": "Margina",
				"leavesAt": "09:06",
				"arrivesAt": "09:24",
				"waitsAtSource": 600,
				"distance": 11700
			},
			{
				"from": "Margina",
				"to": "Făget",
				"leavesAt": "09:25",
				"arrivesAt": "09:33",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Făget",
				"to": "Mănăştur Hm.",
				"leavesAt": "09:34",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Lugoj",
				"leavesAt": "09:44",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 31200
			},
			{
				"from": "Lugoj",
				"to": "Buziaş",
				"leavesAt": "10:27",
				"arrivesAt": "10:57",
				"waitsAtSource": 420,
				"distance": 27500
			},
			{
				"from": "Buziaş",
				"to": "Timişoara Nord",
				"leavesAt": "10:58",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 36400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1731",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "17:38",
				"arrivesAt": "18:14",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "18:16",
				"arrivesAt": "18:25",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "18:26",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "18:33",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "18:43",
				"arrivesAt": "19:07",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "19:08",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "19:33",
				"arrivesAt": "19:38",
				"waitsAtSource": 120,
				"distance": 3000
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "19:40",
				"arrivesAt": "20:13",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "20:14",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "20:51",
				"arrivesAt": "21:28",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Ianca hc.",
				"leavesAt": "21:29",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "21:44",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "22:18",
				"arrivesAt": "22:36",
				"waitsAtSource": 120,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "22:37",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3002",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "04:14",
				"arrivesAt": "04:22",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "04:37",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "04:53",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "05:08",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:23",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Posada h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Posada h.",
				"to": "Comarnic",
				"leavesAt": "05:34",
				"arrivesAt": "05:39",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "05:53",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Bobolia h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Bobolia h.",
				"to": "Floreşti Prahova",
				"leavesAt": "06:05",
				"arrivesAt": "06:12",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "06:13",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "06:23",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 180,
				"distance": 2900
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Brazi",
				"leavesAt": "06:38",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "06:49",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:03",
				"waitsAtSource": 360,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "07:04",
				"arrivesAt": "07:09",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:21",
				"waitsAtSource": 360,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "07:22",
				"arrivesAt": "07:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "07:27",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "07:36",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "07:41",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9161",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:56",
				"waitsAtSource": 0,
				"distance": 10400
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Brebu",
				"leavesAt": "06:06",
				"arrivesAt": "06:18",
				"waitsAtSource": 600,
				"distance": 10500
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:36",
				"waitsAtSource": 600,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "06:44",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "06:56",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8023",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "07:30",
				"arrivesAt": "07:39",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "07:40",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "08:17",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "08:28",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:51",
				"waitsAtSource": 600,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "08:52",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:11",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ivăneşti h.",
				"leavesAt": "09:12",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ivăneşti h.",
				"to": "Ciulniţa",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:34",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "09:42",
				"arrivesAt": "09:44",
				"waitsAtSource": 480,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "09:45",
				"arrivesAt": "09:50",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "09:51",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "09:56",
				"arrivesAt": "10:00",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "10:07",
				"arrivesAt": "10:17",
				"waitsAtSource": 420,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4542",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:27",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "07:28",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "07:41",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "07:58",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "08:27",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "08:37",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Deda",
				"to": "Deda Bistra Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 180,
				"distance": 3900
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Borzia h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Borzia h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "09:00",
				"arrivesAt": "09:04",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 12700
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Stânceni h.",
				"leavesAt": "09:33",
				"arrivesAt": "09:38",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Hm.",
				"leavesAt": "09:39",
				"arrivesAt": "09:46",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Stânceni Hm.",
				"to": "Ciobotani h.",
				"leavesAt": "09:47",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ciobotani h.",
				"to": "Topliţa",
				"leavesAt": "09:53",
				"arrivesAt": "10:03",
				"waitsAtSource": 30,
				"distance": 6600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9166",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "15:10",
				"arrivesAt": "15:19",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "15:29",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "15:37",
				"arrivesAt": "15:49",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "15:50",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Valea Păltinişului h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Caransebeş",
				"leavesAt": "16:11",
				"arrivesAt": "16:17",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2102",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "11:55",
				"arrivesAt": "11:58",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "11:59",
				"arrivesAt": "12:01",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Mohu h.",
				"leavesAt": "12:02",
				"arrivesAt": "12:07",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "12:08",
				"arrivesAt": "12:11",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "12:12",
				"arrivesAt": "12:21",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "12:22",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Sebeş Olt h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Racoviţa h.",
				"leavesAt": "12:35",
				"arrivesAt": "12:38",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Racoviţa h.",
				"to": "Mârşa h.",
				"leavesAt": "12:39",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Mârşa h.",
				"to": "Avrig Hm.",
				"leavesAt": "12:43",
				"arrivesAt": "12:47",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "12:48",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Sărata Colun h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sărata Colun h.",
				"to": "Scoreiu h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:06",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Scoreiu h.",
				"to": "Cârţa h.",
				"leavesAt": "13:07",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârţa h.",
				"to": "Arpaş Hm.",
				"leavesAt": "13:12",
				"arrivesAt": "13:16",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Arpaş Hm.",
				"to": "Ucea",
				"leavesAt": "13:17",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ucea",
				"to": "Viştea h.",
				"leavesAt": "13:24",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Viştea h.",
				"to": "Olteţ h.",
				"leavesAt": "13:28",
				"arrivesAt": "13:32",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Olteţ h.",
				"to": "Voila Hm.",
				"leavesAt": "13:33",
				"arrivesAt": "13:40",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Voila Hm.",
				"to": "Dridif h.",
				"leavesAt": "13:41",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dridif h.",
				"to": "Făgăraş",
				"leavesAt": "13:46",
				"arrivesAt": "13:59",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Făgăraş",
				"to": "Mândra Oltului h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:20",
				"waitsAtSource": 840,
				"distance": 6100
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Şercaia h.",
				"leavesAt": "14:21",
				"arrivesAt": "14:28",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Şercaia h.",
				"to": "Şercaia Hm.",
				"leavesAt": "14:29",
				"arrivesAt": "14:31",
				"waitsAtSource": 30,
				"distance": 1200
			},
			{
				"from": "Şercaia Hm.",
				"to": "Perşani h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Brădet Hm.",
				"leavesAt": "14:39",
				"arrivesAt": "14:48",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Brădet Hm.",
				"to": "Valea Homorod h.",
				"leavesAt": "14:49",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Homorod h.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "14:58",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:20",
				"waitsAtSource": 360,
				"distance": 4600
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "15:21",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Codlea Hm.",
				"to": "Ghimbav Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Bartolomeu",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "15:46",
				"arrivesAt": "15:52",
				"waitsAtSource": 120,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3541",
		"segments": [
			{
				"from": "Odorhei",
				"to": "Odorhei Sud hc.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 0,
				"distance": 1200
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Feliceni h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Feliceni h.",
				"to": "Dobeni h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Lutiţa h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lutiţa h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Beteşti h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Beteşti h.",
				"to": "Cristur Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:28",
				"waitsAtSource": 30,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2236",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "16:32",
				"arrivesAt": "16:38",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Viile Giarmata h.",
				"leavesAt": "16:39",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Giarmata Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Giarmata Hm.",
				"to": "Cerneteaz h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Cerneteaz h.",
				"to": "Pişchia h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Pişchia h.",
				"to": "Bencei h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Bencei h.",
				"to": "Fibiş h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Remetea Mică",
				"leavesAt": "17:21",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4366",
		"segments": [
			{
				"from": "Jibou",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:22",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Poptelec h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:28",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poptelec h.",
				"to": "Mirşid Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:35",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Mirşid Hm.",
				"to": "Zalău Nord",
				"leavesAt": "15:36",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Zalău Nord",
				"to": "Guruslău h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:07",
				"waitsAtSource": 300,
				"distance": 6700
			},
			{
				"from": "Guruslău h.",
				"to": "Borla Hm.",
				"leavesAt": "16:08",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Borla Hm.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "16:14",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Sărmăşag",
				"leavesAt": "16:26",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sărmăşag",
				"to": "Sărmăşag h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 840,
				"distance": 3100
			},
			{
				"from": "Sărmăşag h.",
				"to": "Derşida h.",
				"leavesAt": "16:55",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Derşida h.",
				"to": "Giorocuţa h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Giorocuţa h.",
				"to": "Supur h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Supur h.",
				"to": "Supur Haltă hc.",
				"leavesAt": "17:09",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Acâş Hm.",
				"leavesAt": "17:12",
				"arrivesAt": "17:19",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Acâş Hm.",
				"to": "Săcăşeni h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Săcăşeni h.",
				"to": "Tăşnad",
				"leavesAt": "17:31",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Santău h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Santău h.",
				"to": "Hotoan h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Hotoan h.",
				"to": "Tiream h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Tiream h.",
				"to": "Carei",
				"leavesAt": "17:58",
				"arrivesAt": "18:13",
				"waitsAtSource": 30,
				"distance": 11700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5008",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "14:00",
				"arrivesAt": "14:10",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "14:11",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "14:17",
				"arrivesAt": "14:21",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:32",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "14:33",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "14:50",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "15:02",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "15:06",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "15:14",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "15:22",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "15:35",
				"arrivesAt": "15:42",
				"waitsAtSource": 360,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Brazi",
				"leavesAt": "15:46",
				"arrivesAt": "15:54",
				"waitsAtSource": 240,
				"distance": 5200
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "16:05",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Buftea",
				"leavesAt": "16:16",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 13300
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "16:27",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "16:36",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "16:41",
				"arrivesAt": "16:50",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2411",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(210)",
				"leavesAt": "07:15",
				"arrivesAt": "07:18",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Turnişor Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:24",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Cristian Sibiu h.",
				"leavesAt": "07:25",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Orlat",
				"leavesAt": "07:38",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Orlat",
				"to": "Sibiel h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sibiel h.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sălişte Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sălişte Hm.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "08:03",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 13000
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:31",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Băile Miercurea h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Băile Miercurea h.",
				"to": "Cunţa Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cunţa Hm.",
				"to": "Cut h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:59",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Cut h.",
				"to": "Rahău h.",
				"leavesAt": "09:00",
				"arrivesAt": "09:04",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Rahău h.",
				"to": "Sebeş Alba",
				"leavesAt": "09:05",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sebeş Alba",
				"to": "Sebeş Glod h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sebeş Glod h.",
				"to": "Vinţu de Jos",
				"leavesAt": "09:19",
				"arrivesAt": "09:28",
				"waitsAtSource": 30,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2064",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu Triaj h.",
				"leavesAt": "03:13",
				"arrivesAt": "03:18",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "03:19",
				"arrivesAt": "03:22",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "03:23",
				"arrivesAt": "03:37",
				"waitsAtSource": 60,
				"distance": 13200
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "03:38",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "03:46",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "03:51",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Râu Vadului h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "04:15",
				"arrivesAt": "04:24",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:40",
				"waitsAtSource": 540,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Balota h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Balota h.",
				"to": "Cornet Hm.",
				"leavesAt": "04:45",
				"arrivesAt": "04:51",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cornet Hm.",
				"to": "Beţel h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:05",
				"waitsAtSource": 540,
				"distance": 3600
			},
			{
				"from": "Beţel h.",
				"to": "Lotru",
				"leavesAt": "05:06",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Lotru",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "05:15",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "05:34",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "05:47",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "06:01",
				"arrivesAt": "06:04",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "06:12",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "06:15",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "06:30",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Băbeni",
				"to": "Slăviteşti hc.",
				"leavesAt": "06:37",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Ioneşti Hm.",
				"leavesAt": "06:42",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Fişcălia Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "06:57",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "06:58",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Orleşti hc.",
				"to": "Zăvideni Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Călina h.",
				"leavesAt": "07:07",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Călina h.",
				"to": "Drăgăşani",
				"leavesAt": "07:12",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Drăgăşani",
				"to": "Zlătărei Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Strejeşti",
				"leavesAt": "07:27",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Strejeşti",
				"to": "Colibaşi h.",
				"leavesAt": "07:33",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Arceşti Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Găneasa Olt h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Găneasa h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa h.",
				"to": "Piatra Olt",
				"leavesAt": "07:56",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2570",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:10",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "20:11",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "20:32",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:47",
				"waitsAtSource": 300,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Veşeud h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Veşeud h.",
				"to": "Hăşag h.",
				"leavesAt": "20:54",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "21:06",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:18",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "21:20",
				"arrivesAt": "21:27",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "21:28",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "21:38",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5108",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "13:05",
				"arrivesAt": "13:14",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "13:15",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "13:33",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "13:42",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "13:51",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "14:00",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "14:08",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "14:21",
				"arrivesAt": "14:32",
				"waitsAtSource": 180,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "14:33",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "14:44",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 11500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1962",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "22:21",
				"arrivesAt": "22:27",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "22:29",
				"arrivesAt": "22:51",
				"waitsAtSource": 120,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "22:52",
				"arrivesAt": "23:14",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "23:15",
				"arrivesAt": "23:33",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "23:37",
				"arrivesAt": "23:51",
				"waitsAtSource": 240,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "23:52",
				"arrivesAt": "00:25",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tecuci",
				"leavesAt": "00:29",
				"arrivesAt": "01:15",
				"waitsAtSource": 240,
				"distance": 50300
			},
			{
				"from": "Tecuci",
				"to": "Lieşti",
				"leavesAt": "01:16",
				"arrivesAt": "01:41",
				"waitsAtSource": 60,
				"distance": 24400
			},
			{
				"from": "Lieşti",
				"to": "Barboşi",
				"leavesAt": "01:42",
				"arrivesAt": "02:33",
				"waitsAtSource": 60,
				"distance": 48300
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "02:53",
				"arrivesAt": "03:12",
				"waitsAtSource": 1200,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "03:13",
				"arrivesAt": "03:44",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Ţăndărei",
				"leavesAt": "03:45",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 72100
			},
			{
				"from": "Ţăndărei",
				"to": "Platoneşti h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Platoneşti h.",
				"to": "Movila Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "04:57",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "05:24",
				"arrivesAt": "05:43",
				"waitsAtSource": 600,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "05:44",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Palas",
				"leavesAt": "06:02",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 30600
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "06:21",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "06:55",
				"arrivesAt": "07:18",
				"waitsAtSource": 1560,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "07:21",
				"arrivesAt": "07:28",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "07:35",
				"arrivesAt": "07:51",
				"waitsAtSource": 420,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "07:53",
				"arrivesAt": "07:57",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "07:59",
				"arrivesAt": "08:12",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "08:14",
				"arrivesAt": "08:24",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8695",
		"segments": [
			{
				"from": "Medgidia",
				"to": "Dorobanţu",
				"leavesAt": "16:28",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "16:42",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Palas",
				"leavesAt": "16:51",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "17:00",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180105",
				"to": "20180107",
				"daysOfWeek": 383
			},
			{
				"from": "20180112",
				"to": "20180114",
				"daysOfWeek": 383
			},
			{
				"from": "20180119",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180126",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180202",
				"to": "20180204",
				"daysOfWeek": 383
			},
			{
				"from": "20180209",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180216",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180223",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180302",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180309",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180316",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180323",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180330",
				"to": "20180401",
				"daysOfWeek": 383
			},
			{
				"from": "20180406",
				"to": "20180408",
				"daysOfWeek": 383
			},
			{
				"from": "20180413",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180420",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180427",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180504",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180511",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180518",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180527",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180909",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180914",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180921",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180928",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181005",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181012",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181019",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181026",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181102",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181109",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181116",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181123",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181207",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171215",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171222",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171229",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1745",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "06:05",
				"arrivesAt": "06:47",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "06:49",
				"arrivesAt": "07:13",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "07:14",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Comarnic",
				"leavesAt": "07:20",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Comarnic",
				"to": "Valea Largă Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "07:46",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "07:54",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "08:00",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "08:11",
				"arrivesAt": "08:49",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Augustin Hm.",
				"leavesAt": "08:58",
				"arrivesAt": "10:01",
				"waitsAtSource": 540,
				"distance": 49100
			},
			{
				"from": "Augustin Hm.",
				"to": "Racoş Hm.",
				"leavesAt": "10:02",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Racoş Hm.",
				"to": "Rupea",
				"leavesAt": "10:19",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 14000
			},
			{
				"from": "Rupea",
				"to": "Sighişoara",
				"leavesAt": "10:38",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Sighişoara",
				"to": "Dumbrăveni",
				"leavesAt": "11:43",
				"arrivesAt": "12:10",
				"waitsAtSource": 180,
				"distance": 20400
			},
			{
				"from": "Dumbrăveni",
				"to": "Mediaş",
				"leavesAt": "12:11",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Mediaş",
				"to": "Copşa Mică",
				"leavesAt": "12:38",
				"arrivesAt": "12:51",
				"waitsAtSource": 120,
				"distance": 10400
			},
			{
				"from": "Copşa Mică",
				"to": "Blaj",
				"leavesAt": "12:52",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Blaj",
				"to": "Teiuş",
				"leavesAt": "13:31",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 21300
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "14:03",
				"arrivesAt": "14:16",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Unirea hc.",
				"leavesAt": "14:17",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "14:33",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "14:41",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "14:57",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 51500
			},
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "16:18",
				"arrivesAt": "17:16",
				"waitsAtSource": 900,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "17:18",
				"arrivesAt": "17:37",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Câţcău h.",
				"leavesAt": "17:51",
				"arrivesAt": "18:07",
				"waitsAtSource": 840,
				"distance": 12700
			},
			{
				"from": "Câţcău h.",
				"to": "Gâlgău",
				"leavesAt": "18:08",
				"arrivesAt": "18:19",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Gâlgău",
				"to": "Ileanda",
				"leavesAt": "18:20",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Ileanda",
				"to": "Letca Hm.",
				"leavesAt": "18:40",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Letca Hm.",
				"to": "Jibou",
				"leavesAt": "18:59",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 23100
			},
			{
				"from": "Jibou",
				"to": "Benesat Hm.",
				"leavesAt": "19:38",
				"arrivesAt": "19:56",
				"waitsAtSource": 480,
				"distance": 18000
			},
			{
				"from": "Benesat Hm.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "19:57",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "20:07",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Baia Mare",
				"leavesAt": "20:15",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 25100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8004",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "14:57",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "15:11",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "15:21",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "15:29",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "15:55",
				"arrivesAt": "16:02",
				"waitsAtSource": 540,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "16:03",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Ramificaţia Borcea",
				"leavesAt": "16:13",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 16000
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "16:32",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "17:00",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "17:12",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Ivăneşti h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ivăneşti h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Bogdana h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bogdana h.",
				"to": "Dâlga h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Dâlga h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Lehliu",
				"leavesAt": "17:54",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lehliu",
				"to": "Preasna h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Preasna h.",
				"to": "Săruleşti",
				"leavesAt": "18:06",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săruleşti",
				"to": "Mostiştea h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:23",
				"waitsAtSource": 420,
				"distance": 5900
			},
			{
				"from": "Mostiştea h.",
				"to": "Fundulea Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:29",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Fundulea Hm.",
				"to": "Islaz h.",
				"leavesAt": "18:30",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Islaz h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "18:37",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Brăneşti Sat h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Pasărea",
				"leavesAt": "18:44",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pasărea",
				"to": "Pantelimon",
				"leavesAt": "18:51",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "18:58",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "19:01",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20180916",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180419",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9484",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:21",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "22:22",
				"arrivesAt": "22:28",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Slatina",
				"leavesAt": "22:29",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5602",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "09:06",
				"arrivesAt": "09:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "09:13",
				"arrivesAt": "09:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "09:21",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "09:29",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "09:36",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "09:43",
				"arrivesAt": "09:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "09:49",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "09:59",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "10:05",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "10:17",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "10:31",
				"arrivesAt": "10:45",
				"waitsAtSource": 480,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "10:46",
				"arrivesAt": "10:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "10:54",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "11:00",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "11:09",
				"arrivesAt": "11:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "11:20",
				"arrivesAt": "11:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "11:27",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "11:34",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "11:42",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1578",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "17:35",
				"arrivesAt": "17:54",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "17:55",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "18:14",
				"arrivesAt": "18:44",
				"waitsAtSource": 120,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Făurei",
				"leavesAt": "18:45",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "19:05",
				"arrivesAt": "19:44",
				"waitsAtSource": 180,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "19:47",
				"arrivesAt": "20:19",
				"waitsAtSource": 180,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "20:20",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "20:58",
				"arrivesAt": "21:04",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Bucureşti Nord",
				"leavesAt": "21:08",
				"arrivesAt": "21:53",
				"waitsAtSource": 240,
				"distance": 56600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9502",
		"segments": [
			{
				"from": "Drobeta Tr. Severin",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "04:12",
				"arrivesAt": "04:22",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Ergheviţa h.",
				"leavesAt": "04:23",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ergheviţa h.",
				"to": "Valea Albă Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:38",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Balota",
				"leavesAt": "04:39",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Balota",
				"to": "Gârniţa Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "05:01",
				"arrivesAt": "05:08",
				"waitsAtSource": 240,
				"distance": 6100
			},
			{
				"from": "Prunişor Hm.",
				"to": "Igiroasa Hm.",
				"leavesAt": "05:09",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Tâmna",
				"leavesAt": "05:20",
				"arrivesAt": "05:26",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Tâmna",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Strehaia hc.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strehaia hc.",
				"to": "Strehaia",
				"leavesAt": "05:42",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia",
				"to": "Lunca Banului h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Lunca Banului h.",
				"to": "Butoieşti Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Gura Motrului Hm.",
				"leavesAt": "06:02",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Filiaşi",
				"leavesAt": "06:09",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "06:26",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "06:47",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "06:50",
				"arrivesAt": "06:54",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "06:55",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "06:58",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2061",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(901)",
				"leavesAt": "05:05",
				"arrivesAt": "05:08",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Cârcea h.",
				"leavesAt": "05:09",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Cârcea h.",
				"to": "Toporaş h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:25",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Toporaş h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:34",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Spineni h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Spineni h.",
				"to": "Balş",
				"leavesAt": "05:42",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balş",
				"to": "Canton 217 h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:00",
				"waitsAtSource": 480,
				"distance": 1800
			},
			{
				"from": "Canton 217 h.",
				"to": "Brăneţ h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:05",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Brăneţ h.",
				"to": "Piatra Olt",
				"leavesAt": "06:06",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Piatra Olt",
				"to": "Găneasa h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:37",
				"waitsAtSource": 1080,
				"distance": 3500
			},
			{
				"from": "Găneasa h.",
				"to": "Găneasa Olt h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Arceşti Hm.",
				"leavesAt": "06:42",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Colibaşi h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Strejeşti",
				"leavesAt": "06:54",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Strejeşti",
				"to": "Zlătărei Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Drăgăşani",
				"leavesAt": "07:07",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Drăgăşani",
				"to": "Călina h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:30",
				"waitsAtSource": 480,
				"distance": 6400
			},
			{
				"from": "Călina h.",
				"to": "Zăvideni Hm.",
				"leavesAt": "07:31",
				"arrivesAt": "07:36",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "07:37",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Orleşti hc.",
				"to": "Fişcălia Hm.",
				"leavesAt": "07:43",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:00",
				"waitsAtSource": 600,
				"distance": 3000
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Ioneşti Hm.",
				"leavesAt": "08:01",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Slăviteşti hc.",
				"leavesAt": "08:06",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Băbeni",
				"leavesAt": "08:12",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "08:26",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "08:34",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "08:38",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "08:55",
				"arrivesAt": "08:57",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:12",
				"waitsAtSource": 780,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "09:13",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "09:26",
				"arrivesAt": "09:33",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "09:34",
				"arrivesAt": "09:39",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "09:40",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Cozia Hm.",
				"leavesAt": "09:45",
				"arrivesAt": "09:52",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cozia Hm.",
				"to": "Lotru",
				"leavesAt": "09:53",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lotru",
				"to": "Beţel h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Beţel h.",
				"to": "Cornet Hm.",
				"leavesAt": "10:11",
				"arrivesAt": "10:17",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cornet Hm.",
				"to": "Balota h.",
				"leavesAt": "10:18",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Balota h.",
				"to": "Robeşti h.",
				"leavesAt": "10:24",
				"arrivesAt": "10:27",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Robeşti h.",
				"to": "Câineni",
				"leavesAt": "10:28",
				"arrivesAt": "10:34",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Râu Vadului h.",
				"leavesAt": "10:35",
				"arrivesAt": "10:43",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Râu Vadului h.",
				"to": "Valea Fratelui h.",
				"leavesAt": "10:44",
				"arrivesAt": "10:48",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "10:49",
				"arrivesAt": "11:01",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "11:02",
				"arrivesAt": "11:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "11:13",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:28",
				"waitsAtSource": 180,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "11:29",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "11:39",
				"arrivesAt": "11:42",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "11:43",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj",
				"leavesAt": "11:48",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj",
				"to": "Atelier Zona h",
				"leavesAt": "11:53",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h",
				"to": "Sibiu",
				"leavesAt": "11:57",
				"arrivesAt": "12:01",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9483",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:44",
				"waitsAtSource": 0,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Canton 217 h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Canton 217 h.",
				"to": "Balş",
				"leavesAt": "05:50",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Balş",
				"to": "Spineni h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Spineni h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "05:59",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Toporaş h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Cârcea h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cârcea h.",
				"to": "Plaiu Vulcăneşti Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Plaiu Vulcăneşti Hm.",
				"to": "Bordei hc.(901)",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Craiova",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 863
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2854",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "14:28",
				"arrivesAt": "14:36",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Drăguţeşti h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Vârţ h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vârţ h.",
				"to": "Rogojelu",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Rovinari Hm.",
				"to": "Rovinari Sud h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:32",
				"waitsAtSource": 1500,
				"distance": 1400
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Bâlteni h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bâlteni h.",
				"to": "Peşteana Jiu h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Plopşoru",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Plopşoru",
				"to": "Sărdăneşti h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Gârbovu h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:08",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Gârbovu h.",
				"to": "Turceni",
				"leavesAt": "16:09",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turceni",
				"to": "Termo Turceni h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:22",
				"waitsAtSource": 120,
				"distance": 900
			},
			{
				"from": "Termo Turceni h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "16:23",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:31",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Filiaşi",
				"leavesAt": "16:32",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 12400
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:53",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "17:14",
				"arrivesAt": "17:19",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "17:20",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "17:23",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "17:28",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "17:32",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8585",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "16:45",
				"arrivesAt": "16:55",
				"waitsAtSource": 0,
				"distance": 4200
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Brâncoveni h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Brâncoveni h.",
				"to": "Ciulniţa",
				"leavesAt": "17:05",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "72",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Arad",
				"leavesAt": "14:38",
				"arrivesAt": "15:24",
				"waitsAtSource": 0,
				"distance": 57200
			},
			{
				"from": "Arad",
				"to": "Curtici",
				"leavesAt": "15:26",
				"arrivesAt": "15:39",
				"waitsAtSource": 120,
				"distance": 17000
			},
			{
				"from": "Curtici",
				"to": "Lokoshaza",
				"leavesAt": "16:09",
				"arrivesAt": "16:19",
				"waitsAtSource": 1800,
				"distance": 11200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3548",
		"segments": [
			{
				"from": "Cristur Hm.",
				"to": "Beteşti h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:43",
				"waitsAtSource": 0,
				"distance": 1300
			},
			{
				"from": "Beteşti h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Lutiţa h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Lutiţa h.",
				"to": "Dobeni h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Feliceni h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Feliceni h.",
				"to": "Odorhei Sud hc.",
				"leavesAt": "16:15",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Odorhei",
				"leavesAt": "16:24",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 1200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7366",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "19:50",
				"arrivesAt": "20:03",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "20:05",
				"arrivesAt": "20:12",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Zagna Vădeni h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Vădeni Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:21",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "20:28",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Lacu Sărat",
				"leavesAt": "20:38",
				"arrivesAt": "20:46",
				"waitsAtSource": 120,
				"distance": 9700
			},
			{
				"from": "Lacu Sărat",
				"to": "Traian Sat Hm.",
				"leavesAt": "20:47",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Urleasca Hm.",
				"leavesAt": "20:57",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Urleasca Hm.",
				"to": "Plopu",
				"leavesAt": "21:05",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Plopu",
				"to": "Ianca hc.",
				"leavesAt": "21:13",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ianca hc.",
				"to": "Deduleşti Hm.",
				"leavesAt": "21:17",
				"arrivesAt": "21:25",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Găiseanca h.",
				"leavesAt": "21:26",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Găiseanca h.",
				"to": "Făurei",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Făurei",
				"to": "Vizireni h.",
				"leavesAt": "21:38",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "21:53",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "22:01",
				"arrivesAt": "22:06",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Buzău",
				"leavesAt": "22:17",
				"arrivesAt": "22:31",
				"waitsAtSource": 60,
				"distance": 11800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2092",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Copăcioasa Hm.",
				"leavesAt": "04:00",
				"arrivesAt": "04:16",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Pojogeni Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:23",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "04:27",
				"arrivesAt": "04:34",
				"waitsAtSource": 240,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "04:35",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "04:48",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "04:56",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "05:02",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "05:11",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "05:18",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Filiaşi",
				"leavesAt": "05:28",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:39",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:56",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "06:01",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "06:07",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "06:15",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "06:19",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2104",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "14:35",
				"arrivesAt": "14:38",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Mohu h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "14:52",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "15:02",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Sebeş Olt h.",
				"leavesAt": "15:19",
				"arrivesAt": "15:23",
				"waitsAtSource": 600,
				"distance": 2300
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Racoviţa h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Racoviţa h.",
				"to": "Mârşa h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:31",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Mârşa h.",
				"to": "Avrig Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Sărata Colun h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sărata Colun h.",
				"to": "Scoreiu h.",
				"leavesAt": "15:52",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Scoreiu h.",
				"to": "Cârţa h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârţa h.",
				"to": "Arpaş Hm.",
				"leavesAt": "16:01",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Arpaş Hm.",
				"to": "Ucea",
				"leavesAt": "16:06",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ucea",
				"to": "Viştea h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:30",
				"waitsAtSource": 780,
				"distance": 3000
			},
			{
				"from": "Viştea h.",
				"to": "Olteţ h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Olteţ h.",
				"to": "Voila Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Voila Hm.",
				"to": "Dridif h.",
				"leavesAt": "16:44",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dridif h.",
				"to": "Beclean pe Olt h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Beclean pe Olt h.",
				"to": "Făgăraş",
				"leavesAt": "16:54",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Făgăraş",
				"to": "Mândra Oltului h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:16",
				"waitsAtSource": 420,
				"distance": 6100
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Şercaia h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Şercaia h.",
				"to": "Şercaia Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 1200
			},
			{
				"from": "Şercaia Hm.",
				"to": "Perşani h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 900,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Brădet Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Brădet Hm.",
				"to": "Valea Homorod h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:34",
				"waitsAtSource": 1380,
				"distance": 5500
			},
			{
				"from": "Valea Homorod h.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "18:35",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "18:45",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "19:01",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Codlea Hm.",
				"to": "Ghimbav Hm.",
				"leavesAt": "19:02",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Bartolomeu",
				"leavesAt": "19:09",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "19:16",
				"arrivesAt": "19:22",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6402",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "07:09",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "07:19",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "07:29",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "07:58",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "08:16",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "08:22",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Vaslui",
				"to": "Munteni Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Munteni Hm.",
				"to": "Bulboaca h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bulboaca h.",
				"to": "Crasna",
				"leavesAt": "08:43",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Crasna",
				"to": "Roşieşti hc.",
				"leavesAt": "08:51",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Roşieşti hc.",
				"to": "Dodeşti hc.",
				"leavesAt": "09:00",
				"arrivesAt": "09:06",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Dodeşti hc.",
				"to": "Banca Hm.",
				"leavesAt": "09:07",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Banca Hm.",
				"to": "Zorleni",
				"leavesAt": "09:14",
				"arrivesAt": "09:24",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Zorleni",
				"to": "Bârlad",
				"leavesAt": "09:25",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1557",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "20:46",
				"arrivesAt": "21:01",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Crivina",
				"leavesAt": "21:02",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Crivina",
				"to": "Ploieşti Sud",
				"leavesAt": "21:17",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 20500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5531",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Topile h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:33",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Topile h.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "20:34",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Timişeşti Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:50",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Plăieşu h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Plăieşu h.",
				"to": "Sfântu Mina h.",
				"leavesAt": "20:57",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Târgu Neamţ",
				"leavesAt": "21:01",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2207",
		"segments": [
			{
				"from": "Arad",
				"to": "Şofronea",
				"leavesAt": "14:48",
				"arrivesAt": "14:58",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Şofronea",
				"to": "Curtici",
				"leavesAt": "14:59",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 799
			},
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180609",
				"daysOfWeek": 799
			},
			{
				"from": "20180611",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180623",
				"to": "20180624",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20180928",
				"daysOfWeek": 799
			},
			{
				"from": "20181001",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3500",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Cistei h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:29",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Cistei h.",
				"to": "Crăciunel Hm.",
				"leavesAt": "04:30",
				"arrivesAt": "04:40",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Blaj",
				"leavesAt": "04:44",
				"arrivesAt": "04:52",
				"waitsAtSource": 240,
				"distance": 5300
			},
			{
				"from": "Blaj",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "04:53",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Mănărade h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mănărade h.",
				"to": "Glogoveţ h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:06",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Glogoveţ h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "05:07",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Lunca h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca h.",
				"to": "Micăsasa h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:25",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Micăsasa h.",
				"to": "Copşa Mică",
				"leavesAt": "05:26",
				"arrivesAt": "05:43",
				"waitsAtSource": 30,
				"distance": 10200
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "05:52",
				"arrivesAt": "05:59",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Bratei h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:12",
				"waitsAtSource": 300,
				"distance": 5100
			},
			{
				"from": "Bratei h.",
				"to": "Aţel Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:21",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Aţel Hm.",
				"to": "Dumbrăveni",
				"leavesAt": "06:22",
				"arrivesAt": "06:32",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Dumbrăveni",
				"to": "Luna h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Luna h.",
				"to": "Daneş Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Daneş Hm.",
				"to": "Sighişoara",
				"leavesAt": "06:49",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:23",
				"waitsAtSource": 600,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "07:24",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Saschiz h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Saschiz h.",
				"to": "Mureni Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mureni Hm.",
				"to": "Archita h",
				"leavesAt": "07:44",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Archita h",
				"to": "Beia Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Beia Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Caţa Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Caţa Hm.",
				"to": "Rupea",
				"leavesAt": "08:29",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Rupea",
				"to": "Mateiaş h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Mateiaş h.",
				"to": "Racoş Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:00",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "09:01",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Ormeniş h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ormeniş h.",
				"to": "Apaţa",
				"leavesAt": "09:27",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Apaţa",
				"to": "Măieruş h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Măieruş h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "09:44",
				"arrivesAt": "09:49",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Rotbav h.",
				"leavesAt": "09:50",
				"arrivesAt": "09:55",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Rotbav h.",
				"to": "Feldioara Hm.",
				"leavesAt": "09:56",
				"arrivesAt": "10:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Bod Hm.",
				"leavesAt": "10:04",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Bod Hm.",
				"to": "Stupini Hm.",
				"leavesAt": "10:20",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Stupini Hm.",
				"to": "Braşov",
				"leavesAt": "10:30",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5501",
		"segments": [
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "03:10",
				"arrivesAt": "03:15",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "03:16",
				"arrivesAt": "03:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "03:27",
				"arrivesAt": "03:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "03:33",
				"arrivesAt": "03:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "03:39",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "03:46",
				"arrivesAt": "03:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "03:53",
				"arrivesAt": "03:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "04:00",
				"arrivesAt": "04:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "04:07",
				"arrivesAt": "04:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "04:14",
				"arrivesAt": "04:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "04:23",
				"arrivesAt": "04:29",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9439",
		"segments": [
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "21:40",
				"arrivesAt": "21:45",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "21:46",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "21:56",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "22:01",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "22:10",
				"arrivesAt": "22:15",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "22:16",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9409",
		"segments": [
			{
				"from": "Caracal",
				"to": "Romula Hm.",
				"leavesAt": "20:46",
				"arrivesAt": "20:59",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Romula Hm.",
				"to": "Fălcoiu h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fălcoiu h.",
				"to": "Vlăduleni",
				"leavesAt": "21:09",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vlăduleni",
				"to": "Şopârliţa hc.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Piatra Olt",
				"leavesAt": "21:23",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 11100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3073",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:46",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Suceag h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Suceag h.",
				"to": "Rădaia h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Rădaia h.",
				"to": "Mera Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Mera Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Nădăşel h.",
				"to": "Gârbău Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gârbău Hm.",
				"to": "Macău h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Macău h.",
				"to": "Dorolţu h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Gălăşeni h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Gălăşeni h.",
				"to": "Stana Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:47",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Stana Hm.",
				"to": "Jebuc h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Jebuc h.",
				"to": "Huedin",
				"leavesAt": "08:57",
				"arrivesAt": "09:04",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Huedin",
				"to": "Brăişoru Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Bologa h.",
				"leavesAt": "09:14",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bologa h.",
				"to": "Poieni",
				"leavesAt": "09:20",
				"arrivesAt": "09:25",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Valea Drăganului h.",
				"leavesAt": "09:26",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Ciucea Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:36",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "09:43",
				"arrivesAt": "09:47",
				"waitsAtSource": 420,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "09:48",
				"arrivesAt": "09:52",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "09:53",
				"arrivesAt": "09:58",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "09:59",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:08",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "10:09",
				"arrivesAt": "10:14",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Bălnaca h.",
				"leavesAt": "10:15",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Bălnaca h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "10:19",
				"arrivesAt": "10:25",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Peştera h.",
				"leavesAt": "10:26",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Peştera h.",
				"to": "Vadu Crişului h.",
				"leavesAt": "10:30",
				"arrivesAt": "10:33",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "10:34",
				"arrivesAt": "10:38",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Butan h.",
				"leavesAt": "10:42",
				"arrivesAt": "10:48",
				"waitsAtSource": 240,
				"distance": 5000
			},
			{
				"from": "Butan h.",
				"to": "Aleşd h.",
				"leavesAt": "10:49",
				"arrivesAt": "10:55",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Aleşd h.",
				"to": "Aleşd",
				"leavesAt": "10:56",
				"arrivesAt": "11:02",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aleşd",
				"to": "Ţeţchea hc.",
				"leavesAt": "11:03",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Telechiu Hm.",
				"leavesAt": "11:08",
				"arrivesAt": "11:13",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Telechiu Hm.",
				"to": "Tileagd",
				"leavesAt": "11:14",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Tileagd",
				"to": "Săbolciu h.",
				"leavesAt": "11:21",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Săbolciu h.",
				"to": "Săcădat h.",
				"leavesAt": "11:28",
				"arrivesAt": "11:31",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săcădat h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "11:32",
				"arrivesAt": "11:39",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea Est",
				"leavesAt": "11:40",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Oradea Est",
				"to": "Oradea",
				"leavesAt": "11:49",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7363",
		"segments": [
			{
				"from": "Buzău",
				"to": "Tăbărăşti h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:39",
				"waitsAtSource": 0,
				"distance": 9700
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "15:48",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Vizireni h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:13",
				"waitsAtSource": 300,
				"distance": 3300
			},
			{
				"from": "Vizireni h.",
				"to": "Făurei",
				"leavesAt": "16:14",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:28",
				"waitsAtSource": 120,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "16:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "17:00",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "17:09",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "17:35",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:49",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "17:55",
				"arrivesAt": "18:06",
				"waitsAtSource": 360,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1964",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "22:29",
				"arrivesAt": "22:35",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "22:37",
				"arrivesAt": "22:59",
				"waitsAtSource": 120,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "23:00",
				"arrivesAt": "23:22",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "23:23",
				"arrivesAt": "23:41",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "23:46",
				"arrivesAt": "00:00",
				"waitsAtSource": 300,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "00:01",
				"arrivesAt": "00:34",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "00:39",
				"arrivesAt": "01:24",
				"waitsAtSource": 300,
				"distance": 48600
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Mărăşeşti",
				"leavesAt": "01:26",
				"arrivesAt": "01:52",
				"waitsAtSource": 120,
				"distance": 17800
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "02:10",
				"arrivesAt": "02:34",
				"waitsAtSource": 1080,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "02:36",
				"arrivesAt": "03:13",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "03:15",
				"arrivesAt": "03:47",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "04:07",
				"arrivesAt": "04:45",
				"waitsAtSource": 1200,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Spicu",
				"leavesAt": "04:47",
				"arrivesAt": "05:12",
				"waitsAtSource": 120,
				"distance": 36400
			},
			{
				"from": "Spicu",
				"to": "Ţăndărei",
				"leavesAt": "05:13",
				"arrivesAt": "05:29",
				"waitsAtSource": 60,
				"distance": 21700
			},
			{
				"from": "Ţăndărei",
				"to": "Platoneşti h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:37",
				"waitsAtSource": 120,
				"distance": 6000
			},
			{
				"from": "Platoneşti h.",
				"to": "Movila Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "05:48",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "06:07",
				"arrivesAt": "06:27",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "06:28",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Palas",
				"leavesAt": "06:46",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 30600
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "07:04",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:55",
				"waitsAtSource": 1200,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "08:07",
				"arrivesAt": "08:14",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:25",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "08:26",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "08:35",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "08:41",
				"arrivesAt": "08:54",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "09:02",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180426",
				"to": "20180430",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4133",
		"segments": [
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "02:52",
				"arrivesAt": "03:00",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "03:01",
				"arrivesAt": "03:04",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "03:05",
				"arrivesAt": "03:09",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "03:10",
				"arrivesAt": "03:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "03:15",
				"arrivesAt": "03:21",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "03:22",
				"arrivesAt": "03:26",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Coşbuc Hm.",
				"leavesAt": "03:28",
				"arrivesAt": "03:41",
				"waitsAtSource": 120,
				"distance": 9500
			},
			{
				"from": "Coşbuc Hm.",
				"to": "Telciu Hm.",
				"leavesAt": "03:42",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Telciu Hm.",
				"to": "Fiad Hm.",
				"leavesAt": "03:51",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Fiad Hm.",
				"to": "Romuli h.",
				"leavesAt": "04:16",
				"arrivesAt": "04:25",
				"waitsAtSource": 660,
				"distance": 6700
			},
			{
				"from": "Romuli h.",
				"to": "Dealu Ştefăniţei",
				"leavesAt": "04:26",
				"arrivesAt": "04:35",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Dealu Ştefăniţei",
				"to": "Săcel Hm.",
				"leavesAt": "04:36",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Săcel Hm.",
				"to": "Iza P.M.",
				"leavesAt": "04:48",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Iza P.M.",
				"to": "Vişeu de Jos",
				"leavesAt": "04:59",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Vişeu de Jos",
				"to": "Bocicoel h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:17",
				"waitsAtSource": 120,
				"distance": 2700
			},
			{
				"from": "Bocicoel h.",
				"to": "Leordina h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:26",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Leordina h.",
				"to": "Leordina",
				"leavesAt": "05:27",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Leordina",
				"to": "Petrova hc.",
				"leavesAt": "05:34",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Petrova hc.",
				"to": "Vişeu Bistra h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Valea Vişeului",
				"leavesAt": "05:54",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Valea Vişeului",
				"to": "Lunca la Tisa h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:39",
				"waitsAtSource": 900,
				"distance": 10700
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "06:40",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Crăciuneşti h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Tisa h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Tisa h.",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "06:58",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Sighetu Marmaţiei",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 1900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "75",
		"segments": [
			{
				"from": "Lokoshaza",
				"to": "Curtici",
				"leavesAt": "13:40",
				"arrivesAt": "13:50",
				"waitsAtSource": 0,
				"distance": 11200
			},
			{
				"from": "Curtici",
				"to": "Arad",
				"leavesAt": "14:20",
				"arrivesAt": "14:34",
				"waitsAtSource": 1800,
				"distance": 17000
			},
			{
				"from": "Arad",
				"to": "Radna",
				"leavesAt": "14:36",
				"arrivesAt": "15:13",
				"waitsAtSource": 120,
				"distance": 34500
			},
			{
				"from": "Radna",
				"to": "Săvârşin",
				"leavesAt": "15:14",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Săvârşin",
				"to": "Ilia",
				"leavesAt": "16:10",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "16:58",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "17:27",
				"arrivesAt": "17:39",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Vinţu de Jos",
				"leavesAt": "17:51",
				"arrivesAt": "18:48",
				"waitsAtSource": 720,
				"distance": 43800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Sebeş Alba",
				"leavesAt": "18:49",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Sebeş Alba",
				"to": "Sibiu",
				"leavesAt": "19:00",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 73700
			},
			{
				"from": "Sibiu",
				"to": "Voila Hm.",
				"leavesAt": "20:35",
				"arrivesAt": "21:47",
				"waitsAtSource": 300,
				"distance": 71900
			},
			{
				"from": "Voila Hm.",
				"to": "Făgăraş",
				"leavesAt": "21:51",
				"arrivesAt": "22:04",
				"waitsAtSource": 240,
				"distance": 12000
			},
			{
				"from": "Făgăraş",
				"to": "Codlea Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:59",
				"waitsAtSource": 60,
				"distance": 51200
			},
			{
				"from": "Codlea Hm.",
				"to": "Braşov",
				"leavesAt": "23:00",
				"arrivesAt": "23:17",
				"waitsAtSource": 60,
				"distance": 13800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8587",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:57",
				"waitsAtSource": 0,
				"distance": 4200
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Brâncoveni h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Brâncoveni h.",
				"to": "Ciulniţa",
				"leavesAt": "20:07",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9065",
		"segments": [
			{
				"from": "Caracal",
				"to": "Canton 239+700 h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:22",
				"waitsAtSource": 0,
				"distance": 1400
			},
			{
				"from": "Canton 239+700 h.",
				"to": "Grupa Tehnică Caracal Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:27",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Grupa Tehnică Caracal Hm.",
				"to": "Deveselu h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Deveselu h.",
				"to": "Frăsinet hc.",
				"leavesAt": "18:34",
				"arrivesAt": "18:42",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Frăsinet hc.",
				"to": "Studiniţa h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Studiniţa h.",
				"to": "Studina hc.",
				"leavesAt": "18:48",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Studina hc.",
				"to": "Vişina h.",
				"leavesAt": "18:54",
				"arrivesAt": "19:01",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Vişina h.",
				"to": "Vişina Veche hc.",
				"leavesAt": "19:02",
				"arrivesAt": "19:05",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vişina Veche hc.",
				"to": "Corabia",
				"leavesAt": "19:06",
				"arrivesAt": "19:20",
				"waitsAtSource": 30,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9668",
		"segments": [
			{
				"from": "Stamora Moraviţa",
				"to": "Denta h.",
				"leavesAt": "20:45",
				"arrivesAt": "20:53",
				"waitsAtSource": 0,
				"distance": 8400
			},
			{
				"from": "Denta h.",
				"to": "Deta Hm.",
				"leavesAt": "20:54",
				"arrivesAt": "21:01",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Deta Hm.",
				"to": "Voiteni",
				"leavesAt": "21:02",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "21:13",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "21:24",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "21:31",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara Sud",
				"leavesAt": "21:40",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "21:49",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9532",
		"segments": [
			{
				"from": "Curtea de Argeş",
				"to": "Băiculeşti h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Băiculeşti h.",
				"to": "Merişani h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Merişani h.",
				"to": "Bascov Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Bascov Hm.",
				"to": "C.I.L. h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "C.I.L. h.",
				"to": "Piteşti Nord",
				"leavesAt": "16:39",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Piteşti Nord",
				"to": "Piteşti",
				"leavesAt": "16:44",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4409",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:21",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "16:38",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2710",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "16:08",
				"arrivesAt": "16:14",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băcia h.",
				"to": "Băcia Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Băcia Hm.",
				"to": "Batiz h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Batiz h.",
				"to": "Călan Băi",
				"leavesAt": "16:24",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "16:27",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Ruşi h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ruşi h.",
				"to": "Măceu h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Măceu h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Plopi h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Plopi h.",
				"to": "Covragiu h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Covragiu h.",
				"to": "Subcetate",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Subcetate",
				"to": "Ciopea h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciopea h.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Băeşti Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ruşor h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ruşor h.",
				"to": "Pui",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Pui",
				"to": "Ponor h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ponor h.",
				"to": "Livadia h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Livadia h.",
				"to": "Baru Mare",
				"leavesAt": "17:26",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Baru Mare",
				"to": "Baru Mare h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Baru Mare h.",
				"to": "Crivadia Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Crivadia Hm.",
				"to": "Merişor Hm.",
				"leavesAt": "17:48",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Merişor Hm.",
				"to": "Băniţa",
				"leavesAt": "17:57",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băniţa",
				"to": "Peştera Bolii h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Dep Petroşani h.",
				"leavesAt": "18:22",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani",
				"leavesAt": "18:25",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 288
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1969",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Paşcani",
				"leavesAt": "12:16",
				"arrivesAt": "13:19",
				"waitsAtSource": 0,
				"distance": 75700
			}
		],
		"restrictions": [
			{
				"from": "20181012",
				"to": "20181015",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5105",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Putna Seacă Hm.",
				"leavesAt": "11:15",
				"arrivesAt": "11:24",
				"waitsAtSource": 0,
				"distance": 8000
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Focşani",
				"leavesAt": "11:25",
				"arrivesAt": "11:39",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Focşani",
				"to": "Coteşti Hm.",
				"leavesAt": "11:41",
				"arrivesAt": "11:49",
				"waitsAtSource": 120,
				"distance": 7900
			},
			{
				"from": "Coteşti Hm.",
				"to": "Gugeşti",
				"leavesAt": "11:50",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Gugeşti",
				"to": "Sihlea Hm.",
				"leavesAt": "11:58",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sihlea Hm.",
				"to": "Voetin h.",
				"leavesAt": "12:06",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Voetin h.",
				"to": "Râmnicu Sărat",
				"leavesAt": "12:15",
				"arrivesAt": "12:25",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Zoita Hm.",
				"leavesAt": "12:26",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Zoita Hm.",
				"to": "Boboc Hm.",
				"leavesAt": "12:37",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Boboc Hm.",
				"to": "Buzău",
				"leavesAt": "12:48",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Buzău",
				"to": "Buzău Sud",
				"leavesAt": "13:25",
				"arrivesAt": "13:31",
				"waitsAtSource": 1500,
				"distance": 4600
			},
			{
				"from": "Buzău Sud",
				"to": "Tăbărăşti h.",
				"leavesAt": "13:32",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "13:39",
				"arrivesAt": "13:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Bentu h.",
				"leavesAt": "13:43",
				"arrivesAt": "13:48",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bentu h.",
				"to": "Cilibia Hm.",
				"leavesAt": "13:49",
				"arrivesAt": "13:54",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cilibia Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Movila Oii h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:08",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Vizireni h.",
				"leavesAt": "14:09",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vizireni h.",
				"to": "CTF Făurei h.",
				"leavesAt": "14:14",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "CTF Făurei h.",
				"to": "Făurei",
				"leavesAt": "14:19",
				"arrivesAt": "14:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "14:40",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "14:47",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "14:51",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "14:59",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "15:07",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "15:17",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "15:27",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "15:45",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "15:54",
				"arrivesAt": "16:01",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "16:02",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4508",
		"segments": [
			{
				"from": "Gheorgheni",
				"to": "Valea Strâmbă h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Şugău h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:06",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Şugău h.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "13:07",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "13:12",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Sândominic h.",
				"leavesAt": "13:23",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Oltului",
				"leavesAt": "13:32",
				"arrivesAt": "13:37",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Tomeşti h.",
				"leavesAt": "13:38",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Cârţani h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:45",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Cârţani h.",
				"to": "Dăneşti h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Dăneşti h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "13:50",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Racu h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Racu h.",
				"to": "Siculeni",
				"leavesAt": "14:03",
				"arrivesAt": "14:08",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "14:12",
				"arrivesAt": "14:21",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "14:27",
				"arrivesAt": "14:35",
				"waitsAtSource": 360,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "14:40",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Vrabia h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vrabia h.",
				"to": "Tuşnad Sat",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "15:04",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Malnaş Băi",
				"leavesAt": "15:17",
				"arrivesAt": "15:27",
				"waitsAtSource": 300,
				"distance": 7800
			},
			{
				"from": "Malnaş Băi",
				"to": "Malnaş h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Malnaş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Bodoc Hm.",
				"to": "Arcuş h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:55",
				"waitsAtSource": 480,
				"distance": 4500
			},
			{
				"from": "Arcuş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "15:56",
				"arrivesAt": "16:01",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:09",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "16:15",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "16:25",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2094",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "14:00",
				"arrivesAt": "14:08",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Budieni h.",
				"leavesAt": "14:09",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Budieni h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "14:14",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Pojogeni Hm.",
				"leavesAt": "14:24",
				"arrivesAt": "14:27",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "14:28",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "14:49",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "15:01",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "15:17",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "15:21",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Bungeţel h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bungeţel h.",
				"to": "Filiaşi",
				"leavesAt": "15:31",
				"arrivesAt": "15:35",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:41",
				"waitsAtSource": 180,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "15:46",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:51",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "15:52",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "16:03",
				"arrivesAt": "16:08",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "16:18",
				"arrivesAt": "16:20",
				"waitsAtSource": 600,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "16:21",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "16:26",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "16:29",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2494",
		"segments": [
			{
				"from": "Cugir  Hm.",
				"to": "Cugir hc.",
				"leavesAt": "15:10",
				"arrivesAt": "15:13",
				"waitsAtSource": 0,
				"distance": 600
			},
			{
				"from": "Cugir hc.",
				"to": "Vinerea h.",
				"leavesAt": "15:14",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vinerea h.",
				"to": "Şibot",
				"leavesAt": "15:27",
				"arrivesAt": "15:40",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Şibot",
				"to": "Balomiru de Câmp h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Balomiru de Câmp h.",
				"to": "Tărtăria h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Tărtăria h.",
				"to": "Blandiana Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Blandiana Hm.",
				"to": "Vinţu de Jos",
				"leavesAt": "16:06",
				"arrivesAt": "16:14",
				"waitsAtSource": 300,
				"distance": 5200
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "16:15",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:38",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru  Hm.",
				"leavesAt": "16:39",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Sântimbru  Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "16:51",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "17:04",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2210",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "15:40",
				"arrivesAt": "15:48",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "15:49",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 799
			},
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180623",
				"to": "20180624",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2232",
		"segments": [
			{
				"from": "Remetea Mică",
				"to": "Şarlota h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:36",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Şarlota h.",
				"to": "Gomila h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Gomila h.",
				"to": "Aliuş hcv.",
				"leavesAt": "06:46",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Aliuş hcv.",
				"to": "Zăbrani Hm.",
				"leavesAt": "06:55",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Zăbrani Hm.",
				"to": "Neudorf h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Neudorf h.",
				"to": "Radna",
				"leavesAt": "07:12",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5205",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "12:40",
				"arrivesAt": "12:46",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:50",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "12:51",
				"arrivesAt": "12:56",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "12:57",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "13:01",
				"arrivesAt": "13:12",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Urecheşti Hm.",
				"leavesAt": "13:14",
				"arrivesAt": "13:24",
				"waitsAtSource": 120,
				"distance": 9700
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Bâlca hc.",
				"leavesAt": "13:29",
				"arrivesAt": "13:33",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Bâlca hc.",
				"to": "Căiuţi Hm.",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Borzeşti Bacău",
				"leavesAt": "13:40",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Oneşti",
				"leavesAt": "13:54",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Oneşti",
				"to": "Trotuş h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:09",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Trotuş h.",
				"to": "Viişoara h",
				"leavesAt": "14:10",
				"arrivesAt": "14:14",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Viişoara h",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "14:15",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Saline hc.",
				"leavesAt": "14:21",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Saline hc.",
				"to": "Cireşoaia h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cireşoaia h.",
				"to": "Dofteana Bacău",
				"leavesAt": "14:31",
				"arrivesAt": "14:35",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dofteana Bacău",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Valea Uzului Hm.",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Comăneşti",
				"leavesAt": "14:48",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Comăneşti",
				"to": "Asău Hm.",
				"leavesAt": "15:00",
				"arrivesAt": "15:07",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Asău Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "15:08",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Caraliţa h.",
				"to": "Goioasa Hm.",
				"leavesAt": "15:13",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Goioasa Hm.",
				"to": "Simbrea Hm.",
				"leavesAt": "15:19",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Simbrea Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "15:27",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Palanca Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:39",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Palanca Hm.",
				"to": "Ghimeş",
				"leavesAt": "15:40",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8344",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Palas",
				"leavesAt": "18:02",
				"arrivesAt": "18:09",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Palas",
				"to": "Valul lui Traian",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Valul lui Traian",
				"to": "Murfatlar h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Murfatlar h.",
				"to": "Basarabi",
				"leavesAt": "18:24",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "18:29",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Dorobanţu",
				"leavesAt": "18:34",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Dorobanţu",
				"to": "Castelu h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Castelu h.",
				"to": "Medgidia",
				"leavesAt": "18:43",
				"arrivesAt": "18:49",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Medgidia",
				"to": "Mircea Vodă Hm.",
				"leavesAt": "18:50",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Mircea Vodă Hm.",
				"to": "Saligny",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Saligny",
				"to": "Cernavodă Pod",
				"leavesAt": "19:07",
				"arrivesAt": "19:16",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Cernavodă Pod",
				"to": "Dunărea Hm.",
				"leavesAt": "19:17",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Dunărea Hm.",
				"to": "Ovidiu",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ovidiu",
				"to": "Ramificaţia Borcea",
				"leavesAt": "19:34",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ramificaţia Borcea",
				"to": "Feteşti",
				"leavesAt": "19:39",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Feteşti",
				"to": "Bărăganu Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:05",
				"waitsAtSource": 540,
				"distance": 9900
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Jegălia",
				"leavesAt": "20:11",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Jegălia",
				"to": "Recolta hc.",
				"leavesAt": "20:17",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Recolta hc.",
				"to": "Perişoru Hm.",
				"leavesAt": "20:21",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Perişoru Hm.",
				"to": "Ogoarele h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ogoarele h.",
				"to": "Ciulniţa",
				"leavesAt": "20:31",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ciulniţa",
				"to": "Ştefan Vodă h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:55",
				"waitsAtSource": 120,
				"distance": 12600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "20:56",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Km. 25+700 h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Sud",
				"leavesAt": "21:10",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20180917",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1746",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Mireşu Mare PM.",
				"leavesAt": "05:12",
				"arrivesAt": "05:39",
				"waitsAtSource": 0,
				"distance": 25100
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Benesat Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Benesat Hm.",
				"to": "Jibou",
				"leavesAt": "05:58",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Jibou",
				"to": "Letca Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:55",
				"waitsAtSource": 600,
				"distance": 23100
			},
			{
				"from": "Letca Hm.",
				"to": "Ileanda",
				"leavesAt": "06:56",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Ileanda",
				"to": "Gâlgău",
				"leavesAt": "07:14",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Gâlgău",
				"to": "Câţcău h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Câţcău h.",
				"to": "Dej Călători",
				"leavesAt": "07:43",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 12700
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "08:12",
				"arrivesAt": "08:31",
				"waitsAtSource": 900,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Apahida",
				"leavesAt": "08:32",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 57200
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca",
				"leavesAt": "09:08",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": -12300
			},
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "09:37",
				"arrivesAt": "10:43",
				"waitsAtSource": 720,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "10:44",
				"arrivesAt": "11:00",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "11:01",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "11:07",
				"arrivesAt": "11:22",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "11:23",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Blaj",
				"leavesAt": "11:41",
				"arrivesAt": "12:09",
				"waitsAtSource": 240,
				"distance": 21300
			},
			{
				"from": "Blaj",
				"to": "Copşa Mică",
				"leavesAt": "12:10",
				"arrivesAt": "12:48",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Copşa Mică",
				"to": "Mediaş",
				"leavesAt": "12:53",
				"arrivesAt": "13:06",
				"waitsAtSource": 300,
				"distance": 10400
			},
			{
				"from": "Mediaş",
				"to": "Dumbrăveni",
				"leavesAt": "13:08",
				"arrivesAt": "13:33",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Dumbrăveni",
				"to": "Sighişoara",
				"leavesAt": "13:34",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Sighişoara",
				"to": "Rupea",
				"leavesAt": "14:04",
				"arrivesAt": "15:05",
				"waitsAtSource": 180,
				"distance": 53600
			},
			{
				"from": "Rupea",
				"to": "Racoş Hm.",
				"leavesAt": "15:06",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 14000
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Braşov",
				"leavesAt": "15:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 49100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "16:57",
				"arrivesAt": "17:33",
				"waitsAtSource": 720,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "17:35",
				"arrivesAt": "17:43",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "17:44",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "17:51",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "18:02",
				"arrivesAt": "18:16",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Câmpina",
				"leavesAt": "18:17",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "18:30",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "18:56",
				"arrivesAt": "19:40",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6413",
		"segments": [
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "04:49",
				"arrivesAt": "04:59",
				"waitsAtSource": 0,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "05:10",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "05:31",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "05:38",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:57",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:11",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "06:20",
				"arrivesAt": "06:27",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2515",
		"segments": [
			{
				"from": "Făgăraş",
				"to": "Dridif h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:54",
				"waitsAtSource": 0,
				"distance": 8500
			},
			{
				"from": "Dridif h.",
				"to": "Voila Hm.",
				"leavesAt": "04:55",
				"arrivesAt": "04:59",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Voila Hm.",
				"to": "Olteţ h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Olteţ h.",
				"to": "Viştea h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Viştea h.",
				"to": "Ucea",
				"leavesAt": "05:12",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:35",
				"waitsAtSource": 540,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 120,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:13",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "06:14",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Triaj",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sibiu Triaj",
				"to": "Atelier Zona h",
				"leavesAt": "06:54",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h",
				"to": "Sibiu",
				"leavesAt": "06:59",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1897",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "17:30",
				"arrivesAt": "18:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "18:35",
				"arrivesAt": "18:54",
				"waitsAtSource": 300,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "18:55",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "19:19",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Piteşti",
				"to": "Costeşti",
				"leavesAt": "19:40",
				"arrivesAt": "20:04",
				"waitsAtSource": 600,
				"distance": 21800
			},
			{
				"from": "Costeşti",
				"to": "Stolnici Hm.",
				"leavesAt": "20:05",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Stolnici Hm.",
				"to": "Slatina",
				"leavesAt": "20:20",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 43300
			},
			{
				"from": "Slatina",
				"to": "Piatra Olt",
				"leavesAt": "21:00",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Piatra Olt",
				"to": "Balş",
				"leavesAt": "21:19",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Balş",
				"to": "Craiova",
				"leavesAt": "21:31",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 31200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5730",
		"segments": [
			{
				"from": "Cacica Hm.",
				"to": "Pârteşti h.",
				"leavesAt": "04:03",
				"arrivesAt": "04:10",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Pârteşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "04:11",
				"arrivesAt": "04:17",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Soloneţ h.",
				"to": "Todireşti h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:25",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Todireşti h.",
				"to": "Părhăuţi h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Părhăuţi h.",
				"to": "Dărmăneşti",
				"leavesAt": "04:35",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "04:44",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2237",
		"segments": [
			{
				"from": "Remetea Mică",
				"to": "Fibiş h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:30",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Bencei h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bencei h.",
				"to": "Pişchia h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pişchia h.",
				"to": "Cerneteaz h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Cerneteaz h.",
				"to": "Giarmata Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Giarmata Hm.",
				"to": "Viile Giarmata h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Timişoara Est",
				"leavesAt": "16:05",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180630",
				"to": "20180630",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9505",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "12:35",
				"arrivesAt": "12:38",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Işalniţa hc.",
				"leavesAt": "12:39",
				"arrivesAt": "12:44",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "12:45",
				"arrivesAt": "12:48",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "12:49",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "12:53",
				"arrivesAt": "12:57",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "13:03",
				"arrivesAt": "13:08",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "13:09",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "13:13",
				"arrivesAt": "13:18",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Gura Motrului Hm.",
				"leavesAt": "13:19",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Butoieşti Hm.",
				"leavesAt": "13:28",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Lunca Banului h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lunca Banului h.",
				"to": "Strehaia",
				"leavesAt": "13:41",
				"arrivesAt": "13:45",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Strehaia",
				"to": "Strehaia hc.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia hc.",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "13:50",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Tâmna",
				"leavesAt": "13:59",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Tâmna",
				"to": "Igiroasa Hm.",
				"leavesAt": "14:08",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "14:14",
				"arrivesAt": "14:21",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prunişor Hm.",
				"to": "Gârniţa Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:28",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Balota",
				"leavesAt": "14:29",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Balota",
				"to": "Valea Albă Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Ergheviţa h.",
				"leavesAt": "14:49",
				"arrivesAt": "14:55",
				"waitsAtSource": 240,
				"distance": 3300
			},
			{
				"from": "Ergheviţa h.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "14:56",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "15:14",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Gura Văii Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:28",
				"waitsAtSource": 120,
				"distance": 8500
			},
			{
				"from": "Gura Văii Hm.",
				"to": "Vârciorova Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Vârciorova Hm.",
				"to": "Orşova",
				"leavesAt": "15:41",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 7700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8655",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Basarabi",
				"leavesAt": "15:43",
				"arrivesAt": "15:58",
				"waitsAtSource": 0,
				"distance": 17400
			},
			{
				"from": "Basarabi",
				"to": "Poarta Albă h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Poarta Albă h.",
				"to": "Medgidia",
				"leavesAt": "16:04",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Medgidia",
				"to": "Nicolae Bălcescu",
				"leavesAt": "16:45",
				"arrivesAt": "17:06",
				"waitsAtSource": 1680,
				"distance": 19100
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "17:14",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Cogealac",
				"leavesAt": "17:25",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Cogealac",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 17400
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Baia Dobrogea",
				"leavesAt": "18:06",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Baia Dobrogea",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Babadag",
				"leavesAt": "18:25",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Babadag",
				"to": "Zebil h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Zebil h.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Cataloi Hm.",
				"leavesAt": "19:15",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Cataloi Hm.",
				"to": "Tulcea Mărfuri",
				"leavesAt": "19:30",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Tulcea Oraş",
				"leavesAt": "19:44",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20180911",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180609",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6411",
		"segments": [
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "03:56",
				"arrivesAt": "04:06",
				"waitsAtSource": 0,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "04:07",
				"arrivesAt": "04:12",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "04:13",
				"arrivesAt": "04:17",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "04:18",
				"arrivesAt": "04:25",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "04:32",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "04:46",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "04:56",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "05:12",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "05:19",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "05:26",
				"arrivesAt": "05:33",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "407",
		"segments": [
			{
				"from": "Biharkeresztes",
				"to": "Episcopia Bihor",
				"leavesAt": "22:53",
				"arrivesAt": "23:08",
				"waitsAtSource": 0,
				"distance": 12500
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "23:23",
				"arrivesAt": "23:31",
				"waitsAtSource": 900,
				"distance": 5700
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "23:35",
				"arrivesAt": "00:08",
				"waitsAtSource": 240,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Huedin",
				"leavesAt": "00:09",
				"arrivesAt": "01:16",
				"waitsAtSource": 60,
				"distance": 68400
			},
			{
				"from": "Huedin",
				"to": "Cluj Napoca",
				"leavesAt": "01:17",
				"arrivesAt": "02:08",
				"waitsAtSource": 60,
				"distance": 49400
			},
			{
				"from": "Cluj Napoca",
				"to": "Gherla",
				"leavesAt": "02:20",
				"arrivesAt": "03:18",
				"waitsAtSource": 720,
				"distance": 44900
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "03:20",
				"arrivesAt": "03:39",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "03:44",
				"arrivesAt": "04:17",
				"waitsAtSource": 300,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Sărăţel Hm.",
				"leavesAt": "04:19",
				"arrivesAt": "04:46",
				"waitsAtSource": 120,
				"distance": 24900
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Deda",
				"leavesAt": "04:54",
				"arrivesAt": "05:48",
				"waitsAtSource": 480,
				"distance": 46800
			},
			{
				"from": "Deda",
				"to": "Topliţa",
				"leavesAt": "05:49",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 43900
			},
			{
				"from": "Topliţa",
				"to": "Gheorgheni",
				"leavesAt": "06:47",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Gheorgheni",
				"to": "Izvoru Oltului",
				"leavesAt": "07:20",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "07:49",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "08:08",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:50",
				"waitsAtSource": 360,
				"distance": 20700
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "08:52",
				"arrivesAt": "09:24",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "09:27",
				"arrivesAt": "09:57",
				"waitsAtSource": 180,
				"distance": 32100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7039",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "19:55",
				"arrivesAt": "20:01",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Mogoşoaia",
				"leavesAt": "20:07",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Mogoşoaia",
				"to": "P.O. Aeroport h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "20:37",
				"arrivesAt": "20:40",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "20:41",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "20:47",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "20:59",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "21:19",
				"arrivesAt": "21:25",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "21:26",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "21:31",
				"arrivesAt": "21:38",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9510",
		"segments": [
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:23",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "13:24",
				"arrivesAt": "13:28",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "13:40",
				"arrivesAt": "13:43",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "13:44",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "13:50",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "13:53",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "13:58",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "14:01",
				"arrivesAt": "14:05",
				"waitsAtSource": 30,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180115",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180212",
				"to": "20180330",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2080",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Lunca Jiului hc.",
				"leavesAt": "04:45",
				"arrivesAt": "04:48",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Livezeni",
				"leavesAt": "04:49",
				"arrivesAt": "04:54",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "04:55",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Lainici Hm.",
				"leavesAt": "05:13",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lainici Hm.",
				"to": "Meri",
				"leavesAt": "05:28",
				"arrivesAt": "05:37",
				"waitsAtSource": 300,
				"distance": 6400
			},
			{
				"from": "Meri",
				"to": "Valea Sadului Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Parângu Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Parângu Hm.",
				"to": "Ezureni h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ezureni h.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "06:02",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Târgu Jiu",
				"leavesAt": "06:11",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 800
			},
			{
				"from": "Târgu Jiu",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:31",
				"waitsAtSource": 540,
				"distance": 6800
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Budieni h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Budieni h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Pojogeni Hm.",
				"leavesAt": "06:47",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "06:51",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "07:05",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "07:16",
				"arrivesAt": "07:23",
				"waitsAtSource": 300,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "07:24",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "07:30",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "07:46",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Bungeţel h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bungeţel h.",
				"to": "Filiaşi",
				"leavesAt": "08:01",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:38",
				"waitsAtSource": 1800,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "08:44",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "08:56",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "09:00",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Cernele",
				"leavesAt": "09:06",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "09:12",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "09:16",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4371",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Sărata h.",
				"leavesAt": "19:22",
				"arrivesAt": "19:30",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "19:37",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:47",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Sfântu h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Sfântu h.",
				"to": "Caila hc.",
				"leavesAt": "19:54",
				"arrivesAt": "19:57",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Caila hc.",
				"to": "Şintereag Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "20:03",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "20:14",
				"arrivesAt": "20:24",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "20:37",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "20:49",
				"arrivesAt": "20:56",
				"waitsAtSource": 120,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2610",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "18:04",
				"arrivesAt": "18:11",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Valea Viilor Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Şag Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "18:33",
				"arrivesAt": "18:40",
				"waitsAtSource": 300,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "18:48",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "18:54",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "19:02",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h",
				"leavesAt": "19:09",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "19:12",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Timişoara Nord",
				"leavesAt": "19:15",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9101",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "05:33",
				"arrivesAt": "05:43",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "05:44",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "06:17",
				"arrivesAt": "06:26",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "06:38",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:57",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "07:01",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "07:09",
				"arrivesAt": "07:12",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "07:13",
				"arrivesAt": "07:21",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8152",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Perieţi h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:39",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Perieţi h.",
				"to": "Fundata h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Fundata h.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "14:46",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Ciochina hc.",
				"leavesAt": "14:53",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciochina hc.",
				"to": "Căzăneşti",
				"leavesAt": "15:03",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Căzăneşti",
				"to": "Munteni Buzău h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:24",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Km. 74+600 h.",
				"leavesAt": "15:25",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Malu h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Malu h.",
				"to": "Broşteni Hm.",
				"leavesAt": "15:36",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Alexeni h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Alexeni h.",
				"to": "Urziceni",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5633",
		"segments": [
			{
				"from": "Dărmăneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:06",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Ţibeni h.",
				"leavesAt": "09:07",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ţibeni h.",
				"to": "Dorneşti",
				"leavesAt": "09:16",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9556",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Caransebeş haltă h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:55",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Balta Sărată",
				"leavesAt": "19:56",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Balta Sărată",
				"to": "Valea Timişului Hm.",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Petroşniţa h.",
				"to": "Vălişoara Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Slatina Timiş",
				"leavesAt": "20:23",
				"arrivesAt": "20:29",
				"waitsAtSource": 300,
				"distance": 6400
			},
			{
				"from": "Slatina Timiş",
				"to": "Armeniş",
				"leavesAt": "20:30",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Armeniş",
				"to": "Teregova Hm.",
				"leavesAt": "20:38",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Teregova Hm.",
				"to": "Poarta Hm.",
				"leavesAt": "20:46",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Poarta Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Luncaviţa h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "21:02",
				"arrivesAt": "21:07",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Cornea h.",
				"leavesAt": "21:08",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cornea h.",
				"to": "Cruşovăţ",
				"leavesAt": "21:13",
				"arrivesAt": "21:19",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cruşovăţ",
				"to": "Iablaniţa",
				"leavesAt": "21:20",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Iablaniţa",
				"to": "Mehadia Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mehadia Hm.",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "21:40",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Băile Herculane",
				"leavesAt": "21:44",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Băile Herculane",
				"to": "Topleţ Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:07",
				"waitsAtSource": 660,
				"distance": 7200
			},
			{
				"from": "Topleţ Hm.",
				"to": "Orşova",
				"leavesAt": "22:08",
				"arrivesAt": "22:18",
				"waitsAtSource": 60,
				"distance": 10300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2457",
		"segments": [
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:03",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "07:04",
				"arrivesAt": "07:12",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "07:20",
				"arrivesAt": "07:23",
				"waitsAtSource": 480,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "07:24",
				"arrivesAt": "07:32",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "07:33",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "07:41",
				"arrivesAt": "07:43",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:50",
				"waitsAtSource": 300,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "08:04",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5403",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "11:35",
				"arrivesAt": "11:42",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "11:48",
				"arrivesAt": "11:54",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "11:55",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "11:59",
				"arrivesAt": "12:11",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Adjudu Vechi h.",
				"leavesAt": "12:12",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Şişcani h.",
				"leavesAt": "12:17",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Şişcani h.",
				"to": "Sascut Hm.",
				"leavesAt": "12:22",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sascut Hm.",
				"to": "Orbeni Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Orbeni Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Răcăciuni h.",
				"to": "Faraoani Hm.",
				"leavesAt": "12:44",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Faraoani Hm.",
				"to": "Siretu Bacău h.",
				"leavesAt": "12:53",
				"arrivesAt": "12:58",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Valea Seacă",
				"leavesAt": "12:59",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Valea Seacă",
				"to": "Letea h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Letea h.",
				"to": "Bacău",
				"leavesAt": "13:12",
				"arrivesAt": "13:18",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2234",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Est",
				"leavesAt": "14:13",
				"arrivesAt": "14:19",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Timişoara Est",
				"to": "Viile Giarmata h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Viile Giarmata h.",
				"to": "Giarmata Hm.",
				"leavesAt": "14:28",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Giarmata Hm.",
				"to": "Cerneteaz h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Cerneteaz h.",
				"to": "Pişchia h.",
				"leavesAt": "14:38",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Pişchia h.",
				"to": "Bencei h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Bencei h.",
				"to": "Fibiş h.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Fibiş h.",
				"to": "Remetea Mică",
				"leavesAt": "15:02",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 4300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4703",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Podereia Feldrului h.",
				"leavesAt": "09:30",
				"arrivesAt": "09:34",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Feldru Hm.",
				"leavesAt": "09:35",
				"arrivesAt": "09:40",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Feldru Hm.",
				"to": "Nepos h.",
				"leavesAt": "09:47",
				"arrivesAt": "09:52",
				"waitsAtSource": 420,
				"distance": 4700
			},
			{
				"from": "Nepos h.",
				"to": "Rebrişoara Hm.",
				"leavesAt": "09:53",
				"arrivesAt": "09:59",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Năsăud",
				"leavesAt": "10:00",
				"arrivesAt": "10:05",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Năsăud",
				"to": "Năsăud h.",
				"leavesAt": "10:07",
				"arrivesAt": "10:10",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Năsăud h.",
				"to": "Salva",
				"leavesAt": "10:11",
				"arrivesAt": "10:16",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Salva",
				"to": "Mititei h.",
				"leavesAt": "10:18",
				"arrivesAt": "10:21",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Mititei h.",
				"to": "Nimigea Hm.",
				"leavesAt": "10:22",
				"arrivesAt": "10:28",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "10:29",
				"arrivesAt": "10:32",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "10:33",
				"arrivesAt": "10:37",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "10:38",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "10:41",
				"arrivesAt": "10:50",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "10:52",
				"arrivesAt": "11:02",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "11:03",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "11:07",
				"arrivesAt": "11:09",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "11:10",
				"arrivesAt": "11:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Dej Triaj",
				"leavesAt": "11:15",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "11:26",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:55",
				"waitsAtSource": 840,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "11:56",
				"arrivesAt": "12:07",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "12:08",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "12:15",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "12:25",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "12:31",
				"arrivesAt": "12:34",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "12:35",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "12:54",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "12:58",
				"arrivesAt": "13:06",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "13:07",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "13:13",
				"arrivesAt": "13:18",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171231",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3745",
		"segments": [
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "13:00",
				"arrivesAt": "13:10",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Utviniş h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:19",
				"waitsAtSource": 300,
				"distance": 3100
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:24",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "13:25",
				"arrivesAt": "13:37",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Comlăuş h.",
				"leavesAt": "13:38",
				"arrivesAt": "13:42",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Comlăuş h.",
				"to": "Şimand Hm.",
				"leavesAt": "13:43",
				"arrivesAt": "13:51",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Şimand Hm.",
				"to": "Nădab",
				"leavesAt": "13:52",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Nădab",
				"to": "Chişineu Criş",
				"leavesAt": "14:01",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 4900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5472",
		"segments": [
			{
				"from": "Bicaz",
				"to": "Tarcău Neamţ Hm.",
				"leavesAt": "07:06",
				"arrivesAt": "07:13",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Tarcău Neamţ Hm.",
				"to": "Stejaru h.",
				"leavesAt": "07:14",
				"arrivesAt": "07:20",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stejaru h.",
				"to": "Pângăraţi Hm.",
				"leavesAt": "07:21",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pângăraţi Hm.",
				"to": "Vaduri h.",
				"leavesAt": "07:26",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Vaduri h.",
				"to": "Piatra Neamţ",
				"leavesAt": "07:32",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Piatra Neamţ",
				"to": "Dumbrava h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Săvineşti h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săvineşti h.",
				"to": "Roznov",
				"leavesAt": "07:59",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Roznov",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Podoleni Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Podoleni Hm.",
				"to": "Costişa h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Costişa h.",
				"to": "Buhuşi",
				"leavesAt": "08:27",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhuşi",
				"to": "Racova h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Racova h.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Gârleni Hm.",
				"leavesAt": "08:48",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Gârleni Hm.",
				"to": "Hămeiuş P.M.",
				"leavesAt": "08:53",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Bacău",
				"leavesAt": "09:00",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 7900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8391",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "18:19",
				"arrivesAt": "18:28",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "18:35",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "18:43",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "18:49",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "18:56",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "19:04",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "19:08",
				"arrivesAt": "19:16",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "19:17",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "19:22",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4315",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "11:24",
				"arrivesAt": "11:30",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "11:31",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "11:37",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "11:48",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Apa Hm.",
				"to": "Seini",
				"leavesAt": "11:57",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Seini",
				"to": "Săbişa h.",
				"leavesAt": "12:10",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Săbişa h.",
				"to": "Ilba h.",
				"leavesAt": "12:16",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ilba h.",
				"to": "Cicârlău h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Cicârlău h.",
				"to": "Buşag Hm.",
				"leavesAt": "12:31",
				"arrivesAt": "12:39",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Buşag Hm.",
				"to": "Baia Mare",
				"leavesAt": "12:50",
				"arrivesAt": "13:10",
				"waitsAtSource": 660,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3630",
		"segments": [
			{
				"from": "Poieni",
				"to": "Bologa h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:52",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Bologa h.",
				"to": "Brăişoru Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "16:58",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Aghireş h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "17:53",
				"arrivesAt": "17:56",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "17:57",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "18:08",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9340",
		"segments": [
			{
				"from": "Giurgiu",
				"to": "Giurgiu Nord",
				"leavesAt": "04:00",
				"arrivesAt": "04:05",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Giurgiu Nord",
				"to": "Cetatea h.",
				"leavesAt": "04:06",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cetatea h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "04:10",
				"arrivesAt": "04:13",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Onceşti h.",
				"leavesAt": "04:14",
				"arrivesAt": "04:17",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Onceşti h.",
				"to": "Stăneşti Hm.",
				"leavesAt": "04:18",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Chiriacu Hm.",
				"leavesAt": "04:24",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Toporu",
				"leavesAt": "04:32",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Toporu",
				"to": "Răsuceni h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Răsuceni h.",
				"to": "Vlaşca Hm.",
				"leavesAt": "04:46",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "04:54",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Târnavele Hm.",
				"to": "Răduleşti Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Videle",
				"leavesAt": "05:15",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "05:35",
				"arrivesAt": "05:40",
				"waitsAtSource": 540,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:54",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Zorile h.",
				"leavesAt": "05:55",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zorile h.",
				"to": "Grădinari",
				"leavesAt": "06:00",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 540,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "06:25",
				"arrivesAt": "06:40",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "06:44",
				"arrivesAt": "06:48",
				"waitsAtSource": 240,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Carpaţi h.(900)",
				"leavesAt": "06:49",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "06:54",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Nord",
				"leavesAt": "06:58",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8581",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:50",
				"waitsAtSource": 0,
				"distance": 4200
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Brâncoveni h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Brâncoveni h.",
				"to": "Ciulniţa",
				"leavesAt": "06:00",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1559",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "20:09",
				"arrivesAt": "20:57",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "21:00",
				"arrivesAt": "21:33",
				"waitsAtSource": 180,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "21:34",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 35000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1757",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "23:20",
				"arrivesAt": "00:08",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "00:11",
				"arrivesAt": "00:44",
				"waitsAtSource": 180,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "00:46",
				"arrivesAt": "01:21",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "01:23",
				"arrivesAt": "01:54",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "01:56",
				"arrivesAt": "02:34",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "02:36",
				"arrivesAt": "02:58",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "03:00",
				"arrivesAt": "03:26",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "03:28",
				"arrivesAt": "04:05",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "04:14",
				"arrivesAt": "04:43",
				"waitsAtSource": 540,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "04:44",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "05:15",
				"arrivesAt": "05:35",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "05:36",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "06:02",
				"arrivesAt": "06:14",
				"waitsAtSource": 600,
				"distance": 14800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9360",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "03:00",
				"arrivesAt": "03:03",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "03:04",
				"arrivesAt": "03:15",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "03:16",
				"arrivesAt": "03:28",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "03:29",
				"arrivesAt": "03:36",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "03:37",
				"arrivesAt": "03:51",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "03:52",
				"arrivesAt": "03:59",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171225",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20180101",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1636",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "05:25",
				"arrivesAt": "05:49",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "05:50",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "06:08",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "06:29",
				"arrivesAt": "06:52",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Lehliu",
				"leavesAt": "06:53",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 39300
			},
			{
				"from": "Lehliu",
				"to": "Bucureşti Nord",
				"leavesAt": "07:13",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 69600
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "08:10",
				"arrivesAt": "08:48",
				"waitsAtSource": 1140,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "08:50",
				"arrivesAt": "09:13",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "09:14",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "09:39",
				"arrivesAt": "09:47",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "09:48",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "09:54",
				"arrivesAt": "10:03",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "10:05",
				"arrivesAt": "10:43",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1737",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Călimăneşti",
				"leavesAt": "04:10",
				"arrivesAt": "04:25",
				"waitsAtSource": 0,
				"distance": 16200
			},
			{
				"from": "Călimăneşti",
				"to": "Turnu Roşu hc.",
				"leavesAt": "04:26",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 58300
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "05:41",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "05:53",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 17800
			},
			{
				"from": "Sibiu",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "06:17",
				"arrivesAt": "06:28",
				"waitsAtSource": 300,
				"distance": 10400
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "06:29",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Loamneş Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Loamneş Hm.",
				"to": "Şeica Mare",
				"leavesAt": "06:42",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Şeica Mare",
				"to": "Copşa Mică",
				"leavesAt": "06:56",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Copşa Mică",
				"to": "Blaj",
				"leavesAt": "07:15",
				"arrivesAt": "07:52",
				"waitsAtSource": 360,
				"distance": 30000
			},
			{
				"from": "Blaj",
				"to": "Teiuş",
				"leavesAt": "07:54",
				"arrivesAt": "08:22",
				"waitsAtSource": 120,
				"distance": 21300
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:38",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Unirea hc.",
				"leavesAt": "08:39",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "09:08",
				"arrivesAt": "09:23",
				"waitsAtSource": 360,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Apahida",
				"leavesAt": "09:24",
				"arrivesAt": "10:12",
				"waitsAtSource": 60,
				"distance": 39200
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca",
				"leavesAt": "10:13",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 12300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8211",
		"segments": [
			{
				"from": "Făurei",
				"to": "Cireşu Hm.",
				"leavesAt": "18:55",
				"arrivesAt": "19:08",
				"waitsAtSource": 0,
				"distance": 15700
			},
			{
				"from": "Cireşu Hm.",
				"to": "Scărlăteşti hc.",
				"leavesAt": "19:09",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scărlăteşti hc.",
				"to": "Dudeşti Hm.",
				"leavesAt": "19:14",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dudeşti Hm.",
				"to": "Spicu",
				"leavesAt": "19:20",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Spicu",
				"to": "Murgeanca Hm.",
				"leavesAt": "19:28",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Murgeanca Hm.",
				"to": "Ţăndărei",
				"leavesAt": "19:36",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Ţăndărei",
				"to": "Platoneşti h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:54",
				"waitsAtSource": 120,
				"distance": 6000
			},
			{
				"from": "Platoneşti h.",
				"to": "Movila Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Movila Hm.",
				"to": "Feteşti",
				"leavesAt": "20:05",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 16700
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "20:25",
				"arrivesAt": "20:45",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "20:46",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Basarabi",
				"leavesAt": "21:05",
				"arrivesAt": "21:17",
				"waitsAtSource": 120,
				"distance": 17200
			},
			{
				"from": "Basarabi",
				"to": "Constanţa",
				"leavesAt": "21:18",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 17400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5113",
		"segments": [
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:54",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "17:55",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "18:06",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "18:30",
				"arrivesAt": "18:37",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "18:38",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "18:47",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "18:56",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:22",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "19:23",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1721",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(901)",
				"leavesAt": "14:55",
				"arrivesAt": "14:57",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Cârcea h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Cârcea h.",
				"to": "Toporaş h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Toporaş h.",
				"to": "Spineni h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Spineni h.",
				"to": "Balş",
				"leavesAt": "15:28",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Balş",
				"to": "Canton 217 h.",
				"leavesAt": "15:35",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Canton 217 h.",
				"to": "Brăneţ h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:42",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Brăneţ h.",
				"to": "Piatra Olt",
				"leavesAt": "15:43",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Piatra Olt",
				"to": "Drăgăşani",
				"leavesAt": "16:00",
				"arrivesAt": "16:26",
				"waitsAtSource": 480,
				"distance": 33800
			},
			{
				"from": "Drăgăşani",
				"to": "Băbeni",
				"leavesAt": "16:27",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Băbeni",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "16:53",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Călimăneşti",
				"leavesAt": "17:14",
				"arrivesAt": "17:29",
				"waitsAtSource": 120,
				"distance": 16200
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Lotru",
				"leavesAt": "17:35",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Lotru",
				"to": "Turnu Roşu hc.",
				"leavesAt": "18:05",
				"arrivesAt": "18:57",
				"waitsAtSource": 780,
				"distance": 42700
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "18:58",
				"arrivesAt": "19:07",
				"waitsAtSource": 30,
				"distance": 7300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "19:08",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9487",
		"segments": [
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "20:00",
				"arrivesAt": "20:06",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "20:07",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "20:20",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7032",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:22",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "04:29",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Moldoveni h.",
				"to": "Dridu Hm.",
				"leavesAt": "04:35",
				"arrivesAt": "04:41",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Dridu Hm.",
				"to": "Fierbinţi",
				"leavesAt": "04:42",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Fierbinţi",
				"to": "Greci h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Greci h.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "04:57",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "05:04",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Baloteşti Hm.",
				"leavesAt": "05:10",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Baloteşti Hm.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Mogoşoaia",
				"leavesAt": "05:20",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Mogoşoaia",
				"to": "Chitila",
				"leavesAt": "05:32",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Chitila",
				"to": "Pajura Hm. (700)",
				"leavesAt": "05:50",
				"arrivesAt": "05:56",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Carpaţi h.(700)",
				"leavesAt": "05:57",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Bucureşti Nord",
				"leavesAt": "06:01",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2386",
		"segments": [
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:16",
				"waitsAtSource": 0,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "12:17",
				"arrivesAt": "12:22",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "12:23",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "12:28",
				"arrivesAt": "12:34",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "12:35",
				"arrivesAt": "12:44",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "12:45",
				"arrivesAt": "12:52",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "12:53",
				"arrivesAt": "12:59",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "13:00",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "13:07",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "13:12",
				"arrivesAt": "13:18",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "13:19",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "13:23",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "13:26",
				"arrivesAt": "13:30",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "13:31",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "13:41",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2216",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "21:30",
				"arrivesAt": "21:38",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "21:39",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5721",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Vest",
				"leavesAt": "08:36",
				"arrivesAt": "08:44",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Suceava Vest",
				"to": "Stroieşti",
				"leavesAt": "08:45",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Stroieşti",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "09:11",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Gura Humorului Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Gura Humorului Oraş",
				"leavesAt": "09:30",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "09:38",
				"arrivesAt": "09:47",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Molid Hm.",
				"leavesAt": "09:48",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Molid Hm.",
				"to": "Vama",
				"leavesAt": "09:56",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vama",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "10:02",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "10:10",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "10:21",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1885",
		"segments": [
			{
				"from": "Titu",
				"to": "Nucet",
				"leavesAt": "14:40",
				"arrivesAt": "14:51",
				"waitsAtSource": 0,
				"distance": 15400
			},
			{
				"from": "Nucet",
				"to": "Târgovişte",
				"leavesAt": "14:52",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 16300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9441",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "03:55",
				"arrivesAt": "03:57",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "03:58",
				"arrivesAt": "04:00",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Săteni h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Săteni h.",
				"to": "Doiceşti",
				"leavesAt": "04:06",
				"arrivesAt": "04:09",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Doiceşti",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "04:10",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Trainica h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:20",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Trainica h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "04:21",
				"arrivesAt": "04:25",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Moţăieni h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Moţăieni h.",
				"to": "Fieni",
				"leavesAt": "04:30",
				"arrivesAt": "04:35",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Pietroşiţa Hm.",
				"leavesAt": "04:40",
				"arrivesAt": "04:48",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5562",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "07:53",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "08:03",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Bursuceni h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Bursuceni h.",
				"to": "Bucecea Hm",
				"leavesAt": "08:24",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "09:13",
				"arrivesAt": "09:37",
				"waitsAtSource": 720,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3645",
		"segments": [
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:44",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Bălnaca h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Bălnaca h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Peştera h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Peştera h.",
				"to": "Vadu Crişului h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Butan h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Butan h.",
				"to": "Aleşd h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Aleşd h.",
				"to": "Aleşd",
				"leavesAt": "17:28",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aleşd",
				"to": "Ţeţchea hc.",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Telechiu Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Telechiu Hm.",
				"to": "Tileagd",
				"leavesAt": "17:45",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Tileagd",
				"to": "Săbolciu h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 240,
				"distance": 5400
			},
			{
				"from": "Săbolciu h.",
				"to": "Săcădat h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săcădat h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "18:04",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea Est",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Oradea Est",
				"to": "Oradea",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1824",
		"segments": [
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "07:10",
				"arrivesAt": "07:24",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "07:28",
				"arrivesAt": "07:34",
				"waitsAtSource": 240,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Călan Băi",
				"leavesAt": "07:35",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Subcetate",
				"leavesAt": "07:51",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Subcetate",
				"to": "Pui",
				"leavesAt": "08:07",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Pui",
				"to": "Crivadia Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 13400
			},
			{
				"from": "Crivadia Hm.",
				"to": "Băniţa",
				"leavesAt": "08:47",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Băniţa",
				"to": "Petroşani",
				"leavesAt": "09:10",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Petroşani",
				"to": "Valea Sadului Hm.",
				"leavesAt": "09:30",
				"arrivesAt": "10:15",
				"waitsAtSource": 300,
				"distance": 31700
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "10:16",
				"arrivesAt": "10:38",
				"waitsAtSource": 60,
				"distance": 19600
			},
			{
				"from": "Târgu Jiu",
				"to": "Cărbuneşti",
				"leavesAt": "10:40",
				"arrivesAt": "11:08",
				"waitsAtSource": 120,
				"distance": 23800
			},
			{
				"from": "Cărbuneşti",
				"to": "Filiaşi",
				"leavesAt": "11:09",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 46500
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "11:55",
				"arrivesAt": "12:20",
				"waitsAtSource": 120,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "12:30",
				"arrivesAt": "13:10",
				"waitsAtSource": 600,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "13:12",
				"arrivesAt": "13:27",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "13:28",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "14:02",
				"arrivesAt": "14:48",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "14:50",
				"arrivesAt": "15:43",
				"waitsAtSource": 120,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2204",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "06:50",
				"arrivesAt": "06:57",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "06:58",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5104",
		"segments": [
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:57",
				"waitsAtSource": 0,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "08:10",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "08:15",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5444",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "06:06",
				"arrivesAt": "06:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "06:21",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "06:29",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "06:36",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "06:49",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "07:05",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "07:11",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "07:17",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Paşcani Triaj",
				"leavesAt": "07:25",
				"arrivesAt": "07:29",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Paşcani Triaj",
				"to": "Stolniceni h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "07:53",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "07:58",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "08:05",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "08:16",
				"arrivesAt": "08:23",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "08:29",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "08:44",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "08:50",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1664",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Bârnova Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "17:02",
				"waitsAtSource": 0,
				"distance": 18500
			},
			{
				"from": "Bârnova Hm.",
				"to": "Vaslui",
				"leavesAt": "17:03",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Vaslui",
				"to": "Bârlad",
				"leavesAt": "17:43",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 52100
			},
			{
				"from": "Bârlad",
				"to": "Tecuci",
				"leavesAt": "18:28",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 50300
			},
			{
				"from": "Tecuci",
				"to": "Focşani",
				"leavesAt": "19:24",
				"arrivesAt": "20:06",
				"waitsAtSource": 720,
				"distance": 36500
			},
			{
				"from": "Focşani",
				"to": "Buzău",
				"leavesAt": "20:07",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 70800
			},
			{
				"from": "Buzău",
				"to": "Ploieşti Sud",
				"leavesAt": "21:16",
				"arrivesAt": "22:25",
				"waitsAtSource": 120,
				"distance": 68600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "22:27",
				"arrivesAt": "23:15",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3549",
		"segments": [
			{
				"from": "Odorhei",
				"to": "Odorhei Sud hc.",
				"leavesAt": "22:20",
				"arrivesAt": "22:24",
				"waitsAtSource": 0,
				"distance": 1200
			},
			{
				"from": "Odorhei Sud hc.",
				"to": "Feliceni h.",
				"leavesAt": "22:25",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Feliceni h.",
				"to": "Dobeni h.",
				"leavesAt": "22:33",
				"arrivesAt": "22:38",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Dobeni h.",
				"to": "Lutiţa h.",
				"leavesAt": "22:39",
				"arrivesAt": "22:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lutiţa h.",
				"to": "Porumbenii Mari h.",
				"leavesAt": "22:44",
				"arrivesAt": "22:50",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Porumbenii Mari h.",
				"to": "Porumbenii Mici h.",
				"leavesAt": "22:51",
				"arrivesAt": "22:55",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Porumbenii Mici h.",
				"to": "Beteşti Est h.",
				"leavesAt": "22:56",
				"arrivesAt": "23:01",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Beteşti Est h.",
				"to": "Beteşti h.",
				"leavesAt": "23:02",
				"arrivesAt": "23:05",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Beteşti h.",
				"to": "Cristur Hm.",
				"leavesAt": "23:06",
				"arrivesAt": "23:09",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Cristur Hm.",
				"to": "Sântămaria h.",
				"leavesAt": "23:16",
				"arrivesAt": "23:20",
				"waitsAtSource": 420,
				"distance": 3000
			},
			{
				"from": "Sântămaria h.",
				"to": "Săcuienii Noi h.",
				"leavesAt": "23:21",
				"arrivesAt": "23:26",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Săcuienii Noi h.",
				"to": "Vânători",
				"leavesAt": "23:27",
				"arrivesAt": "23:34",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Vânători",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "23:35",
				"arrivesAt": "23:42",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Sighişoara",
				"leavesAt": "23:43",
				"arrivesAt": "23:52",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9387",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Măldăeni Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:42",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "16:52",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Dăneasa h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Dăneasa h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "17:10",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Fărcaşele Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Caracal",
				"leavesAt": "17:28",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:45",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "17:59",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "18:03",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "18:07",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "18:13",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Malu Mare Hm.",
				"leavesAt": "18:22",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "18:26",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "18:29",
				"arrivesAt": "18:33",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "18:34",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "18:39",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9435",
		"segments": [
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "11:00",
				"arrivesAt": "11:03",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "11:04",
				"arrivesAt": "11:07",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "11:08",
				"arrivesAt": "11:12",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "11:13",
				"arrivesAt": "11:16",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "11:17",
				"arrivesAt": "11:20",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "11:21",
				"arrivesAt": "11:24",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "11:25",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "11:30",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2560",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "04:21",
				"arrivesAt": "04:28",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "04:29",
				"arrivesAt": "04:36",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "04:37",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "04:50",
				"arrivesAt": "04:56",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "04:57",
				"arrivesAt": "04:59",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Hăşag h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "05:11",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "05:38",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "05:48",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9385",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Măldăeni Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:27",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Măldăeni Hm.",
				"to": "Mihăeşti Hm.",
				"leavesAt": "07:28",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "07:37",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Dăneasa h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Dăneasa h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "07:55",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Fărcaşele Hm.",
				"leavesAt": "08:07",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Caracal",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:30",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:37",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "08:38",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "08:45",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "08:49",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "08:59",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:12",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "09:13",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "09:18",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "09:23",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2105",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "17:22",
				"arrivesAt": "17:28",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "17:29",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "17:49",
				"arrivesAt": "17:59",
				"waitsAtSource": 300,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "18:32",
				"arrivesAt": "18:41",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "18:42",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "18:53",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Făgăraş",
				"to": "Beclean pe Olt h.",
				"leavesAt": "19:08",
				"arrivesAt": "19:13",
				"waitsAtSource": 540,
				"distance": 5200
			},
			{
				"from": "Beclean pe Olt h.",
				"to": "Dridif h.",
				"leavesAt": "19:14",
				"arrivesAt": "19:18",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Dridif h.",
				"to": "Voila Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Voila Hm.",
				"to": "Olteţ h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:30",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Olteţ h.",
				"to": "Viştea h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:35",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Viştea h.",
				"to": "Ucea",
				"leavesAt": "19:36",
				"arrivesAt": "19:40",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "19:50",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "19:59",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "20:09",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "20:24",
				"arrivesAt": "20:29",
				"waitsAtSource": 360,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:37",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "20:38",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "20:52",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "21:02",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "21:20",
				"arrivesAt": "21:24",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9416",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "08:15",
				"arrivesAt": "08:26",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "08:52",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 448
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8386",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "11:43",
				"arrivesAt": "11:49",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "11:50",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "11:55",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "12:05",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "12:16",
				"arrivesAt": "12:22",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "12:23",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "12:38",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180427",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4144",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Sărăţel Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "15:56",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Domneşti pe Şieu h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:16",
				"waitsAtSource": 720,
				"distance": 6600
			},
			{
				"from": "Domneşti pe Şieu h.",
				"to": "Mărişelu Hm.",
				"leavesAt": "16:17",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Bârla pe Şieu h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bârla pe Şieu h.",
				"to": "Şieu Hm.",
				"leavesAt": "16:27",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Şieu Hm.",
				"to": "Şieuţ h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Şieuţ h.",
				"to": "Monor Gledin",
				"leavesAt": "16:40",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Monor Gledin",
				"to": "Râpa de Jos Hm.",
				"leavesAt": "16:49",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Râpa de Jos Hm.",
				"to": "Morăreni h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Morăreni h.",
				"to": "Deda",
				"leavesAt": "17:06",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:35",
				"waitsAtSource": 900,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "17:58",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "18:32",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "18:39",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "18:53",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4047",
		"segments": [
			{
				"from": "Jibou",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "11:55",
				"arrivesAt": "12:05",
				"waitsAtSource": 0,
				"distance": 9300
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Inău h.",
				"leavesAt": "12:06",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Inău h.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "12:10",
				"arrivesAt": "12:13",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Benesat Hm.",
				"leavesAt": "12:14",
				"arrivesAt": "12:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Benesat Hm.",
				"to": "Ţicău h.",
				"leavesAt": "12:18",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ţicău h.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "12:25",
				"arrivesAt": "12:28",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "12:29",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Fersig h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:42",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Fersig h.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "12:43",
				"arrivesAt": "12:48",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "12:49",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4538",
		"segments": [
			{
				"from": "Războieni",
				"to": "Lunca Mureşului h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Cheţani h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 420,
				"distance": 3100
			},
			{
				"from": "Cheţani h.",
				"to": "Luduş",
				"leavesAt": "17:05",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Luduş",
				"to": "Bogata Mureş h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 420,
				"distance": 2700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Cuci h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cuci h.",
				"to": "Iernut",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Iernut",
				"to": "Cipău h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Cipău h.",
				"to": "Ogra h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ogra h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "17:49",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Chirileu h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chirileu h.",
				"to": "Vidrasău h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vidrasău h.",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "18:04",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "Azomureş h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş",
				"leavesAt": "18:19",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8394",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "20:08",
				"arrivesAt": "20:14",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:20",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "20:30",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "20:41",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "20:54",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "21:03",
				"arrivesAt": "21:16",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180523",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1646",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Reghin",
				"leavesAt": "13:36",
				"arrivesAt": "14:13",
				"waitsAtSource": 0,
				"distance": 32300
			},
			{
				"from": "Reghin",
				"to": "Deda",
				"leavesAt": "14:14",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 22000
			},
			{
				"from": "Deda",
				"to": "Topliţa",
				"leavesAt": "14:46",
				"arrivesAt": "15:44",
				"waitsAtSource": 720,
				"distance": 43900
			},
			{
				"from": "Topliţa",
				"to": "Gheorgheni",
				"leavesAt": "15:45",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Gheorgheni",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "16:41",
				"arrivesAt": "16:53",
				"waitsAtSource": 420,
				"distance": 10900
			},
			{
				"from": "Izvoru Oltului",
				"to": "Siculeni",
				"leavesAt": "16:54",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "17:17",
				"arrivesAt": "17:25",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:50",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "17:59",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 28300
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Braşov",
				"leavesAt": "18:27",
				"arrivesAt": "18:57",
				"waitsAtSource": 120,
				"distance": 32100
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "19:09",
				"arrivesAt": "19:44",
				"waitsAtSource": 720,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "19:46",
				"arrivesAt": "19:55",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "19:56",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "20:02",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "20:12",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "20:37",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "21:00",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1773",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "P.O. Aeroport h.",
				"leavesAt": "12:50",
				"arrivesAt": "13:21",
				"waitsAtSource": 0,
				"distance": 27400
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Urziceni",
				"leavesAt": "13:22",
				"arrivesAt": "14:05",
				"waitsAtSource": 30,
				"distance": 50500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1772",
		"segments": [
			{
				"from": "Urziceni",
				"to": "P.O. Aeroport h.",
				"leavesAt": "08:35",
				"arrivesAt": "09:18",
				"waitsAtSource": 0,
				"distance": 50500
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Mogoşoaia",
				"leavesAt": "09:19",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Mogoşoaia",
				"to": "Bucureşti Nord",
				"leavesAt": "09:31",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 20400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8596",
		"segments": [
			{
				"from": "Călăraşi Sud",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "16:45",
				"arrivesAt": "16:52",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Ştefan Vodă h.",
				"leavesAt": "16:53",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Ciulniţa",
				"leavesAt": "17:01",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 12600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5402",
		"segments": [
			{
				"from": "Bacău",
				"to": "Letea h.",
				"leavesAt": "09:19",
				"arrivesAt": "09:25",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Letea h.",
				"to": "Valea Seacă",
				"leavesAt": "09:26",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Valea Seacă",
				"to": "Siretu Bacău h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Faraoani Hm.",
				"leavesAt": "09:37",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Faraoani Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "09:43",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Răcăciuni h.",
				"to": "Orbeni Hm.",
				"leavesAt": "09:50",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Orbeni Hm.",
				"to": "Sascut Hm.",
				"leavesAt": "10:02",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Sascut Hm.",
				"to": "Şişcani h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:16",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Şişcani h.",
				"to": "Adjudu Vechi h.",
				"leavesAt": "10:17",
				"arrivesAt": "10:21",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Adjud",
				"leavesAt": "10:22",
				"arrivesAt": "10:26",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:37",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "10:38",
				"arrivesAt": "10:42",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "10:49",
				"arrivesAt": "10:53",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "10:54",
				"arrivesAt": "11:04",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3024",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "19:51",
				"arrivesAt": "20:00",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Jos h.",
				"leavesAt": "20:01",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "20:17",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "20:35",
				"arrivesAt": "20:44",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "20:52",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "20:56",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:06",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Posada h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:16",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Posada h.",
				"to": "Comarnic",
				"leavesAt": "21:17",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:31",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "21:32",
				"arrivesAt": "21:35",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "21:36",
				"arrivesAt": "21:41",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "21:42",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "21:54",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "22:04",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "22:14",
				"arrivesAt": "22:19",
				"waitsAtSource": 120,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9170",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "18:57",
				"arrivesAt": "19:06",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "19:11",
				"arrivesAt": "19:19",
				"waitsAtSource": 300,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:27",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "19:28",
				"arrivesAt": "19:40",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Valea Păltinişului h.",
				"leavesAt": "19:54",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Caransebeş",
				"leavesAt": "20:02",
				"arrivesAt": "20:08",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5448",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "17:00",
				"arrivesAt": "17:05",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "17:07",
				"arrivesAt": "17:16",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "17:17",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "17:32",
				"arrivesAt": "17:38",
				"waitsAtSource": 360,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "17:39",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "17:52",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "18:08",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "18:20",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Paşcani Triaj",
				"leavesAt": "18:30",
				"arrivesAt": "18:34",
				"waitsAtSource": 240,
				"distance": 2300
			},
			{
				"from": "Paşcani Triaj",
				"to": "Stolniceni h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "18:47",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "18:52",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "19:03",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "19:10",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "19:21",
				"arrivesAt": "19:28",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "19:29",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "19:34",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "19:49",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "19:55",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8803",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:48",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "16:49",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "16:58",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "17:14",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "17:23",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "17:27",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "17:39",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 480,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2422",
		"segments": [
			{
				"from": "Sălişte Hm.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:25",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sibiel h.",
				"leavesAt": "13:26",
				"arrivesAt": "13:29",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sibiel h.",
				"to": "Orlat",
				"leavesAt": "13:30",
				"arrivesAt": "13:36",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Orlat",
				"to": "Cristian Sibiu h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:42",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Turnişor Hm.",
				"leavesAt": "13:43",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Sibiu h.(210)",
				"leavesAt": "13:58",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Sibiu",
				"leavesAt": "14:02",
				"arrivesAt": "14:07",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1692",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Lugoj",
				"leavesAt": "05:22",
				"arrivesAt": "06:15",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Lugoj",
				"to": "Caransebeş",
				"leavesAt": "06:19",
				"arrivesAt": "06:54",
				"waitsAtSource": 240,
				"distance": 39400
			},
			{
				"from": "Caransebeş",
				"to": "Băile Herculane",
				"leavesAt": "06:57",
				"arrivesAt": "08:20",
				"waitsAtSource": 180,
				"distance": 70800
			},
			{
				"from": "Băile Herculane",
				"to": "Orşova",
				"leavesAt": "08:22",
				"arrivesAt": "08:42",
				"waitsAtSource": 120,
				"distance": 17500
			},
			{
				"from": "Orşova",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "08:43",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Balota",
				"leavesAt": "09:15",
				"arrivesAt": "09:47",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Balota",
				"to": "Prunişor Hm.",
				"leavesAt": "09:48",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Prunişor Hm.",
				"to": "Strehaia hc.",
				"leavesAt": "10:02",
				"arrivesAt": "10:24",
				"waitsAtSource": 240,
				"distance": 22600
			},
			{
				"from": "Strehaia hc.",
				"to": "Filiaşi",
				"leavesAt": "10:25",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Filiaşi",
				"to": "Craiova",
				"leavesAt": "10:54",
				"arrivesAt": "11:22",
				"waitsAtSource": 120,
				"distance": 35800
			},
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "11:30",
				"arrivesAt": "12:09",
				"waitsAtSource": 480,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Drăgăneşti Olt",
				"leavesAt": "12:11",
				"arrivesAt": "12:26",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Roşiori Nord",
				"leavesAt": "12:27",
				"arrivesAt": "12:58",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "13:00",
				"arrivesAt": "13:44",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Grădinari",
				"leavesAt": "13:45",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 25400
			},
			{
				"from": "Grădinari",
				"to": "Bucureşti Nord",
				"leavesAt": "14:14",
				"arrivesAt": "14:42",
				"waitsAtSource": 240,
				"distance": 25500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1090",
		"segments": [
			{
				"from": "Vidin Patnicheska",
				"to": "Golenţi Hm.",
				"leavesAt": "12:35",
				"arrivesAt": "12:53",
				"waitsAtSource": 0,
				"distance": 23200
			},
			{
				"from": "Golenţi Hm.",
				"to": "Maglavit h.",
				"leavesAt": "13:22",
				"arrivesAt": "13:37",
				"waitsAtSource": 1740,
				"distance": 6600
			},
			{
				"from": "Maglavit h.",
				"to": "Moţăţei Hm.",
				"leavesAt": "13:38",
				"arrivesAt": "13:52",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Moţăţei Hm.",
				"to": "Băileşti",
				"leavesAt": "13:53",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 12800
			},
			{
				"from": "Băileşti",
				"to": "Siliştea Crucii h.",
				"leavesAt": "14:16",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Afumaţi h.",
				"leavesAt": "14:33",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Afumaţi h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Cerăt h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cerăt h.",
				"to": "Segarcea",
				"leavesAt": "15:11",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Segarcea",
				"to": "Segarcea Nord hc.",
				"leavesAt": "15:18",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Dealul Robului h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dealul Robului h.",
				"to": "Sălcuţa Hm.",
				"leavesAt": "15:27",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Podari",
				"leavesAt": "15:33",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Podari",
				"to": "Jiu Hm.",
				"leavesAt": "15:46",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Jiu Hm.",
				"to": "Bordei hc.(913)",
				"leavesAt": "15:56",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Craiova",
				"leavesAt": "16:00",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9665",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "14:48",
				"arrivesAt": "14:58",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "14:59",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "15:03",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "15:10",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "15:18",
				"arrivesAt": "15:24",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "15:25",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Deta Hm.",
				"leavesAt": "15:38",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Deta Hm.",
				"to": "Denta h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Denta h.",
				"to": "Stamora Moraviţa",
				"leavesAt": "15:54",
				"arrivesAt": "16:03",
				"waitsAtSource": 30,
				"distance": 8400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1722",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "02:41",
				"arrivesAt": "03:02",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "03:03",
				"arrivesAt": "03:14",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Câineni",
				"leavesAt": "03:15",
				"arrivesAt": "03:47",
				"waitsAtSource": 30,
				"distance": 21600
			},
			{
				"from": "Câineni",
				"to": "Lotru",
				"leavesAt": "03:55",
				"arrivesAt": "04:19",
				"waitsAtSource": 480,
				"distance": 21100
			},
			{
				"from": "Lotru",
				"to": "Păuşa h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "04:38",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "04:44",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 16200
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Băbeni",
				"leavesAt": "05:10",
				"arrivesAt": "05:28",
				"waitsAtSource": 420,
				"distance": 19600
			},
			{
				"from": "Băbeni",
				"to": "Drăgăşani",
				"leavesAt": "05:29",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 33200
			},
			{
				"from": "Drăgăşani",
				"to": "Piatra Olt",
				"leavesAt": "05:54",
				"arrivesAt": "06:25",
				"waitsAtSource": 120,
				"distance": 33800
			},
			{
				"from": "Piatra Olt",
				"to": "Caracal",
				"leavesAt": "06:27",
				"arrivesAt": "07:05",
				"waitsAtSource": 120,
				"distance": 32400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9103",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "15:05",
				"arrivesAt": "15:16",
				"waitsAtSource": 0,
				"distance": 7700
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "15:17",
				"arrivesAt": "15:20",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "15:21",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "16:19",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:40",
				"waitsAtSource": 540,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "16:41",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "16:51",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "16:56",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "17:10",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2482",
		"segments": [
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "15:25",
				"arrivesAt": "15:30",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:40",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Valea Fratelui h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Râu Vadului h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "15:58",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Cornet Hm.",
				"leavesAt": "16:16",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Cornet Hm.",
				"to": "Lotru",
				"leavesAt": "16:24",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20180115",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180212",
				"to": "20180330",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180413",
				"daysOfWeek": 799
			},
			{
				"from": "20180416",
				"to": "20180420",
				"daysOfWeek": 799
			},
			{
				"from": "20180423",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5006",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "09:55",
				"arrivesAt": "10:05",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "10:06",
				"arrivesAt": "10:11",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "10:12",
				"arrivesAt": "10:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "10:17",
				"arrivesAt": "10:27",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "10:28",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "10:37",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "10:46",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "10:52",
				"arrivesAt": "10:58",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "10:59",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "11:03",
				"arrivesAt": "11:10",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "11:11",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "11:19",
				"arrivesAt": "11:26",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Brazi",
				"leavesAt": "11:28",
				"arrivesAt": "11:43",
				"waitsAtSource": 120,
				"distance": 8800
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "11:44",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "11:52",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "12:04",
				"arrivesAt": "12:09",
				"waitsAtSource": 420,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "12:10",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "12:16",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "12:25",
				"arrivesAt": "12:30",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "12:31",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "12:41",
				"arrivesAt": "12:46",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Basarab",
				"leavesAt": "12:47",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 4700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2093",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "08:36",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "08:46",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "08:52",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "08:59",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "09:03",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "09:17",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "09:26",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "09:37",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "09:43",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "09:52",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Scoarţa h.",
				"leavesAt": "09:59",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Scoarţa h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "10:03",
				"arrivesAt": "10:07",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "10:12",
				"arrivesAt": "10:16",
				"waitsAtSource": 300,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Târgu Jiu",
				"leavesAt": "10:17",
				"arrivesAt": "10:29",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1795",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "20:30",
				"arrivesAt": "21:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "21:32",
				"arrivesAt": "21:51",
				"waitsAtSource": 120,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "21:52",
				"arrivesAt": "22:15",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "22:16",
				"arrivesAt": "22:27",
				"waitsAtSource": 60,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1544",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Apahida",
				"leavesAt": "18:20",
				"arrivesAt": "18:37",
				"waitsAtSource": 0,
				"distance": 12300
			},
			{
				"from": "Apahida",
				"to": "Bonţida Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Bonţida Hm.",
				"to": "Iclod Hm.",
				"leavesAt": "18:57",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Iclod Hm.",
				"to": "Gherla",
				"leavesAt": "19:07",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "19:22",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Căşeiu Hm.",
				"leavesAt": "19:43",
				"arrivesAt": "19:51",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Căşeiu Hm.",
				"to": "Câţcău h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Câţcău h.",
				"to": "Gâlgău",
				"leavesAt": "20:00",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Gâlgău",
				"to": "Ileanda",
				"leavesAt": "20:12",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Ileanda",
				"to": "Răstoci Hm.",
				"leavesAt": "20:33",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Răstoci Hm.",
				"to": "Letca Hm.",
				"leavesAt": "20:42",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Letca Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "20:53",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "21:01",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Ciocmani h.",
				"leavesAt": "21:08",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciocmani h.",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "21:15",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Jibou",
				"leavesAt": "21:23",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Jibou",
				"to": "Benesat Hm.",
				"leavesAt": "21:33",
				"arrivesAt": "21:50",
				"waitsAtSource": 120,
				"distance": 18000
			},
			{
				"from": "Benesat Hm.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "21:51",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "22:01",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "22:09",
				"arrivesAt": "22:20",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "22:21",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2517",
		"segments": [
			{
				"from": "Făgăraş",
				"to": "Dridif h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:56",
				"waitsAtSource": 0,
				"distance": 8500
			},
			{
				"from": "Dridif h.",
				"to": "Voila Hm.",
				"leavesAt": "11:57",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Voila Hm.",
				"to": "Olteţ h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:14",
				"waitsAtSource": 300,
				"distance": 6100
			},
			{
				"from": "Olteţ h.",
				"to": "Viştea h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:19",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Viştea h.",
				"to": "Ucea",
				"leavesAt": "12:20",
				"arrivesAt": "12:24",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ucea",
				"to": "Arpaş Hm.",
				"leavesAt": "12:25",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Arpaş Hm.",
				"to": "Cârţa h.",
				"leavesAt": "12:34",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cârţa h.",
				"to": "Scoreiu h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Scoreiu h.",
				"to": "Sărata Colun h.",
				"leavesAt": "12:43",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sărata Colun h.",
				"to": "Porumbacu Hm.",
				"leavesAt": "12:47",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Avrig Hm.",
				"leavesAt": "12:59",
				"arrivesAt": "13:08",
				"waitsAtSource": 360,
				"distance": 7400
			},
			{
				"from": "Avrig Hm.",
				"to": "Mârşa h.",
				"leavesAt": "13:09",
				"arrivesAt": "13:13",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Mârşa h.",
				"to": "Racoviţa h.",
				"leavesAt": "13:14",
				"arrivesAt": "13:17",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Racoviţa h.",
				"to": "Sebeş Olt h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:21",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Podu Olt",
				"leavesAt": "13:22",
				"arrivesAt": "13:27",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "13:28",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Veştem h.",
				"leavesAt": "13:36",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Veştem h.",
				"to": "Mohu h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mohu h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Atelier Zona h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu",
				"leavesAt": "14:02",
				"arrivesAt": "14:06",
				"waitsAtSource": 30,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1658",
		"segments": [
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "04:47",
				"arrivesAt": "05:26",
				"waitsAtSource": 0,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "05:27",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "05:55",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "06:18",
				"arrivesAt": "06:55",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "06:56",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "07:29",
				"arrivesAt": "08:01",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "08:02",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "08:39",
				"arrivesAt": "09:28",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9172",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "22:05",
				"arrivesAt": "22:14",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "22:24",
				"arrivesAt": "22:31",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "22:32",
				"arrivesAt": "22:43",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "22:44",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Caransebeş",
				"leavesAt": "22:57",
				"arrivesAt": "23:10",
				"waitsAtSource": 60,
				"distance": 10400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2563",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "12:22",
				"arrivesAt": "12:26",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "12:27",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:42",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "12:52",
				"arrivesAt": "12:58",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "12:59",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Şeica Mare h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:15",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "13:16",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "13:27",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "13:33",
				"arrivesAt": "13:38",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:49",
				"waitsAtSource": 240,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "13:50",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Bratei h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bratei h.",
				"to": "Aţel Hm.",
				"leavesAt": "14:07",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Aţel Hm.",
				"to": "Dumbrăveni",
				"leavesAt": "14:16",
				"arrivesAt": "14:26",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Dumbrăveni",
				"to": "Luna h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Luna h.",
				"to": "Daneş Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Daneş Hm.",
				"to": "Sighişoara",
				"leavesAt": "14:43",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7035",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "14:18",
				"arrivesAt": "14:24",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "14:25",
				"arrivesAt": "14:28",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Chitila",
				"leavesAt": "14:29",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chitila",
				"to": "Mogoşoaia",
				"leavesAt": "14:35",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Mogoşoaia",
				"to": "P.O. Aeroport h.",
				"leavesAt": "14:53",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "15:01",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "15:24",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "15:44",
				"arrivesAt": "15:49",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "15:55",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5526",
		"segments": [
			{
				"from": "Târgu Neamţ",
				"to": "Sfântu Mina h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:38",
				"waitsAtSource": 0,
				"distance": 4600
			},
			{
				"from": "Sfântu Mina h.",
				"to": "Plăieşu h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plăieşu h.",
				"to": "Timişeşti Hm.",
				"leavesAt": "15:43",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Timişeşti Hm.",
				"to": "Cristeşti Paşcani hc.",
				"leavesAt": "15:50",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cristeşti Paşcani hc.",
				"to": "Topile h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Topile h.",
				"to": "Paşcani",
				"leavesAt": "16:05",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 863
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2461",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:37",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Dăeşti Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Călimăneşti",
				"leavesAt": "17:51",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Călimăneşti",
				"to": "Păuşa h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Păuşa h.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Cozia Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cozia Hm.",
				"to": "Lotru",
				"leavesAt": "18:19",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lotru",
				"to": "Beţel h.",
				"leavesAt": "18:29",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Beţel h.",
				"to": "Cornet Hm.",
				"leavesAt": "18:37",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cornet Hm.",
				"to": "Balota h.",
				"leavesAt": "18:51",
				"arrivesAt": "18:55",
				"waitsAtSource": 480,
				"distance": 4000
			},
			{
				"from": "Balota h.",
				"to": "Robeşti h.",
				"leavesAt": "18:56",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Robeşti h.",
				"to": "Câineni",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Râu Vadului h.",
				"leavesAt": "19:07",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Râu Vadului h.",
				"to": "Valea Fratelui h.",
				"leavesAt": "19:15",
				"arrivesAt": "19:19",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "19:20",
				"arrivesAt": "19:33",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Turnu Roşu hc.",
				"leavesAt": "19:34",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Podu Olt",
				"leavesAt": "19:45",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9366",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "14:15",
				"arrivesAt": "14:18",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "14:19",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "14:31",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "14:54",
				"arrivesAt": "15:02",
				"waitsAtSource": 600,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "15:03",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "15:20",
				"arrivesAt": "15:27",
				"waitsAtSource": 120,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2144",
		"segments": [
			{
				"from": "Hunedoara",
				"to": "Pestişu Mare h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:20",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pestişu Mare h.",
				"to": "Bârcea Mică",
				"leavesAt": "15:21",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bârcea Mică",
				"to": "Bârcea Mare h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bârcea Mare h.",
				"to": "Simeria",
				"leavesAt": "15:29",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2348",
		"segments": [
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "22:38",
				"arrivesAt": "22:45",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "22:46",
				"arrivesAt": "22:52",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1533",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "13:35",
				"arrivesAt": "14:01",
				"waitsAtSource": 0,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "14:02",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:54",
				"waitsAtSource": 360,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Bratca",
				"leavesAt": "14:55",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "15:17",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Aleşd",
				"leavesAt": "15:26",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Aleşd",
				"to": "Tileagd",
				"leavesAt": "15:48",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Tileagd",
				"to": "Oradea",
				"leavesAt": "16:04",
				"arrivesAt": "16:25",
				"waitsAtSource": 300,
				"distance": 23100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9407",
		"segments": [
			{
				"from": "Caracal",
				"to": "Romula Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:48",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Romula Hm.",
				"to": "Fălcoiu h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:07",
				"waitsAtSource": 600,
				"distance": 7000
			},
			{
				"from": "Fălcoiu h.",
				"to": "Vlăduleni",
				"leavesAt": "17:08",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vlăduleni",
				"to": "Şopârliţa hc.",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Pârşcoveni hc.",
				"leavesAt": "17:22",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Pârşcoveni hc.",
				"to": "Piatra Olt",
				"leavesAt": "17:29",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9027",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "20:00",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "20:05",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "20:09",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "20:14",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "20:19",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "20:23",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "20:55",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:16",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "21:17",
				"arrivesAt": "21:24",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Fusea Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:44",
				"waitsAtSource": 720,
				"distance": 5400
			},
			{
				"from": "Fusea Hm.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "21:45",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Cojocaru h.",
				"leavesAt": "21:52",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Cojocaru h.",
				"to": "Găeşti Sud h.",
				"leavesAt": "21:59",
				"arrivesAt": "22:02",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Găeşti",
				"leavesAt": "22:03",
				"arrivesAt": "22:10",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Găeşti",
				"to": "Pătroaia Hm.",
				"leavesAt": "22:11",
				"arrivesAt": "22:19",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "22:20",
				"arrivesAt": "22:27",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Călineşti Hm.",
				"leavesAt": "22:28",
				"arrivesAt": "22:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Călineşti Hm.",
				"to": "Goleşti",
				"leavesAt": "22:35",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Goleşti",
				"to": "Ram. Goleşti",
				"leavesAt": "22:46",
				"arrivesAt": "22:53",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ram. Goleşti",
				"to": "Piteşti",
				"leavesAt": "22:54",
				"arrivesAt": "23:05",
				"waitsAtSource": 30,
				"distance": 4600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8013",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "17:00",
				"arrivesAt": "17:09",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "17:10",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Pasărea",
				"leavesAt": "17:16",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Pasărea",
				"to": "Brăneşti Sat h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Brăneşti Sat h.",
				"to": "Brăneşti Hm.",
				"leavesAt": "17:28",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Brăneşti Hm.",
				"to": "Islaz h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Islaz h.",
				"to": "Fundulea Hm.",
				"leavesAt": "17:35",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Fundulea Hm.",
				"to": "Mostiştea h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Mostiştea h.",
				"to": "Săruleşti",
				"leavesAt": "17:48",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Săruleşti",
				"to": "Preasna h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Preasna h.",
				"to": "Lehliu",
				"leavesAt": "18:00",
				"arrivesAt": "18:08",
				"waitsAtSource": 30,
				"distance": 8800
			},
			{
				"from": "Lehliu",
				"to": "Dor Mărunt Sat h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dor Mărunt Sat h.",
				"to": "Dor Mărunt Hm.",
				"leavesAt": "18:14",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Dor Mărunt Hm.",
				"to": "Dâlga h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Dâlga h.",
				"to": "Bogdana h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Bogdana h.",
				"to": "Dragoş Vodă Hm.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Dragoş Vodă Hm.",
				"to": "Ciulniţa",
				"leavesAt": "18:35",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Ciulniţa",
				"to": "Ogoarele h.",
				"leavesAt": "18:46",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Ogoarele h.",
				"to": "Perişoru Hm.",
				"leavesAt": "18:53",
				"arrivesAt": "18:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Perişoru Hm.",
				"to": "Recolta hc.",
				"leavesAt": "18:57",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Recolta hc.",
				"to": "Jegălia",
				"leavesAt": "19:01",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Jegălia",
				"to": "Ştefan cel Mare h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ştefan cel Mare h.",
				"to": "Bărăganu Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bărăganu Hm.",
				"to": "Feteşti",
				"leavesAt": "19:15",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2415",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(210)",
				"leavesAt": "19:32",
				"arrivesAt": "19:35",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Turnişor Hm.",
				"leavesAt": "19:36",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Cristian Sibiu h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Orlat",
				"leavesAt": "19:55",
				"arrivesAt": "20:03",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Orlat",
				"to": "Sibiel h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:11",
				"waitsAtSource": 240,
				"distance": 3200
			},
			{
				"from": "Sibiel h.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:15",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sălişte Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sălişte Hm.",
				"to": "Aciliu h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Aciliu h.",
				"to": "Tilişca h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tilişca h.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Miercurea Sibiu Hm.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Băile Miercurea h.",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Băile Miercurea h.",
				"to": "Cunţa Hm.",
				"leavesAt": "21:04",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Cunţa Hm.",
				"to": "Sebeş Alba",
				"leavesAt": "21:11",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 13000
			},
			{
				"from": "Sebeş Alba",
				"to": "Vinţu de Jos",
				"leavesAt": "21:31",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "22:02",
				"arrivesAt": "22:14",
				"waitsAtSource": 1200,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "22:15",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Sântimbru h.",
				"leavesAt": "22:28",
				"arrivesAt": "22:37",
				"waitsAtSource": 240,
				"distance": 6700
			},
			{
				"from": "Sântimbru h.",
				"to": "Coşlariu",
				"leavesAt": "22:38",
				"arrivesAt": "22:50",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "22:51",
				"arrivesAt": "22:59",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "366",
		"segments": [
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "07:07",
				"arrivesAt": "07:36",
				"waitsAtSource": 0,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "08:10",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "08:12",
				"arrivesAt": "08:35",
				"waitsAtSource": 120,
				"distance": 28500
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "08:37",
				"arrivesAt": "08:45",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Izvoru Oltului",
				"leavesAt": "08:47",
				"arrivesAt": "09:03",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Gheorgheni",
				"leavesAt": "09:05",
				"arrivesAt": "09:33",
				"waitsAtSource": 120,
				"distance": 30000
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "09:35",
				"arrivesAt": "10:07",
				"waitsAtSource": 120,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "10:09",
				"arrivesAt": "11:08",
				"waitsAtSource": 120,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Sărăţel Hm.",
				"leavesAt": "11:11",
				"arrivesAt": "12:05",
				"waitsAtSource": 180,
				"distance": 46800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "12:06",
				"arrivesAt": "12:32",
				"waitsAtSource": 60,
				"distance": 24900
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "12:34",
				"arrivesAt": "13:09",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "13:13",
				"arrivesAt": "13:32",
				"waitsAtSource": 240,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "13:33",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 44900
			},
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "14:45",
				"arrivesAt": "15:14",
				"waitsAtSource": 1200,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "15:15",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "15:43",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Bratca",
				"leavesAt": "16:05",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Bratca",
				"to": "Aleşd",
				"leavesAt": "16:28",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 25300
			},
			{
				"from": "Aleşd",
				"to": "Oradea",
				"leavesAt": "16:57",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 34300
			},
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "17:31",
				"arrivesAt": "17:39",
				"waitsAtSource": 180,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharkeresztes",
				"leavesAt": "17:59",
				"arrivesAt": "18:14",
				"waitsAtSource": 1200,
				"distance": 12500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2023",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "22:15",
				"arrivesAt": "22:20",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Bumbeşti Hm.",
				"leavesAt": "22:21",
				"arrivesAt": "22:34",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "22:35",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Meri",
				"leavesAt": "22:42",
				"arrivesAt": "22:50",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Meri",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "22:55",
				"arrivesAt": "23:15",
				"waitsAtSource": 300,
				"distance": 12900
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "23:16",
				"arrivesAt": "23:27",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Livezeni",
				"leavesAt": "23:28",
				"arrivesAt": "23:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Petroşani",
				"leavesAt": "23:35",
				"arrivesAt": "23:43",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Petroşani",
				"to": "Băniţa",
				"leavesAt": "23:47",
				"arrivesAt": "00:01",
				"waitsAtSource": 240,
				"distance": 11300
			},
			{
				"from": "Băniţa",
				"to": "Baru Mare h.",
				"leavesAt": "00:02",
				"arrivesAt": "00:25",
				"waitsAtSource": 60,
				"distance": 14400
			},
			{
				"from": "Baru Mare h.",
				"to": "Pui",
				"leavesAt": "00:26",
				"arrivesAt": "00:40",
				"waitsAtSource": 30,
				"distance": 9800
			},
			{
				"from": "Pui",
				"to": "Ruşor h.",
				"leavesAt": "00:41",
				"arrivesAt": "00:45",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Ruşor h.",
				"to": "Subcetate",
				"leavesAt": "00:46",
				"arrivesAt": "00:55",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Subcetate",
				"to": "Călan Hm.",
				"leavesAt": "00:56",
				"arrivesAt": "01:15",
				"waitsAtSource": 60,
				"distance": 15600
			},
			{
				"from": "Călan Hm.",
				"to": "Simeria",
				"leavesAt": "01:16",
				"arrivesAt": "01:30",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3009",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:10",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "18:11",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "18:14",
				"arrivesAt": "18:17",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "18:18",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "18:22",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "18:26",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:44",
				"waitsAtSource": 420,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "18:45",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "18:53",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "19:03",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "19:08",
				"arrivesAt": "19:17",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "19:23",
				"arrivesAt": "19:27",
				"waitsAtSource": 360,
				"distance": 4600
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Ploieşti Vest",
				"leavesAt": "19:28",
				"arrivesAt": "19:32",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "19:34",
				"arrivesAt": "19:40",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "19:41",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Bobolia h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Bobolia h.",
				"to": "Câmpina",
				"leavesAt": "19:58",
				"arrivesAt": "20:05",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "20:06",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:19",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "20:20",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Posada h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Posada h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "20:37",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "20:42",
				"arrivesAt": "20:44",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "20:46",
				"arrivesAt": "20:50",
				"waitsAtSource": 120,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "20:51",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "20:56",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "21:02",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "21:14",
				"arrivesAt": "21:29",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Timişu de Jos h.",
				"leavesAt": "21:30",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Dârste",
				"leavesAt": "21:38",
				"arrivesAt": "21:46",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "21:47",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9408",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Şopârliţa hc.",
				"leavesAt": "16:16",
				"arrivesAt": "16:28",
				"waitsAtSource": 0,
				"distance": 11100
			},
			{
				"from": "Şopârliţa hc.",
				"to": "Vlăduleni",
				"leavesAt": "16:29",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vlăduleni",
				"to": "Fălcoiu h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Fălcoiu h.",
				"to": "Romula Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Romula Hm.",
				"to": "Caracal",
				"leavesAt": "16:55",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1936",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "12:30",
				"arrivesAt": "13:05",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Sinaia",
				"leavesAt": "13:07",
				"arrivesAt": "13:26",
				"waitsAtSource": 120,
				"distance": 19000
			},
			{
				"from": "Sinaia",
				"to": "Ploieşti Vest",
				"leavesAt": "13:28",
				"arrivesAt": "14:12",
				"waitsAtSource": 120,
				"distance": 62100
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "14:14",
				"arrivesAt": "14:54",
				"waitsAtSource": 120,
				"distance": 58900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "15:15",
				"arrivesAt": "16:11",
				"waitsAtSource": 1260,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "16:12",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "16:36",
				"arrivesAt": "16:56",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "16:57",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "17:14",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2434",
		"segments": [
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:12",
				"waitsAtSource": 0,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "14:17",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "14:20",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "14:24",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:41",
				"waitsAtSource": 420,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "14:42",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6508",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "16:19",
				"arrivesAt": "16:26",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Socola",
				"leavesAt": "16:27",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Socola",
				"to": "Remiza T Socola h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Remiza T Socola h.",
				"to": "Holboca Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Holboca Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "16:44",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Ungheni Prut Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9503",
		"segments": [
			{
				"from": "Filiaşi",
				"to": "Gura Motrului Hm.",
				"leavesAt": "04:22",
				"arrivesAt": "04:30",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Butoieşti Hm.",
				"leavesAt": "04:31",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Lunca Banului h.",
				"leavesAt": "04:38",
				"arrivesAt": "04:44",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lunca Banului h.",
				"to": "Strehaia",
				"leavesAt": "04:45",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Strehaia",
				"to": "Strehaia hc.",
				"leavesAt": "04:51",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia hc.",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "04:55",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Tâmna",
				"leavesAt": "05:04",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Tâmna",
				"to": "Igiroasa Hm.",
				"leavesAt": "05:13",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "05:19",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prunişor Hm.",
				"to": "Gârniţa Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:33",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Balota",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Balota",
				"to": "Valea Albă Hm.",
				"leavesAt": "05:39",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Ergheviţa h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ergheviţa h.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "05:57",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 448
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2028",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab 1 h",
				"leavesAt": "13:54",
				"arrivesAt": "13:58",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab 1 h",
				"to": "Ronaţ Triaj h",
				"leavesAt": "13:59",
				"arrivesAt": "14:02",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Sânandrei Hm.",
				"leavesAt": "14:03",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "14:11",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "14:19",
				"arrivesAt": "14:24",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "14:25",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Aradu Nou",
				"leavesAt": "14:40",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "14:56",
				"arrivesAt": "15:03",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Glogovăţ",
				"leavesAt": "15:25",
				"arrivesAt": "15:33",
				"waitsAtSource": 1320,
				"distance": 6900
			},
			{
				"from": "Glogovăţ",
				"to": "Ghioroc",
				"leavesAt": "15:34",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Ghioroc",
				"to": "Păuliş h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 300,
				"distance": 3500
			},
			{
				"from": "Păuliş h.",
				"to": "Păuliş Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş Hm.",
				"to": "Radna",
				"leavesAt": "16:05",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Radna",
				"to": "Milova",
				"leavesAt": "16:18",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Milova",
				"to": "Corfeni h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Corfeni h.",
				"to": "Conop Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Conop Hm.",
				"to": "Nadăş h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Nadăş h.",
				"to": "Bârzava",
				"leavesAt": "16:48",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârzava",
				"to": "Căpruţa h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Căpruţa h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "17:01",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Vărădia Hm.",
				"leavesAt": "17:12",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vărădia Hm.",
				"to": "Vărădia h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Vărădia h.",
				"to": "Săvârşin",
				"leavesAt": "17:24",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săvârşin",
				"to": "Toc h.",
				"leavesAt": "17:34",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Toc h.",
				"to": "Ilteu",
				"leavesAt": "17:42",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ilteu",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Zam",
				"leavesAt": "17:53",
				"arrivesAt": "17:59",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zam",
				"to": "Burjuc h.",
				"leavesAt": "18:11",
				"arrivesAt": "18:22",
				"waitsAtSource": 720,
				"distance": 8500
			},
			{
				"from": "Burjuc h.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Gurasada Hm.",
				"leavesAt": "18:32",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Gurasada Hm.",
				"to": "Ilia",
				"leavesAt": "18:40",
				"arrivesAt": "18:47",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ilia",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "18:48",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Brănişca Hm.",
				"leavesAt": "18:54",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Veţel h.",
				"leavesAt": "19:02",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Veţel h.",
				"to": "Mintia h.",
				"leavesAt": "19:07",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Mintia",
				"leavesAt": "19:11",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia",
				"to": "Deva",
				"leavesAt": "19:16",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Deva",
				"to": "Săuleşti h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Săuleşti h.",
				"to": "Simeria",
				"leavesAt": "19:34",
				"arrivesAt": "19:40",
				"waitsAtSource": 30,
				"distance": 3300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9001",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "07:55",
				"arrivesAt": "07:58",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h.(900)",
				"leavesAt": "07:59",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureştii Noi",
				"leavesAt": "08:03",
				"arrivesAt": "08:06",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "08:07",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:24",
				"waitsAtSource": 300,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "08:25",
				"arrivesAt": "08:35",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Zorile h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Zorile h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Zăvestreni Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Videle",
				"leavesAt": "09:03",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "09:13",
				"arrivesAt": "09:19",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "09:20",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "09:28",
				"arrivesAt": "09:33",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "09:34",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "09:43",
				"arrivesAt": "09:48",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "09:49",
				"arrivesAt": "09:59",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "10:00",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Roşiori Nord",
				"to": "Mihăeşti Hm.",
				"leavesAt": "10:12",
				"arrivesAt": "10:26",
				"waitsAtSource": 120,
				"distance": 17300
			},
			{
				"from": "Mihăeşti Hm.",
				"to": "Radomireşti Hm.",
				"leavesAt": "10:27",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Radomireşti Hm.",
				"to": "Dăneasa h.",
				"leavesAt": "10:38",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Dăneasa h.",
				"to": "Drăgăneşti Olt",
				"leavesAt": "10:46",
				"arrivesAt": "10:50",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Stoeneşti h.",
				"leavesAt": "10:51",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Stoeneşti h.",
				"to": "Fărcaşele Hm.",
				"leavesAt": "10:58",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Fărcaşele Hm.",
				"to": "Caracal",
				"leavesAt": "11:04",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Caracal",
				"to": "Cezieni h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Cezieni h.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:27",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Radomiru hc.",
				"leavesAt": "11:28",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Radomiru hc.",
				"to": "Jianca",
				"leavesAt": "11:34",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jianca",
				"to": "Ţărţăl h.",
				"leavesAt": "11:38",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţărţăl h.",
				"to": "Leu Hm.",
				"leavesAt": "11:42",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Leu Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "11:48",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Malu Mare Hm.",
				"leavesAt": "11:57",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "12:01",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "12:04",
				"arrivesAt": "12:08",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Bordei hc.(900)",
				"leavesAt": "12:09",
				"arrivesAt": "12:13",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Craiova",
				"leavesAt": "12:14",
				"arrivesAt": "12:19",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9053",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "16:00",
				"arrivesAt": "16:05",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Km. 200+400 P.aj.m",
				"leavesAt": "16:06",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Km. 200+400 P.aj.m",
				"to": "Troian h.",
				"leavesAt": "16:14",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Troian h.",
				"to": "Salcia Teleorman Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Salcia Teleorman Hm.",
				"to": "Km. 231+600 h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 14500
			},
			{
				"from": "Km. 231+600 h.",
				"to": "Turnu Măgurele",
				"leavesAt": "16:55",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2084",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Lunca Jiului hc.",
				"leavesAt": "14:20",
				"arrivesAt": "14:23",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Livezeni",
				"leavesAt": "14:24",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "14:38",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Lainici Hm.",
				"leavesAt": "14:53",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Lainici Hm.",
				"to": "Meri",
				"leavesAt": "15:01",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Meri",
				"to": "Valea Sadului Hm.",
				"leavesAt": "15:12",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Parângu Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Parângu Hm.",
				"to": "Ezureni h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Ezureni h.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "15:37",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Târgu Jiu",
				"leavesAt": "15:46",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 800
			},
			{
				"from": "Târgu Jiu",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:17",
				"waitsAtSource": 1200,
				"distance": 6800
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Budieni h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Budieni h.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Pojogeni Hm.",
				"leavesAt": "16:28",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "16:35",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cărbuneşti",
				"to": "Jupâneşti Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 300,
				"distance": 5400
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "17:01",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Musculeşti",
				"to": "Bibeşti Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "17:15",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Turburea Hm.",
				"to": "Gilort Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gilort Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "17:38",
				"arrivesAt": "17:41",
				"waitsAtSource": 360,
				"distance": 3700
			},
			{
				"from": "Floreşti hc.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Bungeţel h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bungeţel h.",
				"to": "Filiaşi",
				"leavesAt": "17:53",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "18:23",
				"arrivesAt": "18:28",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "18:29",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "18:32",
				"arrivesAt": "18:36",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "18:37",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 863
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4513",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:22",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "16:23",
				"arrivesAt": "16:29",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:42",
				"waitsAtSource": 360,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "16:47",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "16:52",
				"arrivesAt": "16:57",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "16:58",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Bodoc Hm.",
				"leavesAt": "17:07",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Bodoc Hm.",
				"to": "Malnaş h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Malnaş h.",
				"to": "Malnaş Băi",
				"leavesAt": "17:24",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş Băi",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:48",
				"waitsAtSource": 420,
				"distance": 7800
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "18:00",
				"arrivesAt": "18:09",
				"waitsAtSource": 720,
				"distance": 6100
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Vrabia h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Vrabia h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "18:22",
				"arrivesAt": "18:28",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "18:29",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "18:33",
				"arrivesAt": "18:37",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "18:38",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "18:57",
				"arrivesAt": "19:05",
				"waitsAtSource": 660,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:12",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "19:13",
				"arrivesAt": "19:21",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:32",
				"waitsAtSource": 360,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "19:33",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:40",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "19:41",
				"arrivesAt": "19:45",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "19:47",
				"arrivesAt": "19:51",
				"waitsAtSource": 120,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "20:01",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:14",
				"waitsAtSource": 120,
				"distance": 10100
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Şugău h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şugău h.",
				"to": "Valea Strâmbă h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Gheorgheni",
				"leavesAt": "20:23",
				"arrivesAt": "20:27",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Gheorgheni",
				"to": "Lăzarea Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 300,
				"distance": 4400
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Ditrău",
				"leavesAt": "20:38",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Ditrău",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "20:53",
				"arrivesAt": "21:02",
				"waitsAtSource": 480,
				"distance": 8500
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Topliţa",
				"leavesAt": "21:18",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 6000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3512",
		"segments": [
			{
				"from": "Teiuş",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "06:37",
				"arrivesAt": "06:44",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Mihalţ h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Mihalţ h.",
				"to": "Cistei h.",
				"leavesAt": "06:49",
				"arrivesAt": "06:54",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Cistei h.",
				"to": "Crăciunel Hm.",
				"leavesAt": "06:55",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Blaj",
				"leavesAt": "07:06",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Blaj",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "07:19",
				"arrivesAt": "07:23",
				"waitsAtSource": 300,
				"distance": 3500
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Mănărade h.",
				"leavesAt": "07:24",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mănărade h.",
				"to": "Glogoveţ h.",
				"leavesAt": "07:29",
				"arrivesAt": "07:32",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Glogoveţ h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "07:33",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Lunca h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:46",
				"waitsAtSource": 360,
				"distance": 2100
			},
			{
				"from": "Lunca h.",
				"to": "Micăsasa h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Micăsasa h.",
				"to": "Şeica Mică h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Şeica Mică h.",
				"to": "Copşa Mică",
				"leavesAt": "08:06",
				"arrivesAt": "08:15",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "08:24",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Bratei h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:41",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Bratei h.",
				"to": "Aţel Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Aţel Hm.",
				"to": "Dumbrăveni",
				"leavesAt": "08:51",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Dumbrăveni",
				"to": "Luna h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Luna h.",
				"to": "Daneş Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Daneş Hm.",
				"to": "Sighişoara",
				"leavesAt": "09:18",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4318",
		"segments": [
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:51",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "06:52",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "07:11",
				"arrivesAt": "07:18",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1539",
		"segments": [
			{
				"from": "Braşov",
				"to": "Sighişoara",
				"leavesAt": "15:08",
				"arrivesAt": "17:44",
				"waitsAtSource": 0,
				"distance": 127400
			},
			{
				"from": "Sighişoara",
				"to": "Mediaş",
				"leavesAt": "17:49",
				"arrivesAt": "18:39",
				"waitsAtSource": 300,
				"distance": 38400
			},
			{
				"from": "Mediaş",
				"to": "Copşa Mică",
				"leavesAt": "18:41",
				"arrivesAt": "18:54",
				"waitsAtSource": 120,
				"distance": 10400
			},
			{
				"from": "Copşa Mică",
				"to": "Blaj",
				"leavesAt": "18:55",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Blaj",
				"to": "Teiuş",
				"leavesAt": "19:34",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 21300
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "20:06",
				"arrivesAt": "20:19",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Unirea hc.",
				"leavesAt": "20:20",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "20:36",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "20:44",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "21:01",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 51500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1945",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun hc.",
				"leavesAt": "15:30",
				"arrivesAt": "15:40",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "15:42",
				"arrivesAt": "15:54",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "16:10",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "16:20",
				"arrivesAt": "16:27",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:38",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "16:39",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "17:20",
				"arrivesAt": "17:46",
				"waitsAtSource": 1260,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "17:47",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "18:05",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Bucureşti Băneasa",
				"leavesAt": "18:27",
				"arrivesAt": "19:41",
				"waitsAtSource": 120,
				"distance": 139800
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Ploieşti Vest",
				"leavesAt": "19:43",
				"arrivesAt": "20:24",
				"waitsAtSource": 120,
				"distance": 58100
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "20:27",
				"arrivesAt": "20:50",
				"waitsAtSource": 180,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "20:52",
				"arrivesAt": "21:15",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "21:17",
				"arrivesAt": "21:25",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Predeal",
				"leavesAt": "21:27",
				"arrivesAt": "21:40",
				"waitsAtSource": 120,
				"distance": 11400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "21:43",
				"arrivesAt": "22:21",
				"waitsAtSource": 180,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "22:33",
				"arrivesAt": "23:02",
				"waitsAtSource": 720,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "23:04",
				"arrivesAt": "23:36",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "23:38",
				"arrivesAt": "23:47",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Miercurea Ciuc",
				"leavesAt": "23:54",
				"arrivesAt": "00:11",
				"waitsAtSource": 420,
				"distance": 22800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "00:12",
				"arrivesAt": "00:20",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Izvoru Oltului",
				"leavesAt": "00:24",
				"arrivesAt": "00:40",
				"waitsAtSource": 240,
				"distance": 17100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "00:41",
				"arrivesAt": "00:53",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Gheorgheni",
				"leavesAt": "00:59",
				"arrivesAt": "01:17",
				"waitsAtSource": 360,
				"distance": 19100
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "01:18",
				"arrivesAt": "01:51",
				"waitsAtSource": 60,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "01:55",
				"arrivesAt": "02:56",
				"waitsAtSource": 240,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Sărăţel Hm.",
				"leavesAt": "03:10",
				"arrivesAt": "04:04",
				"waitsAtSource": 840,
				"distance": 46800
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Şintereag Hm.",
				"leavesAt": "04:06",
				"arrivesAt": "04:24",
				"waitsAtSource": 120,
				"distance": 17500
			},
			{
				"from": "Şintereag Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "04:28",
				"arrivesAt": "04:37",
				"waitsAtSource": 240,
				"distance": 7400
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "04:49",
				"arrivesAt": "05:23",
				"waitsAtSource": 720,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Gâlgău",
				"leavesAt": "05:35",
				"arrivesAt": "05:59",
				"waitsAtSource": 720,
				"distance": 23400
			},
			{
				"from": "Gâlgău",
				"to": "Ileanda",
				"leavesAt": "06:00",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Ileanda",
				"to": "Letca Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Letca Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "06:37",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Jibou",
				"leavesAt": "06:49",
				"arrivesAt": "07:14",
				"waitsAtSource": 240,
				"distance": 18500
			},
			{
				"from": "Jibou",
				"to": "Benesat Hm.",
				"leavesAt": "07:23",
				"arrivesAt": "07:41",
				"waitsAtSource": 540,
				"distance": 18000
			},
			{
				"from": "Benesat Hm.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "07:42",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Baia Mare",
				"leavesAt": "08:01",
				"arrivesAt": "08:33",
				"waitsAtSource": 600,
				"distance": 31000
			},
			{
				"from": "Baia Mare",
				"to": "Seini",
				"leavesAt": "08:51",
				"arrivesAt": "09:27",
				"waitsAtSource": 1080,
				"distance": 24600
			},
			{
				"from": "Seini",
				"to": "Satu Mare",
				"leavesAt": "09:28",
				"arrivesAt": "10:05",
				"waitsAtSource": 60,
				"distance": 34800
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1839",
		"segments": [
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "00:40",
				"arrivesAt": "00:52",
				"waitsAtSource": 0,
				"distance": 9200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5504",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "21:06",
				"arrivesAt": "21:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "21:13",
				"arrivesAt": "21:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "21:21",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "21:29",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "21:43",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "21:49",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "21:59",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "22:11",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "22:17",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2041",
		"segments": [
			{
				"from": "Săvârşin",
				"to": "Vărădia h.",
				"leavesAt": "04:40",
				"arrivesAt": "04:46",
				"waitsAtSource": 0,
				"distance": 6000
			},
			{
				"from": "Vărădia h.",
				"to": "Vărădia Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:52",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărădia Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "04:53",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "04:59",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Căpruţa h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Căpruţa h.",
				"to": "Bârzava",
				"leavesAt": "05:12",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Bârzava",
				"to": "Nadăş h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nadăş h.",
				"to": "Conop Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Conop Hm.",
				"to": "Corfeni h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Corfeni h.",
				"to": "Milova",
				"leavesAt": "05:37",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Milova",
				"to": "Radna",
				"leavesAt": "05:44",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Radna",
				"to": "Păuliş Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Păuliş Hm.",
				"to": "Păuliş h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş h.",
				"to": "Ghioroc",
				"leavesAt": "06:11",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ghioroc",
				"to": "Glogovăţ",
				"leavesAt": "06:19",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Glogovăţ",
				"to": "Arad",
				"leavesAt": "06:32",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "36322",
		"segments": [
			{
				"from": "Carei",
				"to": "Tiborszallas",
				"leavesAt": "09:27",
				"arrivesAt": "09:53",
				"waitsAtSource": 0,
				"distance": 16100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5473",
		"segments": [
			{
				"from": "Bacău",
				"to": "Hămeiuş P.M.",
				"leavesAt": "16:34",
				"arrivesAt": "16:43",
				"waitsAtSource": 0,
				"distance": 7900
			},
			{
				"from": "Hămeiuş P.M.",
				"to": "Gârleni Hm.",
				"leavesAt": "16:44",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Gârleni Hm.",
				"to": "Lespezi Bacău h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Lespezi Bacău h.",
				"to": "Racova h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Racova h.",
				"to": "Buhuşi",
				"leavesAt": "17:05",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Buhuşi",
				"to": "Costişa h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:26",
				"waitsAtSource": 420,
				"distance": 6300
			},
			{
				"from": "Costişa h.",
				"to": "Podoleni Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Podoleni Hm.",
				"to": "Zăneşti Neamţ h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Zăneşti Neamţ h.",
				"to": "Roznov",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Roznov",
				"to": "Săvineşti h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Săvineşti h.",
				"to": "Dumbrava h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumbrava h.",
				"to": "Piatra Neamţ",
				"leavesAt": "18:05",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Piatra Neamţ",
				"to": "Vaduri h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:26",
				"waitsAtSource": 120,
				"distance": 9600
			},
			{
				"from": "Vaduri h.",
				"to": "Pângăraţi Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pângăraţi Hm.",
				"to": "Stejaru h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Stejaru h.",
				"to": "Tarcău Neamţ Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tarcău Neamţ Hm.",
				"to": "Bicaz",
				"leavesAt": "18:46",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5604",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "11:06",
				"arrivesAt": "11:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "11:13",
				"arrivesAt": "11:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "11:21",
				"arrivesAt": "11:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "11:29",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "11:36",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "11:49",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "11:59",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "12:05",
				"arrivesAt": "12:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "12:11",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "12:17",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "12:31",
				"arrivesAt": "12:45",
				"waitsAtSource": 480,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "12:46",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "12:54",
				"arrivesAt": "12:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "13:00",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "13:20",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "13:27",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "13:34",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "13:42",
				"arrivesAt": "13:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "37651",
		"segments": [
			{
				"from": "Salonta",
				"to": "Kotegyan",
				"leavesAt": "18:30",
				"arrivesAt": "18:50",
				"waitsAtSource": 0,
				"distance": 13200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4422",
		"segments": [
			{
				"from": "Jibou",
				"to": "Var h.",
				"leavesAt": "03:50",
				"arrivesAt": "03:54",
				"waitsAtSource": 0,
				"distance": 2800
			},
			{
				"from": "Var h.",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "03:55",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Ciocmani h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:07",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ciocmani h.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "04:08",
				"arrivesAt": "04:14",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "04:15",
				"arrivesAt": "04:21",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Letca Hm.",
				"leavesAt": "04:22",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Letca Hm.",
				"to": "Răstoci Hm.",
				"leavesAt": "04:30",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Răstoci Hm.",
				"to": "Bizuşa h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bizuşa h.",
				"to": "Ileanda",
				"leavesAt": "04:48",
				"arrivesAt": "04:52",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Ileanda",
				"to": "Rus h.",
				"leavesAt": "04:54",
				"arrivesAt": "05:00",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Rus h.",
				"to": "Glodu Someşului h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Glodu Someşului h.",
				"to": "Gâlgău h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Gâlgău h.",
				"to": "Gâlgău",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Gâlgău",
				"to": "Căpâlna pe Someş h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:28",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Căpâlna pe Someş h.",
				"to": "Câţcău h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:35",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Câţcău h.",
				"to": "Coplean h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Coplean h.",
				"to": "Căşeiu Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Căşeiu Hm.",
				"to": "C. C. H. Dej h.",
				"leavesAt": "05:47",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "C. C. H. Dej h.",
				"to": "Dej Călători",
				"leavesAt": "05:53",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180430",
				"daysOfWeek": 319
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 319
			},
			{
				"from": "20180602",
				"to": "20181129",
				"daysOfWeek": 319
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1981",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Feteşti",
				"leavesAt": "05:40",
				"arrivesAt": "06:57",
				"waitsAtSource": 0,
				"distance": 146400
			},
			{
				"from": "Feteşti",
				"to": "Medgidia",
				"leavesAt": "06:59",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 44000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "07:34",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4337",
		"segments": [
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "15:36",
				"arrivesAt": "15:44",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharia Hm.",
				"leavesAt": "15:45",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Biharia Hm.",
				"to": "Tămăşeu h.",
				"leavesAt": "15:55",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tămăşeu h.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Diosig Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Diosig Hm.",
				"to": "Cadia h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:34",
				"waitsAtSource": 540,
				"distance": 5400
			},
			{
				"from": "Cadia h.",
				"to": "Săcuieni Bihor",
				"leavesAt": "16:35",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Şilindru Hm.",
				"leavesAt": "16:44",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Şilindru Hm.",
				"to": "Simion h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Simion h.",
				"to": "Valea lui Mihai",
				"leavesAt": "17:02",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Valea lui Mihai",
				"to": "Curtuiuşeni h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Resighea h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Resighea h.",
				"to": "Sanislău Hm.",
				"leavesAt": "17:24",
				"arrivesAt": "17:29",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Sanislău Hm.",
				"to": "Marna h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:44",
				"waitsAtSource": 600,
				"distance": 5100
			},
			{
				"from": "Marna h.",
				"to": "Carei",
				"leavesAt": "17:45",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "17:54",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "18:03",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "18:08",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "18:22",
				"arrivesAt": "18:28",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "18:29",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:44",
				"waitsAtSource": 120,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "18:45",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "18:53",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180607",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4482",
		"segments": [
			{
				"from": "Dej Călători",
				"to": "Dej Triaj",
				"leavesAt": "07:13",
				"arrivesAt": "07:20",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Dej Triaj",
				"to": "Reteag Hm.",
				"leavesAt": "07:21",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Reteag Hm.",
				"to": "Reteag h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag h.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:40",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Coldău Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Coldău Hm.",
				"to": "Beclean pe Someş",
				"leavesAt": "07:45",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5446",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "07:13",
				"arrivesAt": "07:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "07:21",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "07:29",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "07:49",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "07:59",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "08:17",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Stolniceni h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:35",
				"waitsAtSource": 300,
				"distance": 7100
			},
			{
				"from": "Stolniceni h.",
				"to": "Muncel Hm.",
				"leavesAt": "08:36",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Muncel Hm.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Hălăuceşti hc.",
				"leavesAt": "08:47",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mirceşti",
				"leavesAt": "08:53",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mirceşti",
				"to": "Săbăoani Hm.",
				"leavesAt": "08:58",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Roman",
				"leavesAt": "09:05",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Roman",
				"to": "Ram. Trifeşti",
				"leavesAt": "09:16",
				"arrivesAt": "09:23",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Galbeni",
				"leavesAt": "09:29",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Galbeni",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Iteşti Hm.",
				"leavesAt": "09:44",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Iteşti Hm.",
				"to": "Bacău",
				"leavesAt": "09:50",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1532",
		"segments": [
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "06:00",
				"arrivesAt": "06:30",
				"waitsAtSource": 0,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "06:31",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "06:52",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:12",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Ciucea Hm.",
				"leavesAt": "07:16",
				"arrivesAt": "07:26",
				"waitsAtSource": 240,
				"distance": 10800
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "07:27",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "07:55",
				"arrivesAt": "08:18",
				"waitsAtSource": 480,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "08:19",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 27900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5405",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "18:45",
				"arrivesAt": "18:52",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "18:53",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "18:58",
				"arrivesAt": "19:04",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "19:09",
				"arrivesAt": "19:21",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Adjud",
				"to": "Adjudu Vechi h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:35",
				"waitsAtSource": 600,
				"distance": 4100
			},
			{
				"from": "Adjudu Vechi h.",
				"to": "Şişcani h.",
				"leavesAt": "19:36",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Şişcani h.",
				"to": "Sascut Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sascut Hm.",
				"to": "Orbeni Hm.",
				"leavesAt": "19:48",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Orbeni Hm.",
				"to": "Răcăciuni h.",
				"leavesAt": "19:56",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Răcăciuni h.",
				"to": "Faraoani Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Faraoani Hm.",
				"to": "Siretu Bacău h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Siretu Bacău h.",
				"to": "Valea Seacă",
				"leavesAt": "20:18",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Valea Seacă",
				"to": "Letea h.",
				"leavesAt": "20:24",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Letea h.",
				"to": "Bacău",
				"leavesAt": "20:31",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9136",
		"segments": [
			{
				"from": "Calafat",
				"to": "Golenţi Hm.",
				"leavesAt": "12:55",
				"arrivesAt": "13:10",
				"waitsAtSource": 0,
				"distance": 11800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1645",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "12:15",
				"arrivesAt": "12:57",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "12:59",
				"arrivesAt": "13:22",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "13:23",
				"arrivesAt": "13:47",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "13:49",
				"arrivesAt": "13:58",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "13:59",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "14:06",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "14:17",
				"arrivesAt": "14:32",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Braşov",
				"leavesAt": "14:33",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 16400
			},
			{
				"from": "Braşov",
				"to": "Sfântu Gheorghe",
				"leavesAt": "15:10",
				"arrivesAt": "15:39",
				"waitsAtSource": 720,
				"distance": 32100
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "15:41",
				"arrivesAt": "16:13",
				"waitsAtSource": 120,
				"distance": 34400
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "16:14",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 28500
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "16:39",
				"arrivesAt": "16:47",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "16:51",
				"arrivesAt": "17:01",
				"waitsAtSource": 240,
				"distance": 7100
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Izvoru Oltului",
				"leavesAt": "17:07",
				"arrivesAt": "17:17",
				"waitsAtSource": 360,
				"distance": 10000
			},
			{
				"from": "Izvoru Oltului",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 10900
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Gheorgheni",
				"leavesAt": "17:30",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Gheorgheni",
				"to": "Topliţa",
				"leavesAt": "17:49",
				"arrivesAt": "18:21",
				"waitsAtSource": 120,
				"distance": 34000
			},
			{
				"from": "Topliţa",
				"to": "Deda",
				"leavesAt": "18:23",
				"arrivesAt": "19:22",
				"waitsAtSource": 120,
				"distance": 43900
			},
			{
				"from": "Deda",
				"to": "Reghin",
				"leavesAt": "19:41",
				"arrivesAt": "20:03",
				"waitsAtSource": 1140,
				"distance": 22000
			},
			{
				"from": "Reghin",
				"to": "Târgu Mureş",
				"leavesAt": "20:10",
				"arrivesAt": "20:45",
				"waitsAtSource": 420,
				"distance": 32300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6312",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "05:01",
				"arrivesAt": "05:08",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "05:09",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "05:37",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:55",
				"waitsAtSource": 240,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "06:09",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "06:26",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "06:32",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Vaslui",
				"to": "Munteni Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Munteni Hm.",
				"to": "Bulboaca h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bulboaca h.",
				"to": "Crasna",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Crasna",
				"to": "Roşieşti hc.",
				"leavesAt": "07:01",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Roşieşti hc.",
				"to": "Dodeşti hc.",
				"leavesAt": "07:10",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Dodeşti hc.",
				"to": "Banca Hm.",
				"leavesAt": "07:17",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Banca Hm.",
				"to": "Zorleni",
				"leavesAt": "07:24",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Zorleni",
				"to": "Bârlad",
				"leavesAt": "07:35",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bârlad",
				"to": "Dragalina h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:58",
				"waitsAtSource": 360,
				"distance": 8200
			},
			{
				"from": "Dragalina h.",
				"to": "Tutova",
				"leavesAt": "07:59",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Tutova",
				"to": "Ghidigeni Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:33",
				"waitsAtSource": 900,
				"distance": 7100
			},
			{
				"from": "Ghidigeni Hm.",
				"to": "Nichişeni",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nichişeni",
				"to": "Berheci Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Berheci Hm.",
				"to": "Rateş Munteni h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Rateş Munteni h.",
				"to": "Frunzeasca Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Frunzeasca Hm.",
				"to": "Tecuci Nord hc.(600)",
				"leavesAt": "09:03",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tecuci Nord hc.(600)",
				"to": "Tecuci",
				"leavesAt": "09:12",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4550",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "22:47",
				"arrivesAt": "22:55",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "22:56",
				"arrivesAt": "23:08",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "23:09",
				"arrivesAt": "23:13",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "23:14",
				"arrivesAt": "23:19",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "23:20",
				"arrivesAt": "23:25",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "23:26",
				"arrivesAt": "23:36",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "23:37",
				"arrivesAt": "23:43",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "23:44",
				"arrivesAt": "23:49",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "23:50",
				"arrivesAt": "23:54",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "23:55",
				"arrivesAt": "00:00",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "00:01",
				"arrivesAt": "00:04",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "00:05",
				"arrivesAt": "00:11",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1787",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "14:30",
				"arrivesAt": "15:32",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "15:35",
				"arrivesAt": "15:54",
				"waitsAtSource": 180,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "15:55",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "16:26",
				"arrivesAt": "16:37",
				"waitsAtSource": 420,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7574",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:53",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "17:54",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Şendreni Hm.",
				"leavesAt": "18:01",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Şendreni Hm.",
				"to": "Braniştea h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Braniştea h.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Independenţa Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:28",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Independenţa Hm.",
				"to": "Piscu h.",
				"leavesAt": "18:29",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Piscu h.",
				"to": "Vameş h.",
				"leavesAt": "18:36",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vameş h.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "18:48",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Şerbăneşti h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Lieşti",
				"leavesAt": "19:00",
				"arrivesAt": "19:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lieşti",
				"to": "Buceşti h.",
				"leavesAt": "19:04",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Buceşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:12",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Iveşti Hm.",
				"to": "Umbrăreşti h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Barcea",
				"leavesAt": "19:18",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Barcea",
				"to": "Malul Alb h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Malul Alb h.",
				"to": "Tecuci",
				"leavesAt": "19:28",
				"arrivesAt": "19:38",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "19:39",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "19:54",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9478",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "19:04",
				"arrivesAt": "19:09",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:15",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:26",
				"waitsAtSource": 240,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "19:27",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:51",
				"waitsAtSource": 540,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "19:52",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "20:01",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "20:19",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:38",
				"waitsAtSource": 240,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "20:39",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "20:46",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "20:56",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Pârvu h.",
				"leavesAt": "21:06",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Pârvu h.",
				"to": "Bradu de Sus",
				"leavesAt": "21:15",
				"arrivesAt": "21:31",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "21:37",
				"arrivesAt": "21:39",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2089",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "16:20",
				"arrivesAt": "16:23",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "16:24",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "16:28",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "16:41",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "16:51",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "17:01",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Bungeţel h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:20",
				"waitsAtSource": 720,
				"distance": 2300
			},
			{
				"from": "Bungeţel h.",
				"to": "Ţânţăreni Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ţânţăreni Hm.",
				"to": "Floreşti hc.",
				"leavesAt": "17:26",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Floreşti hc.",
				"to": "Gilort Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Gilort Hm.",
				"to": "Turburea Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turburea Hm.",
				"to": "Bibeşti Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Bibeşti Hm.",
				"to": "Musculeşti",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Musculeşti",
				"to": "Bărbăteşti Hm.",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bărbăteşti Hm.",
				"to": "Jupâneşti Hm.",
				"leavesAt": "18:05",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Jupâneşti Hm.",
				"to": "Cărbuneşti",
				"leavesAt": "18:11",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cărbuneşti",
				"to": "Pojogeni Hm.",
				"leavesAt": "18:20",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pojogeni Hm.",
				"to": "Copăcioasa Hm.",
				"leavesAt": "18:28",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Copăcioasa Hm.",
				"to": "Budieni h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budieni h.",
				"to": "Lunca Budieni Hm.",
				"leavesAt": "18:40",
				"arrivesAt": "18:44",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Lunca Budieni Hm.",
				"to": "Târgu Jiu",
				"leavesAt": "18:45",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Târgu Jiu",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "18:58",
				"arrivesAt": "19:03",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Parângu Hm.",
				"leavesAt": "19:04",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Parângu Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "19:13",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Valea Sadului Hm.",
				"leavesAt": "19:20",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Meri",
				"leavesAt": "19:27",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Meri",
				"to": "Lainici Hm.",
				"leavesAt": "19:36",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lainici Hm.",
				"to": "Km. 105+600 h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:57",
				"waitsAtSource": 300,
				"distance": 3800
			},
			{
				"from": "Km. 105+600 h.",
				"to": "Pietrele Albe Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:03",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pietrele Albe Hm.",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "20:04",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Livezeni",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Lunca Jiului hc.",
				"leavesAt": "20:22",
				"arrivesAt": "20:25",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Petroşani",
				"leavesAt": "20:26",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2503",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "16:14",
				"arrivesAt": "16:20",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Ghimbav Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ghimbav Hm.",
				"to": "Codlea Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Codlea Hm.",
				"to": "Dumbrăviţa Bârsei Hm.",
				"leavesAt": "16:36",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Dumbrăviţa Bârsei Hm.",
				"to": "Vlădeni Ardeal",
				"leavesAt": "16:46",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vlădeni Ardeal",
				"to": "Valea Homorod h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Valea Homorod h.",
				"to": "Brădet Hm.",
				"leavesAt": "16:59",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Brădet Hm.",
				"to": "Perşani h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:31",
				"waitsAtSource": 780,
				"distance": 5700
			},
			{
				"from": "Perşani h.",
				"to": "Şercaia Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Şercaia Hm.",
				"to": "Şercaia h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 1200
			},
			{
				"from": "Şercaia h.",
				"to": "Mândra Oltului h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândra Oltului h.",
				"to": "Făgăraş",
				"leavesAt": "17:53",
				"arrivesAt": "17:59",
				"waitsAtSource": 30,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3643",
		"segments": [
			{
				"from": "Huedin",
				"to": "Brăişoru Hm.",
				"leavesAt": "14:41",
				"arrivesAt": "14:49",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Bologa h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bologa h.",
				"to": "Poieni",
				"leavesAt": "14:54",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Valea Drăganului h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Ciucea Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:07",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "15:08",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180203",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180604",
				"to": "20180608",
				"daysOfWeek": 799
			},
			{
				"from": "20180611",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180804",
				"to": "20180805",
				"daysOfWeek": 799
			},
			{
				"from": "20180818",
				"to": "20180818",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180901",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2856",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "19:00",
				"arrivesAt": "19:06",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Drăguţeşti h.",
				"leavesAt": "19:07",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Drăguţeşti h.",
				"to": "Cârbeşti Hm.",
				"leavesAt": "19:11",
				"arrivesAt": "19:15",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Vârţ h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vârţ h.",
				"to": "Rogojelu",
				"leavesAt": "19:21",
				"arrivesAt": "19:25",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Rovinari Hm.",
				"to": "Rovinari Sud h.",
				"leavesAt": "19:34",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rovinari Sud h.",
				"to": "Roşia Jiu h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Roşia Jiu h.",
				"to": "Vlăduleni Gorj h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:44",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Vlăduleni Gorj h.",
				"to": "Bâlteni h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Bâlteni h.",
				"to": "Peşteana Jiu h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:52",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Peşteana Jiu h.",
				"to": "Plopşoru",
				"leavesAt": "19:53",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Plopşoru",
				"to": "Sărdăneşti h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sărdăneşti h.",
				"to": "Gârbovu h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Gârbovu h.",
				"to": "Turceni",
				"leavesAt": "20:12",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Turceni",
				"to": "Termo Turceni h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 900
			},
			{
				"from": "Termo Turceni h.",
				"to": "Km. 9+820 h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Km. 9+820 h.",
				"to": "Ioneşti Gorj h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ioneşti Gorj h.",
				"to": "Filiaşi",
				"leavesAt": "20:32",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 12400
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:54",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "20:55",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "21:05",
				"arrivesAt": "21:11",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "21:12",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "21:16",
				"arrivesAt": "21:21",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "21:22",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "21:25",
				"arrivesAt": "21:29",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "21:30",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "21:34",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8384",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "07:45",
				"arrivesAt": "07:51",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Pescăruş h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăruş h.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "08:03",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:26",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "08:49",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180503",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4442",
		"segments": [
			{
				"from": "Zalău Nord",
				"to": "Guruslău h.",
				"leavesAt": "23:29",
				"arrivesAt": "23:35",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Guruslău h.",
				"to": "Borla Hm.",
				"leavesAt": "23:36",
				"arrivesAt": "23:41",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Borla Hm.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "23:42",
				"arrivesAt": "23:46",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "23:47",
				"arrivesAt": "23:51",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Sărmăşag",
				"leavesAt": "23:52",
				"arrivesAt": "23:59",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5482",
		"segments": [
			{
				"from": "Bicaz",
				"to": "Tarcău Neamţ Hm.",
				"leavesAt": "21:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Tarcău Neamţ Hm.",
				"to": "Pângăraţi Hm.",
				"leavesAt": "22:05",
				"arrivesAt": "22:15",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Pângăraţi Hm.",
				"to": "Piatra Neamţ",
				"leavesAt": "22:16",
				"arrivesAt": "22:31",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Piatra Neamţ",
				"to": "Roznov",
				"leavesAt": "22:33",
				"arrivesAt": "22:49",
				"waitsAtSource": 120,
				"distance": 15200
			},
			{
				"from": "Roznov",
				"to": "Podoleni Hm.",
				"leavesAt": "22:50",
				"arrivesAt": "23:01",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Podoleni Hm.",
				"to": "Buhuşi",
				"leavesAt": "23:02",
				"arrivesAt": "23:16",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Buhuşi",
				"to": "Gârleni Hm.",
				"leavesAt": "23:17",
				"arrivesAt": "23:29",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Gârleni Hm.",
				"to": "Bacău",
				"leavesAt": "23:30",
				"arrivesAt": "23:48",
				"waitsAtSource": 60,
				"distance": 12800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5734",
		"segments": [
			{
				"from": "Cacica Hm.",
				"to": "Pârteşti h.",
				"leavesAt": "09:50",
				"arrivesAt": "09:57",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Pârteşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "09:58",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Soloneţ h.",
				"to": "Todireşti h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:12",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Todireşti h.",
				"to": "Părhăuţi h.",
				"leavesAt": "10:13",
				"arrivesAt": "10:21",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Părhăuţi h.",
				"to": "Dărmăneşti",
				"leavesAt": "10:22",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "10:31",
				"arrivesAt": "10:38",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "10:39",
				"arrivesAt": "10:44",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1741",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "18:45",
				"arrivesAt": "19:26",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "19:28",
				"arrivesAt": "19:52",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "19:53",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "20:18",
				"arrivesAt": "20:26",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "20:27",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "20:34",
				"arrivesAt": "20:44",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "20:46",
				"arrivesAt": "21:24",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Rupea",
				"leavesAt": "21:32",
				"arrivesAt": "23:07",
				"waitsAtSource": 480,
				"distance": 73800
			},
			{
				"from": "Rupea",
				"to": "Sighişoara",
				"leavesAt": "23:08",
				"arrivesAt": "00:17",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Sighişoara",
				"to": "Dumbrăveni",
				"leavesAt": "00:21",
				"arrivesAt": "00:48",
				"waitsAtSource": 240,
				"distance": 20400
			},
			{
				"from": "Dumbrăveni",
				"to": "Mediaş",
				"leavesAt": "00:49",
				"arrivesAt": "01:15",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Mediaş",
				"to": "Copşa Mică",
				"leavesAt": "01:17",
				"arrivesAt": "01:31",
				"waitsAtSource": 120,
				"distance": 10400
			},
			{
				"from": "Copşa Mică",
				"to": "Blaj",
				"leavesAt": "01:32",
				"arrivesAt": "02:11",
				"waitsAtSource": 60,
				"distance": 30000
			},
			{
				"from": "Blaj",
				"to": "Teiuş",
				"leavesAt": "02:12",
				"arrivesAt": "02:42",
				"waitsAtSource": 60,
				"distance": 21300
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "02:49",
				"arrivesAt": "03:04",
				"waitsAtSource": 420,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Războieni",
				"leavesAt": "03:06",
				"arrivesAt": "03:29",
				"waitsAtSource": 120,
				"distance": 20400
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "03:31",
				"arrivesAt": "03:47",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "03:48",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 51500
			},
			{
				"from": "Cluj Napoca",
				"to": "Aghireş",
				"leavesAt": "05:11",
				"arrivesAt": "05:41",
				"waitsAtSource": 1020,
				"distance": 27900
			},
			{
				"from": "Aghireş",
				"to": "Huedin",
				"leavesAt": "05:42",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Bratca",
				"leavesAt": "06:36",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Bratca",
				"to": "Aleşd",
				"leavesAt": "07:01",
				"arrivesAt": "07:27",
				"waitsAtSource": 240,
				"distance": 25300
			},
			{
				"from": "Aleşd",
				"to": "Oradea",
				"leavesAt": "07:28",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 34300
			},
			{
				"from": "Oradea",
				"to": "Săcuieni Bihor",
				"leavesAt": "08:11",
				"arrivesAt": "08:54",
				"waitsAtSource": 720,
				"distance": 44200
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Valea lui Mihai",
				"leavesAt": "08:55",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Valea lui Mihai",
				"to": "Carei",
				"leavesAt": "09:15",
				"arrivesAt": "09:39",
				"waitsAtSource": 60,
				"distance": 31200
			},
			{
				"from": "Carei",
				"to": "Satu Mare",
				"leavesAt": "09:40",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 36000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2072",
		"segments": [
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "13:05",
				"arrivesAt": "13:10",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "13:11",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Valea Fratelui h.",
				"leavesAt": "13:22",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Valea Fratelui h.",
				"to": "Râu Vadului h.",
				"leavesAt": "13:33",
				"arrivesAt": "13:37",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "13:38",
				"arrivesAt": "13:48",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "13:49",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Balota h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Balota h.",
				"to": "Cornet Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:06",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cornet Hm.",
				"to": "Beţel h.",
				"leavesAt": "14:07",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Beţel h.",
				"to": "Lotru",
				"leavesAt": "14:12",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "14:38",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "14:43",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "14:49",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "15:12",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Ostroveni h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:22",
				"waitsAtSource": 300,
				"distance": 1000
			},
			{
				"from": "Ostroveni h.",
				"to": "Răstoaca h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Răstoaca h.",
				"to": "Râureni",
				"leavesAt": "15:27",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Râureni",
				"to": "Râureni hc.",
				"leavesAt": "15:30",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni hc.",
				"to": "Govora",
				"leavesAt": "15:36",
				"arrivesAt": "15:41",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Govora",
				"to": "Tătărani h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Tătărani h.",
				"to": "Băbeni",
				"leavesAt": "15:48",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Băbeni",
				"to": "Slăviteşti hc.",
				"leavesAt": "15:55",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Slăviteşti hc.",
				"to": "Ioneşti Hm.",
				"leavesAt": "16:01",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Ioneşti Hm.",
				"to": "Bucşani Vâlcea h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bucşani Vâlcea h.",
				"to": "Fişcălia Hm.",
				"leavesAt": "16:13",
				"arrivesAt": "16:17",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Fişcălia Hm.",
				"to": "Orleşti hc.",
				"leavesAt": "16:18",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Orleşti hc.",
				"to": "Zăvideni Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Călina h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:40",
				"waitsAtSource": 540,
				"distance": 3800
			},
			{
				"from": "Călina h.",
				"to": "Drăgăşani",
				"leavesAt": "16:41",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Drăgăşani",
				"to": "Zlătărei Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "16:57",
				"waitsAtSource": 120,
				"distance": 6600
			},
			{
				"from": "Zlătărei Hm.",
				"to": "Strejeşti",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Strejeşti",
				"to": "Colibaşi h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Colibaşi h.",
				"to": "Arceşti Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Arceşti Hm.",
				"to": "Găneasa Olt h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Găneasa Olt h.",
				"to": "Găneasa h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Găneasa h.",
				"to": "Piatra Olt",
				"leavesAt": "17:28",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9162",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "08:45",
				"arrivesAt": "08:54",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Bănila Câlnic h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Ezeriş h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:11",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Ezeriş h.",
				"to": "Brebu",
				"leavesAt": "09:12",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Brebu",
				"to": "Valeadeni h.",
				"leavesAt": "09:25",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Valeadeni h.",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:38",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Caransebeş",
				"leavesAt": "09:39",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 10400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2087",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "14:25",
				"arrivesAt": "14:29",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "14:30",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "14:34",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "14:39",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "14:47",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 288
			},
			{
				"from": "18991230",
				"to": "20180101",
				"daysOfWeek": 288
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4320",
		"segments": [
			{
				"from": "Apa Hm.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "00:35",
				"arrivesAt": "00:44",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Odoreu h.",
				"leavesAt": "00:45",
				"arrivesAt": "00:55",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Odoreu h.",
				"to": "Botiz Hm.",
				"leavesAt": "00:56",
				"arrivesAt": "01:02",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Botiz Hm.",
				"to": "Satu Mare",
				"leavesAt": "01:03",
				"arrivesAt": "01:10",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20180104",
				"to": "20180409",
				"daysOfWeek": 382
			},
			{
				"from": "20180411",
				"to": "20180528",
				"daysOfWeek": 382
			},
			{
				"from": "20180530",
				"to": "20181130",
				"daysOfWeek": 382
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 382
			},
			{
				"from": "20171210",
				"to": "20171225",
				"daysOfWeek": 382
			},
			{
				"from": "20171228",
				"to": "20180101",
				"daysOfWeek": 382
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8583",
		"segments": [
			{
				"from": "Slobozia Veche",
				"to": "Slobozia Sud Hm.",
				"leavesAt": "14:13",
				"arrivesAt": "14:23",
				"waitsAtSource": 0,
				"distance": 4200
			},
			{
				"from": "Slobozia Sud Hm.",
				"to": "Brâncoveni h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Brâncoveni h.",
				"to": "Ciulniţa",
				"leavesAt": "14:33",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2591",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:08",
				"waitsAtSource": 300,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:17",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "09:18",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 2000
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9361",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "06:52",
				"arrivesAt": "06:57",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "06:58",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "07:12",
				"arrivesAt": "07:21",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:43",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "07:44",
				"arrivesAt": "07:50",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4145",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:48",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "16:07",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "16:19",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:42",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "16:43",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Deda",
				"to": "Morăreni h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 720,
				"distance": 4200
			},
			{
				"from": "Morăreni h.",
				"to": "Râpa de Jos Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râpa de Jos Hm.",
				"to": "Monor Gledin",
				"leavesAt": "17:30",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Monor Gledin",
				"to": "Şieuţ h.",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Şieuţ h.",
				"to": "Şieu Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "17:56",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Şieu Hm.",
				"to": "Bârla pe Şieu h.",
				"leavesAt": "17:57",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Bârla pe Şieu h.",
				"to": "Mărişelu Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Domneşti pe Şieu h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Domneşti pe Şieu h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:50",
				"waitsAtSource": 1200,
				"distance": 9800
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "18:51",
				"arrivesAt": "18:54",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5637",
		"segments": [
			{
				"from": "Dărmăneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "19:57",
				"arrivesAt": "20:08",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Ţibeni h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ţibeni h.",
				"to": "Dorneşti",
				"leavesAt": "20:18",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5568",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "20:14",
				"arrivesAt": "20:19",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "20:20",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "20:30",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Bursuceni h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:57",
				"waitsAtSource": 600,
				"distance": 8100
			},
			{
				"from": "Bursuceni h.",
				"to": "Bucecea Hm",
				"leavesAt": "20:58",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 11000
			},
			{
				"from": "Bucecea Hm",
				"to": "Leorda Hm.",
				"leavesAt": "21:16",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Leorda Hm.",
				"to": "Botoşani",
				"leavesAt": "21:36",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 15500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2381",
		"segments": [
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "07:17",
				"arrivesAt": "07:22",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "07:23",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "07:33",
				"arrivesAt": "07:42",
				"waitsAtSource": 120,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "08:03",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "08:12",
				"arrivesAt": "08:19",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "08:20",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "08:35",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "08:53",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "09:05",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 7400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1660",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "06:00",
				"arrivesAt": "06:06",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "06:30",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "06:53",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "07:12",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "07:27",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tutova",
				"leavesAt": "08:01",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Tutova",
				"to": "Tecuci",
				"leavesAt": "08:18",
				"arrivesAt": "08:52",
				"waitsAtSource": 240,
				"distance": 35300
			},
			{
				"from": "Tecuci",
				"to": "Focşani",
				"leavesAt": "09:07",
				"arrivesAt": "09:50",
				"waitsAtSource": 900,
				"distance": 36500
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "09:52",
				"arrivesAt": "10:29",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "10:31",
				"arrivesAt": "11:02",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "11:04",
				"arrivesAt": "11:36",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "11:37",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "12:14",
				"arrivesAt": "13:07",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8084",
		"segments": [
			{
				"from": "Bucureşti Obor",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "20:22",
				"arrivesAt": "20:33",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Pantelimon",
				"leavesAt": "20:34",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 600
			},
			{
				"from": "Pantelimon",
				"to": "Bucureşti Băneasa",
				"leavesAt": "20:56",
				"arrivesAt": "21:06",
				"waitsAtSource": 900,
				"distance": 9500
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Bucureşti Nord",
				"leavesAt": "21:07",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 6600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1765",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Târgu Frumos",
				"leavesAt": "15:20",
				"arrivesAt": "15:55",
				"waitsAtSource": 0,
				"distance": 44900
			},
			{
				"from": "Târgu Frumos",
				"to": "Paşcani",
				"leavesAt": "15:56",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 30800
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "16:24",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "16:45",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "17:02",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Gura Humorului Oraş",
				"leavesAt": "17:29",
				"arrivesAt": "18:15",
				"waitsAtSource": 900,
				"distance": 46800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "18:18",
				"arrivesAt": "18:26",
				"waitsAtSource": 180,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Vama",
				"leavesAt": "18:27",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Vama",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "18:38",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "18:55",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Pojorâta Hm.",
				"leavesAt": "19:02",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Mestecăniş",
				"leavesAt": "19:13",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "19:35",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Vatra Dornei",
				"leavesAt": "19:45",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "20:03",
				"arrivesAt": "20:06",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Lunca Ilvei",
				"leavesAt": "20:08",
				"arrivesAt": "20:59",
				"waitsAtSource": 120,
				"distance": 42800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mică",
				"leavesAt": "21:18",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 17300
			},
			{
				"from": "Ilva Mică",
				"to": "Năsăud",
				"leavesAt": "21:43",
				"arrivesAt": "22:04",
				"waitsAtSource": 180,
				"distance": 19800
			},
			{
				"from": "Năsăud",
				"to": "Salva",
				"leavesAt": "22:05",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Salva",
				"to": "Beclean pe Someş",
				"leavesAt": "22:13",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Dej Călători",
				"leavesAt": "22:37",
				"arrivesAt": "23:12",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "23:14",
				"arrivesAt": "23:33",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "23:35",
				"arrivesAt": "00:27",
				"waitsAtSource": 120,
				"distance": 44900
			},
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "00:44",
				"arrivesAt": "01:51",
				"waitsAtSource": 1020,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "01:52",
				"arrivesAt": "02:07",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Unirea hc.",
				"leavesAt": "02:08",
				"arrivesAt": "02:12",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Unirea hc.",
				"to": "Aiud Hm.",
				"leavesAt": "02:13",
				"arrivesAt": "02:28",
				"waitsAtSource": 30,
				"distance": 16800
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "02:29",
				"arrivesAt": "02:43",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Alba Iulia",
				"leavesAt": "02:47",
				"arrivesAt": "03:22",
				"waitsAtSource": 240,
				"distance": 19100
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "03:23",
				"arrivesAt": "03:35",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Şibot",
				"leavesAt": "03:36",
				"arrivesAt": "03:58",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Şibot",
				"to": "Orăştie",
				"leavesAt": "03:59",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Orăştie",
				"to": "Simeria",
				"leavesAt": "04:19",
				"arrivesAt": "04:43",
				"waitsAtSource": 300,
				"distance": 16500
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "04:51",
				"arrivesAt": "05:02",
				"waitsAtSource": 480,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "05:05",
				"arrivesAt": "05:34",
				"waitsAtSource": 180,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Săvârşin",
				"leavesAt": "05:37",
				"arrivesAt": "06:24",
				"waitsAtSource": 180,
				"distance": 40400
			},
			{
				"from": "Săvârşin",
				"to": "Radna",
				"leavesAt": "06:26",
				"arrivesAt": "07:27",
				"waitsAtSource": 120,
				"distance": 49700
			},
			{
				"from": "Radna",
				"to": "Arad",
				"leavesAt": "07:29",
				"arrivesAt": "08:12",
				"waitsAtSource": 120,
				"distance": 34500
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "08:32",
				"arrivesAt": "08:40",
				"waitsAtSource": 1200,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Timişoara Nord",
				"leavesAt": "08:45",
				"arrivesAt": "09:29",
				"waitsAtSource": 300,
				"distance": 51000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5610",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "15:06",
				"arrivesAt": "15:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "15:13",
				"arrivesAt": "15:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "15:21",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "15:29",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "15:36",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "15:49",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "16:17",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:45",
				"waitsAtSource": 480,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "16:46",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "17:00",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "17:09",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "17:27",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "17:34",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "17:42",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1661",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "05:48",
				"arrivesAt": "06:33",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Buzău",
				"leavesAt": "06:34",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 68600
			},
			{
				"from": "Buzău",
				"to": "Focşani",
				"leavesAt": "07:44",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 70800
			},
			{
				"from": "Focşani",
				"to": "Tecuci",
				"leavesAt": "08:52",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 36500
			},
			{
				"from": "Tecuci",
				"to": "Bârlad",
				"leavesAt": "09:46",
				"arrivesAt": "10:29",
				"waitsAtSource": 720,
				"distance": 50300
			},
			{
				"from": "Bârlad",
				"to": "Vaslui",
				"leavesAt": "10:30",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 52100
			},
			{
				"from": "Vaslui",
				"to": "Bârnova Hm.",
				"leavesAt": "11:09",
				"arrivesAt": "11:50",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Iaşi",
				"leavesAt": "11:51",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 18500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1892",
		"segments": [
			{
				"from": "Craiova",
				"to": "Balş",
				"leavesAt": "07:25",
				"arrivesAt": "07:55",
				"waitsAtSource": 0,
				"distance": 31200
			},
			{
				"from": "Balş",
				"to": "Piatra Olt",
				"leavesAt": "07:56",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Piatra Olt",
				"to": "Slatina",
				"leavesAt": "08:09",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Slatina",
				"to": "Stolnici Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "09:12",
				"waitsAtSource": 120,
				"distance": 43300
			},
			{
				"from": "Stolnici Hm.",
				"to": "Costeşti",
				"leavesAt": "09:13",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Costeşti",
				"to": "Piteşti",
				"leavesAt": "09:28",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "10:00",
				"arrivesAt": "10:11",
				"waitsAtSource": 540,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "10:12",
				"arrivesAt": "10:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "10:36",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "11:03",
				"arrivesAt": "11:42",
				"waitsAtSource": 480,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5703",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Vest",
				"leavesAt": "16:00",
				"arrivesAt": "16:08",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Suceava Vest",
				"to": "Stroieşti",
				"leavesAt": "16:12",
				"arrivesAt": "16:21",
				"waitsAtSource": 240,
				"distance": 9400
			},
			{
				"from": "Stroieşti",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "16:22",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:41",
				"waitsAtSource": 300,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Gura Humorului Hm.",
				"leavesAt": "16:50",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Gura Humorului Oraş",
				"leavesAt": "17:02",
				"arrivesAt": "17:08",
				"waitsAtSource": 120,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "17:10",
				"arrivesAt": "17:19",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Molid Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:28",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Molid Hm.",
				"to": "Vama",
				"leavesAt": "17:29",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vama",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "17:35",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "17:55",
				"arrivesAt": "18:02",
				"waitsAtSource": 120,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Sadova Hm.",
				"leavesAt": "18:04",
				"arrivesAt": "18:09",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Sadova Hm.",
				"to": "Pojorâta Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Valea Putnei P.M.",
				"leavesAt": "18:17",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Mestecăniş",
				"leavesAt": "18:30",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "18:41",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Argestru Hm.",
				"leavesAt": "18:51",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Argestru Hm.",
				"to": "Vatra Dornei",
				"leavesAt": "19:00",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Vatra Dornei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "19:17",
				"arrivesAt": "19:20",
				"waitsAtSource": 600,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Roşu Hm.",
				"leavesAt": "19:23",
				"arrivesAt": "19:30",
				"waitsAtSource": 180,
				"distance": 4400
			},
			{
				"from": "Roşu Hm.",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Floreni",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Floreni",
				"to": "Coşna Hm.",
				"leavesAt": "19:45",
				"arrivesAt": "19:54",
				"waitsAtSource": 120,
				"distance": 5700
			},
			{
				"from": "Coşna Hm.",
				"to": "Grădiniţa",
				"leavesAt": "19:55",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Grădiniţa",
				"to": "Larion Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:24",
				"waitsAtSource": 540,
				"distance": 5300
			},
			{
				"from": "Larion Hm.",
				"to": "Silhoasa Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "20:37",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Lunca Ilvei",
				"to": "Ilva Mare Hm.",
				"leavesAt": "20:46",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "20:56",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "21:06",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "21:14",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Strâmba h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Strâmba h.",
				"to": "Ilva Mică",
				"leavesAt": "21:28",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1766",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Aradu Nou",
				"leavesAt": "13:35",
				"arrivesAt": "14:21",
				"waitsAtSource": 0,
				"distance": 51000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "14:25",
				"arrivesAt": "14:32",
				"waitsAtSource": 240,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Radna",
				"leavesAt": "14:50",
				"arrivesAt": "15:28",
				"waitsAtSource": 1080,
				"distance": 34500
			},
			{
				"from": "Radna",
				"to": "Săvârşin",
				"leavesAt": "15:30",
				"arrivesAt": "16:26",
				"waitsAtSource": 120,
				"distance": 49700
			},
			{
				"from": "Săvârşin",
				"to": "Ilia",
				"leavesAt": "16:27",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "17:15",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "17:44",
				"arrivesAt": "17:56",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Orăştie",
				"leavesAt": "18:11",
				"arrivesAt": "18:33",
				"waitsAtSource": 900,
				"distance": 16500
			},
			{
				"from": "Orăştie",
				"to": "Şibot",
				"leavesAt": "18:34",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Şibot",
				"to": "Vinţu de Jos",
				"leavesAt": "18:51",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "19:15",
				"arrivesAt": "19:27",
				"waitsAtSource": 120,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Coşlariu",
				"leavesAt": "19:30",
				"arrivesAt": "19:58",
				"waitsAtSource": 180,
				"distance": 15600
			},
			{
				"from": "Coşlariu",
				"to": "Teiuş",
				"leavesAt": "20:04",
				"arrivesAt": "20:12",
				"waitsAtSource": 360,
				"distance": 3500
			},
			{
				"from": "Teiuş",
				"to": "Aiud Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:28",
				"waitsAtSource": 240,
				"distance": 13100
			},
			{
				"from": "Aiud Hm.",
				"to": "Unirea hc.",
				"leavesAt": "20:29",
				"arrivesAt": "20:44",
				"waitsAtSource": 60,
				"distance": 16800
			},
			{
				"from": "Unirea hc.",
				"to": "Războieni",
				"leavesAt": "20:45",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Războieni",
				"to": "Câmpia Turzii",
				"leavesAt": "20:54",
				"arrivesAt": "21:10",
				"waitsAtSource": 120,
				"distance": 17100
			},
			{
				"from": "Câmpia Turzii",
				"to": "Cluj Napoca",
				"leavesAt": "21:11",
				"arrivesAt": "22:17",
				"waitsAtSource": 60,
				"distance": 51500
			},
			{
				"from": "Cluj Napoca",
				"to": "Apahida",
				"leavesAt": "22:30",
				"arrivesAt": "22:47",
				"waitsAtSource": 780,
				"distance": 12300
			},
			{
				"from": "Apahida",
				"to": "Gherla",
				"leavesAt": "22:48",
				"arrivesAt": "23:30",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Gherla",
				"to": "Dej Călători",
				"leavesAt": "23:32",
				"arrivesAt": "23:51",
				"waitsAtSource": 120,
				"distance": 13900
			},
			{
				"from": "Dej Călători",
				"to": "Beclean pe Someş",
				"leavesAt": "23:56",
				"arrivesAt": "00:30",
				"waitsAtSource": 300,
				"distance": 24600
			},
			{
				"from": "Beclean pe Someş",
				"to": "Salva",
				"leavesAt": "00:32",
				"arrivesAt": "00:54",
				"waitsAtSource": 120,
				"distance": 21600
			},
			{
				"from": "Salva",
				"to": "Năsăud",
				"leavesAt": "01:01",
				"arrivesAt": "01:10",
				"waitsAtSource": 420,
				"distance": 6300
			},
			{
				"from": "Năsăud",
				"to": "Ilva Mică",
				"leavesAt": "01:12",
				"arrivesAt": "01:34",
				"waitsAtSource": 120,
				"distance": 19800
			},
			{
				"from": "Ilva Mică",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "01:36",
				"arrivesAt": "01:58",
				"waitsAtSource": 120,
				"distance": 17300
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "01:59",
				"arrivesAt": "02:17",
				"waitsAtSource": 60,
				"distance": 14300
			},
			{
				"from": "Lunca Ilvei",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "02:18",
				"arrivesAt": "03:12",
				"waitsAtSource": 60,
				"distance": 42800
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "03:13",
				"arrivesAt": "03:16",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Iacobeni",
				"leavesAt": "03:17",
				"arrivesAt": "03:32",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "03:33",
				"arrivesAt": "03:44",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Pojorâta Hm.",
				"leavesAt": "03:45",
				"arrivesAt": "04:06",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "04:07",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Vama",
				"leavesAt": "04:25",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 11800
			},
			{
				"from": "Vama",
				"to": "Frasin",
				"leavesAt": "04:40",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 9100
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "04:52",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Suceava",
				"leavesAt": "05:01",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 46800
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "05:58",
				"arrivesAt": "06:11",
				"waitsAtSource": 780,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "06:12",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "06:31",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Târgu Frumos",
				"leavesAt": "06:50",
				"arrivesAt": "07:17",
				"waitsAtSource": 180,
				"distance": 30800
			},
			{
				"from": "Târgu Frumos",
				"to": "Iaşi",
				"leavesAt": "07:19",
				"arrivesAt": "07:54",
				"waitsAtSource": 120,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9447",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:42",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Săteni h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Săteni h.",
				"to": "Doiceşti",
				"leavesAt": "16:51",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Doiceşti",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "16:56",
				"arrivesAt": "17:00",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Trainica h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Trainica h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "17:07",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Moţăieni h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Moţăieni h.",
				"to": "Fieni",
				"leavesAt": "17:16",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Pietroşiţa Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9663",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "07:49",
				"arrivesAt": "07:59",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişeni Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "08:09",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "08:17",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "08:24",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Deta Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Deta Hm.",
				"to": "Denta h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Denta h.",
				"to": "Stamora Moraviţa",
				"leavesAt": "08:53",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 8400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5103",
		"segments": [
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "05:35",
				"arrivesAt": "05:45",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "05:58",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:29",
				"waitsAtSource": 600,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "06:38",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "06:47",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "06:56",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:21",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "07:22",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4453",
		"segments": [
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "23:35",
				"arrivesAt": "23:52",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "23:53",
				"arrivesAt": "00:00",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "00:01",
				"arrivesAt": "00:06",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "00:07",
				"arrivesAt": "00:15",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2702",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "04:10",
				"arrivesAt": "04:17",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:20",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Băcia h.",
				"to": "Băcia Hm.",
				"leavesAt": "04:21",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Băcia Hm.",
				"to": "Batiz h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:26",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Batiz h.",
				"to": "Călan Băi",
				"leavesAt": "04:27",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "04:30",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Ruşi h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ruşi h.",
				"to": "Măceu h.",
				"leavesAt": "04:39",
				"arrivesAt": "04:41",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Măceu h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "04:42",
				"arrivesAt": "04:47",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Plopi h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Plopi h.",
				"to": "Covragiu h.",
				"leavesAt": "04:51",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Covragiu h.",
				"to": "Subcetate",
				"leavesAt": "04:54",
				"arrivesAt": "04:58",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Subcetate",
				"to": "Ciopea h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:12",
				"waitsAtSource": 540,
				"distance": 3800
			},
			{
				"from": "Ciopea h.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Băeşti Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ruşor h.",
				"leavesAt": "05:21",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ruşor h.",
				"to": "Pui",
				"leavesAt": "05:25",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Pui",
				"to": "Ponor h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Ponor h.",
				"to": "Livadia h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Livadia h.",
				"to": "Baru Mare",
				"leavesAt": "05:39",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Baru Mare",
				"to": "Baru Mare h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Baru Mare h.",
				"to": "Crivadia Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Crivadia Hm.",
				"to": "Merişor Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Merişor Hm.",
				"to": "Băniţa",
				"leavesAt": "06:11",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băniţa",
				"to": "Peştera Bolii h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Dep Petroşani h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:38",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani",
				"leavesAt": "06:39",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180331",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180527",
				"daysOfWeek": 383
			},
			{
				"from": "20180602",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181201",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20180114",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9384",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(900)",
				"leavesAt": "14:30",
				"arrivesAt": "14:33",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(900)",
				"to": "Banu Mărăcine Hm.",
				"leavesAt": "14:34",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Banu Mărăcine Hm.",
				"to": "Viaductu Cârcea h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Viaductu Cârcea h.",
				"to": "Malu Mare Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:48",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Malu Mare Hm.",
				"to": "Pasaju Coşoveni hc.",
				"leavesAt": "14:49",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Pasaju Coşoveni hc.",
				"to": "Leu Hm.",
				"leavesAt": "14:54",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Leu Hm.",
				"to": "Ţărţăl h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ţărţăl h.",
				"to": "Jianca",
				"leavesAt": "15:09",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jianca",
				"to": "Radomiru hc.",
				"leavesAt": "15:14",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Radomiru hc.",
				"to": "Grozăveşti Hm.",
				"leavesAt": "15:18",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Grozăveşti Hm.",
				"to": "Cezieni h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Cezieni h.",
				"to": "Caracal",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1751",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Brazi",
				"leavesAt": "11:15",
				"arrivesAt": "11:51",
				"waitsAtSource": 0,
				"distance": 51400
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "11:55",
				"arrivesAt": "12:09",
				"waitsAtSource": 240,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "12:11",
				"arrivesAt": "12:44",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "12:45",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "13:22",
				"arrivesAt": "13:53",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "13:54",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "14:34",
				"arrivesAt": "14:56",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "14:57",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "15:25",
				"arrivesAt": "16:02",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "16:11",
				"arrivesAt": "16:40",
				"waitsAtSource": 540,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "16:41",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "17:12",
				"arrivesAt": "17:32",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "17:33",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "17:58",
				"arrivesAt": "18:10",
				"waitsAtSource": 540,
				"distance": 14800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9363",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "08:22",
				"arrivesAt": "08:36",
				"waitsAtSource": 120,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:08",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "09:09",
				"arrivesAt": "09:15",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1732",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "06:45",
				"arrivesAt": "07:04",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "07:05",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "07:24",
				"arrivesAt": "07:54",
				"waitsAtSource": 120,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Făurei",
				"leavesAt": "07:55",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Făurei",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:27",
				"waitsAtSource": 180,
				"distance": 10000
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Buzău",
				"leavesAt": "08:31",
				"arrivesAt": "09:01",
				"waitsAtSource": 240,
				"distance": 30400
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "09:04",
				"arrivesAt": "09:36",
				"waitsAtSource": 180,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "09:38",
				"arrivesAt": "10:14",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "10:17",
				"arrivesAt": "10:22",
				"waitsAtSource": 180,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "10:24",
				"arrivesAt": "10:49",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "10:51",
				"arrivesAt": "11:15",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "11:17",
				"arrivesAt": "11:24",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "11:25",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "11:31",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "11:42",
				"arrivesAt": "12:20",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1531",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Huedin",
				"leavesAt": "05:45",
				"arrivesAt": "06:35",
				"waitsAtSource": 0,
				"distance": 49400
			},
			{
				"from": "Huedin",
				"to": "Ciucea Hm.",
				"leavesAt": "06:36",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Ciucea Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "07:05",
				"arrivesAt": "07:15",
				"waitsAtSource": 420,
				"distance": 10800
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bratca",
				"leavesAt": "07:17",
				"arrivesAt": "07:28",
				"waitsAtSource": 120,
				"distance": 9900
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Aleşd",
				"leavesAt": "07:38",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Aleşd",
				"to": "Oradea",
				"leavesAt": "07:58",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 34300
			},
			{
				"from": "Oradea",
				"to": "Salonta",
				"leavesAt": "08:30",
				"arrivesAt": "09:10",
				"waitsAtSource": 120,
				"distance": 39200
			},
			{
				"from": "Salonta",
				"to": "Chişineu Criş",
				"leavesAt": "09:16",
				"arrivesAt": "09:54",
				"waitsAtSource": 360,
				"distance": 33900
			},
			{
				"from": "Chişineu Criş",
				"to": "Nădab",
				"leavesAt": "09:56",
				"arrivesAt": "10:02",
				"waitsAtSource": 120,
				"distance": 4900
			},
			{
				"from": "Nădab",
				"to": "Sântana",
				"leavesAt": "10:03",
				"arrivesAt": "10:20",
				"waitsAtSource": 60,
				"distance": 19100
			},
			{
				"from": "Sântana",
				"to": "Arad",
				"leavesAt": "10:22",
				"arrivesAt": "10:47",
				"waitsAtSource": 120,
				"distance": 23500
			},
			{
				"from": "Arad",
				"to": "Timişoara Nord",
				"leavesAt": "10:50",
				"arrivesAt": "11:38",
				"waitsAtSource": 180,
				"distance": 57200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1923",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Tălmaciu Hm.",
				"leavesAt": "18:35",
				"arrivesAt": "19:00",
				"waitsAtSource": 0,
				"distance": 17800
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "19:02",
				"arrivesAt": "19:09",
				"waitsAtSource": 120,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "19:10",
				"arrivesAt": "19:16",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "19:18",
				"arrivesAt": "19:28",
				"waitsAtSource": 120,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Câineni",
				"leavesAt": "19:37",
				"arrivesAt": "20:00",
				"waitsAtSource": 540,
				"distance": 15200
			},
			{
				"from": "Câineni",
				"to": "Lotru",
				"leavesAt": "20:01",
				"arrivesAt": "20:25",
				"waitsAtSource": 60,
				"distance": 21100
			},
			{
				"from": "Lotru",
				"to": "Păuşa h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 11500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "20:42",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "20:48",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 16200
			},
			{
				"from": "Râmnicu Vâlcea",
				"to": "Govora",
				"leavesAt": "21:10",
				"arrivesAt": "21:20",
				"waitsAtSource": 240,
				"distance": 11400
			},
			{
				"from": "Govora",
				"to": "Băbeni",
				"leavesAt": "21:21",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Băbeni",
				"to": "Zăvideni Hm.",
				"leavesAt": "21:31",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 23000
			},
			{
				"from": "Zăvideni Hm.",
				"to": "Drăgăşani",
				"leavesAt": "21:56",
				"arrivesAt": "22:04",
				"waitsAtSource": 480,
				"distance": 10200
			},
			{
				"from": "Drăgăşani",
				"to": "Piatra Olt",
				"leavesAt": "22:06",
				"arrivesAt": "22:35",
				"waitsAtSource": 120,
				"distance": 33800
			},
			{
				"from": "Piatra Olt",
				"to": "Slatina",
				"leavesAt": "22:55",
				"arrivesAt": "23:14",
				"waitsAtSource": 1200,
				"distance": 17000
			},
			{
				"from": "Slatina",
				"to": "Stolnici Hm.",
				"leavesAt": "23:17",
				"arrivesAt": "23:57",
				"waitsAtSource": 180,
				"distance": 43300
			},
			{
				"from": "Stolnici Hm.",
				"to": "Costeşti",
				"leavesAt": "23:58",
				"arrivesAt": "00:13",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Costeşti",
				"to": "Piteşti",
				"leavesAt": "00:19",
				"arrivesAt": "00:45",
				"waitsAtSource": 360,
				"distance": 21800
			},
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "01:10",
				"arrivesAt": "01:21",
				"waitsAtSource": 1500,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "01:22",
				"arrivesAt": "01:43",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "01:45",
				"arrivesAt": "02:04",
				"waitsAtSource": 120,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "02:06",
				"arrivesAt": "02:46",
				"waitsAtSource": 120,
				"distance": 48000
			},
			{
				"from": "Bucureşti Nord",
				"to": "Feteşti",
				"leavesAt": "03:15",
				"arrivesAt": "04:46",
				"waitsAtSource": 1740,
				"distance": 146400
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "04:47",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "05:08",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "05:26",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "06:15",
				"arrivesAt": "06:26",
				"waitsAtSource": 960,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "06:35",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:04",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "07:05",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "07:21",
				"arrivesAt": "07:25",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Pescăruş h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Pescăruş h.",
				"to": "Neptun hc.",
				"leavesAt": "07:34",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "07:49",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1581",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Constanţa",
				"leavesAt": "07:30",
				"arrivesAt": "09:30",
				"waitsAtSource": 0,
				"distance": 225000
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1888",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Nucet",
				"leavesAt": "17:32",
				"arrivesAt": "17:44",
				"waitsAtSource": 0,
				"distance": 16300
			},
			{
				"from": "Nucet",
				"to": "Titu",
				"leavesAt": "17:45",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 15400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9612",
		"segments": [
			{
				"from": "Buziaş",
				"to": "Bacova h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:03",
				"waitsAtSource": 0,
				"distance": 2300
			},
			{
				"from": "Bacova h.",
				"to": "Chevereş h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Chevereş h.",
				"to": "Sacoşu Mic",
				"leavesAt": "06:10",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Sacoşu Mic",
				"to": "Uliuc h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Uliuc h.",
				"to": "Urseni h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:28",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Urseni h.",
				"to": "Semenic Hm.",
				"leavesAt": "06:29",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Semenic Hm.",
				"to": "Giroc h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 600,
				"distance": 2100
			},
			{
				"from": "Giroc h.",
				"to": "Timişoara Sud",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "06:54",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180107",
				"daysOfWeek": 799
			},
			{
				"from": "20180113",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180407",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2185",
		"segments": [
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "14:59",
				"arrivesAt": "15:12",
				"waitsAtSource": 0,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "15:13",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Mintia h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:25",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mintia h.",
				"to": "Veţel h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:28",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "15:41",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Dobra Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dobra Hm.",
				"to": "Lăpugiu h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Lăpugiu h.",
				"to": "Ohaba hc.",
				"leavesAt": "16:05",
				"arrivesAt": "16:11",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ohaba hc.",
				"to": "Holdea Hm.",
				"leavesAt": "16:12",
				"arrivesAt": "16:17",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Holdea Hm.",
				"to": "Coşteiu h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Coşteiu h.",
				"to": "Nemeşeşti h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Nemeşeşti h.",
				"to": "Margina",
				"leavesAt": "16:28",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Margina",
				"to": "Făget",
				"leavesAt": "16:55",
				"arrivesAt": "17:02",
				"waitsAtSource": 1020,
				"distance": 7600
			},
			{
				"from": "Făget",
				"to": "Răchita h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răchita h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Traian Vuia h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Susani Bega h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:19",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Susani Bega h.",
				"to": "Cliciova",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Cliciova",
				"to": "Nevrincea h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:42",
				"waitsAtSource": 840,
				"distance": 4400
			},
			{
				"from": "Nevrincea h.",
				"to": "Balinţ h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Balinţ h.",
				"to": "Păru h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Păru h.",
				"to": "Coşteiu Mare Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Coşteiu Mare Hm.",
				"to": "Lugoj Nord h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Lugoj Nord h.",
				"to": "Lugoj",
				"leavesAt": "18:02",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "461",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "12:45",
				"arrivesAt": "13:38",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Giurgiu Nord",
				"leavesAt": "13:39",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 63000
			},
			{
				"from": "Giurgiu Nord",
				"to": "Ruse",
				"leavesAt": "15:10",
				"arrivesAt": "15:35",
				"waitsAtSource": 1380,
				"distance": 16000
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181001",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3624",
		"segments": [
			{
				"from": "Huedin",
				"to": "Jebuc h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:08",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Jebuc h.",
				"to": "Stana Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Stana Hm.",
				"to": "Gălăşeni h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Gălăşeni h.",
				"to": "Aghireş h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "08:30",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Dorolţu h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Dorolţu h.",
				"to": "Macău h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Macău h.",
				"to": "Gârbău Hm.",
				"leavesAt": "08:41",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Gârbău Hm.",
				"to": "Nădăşel h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Nădăşel h.",
				"to": "Mera Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "08:57",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mera Hm.",
				"to": "Rădaia h.",
				"leavesAt": "08:58",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Rădaia h.",
				"to": "Suceag h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Suceag h.",
				"to": "Baciu Triaj Hm.",
				"leavesAt": "09:04",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Baciu Triaj Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 799
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2705",
		"segments": [
			{
				"from": "Petroşani",
				"to": "Dep Petroşani h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:38",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani Triaj h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:41",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Petroşani Triaj h.",
				"to": "Peştera Bolii h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Băniţa",
				"leavesAt": "07:47",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Băniţa",
				"to": "Merişor Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Merişor Hm.",
				"to": "Crivadia Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Crivadia Hm.",
				"to": "Baru Mare h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Baru Mare h.",
				"to": "Baru Mare",
				"leavesAt": "08:25",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Baru Mare",
				"to": "Livadia h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Livadia h.",
				"to": "Ponor h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ponor h.",
				"to": "Pui",
				"leavesAt": "08:39",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Pui",
				"to": "Ruşor h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:56",
				"waitsAtSource": 480,
				"distance": 4800
			},
			{
				"from": "Ruşor h.",
				"to": "Băeşti Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:00",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ohaba de sub Piatră h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ohaba de sub Piatră h.",
				"to": "Ciopea h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:07",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ciopea h.",
				"to": "Subcetate",
				"leavesAt": "09:08",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Subcetate",
				"to": "Covragiu h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Covragiu h.",
				"to": "Plopi h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Plopi h.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "09:20",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Măceu h.",
				"leavesAt": "09:23",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măceu h.",
				"to": "Ruşi h.",
				"leavesAt": "09:27",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ruşi h.",
				"to": "Călan Hm.",
				"leavesAt": "09:30",
				"arrivesAt": "09:40",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Călan Hm.",
				"to": "Călan Băi",
				"leavesAt": "09:41",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Batiz h.",
				"leavesAt": "09:46",
				"arrivesAt": "09:48",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Batiz h.",
				"to": "Băcia Hm.",
				"leavesAt": "09:49",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Băcia Hm.",
				"to": "Băcia h.",
				"leavesAt": "09:52",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Băcia h.",
				"to": "Simeria Triaj",
				"leavesAt": "09:55",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Simeria Triaj",
				"to": "Simeria",
				"leavesAt": "09:59",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Simeria",
				"to": "Săuleşti h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:24",
				"waitsAtSource": 840,
				"distance": 3300
			},
			{
				"from": "Săuleşti h.",
				"to": "Deva",
				"leavesAt": "10:25",
				"arrivesAt": "10:32",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Deva",
				"to": "Mintia",
				"leavesAt": "10:33",
				"arrivesAt": "10:42",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Mintia",
				"to": "Veţel h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:47",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Veţel h.",
				"to": "Brănişca Hm.",
				"leavesAt": "10:48",
				"arrivesAt": "10:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Brănişca Hm.",
				"to": "Bretea Mureşeană h.",
				"leavesAt": "10:53",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bretea Mureşeană h.",
				"to": "Ilia",
				"leavesAt": "11:00",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ilia",
				"to": "Gurasada Hm.",
				"leavesAt": "11:08",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Gurasada Hm.",
				"to": "Câmpuri Surduc Hm.",
				"leavesAt": "11:16",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Câmpuri Surduc Hm.",
				"to": "Burjuc h.",
				"leavesAt": "11:24",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Burjuc h.",
				"to": "Zam",
				"leavesAt": "11:30",
				"arrivesAt": "11:42",
				"waitsAtSource": 30,
				"distance": 8500
			},
			{
				"from": "Zam",
				"to": "Petriş pe Mureş h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Petriş pe Mureş h.",
				"to": "Ilteu",
				"leavesAt": "11:48",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ilteu",
				"to": "Toc h.",
				"leavesAt": "11:56",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Toc h.",
				"to": "Săvârşin",
				"leavesAt": "12:00",
				"arrivesAt": "12:07",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Săvârşin",
				"to": "Vărădia h.",
				"leavesAt": "12:08",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vărădia h.",
				"to": "Vărădia Hm.",
				"leavesAt": "12:15",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărădia Hm.",
				"to": "Valea Mureşului h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:25",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Valea Mureşului h.",
				"to": "Bătuţa Hm.",
				"leavesAt": "12:26",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Bătuţa Hm.",
				"to": "Căpruţa h.",
				"leavesAt": "12:34",
				"arrivesAt": "12:38",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Căpruţa h.",
				"to": "Bârzava",
				"leavesAt": "12:39",
				"arrivesAt": "12:44",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Bârzava",
				"to": "Conop Hm.",
				"leavesAt": "12:45",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Conop Hm.",
				"to": "Corfeni h.",
				"leavesAt": "12:57",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Corfeni h.",
				"to": "Milova",
				"leavesAt": "13:02",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Milova",
				"to": "Radna",
				"leavesAt": "13:09",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Radna",
				"to": "Păuliş Hm.",
				"leavesAt": "13:21",
				"arrivesAt": "13:29",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Păuliş Hm.",
				"to": "Păuliş h.",
				"leavesAt": "13:30",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Păuliş h.",
				"to": "Ghioroc",
				"leavesAt": "13:35",
				"arrivesAt": "13:42",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ghioroc",
				"to": "Glogovăţ",
				"leavesAt": "13:43",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Glogovăţ",
				"to": "Arad",
				"leavesAt": "13:55",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1797",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "05:30",
				"arrivesAt": "06:21",
				"waitsAtSource": 0,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "06:22",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "07:10",
				"arrivesAt": "07:57",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "07:58",
				"arrivesAt": "08:38",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Filiaşi",
				"leavesAt": "08:45",
				"arrivesAt": "09:11",
				"waitsAtSource": 420,
				"distance": 35800
			},
			{
				"from": "Filiaşi",
				"to": "Strehaia hc.",
				"leavesAt": "09:12",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 26300
			},
			{
				"from": "Strehaia hc.",
				"to": "Balota",
				"leavesAt": "09:36",
				"arrivesAt": "10:11",
				"waitsAtSource": 60,
				"distance": 32600
			},
			{
				"from": "Balota",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "10:12",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Orşova",
				"leavesAt": "10:47",
				"arrivesAt": "11:18",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Orşova",
				"to": "Băile Herculane",
				"leavesAt": "11:19",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 17500
			},
			{
				"from": "Băile Herculane",
				"to": "Caransebeş",
				"leavesAt": "11:40",
				"arrivesAt": "13:02",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "13:03",
				"arrivesAt": "13:36",
				"waitsAtSource": 60,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Timişoara Nord",
				"leavesAt": "13:37",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1634",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "14:15",
				"arrivesAt": "14:50",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "14:52",
				"arrivesAt": "15:01",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "15:02",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "15:09",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "15:19",
				"arrivesAt": "15:33",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Breaza hc.",
				"leavesAt": "15:34",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "15:42",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "15:48",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Ploieşti Vest",
				"leavesAt": "15:59",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 18600
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buftea",
				"leavesAt": "16:16",
				"arrivesAt": "16:44",
				"waitsAtSource": 180,
				"distance": 42000
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "16:45",
				"arrivesAt": "17:03",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9434",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "09:40",
				"arrivesAt": "09:47",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "09:48",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "09:54",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "09:59",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "10:08",
				"arrivesAt": "10:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "10:13",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "10:18",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4541",
		"segments": [
			{
				"from": "Deda",
				"to": "Ruşii Munţi h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:23",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "04:24",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Halta Aluniş h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:32",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "04:33",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Ideciu de Jos h.",
				"leavesAt": "04:37",
				"arrivesAt": "04:42",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Reghin",
				"leavesAt": "04:43",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Reghin",
				"to": "Petelea h.",
				"leavesAt": "04:54",
				"arrivesAt": "05:01",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Petelea h.",
				"to": "Periş Mureş h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Periş Mureş h.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "05:14",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Târgu Mureş",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4071",
		"segments": [
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:12",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "16:25",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180120",
				"to": "20180121",
				"daysOfWeek": 383
			},
			{
				"from": "20180124",
				"to": "20180124",
				"daysOfWeek": 383
			},
			{
				"from": "20180127",
				"to": "20180128",
				"daysOfWeek": 383
			},
			{
				"from": "20180203",
				"to": "20180211",
				"daysOfWeek": 383
			},
			{
				"from": "20180217",
				"to": "20180218",
				"daysOfWeek": 383
			},
			{
				"from": "20180224",
				"to": "20180225",
				"daysOfWeek": 383
			},
			{
				"from": "20180303",
				"to": "20180304",
				"daysOfWeek": 383
			},
			{
				"from": "20180310",
				"to": "20180311",
				"daysOfWeek": 383
			},
			{
				"from": "20180317",
				"to": "20180318",
				"daysOfWeek": 383
			},
			{
				"from": "20180324",
				"to": "20180325",
				"daysOfWeek": 383
			},
			{
				"from": "20180331",
				"to": "20180410",
				"daysOfWeek": 383
			},
			{
				"from": "20180414",
				"to": "20180415",
				"daysOfWeek": 383
			},
			{
				"from": "20180421",
				"to": "20180422",
				"daysOfWeek": 383
			},
			{
				"from": "20180428",
				"to": "20180429",
				"daysOfWeek": 383
			},
			{
				"from": "20180501",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180505",
				"to": "20180506",
				"daysOfWeek": 383
			},
			{
				"from": "20180512",
				"to": "20180513",
				"daysOfWeek": 383
			},
			{
				"from": "20180519",
				"to": "20180520",
				"daysOfWeek": 383
			},
			{
				"from": "20180526",
				"to": "20180528",
				"daysOfWeek": 383
			},
			{
				"from": "20180601",
				"to": "20180603",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180610",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			},
			{
				"from": "20180915",
				"to": "20180916",
				"daysOfWeek": 383
			},
			{
				"from": "20180922",
				"to": "20180923",
				"daysOfWeek": 383
			},
			{
				"from": "20180929",
				"to": "20180930",
				"daysOfWeek": 383
			},
			{
				"from": "20181006",
				"to": "20181007",
				"daysOfWeek": 383
			},
			{
				"from": "20181013",
				"to": "20181014",
				"daysOfWeek": 383
			},
			{
				"from": "20181020",
				"to": "20181021",
				"daysOfWeek": 383
			},
			{
				"from": "20181027",
				"to": "20181028",
				"daysOfWeek": 383
			},
			{
				"from": "20181103",
				"to": "20181104",
				"daysOfWeek": 383
			},
			{
				"from": "20181110",
				"to": "20181111",
				"daysOfWeek": 383
			},
			{
				"from": "20181117",
				"to": "20181118",
				"daysOfWeek": 383
			},
			{
				"from": "20181124",
				"to": "20181125",
				"daysOfWeek": 383
			},
			{
				"from": "20181130",
				"to": "20181202",
				"daysOfWeek": 383
			},
			{
				"from": "20181208",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171210",
				"daysOfWeek": 383
			},
			{
				"from": "20171216",
				"to": "20171217",
				"daysOfWeek": 383
			},
			{
				"from": "20171223",
				"to": "20180114",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2613",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Sânandrei Hm.",
				"leavesAt": "23:26",
				"arrivesAt": "23:42",
				"waitsAtSource": 0,
				"distance": 13300
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "23:43",
				"arrivesAt": "23:49",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "23:50",
				"arrivesAt": "23:55",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "23:56",
				"arrivesAt": "00:01",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "00:07",
				"arrivesAt": "00:13",
				"waitsAtSource": 360,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Aradu Nou",
				"leavesAt": "00:14",
				"arrivesAt": "00:28",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "00:29",
				"arrivesAt": "00:36",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8377",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "19:36",
				"arrivesAt": "19:47",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "19:48",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "19:56",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "20:14",
				"arrivesAt": "20:21",
				"waitsAtSource": 540,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:32",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "20:33",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:51",
				"arrivesAt": "20:55",
				"waitsAtSource": 600,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "20:57",
				"arrivesAt": "21:10",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "21:12",
				"arrivesAt": "21:22",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180529",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5057",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "16:00",
				"arrivesAt": "16:05",
				"waitsAtSource": 0,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "16:06",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "16:16",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "16:26",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "16:32",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "16:38",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "17:05",
				"arrivesAt": "17:12",
				"waitsAtSource": 540,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "17:13",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "17:19",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "17:25",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1583",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "09:30",
				"arrivesAt": "10:25",
				"waitsAtSource": 0,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "10:26",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "10:50",
				"arrivesAt": "11:10",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "11:11",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "11:28",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180608",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9433",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Depoul Buc.Triaj h.(300)",
				"leavesAt": "04:20",
				"arrivesAt": "04:28",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Depoul Buc.Triaj h.(300)",
				"to": "Chitila",
				"leavesAt": "04:29",
				"arrivesAt": "04:32",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "04:33",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "04:43",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "04:56",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "05:07",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "05:30",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "05:39",
				"arrivesAt": "05:43",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Podu Rizii h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Podu Rizii h.",
				"to": "Băneşti h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "05:59",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:07",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "06:14",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5071",
		"segments": [
			{
				"from": "Brazi",
				"to": "Ploieşti Triaj",
				"leavesAt": "07:28",
				"arrivesAt": "07:35",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Ploieşti Sud",
				"leavesAt": "07:39",
				"arrivesAt": "07:46",
				"waitsAtSource": 240,
				"distance": 3600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "07:56",
				"arrivesAt": "08:02",
				"waitsAtSource": 600,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "08:03",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "08:18",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "08:30",
				"arrivesAt": "08:35",
				"waitsAtSource": 480,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "08:36",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "08:43",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "08:52",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "09:04",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "09:12",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "09:24",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9482",
		"segments": [
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:56",
				"waitsAtSource": 0,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "13:57",
				"arrivesAt": "14:03",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "14:04",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "14:13",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "14:22",
				"arrivesAt": "14:32",
				"waitsAtSource": 120,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "14:33",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "14:43",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 256
			},
			{
				"from": "18991230",
				"to": "20180803",
				"daysOfWeek": 256
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4141",
		"segments": [
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "02:24",
				"arrivesAt": "02:32",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Târgu Mureş Nord Hm.",
				"to": "Dumbrăvioara Hm.",
				"leavesAt": "02:33",
				"arrivesAt": "02:45",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Dumbrăvioara Hm.",
				"to": "Gorneşti Mureş h.",
				"leavesAt": "02:46",
				"arrivesAt": "02:50",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gorneşti Mureş h.",
				"to": "Periş Mureş h.",
				"leavesAt": "02:51",
				"arrivesAt": "02:56",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Periş Mureş h.",
				"to": "Petelea h.",
				"leavesAt": "02:57",
				"arrivesAt": "03:02",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Petelea h.",
				"to": "Reghin",
				"leavesAt": "03:03",
				"arrivesAt": "03:13",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Reghin",
				"to": "Ideciu de Jos h.",
				"leavesAt": "03:14",
				"arrivesAt": "03:20",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ideciu de Jos h.",
				"to": "Brâncoveneşti h.",
				"leavesAt": "03:21",
				"arrivesAt": "03:26",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Brâncoveneşti h.",
				"to": "Halta Aluniş h.",
				"leavesAt": "03:27",
				"arrivesAt": "03:31",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Halta Aluniş h.",
				"to": "Aluniş Mureş Hm.",
				"leavesAt": "03:32",
				"arrivesAt": "03:37",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Aluniş Mureş Hm.",
				"to": "Ruşii Munţi h.",
				"leavesAt": "03:38",
				"arrivesAt": "03:41",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ruşii Munţi h.",
				"to": "Deda",
				"leavesAt": "03:42",
				"arrivesAt": "03:48",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Deda",
				"to": "Morăreni h.",
				"leavesAt": "04:27",
				"arrivesAt": "04:34",
				"waitsAtSource": 2340,
				"distance": 4200
			},
			{
				"from": "Morăreni h.",
				"to": "Râpa de Jos Hm.",
				"leavesAt": "04:35",
				"arrivesAt": "04:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râpa de Jos Hm.",
				"to": "Monor Gledin",
				"leavesAt": "04:42",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Monor Gledin",
				"to": "Şieuţ h.",
				"leavesAt": "04:54",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Şieuţ h.",
				"to": "Şieu Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Şieu Hm.",
				"to": "Bârla pe Şieu h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:23",
				"waitsAtSource": 360,
				"distance": 5000
			},
			{
				"from": "Bârla pe Şieu h.",
				"to": "Mărişelu Hm.",
				"leavesAt": "05:24",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Mărişelu Hm.",
				"to": "Domneşti pe Şieu h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Domneşti pe Şieu h.",
				"to": "Sărăţel Hm.",
				"leavesAt": "05:35",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Sărăţel Hm.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:13",
				"waitsAtSource": 1080,
				"distance": 9800
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4317",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "05:12",
				"arrivesAt": "05:19",
				"waitsAtSource": 0,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:38",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:56",
				"waitsAtSource": 600,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1884",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Nucet",
				"leavesAt": "10:22",
				"arrivesAt": "10:34",
				"waitsAtSource": 0,
				"distance": 16300
			},
			{
				"from": "Nucet",
				"to": "Titu",
				"leavesAt": "10:35",
				"arrivesAt": "10:48",
				"waitsAtSource": 60,
				"distance": 15400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1989",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "17:00",
				"arrivesAt": "17:55",
				"waitsAtSource": 0,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "17:56",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "18:20",
				"arrivesAt": "18:38",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "18:39",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "18:56",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 34600
			},
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "19:39",
				"arrivesAt": "19:55",
				"waitsAtSource": 1140,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "19:56",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "20:14",
				"arrivesAt": "20:21",
				"waitsAtSource": 540,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:32",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "20:33",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:51",
				"arrivesAt": "20:55",
				"waitsAtSource": 600,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "20:57",
				"arrivesAt": "21:10",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "21:12",
				"arrivesAt": "21:22",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5073",
		"segments": [
			{
				"from": "Brazi",
				"to": "Ploieşti Triaj",
				"leavesAt": "19:47",
				"arrivesAt": "19:55",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Ploieşti Sud",
				"leavesAt": "19:56",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "20:17",
				"arrivesAt": "20:23",
				"waitsAtSource": 840,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "20:24",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Muru hc.",
				"leavesAt": "20:34",
				"arrivesAt": "20:38",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "20:39",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Inoteşti Hm.",
				"leavesAt": "20:49",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Mizil",
				"leavesAt": "20:55",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Clondiru hc.",
				"leavesAt": "21:14",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Clondiru hc.",
				"to": "Ulmeni",
				"leavesAt": "21:23",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Ulmeni",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "21:29",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Buzău",
				"leavesAt": "21:35",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9304",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Atârnaţi Hm.",
				"leavesAt": "04:10",
				"arrivesAt": "04:17",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "04:18",
				"arrivesAt": "04:26",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Vârtoapele hc.",
				"leavesAt": "04:27",
				"arrivesAt": "04:32",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Olteni",
				"leavesAt": "04:33",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Olteni",
				"to": "Gălăteni Hm.",
				"leavesAt": "04:43",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Ciolpani Hm.",
				"leavesAt": "04:53",
				"arrivesAt": "04:59",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Videle",
				"leavesAt": "05:00",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Videle",
				"to": "Zăvestreni Hm.",
				"leavesAt": "05:21",
				"arrivesAt": "05:26",
				"waitsAtSource": 780,
				"distance": 4800
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:39",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Zorile h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zorile h.",
				"to": "Grădinari",
				"leavesAt": "05:45",
				"arrivesAt": "05:54",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:02",
				"waitsAtSource": 240,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "06:03",
				"arrivesAt": "06:16",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "06:17",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Carpaţi h.(900)",
				"leavesAt": "06:21",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "06:28",
				"arrivesAt": "06:32",
				"waitsAtSource": 30,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9165",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Valea Păltinişului h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Brebu",
				"leavesAt": "09:07",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "09:30",
				"arrivesAt": "09:38",
				"waitsAtSource": 600,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:45",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "09:46",
				"arrivesAt": "09:57",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "09:58",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20180610",
				"to": "20180910",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5106",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "10:15",
				"arrivesAt": "10:28",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "10:29",
				"arrivesAt": "10:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Zagna Vădeni h.",
				"leavesAt": "10:37",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Vădeni Hm.",
				"leavesAt": "10:42",
				"arrivesAt": "10:46",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "10:47",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "10:53",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Lacu Sărat",
				"leavesAt": "11:02",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Lacu Sărat",
				"to": "Traian Sat Hm.",
				"leavesAt": "11:11",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Urleasca Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:28",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Urleasca Hm.",
				"to": "Plopu",
				"leavesAt": "11:29",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Plopu",
				"to": "Ianca hc.",
				"leavesAt": "11:37",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ianca hc.",
				"to": "Deduleşti Hm.",
				"leavesAt": "11:41",
				"arrivesAt": "11:49",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Găiseanca h.",
				"leavesAt": "11:50",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Găiseanca h.",
				"to": "Făurei",
				"leavesAt": "11:56",
				"arrivesAt": "12:01",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Făurei",
				"to": "CTF Făurei h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:26",
				"waitsAtSource": 1200,
				"distance": 4100
			},
			{
				"from": "CTF Făurei h.",
				"to": "Vizireni h.",
				"leavesAt": "12:27",
				"arrivesAt": "12:31",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "12:32",
				"arrivesAt": "12:37",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:45",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "12:46",
				"arrivesAt": "12:51",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:56",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "12:57",
				"arrivesAt": "13:01",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "13:02",
				"arrivesAt": "13:04",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău Sud",
				"leavesAt": "13:05",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Buzău Sud",
				"to": "Buzău",
				"leavesAt": "13:12",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:52",
				"waitsAtSource": 1200,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "13:53",
				"arrivesAt": "14:04",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "14:05",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:42",
				"waitsAtSource": 840,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "14:52",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "15:01",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "15:10",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:37",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "15:38",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Mărăşeşti",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "16:03",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Domneşti Târg h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Adjud",
				"leavesAt": "16:14",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 8400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1881",
		"segments": [
			{
				"from": "Titu",
				"to": "Nucet",
				"leavesAt": "08:40",
				"arrivesAt": "08:51",
				"waitsAtSource": 0,
				"distance": 15400
			},
			{
				"from": "Nucet",
				"to": "Târgovişte",
				"leavesAt": "08:52",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 16300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5705",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Vest",
				"leavesAt": "05:28",
				"arrivesAt": "05:36",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Suceava Vest",
				"to": "Stroieşti",
				"leavesAt": "05:40",
				"arrivesAt": "05:49",
				"waitsAtSource": 240,
				"distance": 9400
			},
			{
				"from": "Stroieşti",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:19",
				"waitsAtSource": 900,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Gura Humorului Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Gura Humorului Oraş",
				"leavesAt": "06:39",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Frasin",
				"leavesAt": "06:47",
				"arrivesAt": "06:56",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Frasin",
				"to": "Molid Hm.",
				"leavesAt": "06:57",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Molid Hm.",
				"to": "Vama",
				"leavesAt": "07:05",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Vama",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "07:18",
				"arrivesAt": "07:25",
				"waitsAtSource": 480,
				"distance": 4300
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "07:38",
				"arrivesAt": "07:45",
				"waitsAtSource": 120,
				"distance": 3800
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Sadova Hm.",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Sadova Hm.",
				"to": "Pojorâta Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Valea Putnei P.M.",
				"leavesAt": "08:00",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Mestecăniş",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Iacobeni",
				"leavesAt": "08:25",
				"arrivesAt": "08:34",
				"waitsAtSource": 120,
				"distance": 5900
			},
			{
				"from": "Iacobeni",
				"to": "Argestru Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Argestru Hm.",
				"to": "Vatra Dornei",
				"leavesAt": "08:44",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9508",
		"segments": [
			{
				"from": "Orşova",
				"to": "Şantier Naval h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:12",
				"waitsAtSource": 0,
				"distance": 1300
			},
			{
				"from": "Şantier Naval h.",
				"to": "Vârciorova Hm.",
				"leavesAt": "16:13",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Vârciorova Hm.",
				"to": "Jidoştiţa h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Jidoştiţa h.",
				"to": "Gura Văii Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Gura Văii Hm.",
				"to": "Dinamica h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 240,
				"distance": 6300
			},
			{
				"from": "Dinamica h.",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Drobeta Tr.Sev Est Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Drobeta Tr.Sev Est Hm.",
				"to": "Drobeta Tr. Severin Mf.",
				"leavesAt": "17:00",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Drobeta Tr. Severin Mf.",
				"to": "Ergheviţa h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ergheviţa h.",
				"to": "Valea Albă Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Albă Hm.",
				"to": "Balota",
				"leavesAt": "17:24",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Balota",
				"to": "Gârniţa Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Gârniţa Hm.",
				"to": "Prunişor Hm.",
				"leavesAt": "17:42",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Prunişor Hm.",
				"to": "Igiroasa Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Igiroasa Hm.",
				"to": "Tâmna",
				"leavesAt": "17:57",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Tâmna",
				"to": "Ciochiuţa Hm.",
				"leavesAt": "18:05",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Ciochiuţa Hm.",
				"to": "Strehaia hc.",
				"leavesAt": "18:17",
				"arrivesAt": "18:22",
				"waitsAtSource": 240,
				"distance": 5700
			},
			{
				"from": "Strehaia hc.",
				"to": "Strehaia",
				"leavesAt": "18:23",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Strehaia",
				"to": "Lunca Banului h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Lunca Banului h.",
				"to": "Butoieşti Hm.",
				"leavesAt": "18:36",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Gura Motrului Hm.",
				"leavesAt": "18:44",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Filiaşi",
				"leavesAt": "18:51",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "19:04",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "19:14",
				"arrivesAt": "19:19",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "19:24",
				"arrivesAt": "19:29",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "19:30",
				"arrivesAt": "19:32",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "19:33",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "19:38",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "19:41",
				"arrivesAt": "19:45",
				"waitsAtSource": 30,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2605",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj h",
				"leavesAt": "16:23",
				"arrivesAt": "16:28",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "16:29",
				"arrivesAt": "16:31",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "16:32",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "16:39",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:11",
				"waitsAtSource": 360,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Aradu Nou",
				"leavesAt": "17:12",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "17:27",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3113",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "05:08",
				"arrivesAt": "05:16",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Băile Călacea",
				"leavesAt": "05:24",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Băile Călacea",
				"to": "Orţişoara",
				"leavesAt": "05:31",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Orţişoara",
				"to": "Vinga Hm.",
				"leavesAt": "05:37",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Vinga Hm.",
				"to": "Şag Hm.",
				"leavesAt": "05:43",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Şag Hm.",
				"to": "Valea Viilor Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:55",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Aradu Nou",
				"leavesAt": "05:56",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "06:18",
				"arrivesAt": "06:25",
				"waitsAtSource": 720,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "06:43",
				"arrivesAt": "06:54",
				"waitsAtSource": 1080,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Utviniş h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "07:05",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Comlăuş h.",
				"leavesAt": "07:17",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Comlăuş h.",
				"to": "Şimand Hm.",
				"leavesAt": "07:22",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şimand Hm.",
				"to": "Nădab",
				"leavesAt": "07:30",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Nădab",
				"to": "Chişineu Criş",
				"leavesAt": "07:38",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Chişineu Criş",
				"to": "Zerind Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Zerind Hm.",
				"to": "Tămaşda h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Tămaşda h.",
				"to": "Boiu Bihor h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "08:06",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "08:17",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:38",
				"waitsAtSource": 120,
				"distance": 3200
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Cefa Hm.",
				"leavesAt": "08:39",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Cefa Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:09",
				"waitsAtSource": 480,
				"distance": 10400
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Oradea Vest Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Oradea",
				"leavesAt": "09:22",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5214",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "07:15",
				"arrivesAt": "07:23",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Mihăileni Hm.",
				"leavesAt": "07:24",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mihăileni Hm.",
				"to": "Nădejdea Sat h.",
				"leavesAt": "07:31",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Nădejdea Sat h.",
				"to": "Nădejdea Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Nădejdea Hm.",
				"to": "Caracău h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Caracău h.",
				"to": "Livezi Ciuc",
				"leavesAt": "07:48",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Livezi Ciuc",
				"to": "Utuşoiu h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:10",
				"waitsAtSource": 600,
				"distance": 4100
			},
			{
				"from": "Utuşoiu h.",
				"to": "Lunca de Sus Hm.",
				"leavesAt": "08:11",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Lunca de Sus Hm.",
				"to": "Tarcău h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Tarcău h.",
				"to": "Lunca de Mijloc Hm.",
				"leavesAt": "08:22",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Lunca de Mijloc Hm.",
				"to": "Bolovăniş h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Bolovăniş h.",
				"to": "Ghimeş",
				"leavesAt": "08:34",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ghimeş",
				"to": "Palanca Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:49",
				"waitsAtSource": 180,
				"distance": 5200
			},
			{
				"from": "Palanca Hm.",
				"to": "Brusturoasa hc.",
				"leavesAt": "08:50",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brusturoasa hc.",
				"to": "Simbrea Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Simbrea Hm.",
				"to": "Goioasa Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 540,
				"distance": 7600
			},
			{
				"from": "Goioasa Hm.",
				"to": "Caraliţa h.",
				"leavesAt": "09:19",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Caraliţa h.",
				"to": "Asău Hm.",
				"leavesAt": "09:26",
				"arrivesAt": "09:30",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Asău Hm.",
				"to": "Comăneşti",
				"leavesAt": "09:31",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2459",
		"segments": [
			{
				"from": "Băbeni",
				"to": "Tătărani h.",
				"leavesAt": "23:10",
				"arrivesAt": "23:13",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Tătărani h.",
				"to": "Govora",
				"leavesAt": "23:14",
				"arrivesAt": "23:22",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Govora",
				"to": "Râureni hc.",
				"leavesAt": "23:23",
				"arrivesAt": "23:26",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Râureni hc.",
				"to": "Râureni",
				"leavesAt": "23:27",
				"arrivesAt": "23:35",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râureni",
				"to": "Răstoaca h.",
				"leavesAt": "23:36",
				"arrivesAt": "23:38",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Răstoaca h.",
				"to": "Ostroveni h.",
				"leavesAt": "23:39",
				"arrivesAt": "23:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ostroveni h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "23:44",
				"arrivesAt": "23:46",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2512",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:39",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "07:43",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Mohu h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "07:54",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "08:04",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Sebeş Olt h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Racoviţa h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Racoviţa h.",
				"to": "Mârşa h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Mârşa h.",
				"to": "Avrig Hm.",
				"leavesAt": "08:25",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Sărata Colun h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:52",
				"waitsAtSource": 420,
				"distance": 3800
			},
			{
				"from": "Sărata Colun h.",
				"to": "Scoreiu h.",
				"leavesAt": "08:53",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Scoreiu h.",
				"to": "Cârţa h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârţa h.",
				"to": "Arpaş Hm.",
				"leavesAt": "09:02",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Arpaş Hm.",
				"to": "Ucea",
				"leavesAt": "09:07",
				"arrivesAt": "09:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ucea",
				"to": "Viştea h.",
				"leavesAt": "09:14",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Viştea h.",
				"to": "Olteţ h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Olteţ h.",
				"to": "Voila Hm.",
				"leavesAt": "09:23",
				"arrivesAt": "09:30",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Voila Hm.",
				"to": "Dridif h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dridif h.",
				"to": "Beclean pe Olt h.",
				"leavesAt": "09:36",
				"arrivesAt": "09:40",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Beclean pe Olt h.",
				"to": "Făgăraş",
				"leavesAt": "09:41",
				"arrivesAt": "09:49",
				"waitsAtSource": 30,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3644",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Est",
				"leavesAt": "14:30",
				"arrivesAt": "14:35",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Oradea Est",
				"to": "Oradea Est Triaj h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 700
			},
			{
				"from": "Oradea Est Triaj h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "14:38",
				"arrivesAt": "14:43",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Săcădat h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:49",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Săcădat h.",
				"to": "Săbolciu h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săbolciu h.",
				"to": "Tileagd",
				"leavesAt": "14:53",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tileagd",
				"to": "Telechiu Hm.",
				"leavesAt": "14:59",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Telechiu Hm.",
				"to": "Ţeţchea hc.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Aleşd",
				"leavesAt": "15:10",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Aleşd",
				"to": "Aleşd h.",
				"leavesAt": "15:15",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aleşd h.",
				"to": "Butan h.",
				"leavesAt": "15:19",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Butan h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "15:24",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Vadu Crişului h.",
				"leavesAt": "15:36",
				"arrivesAt": "15:40",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Peştera h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Peştera h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "15:46",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bălnaca h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 360,
				"distance": 4000
			},
			{
				"from": "Bălnaca h.",
				"to": "Bratca",
				"leavesAt": "16:01",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "16:11",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "16:20",
				"arrivesAt": "16:25",
				"waitsAtSource": 300,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180123",
				"daysOfWeek": 831
			},
			{
				"from": "20180125",
				"to": "20180408",
				"daysOfWeek": 831
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 831
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 831
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 831
			},
			{
				"from": "20180602",
				"to": "20180814",
				"daysOfWeek": 831
			},
			{
				"from": "20180816",
				"to": "20181129",
				"daysOfWeek": 831
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 831
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 831
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6507",
		"segments": [
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "17:25",
				"arrivesAt": "17:33",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 420,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Remiza T Socola h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Remiza T Socola h.",
				"to": "Socola",
				"leavesAt": "17:54",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "18:01",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "18:08",
				"arrivesAt": "18:15",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5023",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "15:50",
				"arrivesAt": "16:00",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "16:01",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "16:09",
				"arrivesAt": "16:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "16:14",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:32",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "16:33",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "16:39",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "16:44",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "16:58",
				"arrivesAt": "17:14",
				"waitsAtSource": 360,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6441",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "09:40",
				"arrivesAt": "09:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "09:55",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "10:03",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "10:10",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "10:18",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "10:35",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "10:40",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "10:50",
				"arrivesAt": "11:04",
				"waitsAtSource": 60,
				"distance": 14700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1571",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Triaj",
				"leavesAt": "05:25",
				"arrivesAt": "06:06",
				"waitsAtSource": 0,
				"distance": 56600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Ploieşti Sud",
				"leavesAt": "06:10",
				"arrivesAt": "06:17",
				"waitsAtSource": 240,
				"distance": 3600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "06:19",
				"arrivesAt": "06:52",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "06:53",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "07:36",
				"arrivesAt": "08:13",
				"waitsAtSource": 480,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Ianca hc.",
				"leavesAt": "08:16",
				"arrivesAt": "08:30",
				"waitsAtSource": 180,
				"distance": 17200
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "08:31",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "09:05",
				"arrivesAt": "09:23",
				"waitsAtSource": 120,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "09:24",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1577",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "15:30",
				"arrivesAt": "15:36",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Chitila",
				"leavesAt": "15:37",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "15:46",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Periş",
				"leavesAt": "15:53",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 13300
			},
			{
				"from": "Periş",
				"to": "Crivina",
				"leavesAt": "16:03",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "16:11",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "16:23",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "16:40",
				"arrivesAt": "16:45",
				"waitsAtSource": 180,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "16:46",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Mizil",
				"leavesAt": "16:55",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 22500
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "17:16",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Cilibia Hm.",
				"leavesAt": "17:52",
				"arrivesAt": "18:12",
				"waitsAtSource": 180,
				"distance": 19900
			},
			{
				"from": "Cilibia Hm.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "18:14",
				"arrivesAt": "18:25",
				"waitsAtSource": 120,
				"distance": 10500
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Făurei",
				"leavesAt": "18:26",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Făurei",
				"to": "Găiseanca h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:43",
				"waitsAtSource": 120,
				"distance": 3900
			},
			{
				"from": "Găiseanca h.",
				"to": "Deduleşti Hm.",
				"leavesAt": "18:44",
				"arrivesAt": "18:50",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Ianca hc.",
				"leavesAt": "18:51",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ianca hc.",
				"to": "Plopu",
				"leavesAt": "18:57",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Plopu",
				"to": "Urleasca Hm.",
				"leavesAt": "19:01",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Urleasca Hm.",
				"to": "Traian Sat Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Lacu Sărat",
				"leavesAt": "19:15",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Lacu Sărat",
				"to": "Brăila",
				"leavesAt": "19:24",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "19:35",
				"arrivesAt": "19:40",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Zagna Vădeni h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Barboşi",
				"leavesAt": "19:50",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "19:57",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "20:04",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "73",
		"segments": [
			{
				"from": "Lokoshaza",
				"to": "Curtici",
				"leavesAt": "11:50",
				"arrivesAt": "12:00",
				"waitsAtSource": 0,
				"distance": 11200
			},
			{
				"from": "Curtici",
				"to": "Arad",
				"leavesAt": "12:30",
				"arrivesAt": "12:44",
				"waitsAtSource": 1800,
				"distance": 17000
			},
			{
				"from": "Arad",
				"to": "Timişoara Nord",
				"leavesAt": "12:47",
				"arrivesAt": "13:34",
				"waitsAtSource": 180,
				"distance": 57200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1623",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "10:00",
				"arrivesAt": "10:14",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Ploieşti Vest",
				"leavesAt": "10:15",
				"arrivesAt": "10:44",
				"waitsAtSource": 60,
				"distance": 42000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "10:46",
				"arrivesAt": "11:10",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Comarnic",
				"leavesAt": "11:11",
				"arrivesAt": "11:22",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "11:23",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "11:38",
				"arrivesAt": "11:45",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "11:46",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "11:52",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "12:04",
				"arrivesAt": "12:42",
				"waitsAtSource": 120,
				"distance": 26300
			},
			{
				"from": "Braşov",
				"to": "Codlea Hm.",
				"leavesAt": "12:54",
				"arrivesAt": "13:10",
				"waitsAtSource": 720,
				"distance": 13800
			},
			{
				"from": "Codlea Hm.",
				"to": "Făgăraş",
				"leavesAt": "13:14",
				"arrivesAt": "14:10",
				"waitsAtSource": 240,
				"distance": 51200
			},
			{
				"from": "Făgăraş",
				"to": "Ucea",
				"leavesAt": "14:12",
				"arrivesAt": "14:34",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Ucea",
				"to": "Avrig Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 26100
			},
			{
				"from": "Avrig Hm.",
				"to": "Podu Olt",
				"leavesAt": "15:01",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Podu Olt",
				"to": "Tălmaciu Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Sibiu",
				"leavesAt": "15:22",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 17800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1742",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Carei",
				"leavesAt": "16:50",
				"arrivesAt": "17:24",
				"waitsAtSource": 0,
				"distance": 36000
			},
			{
				"from": "Carei",
				"to": "Valea lui Mihai",
				"leavesAt": "17:25",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 31200
			},
			{
				"from": "Valea lui Mihai",
				"to": "Săcuieni Bihor",
				"leavesAt": "17:52",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 21600
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Oradea",
				"leavesAt": "18:11",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 44200
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "19:12",
				"arrivesAt": "19:46",
				"waitsAtSource": 720,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Bratca",
				"leavesAt": "19:47",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 25300
			},
			{
				"from": "Bratca",
				"to": "Ciucea Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 20700
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "20:38",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Aghireş",
				"leavesAt": "21:00",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 21500
			},
			{
				"from": "Aghireş",
				"to": "Cluj Napoca",
				"leavesAt": "21:25",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 27900
			},
			{
				"from": "Cluj Napoca",
				"to": "Câmpia Turzii",
				"leavesAt": "22:09",
				"arrivesAt": "23:16",
				"waitsAtSource": 960,
				"distance": 51500
			},
			{
				"from": "Câmpia Turzii",
				"to": "Războieni",
				"leavesAt": "23:17",
				"arrivesAt": "23:33",
				"waitsAtSource": 60,
				"distance": 17100
			},
			{
				"from": "Războieni",
				"to": "Aiud Hm.",
				"leavesAt": "23:34",
				"arrivesAt": "23:56",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Aiud Hm.",
				"to": "Teiuş",
				"leavesAt": "23:57",
				"arrivesAt": "00:11",
				"waitsAtSource": 60,
				"distance": 13100
			},
			{
				"from": "Teiuş",
				"to": "Blaj",
				"leavesAt": "00:15",
				"arrivesAt": "00:46",
				"waitsAtSource": 240,
				"distance": 21300
			},
			{
				"from": "Blaj",
				"to": "Copşa Mică",
				"leavesAt": "00:48",
				"arrivesAt": "01:27",
				"waitsAtSource": 120,
				"distance": 30000
			},
			{
				"from": "Copşa Mică",
				"to": "Mediaş",
				"leavesAt": "01:33",
				"arrivesAt": "01:47",
				"waitsAtSource": 360,
				"distance": 10400
			},
			{
				"from": "Mediaş",
				"to": "Dumbrăveni",
				"leavesAt": "01:48",
				"arrivesAt": "02:14",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Dumbrăveni",
				"to": "Sighişoara",
				"leavesAt": "02:15",
				"arrivesAt": "02:42",
				"waitsAtSource": 60,
				"distance": 20400
			},
			{
				"from": "Sighişoara",
				"to": "Rupea",
				"leavesAt": "02:46",
				"arrivesAt": "03:49",
				"waitsAtSource": 240,
				"distance": 53600
			},
			{
				"from": "Rupea",
				"to": "Braşov",
				"leavesAt": "03:50",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 73800
			},
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "05:45",
				"arrivesAt": "06:23",
				"waitsAtSource": 840,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "06:31",
				"arrivesAt": "06:40",
				"waitsAtSource": 480,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "06:41",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "06:48",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "06:59",
				"arrivesAt": "07:13",
				"waitsAtSource": 120,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Câmpina",
				"leavesAt": "07:14",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "07:26",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "07:52",
				"arrivesAt": "08:35",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180607",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4522",
		"segments": [
			{
				"from": "Gheorgheni",
				"to": "Valea Strâmbă h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:39",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Şugău h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:43",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Şugău h.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "20:44",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "20:49",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Sândominic h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:15",
				"waitsAtSource": 420,
				"distance": 7800
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Oltului",
				"leavesAt": "21:16",
				"arrivesAt": "21:21",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Tomeşti h.",
				"leavesAt": "21:22",
				"arrivesAt": "21:25",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Cârţani h.",
				"leavesAt": "21:26",
				"arrivesAt": "21:29",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Cârţani h.",
				"to": "Dăneşti h.",
				"leavesAt": "21:30",
				"arrivesAt": "21:33",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Dăneşti h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "21:34",
				"arrivesAt": "21:40",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Racu h.",
				"leavesAt": "21:41",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Racu h.",
				"to": "Siculeni",
				"leavesAt": "21:47",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "22:10",
				"arrivesAt": "22:19",
				"waitsAtSource": 1080,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1545",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Carei",
				"leavesAt": "07:33",
				"arrivesAt": "08:03",
				"waitsAtSource": 0,
				"distance": 36000
			},
			{
				"from": "Carei",
				"to": "Tăşnad",
				"leavesAt": "08:13",
				"arrivesAt": "08:35",
				"waitsAtSource": 600,
				"distance": 27800
			},
			{
				"from": "Tăşnad",
				"to": "Acâş Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:50",
				"waitsAtSource": 120,
				"distance": 15500
			},
			{
				"from": "Acâş Hm.",
				"to": "Sărmăşag",
				"leavesAt": "08:51",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 22500
			},
			{
				"from": "Sărmăşag",
				"to": "Zalău Nord",
				"leavesAt": "09:16",
				"arrivesAt": "09:38",
				"waitsAtSource": 120,
				"distance": 22300
			},
			{
				"from": "Zalău Nord",
				"to": "Jibou",
				"leavesAt": "09:47",
				"arrivesAt": "10:19",
				"waitsAtSource": 540,
				"distance": 23700
			},
			{
				"from": "Jibou",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "10:28",
				"arrivesAt": "10:36",
				"waitsAtSource": 540,
				"distance": 6800
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "10:37",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Letca Hm.",
				"leavesAt": "10:56",
				"arrivesAt": "11:03",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Letca Hm.",
				"to": "Răstoci Hm.",
				"leavesAt": "11:04",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Răstoci Hm.",
				"to": "Ileanda",
				"leavesAt": "11:15",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ileanda",
				"to": "Gâlgău",
				"leavesAt": "11:24",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 16100
			},
			{
				"from": "Gâlgău",
				"to": "Câţcău h.",
				"leavesAt": "11:42",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Câţcău h.",
				"to": "Căşeiu Hm.",
				"leavesAt": "11:53",
				"arrivesAt": "12:00",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Căşeiu Hm.",
				"to": "Dej Călători",
				"leavesAt": "12:01",
				"arrivesAt": "12:10",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dej Călători",
				"to": "Gherla",
				"leavesAt": "12:13",
				"arrivesAt": "12:32",
				"waitsAtSource": 180,
				"distance": 13900
			},
			{
				"from": "Gherla",
				"to": "Cluj Napoca",
				"leavesAt": "12:33",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9169",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Valea Păltinişului h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Valea Păltinişului h.",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Brebu",
				"leavesAt": "16:45",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Brebu",
				"to": "Ezeriş h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ezeriş h.",
				"to": "Bănila Câlnic h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bănila Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "17:14",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Reşiţa Nord",
				"to": "Reşiţa Sud Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7573",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "16:02",
				"arrivesAt": "16:09",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Cosmeşti Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "Tecuci",
				"leavesAt": "16:16",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Tecuci",
				"to": "Malul Alb h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Malul Alb h.",
				"to": "Barcea",
				"leavesAt": "16:35",
				"arrivesAt": "16:39",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Barcea",
				"to": "Umbrăreşti h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:51",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Iveşti Hm.",
				"to": "Buceşti h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Buceşti h.",
				"to": "Lieşti",
				"leavesAt": "16:57",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lieşti",
				"to": "Şerbăneşti h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "17:06",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Vameş h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Vameş h.",
				"to": "Piscu h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Piscu h.",
				"to": "Independenţa Hm.",
				"leavesAt": "17:29",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Independenţa Hm.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Braniştea h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Braniştea h.",
				"to": "Şerbeştii Vechi h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şerbeştii Vechi h.",
				"to": "Şendreni Hm.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şendreni Hm.",
				"to": "Barboşi Triaj h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Barboşi Triaj h.",
				"to": "Barboşi",
				"leavesAt": "18:03",
				"arrivesAt": "18:11",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "18:19",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9348",
		"segments": [
			{
				"from": "Giurgiu",
				"to": "Giurgiu Nord",
				"leavesAt": "19:00",
				"arrivesAt": "19:05",
				"waitsAtSource": 0,
				"distance": 3300
			},
			{
				"from": "Giurgiu Nord",
				"to": "Cetatea h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cetatea h.",
				"to": "Bălănoaia Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:13",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bălănoaia Hm.",
				"to": "Onceşti h.",
				"leavesAt": "19:14",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Onceşti h.",
				"to": "Stăneşti Hm.",
				"leavesAt": "19:18",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Stăneşti Hm.",
				"to": "Chiriacu Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Chiriacu Hm.",
				"to": "Toporu",
				"leavesAt": "19:32",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Toporu",
				"to": "Răsuceni h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Răsuceni h.",
				"to": "Vlaşca Hm.",
				"leavesAt": "19:46",
				"arrivesAt": "19:53",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Vlaşca Hm.",
				"to": "Târnavele Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Târnavele Hm.",
				"to": "Răduleşti Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Răduleşti Hm.",
				"to": "Videle",
				"leavesAt": "20:15",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Videle",
				"to": "Vadu Lat Hm.",
				"leavesAt": "20:27",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 14600
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Grădinari",
				"leavesAt": "20:42",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Grădinari",
				"to": "Domneştii de Sus h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:07",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Chiajna",
				"leavesAt": "21:08",
				"arrivesAt": "21:25",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Chiajna",
				"to": "Bucureştii Noi",
				"leavesAt": "21:26",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Carpaţi h.(900)",
				"leavesAt": "21:31",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "21:36",
				"arrivesAt": "21:40",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Nord",
				"leavesAt": "21:41",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 480
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5722",
		"segments": [
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "15:07",
				"arrivesAt": "15:13",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "15:14",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Vama",
				"leavesAt": "15:24",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Vama",
				"to": "Molid Hm.",
				"leavesAt": "15:31",
				"arrivesAt": "15:36",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Molid Hm.",
				"to": "Frasin",
				"leavesAt": "15:37",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "15:45",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Gura Humorului Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "16:04",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Stroieşti",
				"leavesAt": "16:33",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Stroieşti",
				"to": "Suceava Vest",
				"leavesAt": "16:41",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Suceava Vest",
				"to": "Suceava",
				"leavesAt": "16:51",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4512",
		"segments": [
			{
				"from": "Deda",
				"to": "Deda Bistra Hm.",
				"leavesAt": "16:12",
				"arrivesAt": "16:18",
				"waitsAtSource": 0,
				"distance": 3900
			},
			{
				"from": "Deda Bistra Hm.",
				"to": "Borzia h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Borzia h.",
				"to": "Răstoliţa Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:28",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Răstoliţa Hm.",
				"to": "Andreneasa h.",
				"leavesAt": "16:29",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Andreneasa h.",
				"to": "Lunca Bradului Hm.",
				"leavesAt": "16:38",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Lunca Bradului Hm.",
				"to": "Stânceni Neagra h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Stânceni Neagra h.",
				"to": "Stânceni h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Stânceni h.",
				"to": "Stânceni Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Stânceni Hm.",
				"to": "Ciobotani h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Ciobotani h.",
				"to": "Topliţa",
				"leavesAt": "17:18",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Topliţa",
				"to": "Gălăuţaş Hm.",
				"leavesAt": "17:29",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Gălăuţaş Hm.",
				"to": "Sărmaş Runc h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:50",
				"waitsAtSource": 360,
				"distance": 4100
			},
			{
				"from": "Sărmaş Runc h.",
				"to": "Subcetate Mureş Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Subcetate Mureş Hm.",
				"to": "Ditrău",
				"leavesAt": "18:06",
				"arrivesAt": "18:14",
				"waitsAtSource": 480,
				"distance": 8500
			},
			{
				"from": "Ditrău",
				"to": "Lăzarea Hm.",
				"leavesAt": "18:15",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Lăzarea Hm.",
				"to": "Gheorgheni",
				"leavesAt": "18:22",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Gheorgheni",
				"to": "Valea Strâmbă h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Şugău h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:35",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Şugău h.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "18:36",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Sândominic h.",
				"leavesAt": "18:52",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Oltului",
				"leavesAt": "19:01",
				"arrivesAt": "19:06",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Izvoru Oltului",
				"to": "Tomeşti h.",
				"leavesAt": "19:07",
				"arrivesAt": "19:10",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Cârţani h.",
				"leavesAt": "19:11",
				"arrivesAt": "19:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Cârţani h.",
				"to": "Dăneşti h.",
				"leavesAt": "19:15",
				"arrivesAt": "19:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Dăneşti h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:25",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Racu h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Racu h.",
				"to": "Siculeni",
				"leavesAt": "19:32",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "19:41",
				"arrivesAt": "19:49",
				"waitsAtSource": 240,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:15",
				"waitsAtSource": 1140,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:26",
				"waitsAtSource": 420,
				"distance": 3400
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "20:27",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Vrabia h.",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vrabia h.",
				"to": "Tuşnad Sat",
				"leavesAt": "20:38",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Malnaş Băi",
				"leavesAt": "20:59",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Malnaş Băi",
				"to": "Malnaş h.",
				"leavesAt": "21:09",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Malnaş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "21:15",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Bodoc Hm.",
				"to": "Arcuş h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:38",
				"waitsAtSource": 600,
				"distance": 4500
			},
			{
				"from": "Arcuş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "21:46",
				"arrivesAt": "21:52",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "21:53",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:03",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "22:04",
				"arrivesAt": "22:07",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "22:08",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "22:17",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "22:23",
				"arrivesAt": "22:29",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1003",
		"segments": [
			{
				"from": "Vadu Siretului",
				"to": "Vicşani",
				"leavesAt": "16:25",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Vicşani",
				"to": "Dorneşti",
				"leavesAt": "17:35",
				"arrivesAt": "17:49",
				"waitsAtSource": 2640,
				"distance": 8300
			},
			{
				"from": "Dorneşti",
				"to": "Milişăuţi Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Milişăuţi Hm.",
				"to": "Dărmăneşti",
				"leavesAt": "18:03",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Dărmăneşti",
				"to": "Suceava Nord",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "18:23",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Paşcani",
				"leavesAt": "18:40",
				"arrivesAt": "19:28",
				"waitsAtSource": 720,
				"distance": 60600
			},
			{
				"from": "Paşcani",
				"to": "Bacău",
				"leavesAt": "19:29",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 84000
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "20:33",
				"arrivesAt": "21:19",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Focşani",
				"leavesAt": "21:20",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 45400
			},
			{
				"from": "Focşani",
				"to": "Buzău",
				"leavesAt": "22:12",
				"arrivesAt": "23:18",
				"waitsAtSource": 120,
				"distance": 70800
			},
			{
				"from": "Buzău",
				"to": "Ploieşti Sud",
				"leavesAt": "23:20",
				"arrivesAt": "00:25",
				"waitsAtSource": 120,
				"distance": 68600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "00:27",
				"arrivesAt": "01:22",
				"waitsAtSource": 120,
				"distance": 60200
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "01:40",
				"arrivesAt": "02:33",
				"waitsAtSource": 1080,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Giurgiu Nord",
				"leavesAt": "02:34",
				"arrivesAt": "03:48",
				"waitsAtSource": 60,
				"distance": 63000
			},
			{
				"from": "Giurgiu Nord",
				"to": "Ruse",
				"leavesAt": "04:25",
				"arrivesAt": "04:50",
				"waitsAtSource": 2220,
				"distance": 16000
			}
		],
		"restrictions": [
			{
				"from": "20180611",
				"to": "20180611",
				"daysOfWeek": 383
			},
			{
				"from": "20180616",
				"to": "20180616",
				"daysOfWeek": 383
			},
			{
				"from": "20180623",
				"to": "20180623",
				"daysOfWeek": 383
			},
			{
				"from": "20180628",
				"to": "20180628",
				"daysOfWeek": 383
			},
			{
				"from": "20180705",
				"to": "20180705",
				"daysOfWeek": 383
			},
			{
				"from": "20180710",
				"to": "20180710",
				"daysOfWeek": 383
			},
			{
				"from": "20180717",
				"to": "20180717",
				"daysOfWeek": 383
			},
			{
				"from": "20180722",
				"to": "20180722",
				"daysOfWeek": 383
			},
			{
				"from": "20180729",
				"to": "20180729",
				"daysOfWeek": 383
			},
			{
				"from": "20180803",
				"to": "20180803",
				"daysOfWeek": 383
			},
			{
				"from": "20180810",
				"to": "20180810",
				"daysOfWeek": 383
			},
			{
				"from": "20180815",
				"to": "20180815",
				"daysOfWeek": 383
			},
			{
				"from": "20180822",
				"to": "20180822",
				"daysOfWeek": 383
			},
			{
				"from": "20180827",
				"to": "20180827",
				"daysOfWeek": 383
			},
			{
				"from": "20180903",
				"to": "20180903",
				"daysOfWeek": 383
			},
			{
				"from": "20180908",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4581",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "07:51",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "08:20",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1755",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "17:05",
				"arrivesAt": "17:50",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Buzău",
				"leavesAt": "17:52",
				"arrivesAt": "18:58",
				"waitsAtSource": 120,
				"distance": 68600
			},
			{
				"from": "Buzău",
				"to": "Focşani",
				"leavesAt": "18:59",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 70800
			},
			{
				"from": "Focşani",
				"to": "Adjud",
				"leavesAt": "20:05",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 45400
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "20:50",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "21:35",
				"arrivesAt": "22:04",
				"waitsAtSource": 420,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "22:05",
				"arrivesAt": "22:34",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Suceava",
				"leavesAt": "22:35",
				"arrivesAt": "23:20",
				"waitsAtSource": 60,
				"distance": 60600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9590",
		"segments": [
			{
				"from": "Jimbolia",
				"to": "Clarii Vii h.",
				"leavesAt": "12:50",
				"arrivesAt": "12:56",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Clarii Vii h.",
				"to": "Cărpiniş",
				"leavesAt": "12:57",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Cărpiniş",
				"to": "Beregsău hcv.",
				"leavesAt": "13:06",
				"arrivesAt": "13:13",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Beregsău hcv.",
				"to": "Săcălaz h.",
				"leavesAt": "13:14",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săcălaz h.",
				"to": "Timişoara Nord",
				"leavesAt": "13:22",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5421",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "03:29",
				"arrivesAt": "03:40",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "03:41",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "03:46",
				"arrivesAt": "03:51",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "03:52",
				"arrivesAt": "04:01",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "04:02",
				"arrivesAt": "04:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "04:07",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "04:16",
				"arrivesAt": "04:23",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "04:24",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "04:31",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "04:36",
				"arrivesAt": "04:41",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "04:42",
				"arrivesAt": "04:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "04:47",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "04:52",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:36",
				"waitsAtSource": 1200,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "05:37",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "05:51",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "06:11",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "06:25",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "06:33",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5605",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "07:40",
				"arrivesAt": "07:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "07:55",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "08:03",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "08:10",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "08:18",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "08:35",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "08:50",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:15",
				"waitsAtSource": 360,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "09:16",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "09:27",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "09:33",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "09:46",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "09:53",
				"arrivesAt": "09:59",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "10:00",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "10:07",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "10:14",
				"arrivesAt": "10:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "10:23",
				"arrivesAt": "10:29",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8591",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Ştefan Vodă h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:53",
				"waitsAtSource": 0,
				"distance": 12600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Km. 25+700 h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Sud",
				"leavesAt": "09:08",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7565",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Tecuci",
				"leavesAt": "03:05",
				"arrivesAt": "03:29",
				"waitsAtSource": 0,
				"distance": 19000
			},
			{
				"from": "Tecuci",
				"to": "Barcea",
				"leavesAt": "03:30",
				"arrivesAt": "03:39",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Barcea",
				"to": "Umbrăreşti h.",
				"leavesAt": "03:40",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "03:46",
				"arrivesAt": "03:51",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Iveşti Hm.",
				"to": "Buceşti h.",
				"leavesAt": "03:52",
				"arrivesAt": "03:56",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Buceşti h.",
				"to": "Lieşti",
				"leavesAt": "03:57",
				"arrivesAt": "04:01",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Lieşti",
				"to": "Şerbăneşti h.",
				"leavesAt": "04:02",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "04:06",
				"arrivesAt": "04:11",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "04:12",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Vameş h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Vameş h.",
				"to": "Piscu h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:28",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Piscu h.",
				"to": "Independenţa Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:35",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Independenţa Hm.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Braniştea h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Braniştea h.",
				"to": "Şendreni Hm.",
				"leavesAt": "04:45",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Şendreni Hm.",
				"to": "Barboşi",
				"leavesAt": "04:54",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Barboşi",
				"to": "Fileşti Hm.",
				"leavesAt": "05:06",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Fileşti Hm.",
				"to": "Galaţi",
				"leavesAt": "05:14",
				"arrivesAt": "05:27",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8083",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Bucureşti Băneasa",
				"leavesAt": "14:40",
				"arrivesAt": "14:48",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Pantelimon",
				"leavesAt": "14:49",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "15:20",
				"arrivesAt": "15:24",
				"waitsAtSource": 1200,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "15:25",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8802",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "06:45",
				"arrivesAt": "06:52",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "06:59",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "07:13",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "07:18",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:41",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "07:50",
				"arrivesAt": "07:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "07:58",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9364",
		"segments": [
			{
				"from": "Alexandria",
				"to": "Alexandria Nord h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:28",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Buzescu h.",
				"leavesAt": "12:29",
				"arrivesAt": "12:41",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Buzescu h.",
				"to": "Plosca Hm.",
				"leavesAt": "12:42",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Plosca Hm.",
				"to": "Peret hc.",
				"leavesAt": "12:55",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Peret hc.",
				"to": "Roşiori Hm.",
				"leavesAt": "13:03",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Roşiori Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "13:18",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1556",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "19:28",
				"arrivesAt": "19:35",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Crivina",
				"leavesAt": "19:39",
				"arrivesAt": "19:55",
				"waitsAtSource": 240,
				"distance": 16900
			},
			{
				"from": "Crivina",
				"to": "Buftea",
				"leavesAt": "19:56",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "20:12",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1573",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Sud",
				"leavesAt": "08:25",
				"arrivesAt": "09:17",
				"waitsAtSource": 0,
				"distance": 60200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "09:19",
				"arrivesAt": "09:52",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "09:53",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "10:30",
				"arrivesAt": "11:07",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Ianca hc.",
				"leavesAt": "11:09",
				"arrivesAt": "11:23",
				"waitsAtSource": 120,
				"distance": 17200
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "11:24",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Barboşi",
				"leavesAt": "11:59",
				"arrivesAt": "12:18",
				"waitsAtSource": 120,
				"distance": 19500
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "12:19",
				"arrivesAt": "12:38",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8652",
		"segments": [
			{
				"from": "Tulcea Oraş",
				"to": "Tulcea Mărfuri",
				"leavesAt": "05:17",
				"arrivesAt": "05:26",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Tulcea Mărfuri",
				"to": "Cataloi Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Cataloi Hm.",
				"to": "Mihail Kogălniceanu h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mihail Kogălniceanu h.",
				"to": "Zebil h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Zebil h.",
				"to": "Babadag",
				"leavesAt": "06:13",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Babadag",
				"to": "Ceamurlia de Jos h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Ceamurlia de Jos h.",
				"to": "Baia Dobrogea",
				"leavesAt": "06:48",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baia Dobrogea",
				"to": "Mihai Viteazu Hm.",
				"leavesAt": "06:55",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 10300
			},
			{
				"from": "Mihai Viteazu Hm.",
				"to": "Cogealac",
				"leavesAt": "07:15",
				"arrivesAt": "07:33",
				"waitsAtSource": 480,
				"distance": 17400
			},
			{
				"from": "Cogealac",
				"to": "Târguşor Dobrogea Hm.",
				"leavesAt": "07:34",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 20200
			},
			{
				"from": "Târguşor Dobrogea Hm.",
				"to": "Ram. M.K.P. Aj. M.",
				"leavesAt": "07:55",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Ram. M.K.P. Aj. M.",
				"to": "Nicolae Bălcescu",
				"leavesAt": "08:06",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Nicolae Bălcescu",
				"to": "Medgidia",
				"leavesAt": "08:13",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 19100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3008",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "14:25",
				"arrivesAt": "14:34",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Timişu de Jos h.",
				"leavesAt": "14:35",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Timişu de Jos h.",
				"to": "Timişu de Sus Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Timişu de Sus Hm.",
				"to": "Predeal",
				"leavesAt": "14:53",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "15:11",
				"arrivesAt": "15:20",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "15:21",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "15:28",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "15:32",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:41",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Posada h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 8900
			},
			{
				"from": "Posada h.",
				"to": "Comarnic",
				"leavesAt": "15:51",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "16:06",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "16:10",
				"arrivesAt": "16:16",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Bobolia h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:28",
				"waitsAtSource": 480,
				"distance": 5500
			},
			{
				"from": "Bobolia h.",
				"to": "Floreşti Prahova",
				"leavesAt": "16:29",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "16:37",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "P. M. Ram. Ploieşti Tj.",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 120,
				"distance": 2900
			},
			{
				"from": "P. M. Ram. Ploieşti Tj.",
				"to": "Brazi",
				"leavesAt": "17:01",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Brazi",
				"to": "Prahova h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:19",
				"waitsAtSource": 480,
				"distance": 6900
			},
			{
				"from": "Prahova h.",
				"to": "Crivina",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "17:30",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "17:44",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Chitila",
				"leavesAt": "17:49",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Triaj hc.",
				"leavesAt": "17:58",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bucureşti Triaj hc.",
				"to": "Bucureşti Nord",
				"leavesAt": "18:03",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3528",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Albeşti Târnava Hm.",
				"leavesAt": "02:18",
				"arrivesAt": "02:25",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Albeşti Târnava Hm.",
				"to": "Vânători",
				"leavesAt": "02:26",
				"arrivesAt": "02:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Vânători",
				"to": "Archita h",
				"leavesAt": "02:34",
				"arrivesAt": "02:55",
				"waitsAtSource": 60,
				"distance": 16400
			},
			{
				"from": "Archita h",
				"to": "Beia Hm.",
				"leavesAt": "02:56",
				"arrivesAt": "03:11",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Beia Hm.",
				"to": "Paloş Ardeal h.",
				"leavesAt": "03:12",
				"arrivesAt": "03:19",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paloş Ardeal h.",
				"to": "Caţa Hm.",
				"leavesAt": "03:20",
				"arrivesAt": "03:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Caţa Hm.",
				"to": "Rupea",
				"leavesAt": "03:27",
				"arrivesAt": "03:36",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Rupea",
				"to": "Mateiaş h.",
				"leavesAt": "03:56",
				"arrivesAt": "04:10",
				"waitsAtSource": 1200,
				"distance": 10700
			},
			{
				"from": "Mateiaş h.",
				"to": "Racoş Hm.",
				"leavesAt": "04:11",
				"arrivesAt": "04:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Racoş Hm.",
				"to": "Augustin Hm.",
				"leavesAt": "04:18",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Augustin Hm.",
				"to": "Ormeniş h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ormeniş h.",
				"to": "Apaţa",
				"leavesAt": "04:44",
				"arrivesAt": "04:54",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Apaţa",
				"to": "Măieruş h.",
				"leavesAt": "04:55",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Măieruş h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:06",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Rotbav h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:12",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Rotbav h.",
				"to": "Feldioara Hm.",
				"leavesAt": "05:13",
				"arrivesAt": "05:20",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Bod Hm.",
				"leavesAt": "05:21",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Bod Hm.",
				"to": "Stupini Hm.",
				"leavesAt": "05:37",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Stupini Hm.",
				"to": "Braşov",
				"leavesAt": "05:47",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4408",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "15:30",
				"arrivesAt": "15:36",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "15:54",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180408",
				"to": "20180408",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171231",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2565",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Sibiu h.(203)",
				"leavesAt": "15:55",
				"arrivesAt": "15:59",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Mândra h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:24",
				"waitsAtSource": 120,
				"distance": 6200
			},
			{
				"from": "Mândra h.",
				"to": "Loamneş Hm.",
				"leavesAt": "16:25",
				"arrivesAt": "16:32",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Loamneş Hm.",
				"to": "Hăşag h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:44",
				"waitsAtSource": 360,
				"distance": 4100
			},
			{
				"from": "Hăşag h.",
				"to": "Şeica Mare h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Şeica Mare h.",
				"to": "Şeica Mare",
				"leavesAt": "16:56",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Şeica Mare",
				"to": "Agârbiciu h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:16",
				"waitsAtSource": 540,
				"distance": 4500
			},
			{
				"from": "Agârbiciu h.",
				"to": "Axente Sever h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Axente Sever h.",
				"to": "Copşa Mică",
				"leavesAt": "17:23",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Copşa Mică",
				"to": "Târnava h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Târnava h.",
				"to": "Mediaş",
				"leavesAt": "17:37",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5312",
		"segments": [
			{
				"from": "Comăneşti",
				"to": "Valea Uzului Hm.",
				"leavesAt": "21:00",
				"arrivesAt": "21:08",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Valea Uzului Hm.",
				"to": "Valea Uzului Haltă h.",
				"leavesAt": "21:09",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Valea Uzului Haltă h.",
				"to": "Dofteana Bacău",
				"leavesAt": "21:12",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Dofteana Bacău",
				"to": "Cireşoaia h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cireşoaia h.",
				"to": "Saline hc.",
				"leavesAt": "21:23",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Saline hc.",
				"to": "Târgu Ocna Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Târgu Ocna Hm.",
				"to": "Viişoara h",
				"leavesAt": "21:33",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Viişoara h",
				"to": "Oneşti",
				"leavesAt": "21:38",
				"arrivesAt": "21:49",
				"waitsAtSource": 30,
				"distance": 9100
			},
			{
				"from": "Oneşti",
				"to": "Borzeşti Bacău h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:54",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Borzeşti Bacău h.",
				"to": "Borzeşti Bacău",
				"leavesAt": "21:55",
				"arrivesAt": "22:01",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Borzeşti Bacău",
				"to": "Căiuţi Hm.",
				"leavesAt": "22:02",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Căiuţi Hm.",
				"to": "Bâlca hc.",
				"leavesAt": "22:09",
				"arrivesAt": "22:14",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Bâlca hc.",
				"to": "Cornăţel Moldova h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:19",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Cornăţel Moldova h.",
				"to": "Urecheşti Hm.",
				"leavesAt": "22:20",
				"arrivesAt": "22:23",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Urecheşti Hm.",
				"to": "Adjud",
				"leavesAt": "22:24",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Adjud",
				"to": "Domneşti Târg h.",
				"leavesAt": "22:37",
				"arrivesAt": "22:44",
				"waitsAtSource": 120,
				"distance": 8400
			},
			{
				"from": "Domneşti Târg h.",
				"to": "Pufeşti Hm.",
				"leavesAt": "22:45",
				"arrivesAt": "22:48",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Pufeşti Hm.",
				"to": "Călimăneşti Vrancea h.",
				"leavesAt": "22:49",
				"arrivesAt": "22:56",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Călimăneşti Vrancea h.",
				"to": "Pădureni Putna Hm.",
				"leavesAt": "22:57",
				"arrivesAt": "23:01",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Pădureni Putna Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "23:02",
				"arrivesAt": "23:12",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4339",
		"segments": [
			{
				"from": "Oradea",
				"to": "Episcopia Bihor",
				"leavesAt": "19:37",
				"arrivesAt": "19:46",
				"waitsAtSource": 0,
				"distance": 5700
			},
			{
				"from": "Episcopia Bihor",
				"to": "Biharia Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Biharia Hm.",
				"to": "Tămăşeu h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Tămăşeu h.",
				"to": "Roşiori Bihor h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Roşiori Bihor h.",
				"to": "Diosig Hm.",
				"leavesAt": "20:15",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Diosig Hm.",
				"to": "Cadia h.",
				"leavesAt": "20:23",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Cadia h.",
				"to": "Săcuieni Bihor",
				"leavesAt": "20:30",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Săcuieni Bihor",
				"to": "Şilindru Hm.",
				"leavesAt": "20:40",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Şilindru Hm.",
				"to": "Simion h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Simion h.",
				"to": "Valea lui Mihai",
				"leavesAt": "20:58",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Valea lui Mihai",
				"to": "Curtuiuşeni h.",
				"leavesAt": "21:26",
				"arrivesAt": "21:31",
				"waitsAtSource": 1200,
				"distance": 6300
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Resighea h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:38",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Resighea h.",
				"to": "Sanislău Hm.",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Sanislău Hm.",
				"to": "Marna h.",
				"leavesAt": "21:45",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Marna h.",
				"to": "Carei",
				"leavesAt": "21:50",
				"arrivesAt": "21:56",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "21:57",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:09",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "22:10",
				"arrivesAt": "22:14",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "22:24",
				"arrivesAt": "22:30",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "22:31",
				"arrivesAt": "22:38",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180607",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1893",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "13:30",
				"arrivesAt": "14:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "14:36",
				"arrivesAt": "14:55",
				"waitsAtSource": 360,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "14:56",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "15:19",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Piteşti",
				"to": "Costeşti",
				"leavesAt": "15:40",
				"arrivesAt": "16:05",
				"waitsAtSource": 600,
				"distance": 21800
			},
			{
				"from": "Costeşti",
				"to": "Stolnici Hm.",
				"leavesAt": "16:06",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Stolnici Hm.",
				"to": "Slatina",
				"leavesAt": "16:22",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 43300
			},
			{
				"from": "Slatina",
				"to": "Slătioara Hm.",
				"leavesAt": "17:02",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Slătioara Hm.",
				"to": "Piatra Olt",
				"leavesAt": "17:18",
				"arrivesAt": "17:28",
				"waitsAtSource": 240,
				"distance": 7100
			},
			{
				"from": "Piatra Olt",
				"to": "Brăneţ h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:38",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Brăneţ h.",
				"to": "Balş",
				"leavesAt": "17:39",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Balş",
				"to": "Robăneşti Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Toporaş h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Cârcea h.",
				"leavesAt": "18:11",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Cârcea h.",
				"to": "Bordei hc.(901)",
				"leavesAt": "18:19",
				"arrivesAt": "18:27",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Craiova",
				"leavesAt": "18:28",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 1700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5704",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Strâmba h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:57",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Strâmba h.",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "12:58",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "13:04",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "13:13",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mare Hm.",
				"leavesAt": "13:21",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "13:31",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Lunca Ilvei",
				"to": "Silhoasa Hm.",
				"leavesAt": "13:41",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Larion Hm.",
				"leavesAt": "13:50",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Larion Hm.",
				"to": "Grădiniţa",
				"leavesAt": "14:01",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Grădiniţa",
				"to": "Coşna Hm.",
				"leavesAt": "14:11",
				"arrivesAt": "14:20",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Coşna Hm.",
				"to": "Floreni",
				"leavesAt": "14:21",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Floreni",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Roşu Hm.",
				"leavesAt": "14:36",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Roşu Hm.",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "14:43",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "14:51",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Argestru Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Argestru Hm.",
				"to": "Iacobeni",
				"leavesAt": "15:02",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "15:13",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Valea Putnei P.M.",
				"leavesAt": "15:24",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Pojorâta Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Sadova Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sadova Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "16:06",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Vama",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Vama",
				"to": "Molid Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Molid Hm.",
				"to": "Frasin",
				"leavesAt": "16:29",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "16:37",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Gura Humorului Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:14",
				"waitsAtSource": 480,
				"distance": 7900
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Stroieşti",
				"leavesAt": "17:32",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Stroieşti",
				"to": "Suceava Vest",
				"leavesAt": "17:45",
				"arrivesAt": "17:54",
				"waitsAtSource": 300,
				"distance": 9400
			},
			{
				"from": "Suceava Vest",
				"to": "Suceava",
				"leavesAt": "17:55",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2106",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h",
				"to": "Sibiu Triaj",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj",
				"to": "Mohu h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "16:04",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "16:05",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Sebeş Olt h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Racoviţa h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Racoviţa h.",
				"to": "Mârşa h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Mârşa h.",
				"to": "Avrig Hm.",
				"leavesAt": "16:26",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Sărata Colun h.",
				"leavesAt": "16:41",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sărata Colun h.",
				"to": "Scoreiu h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:49",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Scoreiu h.",
				"to": "Cârţa h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârţa h.",
				"to": "Arpaş Hm.",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Arpaş Hm.",
				"to": "Ucea",
				"leavesAt": "17:00",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ucea",
				"to": "Viştea h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Viştea h.",
				"to": "Olteţ h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Olteţ h.",
				"to": "Voila Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Voila Hm.",
				"to": "Dridif h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dridif h.",
				"to": "Făgăraş",
				"leavesAt": "17:29",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 8500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5612",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "19:06",
				"arrivesAt": "19:11",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "19:13",
				"arrivesAt": "19:20",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "19:21",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "19:29",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "19:36",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "19:49",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "19:59",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "20:05",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "20:17",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:45",
				"waitsAtSource": 480,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "20:46",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "20:54",
				"arrivesAt": "20:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "21:00",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "21:09",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "21:20",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "21:27",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "21:34",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "21:42",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4502",
		"segments": [
			{
				"from": "Siculeni",
				"to": "Miercurea Ciuc",
				"leavesAt": "04:38",
				"arrivesAt": "04:46",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Tuşnad Sat",
				"leavesAt": "04:48",
				"arrivesAt": "05:06",
				"waitsAtSource": 120,
				"distance": 22800
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "05:07",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Malnaş Băi",
				"leavesAt": "05:23",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Malnaş Băi",
				"to": "Malnaş h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:45",
				"waitsAtSource": 480,
				"distance": 4200
			},
			{
				"from": "Malnaş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Bodoc Hm.",
				"to": "Arcuş h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Arcuş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "05:59",
				"arrivesAt": "06:04",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "06:06",
				"arrivesAt": "06:12",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 420,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "06:36",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7402",
		"segments": [
			{
				"from": "Făurei",
				"to": "Vizireni h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Vizireni h.",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Movila Oii h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:25",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Movila Oii h.",
				"to": "Cilibia Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cilibia Hm.",
				"to": "Bentu h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:40",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Bentu h.",
				"to": "Tăbărăşti Sud h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Tăbărăşti Sud h.",
				"to": "Tăbărăşti h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:48",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Tăbărăşti h.",
				"to": "Buzău",
				"leavesAt": "05:49",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9371",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Roşiori Hm.",
				"leavesAt": "16:28",
				"arrivesAt": "16:33",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Roşiori Hm.",
				"to": "Peret hc.",
				"leavesAt": "16:34",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Peret hc.",
				"to": "Plosca Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Plosca Hm.",
				"to": "Buzescu h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzescu h.",
				"to": "Alexandria Nord h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Alexandria Nord h.",
				"to": "Alexandria",
				"leavesAt": "17:16",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2145",
		"segments": [
			{
				"from": "Simeria",
				"to": "Bârcea Mare h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Bârcea Mare h.",
				"to": "Bârcea Mică",
				"leavesAt": "16:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Bârcea Mică",
				"to": "Pestişu Mare h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Pestişu Mare h.",
				"to": "Hunedoara",
				"leavesAt": "16:51",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6501",
		"segments": [
			{
				"from": "Ungheni Prut Hm.",
				"to": "Cristeşti Jijia",
				"leavesAt": "05:00",
				"arrivesAt": "05:08",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Cristeşti Jijia",
				"to": "Holboca Hm.",
				"leavesAt": "05:09",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Holboca Hm.",
				"to": "Socola",
				"leavesAt": "05:16",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Socola",
				"to": "Nicolina",
				"leavesAt": "05:27",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "05:33",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4410",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:26",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "17:44",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4526",
		"segments": [
			{
				"from": "Miercurea Ciuc",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "23:52",
				"arrivesAt": "00:00",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "00:07",
				"arrivesAt": "00:11",
				"waitsAtSource": 420,
				"distance": 3400
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "00:12",
				"arrivesAt": "00:16",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Vrabia h.",
				"leavesAt": "00:17",
				"arrivesAt": "00:22",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Vrabia h.",
				"to": "Tuşnad Sat",
				"leavesAt": "00:23",
				"arrivesAt": "00:27",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Tuşnad Sat",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "00:28",
				"arrivesAt": "00:36",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20180325",
				"to": "20180325",
				"daysOfWeek": 319
			},
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5074",
		"segments": [
			{
				"from": "Buzău",
				"to": "Băile Sarata Monteoru hcv.",
				"leavesAt": "16:55",
				"arrivesAt": "17:04",
				"waitsAtSource": 0,
				"distance": 10500
			},
			{
				"from": "Băile Sarata Monteoru hcv.",
				"to": "Ulmeni",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Ulmeni",
				"to": "Clondiru hc.",
				"leavesAt": "17:11",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Clondiru hc.",
				"to": "Săhăteni Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "17:27",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Inoteşti Hm.",
				"leavesAt": "17:35",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Inoteşti Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "17:49",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "17:55",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Valea Calugareasca Hm",
				"leavesAt": "17:59",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Valea Calugareasca Hm",
				"to": "Ploieşti Est",
				"leavesAt": "18:07",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "18:15",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "18:24",
				"arrivesAt": "18:30",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Brazi",
				"leavesAt": "18:34",
				"arrivesAt": "18:42",
				"waitsAtSource": 240,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5607",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "15:40",
				"arrivesAt": "15:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "15:55",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "16:03",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "16:10",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "16:18",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "16:35",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "16:50",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 960,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "17:26",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "17:56",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "18:03",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "18:17",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "18:24",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "18:33",
				"arrivesAt": "18:39",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20180601",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5111",
		"segments": [
			{
				"from": "Buzău",
				"to": "Boboc Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:29",
				"waitsAtSource": 0,
				"distance": 11500
			},
			{
				"from": "Boboc Hm.",
				"to": "Zoita Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Zoita Hm.",
				"to": "Râmnicu Sărat",
				"leavesAt": "16:41",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 11300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Voetin h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 120,
				"distance": 7900
			},
			{
				"from": "Voetin h.",
				"to": "Sihlea Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sihlea Hm.",
				"to": "Gugeşti",
				"leavesAt": "17:14",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gugeşti",
				"to": "Coteşti Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Coteşti Hm.",
				"to": "Focşani",
				"leavesAt": "17:31",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Focşani",
				"to": "Putna Seacă Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:56",
				"waitsAtSource": 120,
				"distance": 11700
			},
			{
				"from": "Putna Seacă Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "17:57",
				"arrivesAt": "18:07",
				"waitsAtSource": 60,
				"distance": 8000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7362",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "06:07",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "06:08",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Zagna Vădeni h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Zagna Vădeni h.",
				"to": "Vădeni Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "06:34",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Lacu Sărat",
				"leavesAt": "06:44",
				"arrivesAt": "06:52",
				"waitsAtSource": 120,
				"distance": 9700
			},
			{
				"from": "Lacu Sărat",
				"to": "Traian Sat Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Traian Sat Hm.",
				"to": "Urleasca Hm.",
				"leavesAt": "07:03",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Urleasca Hm.",
				"to": "Plopu",
				"leavesAt": "07:11",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Plopu",
				"to": "Ianca hc.",
				"leavesAt": "07:20",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Ianca hc.",
				"to": "Deduleşti Hm.",
				"leavesAt": "07:25",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Deduleşti Hm.",
				"to": "Găiseanca h.",
				"leavesAt": "07:35",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Găiseanca h.",
				"to": "Făurei",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Făurei",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "07:49",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Cilibia Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:14",
				"waitsAtSource": 300,
				"distance": 10500
			},
			{
				"from": "Cilibia Hm.",
				"to": "Buzău",
				"leavesAt": "08:19",
				"arrivesAt": "08:42",
				"waitsAtSource": 300,
				"distance": 19900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9489",
		"segments": [
			{
				"from": "Slatina",
				"to": "Slătioara Hm.",
				"leavesAt": "23:30",
				"arrivesAt": "23:42",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "23:43",
				"arrivesAt": "23:46",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "23:47",
				"arrivesAt": "23:53",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6401",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Zorleni",
				"leavesAt": "11:18",
				"arrivesAt": "11:26",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Zorleni",
				"to": "Banca Hm.",
				"leavesAt": "11:27",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Banca Hm.",
				"to": "Dodeşti hc.",
				"leavesAt": "11:36",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Dodeşti hc.",
				"to": "Roşieşti hc.",
				"leavesAt": "11:42",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Roşieşti hc.",
				"to": "Crasna",
				"leavesAt": "11:49",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Crasna",
				"to": "Bulboaca h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Bulboaca h.",
				"to": "Munteni Hm.",
				"leavesAt": "12:07",
				"arrivesAt": "12:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Munteni Hm.",
				"to": "Vaslui",
				"leavesAt": "12:14",
				"arrivesAt": "12:20",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vaslui",
				"to": "Bălteni Hm.",
				"leavesAt": "12:26",
				"arrivesAt": "12:36",
				"waitsAtSource": 360,
				"distance": 9800
			},
			{
				"from": "Bălteni Hm.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:42",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bârzeşti h.",
				"leavesAt": "12:43",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bârzeşti h.",
				"to": "Buhăieşti",
				"leavesAt": "12:48",
				"arrivesAt": "12:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "13:02",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "13:16",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "13:26",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:41",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "13:42",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "13:49",
				"arrivesAt": "13:55",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "13:56",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8805",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "18:39",
				"arrivesAt": "18:51",
				"waitsAtSource": 0,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "18:59",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "19:15",
				"arrivesAt": "19:22",
				"waitsAtSource": 480,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "19:23",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "19:39",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "19:44",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "19:55",
				"arrivesAt": "19:59",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "20:00",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9662",
		"segments": [
			{
				"from": "Stamora Moraviţa",
				"to": "Denta h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:35",
				"waitsAtSource": 0,
				"distance": 8400
			},
			{
				"from": "Denta h.",
				"to": "Deta Hm.",
				"leavesAt": "05:36",
				"arrivesAt": "05:43",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Deta Hm.",
				"to": "Voiteni",
				"leavesAt": "05:44",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "05:55",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "06:06",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "06:13",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "06:22",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "06:29",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "06:36",
				"arrivesAt": "06:47",
				"waitsAtSource": 240,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2420",
		"segments": [
			{
				"from": "Miercurea Sibiu Hm.",
				"to": "Apoldu de Jos h.",
				"leavesAt": "05:47",
				"arrivesAt": "05:51",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Apoldu de Jos h.",
				"to": "Apoldu de Sus Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Apoldu de Sus Hm.",
				"to": "Tilişca h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Tilişca h.",
				"to": "Aciliu h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Aciliu h.",
				"to": "Sălişte Hm.",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Sălişte Hm.",
				"to": "Săcelu Sibiului h.",
				"leavesAt": "06:26",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Săcelu Sibiului h.",
				"to": "Sibiel h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sibiel h.",
				"to": "Orlat",
				"leavesAt": "06:36",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Orlat",
				"to": "Cristian Sibiu h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Cristian Sibiu h.",
				"to": "Turnişor Hm.",
				"leavesAt": "06:49",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Turnişor Hm.",
				"to": "Sibiu h.(210)",
				"leavesAt": "07:05",
				"arrivesAt": "07:08",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Sibiu h.(210)",
				"to": "Sibiu",
				"leavesAt": "07:09",
				"arrivesAt": "07:14",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20180114",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180714",
				"to": "20180714",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180909",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7031",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "05:39",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Chitila",
				"leavesAt": "05:43",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chitila",
				"to": "Mogoşoaia",
				"leavesAt": "05:51",
				"arrivesAt": "06:07",
				"waitsAtSource": 120,
				"distance": 11000
			},
			{
				"from": "Mogoşoaia",
				"to": "Odăile h.",
				"leavesAt": "06:08",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Odăile h.",
				"to": "P.O. Aeroport h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "06:16",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "06:26",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "06:39",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "06:46",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "07:09",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1952",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "20:25",
				"arrivesAt": "20:30",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "20:35",
				"arrivesAt": "20:47",
				"waitsAtSource": 300,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "20:49",
				"arrivesAt": "21:07",
				"waitsAtSource": 120,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "21:09",
				"arrivesAt": "21:25",
				"waitsAtSource": 120,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "21:28",
				"arrivesAt": "21:55",
				"waitsAtSource": 180,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "21:57",
				"arrivesAt": "22:26",
				"waitsAtSource": 120,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "22:28",
				"arrivesAt": "23:07",
				"waitsAtSource": 120,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "23:09",
				"arrivesAt": "23:36",
				"waitsAtSource": 120,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "23:38",
				"arrivesAt": "23:59",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "00:01",
				"arrivesAt": "00:38",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "00:39",
				"arrivesAt": "01:10",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "C.A.Rosetti Hm.",
				"leavesAt": "01:30",
				"arrivesAt": "01:59",
				"waitsAtSource": 1200,
				"distance": 30400
			},
			{
				"from": "C.A.Rosetti Hm.",
				"to": "Făurei",
				"leavesAt": "02:04",
				"arrivesAt": "02:16",
				"waitsAtSource": 300,
				"distance": 10000
			},
			{
				"from": "Făurei",
				"to": "Ţăndărei",
				"leavesAt": "02:17",
				"arrivesAt": "02:56",
				"waitsAtSource": 60,
				"distance": 58100
			},
			{
				"from": "Ţăndărei",
				"to": "Feteşti",
				"leavesAt": "02:57",
				"arrivesAt": "03:27",
				"waitsAtSource": 60,
				"distance": 30600
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "03:28",
				"arrivesAt": "03:48",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "03:49",
				"arrivesAt": "04:06",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "04:07",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 34600
			},
			{
				"from": "Constanţa",
				"to": "Eforie Nord",
				"leavesAt": "04:46",
				"arrivesAt": "05:09",
				"waitsAtSource": 900,
				"distance": 14000
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Costineşti",
				"leavesAt": "05:20",
				"arrivesAt": "05:36",
				"waitsAtSource": 120,
				"distance": 8600
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "05:38",
				"arrivesAt": "05:42",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "05:44",
				"arrivesAt": "05:57",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "05:59",
				"arrivesAt": "06:09",
				"waitsAtSource": 120,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180608",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8372",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "08:01",
				"arrivesAt": "08:09",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "08:10",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Pescăruş h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Pescăruş h.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "08:21",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "08:27",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:44",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "08:45",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "08:52",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "08:59",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 14000
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180502",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1754",
		"segments": [
			{
				"from": "Suceava",
				"to": "Vereşti",
				"leavesAt": "12:30",
				"arrivesAt": "12:43",
				"waitsAtSource": 0,
				"distance": 14800
			},
			{
				"from": "Vereşti",
				"to": "Dolhasca",
				"leavesAt": "12:58",
				"arrivesAt": "13:17",
				"waitsAtSource": 900,
				"distance": 24600
			},
			{
				"from": "Dolhasca",
				"to": "Paşcani",
				"leavesAt": "13:18",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 21200
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "13:36",
				"arrivesAt": "14:03",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "14:04",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "14:42",
				"arrivesAt": "15:21",
				"waitsAtSource": 540,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Mărăşeşti",
				"leavesAt": "15:22",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "15:50",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "16:13",
				"arrivesAt": "16:50",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "16:51",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "17:25",
				"arrivesAt": "17:58",
				"waitsAtSource": 180,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "18:00",
				"arrivesAt": "18:36",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "18:40",
				"arrivesAt": "19:31",
				"waitsAtSource": 240,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "1091",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(913)",
				"leavesAt": "08:10",
				"arrivesAt": "08:13",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(913)",
				"to": "Jiu Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Jiu Hm.",
				"to": "Podari",
				"leavesAt": "08:20",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Podari",
				"to": "Sălcuţa Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 13800
			},
			{
				"from": "Sălcuţa Hm.",
				"to": "Dealul Robului h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dealul Robului h.",
				"to": "Segarcea Nord hc.",
				"leavesAt": "08:52",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Segarcea Nord hc.",
				"to": "Segarcea",
				"leavesAt": "09:00",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Segarcea",
				"to": "Cerăt h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cerăt h.",
				"to": "Portăreşti Hm.",
				"leavesAt": "09:11",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Portăreşti Hm.",
				"to": "Afumaţi h.",
				"leavesAt": "09:21",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Afumaţi h.",
				"to": "Siliştea Crucii h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:47",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Siliştea Crucii h.",
				"to": "Băileşti",
				"leavesAt": "09:48",
				"arrivesAt": "10:05",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Băileşti",
				"to": "Moţăţei Hm.",
				"leavesAt": "10:06",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 12800
			},
			{
				"from": "Moţăţei Hm.",
				"to": "Maglavit h.",
				"leavesAt": "10:29",
				"arrivesAt": "10:43",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Maglavit h.",
				"to": "Golenţi Hm.",
				"leavesAt": "10:44",
				"arrivesAt": "10:59",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Golenţi Hm.",
				"to": "Vidin Patnicheska",
				"leavesAt": "11:07",
				"arrivesAt": "11:25",
				"waitsAtSource": 480,
				"distance": 23200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8373",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:38",
				"arrivesAt": "07:55",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "08:07",
				"arrivesAt": "08:14",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:25",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "08:26",
				"arrivesAt": "08:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "08:35",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "08:41",
				"arrivesAt": "08:54",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "09:02",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180502",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1896",
		"segments": [
			{
				"from": "Craiova",
				"to": "Balş",
				"leavesAt": "16:25",
				"arrivesAt": "16:55",
				"waitsAtSource": 0,
				"distance": 31200
			},
			{
				"from": "Balş",
				"to": "Piatra Olt",
				"leavesAt": "16:56",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 12900
			},
			{
				"from": "Piatra Olt",
				"to": "Slatina",
				"leavesAt": "17:09",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 17000
			},
			{
				"from": "Slatina",
				"to": "Stolnici Hm.",
				"leavesAt": "17:30",
				"arrivesAt": "18:10",
				"waitsAtSource": 120,
				"distance": 43300
			},
			{
				"from": "Stolnici Hm.",
				"to": "Costeşti",
				"leavesAt": "18:11",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Costeşti",
				"to": "Piteşti",
				"leavesAt": "18:26",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "19:00",
				"arrivesAt": "19:11",
				"waitsAtSource": 600,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "19:12",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Titu",
				"leavesAt": "19:36",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "19:57",
				"arrivesAt": "20:37",
				"waitsAtSource": 120,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1882",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Nucet",
				"leavesAt": "06:27",
				"arrivesAt": "06:39",
				"waitsAtSource": 0,
				"distance": 16300
			},
			{
				"from": "Nucet",
				"to": "Titu",
				"leavesAt": "06:40",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 15400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8693",
		"segments": [
			{
				"from": "Medgidia",
				"to": "Castelu h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:36",
				"waitsAtSource": 0,
				"distance": 5200
			},
			{
				"from": "Castelu h.",
				"to": "Dorobanţu",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Dorobanţu",
				"to": "Poarta Albă h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Poarta Albă h.",
				"to": "Basarabi",
				"leavesAt": "05:47",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Basarabi",
				"to": "Murfatlar h.",
				"leavesAt": "05:53",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Murfatlar h.",
				"to": "Valul lui Traian",
				"leavesAt": "05:57",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Valul lui Traian",
				"to": "Palas",
				"leavesAt": "06:03",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Palas",
				"to": "Constanţa",
				"leavesAt": "06:09",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180428",
				"daysOfWeek": 383
			},
			{
				"from": "20180430",
				"to": "20180430",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180529",
				"daysOfWeek": 383
			},
			{
				"from": "20180609",
				"to": "20180609",
				"daysOfWeek": 383
			},
			{
				"from": "20180611",
				"to": "20180616",
				"daysOfWeek": 383
			},
			{
				"from": "20180618",
				"to": "20180623",
				"daysOfWeek": 383
			},
			{
				"from": "20180625",
				"to": "20180630",
				"daysOfWeek": 383
			},
			{
				"from": "20180702",
				"to": "20180707",
				"daysOfWeek": 383
			},
			{
				"from": "20180709",
				"to": "20180714",
				"daysOfWeek": 383
			},
			{
				"from": "20180716",
				"to": "20180721",
				"daysOfWeek": 383
			},
			{
				"from": "20180723",
				"to": "20180728",
				"daysOfWeek": 383
			},
			{
				"from": "20180730",
				"to": "20180804",
				"daysOfWeek": 383
			},
			{
				"from": "20180806",
				"to": "20180811",
				"daysOfWeek": 383
			},
			{
				"from": "20180813",
				"to": "20180814",
				"daysOfWeek": 383
			},
			{
				"from": "20180816",
				"to": "20180818",
				"daysOfWeek": 383
			},
			{
				"from": "20180820",
				"to": "20180825",
				"daysOfWeek": 383
			},
			{
				"from": "20180827",
				"to": "20180901",
				"daysOfWeek": 383
			},
			{
				"from": "20180903",
				"to": "20180908",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4490",
		"segments": [
			{
				"from": "Beclean pe Someş",
				"to": "Cociu h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:51",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Cociu h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "08:52",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Nimigea h.",
				"leavesAt": "08:56",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Nimigea h.",
				"to": "Nimigea Hm.",
				"leavesAt": "09:01",
				"arrivesAt": "09:04",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Nimigea Hm.",
				"to": "Mititei h.",
				"leavesAt": "09:05",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mititei h.",
				"to": "Salva",
				"leavesAt": "09:12",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Salva",
				"to": "Năsăud h.",
				"leavesAt": "09:16",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Năsăud h.",
				"to": "Năsăud",
				"leavesAt": "09:21",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Năsăud",
				"to": "Rebrişoara Hm.",
				"leavesAt": "09:26",
				"arrivesAt": "09:31",
				"waitsAtSource": 120,
				"distance": 4800
			},
			{
				"from": "Rebrişoara Hm.",
				"to": "Nepos h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Nepos h.",
				"to": "Feldru Hm.",
				"leavesAt": "09:39",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Feldru Hm.",
				"to": "Podereia Feldrului h.",
				"leavesAt": "09:46",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Podereia Feldrului h.",
				"to": "Ilva Mică",
				"leavesAt": "09:50",
				"arrivesAt": "09:55",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3071",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Huedin",
				"leavesAt": "02:16",
				"arrivesAt": "03:07",
				"waitsAtSource": 0,
				"distance": 49400
			},
			{
				"from": "Huedin",
				"to": "Poieni",
				"leavesAt": "03:31",
				"arrivesAt": "03:46",
				"waitsAtSource": 1440,
				"distance": 15300
			},
			{
				"from": "Poieni",
				"to": "Valea Drăganului h.",
				"leavesAt": "03:47",
				"arrivesAt": "03:51",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Ciucea Hm.",
				"leavesAt": "03:52",
				"arrivesAt": "03:57",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "03:58",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "04:03",
				"arrivesAt": "04:07",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "04:08",
				"arrivesAt": "04:13",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "04:18",
				"arrivesAt": "04:23",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "04:28",
				"arrivesAt": "04:34",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Bălnaca h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Bălnaca h.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:45",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului h.",
				"leavesAt": "04:46",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Vadu Crişului h.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "04:53",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Butan h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:03",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Butan h.",
				"to": "Aleşd h.",
				"leavesAt": "05:04",
				"arrivesAt": "05:08",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Aleşd h.",
				"to": "Aleşd",
				"leavesAt": "05:09",
				"arrivesAt": "05:15",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aleşd",
				"to": "Ţeţchea hc.",
				"leavesAt": "05:16",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Ţeţchea hc.",
				"to": "Telechiu Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Telechiu Hm.",
				"to": "Tileagd",
				"leavesAt": "05:29",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Tileagd",
				"to": "Săbolciu h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Săbolciu h.",
				"to": "Săcădat h.",
				"leavesAt": "05:47",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Săcădat h.",
				"to": "Oşorhei Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea Est Triaj h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Oradea Est Triaj h.",
				"to": "Oradea Est",
				"leavesAt": "06:09",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 700
			},
			{
				"from": "Oradea Est",
				"to": "Oradea",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3513",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:25",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "16:26",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Micăsasa h.",
				"leavesAt": "16:45",
				"arrivesAt": "17:02",
				"waitsAtSource": 720,
				"distance": 10200
			},
			{
				"from": "Micăsasa h.",
				"to": "Lunca h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lunca h.",
				"to": "Valea Lungă Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Valea Lungă Hm.",
				"to": "Glogoveţ h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Glogoveţ h.",
				"to": "Mănărade h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:28",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Mănărade h.",
				"to": "Câmpu Libertăţii  h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:33",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Câmpu Libertăţii  h.",
				"to": "Blaj",
				"leavesAt": "17:34",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Blaj",
				"to": "Crăciunel Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:49",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Crăciunel Hm.",
				"to": "Cistei h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Cistei h.",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "18:00",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Teiuş",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4451",
		"segments": [
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "10:00",
				"arrivesAt": "10:16",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "10:17",
				"arrivesAt": "10:23",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "10:24",
				"arrivesAt": "10:28",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "10:29",
				"arrivesAt": "10:36",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3079",
		"segments": [
			{
				"from": "Câmpia Turzii",
				"to": "Cânepişti h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 7700
			},
			{
				"from": "Cânepişti h.",
				"to": "Ploscoş h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:42",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Ploscoş h.",
				"to": "Valea Florilor Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:49",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Valea Florilor Hm.",
				"to": "Boju",
				"leavesAt": "16:50",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Boju",
				"to": "Tunel Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Tunel Hm.",
				"to": "Cojocna Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cojocna Hm.",
				"to": "Apahida",
				"leavesAt": "17:19",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "17:30",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180106",
				"to": "20180106",
				"daysOfWeek": 799
			},
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180203",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180604",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1536",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Arad",
				"leavesAt": "17:15",
				"arrivesAt": "18:03",
				"waitsAtSource": 0,
				"distance": 57200
			},
			{
				"from": "Arad",
				"to": "Sântana",
				"leavesAt": "18:08",
				"arrivesAt": "18:32",
				"waitsAtSource": 300,
				"distance": 23500
			},
			{
				"from": "Sântana",
				"to": "Chişineu Criş",
				"leavesAt": "18:33",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Chişineu Criş",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "18:53",
				"arrivesAt": "19:16",
				"waitsAtSource": 120,
				"distance": 23700
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "19:17",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Oradea",
				"leavesAt": "19:36",
				"arrivesAt": "20:15",
				"waitsAtSource": 420,
				"distance": 39200
			},
			{
				"from": "Oradea",
				"to": "Aleşd",
				"leavesAt": "20:24",
				"arrivesAt": "20:57",
				"waitsAtSource": 540,
				"distance": 34300
			},
			{
				"from": "Aleşd",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "20:58",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 19000
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "21:19",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Ciucea Hm.",
				"leavesAt": "21:39",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Ciucea Hm.",
				"to": "Huedin",
				"leavesAt": "21:49",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 22400
			},
			{
				"from": "Huedin",
				"to": "Cluj Napoca",
				"leavesAt": "22:19",
				"arrivesAt": "23:09",
				"waitsAtSource": 600,
				"distance": 49400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5702",
		"segments": [
			{
				"from": "Ilva Mică",
				"to": "Strâmba h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:43",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Strâmba h.",
				"to": "Leşu Ilvei Hm.",
				"leavesAt": "05:44",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Leşu Ilvei Hm.",
				"to": "Poiana Ilvei",
				"leavesAt": "05:50",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Poiana Ilvei",
				"to": "Măgura Ilvei Hm.",
				"leavesAt": "05:59",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Măgura Ilvei Hm.",
				"to": "Ilva Mare Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:21",
				"waitsAtSource": 300,
				"distance": 7100
			},
			{
				"from": "Ilva Mare Hm.",
				"to": "Lunca Ilvei",
				"leavesAt": "06:22",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Lunca Ilvei",
				"to": "Silhoasa Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "06:41",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Silhoasa Hm.",
				"to": "Larion Hm.",
				"leavesAt": "06:42",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Larion Hm.",
				"to": "Grădiniţa",
				"leavesAt": "06:53",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Grădiniţa",
				"to": "Coşna Hm.",
				"leavesAt": "07:03",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Coşna Hm.",
				"to": "Floreni",
				"leavesAt": "07:13",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Floreni",
				"to": "Dorna Candrenilor h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Dorna Candrenilor h.",
				"to": "Roşu Hm.",
				"leavesAt": "07:28",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Roşu Hm.",
				"to": "Vatra Dornei Băi hc.",
				"leavesAt": "07:35",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Vatra Dornei Băi hc.",
				"to": "Vatra Dornei",
				"leavesAt": "07:44",
				"arrivesAt": "07:47",
				"waitsAtSource": 120,
				"distance": 1000
			},
			{
				"from": "Vatra Dornei",
				"to": "Argestru Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:56",
				"waitsAtSource": 180,
				"distance": 4500
			},
			{
				"from": "Argestru Hm.",
				"to": "Iacobeni",
				"leavesAt": "07:57",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Iacobeni",
				"to": "Mestecăniş",
				"leavesAt": "08:08",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mestecăniş",
				"to": "Valea Putnei P.M.",
				"leavesAt": "08:19",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Valea Putnei P.M.",
				"to": "Pojorâta Hm.",
				"leavesAt": "08:29",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Pojorâta Hm.",
				"to": "Sadova Hm.",
				"leavesAt": "08:42",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Sadova Hm.",
				"to": "Câmpulung Mold.",
				"leavesAt": "08:48",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Câmpulung Mold.",
				"to": "Câmpulung Est Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:02",
				"waitsAtSource": 180,
				"distance": 3800
			},
			{
				"from": "Câmpulung Est Hm.",
				"to": "Prisaca Dornei Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:14",
				"waitsAtSource": 180,
				"distance": 7500
			},
			{
				"from": "Prisaca Dornei Hm.",
				"to": "Vama",
				"leavesAt": "09:16",
				"arrivesAt": "09:22",
				"waitsAtSource": 120,
				"distance": 4300
			},
			{
				"from": "Vama",
				"to": "Molid Hm.",
				"leavesAt": "09:31",
				"arrivesAt": "09:36",
				"waitsAtSource": 540,
				"distance": 3300
			},
			{
				"from": "Molid Hm.",
				"to": "Frasin",
				"leavesAt": "09:37",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Frasin",
				"to": "Gura Humorului Oraş",
				"leavesAt": "09:49",
				"arrivesAt": "09:58",
				"waitsAtSource": 300,
				"distance": 6800
			},
			{
				"from": "Gura Humorului Oraş",
				"to": "Gura Humorului Hm.",
				"leavesAt": "09:59",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Gura Humorului Hm.",
				"to": "Berchişeşti Hm.",
				"leavesAt": "10:08",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Berchişeşti Hm.",
				"to": "Lucăceşti h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:26",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lucăceşti h.",
				"to": "Ciprian Porumbescu Hm.",
				"leavesAt": "10:27",
				"arrivesAt": "10:35",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ciprian Porumbescu Hm.",
				"to": "Stroieşti",
				"leavesAt": "10:36",
				"arrivesAt": "10:43",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Stroieşti",
				"to": "Suceava Vest",
				"leavesAt": "10:44",
				"arrivesAt": "10:53",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Suceava Vest",
				"to": "Suceava",
				"leavesAt": "10:54",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8379",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "20:49",
				"arrivesAt": "21:03",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "21:04",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "21:22",
				"arrivesAt": "21:27",
				"waitsAtSource": 660,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "21:35",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "21:43",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "21:47",
				"arrivesAt": "21:56",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "21:57",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180525",
				"to": "20180529",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2206",
		"segments": [
			{
				"from": "Curtici",
				"to": "Şofronea",
				"leavesAt": "08:40",
				"arrivesAt": "08:48",
				"waitsAtSource": 0,
				"distance": 7300
			},
			{
				"from": "Şofronea",
				"to": "Arad",
				"leavesAt": "08:49",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 9700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9305",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:14",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h.(900)",
				"leavesAt": "16:15",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Carpaţi h.(900)",
				"to": "Bucureştii Noi",
				"leavesAt": "16:19",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Bucureştii Noi",
				"to": "Chiajna",
				"leavesAt": "16:23",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiajna",
				"to": "Domneştii de Sus h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Domneştii de Sus h.",
				"to": "Grădinari",
				"leavesAt": "16:37",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Grădinari",
				"to": "Zorile h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:01",
				"waitsAtSource": 540,
				"distance": 5700
			},
			{
				"from": "Zorile h.",
				"to": "Vadu Lat Hm.",
				"leavesAt": "17:02",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Vadu Lat Hm.",
				"to": "Angheleşti h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Angheleşti h.",
				"to": "Zăvestreni Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Zăvestreni Hm.",
				"to": "Videle",
				"leavesAt": "17:22",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Videle",
				"to": "Ciolpani Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:39",
				"waitsAtSource": 120,
				"distance": 7700
			},
			{
				"from": "Ciolpani Hm.",
				"to": "Gălăteni Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Gălăteni Hm.",
				"to": "Olteni",
				"leavesAt": "17:50",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Olteni",
				"to": "Vârtoapele hc.",
				"leavesAt": "17:57",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vârtoapele hc.",
				"to": "Rădoieşti Hm.",
				"leavesAt": "18:05",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Rădoieşti Hm.",
				"to": "Atârnaţi Hm.",
				"leavesAt": "18:12",
				"arrivesAt": "18:22",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Atârnaţi Hm.",
				"to": "Roşiori Nord",
				"leavesAt": "18:23",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1886",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Nucet",
				"leavesAt": "13:30",
				"arrivesAt": "13:42",
				"waitsAtSource": 0,
				"distance": 16300
			},
			{
				"from": "Nucet",
				"to": "Titu",
				"leavesAt": "13:43",
				"arrivesAt": "13:55",
				"waitsAtSource": 60,
				"distance": 15400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1883",
		"segments": [
			{
				"from": "Titu",
				"to": "Nucet",
				"leavesAt": "10:40",
				"arrivesAt": "10:51",
				"waitsAtSource": 0,
				"distance": 15400
			},
			{
				"from": "Nucet",
				"to": "Târgovişte",
				"leavesAt": "10:52",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 16300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4652",
		"segments": [
			{
				"from": "Sighetu Marmaţiei",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:37",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Tisa h.",
				"leavesAt": "14:38",
				"arrivesAt": "14:45",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tisa h.",
				"to": "Crăciuneşti h.",
				"leavesAt": "14:46",
				"arrivesAt": "14:49",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Lunca la Tisa h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Valea Vişeului",
				"leavesAt": "15:03",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Valea Vişeului",
				"to": "Vişeu Bistra h.",
				"leavesAt": "15:36",
				"arrivesAt": "15:50",
				"waitsAtSource": 900,
				"distance": 8500
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Petrova hc.",
				"leavesAt": "15:51",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Petrova hc.",
				"to": "Leordina",
				"leavesAt": "16:01",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Leordina",
				"to": "Leordina h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Leordina h.",
				"to": "Bocicoel h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Bocicoel h.",
				"to": "Vişeu de Jos",
				"leavesAt": "16:28",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180204",
				"daysOfWeek": 799
			},
			{
				"from": "20180210",
				"to": "20180302",
				"daysOfWeek": 799
			},
			{
				"from": "20180305",
				"to": "20180401",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180617",
				"daysOfWeek": 799
			},
			{
				"from": "20180701",
				"to": "20180701",
				"daysOfWeek": 799
			},
			{
				"from": "20180901",
				"to": "20180902",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9591",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Săcălaz h.",
				"leavesAt": "16:25",
				"arrivesAt": "16:35",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Săcălaz h.",
				"to": "Beregsău hcv.",
				"leavesAt": "16:36",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Beregsău hcv.",
				"to": "Cărpiniş",
				"leavesAt": "16:44",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Cărpiniş",
				"to": "Clarii Vii h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Clarii Vii h.",
				"to": "Jimbolia",
				"leavesAt": "17:00",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 6300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2572",
		"segments": [
			{
				"from": "Sighişoara",
				"to": "Daneş Hm.",
				"leavesAt": "06:29",
				"arrivesAt": "06:45",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Daneş Hm.",
				"to": "Luna h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:57",
				"waitsAtSource": 300,
				"distance": 4900
			},
			{
				"from": "Luna h.",
				"to": "Dumbrăveni",
				"leavesAt": "06:58",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dumbrăveni",
				"to": "Aţel Hm.",
				"leavesAt": "07:06",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Aţel Hm.",
				"to": "Bratei h.",
				"leavesAt": "07:16",
				"arrivesAt": "07:25",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Bratei h.",
				"to": "Mediaş",
				"leavesAt": "07:26",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:45",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "07:46",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:00",
				"waitsAtSource": 120,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "08:08",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:22",
				"waitsAtSource": 360,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Veşeud h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Veşeud h.",
				"to": "Hăşag h.",
				"leavesAt": "08:29",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "08:35",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "09:03",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "09:13",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8382",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "06:29",
				"arrivesAt": "06:35",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "06:36",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "06:41",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "06:51",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "07:02",
				"arrivesAt": "07:08",
				"waitsAtSource": 480,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "07:09",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "07:16",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "07:22",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Agigea Nord",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Nord",
				"to": "Constanţa",
				"leavesAt": "07:36",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 5300
			}
		],
		"restrictions": [
			{
				"from": "20180103",
				"to": "20180106",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180113",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180120",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180127",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180203",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180210",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180217",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180224",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180303",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180310",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180317",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180324",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180331",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180410",
				"to": "20180414",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180421",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180426",
				"daysOfWeek": 383
			},
			{
				"from": "20180503",
				"to": "20180505",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180512",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180519",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180602",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180915",
				"daysOfWeek": 383
			},
			{
				"from": "20180917",
				"to": "20180922",
				"daysOfWeek": 383
			},
			{
				"from": "20180924",
				"to": "20180929",
				"daysOfWeek": 383
			},
			{
				"from": "20181001",
				"to": "20181006",
				"daysOfWeek": 383
			},
			{
				"from": "20181008",
				"to": "20181013",
				"daysOfWeek": 383
			},
			{
				"from": "20181015",
				"to": "20181020",
				"daysOfWeek": 383
			},
			{
				"from": "20181022",
				"to": "20181027",
				"daysOfWeek": 383
			},
			{
				"from": "20181029",
				"to": "20181103",
				"daysOfWeek": 383
			},
			{
				"from": "20181105",
				"to": "20181110",
				"daysOfWeek": 383
			},
			{
				"from": "20181112",
				"to": "20181117",
				"daysOfWeek": 383
			},
			{
				"from": "20181119",
				"to": "20181124",
				"daysOfWeek": 383
			},
			{
				"from": "20181126",
				"to": "20181201",
				"daysOfWeek": 383
			},
			{
				"from": "20181203",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171216",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171223",
				"daysOfWeek": 383
			},
			{
				"from": "20171227",
				"to": "20171230",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1094",
		"segments": [
			{
				"from": "Ruse",
				"to": "Giurgiu Nord",
				"leavesAt": "16:10",
				"arrivesAt": "16:35",
				"waitsAtSource": 0,
				"distance": 16000
			},
			{
				"from": "Giurgiu Nord",
				"to": "Videle",
				"leavesAt": "16:58",
				"arrivesAt": "18:07",
				"waitsAtSource": 1380,
				"distance": 63000
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "18:08",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 50900
			}
		],
		"restrictions": [
			{
				"from": "20181002",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180531",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9571",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Belinţ Hm.",
				"leavesAt": "04:51",
				"arrivesAt": "05:01",
				"waitsAtSource": 0,
				"distance": 13200
			},
			{
				"from": "Belinţ Hm.",
				"to": "Chizătău Hm.",
				"leavesAt": "05:02",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Chizătău Hm.",
				"to": "Topolovăţ",
				"leavesAt": "05:07",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Topolovăţ",
				"to": "Şuştra h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Şuştra h.",
				"to": "Recaş",
				"leavesAt": "05:18",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Recaş",
				"to": "Izvin h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Izvin h.",
				"to": "Remetea Mare",
				"leavesAt": "05:29",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Remetea Mare",
				"to": "Timişoara Est",
				"leavesAt": "05:41",
				"arrivesAt": "05:55",
				"waitsAtSource": 240,
				"distance": 9600
			},
			{
				"from": "Timişoara Est",
				"to": "Timişoara Nord",
				"leavesAt": "05:56",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2514",
		"segments": [
			{
				"from": "Sibiu",
				"to": "Atelier Zona h.",
				"leavesAt": "19:28",
				"arrivesAt": "19:31",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Atelier Zona h.",
				"to": "Sibiu Triaj h.",
				"leavesAt": "19:32",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Sibiu Triaj h.",
				"to": "Sibiu Gr.Şelimbăr Hm.",
				"leavesAt": "19:35",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sibiu Gr.Şelimbăr Hm.",
				"to": "Mohu h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Mohu h.",
				"to": "Veştem h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:46",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Veştem h.",
				"to": "Tălmaciu Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 7500
			},
			{
				"from": "Tălmaciu Hm.",
				"to": "Podu Olt",
				"leavesAt": "19:57",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Podu Olt",
				"to": "Sebeş Olt h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Sebeş Olt h.",
				"to": "Racoviţa h.",
				"leavesAt": "20:10",
				"arrivesAt": "20:13",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Racoviţa h.",
				"to": "Mârşa h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Mârşa h.",
				"to": "Avrig Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Avrig Hm.",
				"to": "Porumbacu Hm.",
				"leavesAt": "20:23",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Porumbacu Hm.",
				"to": "Sărata Colun h.",
				"leavesAt": "20:33",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sărata Colun h.",
				"to": "Scoreiu h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Scoreiu h.",
				"to": "Cârţa h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Cârţa h.",
				"to": "Arpaş Hm.",
				"leavesAt": "20:47",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Arpaş Hm.",
				"to": "Ucea",
				"leavesAt": "20:52",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Ucea",
				"to": "Viştea h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Viştea h.",
				"to": "Olteţ h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:07",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Olteţ h.",
				"to": "Voila Hm.",
				"leavesAt": "21:08",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Voila Hm.",
				"to": "Dridif h.",
				"leavesAt": "21:20",
				"arrivesAt": "21:24",
				"waitsAtSource": 300,
				"distance": 3500
			},
			{
				"from": "Dridif h.",
				"to": "Beclean pe Olt h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:29",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Beclean pe Olt h.",
				"to": "Făgăraş",
				"leavesAt": "21:30",
				"arrivesAt": "21:38",
				"waitsAtSource": 30,
				"distance": 5200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2606",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "14:44",
				"arrivesAt": "14:51",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Valea Viilor Hm.",
				"leavesAt": "14:55",
				"arrivesAt": "15:05",
				"waitsAtSource": 240,
				"distance": 5500
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Şag Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:20",
				"waitsAtSource": 600,
				"distance": 5500
			},
			{
				"from": "Şag Hm.",
				"to": "Vinga Hm.",
				"leavesAt": "15:21",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vinga Hm.",
				"to": "Orţişoara",
				"leavesAt": "15:28",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Orţişoara",
				"to": "Băile Călacea",
				"leavesAt": "15:34",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Băile Călacea",
				"to": "Sânandrei Hm.",
				"leavesAt": "15:40",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "15:55",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "15:58",
				"arrivesAt": "16:06",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2143",
		"segments": [
			{
				"from": "Simeria",
				"to": "Bârcea Mare h.",
				"leavesAt": "14:03",
				"arrivesAt": "14:09",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Bârcea Mare h.",
				"to": "Bârcea Mică",
				"leavesAt": "14:10",
				"arrivesAt": "14:13",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Bârcea Mică",
				"to": "Pestişu Mare h.",
				"leavesAt": "14:14",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Pestişu Mare h.",
				"to": "Hunedoara",
				"leavesAt": "14:19",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5603",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "06:40",
				"arrivesAt": "06:54",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "06:55",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Budăi hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Budăi hc.",
				"to": "Sârca Hm.",
				"leavesAt": "07:10",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Sârca Hm.",
				"to": "Târgu Frumos",
				"leavesAt": "07:18",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Târgu Frumos",
				"to": "Pietrişu h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pietrişu h.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "07:35",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Ruginoasa Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Paşcani",
				"leavesAt": "07:50",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 14700
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 960,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "08:26",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "08:43",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "08:49",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "09:03",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "09:17",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "09:24",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "09:33",
				"arrivesAt": "09:39",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1649",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Sărăţel Hm.",
				"leavesAt": "22:35",
				"arrivesAt": "22:47",
				"waitsAtSource": 0,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5027",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "22:15",
				"arrivesAt": "22:25",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "22:26",
				"arrivesAt": "22:32",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "22:33",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "22:38",
				"arrivesAt": "22:46",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "22:47",
				"arrivesAt": "22:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "22:52",
				"arrivesAt": "22:57",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "22:58",
				"arrivesAt": "23:02",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "23:03",
				"arrivesAt": "23:11",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "23:12",
				"arrivesAt": "23:28",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8081",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Bucureşti Băneasa",
				"leavesAt": "04:47",
				"arrivesAt": "04:55",
				"waitsAtSource": 0,
				"distance": 6600
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Pantelimon",
				"leavesAt": "04:56",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Pantelimon",
				"to": "Pantelimon Sud hc.",
				"leavesAt": "05:24",
				"arrivesAt": "05:28",
				"waitsAtSource": 1020,
				"distance": 600
			},
			{
				"from": "Pantelimon Sud hc.",
				"to": "Bucureşti Obor",
				"leavesAt": "05:29",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4095",
		"segments": [
			{
				"from": "Jibou",
				"to": "Var h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:44",
				"waitsAtSource": 0,
				"distance": 2800
			},
			{
				"from": "Var h.",
				"to": "Surduc Sălaj Hm.",
				"leavesAt": "16:45",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Surduc Sălaj Hm.",
				"to": "Ciocmani h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:02",
				"waitsAtSource": 360,
				"distance": 4400
			},
			{
				"from": "Ciocmani h.",
				"to": "Băbuţeni Hm.",
				"leavesAt": "17:03",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Băbuţeni Hm.",
				"to": "Cuciulat Hm.",
				"leavesAt": "17:10",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Cuciulat Hm.",
				"to": "Letca Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Letca Hm.",
				"to": "Răstoci Hm.",
				"leavesAt": "17:24",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Răstoci Hm.",
				"to": "Bizuşa h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bizuşa h.",
				"to": "Ileanda",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Ileanda",
				"to": "Rus h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Rus h.",
				"to": "Glodu Someşului h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Glodu Someşului h.",
				"to": "Gâlgău h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Gâlgău h.",
				"to": "Gâlgău",
				"leavesAt": "18:03",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Gâlgău",
				"to": "Căpâlna pe Someş h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Căpâlna pe Someş h.",
				"to": "Câţcău h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Câţcău h.",
				"to": "Coplean h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:27",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Coplean h.",
				"to": "Căşeiu Hm.",
				"leavesAt": "18:28",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Căşeiu Hm.",
				"to": "C. C. H. Dej h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "C. C. H. Dej h.",
				"to": "Dej Călători",
				"leavesAt": "18:38",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:52",
				"waitsAtSource": 120,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "18:53",
				"arrivesAt": "19:04",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "19:12",
				"arrivesAt": "19:17",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "19:18",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "19:22",
				"arrivesAt": "19:27",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "19:28",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "19:32",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida h.",
				"leavesAt": "19:38",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Apahida h.",
				"to": "Apahida",
				"leavesAt": "19:45",
				"arrivesAt": "19:50",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Apahida",
				"to": "Dezmir h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Dezmir h.",
				"to": "Cluj Napoca Est",
				"leavesAt": "19:55",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "20:09",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8593",
		"segments": [
			{
				"from": "Ciulniţa",
				"to": "Ştefan Vodă h.",
				"leavesAt": "15:35",
				"arrivesAt": "15:48",
				"waitsAtSource": 0,
				"distance": 12600
			},
			{
				"from": "Ştefan Vodă h.",
				"to": "Călăraşi Nord Hm.",
				"leavesAt": "15:49",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Călăraşi Nord Hm.",
				"to": "Km. 25+700 h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Km. 25+700 h.",
				"to": "Călăraşi Sud",
				"leavesAt": "16:03",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 1300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4407",
		"segments": [
			{
				"from": "Satu Mare",
				"to": "Ram. Botiz h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:46",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Micula Hm.",
				"leavesAt": "14:47",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Micula Hm.",
				"to": "Porumbeşti Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Halmeu",
				"leavesAt": "15:05",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20180113",
				"to": "20180123",
				"daysOfWeek": 799
			},
			{
				"from": "20180125",
				"to": "20180202",
				"daysOfWeek": 799
			},
			{
				"from": "20180211",
				"to": "20180331",
				"daysOfWeek": 799
			},
			{
				"from": "20180411",
				"to": "20180430",
				"daysOfWeek": 799
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 799
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 799
			},
			{
				"from": "20180602",
				"to": "20180615",
				"daysOfWeek": 799
			},
			{
				"from": "20180908",
				"to": "20181129",
				"daysOfWeek": 799
			},
			{
				"from": "20181201",
				"to": "20181208",
				"daysOfWeek": 799
			},
			{
				"from": "20171210",
				"to": "20171222",
				"daysOfWeek": 799
			},
			{
				"from": "20171230",
				"to": "20171231",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1785",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Titu",
				"leavesAt": "11:30",
				"arrivesAt": "12:30",
				"waitsAtSource": 0,
				"distance": 48000
			},
			{
				"from": "Titu",
				"to": "Găeşti",
				"leavesAt": "12:31",
				"arrivesAt": "12:50",
				"waitsAtSource": 60,
				"distance": 21800
			},
			{
				"from": "Găeşti",
				"to": "Goleşti",
				"leavesAt": "12:51",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Goleşti",
				"to": "Piteşti",
				"leavesAt": "13:15",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 7800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1550",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "06:06",
				"arrivesAt": "06:11",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crivina",
				"leavesAt": "06:20",
				"arrivesAt": "06:35",
				"waitsAtSource": 540,
				"distance": 19200
			},
			{
				"from": "Crivina",
				"to": "Buftea",
				"leavesAt": "06:36",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "06:53",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "369",
		"segments": [
			{
				"from": "Biharkeresztes",
				"to": "Episcopia Bihor",
				"leavesAt": "09:02",
				"arrivesAt": "09:17",
				"waitsAtSource": 0,
				"distance": 12500
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "09:35",
				"arrivesAt": "09:43",
				"waitsAtSource": 1080,
				"distance": 5700
			},
			{
				"from": "Oradea",
				"to": "Leş Bihor Hm.",
				"leavesAt": "09:56",
				"arrivesAt": "10:13",
				"waitsAtSource": 780,
				"distance": 16300
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Cefa Hm.",
				"leavesAt": "10:14",
				"arrivesAt": "10:25",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Cefa Hm.",
				"to": "Salonta",
				"leavesAt": "10:26",
				"arrivesAt": "10:38",
				"waitsAtSource": 60,
				"distance": 12500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9023",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:05",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "08:06",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "08:10",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "08:14",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Sabareni",
				"leavesAt": "08:22",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Sabareni",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "08:31",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Bâldana h.",
				"leavesAt": "08:44",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Bâldana h.",
				"to": "Ghergani Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Ghergani Hm.",
				"to": "Conţeşti h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Conţeşti h.",
				"to": "Boteni h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boteni h.",
				"to": "Titu",
				"leavesAt": "09:21",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Titu",
				"to": "Fusea Hm.",
				"leavesAt": "09:30",
				"arrivesAt": "09:36",
				"waitsAtSource": 120,
				"distance": 5400
			},
			{
				"from": "Fusea Hm.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "09:37",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Cojocaru h.",
				"leavesAt": "09:44",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Cojocaru h.",
				"to": "Găeşti Sud h.",
				"leavesAt": "09:50",
				"arrivesAt": "09:53",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Găeşti Sud h.",
				"to": "Găeşti",
				"leavesAt": "09:54",
				"arrivesAt": "10:00",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Găeşti",
				"to": "Pătroaia Hm.",
				"leavesAt": "10:01",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Pătroaia Hm.",
				"to": "Leordeni Argeş",
				"leavesAt": "10:10",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Leordeni Argeş",
				"to": "Călineşti Hm.",
				"leavesAt": "10:18",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Călineşti Hm.",
				"to": "Goleşti",
				"leavesAt": "10:25",
				"arrivesAt": "10:33",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Goleşti",
				"to": "Ram. Goleşti",
				"leavesAt": "10:34",
				"arrivesAt": "10:39",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ram. Goleşti",
				"to": "Piteşti",
				"leavesAt": "10:40",
				"arrivesAt": "10:50",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Piteşti",
				"to": "Bradu de Sus",
				"leavesAt": "11:10",
				"arrivesAt": "11:15",
				"waitsAtSource": 1200,
				"distance": 4500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu h.",
				"leavesAt": "11:16",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Pârvu h.",
				"to": "Costeşti",
				"leavesAt": "11:26",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Costeşti",
				"to": "Stolnici Hm.",
				"leavesAt": "11:39",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 15900
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "11:54",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "12:00",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "12:06",
				"arrivesAt": "12:12",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "12:13",
				"arrivesAt": "12:19",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "12:20",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "12:28",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "12:36",
				"arrivesAt": "12:44",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Criva h.",
				"leavesAt": "12:45",
				"arrivesAt": "12:58",
				"waitsAtSource": 60,
				"distance": 13000
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "12:59",
				"arrivesAt": "13:05",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8388",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "14:00",
				"arrivesAt": "14:06",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "14:07",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Pescăruş h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăruş h.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "14:18",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "14:24",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "14:35",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "14:57",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180529",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180427",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5733",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "05:31",
				"arrivesAt": "05:36",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "05:37",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Părhăuţi h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:59",
				"waitsAtSource": 360,
				"distance": 4400
			},
			{
				"from": "Părhăuţi h.",
				"to": "Todireşti h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Todireşti h.",
				"to": "Soloneţ h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Soloneţ h.",
				"to": "Pârteşti h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Pârteşti h.",
				"to": "Cacica Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1698",
		"segments": [
			{
				"from": "Reşiţa Sud Hm.",
				"to": "Reşiţa Nord",
				"leavesAt": "05:17",
				"arrivesAt": "05:26",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Reşiţa Nord",
				"to": "Cornuţel Banat Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 29000
			},
			{
				"from": "Cornuţel Banat Hm.",
				"to": "Caransebeş",
				"leavesAt": "06:01",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "06:39",
				"arrivesAt": "07:12",
				"waitsAtSource": 1560,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Recaş",
				"leavesAt": "07:13",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 35700
			},
			{
				"from": "Recaş",
				"to": "Timişoara Nord",
				"leavesAt": "07:39",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 23200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9411",
		"segments": [
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "06:50",
				"arrivesAt": "06:58",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "07:12",
				"arrivesAt": "07:20",
				"waitsAtSource": 300,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "07:22",
				"arrivesAt": "07:28",
				"waitsAtSource": 120,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "07:29",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 288
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1558",
		"segments": [
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "06:40",
				"arrivesAt": "07:13",
				"waitsAtSource": 0,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "07:14",
				"arrivesAt": "07:49",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Buftea",
				"leavesAt": "07:51",
				"arrivesAt": "08:28",
				"waitsAtSource": 120,
				"distance": 43300
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "08:29",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4582",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "11:05",
				"arrivesAt": "11:12",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "11:13",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "11:18",
				"arrivesAt": "11:23",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "11:24",
				"arrivesAt": "11:27",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "11:28",
				"arrivesAt": "11:36",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "11:37",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "11:43",
				"arrivesAt": "11:49",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 831
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2566",
		"segments": [
			{
				"from": "Mediaş",
				"to": "Târnava h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:33",
				"waitsAtSource": 0,
				"distance": 5100
			},
			{
				"from": "Târnava h.",
				"to": "Copşa Mică",
				"leavesAt": "12:34",
				"arrivesAt": "12:41",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Copşa Mică",
				"to": "Axente Sever h.",
				"leavesAt": "12:57",
				"arrivesAt": "13:02",
				"waitsAtSource": 960,
				"distance": 2700
			},
			{
				"from": "Axente Sever h.",
				"to": "Agârbiciu h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Agârbiciu h.",
				"to": "Şeica Mare",
				"leavesAt": "13:10",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şeica Mare",
				"to": "Şeica Mare h.",
				"leavesAt": "13:21",
				"arrivesAt": "13:23",
				"waitsAtSource": 300,
				"distance": 1400
			},
			{
				"from": "Şeica Mare h.",
				"to": "Veşeud h.",
				"leavesAt": "13:24",
				"arrivesAt": "13:29",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Veşeud h.",
				"to": "Hăşag h.",
				"leavesAt": "13:30",
				"arrivesAt": "13:35",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hăşag h.",
				"to": "Loamneş Hm.",
				"leavesAt": "13:36",
				"arrivesAt": "13:41",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Loamneş Hm.",
				"to": "Mândra h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Mândra h.",
				"to": "Băile Ocna Sibiului h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:54",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Băile Ocna Sibiului h.",
				"to": "Ocna Sibiului Hm.",
				"leavesAt": "13:56",
				"arrivesAt": "14:03",
				"waitsAtSource": 120,
				"distance": 2100
			},
			{
				"from": "Ocna Sibiului Hm.",
				"to": "Sibiu h.(203)",
				"leavesAt": "14:04",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Sibiu h.(203)",
				"to": "Sibiu",
				"leavesAt": "14:14",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8123",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Carpaţi h.(700)",
				"leavesAt": "16:45",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Carpaţi h.(700)",
				"to": "Pajura Hm. (700)",
				"leavesAt": "16:52",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (700)",
				"to": "Mogoşoaia",
				"leavesAt": "16:56",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Mogoşoaia",
				"to": "P.O. Aeroport h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "P.O. Aeroport h.",
				"to": "Baloteşti Hm.",
				"leavesAt": "17:27",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Baloteşti Hm.",
				"to": "Căciulaţi Hm.",
				"leavesAt": "17:31",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Căciulaţi Hm.",
				"to": "Moara Vlasiei Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Moara Vlasiei Hm.",
				"to": "Greci h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Greci h.",
				"to": "Fierbinţi",
				"leavesAt": "17:49",
				"arrivesAt": "17:55",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Fierbinţi",
				"to": "Dridu Hm.",
				"leavesAt": "17:56",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Dridu Hm.",
				"to": "Moldoveni h.",
				"leavesAt": "18:03",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Moldoveni h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "18:09",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "18:20",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Urziceni",
				"to": "Alexeni h.",
				"leavesAt": "18:37",
				"arrivesAt": "18:43",
				"waitsAtSource": 660,
				"distance": 5800
			},
			{
				"from": "Alexeni h.",
				"to": "Broşteni Hm.",
				"leavesAt": "18:44",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Broşteni Hm.",
				"to": "Malu h.",
				"leavesAt": "18:52",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Malu h.",
				"to": "Km. 74+600 h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Km. 74+600 h.",
				"to": "Sărăţuica Hm.",
				"leavesAt": "19:03",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Sărăţuica Hm.",
				"to": "Sărăţeni Ialomiţa h.",
				"leavesAt": "19:08",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sărăţeni Ialomiţa h.",
				"to": "Munteni Buzău h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Munteni Buzău h.",
				"to": "Căzăneşti",
				"leavesAt": "19:18",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Căzăneşti",
				"to": "Ciochina hc.",
				"leavesAt": "19:25",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ciochina hc.",
				"to": "Andrăşeşti Hm.",
				"leavesAt": "19:32",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Andrăşeşti Hm.",
				"to": "Fundata h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Fundata h.",
				"to": "Perieţi h.",
				"leavesAt": "19:47",
				"arrivesAt": "19:52",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Perieţi h.",
				"to": "Slobozia Veche",
				"leavesAt": "19:53",
				"arrivesAt": "20:04",
				"waitsAtSource": 30,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1553",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "18:52",
				"arrivesAt": "19:06",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Crivina",
				"leavesAt": "19:07",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 22800
			},
			{
				"from": "Crivina",
				"to": "Ploieşti Sud",
				"leavesAt": "19:22",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 20500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7570",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "14:49",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "14:50",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Şendreni Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Şendreni Hm.",
				"to": "Şerbeştii Vechi h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Şerbeştii Vechi h.",
				"to": "Braniştea h.",
				"leavesAt": "15:11",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Braniştea h.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Independenţa Hm.",
				"leavesAt": "15:20",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Independenţa Hm.",
				"to": "Piscu h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Piscu h.",
				"to": "Vameş h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vameş h.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "15:45",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Şerbăneşti h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Lieşti",
				"leavesAt": "15:57",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lieşti",
				"to": "Buceşti h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:04",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Buceşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "16:05",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Iveşti Hm.",
				"to": "Umbrăreşti h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Barcea",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Barcea",
				"to": "Malul Alb h.",
				"leavesAt": "16:23",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Malul Alb h.",
				"to": "Tecuci",
				"leavesAt": "16:27",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:47",
				"waitsAtSource": 180,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "16:54",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1792",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Goleşti",
				"leavesAt": "16:00",
				"arrivesAt": "16:11",
				"waitsAtSource": 0,
				"distance": 7800
			},
			{
				"from": "Goleşti",
				"to": "Găeşti",
				"leavesAt": "16:12",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 30400
			},
			{
				"from": "Găeşti",
				"to": "Cojocaru h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Cojocaru h.",
				"to": "Mătăsaru Hm.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Mătăsaru Hm.",
				"to": "Fusea Hm.",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Fusea Hm.",
				"to": "Titu",
				"leavesAt": "16:54",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Titu",
				"to": "Bucureşti Nord",
				"leavesAt": "17:03",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 48000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1993",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "12:50",
				"arrivesAt": "12:57",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "12:58",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "13:05",
				"arrivesAt": "13:18",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "13:20",
				"arrivesAt": "13:24",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "13:26",
				"arrivesAt": "13:34",
				"waitsAtSource": 120,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "13:35",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "13:47",
				"arrivesAt": "13:54",
				"waitsAtSource": 180,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "13:57",
				"arrivesAt": "14:21",
				"waitsAtSource": 180,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "14:40",
				"arrivesAt": "15:04",
				"waitsAtSource": 1140,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Feteşti",
				"leavesAt": "15:05",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 44000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "15:36",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "15:59",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 108900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "17:25",
				"arrivesAt": "18:15",
				"waitsAtSource": 1860,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "18:16",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Drăgăneşti Olt",
				"leavesAt": "19:03",
				"arrivesAt": "19:34",
				"waitsAtSource": 120,
				"distance": 37300
			},
			{
				"from": "Drăgăneşti Olt",
				"to": "Caracal",
				"leavesAt": "19:35",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "19:54",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2186",
		"segments": [
			{
				"from": "Lugoj",
				"to": "Lugoj Nord h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:54",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lugoj Nord h.",
				"to": "Coşteiu Mare Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Coşteiu Mare Hm.",
				"to": "Păru h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Păru h.",
				"to": "Balinţ h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Balinţ h.",
				"to": "Nevrincea h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Nevrincea h.",
				"to": "Cliciova",
				"leavesAt": "16:11",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Cliciova",
				"to": "Susani Bega h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Susani Bega h.",
				"to": "Traian Vuia h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Traian Vuia h.",
				"to": "Mănăştur Hm.",
				"leavesAt": "16:23",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Mănăştur Hm.",
				"to": "Răchita h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Răchita h.",
				"to": "Făget",
				"leavesAt": "16:32",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Făget",
				"to": "Margina",
				"leavesAt": "16:38",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6826",
		"segments": [
			{
				"from": "Nyirabrany",
				"to": "Valea lui Mihai",
				"leavesAt": "17:31",
				"arrivesAt": "17:46",
				"waitsAtSource": 0,
				"distance": 8800
			},
			{
				"from": "Valea lui Mihai",
				"to": "Curtuiuşeni h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:11",
				"waitsAtSource": 1140,
				"distance": 6300
			},
			{
				"from": "Curtuiuşeni h.",
				"to": "Resighea h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:18",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Resighea h.",
				"to": "Sanislău Hm.",
				"leavesAt": "18:19",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Sanislău Hm.",
				"to": "Marna h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Marna h.",
				"to": "Carei",
				"leavesAt": "18:31",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Carei",
				"to": "Domăneşti h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:52",
				"waitsAtSource": 300,
				"distance": 9900
			},
			{
				"from": "Domăneşti h.",
				"to": "Moftin h.",
				"leavesAt": "18:53",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Moftin h.",
				"to": "Gen. Gh. Avramescu Hm.",
				"leavesAt": "18:59",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Gen. Gh. Avramescu Hm.",
				"to": "Sătmărel h.",
				"leavesAt": "19:04",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 9900
			},
			{
				"from": "Sătmărel h.",
				"to": "Satu Mare Sud",
				"leavesAt": "19:14",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Satu Mare Sud",
				"to": "Satu Mare",
				"leavesAt": "19:22",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Satu Mare",
				"to": "Botiz Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:10",
				"waitsAtSource": 2040,
				"distance": 5500
			},
			{
				"from": "Botiz Hm.",
				"to": "Odoreu h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Odoreu h.",
				"to": "Medieşu Aurit Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Medieşu Aurit Hm.",
				"to": "Apa Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Apa Hm.",
				"to": "Seini",
				"leavesAt": "20:41",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Seini",
				"to": "Săbişa h.",
				"leavesAt": "21:08",
				"arrivesAt": "21:14",
				"waitsAtSource": 660,
				"distance": 3300
			},
			{
				"from": "Săbişa h.",
				"to": "Ilba h.",
				"leavesAt": "21:15",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ilba h.",
				"to": "Cicârlău h.",
				"leavesAt": "21:20",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Cicârlău h.",
				"to": "Buşag Hm.",
				"leavesAt": "21:29",
				"arrivesAt": "21:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Buşag Hm.",
				"to": "Baia Mare",
				"leavesAt": "21:36",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 10500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1987",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Feteşti",
				"leavesAt": "03:15",
				"arrivesAt": "04:46",
				"waitsAtSource": 0,
				"distance": 146400
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "04:47",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "05:08",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "05:26",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 36000
			},
			{
				"from": "Constanţa",
				"to": "Agigea Nord",
				"leavesAt": "06:15",
				"arrivesAt": "06:26",
				"waitsAtSource": 960,
				"distance": 5300
			},
			{
				"from": "Agigea Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "06:35",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "06:46",
				"arrivesAt": "06:53",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:04",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "07:05",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "07:21",
				"arrivesAt": "07:25",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Pescăruş h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Pescăruş h.",
				"to": "Neptun hc.",
				"leavesAt": "07:34",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Neptun hc.",
				"to": "Neptun",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Neptun",
				"to": "Mangalia",
				"leavesAt": "07:49",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20180427",
				"to": "20180501",
				"daysOfWeek": 383
			},
			{
				"from": "20180524",
				"to": "20180528",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "365",
		"segments": [
			{
				"from": "Biharkeresztes",
				"to": "Episcopia Bihor",
				"leavesAt": "15:37",
				"arrivesAt": "15:52",
				"waitsAtSource": 0,
				"distance": 12500
			},
			{
				"from": "Episcopia Bihor",
				"to": "Oradea",
				"leavesAt": "16:07",
				"arrivesAt": "16:15",
				"waitsAtSource": 900,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4509",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:14",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "12:15",
				"arrivesAt": "12:21",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "12:29",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "12:33",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "12:38",
				"arrivesAt": "12:44",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "12:51",
				"arrivesAt": "13:00",
				"waitsAtSource": 420,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Arcuş h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:08",
				"waitsAtSource": 240,
				"distance": 5000
			},
			{
				"from": "Arcuş h.",
				"to": "Bodoc Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Bodoc Hm.",
				"to": "Malnaş h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Malnaş h.",
				"to": "Malnaş Băi",
				"leavesAt": "13:23",
				"arrivesAt": "13:29",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Malnaş Băi",
				"to": "Bicsadu Oltului Hm.",
				"leavesAt": "13:30",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Bicsadu Oltului Hm.",
				"to": "Băile Tuşnad Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băile Tuşnad Hm.",
				"to": "Tuşnad Sat",
				"leavesAt": "13:49",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Tuşnad Sat",
				"to": "Vrabia h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Vrabia h.",
				"to": "Sânsimion Hm.",
				"leavesAt": "14:01",
				"arrivesAt": "14:07",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Sânsimion Hm.",
				"to": "Sântimbru Ciuc h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sântimbru Ciuc h.",
				"to": "Sâncrăieni Hm.",
				"leavesAt": "14:12",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sâncrăieni Hm.",
				"to": "Miercurea Ciuc",
				"leavesAt": "14:17",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Miercurea Ciuc",
				"to": "Siculeni",
				"leavesAt": "14:28",
				"arrivesAt": "14:36",
				"waitsAtSource": 180,
				"distance": 8200
			},
			{
				"from": "Siculeni",
				"to": "Racu h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:43",
				"waitsAtSource": 240,
				"distance": 2200
			},
			{
				"from": "Racu h.",
				"to": "Mădăraş Ciuc Hm.",
				"leavesAt": "14:44",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Mădăraş Ciuc Hm.",
				"to": "Dăneşti h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Dăneşti h.",
				"to": "Cârţani h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Cârţani h.",
				"to": "Tomeşti h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Tomeşti h.",
				"to": "Izvoru Oltului",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Izvoru Oltului",
				"to": "Sândominic h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:14",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sândominic h.",
				"to": "Izvoru Mureşului Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 7800
			},
			{
				"from": "Izvoru Mureşului Hm.",
				"to": "Voşlăbeni Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:44",
				"waitsAtSource": 420,
				"distance": 10100
			},
			{
				"from": "Voşlăbeni Hm.",
				"to": "Şugău h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Şugău h.",
				"to": "Valea Strâmbă h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Valea Strâmbă h.",
				"to": "Gheorgheni",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4530",
		"segments": [
			{
				"from": "Războieni",
				"to": "Lunca Mureşului h.",
				"leavesAt": "03:35",
				"arrivesAt": "03:40",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "03:41",
				"arrivesAt": "03:45",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Cheţani h.",
				"leavesAt": "03:46",
				"arrivesAt": "03:53",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cheţani h.",
				"to": "Luduş",
				"leavesAt": "03:54",
				"arrivesAt": "04:02",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Luduş",
				"to": "Bogata Mureş h.",
				"leavesAt": "04:09",
				"arrivesAt": "04:14",
				"waitsAtSource": 420,
				"distance": 2700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Cuci h.",
				"leavesAt": "04:15",
				"arrivesAt": "04:21",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cuci h.",
				"to": "Iernut",
				"leavesAt": "04:22",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Iernut",
				"to": "Cipău h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:34",
				"waitsAtSource": 120,
				"distance": 4100
			},
			{
				"from": "Cipău h.",
				"to": "Ogra h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:38",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ogra h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:43",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Chirileu h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chirileu h.",
				"to": "Vidrasău h.",
				"leavesAt": "04:49",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vidrasău h.",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "04:54",
				"arrivesAt": "04:59",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "05:00",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "Azomureş h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş",
				"leavesAt": "05:09",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Târgu Mureş",
				"to": "Târgu Mureş Nord Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:26",
				"waitsAtSource": 240,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5425",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:50",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:55",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "06:56",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "07:02",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "07:12",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "07:17",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:33",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "07:41",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani Triaj",
				"leavesAt": "08:02",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Paşcani Triaj",
				"to": "Paşcani",
				"leavesAt": "08:08",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "08:41",
				"arrivesAt": "08:55",
				"waitsAtSource": 1560,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "08:56",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "09:30",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "09:37",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "09:44",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "09:52",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2466",
		"segments": [
			{
				"from": "Podu Olt",
				"to": "Turnu Roşu hc.",
				"leavesAt": "20:10",
				"arrivesAt": "20:15",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Turnu Roşu hc.",
				"to": "Valea Mărului Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Valea Mărului Hm.",
				"to": "Râu Vadului h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Râu Vadului h.",
				"to": "Câineni",
				"leavesAt": "20:41",
				"arrivesAt": "20:50",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Câineni",
				"to": "Robeşti h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Robeşti h.",
				"to": "Balota h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Balota h.",
				"to": "Cornet Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:09",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Cornet Hm.",
				"to": "Beţel h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Beţel h.",
				"to": "Lotru",
				"leavesAt": "21:15",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Lotru",
				"to": "Cozia Hm.",
				"leavesAt": "21:23",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cozia Hm.",
				"to": "Mânăstirea Turnu h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mânăstirea Turnu h.",
				"to": "Păuşa h.",
				"leavesAt": "21:38",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Păuşa h.",
				"to": "Călimăneşti",
				"leavesAt": "21:44",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Călimăneşti",
				"to": "Dăeşti Hm.",
				"leavesAt": "21:50",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Dăeşti Hm.",
				"to": "Bujoreni Vâlcea Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Bujoreni Vâlcea Hm.",
				"to": "Râmnicu Vâlcea Nord h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râmnicu Vâlcea Nord h.",
				"to": "Râmnicu Vâlcea",
				"leavesAt": "22:13",
				"arrivesAt": "22:16",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 480
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9106",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:07",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "15:08",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "15:14",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "15:19",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:27",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Podu Rizii h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Podu Rizii h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "15:38",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Boteni h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:49",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Boteni h.",
				"to": "Conţeşti h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Conţeşti h.",
				"to": "Ghergani Hm.",
				"leavesAt": "15:54",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Bâldana h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 600,
				"distance": 5800
			},
			{
				"from": "Bâldana h.",
				"to": "Ciocăneşti Hm.",
				"leavesAt": "16:16",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Ciocăneşti Hm.",
				"to": "Sabareni",
				"leavesAt": "16:24",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 8500
			},
			{
				"from": "Sabareni",
				"to": "Chitila",
				"leavesAt": "16:33",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Chitila",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "16:41",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "16:44",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "16:51",
				"arrivesAt": "16:53",
				"waitsAtSource": 240,
				"distance": 1900
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Bucureşti Basarab",
				"leavesAt": "16:57",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 1500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1857",
		"segments": [
			{
				"from": "Mărăşeşti",
				"to": "Adjud",
				"leavesAt": "03:40",
				"arrivesAt": "04:06",
				"waitsAtSource": 0,
				"distance": 25700
			},
			{
				"from": "Adjud",
				"to": "Bacău",
				"leavesAt": "04:07",
				"arrivesAt": "04:44",
				"waitsAtSource": 60,
				"distance": 58200
			},
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "04:46",
				"arrivesAt": "05:15",
				"waitsAtSource": 120,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Paşcani",
				"leavesAt": "05:17",
				"arrivesAt": "05:46",
				"waitsAtSource": 120,
				"distance": 40200
			},
			{
				"from": "Paşcani",
				"to": "Dolhasca",
				"leavesAt": "05:49",
				"arrivesAt": "06:09",
				"waitsAtSource": 180,
				"distance": 21200
			},
			{
				"from": "Dolhasca",
				"to": "Vereşti",
				"leavesAt": "06:10",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 24600
			},
			{
				"from": "Vereşti",
				"to": "Suceava",
				"leavesAt": "06:27",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 14800
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "06:40",
				"arrivesAt": "06:46",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4363",
		"segments": [
			{
				"from": "Carei",
				"to": "Tiream h.",
				"leavesAt": "12:24",
				"arrivesAt": "12:35",
				"waitsAtSource": 0,
				"distance": 11700
			},
			{
				"from": "Tiream h.",
				"to": "Hotoan h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Hotoan h.",
				"to": "Santău h.",
				"leavesAt": "12:43",
				"arrivesAt": "12:48",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Santău h.",
				"to": "Tăşnad",
				"leavesAt": "12:49",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tăşnad",
				"to": "Săcăşeni h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Săcăşeni h.",
				"to": "Acâş Hm.",
				"leavesAt": "13:03",
				"arrivesAt": "13:13",
				"waitsAtSource": 30,
				"distance": 10000
			},
			{
				"from": "Acâş Hm.",
				"to": "Supur Haltă hc.",
				"leavesAt": "13:14",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Supur Haltă hc.",
				"to": "Supur h.",
				"leavesAt": "13:23",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Supur h.",
				"to": "Giorocuţa h.",
				"leavesAt": "13:26",
				"arrivesAt": "13:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Giorocuţa h.",
				"to": "Derşida h.",
				"leavesAt": "13:30",
				"arrivesAt": "13:36",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Derşida h.",
				"to": "Sărmăşag h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:40",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Sărmăşag h.",
				"to": "Sărmăşag",
				"leavesAt": "13:41",
				"arrivesAt": "13:47",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Sărmăşag",
				"to": "Câmpia Sălaj h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Câmpia Sălaj h.",
				"to": "Bocşa Sălaj h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bocşa Sălaj h.",
				"to": "Borla Hm.",
				"leavesAt": "14:02",
				"arrivesAt": "14:07",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Borla Hm.",
				"to": "Guruslău h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Guruslău h.",
				"to": "Zalău Nord",
				"leavesAt": "14:14",
				"arrivesAt": "14:23",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Zalău Nord",
				"to": "Mirşid Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:47",
				"waitsAtSource": 420,
				"distance": 12000
			},
			{
				"from": "Mirşid Hm.",
				"to": "Poptelec h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:54",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Poptelec h.",
				"to": "Cuceu Sălaj h.",
				"leavesAt": "14:55",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Cuceu Sălaj h.",
				"to": "Jibou",
				"leavesAt": "15:01",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 5100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "6406",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "17:10",
				"arrivesAt": "17:17",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "17:46",
				"arrivesAt": "17:53",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "17:54",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:18",
				"waitsAtSource": 300,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "18:19",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Bârzeşti h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bârzeşti h.",
				"to": "Brăhăşoaia h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Brăhăşoaia h.",
				"to": "Bălteni Hm.",
				"leavesAt": "18:37",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bălteni Hm.",
				"to": "Vaslui",
				"leavesAt": "18:43",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Vaslui",
				"to": "Munteni Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Munteni Hm.",
				"to": "Bulboaca h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bulboaca h.",
				"to": "Crasna",
				"leavesAt": "19:04",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Crasna",
				"to": "Roşieşti hc.",
				"leavesAt": "19:12",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Roşieşti hc.",
				"to": "Dodeşti hc.",
				"leavesAt": "19:21",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Dodeşti hc.",
				"to": "Banca Hm.",
				"leavesAt": "19:28",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Banca Hm.",
				"to": "Zorleni",
				"leavesAt": "19:35",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Zorleni",
				"to": "Bârlad",
				"leavesAt": "19:46",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 7300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5025",
		"segments": [
			{
				"from": "Bucureşti Basarab",
				"to": "Bucureşti Basarab h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:54",
				"waitsAtSource": 0,
				"distance": 1500
			},
			{
				"from": "Bucureşti Basarab h.",
				"to": "Carpaţi h. (IIIK)",
				"leavesAt": "19:55",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Carpaţi h. (IIIK)",
				"to": "Pajura Hm. (IIIK)",
				"leavesAt": "19:57",
				"arrivesAt": "20:00",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Pajura Hm. (IIIK)",
				"to": "Depoul Buc.Triaj h. (IIIK)",
				"leavesAt": "20:01",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Depoul Buc.Triaj h. (IIIK)",
				"to": "Chitila",
				"leavesAt": "20:04",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Chitila",
				"to": "Buftea",
				"leavesAt": "20:08",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "20:20",
				"arrivesAt": "20:27",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "20:33",
				"arrivesAt": "20:38",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "20:39",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Prahova h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Prahova h.",
				"to": "Brazi",
				"leavesAt": "20:49",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "20:58",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4534",
		"segments": [
			{
				"from": "Războieni",
				"to": "Lunca Mureşului h.",
				"leavesAt": "11:52",
				"arrivesAt": "11:57",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Lunca Mureşului h.",
				"to": "Gura Arieşului h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Gura Arieşului h.",
				"to": "Gligoreşti Hm.",
				"leavesAt": "12:03",
				"arrivesAt": "12:08",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Gligoreşti Hm.",
				"to": "Cheţani h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:13",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Cheţani h.",
				"to": "Luduş",
				"leavesAt": "12:14",
				"arrivesAt": "12:22",
				"waitsAtSource": 30,
				"distance": 6300
			},
			{
				"from": "Luduş",
				"to": "Bogata Mureş h.",
				"leavesAt": "12:29",
				"arrivesAt": "12:33",
				"waitsAtSource": 420,
				"distance": 2700
			},
			{
				"from": "Bogata Mureş h.",
				"to": "Cuci h.",
				"leavesAt": "12:34",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cuci h.",
				"to": "Iernut",
				"leavesAt": "12:40",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Iernut",
				"to": "Cipău h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:51",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Cipău h.",
				"to": "Ogra h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ogra h.",
				"to": "Sânpaul Hm.",
				"leavesAt": "12:56",
				"arrivesAt": "13:00",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Sânpaul Hm.",
				"to": "Chirileu h.",
				"leavesAt": "13:01",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Chirileu h.",
				"to": "Vidrasău h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:10",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Vidrasău h.",
				"to": "G-ral N. Dăscălescu Hm.",
				"leavesAt": "13:11",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "G-ral N. Dăscălescu Hm.",
				"to": "Târgu Mureş Sud",
				"leavesAt": "13:17",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Târgu Mureş Sud",
				"to": "Azomureş h.",
				"leavesAt": "13:22",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Azomureş h.",
				"to": "Târgu Mureş",
				"leavesAt": "13:26",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4111",
		"segments": [
			{
				"from": "Sighetu Marmaţiei",
				"to": "Cămara Sighet Hm.",
				"leavesAt": "01:00",
				"arrivesAt": "01:05",
				"waitsAtSource": 0,
				"distance": 1900
			},
			{
				"from": "Cămara Sighet Hm.",
				"to": "Tisa h.",
				"leavesAt": "01:06",
				"arrivesAt": "01:13",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tisa h.",
				"to": "Crăciuneşti h.",
				"leavesAt": "01:14",
				"arrivesAt": "01:17",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Crăciuneşti h.",
				"to": "Bocicoi  Hm.",
				"leavesAt": "01:18",
				"arrivesAt": "01:24",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bocicoi  Hm.",
				"to": "Lunca la Tisa h.",
				"leavesAt": "01:25",
				"arrivesAt": "01:29",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Lunca la Tisa h.",
				"to": "Valea Vişeului",
				"leavesAt": "01:30",
				"arrivesAt": "01:48",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Valea Vişeului",
				"to": "Vişeu Bistra h.",
				"leavesAt": "02:08",
				"arrivesAt": "02:22",
				"waitsAtSource": 1200,
				"distance": 8500
			},
			{
				"from": "Vişeu Bistra h.",
				"to": "Petrova hc.",
				"leavesAt": "02:23",
				"arrivesAt": "02:32",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Petrova hc.",
				"to": "Leordina",
				"leavesAt": "02:33",
				"arrivesAt": "02:44",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Leordina",
				"to": "Leordina h.",
				"leavesAt": "02:45",
				"arrivesAt": "02:50",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Leordina h.",
				"to": "Bocicoel h.",
				"leavesAt": "02:51",
				"arrivesAt": "02:59",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Bocicoel h.",
				"to": "Vişeu de Jos",
				"leavesAt": "03:00",
				"arrivesAt": "03:05",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Vişeu de Jos",
				"to": "Iza P.M.",
				"leavesAt": "03:15",
				"arrivesAt": "03:27",
				"waitsAtSource": 600,
				"distance": 8600
			},
			{
				"from": "Iza P.M.",
				"to": "Săcel Hm.",
				"leavesAt": "03:28",
				"arrivesAt": "03:38",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Săcel Hm.",
				"to": "Dealu Ştefăniţei",
				"leavesAt": "03:39",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dealu Ştefăniţei",
				"to": "Romuli h.",
				"leavesAt": "03:51",
				"arrivesAt": "04:00",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Romuli h.",
				"to": "Fiad Hm.",
				"leavesAt": "04:01",
				"arrivesAt": "04:11",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Fiad Hm.",
				"to": "Fiezel h.",
				"leavesAt": "04:12",
				"arrivesAt": "04:18",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Fiezel h.",
				"to": "Telciu Hm.",
				"leavesAt": "04:19",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Telciu Hm.",
				"to": "Bichigiu h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:32",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Bichigiu h.",
				"to": "Coşbuc Hm.",
				"leavesAt": "04:33",
				"arrivesAt": "04:37",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Coşbuc Hm.",
				"to": "Salva",
				"leavesAt": "04:38",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Salva",
				"to": "Mititei h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:14",
				"waitsAtSource": 1200,
				"distance": 2200
			},
			{
				"from": "Mititei h.",
				"to": "Nimigea Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Nimigea Hm.",
				"to": "Nimigea h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Nimigea h.",
				"to": "Mogoşeni Hm.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Mogoşeni Hm.",
				"to": "Cociu h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cociu h.",
				"to": "Beclean pe Someş",
				"leavesAt": "05:35",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Beclean pe Someş",
				"to": "Coldău Hm.",
				"leavesAt": "05:46",
				"arrivesAt": "05:56",
				"waitsAtSource": 120,
				"distance": 5100
			},
			{
				"from": "Coldău Hm.",
				"to": "Ciceu Cristur h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ciceu Cristur h.",
				"to": "Reteag h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:04",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Reteag h.",
				"to": "Reteag Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Reteag Hm.",
				"to": "Ciceu Mihăeşti h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Ciceu Mihăeşti h.",
				"to": "Dej Triaj",
				"leavesAt": "06:15",
				"arrivesAt": "06:21",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Dej Triaj",
				"to": "Dej Călători",
				"leavesAt": "06:22",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Dej Călători",
				"to": "Nima h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:46",
				"waitsAtSource": 540,
				"distance": 5800
			},
			{
				"from": "Nima h.",
				"to": "Gherla",
				"leavesAt": "06:47",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Gherla",
				"to": "Livada Someş h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Livada Someş h.",
				"to": "Iclod Hm.",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Iclod Hm.",
				"to": "Fundătura h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Fundătura h.",
				"to": "Bonţida Hm.",
				"leavesAt": "07:16",
				"arrivesAt": "07:21",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bonţida Hm.",
				"to": "Răscruci h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Răscruci h.",
				"to": "Jucu Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:31",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Jucu Hm.",
				"to": "Apahida",
				"leavesAt": "07:32",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 8900
			},
			{
				"from": "Apahida",
				"to": "Cluj Napoca Est",
				"leavesAt": "07:43",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cluj Napoca Est",
				"to": "Clujana h.",
				"leavesAt": "07:53",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Clujana h.",
				"to": "Cluj Napoca",
				"leavesAt": "07:59",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1851",
		"segments": [
			{
				"from": "Bacău",
				"to": "Roman",
				"leavesAt": "18:20",
				"arrivesAt": "18:51",
				"waitsAtSource": 0,
				"distance": 43800
			},
			{
				"from": "Roman",
				"to": "Târgu Frumos",
				"leavesAt": "18:53",
				"arrivesAt": "19:49",
				"waitsAtSource": 120,
				"distance": 69200
			},
			{
				"from": "Târgu Frumos",
				"to": "Iaşi",
				"leavesAt": "19:50",
				"arrivesAt": "20:25",
				"waitsAtSource": 60,
				"distance": 44900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9594",
		"segments": [
			{
				"from": "Jimbolia",
				"to": "Clarii Vii h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 0,
				"distance": 6300
			},
			{
				"from": "Clarii Vii h.",
				"to": "Cărpiniş",
				"leavesAt": "17:47",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Cărpiniş",
				"to": "Beregsău hcv.",
				"leavesAt": "17:56",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Beregsău hcv.",
				"to": "Săcălaz h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Săcălaz h.",
				"to": "Timişoara Nord",
				"leavesAt": "18:12",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2024",
		"segments": [
			{
				"from": "Simeria",
				"to": "Simeria Triaj",
				"leavesAt": "19:53",
				"arrivesAt": "20:00",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Simeria Triaj",
				"to": "Băcia Hm.",
				"leavesAt": "20:01",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Băcia Hm.",
				"to": "Călan Băi",
				"leavesAt": "20:06",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Băi",
				"to": "Călan Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Călan Hm.",
				"to": "Bretea Streiului Hm.",
				"leavesAt": "20:16",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Bretea Streiului Hm.",
				"to": "Subcetate",
				"leavesAt": "20:27",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Subcetate",
				"to": "Băeşti Hm.",
				"leavesAt": "20:35",
				"arrivesAt": "20:43",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Băeşti Hm.",
				"to": "Ruşor h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ruşor h.",
				"to": "Pui",
				"leavesAt": "20:47",
				"arrivesAt": "20:52",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Pui",
				"to": "Livadia h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Livadia h.",
				"to": "Baru Mare",
				"leavesAt": "20:58",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Baru Mare",
				"to": "Baru Mare h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Baru Mare h.",
				"to": "Crivadia Hm.",
				"leavesAt": "21:12",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Crivadia Hm.",
				"to": "Merişor Hm.",
				"leavesAt": "21:19",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Merişor Hm.",
				"to": "Băniţa",
				"leavesAt": "21:29",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Băniţa",
				"to": "Peştera Bolii h.",
				"leavesAt": "21:42",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Peştera Bolii h.",
				"to": "Dep Petroşani h.",
				"leavesAt": "21:49",
				"arrivesAt": "21:54",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Dep Petroşani h.",
				"to": "Petroşani",
				"leavesAt": "21:55",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Petroşani",
				"to": "Lunca Jiului hc.",
				"leavesAt": "22:25",
				"arrivesAt": "22:28",
				"waitsAtSource": 1620,
				"distance": 2200
			},
			{
				"from": "Lunca Jiului hc.",
				"to": "Livezeni",
				"leavesAt": "22:29",
				"arrivesAt": "22:34",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Livezeni",
				"to": "Strâmbuţa Hm.",
				"leavesAt": "22:35",
				"arrivesAt": "22:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strâmbuţa Hm.",
				"to": "Lainici Hm.",
				"leavesAt": "22:42",
				"arrivesAt": "23:01",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Lainici Hm.",
				"to": "Meri",
				"leavesAt": "23:06",
				"arrivesAt": "23:16",
				"waitsAtSource": 300,
				"distance": 6400
			},
			{
				"from": "Meri",
				"to": "Valea Sadului Hm.",
				"leavesAt": "23:17",
				"arrivesAt": "23:25",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Valea Sadului Hm.",
				"to": "Bumbeşti Hm.",
				"leavesAt": "23:26",
				"arrivesAt": "23:31",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bumbeşti Hm.",
				"to": "Parângu Hm.",
				"leavesAt": "23:32",
				"arrivesAt": "23:39",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Parângu Hm.",
				"to": "Ecaterina Teodoroiu",
				"leavesAt": "23:40",
				"arrivesAt": "23:46",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Ecaterina Teodoroiu",
				"to": "Ramificaţia C.A.M. h.",
				"leavesAt": "23:47",
				"arrivesAt": "23:50",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ramificaţia C.A.M. h.",
				"to": "Târgu Jiu",
				"leavesAt": "23:51",
				"arrivesAt": "23:55",
				"waitsAtSource": 30,
				"distance": 800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9554",
		"segments": [
			{
				"from": "Caransebeş",
				"to": "Caransebeş haltă h.",
				"leavesAt": "13:28",
				"arrivesAt": "13:30",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Caransebeş haltă h.",
				"to": "Balta Sărată",
				"leavesAt": "13:31",
				"arrivesAt": "13:35",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balta Sărată",
				"to": "Valea Timişului Hm.",
				"leavesAt": "13:36",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Valea Timişului Hm.",
				"to": "Petroşniţa h.",
				"leavesAt": "13:41",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Petroşniţa h.",
				"to": "Vălişoara Hm.",
				"leavesAt": "13:45",
				"arrivesAt": "13:52",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălişoara Hm.",
				"to": "Slatina Timiş",
				"leavesAt": "13:53",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Slatina Timiş",
				"to": "Armeniş",
				"leavesAt": "14:00",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Armeniş",
				"to": "Teregova Hm.",
				"leavesAt": "14:08",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Teregova Hm.",
				"to": "Poarta Hm.",
				"leavesAt": "14:16",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Poarta Hm.",
				"to": "Luncaviţa h.",
				"leavesAt": "14:26",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Luncaviţa h.",
				"to": "Domaşnea Cornea Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Domaşnea Cornea Hm.",
				"to": "Cornea h.",
				"leavesAt": "14:38",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cornea h.",
				"to": "Cruşovăţ",
				"leavesAt": "14:44",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Cruşovăţ",
				"to": "Iablaniţa",
				"leavesAt": "14:52",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Iablaniţa",
				"to": "Mehadia Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Mehadia Hm.",
				"to": "Mehadia Nouă Hm.",
				"leavesAt": "15:13",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Mehadia Nouă Hm.",
				"to": "Băile Herculane",
				"leavesAt": "15:18",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Băile Herculane",
				"to": "Topleţ Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:31",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Topleţ Hm.",
				"to": "Valea Cernei Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Valea Cernei Hm.",
				"to": "Orşova",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 5700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9012",
		"segments": [
			{
				"from": "Craiova",
				"to": "Bordei hc.(901)",
				"leavesAt": "19:25",
				"arrivesAt": "19:29",
				"waitsAtSource": 0,
				"distance": 1700
			},
			{
				"from": "Bordei hc.(901)",
				"to": "Plaiu Vulcăneşti Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Plaiu Vulcăneşti Hm.",
				"to": "Cârcea h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cârcea h.",
				"to": "Pieleşti Hm.",
				"leavesAt": "19:41",
				"arrivesAt": "19:50",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Pieleşti Hm.",
				"to": "Toporaş h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:01",
				"waitsAtSource": 480,
				"distance": 2300
			},
			{
				"from": "Toporaş h.",
				"to": "Robăneşti Hm.",
				"leavesAt": "20:02",
				"arrivesAt": "20:09",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Robăneşti Hm.",
				"to": "Spineni h.",
				"leavesAt": "20:10",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Spineni h.",
				"to": "Balş",
				"leavesAt": "20:17",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Balş",
				"to": "Canton 217 h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Canton 217 h.",
				"to": "Brăneţ h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Brăneţ h.",
				"to": "Piatra Olt",
				"leavesAt": "20:33",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Piatra Olt",
				"to": "Criva h.",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 780,
				"distance": 4000
			},
			{
				"from": "Criva h.",
				"to": "Slătioara Hm.",
				"leavesAt": "21:01",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Slătioara Hm.",
				"to": "Milcov Hm.",
				"leavesAt": "21:11",
				"arrivesAt": "21:19",
				"waitsAtSource": 300,
				"distance": 4600
			},
			{
				"from": "Milcov Hm.",
				"to": "Slatina",
				"leavesAt": "21:20",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Slatina",
				"to": "Recea Hm.",
				"leavesAt": "21:28",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Recea Hm.",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "21:38",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Potcoava",
				"leavesAt": "21:48",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Potcoava",
				"to": "Sineşti Hm.",
				"leavesAt": "21:58",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sineşti Hm.",
				"to": "Corbu",
				"leavesAt": "22:06",
				"arrivesAt": "22:13",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Corbu",
				"to": "Hârseşti Hm.",
				"leavesAt": "22:14",
				"arrivesAt": "22:20",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "22:21",
				"arrivesAt": "22:27",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Stolnici Hm.",
				"to": "Fâlfani Hm.",
				"leavesAt": "22:28",
				"arrivesAt": "22:38",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Costeşti",
				"leavesAt": "22:39",
				"arrivesAt": "22:48",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Costeşti",
				"to": "Pârvu h.",
				"leavesAt": "22:49",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Pârvu h.",
				"to": "Bradu de Sus",
				"leavesAt": "22:59",
				"arrivesAt": "23:16",
				"waitsAtSource": 30,
				"distance": 9700
			},
			{
				"from": "Bradu de Sus",
				"to": "Km. 109+000 h.",
				"leavesAt": "23:17",
				"arrivesAt": "23:21",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Km. 109+000 h.",
				"to": "Piteşti",
				"leavesAt": "23:22",
				"arrivesAt": "23:25",
				"waitsAtSource": 30,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 351
			},
			{
				"from": "20180409",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 351
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4049",
		"segments": [
			{
				"from": "Jibou",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "20:03",
				"waitsAtSource": 0,
				"distance": 9300
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Inău h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Inău h.",
				"to": "Aluniş Sălaj h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aluniş Sălaj h.",
				"to": "Benesat Hm.",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Benesat Hm.",
				"to": "Ţicău h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:33",
				"waitsAtSource": 540,
				"distance": 6600
			},
			{
				"from": "Ţicău h.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "20:34",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Mireşu Mare PM.",
				"leavesAt": "20:39",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Fersig h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Fersig h.",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "20:53",
				"arrivesAt": "20:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Baia Mare",
				"leavesAt": "20:59",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 14600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9667",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "16:32",
				"arrivesAt": "16:42",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişeni Hm.",
				"leavesAt": "16:43",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "16:52",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "17:00",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "17:07",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Deta Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Deta Hm.",
				"to": "Denta h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Denta h.",
				"to": "Stamora Moraviţa",
				"leavesAt": "17:36",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 8400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4402",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:46",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "05:47",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "06:04",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180408",
				"daysOfWeek": 319
			},
			{
				"from": "20180410",
				"to": "20180430",
				"daysOfWeek": 319
			},
			{
				"from": "20180502",
				"to": "20180527",
				"daysOfWeek": 319
			},
			{
				"from": "20180529",
				"to": "20180531",
				"daysOfWeek": 319
			},
			{
				"from": "20180602",
				"to": "20181129",
				"daysOfWeek": 319
			},
			{
				"from": "20181202",
				"to": "20181208",
				"daysOfWeek": 319
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 319
			},
			{
				"from": "20171227",
				"to": "20171231",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3531",
		"segments": [
			{
				"from": "Braşov",
				"to": "Stupini Hm.",
				"leavesAt": "07:50",
				"arrivesAt": "07:59",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Stupini Hm.",
				"to": "Bod Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Bod Hm.",
				"to": "Feldioara Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Feldioara Hm.",
				"to": "Rotbav h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Rotbav h.",
				"to": "Vadu Roşu h.",
				"leavesAt": "08:24",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Vadu Roşu h.",
				"to": "Măieruş h.",
				"leavesAt": "08:29",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Măieruş h.",
				"to": "Apaţa",
				"leavesAt": "08:33",
				"arrivesAt": "08:45",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Apaţa",
				"to": "Ormeniş h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Ormeniş h.",
				"to": "Augustin Hm.",
				"leavesAt": "08:53",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 7100
			},
			{
				"from": "Augustin Hm.",
				"to": "Racoş Hm.",
				"leavesAt": "09:07",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Racoş Hm.",
				"to": "Mateiaş h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mateiaş h.",
				"to": "Rupea",
				"leavesAt": "09:29",
				"arrivesAt": "09:45",
				"waitsAtSource": 30,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "2870",
		"segments": [
			{
				"from": "Târgu Jiu",
				"to": "Amaradia",
				"leavesAt": "06:20",
				"arrivesAt": "06:27",
				"waitsAtSource": 0,
				"distance": 6100
			},
			{
				"from": "Amaradia",
				"to": "Cârbeşti Hm.",
				"leavesAt": "06:28",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Cârbeşti Hm.",
				"to": "Rogojelu",
				"leavesAt": "06:35",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Rogojelu",
				"to": "Km. 49+800 h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Km. 49+800 h.",
				"to": "Rovinari Hm.",
				"leavesAt": "06:48",
				"arrivesAt": "06:51",
				"waitsAtSource": 120,
				"distance": 1000
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180407",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180526",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171224",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1750",
		"segments": [
			{
				"from": "Suceava",
				"to": "Paşcani",
				"leavesAt": "05:20",
				"arrivesAt": "06:03",
				"waitsAtSource": 0,
				"distance": 60600
			},
			{
				"from": "Paşcani",
				"to": "Roman",
				"leavesAt": "06:04",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 40200
			},
			{
				"from": "Roman",
				"to": "Bacău",
				"leavesAt": "06:32",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 43800
			},
			{
				"from": "Bacău",
				"to": "Adjud",
				"leavesAt": "07:02",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 58200
			},
			{
				"from": "Adjud",
				"to": "Focşani",
				"leavesAt": "07:42",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 45400
			},
			{
				"from": "Focşani",
				"to": "Buzău",
				"leavesAt": "08:29",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 70800
			},
			{
				"from": "Buzău",
				"to": "Ploieşti Sud",
				"leavesAt": "09:36",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 68600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "10:42",
				"arrivesAt": "11:31",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "3111",
		"segments": [
			{
				"from": "Arad",
				"to": "Utviniş h.",
				"leavesAt": "03:20",
				"arrivesAt": "03:33",
				"waitsAtSource": 0,
				"distance": 9600
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "03:34",
				"arrivesAt": "03:38",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "03:39",
				"arrivesAt": "03:51",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Comlăuş h.",
				"leavesAt": "03:52",
				"arrivesAt": "03:57",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Comlăuş h.",
				"to": "Şimand Hm.",
				"leavesAt": "03:58",
				"arrivesAt": "04:06",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şimand Hm.",
				"to": "Nădab",
				"leavesAt": "04:07",
				"arrivesAt": "04:15",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Nădab",
				"to": "Chişineu Criş",
				"leavesAt": "04:35",
				"arrivesAt": "04:41",
				"waitsAtSource": 1200,
				"distance": 4900
			},
			{
				"from": "Chişineu Criş",
				"to": "Zerind Hm.",
				"leavesAt": "04:42",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Zerind Hm.",
				"to": "Tămaşda h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Tămaşda h.",
				"to": "Boiu Bihor h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Boiu Bihor h.",
				"to": "Ciumeghiu Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Ciumeghiu Hm.",
				"to": "Salonta",
				"leavesAt": "05:25",
				"arrivesAt": "05:39",
				"waitsAtSource": 540,
				"distance": 10200
			},
			{
				"from": "Salonta",
				"to": "Mădăraş Bihor h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 600,
				"distance": 3200
			},
			{
				"from": "Mădăraş Bihor h.",
				"to": "Cefa Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 9300
			},
			{
				"from": "Cefa Hm.",
				"to": "Leş Bihor Hm.",
				"leavesAt": "06:03",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Leş Bihor Hm.",
				"to": "Oradea Vest Hm.",
				"leavesAt": "06:14",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Oradea Vest Hm.",
				"to": "Oradea",
				"leavesAt": "06:30",
				"arrivesAt": "06:38",
				"waitsAtSource": 300,
				"distance": 5500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4096",
		"segments": [
			{
				"from": "Baia Mare",
				"to": "Satulung pe Someş Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "09:03",
				"waitsAtSource": 0,
				"distance": 14600
			},
			{
				"from": "Satulung pe Someş Hm.",
				"to": "Fersig h.",
				"leavesAt": "09:14",
				"arrivesAt": "09:19",
				"waitsAtSource": 660,
				"distance": 4300
			},
			{
				"from": "Fersig h.",
				"to": "Mireşu Mare PM.",
				"leavesAt": "09:20",
				"arrivesAt": "09:26",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Mireşu Mare PM.",
				"to": "Ulmeni Sălaj",
				"leavesAt": "09:27",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Ulmeni Sălaj",
				"to": "Benesat Hm.",
				"leavesAt": "09:35",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Benesat Hm.",
				"to": "Someş Odorhei Hm.",
				"leavesAt": "09:45",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Someş Odorhei Hm.",
				"to": "Jibou",
				"leavesAt": "09:55",
				"arrivesAt": "10:05",
				"waitsAtSource": 60,
				"distance": 9300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "7576",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Fileşti Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "19:58",
				"waitsAtSource": 0,
				"distance": 6800
			},
			{
				"from": "Fileşti Hm.",
				"to": "Barboşi",
				"leavesAt": "19:59",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Barboşi",
				"to": "Barboşi Triaj h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Barboşi Triaj h.",
				"to": "Şendreni Hm.",
				"leavesAt": "20:11",
				"arrivesAt": "20:15",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Şendreni Hm.",
				"to": "Şerbeştii Vechi h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Şerbeştii Vechi h.",
				"to": "Braniştea h.",
				"leavesAt": "20:21",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Braniştea h.",
				"to": "Vasile Alecsandri h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vasile Alecsandri h.",
				"to": "Independenţa Hm.",
				"leavesAt": "20:30",
				"arrivesAt": "20:35",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Independenţa Hm.",
				"to": "Piscu h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Piscu h.",
				"to": "Vameş h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vameş h.",
				"to": "Tudor Vladimirescu hc.",
				"leavesAt": "20:48",
				"arrivesAt": "20:54",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Tudor Vladimirescu hc.",
				"to": "Hanu Conachi Hm.",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Hanu Conachi Hm.",
				"to": "Şerbăneşti h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Şerbăneşti h.",
				"to": "Lieşti",
				"leavesAt": "21:07",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lieşti",
				"to": "Buceşti h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Buceşti h.",
				"to": "Iveşti Hm.",
				"leavesAt": "21:16",
				"arrivesAt": "21:20",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Iveşti Hm.",
				"to": "Umbrăreşti h.",
				"leavesAt": "21:21",
				"arrivesAt": "21:25",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Umbrăreşti h.",
				"to": "Barcea",
				"leavesAt": "21:26",
				"arrivesAt": "21:32",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Barcea",
				"to": "Malul Alb h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Malul Alb h.",
				"to": "Tecuci",
				"leavesAt": "21:37",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Tecuci",
				"to": "Cosmeşti Hm.",
				"leavesAt": "22:16",
				"arrivesAt": "22:26",
				"waitsAtSource": 1740,
				"distance": 7400
			},
			{
				"from": "Cosmeşti Hm.",
				"to": "G-ral. E. Grigorescu Hm.",
				"leavesAt": "22:27",
				"arrivesAt": "22:33",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "G-ral. E. Grigorescu Hm.",
				"to": "Mărăşeşti",
				"leavesAt": "22:34",
				"arrivesAt": "22:45",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8395",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "20:45",
				"arrivesAt": "20:58",
				"waitsAtSource": 0,
				"distance": 8600
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Eforie Nord",
				"leavesAt": "21:04",
				"arrivesAt": "21:11",
				"waitsAtSource": 360,
				"distance": 5400
			},
			{
				"from": "Eforie Nord",
				"to": "Eforie Sud",
				"leavesAt": "21:12",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Sud",
				"to": "Tuzla h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Tuzla h.",
				"to": "Costineşti",
				"leavesAt": "21:25",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Costineşti",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "21:33",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Neptun hc.",
				"leavesAt": "21:37",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Neptun hc.",
				"to": "Mangalia",
				"leavesAt": "21:46",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 6800
			}
		],
		"restrictions": [
			{
				"from": "20180102",
				"to": "20180105",
				"daysOfWeek": 383
			},
			{
				"from": "20180107",
				"to": "20180112",
				"daysOfWeek": 383
			},
			{
				"from": "20180114",
				"to": "20180119",
				"daysOfWeek": 383
			},
			{
				"from": "20180121",
				"to": "20180126",
				"daysOfWeek": 383
			},
			{
				"from": "20180128",
				"to": "20180202",
				"daysOfWeek": 383
			},
			{
				"from": "20180204",
				"to": "20180209",
				"daysOfWeek": 383
			},
			{
				"from": "20180211",
				"to": "20180216",
				"daysOfWeek": 383
			},
			{
				"from": "20180218",
				"to": "20180223",
				"daysOfWeek": 383
			},
			{
				"from": "20180225",
				"to": "20180302",
				"daysOfWeek": 383
			},
			{
				"from": "20180304",
				"to": "20180309",
				"daysOfWeek": 383
			},
			{
				"from": "20180311",
				"to": "20180316",
				"daysOfWeek": 383
			},
			{
				"from": "20180318",
				"to": "20180323",
				"daysOfWeek": 383
			},
			{
				"from": "20180325",
				"to": "20180330",
				"daysOfWeek": 383
			},
			{
				"from": "20180401",
				"to": "20180406",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180413",
				"daysOfWeek": 383
			},
			{
				"from": "20180415",
				"to": "20180420",
				"daysOfWeek": 383
			},
			{
				"from": "20180422",
				"to": "20180426",
				"daysOfWeek": 383
			},
			{
				"from": "20180502",
				"to": "20180504",
				"daysOfWeek": 383
			},
			{
				"from": "20180506",
				"to": "20180511",
				"daysOfWeek": 383
			},
			{
				"from": "20180513",
				"to": "20180518",
				"daysOfWeek": 383
			},
			{
				"from": "20180520",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180601",
				"daysOfWeek": 383
			},
			{
				"from": "20180603",
				"to": "20180607",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20180914",
				"daysOfWeek": 383
			},
			{
				"from": "20180916",
				"to": "20180921",
				"daysOfWeek": 383
			},
			{
				"from": "20180923",
				"to": "20180928",
				"daysOfWeek": 383
			},
			{
				"from": "20180930",
				"to": "20181005",
				"daysOfWeek": 383
			},
			{
				"from": "20181007",
				"to": "20181012",
				"daysOfWeek": 383
			},
			{
				"from": "20181014",
				"to": "20181019",
				"daysOfWeek": 383
			},
			{
				"from": "20181021",
				"to": "20181026",
				"daysOfWeek": 383
			},
			{
				"from": "20181028",
				"to": "20181102",
				"daysOfWeek": 383
			},
			{
				"from": "20181104",
				"to": "20181109",
				"daysOfWeek": 383
			},
			{
				"from": "20181111",
				"to": "20181116",
				"daysOfWeek": 383
			},
			{
				"from": "20181118",
				"to": "20181123",
				"daysOfWeek": 383
			},
			{
				"from": "20181125",
				"to": "20181130",
				"daysOfWeek": 383
			},
			{
				"from": "20181202",
				"to": "20181207",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171215",
				"daysOfWeek": 383
			},
			{
				"from": "20171217",
				"to": "20171222",
				"daysOfWeek": 383
			},
			{
				"from": "20171226",
				"to": "20171229",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9479",
		"segments": [
			{
				"from": "Piteşti",
				"to": "Bradu de Sus",
				"leavesAt": "23:40",
				"arrivesAt": "23:46",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bradu de Sus",
				"to": "Pârvu Hm.",
				"leavesAt": "23:47",
				"arrivesAt": "23:54",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Pârvu Hm.",
				"to": "Pârvu h.",
				"leavesAt": "23:55",
				"arrivesAt": "00:01",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Pârvu h.",
				"to": "Costeşti",
				"leavesAt": "00:02",
				"arrivesAt": "00:16",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Costeşti",
				"to": "Fâlfani Hm.",
				"leavesAt": "00:17",
				"arrivesAt": "00:26",
				"waitsAtSource": 60,
				"distance": 7900
			},
			{
				"from": "Fâlfani Hm.",
				"to": "Stolnici Hm.",
				"leavesAt": "00:27",
				"arrivesAt": "00:37",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Stolnici Hm.",
				"to": "Hârseşti Hm.",
				"leavesAt": "00:38",
				"arrivesAt": "00:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Hârseşti Hm.",
				"to": "Corbu",
				"leavesAt": "00:46",
				"arrivesAt": "00:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Corbu",
				"to": "Sineşti Hm.",
				"leavesAt": "00:54",
				"arrivesAt": "01:02",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Sineşti Hm.",
				"to": "Potcoava",
				"leavesAt": "01:03",
				"arrivesAt": "01:11",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Potcoava",
				"to": "Bâlteni Olt Hm.",
				"leavesAt": "01:12",
				"arrivesAt": "01:21",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Bâlteni Olt Hm.",
				"to": "Recea Hm.",
				"leavesAt": "01:22",
				"arrivesAt": "01:31",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Recea Hm.",
				"to": "Slatina",
				"leavesAt": "01:32",
				"arrivesAt": "01:42",
				"waitsAtSource": 60,
				"distance": 7800
			},
			{
				"from": "Slatina",
				"to": "Milcov Hm.",
				"leavesAt": "01:43",
				"arrivesAt": "01:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Milcov Hm.",
				"to": "Slătioara Hm.",
				"leavesAt": "01:52",
				"arrivesAt": "01:59",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Slătioara Hm.",
				"to": "Criva h.",
				"leavesAt": "02:00",
				"arrivesAt": "02:04",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Criva h.",
				"to": "Piatra Olt",
				"leavesAt": "02:05",
				"arrivesAt": "02:11",
				"waitsAtSource": 30,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1991",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "19:48",
				"arrivesAt": "19:55",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "20:03",
				"arrivesAt": "20:08",
				"waitsAtSource": 480,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "20:10",
				"arrivesAt": "20:23",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "20:25",
				"arrivesAt": "20:29",
				"waitsAtSource": 120,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Eforie Sud",
				"leavesAt": "20:30",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "20:47",
				"arrivesAt": "20:54",
				"waitsAtSource": 120,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Constanţa",
				"leavesAt": "20:56",
				"arrivesAt": "21:19",
				"waitsAtSource": 120,
				"distance": 14000
			},
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "21:35",
				"arrivesAt": "22:00",
				"waitsAtSource": 960,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "22:01",
				"arrivesAt": "22:20",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "22:21",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "22:44",
				"arrivesAt": "23:08",
				"waitsAtSource": 120,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Băneasa",
				"leavesAt": "23:09",
				"arrivesAt": "00:03",
				"waitsAtSource": 60,
				"distance": 102300
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Videle",
				"leavesAt": "00:05",
				"arrivesAt": "00:59",
				"waitsAtSource": 120,
				"distance": 51000
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "01:01",
				"arrivesAt": "01:48",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "01:50",
				"arrivesAt": "02:38",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "02:40",
				"arrivesAt": "03:20",
				"waitsAtSource": 120,
				"distance": 53600
			},
			{
				"from": "Craiova",
				"to": "Strehaia hc.",
				"leavesAt": "03:30",
				"arrivesAt": "04:25",
				"waitsAtSource": 600,
				"distance": 62100
			},
			{
				"from": "Strehaia hc.",
				"to": "Balota",
				"leavesAt": "04:27",
				"arrivesAt": "05:05",
				"waitsAtSource": 120,
				"distance": 32600
			},
			{
				"from": "Balota",
				"to": "Drobeta Tr. Severin",
				"leavesAt": "05:11",
				"arrivesAt": "05:45",
				"waitsAtSource": 360,
				"distance": 19000
			},
			{
				"from": "Drobeta Tr. Severin",
				"to": "Orşova",
				"leavesAt": "05:48",
				"arrivesAt": "06:22",
				"waitsAtSource": 180,
				"distance": 24000
			},
			{
				"from": "Orşova",
				"to": "Băile Herculane",
				"leavesAt": "06:23",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 17500
			},
			{
				"from": "Băile Herculane",
				"to": "Teregova Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 37900
			},
			{
				"from": "Teregova Hm.",
				"to": "Caransebeş",
				"leavesAt": "07:36",
				"arrivesAt": "08:14",
				"waitsAtSource": 360,
				"distance": 32900
			},
			{
				"from": "Caransebeş",
				"to": "Lugoj",
				"leavesAt": "08:28",
				"arrivesAt": "09:02",
				"waitsAtSource": 840,
				"distance": 39400
			},
			{
				"from": "Lugoj",
				"to": "Timişoara Nord",
				"leavesAt": "09:04",
				"arrivesAt": "09:58",
				"waitsAtSource": 120,
				"distance": 58900
			}
		],
		"restrictions": [
			{
				"from": "20180609",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5606",
		"segments": [
			{
				"from": "Suceava Nord",
				"to": "Suceava",
				"leavesAt": "12:10",
				"arrivesAt": "12:15",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava",
				"to": "Văratec",
				"leavesAt": "12:17",
				"arrivesAt": "12:24",
				"waitsAtSource": 120,
				"distance": 8200
			},
			{
				"from": "Văratec",
				"to": "Vereşti",
				"leavesAt": "12:25",
				"arrivesAt": "12:32",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Vereşti",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "12:33",
				"arrivesAt": "12:39",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Liteni Hm.",
				"leavesAt": "12:40",
				"arrivesAt": "12:46",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Liteni Hm.",
				"to": "Corni h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Corni h.",
				"to": "Dolhasca",
				"leavesAt": "12:53",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Dolhasca",
				"to": "Probota h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Probota h.",
				"to": "Lespezi Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Lespezi Hm.",
				"to": "Lunca Siretului h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Paşcani",
				"leavesAt": "13:21",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Paşcani",
				"to": "Ruginoasa Hm.",
				"leavesAt": "13:31",
				"arrivesAt": "13:45",
				"waitsAtSource": 240,
				"distance": 14700
			},
			{
				"from": "Ruginoasa Hm.",
				"to": "Costeşti Iaşi hc.",
				"leavesAt": "13:46",
				"arrivesAt": "13:53",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Costeşti Iaşi hc.",
				"to": "Pietrişu h.",
				"leavesAt": "13:54",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pietrişu h.",
				"to": "Târgu Frumos",
				"leavesAt": "14:00",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Târgu Frumos",
				"to": "Sârca Hm.",
				"leavesAt": "14:09",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 11000
			},
			{
				"from": "Sârca Hm.",
				"to": "Budăi hc.",
				"leavesAt": "14:20",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Budăi hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "14:27",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "14:34",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "14:42",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "1570",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "05:00",
				"arrivesAt": "05:19",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Brăila",
				"leavesAt": "05:20",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 19500
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "05:39",
				"arrivesAt": "06:09",
				"waitsAtSource": 120,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Făurei",
				"leavesAt": "06:10",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "06:27",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "07:07",
				"arrivesAt": "07:39",
				"waitsAtSource": 120,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "07:40",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Bucureşti Nord",
				"leavesAt": "08:17",
				"arrivesAt": "09:10",
				"waitsAtSource": 120,
				"distance": 60200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "8390",
		"segments": [
			{
				"from": "Mangalia",
				"to": "Neptun",
				"leavesAt": "16:07",
				"arrivesAt": "16:13",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Neptun",
				"to": "Neptun hc.",
				"leavesAt": "16:14",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Neptun hc.",
				"to": "Costineşti Tabără hc.",
				"leavesAt": "16:19",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Costineşti Tabără hc.",
				"to": "Costineşti",
				"leavesAt": "16:29",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Costineşti",
				"to": "Tuzla h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Tuzla h.",
				"to": "Eforie Sud",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Eforie Sud",
				"to": "Eforie Nord",
				"leavesAt": "16:47",
				"arrivesAt": "16:52",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Eforie Nord",
				"to": "Agigea Ecluză Hm.",
				"leavesAt": "17:00",
				"arrivesAt": "17:08",
				"waitsAtSource": 480,
				"distance": 5400
			},
			{
				"from": "Agigea Ecluză Hm.",
				"to": "Constanţa",
				"leavesAt": "17:09",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 8600
			}
		],
		"restrictions": [
			{
				"from": "20180502",
				"to": "20180524",
				"daysOfWeek": 383
			},
			{
				"from": "20180530",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180426",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "4404",
		"segments": [
			{
				"from": "Halmeu",
				"to": "Porumbeşti Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:46",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Porumbeşti Hm.",
				"to": "Micula Hm.",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Micula Hm.",
				"to": "Ram. Botiz h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Ram. Botiz h.",
				"to": "Satu Mare",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5731",
		"segments": [
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "02:50",
				"arrivesAt": "02:55",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Suceava Nord",
				"to": "Dărmăneşti",
				"leavesAt": "02:56",
				"arrivesAt": "03:05",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Dărmăneşti",
				"to": "Cacica Hm.",
				"leavesAt": "03:06",
				"arrivesAt": "03:42",
				"waitsAtSource": 60,
				"distance": 21300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "9442",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "06:35",
				"arrivesAt": "06:39",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Scârlenţa h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Scârlenţa h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "06:47",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Doiceşti h.",
				"to": "Doiceşti",
				"leavesAt": "06:54",
				"arrivesAt": "06:56",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Doiceşti",
				"to": "Săteni h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Săteni h.",
				"to": "Aninoasa Hm.",
				"leavesAt": "07:01",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Aninoasa Hm.",
				"to": "TEIŞ Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "07:11",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "CFR",
		"number": "5451",
		"segments": [
			{
				"from": "Bacău",
				"to": "Iteşti Hm.",
				"leavesAt": "14:43",
				"arrivesAt": "14:54",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Iteşti Hm.",
				"to": "Şerbeşti Bacău h.",
				"leavesAt": "14:55",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Şerbeşti Bacău h.",
				"to": "Galbeni",
				"leavesAt": "15:00",
				"arrivesAt": "15:05",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Galbeni",
				"to": "Săcueni Roman Hm.",
				"leavesAt": "15:06",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Săcueni Roman Hm.",
				"to": "Ram. Trifeşti",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ram. Trifeşti",
				"to": "Roman",
				"leavesAt": "15:21",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Roman",
				"to": "Săbăoani Hm.",
				"leavesAt": "15:30",
				"arrivesAt": "15:37",
				"waitsAtSource": 120,
				"distance": 8100
			},
			{
				"from": "Săbăoani Hm.",
				"to": "Mirceşti",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Mirceşti",
				"to": "Hălăuceşti hc.",
				"leavesAt": "15:45",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hălăuceşti hc.",
				"to": "Mogoşeşti hc.",
				"leavesAt": "15:50",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Mogoşeşti hc.",
				"to": "Muncel Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Muncel Hm.",
				"to": "Stolniceni h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stolniceni h.",
				"to": "Paşcani",
				"leavesAt": "16:06",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Paşcani",
				"to": "Lunca Siretului h.",
				"leavesAt": "16:29",
				"arrivesAt": "16:34",
				"waitsAtSource": 780,
				"distance": 5900
			},
			{
				"from": "Lunca Siretului h.",
				"to": "Lespezi Hm.",
				"leavesAt": "16:35",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Lespezi Hm.",
				"to": "Probota h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Probota h.",
				"to": "Dolhasca",
				"leavesAt": "16:52",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Dolhasca",
				"to": "Corni h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Corni h.",
				"to": "Liteni Hm.",
				"leavesAt": "17:05",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Liteni Hm.",
				"to": "Băneşti Suceava hc.",
				"leavesAt": "17:12",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Băneşti Suceava hc.",
				"to": "Vereşti",
				"leavesAt": "17:19",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Vereşti",
				"to": "Văratec",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Văratec",
				"to": "Suceava",
				"leavesAt": "17:33",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Suceava",
				"to": "Suceava Nord",
				"leavesAt": "17:42",
				"arrivesAt": "17:48",
				"waitsAtSource": 120,
				"distance": 2500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "CFR",
		"number": "78",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Arad",
				"leavesAt": "07:30",
				"arrivesAt": "08:18",
				"waitsAtSource": 0,
				"distance": 57200
			},
			{
				"from": "Arad",
				"to": "Curtici",
				"leavesAt": "08:21",
				"arrivesAt": "08:34",
				"waitsAtSource": 180,
				"distance": 17000
			},
			{
				"from": "Curtici",
				"to": "Lokoshaza",
				"leavesAt": "08:59",
				"arrivesAt": "09:09",
				"waitsAtSource": 1500,
				"distance": 11200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15107",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "11:00",
				"arrivesAt": "11:05",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "11:06",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "11:16",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "11:26",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "11:31",
				"arrivesAt": "11:35",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "11:36",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "11:53",
				"arrivesAt": "11:56",
				"waitsAtSource": 540,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "11:57",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "12:03",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "12:12",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "12:21",
				"arrivesAt": "12:25",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "12:26",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "12:35",
				"arrivesAt": "12:38",
				"waitsAtSource": 120,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "12:39",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "12:42",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15362",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 480,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "17:21",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "17:25",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "17:35",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "18:34",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15189",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "19:46",
				"arrivesAt": "19:54",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 480,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:16",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "20:17",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "20:29",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "20:33",
				"arrivesAt": "20:37",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "20:38",
				"arrivesAt": "20:44",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "20:45",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "20:56",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "21:01",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "21:07",
				"arrivesAt": "21:19",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15309",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "10:03",
				"arrivesAt": "10:26",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "10:27",
				"arrivesAt": "10:34",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "10:35",
				"arrivesAt": "10:42",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:49",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "11:03",
				"arrivesAt": "11:09",
				"waitsAtSource": 480,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "11:10",
				"arrivesAt": "11:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:19",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "11:20",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "11:26",
				"arrivesAt": "11:29",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "11:30",
				"arrivesAt": "11:34",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "11:35",
				"arrivesAt": "11:42",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:52",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "11:53",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "12:03",
				"arrivesAt": "12:07",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "12:08",
				"arrivesAt": "12:16",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "12:17",
				"arrivesAt": "12:24",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:28",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "12:29",
				"arrivesAt": "12:35",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "12:41",
				"arrivesAt": "12:49",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15034",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oşorhei Hm.",
				"leavesAt": "11:38",
				"arrivesAt": "11:49",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Aleşd",
				"leavesAt": "11:53",
				"arrivesAt": "12:14",
				"waitsAtSource": 240,
				"distance": 24800
			},
			{
				"from": "Aleşd",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "12:15",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "12:28",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "12:37",
				"arrivesAt": "12:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "12:46",
				"arrivesAt": "12:50",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "12:51",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "12:55",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "13:01",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:10",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "13:11",
				"arrivesAt": "13:14",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Poieni",
				"leavesAt": "13:15",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Poieni",
				"to": "Huedin",
				"leavesAt": "13:23",
				"arrivesAt": "13:37",
				"waitsAtSource": 60,
				"distance": 15300
			},
			{
				"from": "Huedin",
				"to": "Aghireş h.",
				"leavesAt": "13:38",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 18900
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "14:00",
				"arrivesAt": "14:04",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Gârbău Hm.",
				"leavesAt": "14:05",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Gârbău Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "14:13",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 20200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15261",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:58",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "17:12",
				"arrivesAt": "17:19",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "17:43",
				"arrivesAt": "18:15",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181216",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15102",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:44",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "05:45",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "05:52",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "05:58",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "06:01",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "06:10",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "06:38",
				"arrivesAt": "06:44",
				"waitsAtSource": 480,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "06:50",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "06:56",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "07:00",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "07:06",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "07:18",
				"arrivesAt": "07:24",
				"waitsAtSource": 120,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15051",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "10:10",
				"arrivesAt": "10:33",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Crivina",
				"leavesAt": "10:34",
				"arrivesAt": "10:42",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "10:43",
				"arrivesAt": "10:53",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "10:57",
				"arrivesAt": "11:11",
				"waitsAtSource": 240,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "11:14",
				"arrivesAt": "11:47",
				"waitsAtSource": 180,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "11:48",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 35000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15352",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:55",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "06:56",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "07:12",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "07:25",
				"arrivesAt": "07:31",
				"waitsAtSource": 480,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "07:40",
				"arrivesAt": "07:43",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "07:44",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "07:54",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "08:05",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "08:19",
				"arrivesAt": "08:24",
				"waitsAtSource": 480,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "08:25",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "08:36",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "08:41",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "08:47",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "09:01",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15132",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "13:42",
				"arrivesAt": "13:46",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "13:47",
				"arrivesAt": "13:51",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "13:52",
				"arrivesAt": "13:55",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "13:56",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "14:01",
				"arrivesAt": "14:04",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "14:05",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "14:11",
				"arrivesAt": "14:14",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "14:15",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "14:21",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "14:27",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "14:32",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "14:45",
				"arrivesAt": "14:52",
				"waitsAtSource": 240,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "14:53",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15256",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "11:00",
				"arrivesAt": "11:31",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "11:32",
				"arrivesAt": "11:41",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "11:50",
				"arrivesAt": "11:55",
				"waitsAtSource": 540,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "11:56",
				"arrivesAt": "12:01",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "12:02",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:13",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "12:14",
				"arrivesAt": "12:17",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "12:18",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "12:22",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181210",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15149",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "14:37",
				"arrivesAt": "15:00",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Crivina",
				"leavesAt": "15:01",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Crivina",
				"to": "Ploieşti Sud",
				"leavesAt": "15:09",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 20500
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "15:39",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "15:45",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "15:56",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "15:59",
				"arrivesAt": "16:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "16:18",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "16:27",
				"arrivesAt": "16:31",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "16:32",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "16:38",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "16:45",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "16:52",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "16:58",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15184",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "14:15",
				"arrivesAt": "14:27",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "14:33",
				"arrivesAt": "14:37",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "14:38",
				"arrivesAt": "14:41",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "14:58",
				"arrivesAt": "15:03",
				"waitsAtSource": 480,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "15:04",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "15:13",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "15:16",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "15:34",
				"arrivesAt": "15:39",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:56",
				"waitsAtSource": 480,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15252",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "05:50",
				"arrivesAt": "06:21",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "06:22",
				"arrivesAt": "06:32",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "06:40",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:03",
				"waitsAtSource": 600,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "07:04",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "07:15",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "07:20",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170701",
				"to": "20181209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15109",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "13:54",
				"arrivesAt": "13:59",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "14:00",
				"arrivesAt": "14:09",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "14:10",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "14:15",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "14:25",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "14:30",
				"arrivesAt": "14:38",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:51",
				"waitsAtSource": 600,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "14:58",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "15:07",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "15:16",
				"arrivesAt": "15:20",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "15:21",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:32",
				"waitsAtSource": 120,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "15:36",
				"arrivesAt": "15:40",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15112",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:23",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "18:27",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "18:31",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "18:37",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "18:41",
				"arrivesAt": "18:49",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "18:50",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "19:01",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "19:06",
				"arrivesAt": "19:11",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "19:21",
				"arrivesAt": "19:27",
				"waitsAtSource": 600,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "19:28",
				"arrivesAt": "19:32",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "19:33",
				"arrivesAt": "19:39",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "19:40",
				"arrivesAt": "19:43",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "19:44",
				"arrivesAt": "19:49",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "19:50",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "20:01",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15035",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gârbău Hm.",
				"leavesAt": "14:02",
				"arrivesAt": "14:21",
				"waitsAtSource": 0,
				"distance": 20200
			},
			{
				"from": "Gârbău Hm.",
				"to": "Aghireş",
				"leavesAt": "14:22",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Huedin",
				"leavesAt": "14:35",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 18900
			},
			{
				"from": "Huedin",
				"to": "Brăişoru Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Poieni",
				"leavesAt": "15:05",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Poieni",
				"to": "Ciucea Hm.",
				"leavesAt": "15:12",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "15:28",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "15:42",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "15:48",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "15:57",
				"arrivesAt": "16:05",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Aleşd",
				"leavesAt": "16:06",
				"arrivesAt": "16:18",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Aleşd",
				"to": "Telechiu Hm.",
				"leavesAt": "16:19",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Telechiu Hm.",
				"to": "Oşorhei Hm.",
				"leavesAt": "16:28",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea",
				"leavesAt": "16:44",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 336
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15170",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "03:30",
				"arrivesAt": "03:42",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "03:43",
				"arrivesAt": "03:47",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "03:48",
				"arrivesAt": "03:52",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "03:53",
				"arrivesAt": "03:56",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "03:57",
				"arrivesAt": "03:59",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "04:00",
				"arrivesAt": "04:05",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "04:06",
				"arrivesAt": "04:11",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "04:12",
				"arrivesAt": "04:15",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "04:16",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:23",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "04:24",
				"arrivesAt": "04:26",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "04:27",
				"arrivesAt": "04:31",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "04:32",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:41",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "04:42",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "04:47",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15120",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:34",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "04:35",
				"arrivesAt": "04:39",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "04:40",
				"arrivesAt": "04:43",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "04:44",
				"arrivesAt": "04:48",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "04:49",
				"arrivesAt": "04:52",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "04:53",
				"arrivesAt": "04:58",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "04:59",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "05:03",
				"arrivesAt": "05:08",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "05:09",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "05:14",
				"arrivesAt": "05:18",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "05:19",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "05:29",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "05:38",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15141",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "05:55",
				"arrivesAt": "05:59",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "06:00",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "06:06",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "06:19",
				"arrivesAt": "06:21",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "06:43",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "06:53",
				"arrivesAt": "06:57",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "06:58",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "07:04",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "07:11",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "07:18",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "07:24",
				"arrivesAt": "07:27",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "07:28",
				"arrivesAt": "07:33",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15148",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "08:13",
				"arrivesAt": "08:15",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "08:16",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "08:28",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "08:33",
				"arrivesAt": "08:37",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:57",
				"waitsAtSource": 540,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "08:58",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "09:06",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "09:10",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:16",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "09:17",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "09:23",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "09:29",
				"arrivesAt": "09:33",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "09:34",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Brazi",
				"leavesAt": "09:45",
				"arrivesAt": "09:59",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "10:00",
				"arrivesAt": "10:09",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:14",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "10:15",
				"arrivesAt": "10:20",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Bucureşti Nord",
				"leavesAt": "10:21",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 30200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15263",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "18:46",
				"arrivesAt": "19:04",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:12",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "19:13",
				"arrivesAt": "19:17",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "19:18",
				"arrivesAt": "19:25",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "19:34",
				"arrivesAt": "19:39",
				"waitsAtSource": 540,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "19:40",
				"arrivesAt": "19:46",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "19:47",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "19:57",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170701",
				"to": "20181211",
				"daysOfWeek": 383
			},
			{
				"from": "20181214",
				"to": "20181229",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15151",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "17:22",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:41",
				"waitsAtSource": 540,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "17:42",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "17:45",
				"arrivesAt": "17:49",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "17:50",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "18:04",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "18:13",
				"arrivesAt": "18:17",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "18:24",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "18:31",
				"arrivesAt": "18:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "18:38",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "18:44",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "18:48",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15361",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "16:51",
				"arrivesAt": "17:01",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "17:02",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "17:10",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "17:35",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "17:41",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:01",
				"waitsAtSource": 480,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "18:02",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "18:07",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "18:35",
				"arrivesAt": "18:41",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "18:42",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "18:47",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:58",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "18:59",
				"arrivesAt": "19:03",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "19:04",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15259",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "14:26",
				"arrivesAt": "14:44",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:48",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "14:49",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "14:58",
				"arrivesAt": "15:05",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "15:12",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "15:19",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "15:29",
				"arrivesAt": "16:01",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170701",
				"to": "20181210",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15061",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "08:32",
				"arrivesAt": "08:55",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "09:08",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "09:21",
				"arrivesAt": "09:36",
				"waitsAtSource": 120,
				"distance": 8800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15160",
		"segments": [
			{
				"from": "Pietroşiţa Hm.",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:36",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Fieni",
				"leavesAt": "14:37",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Moţăieni h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Moţăieni h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Trainica h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Trainica h.",
				"to": "Scârlenţa h.",
				"leavesAt": "14:57",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Scârlenţa h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "15:00",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Doiceşti h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Doiceşti h.",
				"to": "Doiceşti",
				"leavesAt": "15:07",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Doiceşti",
				"to": "Aninoasa Hm.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Aninoasa Hm.",
				"to": "TEIŞ Hm.",
				"leavesAt": "15:17",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:23",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "15:24",
				"arrivesAt": "15:28",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20180702",
				"to": "20180707",
				"daysOfWeek": 320
			},
			{
				"from": "20180709",
				"to": "20180714",
				"daysOfWeek": 320
			},
			{
				"from": "20180716",
				"to": "20180721",
				"daysOfWeek": 320
			},
			{
				"from": "20180723",
				"to": "20180728",
				"daysOfWeek": 320
			},
			{
				"from": "20180730",
				"to": "20180804",
				"daysOfWeek": 320
			},
			{
				"from": "20180806",
				"to": "20180811",
				"daysOfWeek": 320
			},
			{
				"from": "20180813",
				"to": "20180818",
				"daysOfWeek": 320
			},
			{
				"from": "20180820",
				"to": "20180825",
				"daysOfWeek": 320
			},
			{
				"from": "20180827",
				"to": "20180901",
				"daysOfWeek": 320
			},
			{
				"from": "20180903",
				"to": "20180908",
				"daysOfWeek": 320
			},
			{
				"from": "20180910",
				"to": "20180915",
				"daysOfWeek": 320
			},
			{
				"from": "20180917",
				"to": "20180922",
				"daysOfWeek": 320
			},
			{
				"from": "20180924",
				"to": "20181208",
				"daysOfWeek": 320
			},
			{
				"from": "20171210",
				"to": "20180630",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15145",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "12:22",
				"arrivesAt": "12:26",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "12:27",
				"arrivesAt": "12:32",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "12:33",
				"arrivesAt": "12:38",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "12:39",
				"arrivesAt": "12:43",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "12:44",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "12:47",
				"arrivesAt": "12:51",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:00",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "13:01",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "13:06",
				"arrivesAt": "13:09",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "13:15",
				"arrivesAt": "13:19",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "13:20",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "13:26",
				"arrivesAt": "13:32",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "13:33",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "13:40",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "13:50",
				"arrivesAt": "13:55",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15311",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "13:05",
				"arrivesAt": "13:29",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:43",
				"waitsAtSource": 480,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "13:44",
				"arrivesAt": "13:50",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "13:58",
				"arrivesAt": "14:03",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "14:11",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "14:16",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "14:21",
				"arrivesAt": "14:26",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "14:27",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "14:38",
				"arrivesAt": "14:42",
				"waitsAtSource": 480,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:49",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "14:59",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "15:14",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "15:23",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:40",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "15:46",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15359",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "15:15",
				"arrivesAt": "15:25",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "15:33",
				"arrivesAt": "15:39",
				"waitsAtSource": 480,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "15:40",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "15:58",
				"arrivesAt": "16:02",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "16:03",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "16:09",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "16:23",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "16:28",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "16:34",
				"arrivesAt": "16:44",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "16:53",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "16:57",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "17:26",
				"arrivesAt": "17:30",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20180101",
				"to": "20180105",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180112",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180119",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180126",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180202",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180209",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180216",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180223",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180302",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180309",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180316",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180323",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180330",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180406",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180413",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180420",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180427",
				"daysOfWeek": 383
			},
			{
				"from": "20180430",
				"to": "20180504",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180511",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180518",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180525",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20180601",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180611",
				"to": "20180615",
				"daysOfWeek": 383
			},
			{
				"from": "20180618",
				"to": "20180622",
				"daysOfWeek": 383
			},
			{
				"from": "20180625",
				"to": "20180629",
				"daysOfWeek": 383
			},
			{
				"from": "20180701",
				"to": "20180706",
				"daysOfWeek": 383
			},
			{
				"from": "20180708",
				"to": "20180713",
				"daysOfWeek": 383
			},
			{
				"from": "20180715",
				"to": "20180720",
				"daysOfWeek": 383
			},
			{
				"from": "20180722",
				"to": "20180727",
				"daysOfWeek": 383
			},
			{
				"from": "20180729",
				"to": "20180803",
				"daysOfWeek": 383
			},
			{
				"from": "20180805",
				"to": "20180810",
				"daysOfWeek": 383
			},
			{
				"from": "20180812",
				"to": "20180817",
				"daysOfWeek": 383
			},
			{
				"from": "20180819",
				"to": "20180824",
				"daysOfWeek": 383
			},
			{
				"from": "20180826",
				"to": "20180831",
				"daysOfWeek": 383
			},
			{
				"from": "20180902",
				"to": "20180907",
				"daysOfWeek": 383
			},
			{
				"from": "20180909",
				"to": "20180914",
				"daysOfWeek": 383
			},
			{
				"from": "20180916",
				"to": "20180921",
				"daysOfWeek": 383
			},
			{
				"from": "20180923",
				"to": "20180928",
				"daysOfWeek": 383
			},
			{
				"from": "20180930",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171215",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171222",
				"daysOfWeek": 383
			},
			{
				"from": "20171225",
				"to": "20171229",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15255",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:18",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:39",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "08:46",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:10",
				"waitsAtSource": 540,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "09:11",
				"arrivesAt": "09:43",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15161",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:40",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "12:41",
				"arrivesAt": "12:43",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Aninoasa Hm.",
				"leavesAt": "12:44",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Aninoasa Hm.",
				"to": "Doiceşti",
				"leavesAt": "12:48",
				"arrivesAt": "12:54",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Doiceşti",
				"to": "Doiceşti h.",
				"leavesAt": "12:55",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Doiceşti h.",
				"to": "Vulcana Pandele P.M.Aj.",
				"leavesAt": "12:58",
				"arrivesAt": "13:01",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vulcana Pandele P.M.Aj.",
				"to": "Scârlenţa h.",
				"leavesAt": "13:02",
				"arrivesAt": "13:05",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Scârlenţa h.",
				"to": "Trainica h.",
				"leavesAt": "13:06",
				"arrivesAt": "13:08",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Trainica h.",
				"to": "Pucioasa Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:14",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Pucioasa Hm.",
				"to": "Moţăieni h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:18",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Moţăieni h.",
				"to": "Fieni",
				"leavesAt": "13:19",
				"arrivesAt": "13:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Fieni",
				"to": "Ţepeş Vodă h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ţepeş Vodă h.",
				"to": "Pietroşiţa Hm.",
				"leavesAt": "13:29",
				"arrivesAt": "13:37",
				"waitsAtSource": 30,
				"distance": 4100
			}
		],
		"restrictions": [
			{
				"from": "20180702",
				"to": "20180707",
				"daysOfWeek": 320
			},
			{
				"from": "20180709",
				"to": "20180711",
				"daysOfWeek": 320
			},
			{
				"from": "20180713",
				"to": "20180714",
				"daysOfWeek": 320
			},
			{
				"from": "20180716",
				"to": "20180718",
				"daysOfWeek": 320
			},
			{
				"from": "20180720",
				"to": "20180721",
				"daysOfWeek": 320
			},
			{
				"from": "20180723",
				"to": "20180728",
				"daysOfWeek": 320
			},
			{
				"from": "20180730",
				"to": "20180804",
				"daysOfWeek": 320
			},
			{
				"from": "20180806",
				"to": "20180811",
				"daysOfWeek": 320
			},
			{
				"from": "20180813",
				"to": "20180818",
				"daysOfWeek": 320
			},
			{
				"from": "20180820",
				"to": "20180825",
				"daysOfWeek": 320
			},
			{
				"from": "20180827",
				"to": "20180901",
				"daysOfWeek": 320
			},
			{
				"from": "20180903",
				"to": "20180908",
				"daysOfWeek": 320
			},
			{
				"from": "20180910",
				"to": "20180915",
				"daysOfWeek": 320
			},
			{
				"from": "20180917",
				"to": "20180922",
				"daysOfWeek": 320
			},
			{
				"from": "20180924",
				"to": "20181208",
				"daysOfWeek": 320
			},
			{
				"from": "20171210",
				"to": "20180630",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15150",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "10:52",
				"arrivesAt": "10:56",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "10:57",
				"arrivesAt": "10:59",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "11:00",
				"arrivesAt": "11:06",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "11:07",
				"arrivesAt": "11:11",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "11:12",
				"arrivesAt": "11:16",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "11:17",
				"arrivesAt": "11:21",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:25",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "11:26",
				"arrivesAt": "11:30",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "11:31",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "11:34",
				"arrivesAt": "11:38",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "11:39",
				"arrivesAt": "11:41",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "11:42",
				"arrivesAt": "11:45",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "11:46",
				"arrivesAt": "11:50",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "11:51",
				"arrivesAt": "11:52",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "11:53",
				"arrivesAt": "11:58",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "11:59",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "12:05",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "12:10",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Crivina",
				"leavesAt": "13:00",
				"arrivesAt": "13:22",
				"waitsAtSource": 2640,
				"distance": 20500
			},
			{
				"from": "Crivina",
				"to": "Periş",
				"leavesAt": "13:23",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Periş",
				"to": "Bucureşti Nord",
				"leavesAt": "13:31",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 30200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15264",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "20:40",
				"arrivesAt": "21:11",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "21:12",
				"arrivesAt": "21:21",
				"waitsAtSource": 30,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20170701",
				"to": "20181210",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15129",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "13:42",
				"arrivesAt": "13:47",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "13:49",
				"arrivesAt": "13:56",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "13:57",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "14:06",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "14:11",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "14:24",
				"arrivesAt": "14:28",
				"waitsAtSource": 540,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:32",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "14:33",
				"arrivesAt": "14:38",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:43",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "14:48",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15056",
		"segments": [
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "16:50",
				"arrivesAt": "17:22",
				"waitsAtSource": 0,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "17:23",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "18:04",
				"arrivesAt": "18:11",
				"waitsAtSource": 360,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Crivina",
				"leavesAt": "18:15",
				"arrivesAt": "18:30",
				"waitsAtSource": 240,
				"distance": 16900
			},
			{
				"from": "Crivina",
				"to": "Bucureşti Nord",
				"leavesAt": "18:31",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 39700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15072",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Barboşi",
				"leavesAt": "07:25",
				"arrivesAt": "07:44",
				"waitsAtSource": 0,
				"distance": 12000
			},
			{
				"from": "Barboşi",
				"to": "Vădeni Hm.",
				"leavesAt": "07:45",
				"arrivesAt": "07:52",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Vădeni Hm.",
				"to": "Baldovineşti Hm.",
				"leavesAt": "07:53",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Brăila",
				"leavesAt": "07:59",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Brăila",
				"to": "Ianca hc.",
				"leavesAt": "08:13",
				"arrivesAt": "08:43",
				"waitsAtSource": 360,
				"distance": 42400
			},
			{
				"from": "Ianca hc.",
				"to": "Făurei",
				"leavesAt": "08:44",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Făurei",
				"to": "Buzău",
				"leavesAt": "09:01",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "09:43",
				"arrivesAt": "10:15",
				"waitsAtSource": 180,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "10:17",
				"arrivesAt": "10:53",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Triaj",
				"leavesAt": "10:55",
				"arrivesAt": "11:02",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Bucureşti Nord",
				"leavesAt": "11:06",
				"arrivesAt": "11:55",
				"waitsAtSource": 240,
				"distance": 56600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15360",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:40",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "13:41",
				"arrivesAt": "13:45",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "13:57",
				"arrivesAt": "14:02",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "14:03",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "14:09",
				"arrivesAt": "14:12",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:16",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "14:17",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "14:21",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "14:31",
				"arrivesAt": "14:36",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "14:42",
				"arrivesAt": "14:48",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "14:49",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "14:54",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "15:10",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "15:16",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "15:23",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "15:30",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15351",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:36",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "07:37",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "07:44",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "07:51",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "08:02",
				"arrivesAt": "08:06",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "08:07",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "08:12",
				"arrivesAt": "08:16",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "08:24",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "08:29",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "08:35",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:48",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "08:49",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "08:53",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "08:57",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "09:09",
				"arrivesAt": "09:15",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "09:16",
				"arrivesAt": "09:19",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "09:20",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "09:25",
				"arrivesAt": "09:29",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15307",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "08:00",
				"arrivesAt": "08:25",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:39",
				"waitsAtSource": 480,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:53",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "08:59",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "09:00",
				"arrivesAt": "09:06",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "09:07",
				"arrivesAt": "09:11",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "09:12",
				"arrivesAt": "09:16",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "09:23",
				"arrivesAt": "09:26",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "09:27",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "09:33",
				"arrivesAt": "09:39",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "09:40",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "09:49",
				"arrivesAt": "09:58",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "09:59",
				"arrivesAt": "10:03",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "10:04",
				"arrivesAt": "10:12",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "10:13",
				"arrivesAt": "10:19",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:23",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "10:24",
				"arrivesAt": "10:30",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:35",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "10:36",
				"arrivesAt": "10:44",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15146",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "06:05",
				"arrivesAt": "06:09",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "06:10",
				"arrivesAt": "06:12",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "06:13",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "06:20",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "06:30",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "06:39",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:54",
				"waitsAtSource": 540,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:59",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "07:07",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:13",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "07:14",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "07:21",
				"arrivesAt": "07:26",
				"waitsAtSource": 120,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "07:28",
				"arrivesAt": "07:32",
				"waitsAtSource": 120,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "07:33",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15251",
		"segments": [
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "04:38",
				"arrivesAt": "04:43",
				"waitsAtSource": 0,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "04:44",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "04:51",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "05:01",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170701",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15108",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:53",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "13:54",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "13:58",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "14:02",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "14:08",
				"arrivesAt": "14:11",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "14:12",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "14:21",
				"arrivesAt": "14:31",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:36",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "14:37",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "14:52",
				"arrivesAt": "14:58",
				"waitsAtSource": 600,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "15:05",
				"arrivesAt": "15:11",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "15:12",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "15:16",
				"arrivesAt": "15:21",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "15:22",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "15:33",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15187",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "18:14",
				"arrivesAt": "18:22",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "18:30",
				"arrivesAt": "18:34",
				"waitsAtSource": 480,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:44",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "18:45",
				"arrivesAt": "18:49",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "18:50",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "18:53",
				"arrivesAt": "18:56",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "18:57",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "19:01",
				"arrivesAt": "19:05",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "19:06",
				"arrivesAt": "19:12",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:24",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "19:25",
				"arrivesAt": "19:26",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:31",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "19:32",
				"arrivesAt": "19:35",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "19:36",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "19:42",
				"arrivesAt": "19:54",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15258",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "14:30",
				"arrivesAt": "15:01",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "15:02",
				"arrivesAt": "15:12",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "15:22",
				"arrivesAt": "15:27",
				"waitsAtSource": 600,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "15:28",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:49",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "15:54",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15265",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:38",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "20:39",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "20:47",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "20:52",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "21:00",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "21:06",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 4700
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15103",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "05:50",
				"arrivesAt": "05:55",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "05:56",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "06:26",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "06:39",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "06:45",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "06:54",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:07",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "07:08",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "07:16",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "07:20",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "07:23",
				"arrivesAt": "07:27",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15358",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "12:27",
				"arrivesAt": "12:31",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "12:32",
				"arrivesAt": "12:36",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:47",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "12:48",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "13:02",
				"arrivesAt": "13:08",
				"waitsAtSource": 540,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "13:09",
				"arrivesAt": "13:12",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "13:13",
				"arrivesAt": "13:16",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "13:17",
				"arrivesAt": "13:20",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "13:21",
				"arrivesAt": "13:30",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "13:31",
				"arrivesAt": "13:36",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "13:42",
				"arrivesAt": "13:48",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "13:49",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "14:01",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "14:11",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "14:17",
				"arrivesAt": "14:23",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "14:24",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "14:31",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15181",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "14:03",
				"arrivesAt": "14:11",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "14:16",
				"arrivesAt": "14:21",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "14:22",
				"arrivesAt": "14:25",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "14:26",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:37",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "14:38",
				"arrivesAt": "14:42",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "14:43",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "14:48",
				"arrivesAt": "14:54",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "14:55",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:05",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:10",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "15:11",
				"arrivesAt": "15:16",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "15:17",
				"arrivesAt": "15:29",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15155",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "20:44",
				"arrivesAt": "20:48",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "20:49",
				"arrivesAt": "20:54",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "20:55",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "21:06",
				"arrivesAt": "21:08",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "21:09",
				"arrivesAt": "21:13",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "21:14",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "21:28",
				"arrivesAt": "21:31",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "21:37",
				"arrivesAt": "21:41",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "21:42",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "21:48",
				"arrivesAt": "21:54",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "21:55",
				"arrivesAt": "22:01",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "22:02",
				"arrivesAt": "22:07",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "22:08",
				"arrivesAt": "22:11",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "22:12",
				"arrivesAt": "22:17",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15094",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:56",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "16:03",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "16:23",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Ghergani Hm.",
				"leavesAt": "16:31",
				"arrivesAt": "16:41",
				"waitsAtSource": 180,
				"distance": 12100
			},
			{
				"from": "Ghergani Hm.",
				"to": "Chitila",
				"leavesAt": "16:42",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 26500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Nord",
				"leavesAt": "17:05",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 9400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15124",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "06:23",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "06:47",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "06:51",
				"arrivesAt": "06:56",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "06:57",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "07:02",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "07:07",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "07:17",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "07:26",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15175",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "08:57",
				"arrivesAt": "09:05",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:17",
				"waitsAtSource": 480,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:27",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "09:28",
				"arrivesAt": "09:32",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "09:33",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "09:36",
				"arrivesAt": "09:39",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "09:40",
				"arrivesAt": "09:43",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "09:44",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "09:49",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "09:56",
				"arrivesAt": "10:00",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "10:01",
				"arrivesAt": "10:02",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:07",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "10:08",
				"arrivesAt": "10:11",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "10:12",
				"arrivesAt": "10:17",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "10:18",
				"arrivesAt": "10:30",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15260",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "16:52",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:29",
				"waitsAtSource": 600,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "17:30",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "17:43",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181210",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15322",
		"segments": [
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "03:38",
				"arrivesAt": "03:41",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "03:42",
				"arrivesAt": "03:47",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "03:48",
				"arrivesAt": "03:52",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "03:53",
				"arrivesAt": "03:57",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "03:58",
				"arrivesAt": "04:05",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "04:06",
				"arrivesAt": "04:12",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "04:13",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:26",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "04:27",
				"arrivesAt": "04:33",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "04:34",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15301",
		"segments": [
			{
				"from": "Târgu Bujor",
				"to": "Bereşti Hm.",
				"leavesAt": "01:46",
				"arrivesAt": "02:11",
				"waitsAtSource": 0,
				"distance": 24900
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bârlad",
				"leavesAt": "02:16",
				"arrivesAt": "02:56",
				"waitsAtSource": 300,
				"distance": 31100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15126",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:04",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "08:05",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:18",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "08:29",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "08:33",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "08:44",
				"arrivesAt": "08:48",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "08:49",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "08:59",
				"arrivesAt": "09:06",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "09:07",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15182",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "12:24",
				"arrivesAt": "12:36",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "12:42",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:52",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "12:53",
				"arrivesAt": "12:55",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "12:56",
				"arrivesAt": "13:01",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "13:02",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "13:08",
				"arrivesAt": "13:12",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "13:13",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "13:17",
				"arrivesAt": "13:19",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "13:20",
				"arrivesAt": "13:23",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "13:24",
				"arrivesAt": "13:27",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "13:28",
				"arrivesAt": "13:31",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "13:32",
				"arrivesAt": "13:37",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "13:38",
				"arrivesAt": "13:43",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "13:44",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15127",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "11:32",
				"arrivesAt": "11:37",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "11:38",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "11:47",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "11:56",
				"arrivesAt": "12:00",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "12:01",
				"arrivesAt": "12:05",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "12:06",
				"arrivesAt": "12:10",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "12:11",
				"arrivesAt": "12:14",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:25",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "12:26",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "12:30",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "12:34",
				"arrivesAt": "12:38",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "12:39",
				"arrivesAt": "12:44",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180615",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15143",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "08:04",
				"arrivesAt": "08:08",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "08:09",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "08:26",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "08:29",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:37",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "08:48",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "08:52",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "09:15",
				"arrivesAt": "09:21",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "09:22",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "09:28",
				"arrivesAt": "09:31",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "09:32",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15144",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "05:03",
				"arrivesAt": "05:07",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "05:08",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "05:11",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "05:23",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "05:28",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "05:53",
				"arrivesAt": "05:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 540,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "06:24",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "06:29",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20180618",
				"to": "20180622",
				"daysOfWeek": 480
			},
			{
				"from": "20180625",
				"to": "20180629",
				"daysOfWeek": 480
			},
			{
				"from": "20180702",
				"to": "20180706",
				"daysOfWeek": 480
			},
			{
				"from": "20180709",
				"to": "20180713",
				"daysOfWeek": 480
			},
			{
				"from": "20180716",
				"to": "20180720",
				"daysOfWeek": 480
			},
			{
				"from": "20180723",
				"to": "20180727",
				"daysOfWeek": 480
			},
			{
				"from": "20180730",
				"to": "20180803",
				"daysOfWeek": 480
			},
			{
				"from": "20180806",
				"to": "20180810",
				"daysOfWeek": 480
			},
			{
				"from": "20180813",
				"to": "20180817",
				"daysOfWeek": 480
			},
			{
				"from": "20180820",
				"to": "20180824",
				"daysOfWeek": 480
			},
			{
				"from": "20180827",
				"to": "20180831",
				"daysOfWeek": 480
			},
			{
				"from": "20180903",
				"to": "20180907",
				"daysOfWeek": 480
			},
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 480
			},
			{
				"from": "20171210",
				"to": "20180615",
				"daysOfWeek": 480
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15142",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "05:03",
				"arrivesAt": "05:07",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "05:08",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "05:11",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "05:23",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "05:28",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:52",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "05:53",
				"arrivesAt": "05:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "05:57",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "06:18",
				"arrivesAt": "06:23",
				"waitsAtSource": 540,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "06:24",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "06:29",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "06:55",
				"arrivesAt": "07:00",
				"waitsAtSource": 1140,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "07:05",
				"arrivesAt": "07:12",
				"waitsAtSource": 300,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "07:13",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "07:28",
				"arrivesAt": "07:33",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Bucureşti Nord",
				"leavesAt": "07:34",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 30200
			}
		],
		"restrictions": [
			{
				"from": "20180101",
				"to": "20180105",
				"daysOfWeek": 383
			},
			{
				"from": "20180108",
				"to": "20180112",
				"daysOfWeek": 383
			},
			{
				"from": "20180115",
				"to": "20180119",
				"daysOfWeek": 383
			},
			{
				"from": "20180122",
				"to": "20180126",
				"daysOfWeek": 383
			},
			{
				"from": "20180129",
				"to": "20180202",
				"daysOfWeek": 383
			},
			{
				"from": "20180205",
				"to": "20180209",
				"daysOfWeek": 383
			},
			{
				"from": "20180212",
				"to": "20180216",
				"daysOfWeek": 383
			},
			{
				"from": "20180219",
				"to": "20180223",
				"daysOfWeek": 383
			},
			{
				"from": "20180226",
				"to": "20180302",
				"daysOfWeek": 383
			},
			{
				"from": "20180305",
				"to": "20180309",
				"daysOfWeek": 383
			},
			{
				"from": "20180312",
				"to": "20180316",
				"daysOfWeek": 383
			},
			{
				"from": "20180319",
				"to": "20180323",
				"daysOfWeek": 383
			},
			{
				"from": "20180326",
				"to": "20180330",
				"daysOfWeek": 383
			},
			{
				"from": "20180402",
				"to": "20180406",
				"daysOfWeek": 383
			},
			{
				"from": "20180409",
				"to": "20180413",
				"daysOfWeek": 383
			},
			{
				"from": "20180416",
				"to": "20180420",
				"daysOfWeek": 383
			},
			{
				"from": "20180423",
				"to": "20180427",
				"daysOfWeek": 383
			},
			{
				"from": "20180430",
				"to": "20180504",
				"daysOfWeek": 383
			},
			{
				"from": "20180507",
				"to": "20180511",
				"daysOfWeek": 383
			},
			{
				"from": "20180514",
				"to": "20180518",
				"daysOfWeek": 383
			},
			{
				"from": "20180521",
				"to": "20180525",
				"daysOfWeek": 383
			},
			{
				"from": "20180528",
				"to": "20180601",
				"daysOfWeek": 383
			},
			{
				"from": "20180604",
				"to": "20180608",
				"daysOfWeek": 383
			},
			{
				"from": "20180611",
				"to": "20180914",
				"daysOfWeek": 383
			},
			{
				"from": "20180917",
				"to": "20180921",
				"daysOfWeek": 383
			},
			{
				"from": "20180924",
				"to": "20180928",
				"daysOfWeek": 383
			},
			{
				"from": "20181001",
				"to": "20181005",
				"daysOfWeek": 383
			},
			{
				"from": "20181008",
				"to": "20181012",
				"daysOfWeek": 383
			},
			{
				"from": "20181015",
				"to": "20181019",
				"daysOfWeek": 383
			},
			{
				"from": "20181022",
				"to": "20181026",
				"daysOfWeek": 383
			},
			{
				"from": "20181029",
				"to": "20181102",
				"daysOfWeek": 383
			},
			{
				"from": "20181105",
				"to": "20181109",
				"daysOfWeek": 383
			},
			{
				"from": "20181112",
				"to": "20181116",
				"daysOfWeek": 383
			},
			{
				"from": "20181119",
				"to": "20181123",
				"daysOfWeek": 383
			},
			{
				"from": "20181126",
				"to": "20181130",
				"daysOfWeek": 383
			},
			{
				"from": "20181203",
				"to": "20181207",
				"daysOfWeek": 383
			},
			{
				"from": "20171211",
				"to": "20171215",
				"daysOfWeek": 383
			},
			{
				"from": "20171218",
				"to": "20171222",
				"daysOfWeek": 383
			},
			{
				"from": "20171225",
				"to": "20171229",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15110",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:23",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "16:28",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "16:32",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "16:38",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "16:42",
				"arrivesAt": "16:50",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "16:51",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "17:07",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "17:13",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "17:25",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "17:32",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "17:36",
				"arrivesAt": "17:41",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "17:42",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "17:55",
				"arrivesAt": "18:01",
				"waitsAtSource": 180,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15176",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "07:44",
				"arrivesAt": "07:56",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:06",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "08:07",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "08:28",
				"arrivesAt": "08:33",
				"waitsAtSource": 480,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "08:34",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:45",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "08:46",
				"arrivesAt": "08:49",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:57",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "08:58",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "09:04",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15122",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "05:15",
				"arrivesAt": "05:19",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "05:20",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "05:44",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "05:59",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "06:04",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "06:15",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15037",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Rădaia h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:31",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Rădaia h.",
				"to": "Gârbău Hm.",
				"leavesAt": "16:32",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 9600
			},
			{
				"from": "Gârbău Hm.",
				"to": "Dorolţu h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Dorolţu h.",
				"to": "Aghireş",
				"leavesAt": "16:49",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Huedin",
				"leavesAt": "16:57",
				"arrivesAt": "17:18",
				"waitsAtSource": 30,
				"distance": 18900
			},
			{
				"from": "Huedin",
				"to": "Brăişoru Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Bologa h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bologa h.",
				"to": "Poieni",
				"leavesAt": "17:33",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Poieni",
				"to": "Valea Drăganului h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Drăganului h.",
				"to": "Ciucea Hm.",
				"leavesAt": "17:44",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "17:57",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "18:02",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "18:08",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:20",
				"waitsAtSource": 300,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "18:36",
				"arrivesAt": "18:43",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Aleşd",
				"leavesAt": "18:44",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Aleşd",
				"to": "Oşorhei Hm.",
				"leavesAt": "18:57",
				"arrivesAt": "19:17",
				"waitsAtSource": 120,
				"distance": 24800
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea",
				"leavesAt": "19:18",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15115",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "20:26",
				"arrivesAt": "20:31",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "20:33",
				"arrivesAt": "20:42",
				"waitsAtSource": 120,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "20:48",
				"arrivesAt": "20:52",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "20:58",
				"arrivesAt": "21:02",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "21:03",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "21:21",
				"arrivesAt": "21:24",
				"waitsAtSource": 540,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "21:25",
				"arrivesAt": "21:30",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "21:31",
				"arrivesAt": "21:39",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "21:40",
				"arrivesAt": "21:49",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "21:50",
				"arrivesAt": "21:54",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "21:55",
				"arrivesAt": "22:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "22:03",
				"arrivesAt": "22:06",
				"waitsAtSource": 120,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:09",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "22:10",
				"arrivesAt": "22:14",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15121",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "06:20",
				"arrivesAt": "06:25",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "06:26",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "06:35",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "06:44",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "06:49",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "07:01",
				"arrivesAt": "07:05",
				"waitsAtSource": 480,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:09",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "07:16",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "07:25",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "07:29",
				"arrivesAt": "07:33",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "07:34",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15318",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "22:24",
				"arrivesAt": "22:31",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "22:32",
				"arrivesAt": "22:36",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "22:37",
				"arrivesAt": "22:43",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "22:44",
				"arrivesAt": "22:47",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "22:48",
				"arrivesAt": "22:54",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "22:55",
				"arrivesAt": "23:02",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "23:03",
				"arrivesAt": "23:07",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Târgu Bujor",
				"leavesAt": "23:08",
				"arrivesAt": "23:42",
				"waitsAtSource": 60,
				"distance": 24900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15364",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:01",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:10",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "20:19",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 480,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:45",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "20:46",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "20:50",
				"arrivesAt": "20:59",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "21:00",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "21:06",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "21:11",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "21:18",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "21:24",
				"arrivesAt": "21:29",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "21:30",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:39",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "21:40",
				"arrivesAt": "21:45",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "21:46",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "21:53",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "22:00",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15188",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "18:40",
				"arrivesAt": "18:52",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "18:53",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:02",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "19:03",
				"arrivesAt": "19:07",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "19:08",
				"arrivesAt": "19:10",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "19:11",
				"arrivesAt": "19:16",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "19:17",
				"arrivesAt": "19:22",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "19:23",
				"arrivesAt": "19:26",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:30",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:33",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "19:34",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "19:38",
				"arrivesAt": "19:42",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:52",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "19:53",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "19:59",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15152",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "14:05",
				"arrivesAt": "14:09",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "14:10",
				"arrivesAt": "14:12",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "14:13",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "14:20",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "14:25",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "14:30",
				"arrivesAt": "14:34",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "14:35",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "14:39",
				"arrivesAt": "14:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:54",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "14:55",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "14:59",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:05",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "15:06",
				"arrivesAt": "15:11",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "15:12",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "15:18",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "15:23",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15363",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "18:54",
				"arrivesAt": "19:04",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "19:05",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "19:12",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "19:18",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "19:28",
				"arrivesAt": "19:32",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "19:33",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "19:38",
				"arrivesAt": "19:42",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "19:50",
				"arrivesAt": "19:54",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "20:01",
				"arrivesAt": "20:10",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "20:19",
				"arrivesAt": "20:22",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "20:23",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:45",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:50",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "20:51",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15154",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "16:19",
				"arrivesAt": "16:23",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "16:24",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "16:27",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "16:34",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "16:47",
				"arrivesAt": "16:51",
				"waitsAtSource": 540,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "17:01",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "17:17",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:27",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "17:28",
				"arrivesAt": "17:33",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "17:34",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "17:45",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15313",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "15:00",
				"arrivesAt": "15:25",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "15:33",
				"arrivesAt": "15:39",
				"waitsAtSource": 480,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:46",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "15:54",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "16:07",
				"arrivesAt": "16:11",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:16",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "16:23",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "16:27",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:39",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "16:49",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15303",
		"segments": [
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "04:31",
				"arrivesAt": "04:35",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:42",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:50",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "04:51",
				"arrivesAt": "05:00",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 300,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "05:18",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "05:28",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:38",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "05:39",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15104",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:01",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "08:02",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "08:06",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "08:10",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "08:16",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "08:20",
				"arrivesAt": "08:28",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "08:29",
				"arrivesAt": "08:39",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "08:40",
				"arrivesAt": "08:44",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "08:59",
				"arrivesAt": "09:05",
				"waitsAtSource": 540,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:10",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "09:11",
				"arrivesAt": "09:16",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "09:17",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "09:21",
				"arrivesAt": "09:26",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "09:27",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "09:38",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180301",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15312",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:27",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "13:28",
				"arrivesAt": "13:32",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "13:33",
				"arrivesAt": "13:39",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "13:40",
				"arrivesAt": "13:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "13:44",
				"arrivesAt": "13:50",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:59",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "14:00",
				"arrivesAt": "14:04",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "14:05",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "14:14",
				"arrivesAt": "14:22",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "14:23",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "14:30",
				"arrivesAt": "14:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:45",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "14:46",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "15:24",
				"arrivesAt": "15:30",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "15:31",
				"arrivesAt": "15:55",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15355",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "11:12",
				"arrivesAt": "11:22",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "11:23",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "11:31",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "11:38",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "11:49",
				"arrivesAt": "11:53",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "11:54",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "12:00",
				"arrivesAt": "12:05",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "12:13",
				"arrivesAt": "12:19",
				"waitsAtSource": 480,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "12:20",
				"arrivesAt": "12:24",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "12:25",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "12:31",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:44",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "12:45",
				"arrivesAt": "12:48",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "12:49",
				"arrivesAt": "12:52",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "12:53",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:08",
				"waitsAtSource": 300,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "13:09",
				"arrivesAt": "13:15",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "13:16",
				"arrivesAt": "13:19",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:24",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "13:25",
				"arrivesAt": "13:29",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15036",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oşorhei Hm.",
				"leavesAt": "15:16",
				"arrivesAt": "15:27",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Aleşd",
				"leavesAt": "15:28",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 24800
			},
			{
				"from": "Aleşd",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "15:50",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "16:07",
				"arrivesAt": "16:15",
				"waitsAtSource": 300,
				"distance": 6800
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "16:16",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 420,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:40",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "16:46",
				"arrivesAt": "16:51",
				"waitsAtSource": 360,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "17:01",
				"arrivesAt": "17:05",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Poieni",
				"leavesAt": "17:12",
				"arrivesAt": "17:20",
				"waitsAtSource": 420,
				"distance": 7100
			},
			{
				"from": "Poieni",
				"to": "Brăişoru Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "17:29",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Stana Hm.",
				"leavesAt": "17:38",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 10600
			},
			{
				"from": "Stana Hm.",
				"to": "Aghireş h.",
				"leavesAt": "17:51",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "18:00",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Gârbău Hm.",
				"leavesAt": "18:05",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Gârbău Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "18:14",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 20200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15302",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "03:10",
				"arrivesAt": "03:17",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "03:18",
				"arrivesAt": "03:22",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "03:23",
				"arrivesAt": "03:29",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "03:30",
				"arrivesAt": "03:33",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "03:34",
				"arrivesAt": "03:40",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "03:41",
				"arrivesAt": "03:49",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "03:50",
				"arrivesAt": "03:54",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "03:55",
				"arrivesAt": "04:03",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "04:04",
				"arrivesAt": "04:12",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "04:13",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "04:20",
				"arrivesAt": "04:25",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "04:26",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:35",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:40",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:45",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "04:46",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "04:54",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "05:22",
				"arrivesAt": "05:46",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15128",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "09:46",
				"arrivesAt": "09:50",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "09:51",
				"arrivesAt": "09:55",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "09:56",
				"arrivesAt": "09:59",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "10:00",
				"arrivesAt": "10:04",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "10:05",
				"arrivesAt": "10:08",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "10:09",
				"arrivesAt": "10:14",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "10:15",
				"arrivesAt": "10:18",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "10:19",
				"arrivesAt": "10:24",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "10:25",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "10:30",
				"arrivesAt": "10:34",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "10:35",
				"arrivesAt": "10:44",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "10:45",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "10:54",
				"arrivesAt": "10:59",
				"waitsAtSource": 120,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15300",
		"segments": [
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "03:07",
				"arrivesAt": "03:15",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "03:16",
				"arrivesAt": "03:24",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "03:25",
				"arrivesAt": "03:31",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "03:32",
				"arrivesAt": "03:37",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "03:38",
				"arrivesAt": "03:41",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "03:42",
				"arrivesAt": "03:47",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "03:48",
				"arrivesAt": "03:52",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "03:53",
				"arrivesAt": "03:57",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "03:58",
				"arrivesAt": "04:05",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "04:06",
				"arrivesAt": "04:12",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "04:13",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "04:20",
				"arrivesAt": "04:26",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "04:27",
				"arrivesAt": "04:33",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "04:34",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15315",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:57",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "17:18",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "17:47",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "17:51",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "17:57",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "18:13",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "18:28",
				"arrivesAt": "18:36",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "18:37",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "18:48",
				"arrivesAt": "18:54",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "18:55",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "19:00",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15057",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "21:50",
				"arrivesAt": "22:33",
				"waitsAtSource": 0,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "22:38",
				"arrivesAt": "22:43",
				"waitsAtSource": 300,
				"distance": 3000
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "22:45",
				"arrivesAt": "23:18",
				"waitsAtSource": 120,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "23:19",
				"arrivesAt": "23:54",
				"waitsAtSource": 60,
				"distance": 35000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15038",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oradea Est",
				"leavesAt": "17:29",
				"arrivesAt": "17:34",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Oradea Est",
				"to": "Oşorhei Hm.",
				"leavesAt": "17:35",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Aleşd",
				"leavesAt": "17:42",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 24800
			},
			{
				"from": "Aleşd",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:22",
				"waitsAtSource": 420,
				"distance": 12200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "18:23",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "18:35",
				"arrivesAt": "18:43",
				"waitsAtSource": 240,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Stâna de Vale h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bulz Hm.",
				"leavesAt": "18:50",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "18:55",
				"arrivesAt": "19:00",
				"waitsAtSource": 120,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "19:01",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "19:06",
				"arrivesAt": "19:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "19:10",
				"arrivesAt": "19:14",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Poieni",
				"leavesAt": "19:15",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Poieni",
				"to": "Brăişoru Hm.",
				"leavesAt": "19:24",
				"arrivesAt": "19:31",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "19:32",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Aghireş h.",
				"leavesAt": "19:41",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 18900
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "20:03",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Gârbău Hm.",
				"leavesAt": "20:08",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Gârbău Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "20:17",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 20200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 336
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15193",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "22:45",
				"arrivesAt": "22:53",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "22:54",
				"arrivesAt": "22:57",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "22:58",
				"arrivesAt": "23:03",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "23:04",
				"arrivesAt": "23:06",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "23:07",
				"arrivesAt": "23:11",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "23:12",
				"arrivesAt": "23:14",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "23:15",
				"arrivesAt": "23:18",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "23:19",
				"arrivesAt": "23:22",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "23:23",
				"arrivesAt": "23:27",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "23:28",
				"arrivesAt": "23:34",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "23:35",
				"arrivesAt": "23:39",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "23:40",
				"arrivesAt": "23:41",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "23:42",
				"arrivesAt": "23:46",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "23:47",
				"arrivesAt": "23:50",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "23:51",
				"arrivesAt": "23:56",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "23:57",
				"arrivesAt": "00:09",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15071",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Triaj",
				"leavesAt": "15:20",
				"arrivesAt": "16:05",
				"waitsAtSource": 0,
				"distance": 56600
			},
			{
				"from": "Ploieşti Triaj",
				"to": "Ploieşti Sud",
				"leavesAt": "16:09",
				"arrivesAt": "16:16",
				"waitsAtSource": 240,
				"distance": 3600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "16:17",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "16:51",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Făurei",
				"leavesAt": "17:27",
				"arrivesAt": "18:03",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Făurei",
				"to": "Ianca hc.",
				"leavesAt": "18:04",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Ianca hc.",
				"to": "Brăila",
				"leavesAt": "18:19",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 42400
			},
			{
				"from": "Brăila",
				"to": "Baldovineşti Hm.",
				"leavesAt": "18:53",
				"arrivesAt": "18:59",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Baldovineşti Hm.",
				"to": "Vădeni Hm.",
				"leavesAt": "19:00",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Vădeni Hm.",
				"to": "Barboşi",
				"leavesAt": "19:06",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 7300
			},
			{
				"from": "Barboşi",
				"to": "Galaţi",
				"leavesAt": "19:16",
				"arrivesAt": "19:35",
				"waitsAtSource": 60,
				"distance": 12000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15320",
		"segments": [
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "21:36",
				"arrivesAt": "21:43",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "21:44",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "21:53",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "22:01",
				"arrivesAt": "22:05",
				"waitsAtSource": 30,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15306",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "06:14",
				"arrivesAt": "06:21",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:53",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "06:54",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:16",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "07:17",
				"arrivesAt": "07:23",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "07:24",
				"arrivesAt": "07:29",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:39",
				"waitsAtSource": 480,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:44",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:54",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "07:55",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:16",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "08:24",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "08:31",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15262",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "18:35",
				"arrivesAt": "19:06",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "19:07",
				"arrivesAt": "19:17",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "19:18",
				"arrivesAt": "19:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:30",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:47",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "19:52",
				"arrivesAt": "20:10",
				"waitsAtSource": 30,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181221",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15253",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:28",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "06:29",
				"arrivesAt": "06:33",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "06:34",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "06:57",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "07:04",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "07:14",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181210",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15111",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "16:23",
				"arrivesAt": "16:28",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:38",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "16:39",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "16:44",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "16:59",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:19",
				"waitsAtSource": 540,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "17:26",
				"arrivesAt": "17:34",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "17:35",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "17:44",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "17:49",
				"arrivesAt": "17:55",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "17:56",
				"arrivesAt": "17:59",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:02",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "18:03",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15106",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "10:55",
				"arrivesAt": "10:58",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "10:59",
				"arrivesAt": "11:02",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "11:03",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "11:07",
				"arrivesAt": "11:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "11:13",
				"arrivesAt": "11:16",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "11:17",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "11:26",
				"arrivesAt": "11:36",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "11:37",
				"arrivesAt": "11:41",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "11:42",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "11:48",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "11:55",
				"arrivesAt": "11:59",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "12:00",
				"arrivesAt": "12:06",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "12:07",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "12:12",
				"arrivesAt": "12:17",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "12:18",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "12:29",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15054",
		"segments": [
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "14:53",
				"arrivesAt": "15:25",
				"waitsAtSource": 0,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "15:26",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Periş",
				"leavesAt": "16:02",
				"arrivesAt": "16:29",
				"waitsAtSource": 120,
				"distance": 30000
			},
			{
				"from": "Periş",
				"to": "Bucureşti Nord",
				"leavesAt": "16:30",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 30200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15033",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gârbău Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:27",
				"waitsAtSource": 0,
				"distance": 20200
			},
			{
				"from": "Gârbău Hm.",
				"to": "Aghireş",
				"leavesAt": "09:28",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "09:37",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Huedin",
				"leavesAt": "09:41",
				"arrivesAt": "10:04",
				"waitsAtSource": 30,
				"distance": 18900
			},
			{
				"from": "Huedin",
				"to": "Poieni",
				"leavesAt": "10:05",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 15300
			},
			{
				"from": "Poieni",
				"to": "Ciucea Hm.",
				"leavesAt": "10:20",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:31",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "10:32",
				"arrivesAt": "10:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "10:36",
				"arrivesAt": "10:40",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "10:41",
				"arrivesAt": "10:46",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:49",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "10:50",
				"arrivesAt": "10:55",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "11:00",
				"arrivesAt": "11:08",
				"waitsAtSource": 300,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "11:09",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Aleşd",
				"leavesAt": "11:18",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Aleşd",
				"to": "Oşorhei Hm.",
				"leavesAt": "11:31",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 24800
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea Est",
				"leavesAt": "11:52",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 5800
			},
			{
				"from": "Oradea Est",
				"to": "Oradea",
				"leavesAt": "11:59",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15305",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "06:07",
				"arrivesAt": "06:31",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "06:39",
				"arrivesAt": "06:45",
				"waitsAtSource": 480,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:52",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "06:53",
				"arrivesAt": "06:59",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "07:00",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "07:13",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "07:18",
				"arrivesAt": "07:22",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "07:23",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "07:29",
				"arrivesAt": "07:34",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "07:35",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "07:41",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "07:57",
				"arrivesAt": "08:06",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "08:07",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "08:21",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:43",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "08:44",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15357",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "13:35",
				"arrivesAt": "13:45",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "13:46",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "13:53",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "14:00",
				"arrivesAt": "14:06",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "14:14",
				"arrivesAt": "14:18",
				"waitsAtSource": 480,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "14:19",
				"arrivesAt": "14:24",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "14:25",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "14:31",
				"arrivesAt": "14:36",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:58",
				"waitsAtSource": 960,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "14:59",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "15:04",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "15:10",
				"arrivesAt": "15:19",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "15:28",
				"arrivesAt": "15:31",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "15:32",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "15:39",
				"arrivesAt": "15:43",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "16:01",
				"arrivesAt": "16:05",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15257",
		"segments": [
			{
				"from": "Roşiori Nord",
				"to": "Drăcşenei h.",
				"leavesAt": "10:55",
				"arrivesAt": "11:12",
				"waitsAtSource": 0,
				"distance": 13500
			},
			{
				"from": "Drăcşenei h.",
				"to": "Beuca Sat h.",
				"leavesAt": "11:13",
				"arrivesAt": "11:16",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Beuca Sat h.",
				"to": "Beuca h.",
				"leavesAt": "11:17",
				"arrivesAt": "11:20",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca h.",
				"to": "Zâmbreasca h.",
				"leavesAt": "11:21",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Balaci Hm.",
				"leavesAt": "11:26",
				"arrivesAt": "11:33",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Balaci Hm.",
				"to": "Surduleşti h.",
				"leavesAt": "11:34",
				"arrivesAt": "11:39",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Surduleşti h.",
				"to": "Miroşi",
				"leavesAt": "11:40",
				"arrivesAt": "11:46",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Miroşi",
				"to": "Colţ h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 8100
			},
			{
				"from": "Colţ h.",
				"to": "Costeşti",
				"leavesAt": "11:57",
				"arrivesAt": "12:29",
				"waitsAtSource": 30,
				"distance": 19300
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15172",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "04:22",
				"arrivesAt": "04:34",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "04:35",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "04:41",
				"arrivesAt": "04:44",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "04:45",
				"arrivesAt": "04:48",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "04:49",
				"arrivesAt": "04:51",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "04:58",
				"arrivesAt": "05:04",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "05:18",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "05:37",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "05:43",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15130",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "10:40",
				"arrivesAt": "10:44",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "10:45",
				"arrivesAt": "10:49",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "10:50",
				"arrivesAt": "10:53",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "10:54",
				"arrivesAt": "10:58",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "10:59",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "11:03",
				"arrivesAt": "11:08",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "11:09",
				"arrivesAt": "11:12",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "11:13",
				"arrivesAt": "11:18",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "11:19",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "11:24",
				"arrivesAt": "11:28",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "11:29",
				"arrivesAt": "11:38",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "11:39",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "11:47",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180910",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20180615",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15191",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "21:00",
				"arrivesAt": "21:08",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "21:09",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "21:13",
				"arrivesAt": "21:18",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "21:19",
				"arrivesAt": "21:22",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "21:23",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "21:27",
				"arrivesAt": "21:30",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "21:31",
				"arrivesAt": "21:33",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "21:34",
				"arrivesAt": "21:38",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "21:39",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "21:44",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "21:55",
				"arrivesAt": "21:57",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "21:58",
				"arrivesAt": "22:01",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "22:02",
				"arrivesAt": "22:06",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "22:07",
				"arrivesAt": "22:12",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "22:13",
				"arrivesAt": "22:25",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15173",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "07:35",
				"arrivesAt": "07:43",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:53",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "07:54",
				"arrivesAt": "07:56",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "08:18",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "08:30",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:41",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "08:42",
				"arrivesAt": "08:47",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "08:48",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15135",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "19:50",
				"arrivesAt": "20:13",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "20:19",
				"arrivesAt": "20:23",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "20:24",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "20:36",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "21:07",
				"arrivesAt": "21:12",
				"waitsAtSource": 1080,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "21:14",
				"arrivesAt": "21:21",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "21:22",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "21:31",
				"arrivesAt": "21:35",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:40",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "21:45",
				"arrivesAt": "21:49",
				"waitsAtSource": 300,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "21:50",
				"arrivesAt": "21:53",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "21:54",
				"arrivesAt": "21:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "22:00",
				"arrivesAt": "22:04",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "22:09",
				"arrivesAt": "22:12",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "22:13",
				"arrivesAt": "22:17",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "22:18",
				"arrivesAt": "22:23",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15002",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "03:56",
				"arrivesAt": "04:00",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:05",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "04:06",
				"arrivesAt": "04:09",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "04:10",
				"arrivesAt": "04:16",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "04:17",
				"arrivesAt": "04:22",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "04:23",
				"arrivesAt": "04:29",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "04:30",
				"arrivesAt": "04:33",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "04:34",
				"arrivesAt": "04:37",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "04:38",
				"arrivesAt": "04:41",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "04:42",
				"arrivesAt": "04:51",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "05:04",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "05:11",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "05:16",
				"arrivesAt": "05:21",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "05:39",
				"arrivesAt": "05:44",
				"waitsAtSource": 480,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "05:45",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "05:52",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "05:59",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzău",
				"to": "Ulmeni",
				"leavesAt": "06:24",
				"arrivesAt": "06:38",
				"waitsAtSource": 900,
				"distance": 15400
			},
			{
				"from": "Ulmeni",
				"to": "Săhăteni Hm.",
				"leavesAt": "06:39",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "06:53",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Tomşani hc.",
				"leavesAt": "07:01",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "07:13",
				"arrivesAt": "07:18",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "07:19",
				"arrivesAt": "07:22",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Ploieşti Est",
				"leavesAt": "07:23",
				"arrivesAt": "07:36",
				"waitsAtSource": 30,
				"distance": 10100
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "07:37",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "07:53",
				"arrivesAt": "07:58",
				"waitsAtSource": 540,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "08:05",
				"arrivesAt": "08:12",
				"waitsAtSource": 420,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "08:13",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "08:24",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "08:29",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Bucureşti Nord",
				"leavesAt": "08:35",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 30200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15185",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "16:45",
				"arrivesAt": "16:53",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:16",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "17:21",
				"arrivesAt": "17:25",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "17:26",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:51",
				"waitsAtSource": 540,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:53",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "18:03",
				"arrivesAt": "18:08",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "18:09",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15004",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 480,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "17:21",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "17:25",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "17:35",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "17:46",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "18:15",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "18:34",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buzău",
				"to": "Ulmeni",
				"leavesAt": "19:06",
				"arrivesAt": "19:20",
				"waitsAtSource": 1320,
				"distance": 15400
			},
			{
				"from": "Ulmeni",
				"to": "Săhăteni Hm.",
				"leavesAt": "19:21",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Mizil",
				"leavesAt": "19:34",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Mizil",
				"to": "Tomşani hc.",
				"leavesAt": "19:42",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Tomşani hc.",
				"to": "Cricov Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cricov Hm.",
				"to": "Muru hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Muru hc.",
				"to": "Ploieşti Est",
				"leavesAt": "20:02",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 10100
			},
			{
				"from": "Ploieşti Est",
				"to": "Ploieşti Sud",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 660,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crivina",
				"leavesAt": "20:42",
				"arrivesAt": "20:56",
				"waitsAtSource": 300,
				"distance": 19200
			},
			{
				"from": "Crivina",
				"to": "Periş",
				"leavesAt": "20:57",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Periş",
				"to": "Bucureşti Nord",
				"leavesAt": "21:05",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 30200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15101",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "04:17",
				"arrivesAt": "04:22",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:32",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "04:33",
				"arrivesAt": "04:37",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "04:38",
				"arrivesAt": "04:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "04:48",
				"arrivesAt": "04:52",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "04:53",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "05:06",
				"arrivesAt": "05:11",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "05:12",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "05:20",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "05:29",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "05:33",
				"arrivesAt": "05:39",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "05:40",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte",
				"leavesAt": "05:44",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20180301",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15140",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "04:24",
				"arrivesAt": "04:28",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "04:29",
				"arrivesAt": "04:31",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "04:32",
				"arrivesAt": "04:38",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "04:39",
				"arrivesAt": "04:43",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "04:44",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "04:49",
				"arrivesAt": "04:53",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "04:58",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "05:06",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "05:11",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "05:14",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "05:23",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "05:25",
				"arrivesAt": "05:30",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "05:31",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "05:37",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "05:42",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15304",
		"segments": [
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:18",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "05:28",
				"arrivesAt": "05:34",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "05:35",
				"arrivesAt": "05:40",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "05:56",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "06:01",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "06:37",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15125",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "08:32",
				"arrivesAt": "08:55",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "08:56",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "09:08",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "09:21",
				"arrivesAt": "09:36",
				"waitsAtSource": 120,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "09:48",
				"arrivesAt": "09:53",
				"waitsAtSource": 720,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "09:54",
				"arrivesAt": "10:00",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "10:01",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "10:11",
				"arrivesAt": "10:15",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "10:16",
				"arrivesAt": "10:20",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "10:28",
				"arrivesAt": "10:32",
				"waitsAtSource": 480,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "10:33",
				"arrivesAt": "10:36",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "10:37",
				"arrivesAt": "10:42",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:47",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "10:48",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "10:52",
				"arrivesAt": "10:55",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "10:56",
				"arrivesAt": "11:00",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "11:01",
				"arrivesAt": "11:06",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20180616",
				"to": "20180909",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15031",
		"segments": [
			{
				"from": "Cluj Napoca",
				"to": "Gârbău Hm.",
				"leavesAt": "07:15",
				"arrivesAt": "07:35",
				"waitsAtSource": 0,
				"distance": 20200
			},
			{
				"from": "Gârbău Hm.",
				"to": "Aghireş",
				"leavesAt": "07:36",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Aghireş",
				"to": "Aghireş h.",
				"leavesAt": "07:45",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Aghireş h.",
				"to": "Huedin",
				"leavesAt": "07:49",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 18900
			},
			{
				"from": "Huedin",
				"to": "Poieni",
				"leavesAt": "08:13",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 15300
			},
			{
				"from": "Poieni",
				"to": "Ciucea Hm.",
				"leavesAt": "08:28",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Ciucea Hm.",
				"to": "Negreni h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Lacu Crişului h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:44",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "08:45",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Bulz Hm.",
				"leavesAt": "08:51",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bulz Hm.",
				"to": "Stâna de Vale h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Stâna de Vale h.",
				"to": "Bratca",
				"leavesAt": "09:01",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Bratca",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "09:07",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "09:16",
				"arrivesAt": "09:24",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Aleşd",
				"leavesAt": "09:25",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Aleşd",
				"to": "Oşorhei Hm.",
				"leavesAt": "09:38",
				"arrivesAt": "09:58",
				"waitsAtSource": 60,
				"distance": 24800
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Oradea",
				"leavesAt": "09:59",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 9500
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15180",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "10:54",
				"arrivesAt": "11:06",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "11:07",
				"arrivesAt": "11:11",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "11:12",
				"arrivesAt": "11:16",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "11:17",
				"arrivesAt": "11:21",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:24",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "11:25",
				"arrivesAt": "11:31",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "11:32",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "11:38",
				"arrivesAt": "11:41",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "11:42",
				"arrivesAt": "11:45",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:49",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "11:50",
				"arrivesAt": "11:52",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "11:53",
				"arrivesAt": "11:57",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:00",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "12:01",
				"arrivesAt": "12:07",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "12:08",
				"arrivesAt": "12:12",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "12:13",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15032",
		"segments": [
			{
				"from": "Oradea",
				"to": "Oşorhei Hm.",
				"leavesAt": "04:43",
				"arrivesAt": "04:54",
				"waitsAtSource": 0,
				"distance": 9500
			},
			{
				"from": "Oşorhei Hm.",
				"to": "Tileagd",
				"leavesAt": "04:55",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 13600
			},
			{
				"from": "Tileagd",
				"to": "Aleşd",
				"leavesAt": "05:07",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 11200
			},
			{
				"from": "Aleşd",
				"to": "Vadu Crişului Hm.",
				"leavesAt": "05:18",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 12200
			},
			{
				"from": "Vadu Crişului Hm.",
				"to": "Şuncuiuş Hm.",
				"leavesAt": "05:31",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Şuncuiuş Hm.",
				"to": "Bratca",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Bratca",
				"to": "Bulz Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Bulz Hm.",
				"to": "Piatra Craiului Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Piatra Craiului Hm.",
				"to": "Lacu Crişului h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Lacu Crişului h.",
				"to": "Negreni h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Negreni h.",
				"to": "Ciucea Hm.",
				"leavesAt": "06:10",
				"arrivesAt": "06:14",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ciucea Hm.",
				"to": "Poieni",
				"leavesAt": "06:15",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 7100
			},
			{
				"from": "Poieni",
				"to": "Bologa h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Bologa h.",
				"to": "Brăişoru Hm.",
				"leavesAt": "06:27",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Brăişoru Hm.",
				"to": "Huedin",
				"leavesAt": "06:32",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Huedin",
				"to": "Aghireş h.",
				"leavesAt": "06:41",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 18900
			},
			{
				"from": "Aghireş h.",
				"to": "Aghireş",
				"leavesAt": "07:02",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aghireş",
				"to": "Gârbău Hm.",
				"leavesAt": "07:07",
				"arrivesAt": "07:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Gârbău Hm.",
				"to": "Cluj Napoca",
				"leavesAt": "07:15",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 20200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15136",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "19:17",
				"arrivesAt": "19:21",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "19:22",
				"arrivesAt": "19:26",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:30",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:35",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "19:36",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "19:46",
				"arrivesAt": "19:49",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "19:50",
				"arrivesAt": "19:55",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "19:56",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "20:01",
				"arrivesAt": "20:05",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "20:06",
				"arrivesAt": "20:15",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "20:17",
				"arrivesAt": "20:25",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "20:26",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15314",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:31",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:43",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "16:44",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "16:55",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "17:04",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:23",
				"waitsAtSource": 420,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:57",
				"waitsAtSource": 480,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:08",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:13",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "18:14",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:33",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "18:34",
				"arrivesAt": "18:40",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "18:48",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15317",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "19:40",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "20:54",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:19",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "21:20",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Bereşti Hm.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "21:29",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Tălăşmani h.",
				"leavesAt": "21:34",
				"arrivesAt": "21:42",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Tălăşmani h.",
				"to": "Docăneasa hc.",
				"leavesAt": "21:43",
				"arrivesAt": "21:49",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Docăneasa hc.",
				"to": "Lungeşti h.",
				"leavesAt": "21:50",
				"arrivesAt": "21:53",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Lungeşti h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "21:54",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Griviţa h.",
				"leavesAt": "22:01",
				"arrivesAt": "22:05",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Griviţa h.",
				"to": "Bârlad",
				"leavesAt": "22:06",
				"arrivesAt": "22:14",
				"waitsAtSource": 30,
				"distance": 7100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15133",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "19:15",
				"arrivesAt": "19:20",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "19:22",
				"arrivesAt": "19:29",
				"waitsAtSource": 120,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "19:31",
				"arrivesAt": "19:39",
				"waitsAtSource": 120,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "19:40",
				"arrivesAt": "19:44",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "19:45",
				"arrivesAt": "19:49",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 540,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:06",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "20:18",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "20:22",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "20:31",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15350",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:58",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "04:59",
				"arrivesAt": "05:03",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "05:04",
				"arrivesAt": "05:07",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "05:08",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:20",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "05:21",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "05:28",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:35",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "05:36",
				"arrivesAt": "05:39",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "05:40",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "05:50",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "05:56",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "06:01",
				"arrivesAt": "06:07",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "06:08",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "06:14",
				"arrivesAt": "06:19",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "06:20",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "06:36",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15179",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "12:00",
				"arrivesAt": "12:08",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "12:16",
				"arrivesAt": "12:20",
				"waitsAtSource": 480,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "12:21",
				"arrivesAt": "12:26",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "12:27",
				"arrivesAt": "12:29",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "12:30",
				"arrivesAt": "12:34",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "12:35",
				"arrivesAt": "12:37",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:41",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "12:42",
				"arrivesAt": "12:45",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "12:46",
				"arrivesAt": "12:50",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "12:51",
				"arrivesAt": "12:57",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:09",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:16",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "13:17",
				"arrivesAt": "13:21",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "13:22",
				"arrivesAt": "13:27",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "13:28",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15147",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "13:50",
				"arrivesAt": "13:54",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "14:01",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:12",
				"waitsAtSource": 120,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "14:13",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "14:16",
				"arrivesAt": "14:20",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "14:21",
				"arrivesAt": "14:24",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "14:25",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "14:35",
				"arrivesAt": "14:38",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "14:46",
				"arrivesAt": "14:50",
				"waitsAtSource": 480,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "15:09",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "15:16",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "15:22",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "15:26",
				"arrivesAt": "15:31",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20180702",
				"to": "20180707",
				"daysOfWeek": 351
			},
			{
				"from": "20180709",
				"to": "20180714",
				"daysOfWeek": 351
			},
			{
				"from": "20180716",
				"to": "20180721",
				"daysOfWeek": 351
			},
			{
				"from": "20180723",
				"to": "20180728",
				"daysOfWeek": 351
			},
			{
				"from": "20180730",
				"to": "20180804",
				"daysOfWeek": 351
			},
			{
				"from": "20180806",
				"to": "20180811",
				"daysOfWeek": 351
			},
			{
				"from": "20180813",
				"to": "20180818",
				"daysOfWeek": 351
			},
			{
				"from": "20180820",
				"to": "20180825",
				"daysOfWeek": 351
			},
			{
				"from": "20180827",
				"to": "20180901",
				"daysOfWeek": 351
			},
			{
				"from": "20180903",
				"to": "20180908",
				"daysOfWeek": 351
			},
			{
				"from": "20180910",
				"to": "20180915",
				"daysOfWeek": 351
			},
			{
				"from": "20180917",
				"to": "20180922",
				"daysOfWeek": 351
			},
			{
				"from": "20180924",
				"to": "20181208",
				"daysOfWeek": 351
			},
			{
				"from": "20171210",
				"to": "20180630",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15113",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "18:30",
				"arrivesAt": "18:35",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "18:36",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "18:46",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "18:51",
				"arrivesAt": "18:55",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "18:56",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "19:01",
				"arrivesAt": "19:06",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "19:07",
				"arrivesAt": "19:15",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "19:16",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "19:20",
				"arrivesAt": "19:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "19:26",
				"arrivesAt": "19:34",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "19:35",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "19:44",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "19:49",
				"arrivesAt": "19:55",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "19:56",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "20:00",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "20:03",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20180301",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15095",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "18:37",
				"arrivesAt": "18:47",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Ghergani Hm.",
				"leavesAt": "18:48",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 26500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Titu",
				"leavesAt": "19:28",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Băneşti h.",
				"leavesAt": "19:47",
				"arrivesAt": "19:53",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:57",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "19:58",
				"arrivesAt": "20:01",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "20:13",
				"arrivesAt": "20:21",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15090",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Văcăreşti h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:36",
				"waitsAtSource": 0,
				"distance": 7200
			},
			{
				"from": "Văcăreşti h.",
				"to": "Cazaci h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Cazaci h.",
				"to": "Nucet",
				"leavesAt": "07:43",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Nucet",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Băneşti h.",
				"leavesAt": "07:52",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Băneşti h.",
				"to": "Dâmbovicioara h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Titu",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Titu",
				"to": "Ghergani Hm.",
				"leavesAt": "08:12",
				"arrivesAt": "08:22",
				"waitsAtSource": 240,
				"distance": 12100
			},
			{
				"from": "Ghergani Hm.",
				"to": "Chitila",
				"leavesAt": "08:23",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 26500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Nord",
				"leavesAt": "08:44",
				"arrivesAt": "08:56",
				"waitsAtSource": 60,
				"distance": 9400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15171",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "05:30",
				"arrivesAt": "05:38",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Tânganu h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:55",
				"waitsAtSource": 480,
				"distance": 8600
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "05:56",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "05:59",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:06",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:09",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "06:10",
				"arrivesAt": "06:13",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "06:19",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:38",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "06:39",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "06:47",
				"arrivesAt": "06:51",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "06:52",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "06:58",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15091",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Chitila",
				"leavesAt": "10:20",
				"arrivesAt": "10:30",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Chitila",
				"to": "Ghergani Hm.",
				"leavesAt": "10:31",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 26500
			},
			{
				"from": "Ghergani Hm.",
				"to": "Titu",
				"leavesAt": "11:09",
				"arrivesAt": "11:22",
				"waitsAtSource": 60,
				"distance": 12100
			},
			{
				"from": "Titu",
				"to": "Dâmbovicioara h.",
				"leavesAt": "11:24",
				"arrivesAt": "11:27",
				"waitsAtSource": 120,
				"distance": 2500
			},
			{
				"from": "Dâmbovicioara h.",
				"to": "Băneşti h.",
				"leavesAt": "11:28",
				"arrivesAt": "11:34",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Băneşti h.",
				"to": "Movila Dâmboviţa h.",
				"leavesAt": "11:35",
				"arrivesAt": "11:38",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Movila Dâmboviţa h.",
				"to": "Nucet",
				"leavesAt": "11:39",
				"arrivesAt": "11:42",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Nucet",
				"to": "Cazaci h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Cazaci h.",
				"to": "Văcăreşti h.",
				"leavesAt": "11:48",
				"arrivesAt": "11:53",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Văcăreşti h.",
				"to": "Târgovişte",
				"leavesAt": "11:54",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15134",
		"segments": [
			{
				"from": "Slănic",
				"to": "Prăjani h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:24",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Prăjani h.",
				"to": "Vărbilău hc.",
				"leavesAt": "16:25",
				"arrivesAt": "16:29",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Vărbilău hc.",
				"to": "Vlădeşti h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vlădeşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "16:39",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Mălăeşti h.",
				"leavesAt": "16:43",
				"arrivesAt": "16:48",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Mălăeşti h.",
				"to": "Găvănel hc.",
				"leavesAt": "16:49",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Găvănel hc.",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "16:53",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Plopeni",
				"leavesAt": "17:08",
				"arrivesAt": "17:11",
				"waitsAtSource": 600,
				"distance": 2200
			},
			{
				"from": "Plopeni",
				"to": "Găgeni hc.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Găgeni hc.",
				"to": "Buda",
				"leavesAt": "17:17",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 6800
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "17:32",
				"arrivesAt": "17:39",
				"waitsAtSource": 360,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "17:40",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15105",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "08:11",
				"arrivesAt": "08:16",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "08:17",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "08:27",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "08:32",
				"arrivesAt": "08:36",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Brătăşanca h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Brătăşanca h.",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "I. L. Caragiale",
				"leavesAt": "08:47",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "I. L. Caragiale",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "08:56",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "Mija",
				"leavesAt": "09:00",
				"arrivesAt": "09:05",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Mija",
				"to": "Adânca PM.",
				"leavesAt": "09:06",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Adânca PM.",
				"to": "Răzvad hc.",
				"leavesAt": "09:15",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Răzvad hc.",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Târgovişte Nord",
				"leavesAt": "09:29",
				"arrivesAt": "09:36",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Târgovişte Nord",
				"to": "TEIŞ Hm.",
				"leavesAt": "09:37",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Romlux h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:43",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Romlux h.",
				"to": "Târgovişte",
				"leavesAt": "09:44",
				"arrivesAt": "09:48",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15254",
		"segments": [
			{
				"from": "Costeşti",
				"to": "Colţ h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:46",
				"waitsAtSource": 0,
				"distance": 19300
			},
			{
				"from": "Colţ h.",
				"to": "Miroşi",
				"leavesAt": "08:47",
				"arrivesAt": "08:57",
				"waitsAtSource": 30,
				"distance": 8100
			},
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "08:58",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "09:05",
				"arrivesAt": "09:10",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "09:11",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "09:19",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:27",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "09:32",
				"arrivesAt": "09:50",
				"waitsAtSource": 30,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15114",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "20:29",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "20:33",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "20:37",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "20:43",
				"arrivesAt": "20:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "20:47",
				"arrivesAt": "20:55",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "20:56",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "21:12",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "21:18",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:30",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "21:31",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "21:38",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "21:42",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "21:48",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "21:59",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20180301",
				"to": "20181208",
				"daysOfWeek": 383
			},
			{
				"from": "20171210",
				"to": "20171231",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15354",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "08:31",
				"arrivesAt": "08:35",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "08:36",
				"arrivesAt": "08:40",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:45",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "08:53",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "09:06",
				"arrivesAt": "09:11",
				"waitsAtSource": 480,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "09:12",
				"arrivesAt": "09:15",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "09:16",
				"arrivesAt": "09:19",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "09:20",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "09:24",
				"arrivesAt": "09:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "09:34",
				"arrivesAt": "09:39",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "09:40",
				"arrivesAt": "09:44",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "09:52",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "09:57",
				"arrivesAt": "10:02",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "10:08",
				"arrivesAt": "10:11",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "10:12",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "10:19",
				"arrivesAt": "10:24",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "10:25",
				"arrivesAt": "10:31",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "10:32",
				"arrivesAt": "10:42",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 287
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15183",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "15:35",
				"arrivesAt": "15:43",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "15:58",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "16:10",
				"arrivesAt": "16:13",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "16:14",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "16:19",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:31",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "16:42",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "16:47",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15177",
		"segments": [
			{
				"from": "Titan Sud Hm.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "10:30",
				"arrivesAt": "10:38",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Căldăraru h.",
				"leavesAt": "10:46",
				"arrivesAt": "10:50",
				"waitsAtSource": 480,
				"distance": 3100
			},
			{
				"from": "Căldăraru h.",
				"to": "Tânganu h.",
				"leavesAt": "10:51",
				"arrivesAt": "10:56",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Tânganu h.",
				"to": "Frunzăneşti h.",
				"leavesAt": "10:57",
				"arrivesAt": "11:00",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "11:01",
				"arrivesAt": "11:04",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Plătăreşti hc.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "11:05",
				"arrivesAt": "11:08",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "11:09",
				"arrivesAt": "11:11",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "11:12",
				"arrivesAt": "11:15",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Vasilaţi hc.",
				"leavesAt": "11:16",
				"arrivesAt": "11:20",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Budeşti Hm.",
				"leavesAt": "11:21",
				"arrivesAt": "11:27",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Budeşti Hm.",
				"to": "Negoieşti h.",
				"leavesAt": "11:35",
				"arrivesAt": "11:39",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Negoieşti h.",
				"to": "Şoldanu h.",
				"leavesAt": "11:40",
				"arrivesAt": "11:41",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Şoldanu h.",
				"to": "Luica h.",
				"leavesAt": "11:42",
				"arrivesAt": "11:46",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Luica h.",
				"to": "Curcani h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:50",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Curcani h.",
				"to": "Valea Roşie hc.",
				"leavesAt": "11:51",
				"arrivesAt": "11:56",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Olteniţa",
				"leavesAt": "11:57",
				"arrivesAt": "12:09",
				"waitsAtSource": 30,
				"distance": 9900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 319
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15153",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "19:34",
				"arrivesAt": "19:38",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "19:39",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "19:45",
				"arrivesAt": "19:50",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "19:56",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "20:18",
				"arrivesAt": "20:21",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "20:27",
				"arrivesAt": "20:31",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "20:38",
				"arrivesAt": "20:44",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "20:58",
				"arrivesAt": "21:01",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "21:02",
				"arrivesAt": "21:07",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15308",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:15",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "09:16",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "09:21",
				"arrivesAt": "09:27",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "09:28",
				"arrivesAt": "09:31",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:38",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:47",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "09:48",
				"arrivesAt": "09:52",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "10:01",
				"arrivesAt": "10:09",
				"waitsAtSource": 540,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:18",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "10:19",
				"arrivesAt": "10:25",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "10:26",
				"arrivesAt": "10:31",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "10:32",
				"arrivesAt": "10:35",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "10:36",
				"arrivesAt": "10:41",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "10:42",
				"arrivesAt": "10:46",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:51",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "10:52",
				"arrivesAt": "11:00",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "11:01",
				"arrivesAt": "11:07",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "11:08",
				"arrivesAt": "11:14",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:21",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "11:22",
				"arrivesAt": "11:28",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "11:29",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15321",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "19:40",
				"arrivesAt": "20:04",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:18",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "20:25",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:42",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "20:54",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Târgu Bujor",
				"to": "Moscu hc.",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moscu hc.",
				"to": "Roşcani h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Roşcani h.",
				"to": "Balinteşti h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:19",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Balinteşti h.",
				"to": "Bereşti Hm.",
				"leavesAt": "21:20",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 7200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15100",
		"segments": [
			{
				"from": "Târgovişte",
				"to": "Romlux h.",
				"leavesAt": "04:05",
				"arrivesAt": "04:08",
				"waitsAtSource": 0,
				"distance": 2100
			},
			{
				"from": "Romlux h.",
				"to": "TEIŞ Hm.",
				"leavesAt": "04:09",
				"arrivesAt": "04:12",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "TEIŞ Hm.",
				"to": "Târgovişte Nord",
				"leavesAt": "04:13",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Târgovişte Nord",
				"to": "Valea Voievozilor hc.",
				"leavesAt": "04:17",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Valea Voievozilor hc.",
				"to": "Răzvad hc.",
				"leavesAt": "04:23",
				"arrivesAt": "04:26",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Răzvad hc.",
				"to": "Adânca PM.",
				"leavesAt": "04:27",
				"arrivesAt": "04:35",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Adânca PM.",
				"to": "Mija",
				"leavesAt": "04:36",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Mija",
				"to": "I. L. Caragiale Vest h.",
				"leavesAt": "04:47",
				"arrivesAt": "04:51",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "I. L. Caragiale Vest h.",
				"to": "I. L. Caragiale",
				"leavesAt": "04:52",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "I. L. Caragiale",
				"to": "P. mac. Zalhanaua",
				"leavesAt": "05:05",
				"arrivesAt": "05:11",
				"waitsAtSource": 480,
				"distance": 5000
			},
			{
				"from": "P. mac. Zalhanaua",
				"to": "Brătăşanca h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Brătăşanca h.",
				"to": "Târgşoru Nou Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:23",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Târgşoru Nou Hm.",
				"to": "Crângu Lui Tei hc.",
				"leavesAt": "05:24",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Crângu Lui Tei hc.",
				"to": "Crângu Lui Bot Hm.",
				"leavesAt": "05:28",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Crângu Lui Bot Hm.",
				"to": "Ploieşti Vest",
				"leavesAt": "05:34",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "05:45",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15250",
		"segments": [
			{
				"from": "Miroşi",
				"to": "Surduleşti h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:24",
				"waitsAtSource": 0,
				"distance": 4700
			},
			{
				"from": "Surduleşti h.",
				"to": "Balaci Hm.",
				"leavesAt": "04:25",
				"arrivesAt": "04:30",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Balaci Hm.",
				"to": "Zâmbreasca h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:57",
				"waitsAtSource": 1200,
				"distance": 5900
			},
			{
				"from": "Zâmbreasca h.",
				"to": "Beuca h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:02",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Beuca h.",
				"to": "Beuca Sat h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:06",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Beuca Sat h.",
				"to": "Drăcşenei h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Drăcşenei h.",
				"to": "Roşiori Nord",
				"leavesAt": "05:12",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 13500
			}
		],
		"restrictions": [
			{
				"from": "20170515",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15349",
		"segments": [
			{
				"from": "Buzău",
				"to": "Verneşti",
				"leavesAt": "05:05",
				"arrivesAt": "05:20",
				"waitsAtSource": 0,
				"distance": 12400
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "05:21",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:35",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "05:41",
				"arrivesAt": "05:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "05:47",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "05:53",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "06:30",
				"arrivesAt": "06:37",
				"waitsAtSource": 1920,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "06:38",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "06:44",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "06:50",
				"arrivesAt": "07:00",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:04",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:09",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "07:10",
				"arrivesAt": "07:13",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:21",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "07:34",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "07:38",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "07:43",
				"arrivesAt": "07:47",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15319",
		"segments": [
			{
				"from": "Galaţi",
				"to": "Tuluceşti Hm.",
				"leavesAt": "20:20",
				"arrivesAt": "20:44",
				"waitsAtSource": 0,
				"distance": 13600
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Şiviţa h.",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Stoicani h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stoicani h.",
				"to": "Folteşti Hm.",
				"leavesAt": "21:06",
				"arrivesAt": "21:11",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Folteşti Hm.",
				"to": "Chiraftei h.",
				"leavesAt": "21:12",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chiraftei h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "21:19",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Băleni h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Băleni h.",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "21:29",
				"arrivesAt": "21:34",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Târgu Bujor",
				"leavesAt": "21:35",
				"arrivesAt": "21:38",
				"waitsAtSource": 30,
				"distance": 2100
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15353",
		"segments": [
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "09:36",
				"arrivesAt": "09:46",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "09:47",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "09:54",
				"arrivesAt": "10:00",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "10:01",
				"arrivesAt": "10:07",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "10:15",
				"arrivesAt": "10:18",
				"waitsAtSource": 480,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "10:19",
				"arrivesAt": "10:23",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "10:24",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "10:29",
				"arrivesAt": "10:34",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "10:35",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "10:42",
				"arrivesAt": "10:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "10:47",
				"arrivesAt": "10:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "10:53",
				"arrivesAt": "11:02",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "11:03",
				"arrivesAt": "11:06",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "11:07",
				"arrivesAt": "11:10",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "11:11",
				"arrivesAt": "11:14",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "11:15",
				"arrivesAt": "11:21",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:26",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "11:27",
				"arrivesAt": "11:33",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "11:34",
				"arrivesAt": "11:37",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "11:38",
				"arrivesAt": "11:42",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "11:43",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15356",
		"segments": [
			{
				"from": "Nehoiaşu",
				"to": "Nehoiu h.",
				"leavesAt": "10:48",
				"arrivesAt": "10:52",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "Nehoiu h.",
				"to": "Păltineni h.",
				"leavesAt": "10:53",
				"arrivesAt": "10:57",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Păltineni h.",
				"to": "Şeţu h.",
				"leavesAt": "10:58",
				"arrivesAt": "11:01",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Şeţu h.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "11:02",
				"arrivesAt": "11:08",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "11:09",
				"arrivesAt": "11:14",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "11:24",
				"arrivesAt": "11:30",
				"waitsAtSource": 600,
				"distance": 4000
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Valea Seacă h.",
				"leavesAt": "11:31",
				"arrivesAt": "11:34",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Valea Seacă h.",
				"to": "Gura Bascii h.",
				"leavesAt": "11:35",
				"arrivesAt": "11:38",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Gura Bascii h.",
				"to": "Cislău hcv.",
				"leavesAt": "11:39",
				"arrivesAt": "11:42",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Cislău hcv.",
				"to": "Vipereşti hc.",
				"leavesAt": "11:43",
				"arrivesAt": "11:52",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Vipereşti hc.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "11:53",
				"arrivesAt": "11:58",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Bădila h.",
				"leavesAt": "11:59",
				"arrivesAt": "12:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Bădila h.",
				"to": "Pârscov",
				"leavesAt": "12:04",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pârscov",
				"to": "Măgura hcv.",
				"leavesAt": "12:11",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Măgura hcv.",
				"to": "Unguriu hc.",
				"leavesAt": "12:17",
				"arrivesAt": "12:22",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Unguriu hc.",
				"to": "Ojasca h.",
				"leavesAt": "12:23",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Ojasca h.",
				"to": "Berca Hm.",
				"leavesAt": "12:28",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Berca Hm.",
				"to": "Cândeşti hc.",
				"leavesAt": "12:33",
				"arrivesAt": "12:38",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Cândeşti hc.",
				"to": "Verneşti",
				"leavesAt": "12:39",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Verneşti",
				"to": "Buzău Nord Hm.",
				"leavesAt": "12:47",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Buzău",
				"leavesAt": "12:54",
				"arrivesAt": "13:04",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15156",
		"segments": [
			{
				"from": "Măneciu",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "17:25",
				"arrivesAt": "17:29",
				"waitsAtSource": 0,
				"distance": 2700
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Izvoarele hc.",
				"leavesAt": "17:30",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Homorâciu P.M.",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Teişani Hm.",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Teişani Hm.",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "17:45",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Vălenii de Munte",
				"leavesAt": "17:50",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Vălenii de Munte",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "17:55",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Făget Teleajen",
				"leavesAt": "17:59",
				"arrivesAt": "18:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Făget Teleajen",
				"to": "Măgurele Nord h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:14",
				"waitsAtSource": 540,
				"distance": 1700
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:19",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Sud h.",
				"leavesAt": "18:20",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Lipăneşti hc.",
				"leavesAt": "18:23",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Boldeşti hc.",
				"leavesAt": "18:27",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Boldeşti hc.",
				"to": "Scăieni h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:33",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Scăieni h.",
				"to": "Blejoi",
				"leavesAt": "18:34",
				"arrivesAt": "18:39",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Blejoi",
				"to": "Ploieşti Nord",
				"leavesAt": "18:40",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Ploieşti Nord",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "18:46",
				"arrivesAt": "18:50",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Sud",
				"leavesAt": "18:51",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 351
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15003",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "17:22",
				"arrivesAt": "17:46",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "17:59",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Vest",
				"leavesAt": "18:11",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "18:24",
				"arrivesAt": "18:29",
				"waitsAtSource": 360,
				"distance": 3000
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Est",
				"leavesAt": "18:33",
				"arrivesAt": "18:39",
				"waitsAtSource": 240,
				"distance": 4300
			},
			{
				"from": "Ploieşti Est",
				"to": "Muru hc.",
				"leavesAt": "18:40",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 10100
			},
			{
				"from": "Muru hc.",
				"to": "Cricov Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:55",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Cricov Hm.",
				"to": "Tomşani hc.",
				"leavesAt": "18:56",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Tomşani hc.",
				"to": "Mizil",
				"leavesAt": "19:02",
				"arrivesAt": "19:14",
				"waitsAtSource": 30,
				"distance": 12100
			},
			{
				"from": "Mizil",
				"to": "Săhăteni Hm.",
				"leavesAt": "19:15",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Săhăteni Hm.",
				"to": "Ulmeni",
				"leavesAt": "19:27",
				"arrivesAt": "19:38",
				"waitsAtSource": 60,
				"distance": 12000
			},
			{
				"from": "Ulmeni",
				"to": "Buzău",
				"leavesAt": "19:39",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 15400
			},
			{
				"from": "Buzău",
				"to": "Buzău Nord Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:27",
				"waitsAtSource": 1260,
				"distance": 6900
			},
			{
				"from": "Buzău Nord Hm.",
				"to": "Verneşti",
				"leavesAt": "20:28",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Verneşti",
				"to": "Cândeşti hc.",
				"leavesAt": "20:36",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Cândeşti hc.",
				"to": "Berca Hm.",
				"leavesAt": "20:43",
				"arrivesAt": "20:49",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Berca Hm.",
				"to": "Ojasca h.",
				"leavesAt": "20:50",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ojasca h.",
				"to": "Unguriu hc.",
				"leavesAt": "20:54",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Unguriu hc.",
				"to": "Măgura hcv.",
				"leavesAt": "20:59",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Măgura hcv.",
				"to": "Pârscov",
				"leavesAt": "21:05",
				"arrivesAt": "21:10",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Pârscov",
				"to": "Bădila h.",
				"leavesAt": "21:20",
				"arrivesAt": "21:26",
				"waitsAtSource": 600,
				"distance": 4300
			},
			{
				"from": "Bădila h.",
				"to": "Ruşavăţu hc.",
				"leavesAt": "21:27",
				"arrivesAt": "21:31",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Ruşavăţu hc.",
				"to": "Vipereşti hc.",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Vipereşti hc.",
				"to": "Cislău hcv.",
				"leavesAt": "21:38",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Cislău hcv.",
				"to": "Gura Bascii h.",
				"leavesAt": "21:48",
				"arrivesAt": "21:51",
				"waitsAtSource": 30,
				"distance": 1780
			},
			{
				"from": "Gura Bascii h.",
				"to": "Valea Seacă h.",
				"leavesAt": "21:52",
				"arrivesAt": "21:55",
				"waitsAtSource": 30,
				"distance": 2120
			},
			{
				"from": "Valea Seacă h.",
				"to": "Mărunţişu hcv.",
				"leavesAt": "21:56",
				"arrivesAt": "21:59",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Mărunţişu hcv.",
				"to": "Pătârlagele Hm.",
				"leavesAt": "22:00",
				"arrivesAt": "22:06",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Pătârlagele Hm.",
				"to": "Valea Sibiciului h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Valea Sibiciului h.",
				"to": "Şeţu h.",
				"leavesAt": "22:12",
				"arrivesAt": "22:18",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şeţu h.",
				"to": "Păltineni h.",
				"leavesAt": "22:19",
				"arrivesAt": "22:23",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Păltineni h.",
				"to": "Nehoiu h.",
				"leavesAt": "22:24",
				"arrivesAt": "22:28",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Nehoiu h.",
				"to": "Nehoiaşu",
				"leavesAt": "22:29",
				"arrivesAt": "22:33",
				"waitsAtSource": 30,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15123",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "08:02",
				"arrivesAt": "08:07",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "08:08",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "08:16",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "08:25",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "08:30",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 480,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "09:06",
				"arrivesAt": "09:09",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "09:15",
				"arrivesAt": "09:20",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15131",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "16:37",
				"arrivesAt": "16:45",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Găgeni hc.",
				"leavesAt": "16:46",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 6800
			},
			{
				"from": "Găgeni hc.",
				"to": "Plopeni",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Plopeni",
				"to": "Plopeni Sat Hm.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Plopeni Sat Hm.",
				"to": "Găvănel hc.",
				"leavesAt": "17:05",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Găvănel hc.",
				"to": "Mălăeşti h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:13",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Mălăeşti h.",
				"to": "Coţofeneşti h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:19",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Coţofeneşti h.",
				"to": "Poiana Slănic h.",
				"leavesAt": "17:20",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Poiana Slănic h.",
				"to": "Vlădeşti h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Vlădeşti h.",
				"to": "Vărbilău hc.",
				"leavesAt": "17:29",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vărbilău hc.",
				"to": "Prăjani h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Prăjani h.",
				"to": "Slănic",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "TFC",
		"number": "15053",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Periş",
				"leavesAt": "12:40",
				"arrivesAt": "13:03",
				"waitsAtSource": 0,
				"distance": 30200
			},
			{
				"from": "Periş",
				"to": "Crivina",
				"leavesAt": "13:04",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "13:13",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Sud",
				"leavesAt": "13:26",
				"arrivesAt": "13:40",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "13:41",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "14:15",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 35000
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15157",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Ploiesti Est Post 1",
				"leavesAt": "21:17",
				"arrivesAt": "21:21",
				"waitsAtSource": 0,
				"distance": 3200
			},
			{
				"from": "Ploiesti Est Post 1",
				"to": "Ploieşti Nord",
				"leavesAt": "21:22",
				"arrivesAt": "21:27",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Ploieşti Nord",
				"to": "Blejoi",
				"leavesAt": "21:28",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Blejoi",
				"to": "Scăieni h.",
				"leavesAt": "21:36",
				"arrivesAt": "21:40",
				"waitsAtSource": 180,
				"distance": 3800
			},
			{
				"from": "Scăieni h.",
				"to": "Boldeşti hc.",
				"leavesAt": "21:41",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Boldeşti hc.",
				"to": "Lipăneşti hc.",
				"leavesAt": "21:44",
				"arrivesAt": "21:48",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lipăneşti hc.",
				"to": "Măgurele Sud h.",
				"leavesAt": "21:49",
				"arrivesAt": "21:52",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Măgurele Sud h.",
				"to": "Măgurele Prahova h.",
				"leavesAt": "21:53",
				"arrivesAt": "21:57",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Măgurele Prahova h.",
				"to": "Măgurele Nord h.",
				"leavesAt": "21:58",
				"arrivesAt": "22:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Măgurele Nord h.",
				"to": "Făget Teleajen",
				"leavesAt": "22:03",
				"arrivesAt": "22:06",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Făget Teleajen",
				"to": "PO Gura Vitioarei h.",
				"leavesAt": "22:07",
				"arrivesAt": "22:11",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "PO Gura Vitioarei h.",
				"to": "Vălenii de Munte",
				"leavesAt": "22:12",
				"arrivesAt": "22:16",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Vălenii de Munte",
				"to": "P.mac. Văleni Nord",
				"leavesAt": "22:17",
				"arrivesAt": "22:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "P.mac. Văleni Nord",
				"to": "Teişani Hm.",
				"leavesAt": "22:23",
				"arrivesAt": "22:29",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Teişani Hm.",
				"to": "Homorâciu P.M.",
				"leavesAt": "22:30",
				"arrivesAt": "22:36",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Homorâciu P.M.",
				"to": "Izvoarele hc.",
				"leavesAt": "22:37",
				"arrivesAt": "22:42",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Izvoarele hc.",
				"to": "Măneciu Pamânteni hc.",
				"leavesAt": "22:43",
				"arrivesAt": "22:46",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Măneciu Pamânteni hc.",
				"to": "Măneciu",
				"leavesAt": "22:47",
				"arrivesAt": "22:52",
				"waitsAtSource": 30,
				"distance": 2700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15174",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "05:54",
				"arrivesAt": "06:05",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:20",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "06:36",
				"arrivesAt": "06:39",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "06:44",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "06:48",
				"arrivesAt": "06:51",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "06:57",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "07:07",
				"arrivesAt": "07:12",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "07:13",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15316",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "19:18",
				"arrivesAt": "19:25",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "19:26",
				"arrivesAt": "19:30",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "19:31",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "19:38",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:48",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "19:49",
				"arrivesAt": "19:57",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "20:03",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:20",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "20:21",
				"arrivesAt": "20:27",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "20:28",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 3200
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15186",
		"segments": [
			{
				"from": "Olteniţa",
				"to": "Valea Roşie hc.",
				"leavesAt": "17:09",
				"arrivesAt": "17:21",
				"waitsAtSource": 0,
				"distance": 9900
			},
			{
				"from": "Valea Roşie hc.",
				"to": "Curcani h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Curcani h.",
				"to": "Luica h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:31",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Luica h.",
				"to": "Şoldanu h.",
				"leavesAt": "17:32",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Şoldanu h.",
				"to": "Negoieşti h.",
				"leavesAt": "17:36",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 1100
			},
			{
				"from": "Negoieşti h.",
				"to": "Budeşti Hm.",
				"leavesAt": "17:39",
				"arrivesAt": "17:43",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Budeşti Hm.",
				"to": "Vasilaţi hc.",
				"leavesAt": "17:44",
				"arrivesAt": "17:49",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Vasilaţi hc.",
				"to": "Gălbinaşi hc.",
				"leavesAt": "17:50",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Gălbinaşi hc.",
				"to": "Cucuieţi Sudiţi h.",
				"leavesAt": "17:55",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Cucuieţi Sudiţi h.",
				"to": "PO Podu Pitarului h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "PO Podu Pitarului h.",
				"to": "Plătăreşti hc.",
				"leavesAt": "18:02",
				"arrivesAt": "18:05",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Plătăreşti hc.",
				"to": "Frunzăneşti h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Frunzăneşti h.",
				"to": "Tânganu h.",
				"leavesAt": "18:11",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Tânganu h.",
				"to": "Căldăraru h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Căldăraru h.",
				"to": "Buc. Sud Gr. Călători",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Buc. Sud Gr. Călători",
				"to": "Titan Sud Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "TFC",
		"number": "15310",
		"segments": [
			{
				"from": "Bârlad",
				"to": "Griviţa h.",
				"leavesAt": "11:14",
				"arrivesAt": "11:21",
				"waitsAtSource": 0,
				"distance": 7100
			},
			{
				"from": "Griviţa h.",
				"to": "Bălăbăneşti h.",
				"leavesAt": "11:22",
				"arrivesAt": "11:26",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bălăbăneşti h.",
				"to": "Lungeşti h.",
				"leavesAt": "11:27",
				"arrivesAt": "11:33",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Lungeşti h.",
				"to": "Docăneasa hc.",
				"leavesAt": "11:34",
				"arrivesAt": "11:37",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Docăneasa hc.",
				"to": "Tălăşmani h.",
				"leavesAt": "11:38",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 5000
			},
			{
				"from": "Tălăşmani h.",
				"to": "Bereşti Tunel h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:53",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Bereşti Tunel h.",
				"to": "Bereşti Hm.",
				"leavesAt": "11:54",
				"arrivesAt": "11:58",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Bereşti Hm.",
				"to": "Balinteşti h.",
				"leavesAt": "12:06",
				"arrivesAt": "12:14",
				"waitsAtSource": 480,
				"distance": 7200
			},
			{
				"from": "Balinteşti h.",
				"to": "Roşcani h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:23",
				"waitsAtSource": 30,
				"distance": 7900
			},
			{
				"from": "Roşcani h.",
				"to": "Moscu hc.",
				"leavesAt": "12:24",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Moscu hc.",
				"to": "Târgu Bujor",
				"leavesAt": "12:31",
				"arrivesAt": "12:36",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Târgu Bujor",
				"to": "Umbrăreşti Sat h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Umbrăreşti Sat h.",
				"to": "Băleni h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Băleni h.",
				"to": "Fârţăneşti h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:51",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Fârţăneşti h.",
				"to": "Chiraftei h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Chiraftei h.",
				"to": "Folteşti Hm.",
				"leavesAt": "12:57",
				"arrivesAt": "13:04",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Folteşti Hm.",
				"to": "Stoicani h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Stoicani h.",
				"to": "Frumuşiţa h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:18",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Frumuşiţa h.",
				"to": "Şiviţa h.",
				"leavesAt": "13:19",
				"arrivesAt": "13:25",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Şiviţa h.",
				"to": "Tuluceşti Hm.",
				"leavesAt": "13:26",
				"arrivesAt": "13:33",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tuluceşti Hm.",
				"to": "Galaţi",
				"leavesAt": "13:34",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 13600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15982",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "06:50",
				"arrivesAt": "07:30",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "07:32",
				"arrivesAt": "08:16",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "08:18",
				"arrivesAt": "09:02",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "09:03",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 50900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ciulniţa",
				"leavesAt": "10:20",
				"arrivesAt": "11:13",
				"waitsAtSource": 1560,
				"distance": 108900
			},
			{
				"from": "Ciulniţa",
				"to": "Feteşti",
				"leavesAt": "11:14",
				"arrivesAt": "11:33",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Feteşti",
				"to": "Cernavodă Pod",
				"leavesAt": "11:35",
				"arrivesAt": "11:53",
				"waitsAtSource": 120,
				"distance": 20000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Medgidia",
				"leavesAt": "11:54",
				"arrivesAt": "12:09",
				"waitsAtSource": 60,
				"distance": 24000
			},
			{
				"from": "Medgidia",
				"to": "Constanţa",
				"leavesAt": "12:10",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 34600
			}
		],
		"restrictions": [
			{
				"from": "20180420",
				"to": "20180915",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15939",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "16:10",
				"arrivesAt": "16:50",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "16:52",
				"arrivesAt": "17:36",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "17:38",
				"arrivesAt": "18:22",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "18:23",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 50900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "19:38",
				"arrivesAt": "20:17",
				"waitsAtSource": 1440,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "20:19",
				"arrivesAt": "20:43",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "20:44",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "21:08",
				"arrivesAt": "21:16",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "21:17",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "21:23",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "21:34",
				"arrivesAt": "22:12",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20180901",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "SFT",
		"number": "15994",
		"segments": [
			{
				"from": "Motru Est Gr. Călători",
				"to": "Motru Est",
				"leavesAt": "19:40",
				"arrivesAt": "19:47",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Motru Est",
				"to": "Samarineşti h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Samarineşti h.",
				"to": "Corcova h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:57",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Corcova h.",
				"to": "Ceramica h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ceramica h.",
				"to": "Jirov Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:14",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jirov Hm.",
				"to": "Cernaia h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cernaia h.",
				"to": "Comanda h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comanda h.",
				"to": "Strehaia Nord h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:29",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Strehaia Nord h.",
				"to": "Strehaia",
				"leavesAt": "20:30",
				"arrivesAt": "20:34",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Strehaia",
				"to": "Lunca Banului h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Lunca Banului h.",
				"to": "Butoieşti Hm.",
				"leavesAt": "20:40",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Gura Motrului Hm.",
				"leavesAt": "20:48",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Filiaşi",
				"leavesAt": "20:56",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:08",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "21:09",
				"arrivesAt": "21:13",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "21:14",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "21:19",
				"arrivesAt": "21:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "21:29",
				"arrivesAt": "21:34",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "21:35",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "21:38",
				"arrivesAt": "21:42",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "21:43",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "21:47",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15931",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "05:55",
				"arrivesAt": "06:34",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "06:35",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "07:21",
				"arrivesAt": "08:05",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "08:25",
				"arrivesAt": "09:16",
				"waitsAtSource": 1200,
				"distance": 50900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "09:28",
				"arrivesAt": "10:05",
				"waitsAtSource": 720,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "10:06",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "10:29",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "10:52",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "11:00",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "11:06",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "11:17",
				"arrivesAt": "11:55",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20180331",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15984",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Medgidia",
				"leavesAt": "16:00",
				"arrivesAt": "16:23",
				"waitsAtSource": 0,
				"distance": 34600
			},
			{
				"from": "Medgidia",
				"to": "Cernavodă Pod",
				"leavesAt": "16:25",
				"arrivesAt": "16:42",
				"waitsAtSource": 120,
				"distance": 24000
			},
			{
				"from": "Cernavodă Pod",
				"to": "Feteşti",
				"leavesAt": "16:43",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 20000
			},
			{
				"from": "Feteşti",
				"to": "Ciulniţa",
				"leavesAt": "17:00",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 37500
			},
			{
				"from": "Ciulniţa",
				"to": "Bucureşti Nord",
				"leavesAt": "17:22",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 108900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Chiajna",
				"leavesAt": "18:32",
				"arrivesAt": "18:44",
				"waitsAtSource": 1080,
				"distance": 9000
			},
			{
				"from": "Chiajna",
				"to": "Videle",
				"leavesAt": "18:55",
				"arrivesAt": "19:36",
				"waitsAtSource": 660,
				"distance": 41900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "19:37",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "20:24",
				"arrivesAt": "21:12",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "21:13",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20180420",
				"to": "20180915",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15935",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "06:10",
				"arrivesAt": "06:50",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "06:52",
				"arrivesAt": "07:36",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "07:38",
				"arrivesAt": "08:23",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "08:25",
				"arrivesAt": "09:16",
				"waitsAtSource": 120,
				"distance": 50900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "09:28",
				"arrivesAt": "10:05",
				"waitsAtSource": 720,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "10:06",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "10:29",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "10:52",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "11:00",
				"arrivesAt": "11:05",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "11:06",
				"arrivesAt": "11:15",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "11:17",
				"arrivesAt": "11:55",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20180401",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15937",
		"segments": [
			{
				"from": "Craiova",
				"to": "Caracal",
				"leavesAt": "06:50",
				"arrivesAt": "07:30",
				"waitsAtSource": 0,
				"distance": 53600
			},
			{
				"from": "Caracal",
				"to": "Roşiori Nord",
				"leavesAt": "07:32",
				"arrivesAt": "08:16",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Roşiori Nord",
				"to": "Videle",
				"leavesAt": "08:18",
				"arrivesAt": "09:02",
				"waitsAtSource": 120,
				"distance": 49200
			},
			{
				"from": "Videle",
				"to": "Bucureşti Nord",
				"leavesAt": "09:03",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 50900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Ploieşti Vest",
				"leavesAt": "10:30",
				"arrivesAt": "11:09",
				"waitsAtSource": 2160,
				"distance": 58900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Câmpina",
				"leavesAt": "11:11",
				"arrivesAt": "11:34",
				"waitsAtSource": 120,
				"distance": 32800
			},
			{
				"from": "Câmpina",
				"to": "Sinaia",
				"leavesAt": "11:35",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 29300
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "11:58",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "12:06",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "12:12",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "12:22",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20180401",
				"to": "20180419",
				"daysOfWeek": 383
			},
			{
				"from": "20180916",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "SFT",
		"number": "15993",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "17:00",
				"arrivesAt": "17:04",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "17:05",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "17:09",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "17:14",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "17:22",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "17:32",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "17:42",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Gura Motrului Hm.",
				"leavesAt": "17:48",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Butoieşti Hm.",
				"leavesAt": "17:57",
				"arrivesAt": "18:03",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Lunca Banului h.",
				"leavesAt": "18:04",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lunca Banului h.",
				"to": "Strehaia",
				"leavesAt": "18:10",
				"arrivesAt": "18:15",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Strehaia",
				"to": "Strehaia Nord h.",
				"leavesAt": "18:16",
				"arrivesAt": "18:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strehaia Nord h.",
				"to": "Comanda h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Comanda h.",
				"to": "Cernaia h.",
				"leavesAt": "18:26",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Cernaia h.",
				"to": "Jirov Hm.",
				"leavesAt": "18:31",
				"arrivesAt": "18:35",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Jirov Hm.",
				"to": "Ceramica h.",
				"leavesAt": "18:36",
				"arrivesAt": "18:40",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ceramica h.",
				"to": "Corcova h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Corcova h.",
				"to": "Samarineşti h.",
				"leavesAt": "18:46",
				"arrivesAt": "18:49",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Samarineşti h.",
				"to": "Motru Est",
				"leavesAt": "18:50",
				"arrivesAt": "19:03",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Motru Est",
				"to": "Motru Est Gr. Călători",
				"leavesAt": "19:05",
				"arrivesAt": "19:12",
				"waitsAtSource": 120,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15932",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "14:55",
				"arrivesAt": "15:29",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "15:31",
				"arrivesAt": "15:39",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "15:40",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "15:46",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "15:56",
				"arrivesAt": "16:19",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "16:20",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "16:44",
				"arrivesAt": "17:24",
				"waitsAtSource": 120,
				"distance": 58900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "17:42",
				"arrivesAt": "18:33",
				"waitsAtSource": 1080,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "18:34",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "19:21",
				"arrivesAt": "20:08",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "20:09",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "SFT",
		"number": "15936",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "07:10",
				"arrivesAt": "07:45",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "07:46",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "07:55",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "08:02",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Câmpina",
				"leavesAt": "08:12",
				"arrivesAt": "08:35",
				"waitsAtSource": 120,
				"distance": 29300
			},
			{
				"from": "Câmpina",
				"to": "Ploieşti Vest",
				"leavesAt": "08:36",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 32800
			},
			{
				"from": "Ploieşti Vest",
				"to": "Bucureşti Nord",
				"leavesAt": "09:01",
				"arrivesAt": "09:43",
				"waitsAtSource": 120,
				"distance": 58900
			},
			{
				"from": "Bucureşti Nord",
				"to": "Videle",
				"leavesAt": "09:55",
				"arrivesAt": "10:45",
				"waitsAtSource": 720,
				"distance": 50900
			},
			{
				"from": "Videle",
				"to": "Roşiori Nord",
				"leavesAt": "10:46",
				"arrivesAt": "11:31",
				"waitsAtSource": 60,
				"distance": 49200
			},
			{
				"from": "Roşiori Nord",
				"to": "Caracal",
				"leavesAt": "11:33",
				"arrivesAt": "12:20",
				"waitsAtSource": 120,
				"distance": 55300
			},
			{
				"from": "Caracal",
				"to": "Craiova",
				"leavesAt": "12:21",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 53600
			}
		],
		"restrictions": [
			{
				"from": "20180901",
				"to": "20181208",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "SFT",
		"number": "15992",
		"segments": [
			{
				"from": "Motru Est Gr. Călători",
				"to": "Motru Est",
				"leavesAt": "07:40",
				"arrivesAt": "07:47",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Motru Est",
				"to": "Samarineşti h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Samarineşti h.",
				"to": "Corcova h.",
				"leavesAt": "07:54",
				"arrivesAt": "07:57",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Corcova h.",
				"to": "Ceramica h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Ceramica h.",
				"to": "Jirov Hm.",
				"leavesAt": "08:03",
				"arrivesAt": "08:14",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Jirov Hm.",
				"to": "Cernaia h.",
				"leavesAt": "08:15",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cernaia h.",
				"to": "Comanda h.",
				"leavesAt": "08:20",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comanda h.",
				"to": "Strehaia Nord h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Strehaia Nord h.",
				"to": "Strehaia",
				"leavesAt": "08:30",
				"arrivesAt": "08:34",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Strehaia",
				"to": "Lunca Banului h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:39",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Lunca Banului h.",
				"to": "Butoieşti Hm.",
				"leavesAt": "08:40",
				"arrivesAt": "08:47",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Gura Motrului Hm.",
				"leavesAt": "08:48",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Filiaşi",
				"leavesAt": "08:56",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Filiaşi",
				"to": "Canton 282 h.",
				"leavesAt": "09:05",
				"arrivesAt": "09:08",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Canton 282 h.",
				"to": "Răcari Hm.",
				"leavesAt": "09:09",
				"arrivesAt": "09:13",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Răcari Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "09:14",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Brădeşti h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Almăj h.",
				"leavesAt": "09:25",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Işalniţa",
				"leavesAt": "09:29",
				"arrivesAt": "09:34",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Işalniţa",
				"to": "Işalniţa hc.",
				"leavesAt": "09:35",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Işalniţa hc.",
				"to": "Cernele",
				"leavesAt": "09:38",
				"arrivesAt": "09:42",
				"waitsAtSource": 30,
				"distance": 4800
			},
			{
				"from": "Cernele",
				"to": "Craiova Triaj hc.",
				"leavesAt": "09:43",
				"arrivesAt": "09:46",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Craiova",
				"leavesAt": "09:47",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 3700
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "SFT",
		"number": "15991",
		"segments": [
			{
				"from": "Craiova",
				"to": "Craiova Triaj hc.",
				"leavesAt": "05:00",
				"arrivesAt": "05:04",
				"waitsAtSource": 0,
				"distance": 3700
			},
			{
				"from": "Craiova Triaj hc.",
				"to": "Cernele",
				"leavesAt": "05:05",
				"arrivesAt": "05:08",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Cernele",
				"to": "Işalniţa hc.",
				"leavesAt": "05:09",
				"arrivesAt": "05:13",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Işalniţa hc.",
				"to": "Işalniţa",
				"leavesAt": "05:14",
				"arrivesAt": "05:17",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Işalniţa",
				"to": "Almăj h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Almăj h.",
				"to": "Coţofeni Hm.",
				"leavesAt": "05:22",
				"arrivesAt": "05:26",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Coţofeni Hm.",
				"to": "Brădeşti h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Brădeşti h.",
				"to": "Răcari Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Răcari Hm.",
				"to": "Canton 282 h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Canton 282 h.",
				"to": "Filiaşi",
				"leavesAt": "05:42",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Filiaşi",
				"to": "Gura Motrului Hm.",
				"leavesAt": "05:48",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Gura Motrului Hm.",
				"to": "Butoieşti Hm.",
				"leavesAt": "05:57",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Butoieşti Hm.",
				"to": "Lunca Banului h.",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Lunca Banului h.",
				"to": "Strehaia",
				"leavesAt": "06:10",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Strehaia",
				"to": "Strehaia Nord h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Strehaia Nord h.",
				"to": "Comanda h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Comanda h.",
				"to": "Cernaia h.",
				"leavesAt": "06:26",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Cernaia h.",
				"to": "Jirov Hm.",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Jirov Hm.",
				"to": "Ceramica h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ceramica h.",
				"to": "Corcova h.",
				"leavesAt": "06:41",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Corcova h.",
				"to": "Samarineşti h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:49",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Samarineşti h.",
				"to": "Motru Est",
				"leavesAt": "06:50",
				"arrivesAt": "07:03",
				"waitsAtSource": 30,
				"distance": 5600
			},
			{
				"from": "Motru Est",
				"to": "Motru Est Gr. Călători",
				"leavesAt": "07:05",
				"arrivesAt": "07:12",
				"waitsAtSource": 120,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20171210",
				"to": "20181208",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14712",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "17:00",
				"arrivesAt": "17:03",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "17:04",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "17:26",
				"arrivesAt": "17:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "17:34",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14713",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "17:50",
				"arrivesAt": "17:56",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "17:57",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "18:10",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "18:15",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "18:24",
				"arrivesAt": "18:27",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "18:28",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14817",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "09:03",
				"arrivesAt": "09:16",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "09:17",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "09:28",
				"arrivesAt": "09:34",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "09:35",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "09:42",
				"arrivesAt": "09:54",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "09:55",
				"arrivesAt": "10:01",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "10:02",
				"arrivesAt": "10:07",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "10:08",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "10:14",
				"arrivesAt": "10:18",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "10:19",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "10:25",
				"arrivesAt": "10:31",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "10:32",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "10:41",
				"arrivesAt": "10:46",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "10:47",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Truşeşti",
				"to": "Buhăceni h.",
				"leavesAt": "10:56",
				"arrivesAt": "11:02",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Buhăceni h.",
				"to": "Dângeni",
				"leavesAt": "11:03",
				"arrivesAt": "11:10",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dângeni",
				"to": "Dângeni Nord h.",
				"leavesAt": "11:18",
				"arrivesAt": "11:23",
				"waitsAtSource": 480,
				"distance": 4700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Ungureni Hm.",
				"leavesAt": "11:24",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Ungureni Hm.",
				"to": "Mândreşti h.",
				"leavesAt": "11:33",
				"arrivesAt": "11:38",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mândreşti h.",
				"to": "Vorniceni h.",
				"leavesAt": "11:39",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vorniceni h.",
				"to": "Mateieni h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Mateieni h.",
				"to": "Corlăteni h",
				"leavesAt": "11:52",
				"arrivesAt": "11:56",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Corlăteni h",
				"to": "Carasa h.",
				"leavesAt": "11:57",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Carasa h.",
				"to": "Broscăuţi h.",
				"leavesAt": "12:01",
				"arrivesAt": "12:07",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Broscăuţi h.",
				"to": "Dorohoi",
				"leavesAt": "12:08",
				"arrivesAt": "12:18",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14604",
		"segments": [
			{
				"from": "Praid",
				"to": "Sovata  hcv.",
				"leavesAt": "07:17",
				"arrivesAt": "07:37",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Sovata  hcv.",
				"to": "Sărăţeni h.",
				"leavesAt": "07:38",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sărăţeni h.",
				"to": "Chibed h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Chibed h.",
				"to": "Ghindari h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:55",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ghindari h.",
				"to": "Cioc h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Cioc h.",
				"to": "Sângeorgiu de Pădure h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Sângeorgiu de Pădure h.",
				"to": "Fântânele h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fântânele h.",
				"to": "Bălăuşeri hcv.",
				"leavesAt": "08:17",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Bălăuşeri hcv.",
				"to": "Coroiu h.",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 840,
				"distance": 6700
			},
			{
				"from": "Coroiu h.",
				"to": "Şoimuş h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 1300
			},
			{
				"from": "Şoimuş h.",
				"to": "Laslău h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Laslău h.",
				"to": "Bahnea h.",
				"leavesAt": "09:03",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bahnea h.",
				"to": "Bernadea h.",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bernadea h.",
				"to": "Mica h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:21",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mica h.",
				"to": "Deaj h.",
				"leavesAt": "09:22",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Deaj h.",
				"to": "Găneşti h.",
				"leavesAt": "09:27",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Găneşti h.",
				"to": "Şeuca h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Şeuca h.",
				"to": "Târnaveni",
				"leavesAt": "09:38",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Târnaveni",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "09:46",
				"arrivesAt": "09:51",
				"waitsAtSource": 120,
				"distance": 2400
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Adămuş h.",
				"leavesAt": "09:52",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Adămuş h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "09:57",
				"arrivesAt": "10:01",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Crăieşti h.",
				"leavesAt": "10:02",
				"arrivesAt": "10:05",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Crăieşti h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "10:06",
				"arrivesAt": "10:13",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Feisa h.",
				"leavesAt": "10:14",
				"arrivesAt": "10:17",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Feisa h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "10:18",
				"arrivesAt": "10:22",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Bălcaci h.",
				"leavesAt": "10:23",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Bălcaci h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "10:28",
				"arrivesAt": "10:32",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Şona h.",
				"leavesAt": "10:33",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Şona h.",
				"to": "Pănade h.",
				"leavesAt": "10:38",
				"arrivesAt": "10:43",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Pănade h.",
				"to": "Sâncel h.",
				"leavesAt": "10:44",
				"arrivesAt": "10:47",
				"waitsAtSource": 30,
				"distance": 1654
			},
			{
				"from": "Sâncel h.",
				"to": "Blaj",
				"leavesAt": "10:48",
				"arrivesAt": "10:55",
				"waitsAtSource": 30,
				"distance": 4246
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14985",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "19:08",
				"arrivesAt": "19:13",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "19:14",
				"arrivesAt": "19:19",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:33",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "19:34",
				"arrivesAt": "19:39",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "19:40",
				"arrivesAt": "19:44",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:49",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "19:50",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "19:57",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "20:02",
				"arrivesAt": "20:09",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "20:10",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "20:22",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18230",
		"segments": [
			{
				"from": "Nerău hcv.",
				"to": "Teremia Banat hc.",
				"leavesAt": "12:17",
				"arrivesAt": "12:25",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Comloşu Mare h.",
				"leavesAt": "12:26",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Gotlob h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:45",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gotlob h.",
				"to": "Lovrin",
				"leavesAt": "12:46",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "13:10",
				"arrivesAt": "13:17",
				"waitsAtSource": 1020,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "13:18",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "13:27",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "13:40",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "13:51",
				"arrivesAt": "13:57",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "14:10",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "14:17",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "14:33",
				"arrivesAt": "14:39",
				"waitsAtSource": 420,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:41",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "14:42",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "14:45",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14508",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:43",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "14:54",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "15:01",
				"arrivesAt": "15:08",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "15:09",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "15:14",
				"arrivesAt": "15:18",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "15:19",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "15:37",
				"arrivesAt": "15:40",
				"waitsAtSource": 480,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "15:41",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "15:48",
				"arrivesAt": "15:56",
				"waitsAtSource": 30,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14014",
		"segments": [
			{
				"from": "Sărmaşu h.",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Sărmăşel hcv .",
				"to": "Ţăgşor h.",
				"leavesAt": "05:15",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ţăgşor h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:25",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţagu h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:28",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Brăteni h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Brăteni h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "06:02",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Vermeş h.",
				"leavesAt": "06:09",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vermeş h.",
				"to": "Lechinţa",
				"leavesAt": "06:18",
				"arrivesAt": "06:22",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Lechinţa",
				"to": "Ţigău h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ţigău h.",
				"to": "Chiraleş h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Chiraleş h.",
				"to": "Chintelnic h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 2276
			},
			{
				"from": "Chintelnic h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "06:41",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 2314
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "06:46",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel",
				"leavesAt": "06:49",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel",
				"to": "Sărata h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:04",
				"waitsAtSource": 240,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "07:13",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14552",
		"segments": [
			{
				"from": "Luduş",
				"to": "Luduş Sat hc.",
				"leavesAt": "20:45",
				"arrivesAt": "20:48",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "20:49",
				"arrivesAt": "21:00",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Tăureni h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:08",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Tăureni h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "21:09",
				"arrivesAt": "21:13",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "21:14",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Bota Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:30",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "21:31",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Balda h.",
				"leavesAt": "21:38",
				"arrivesAt": "21:44",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Balda h.",
				"to": "Sărmaşu h.",
				"leavesAt": "21:45",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "21:56",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 2000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14441",
		"segments": [
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "08:08",
				"arrivesAt": "08:16",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Utviniş h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:25",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "08:26",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Şiria Hm.",
				"leavesAt": "08:37",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Şiria Hm.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Pâncota h.",
				"leavesAt": "08:55",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pâncota h.",
				"to": "Seleuş h.",
				"leavesAt": "08:59",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Seleuş h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "09:04",
				"arrivesAt": "09:11",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Mocrea h.",
				"leavesAt": "09:12",
				"arrivesAt": "09:17",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mocrea h.",
				"to": "Ineu",
				"leavesAt": "09:18",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Ineu",
				"to": "Tămand h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:39",
				"waitsAtSource": 420,
				"distance": 8400
			},
			{
				"from": "Tămand h.",
				"to": "Bocsig  h",
				"leavesAt": "09:40",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bocsig  h",
				"to": "Răpsig h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răpsig h.",
				"to": "Sebiş",
				"leavesAt": "09:52",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Sebiş",
				"to": "Paulian h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:08",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Paulian h.",
				"to": "Joia Mare hc.",
				"leavesAt": "10:09",
				"arrivesAt": "10:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Joia Mare hc.",
				"to": "Almaş h.",
				"leavesAt": "10:14",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Almaş h.",
				"to": "Bonţeşti h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:25",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bonţeşti h.",
				"to": "Gurahonţ",
				"leavesAt": "10:26",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14709",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "14:20",
				"arrivesAt": "14:26",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "14:27",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "14:38",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "14:39",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "14:44",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "14:47",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "14:53",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "14:57",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14301",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "16:16",
				"arrivesAt": "16:25",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:38",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "16:39",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Semlac h.",
				"leavesAt": "16:52",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "17:25",
				"arrivesAt": "17:38",
				"waitsAtSource": 30,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14706",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "06:12",
				"arrivesAt": "06:15",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "06:16",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "06:30",
				"arrivesAt": "06:34",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "06:39",
				"arrivesAt": "06:46",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18263",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "09:44",
				"arrivesAt": "09:50",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:15",
				"waitsAtSource": 8220,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "12:16",
				"arrivesAt": "12:19",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "12:20",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "12:28",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "12:34",
				"arrivesAt": "12:37",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "12:38",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 256
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14306",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:59",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:09",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Pecica",
				"leavesAt": "18:10",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 17200
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "18:46",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "18:53",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "19:02",
				"arrivesAt": "19:11",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14989",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "23:44",
				"arrivesAt": "23:49",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "23:50",
				"arrivesAt": "23:55",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "23:56",
				"arrivesAt": "23:59",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "00:00",
				"arrivesAt": "00:05",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "00:06",
				"arrivesAt": "00:09",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "00:10",
				"arrivesAt": "00:15",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "00:16",
				"arrivesAt": "00:22",
				"waitsAtSource": 60,
				"distance": 4000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14323",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:43",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "16:44",
				"arrivesAt": "16:46",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Hodoni h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:08",
				"waitsAtSource": 300,
				"distance": 8600
			},
			{
				"from": "Hodoni h.",
				"to": "Chinezu h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Chinezu h.",
				"to": "Bărăteaz h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:21",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărăteaz h.",
				"to": "Gelu hc.",
				"leavesAt": "17:22",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gelu hc.",
				"to": "Variaş hc.",
				"leavesAt": "17:29",
				"arrivesAt": "17:35",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Variaş hc.",
				"to": "Periam",
				"leavesAt": "17:36",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Periam",
				"to": "Pesac h.",
				"leavesAt": "18:03",
				"arrivesAt": "18:14",
				"waitsAtSource": 1020,
				"distance": 6700
			},
			{
				"from": "Pesac h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "18:15",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "18:23",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lovrin",
				"to": "Gotlob h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:44",
				"waitsAtSource": 480,
				"distance": 6400
			},
			{
				"from": "Gotlob h.",
				"to": "Comloşu Mare h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:52",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Teremia Banat hc.",
				"leavesAt": "18:53",
				"arrivesAt": "19:03",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Nerău hcv.",
				"leavesAt": "19:04",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14439",
		"segments": [
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "05:10",
				"arrivesAt": "05:18",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Zimandu Nou h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "05:26",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Şiria Hm.",
				"leavesAt": "05:37",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Şiria Hm.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Pâncota h.",
				"leavesAt": "05:55",
				"arrivesAt": "05:58",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pâncota h.",
				"to": "Seleuş h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:03",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Seleuş h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "06:04",
				"arrivesAt": "06:11",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Mocrea h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mocrea h.",
				"to": "Ineu",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Ineu",
				"to": "Tămand h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:39",
				"waitsAtSource": 420,
				"distance": 8400
			},
			{
				"from": "Tămand h.",
				"to": "Bocsig  h",
				"leavesAt": "06:40",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bocsig  h",
				"to": "Răpsig h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răpsig h.",
				"to": "Sebiş",
				"leavesAt": "06:52",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Sebiş",
				"to": "Paulian h.",
				"leavesAt": "07:03",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Paulian h.",
				"to": "Joia Mare hc.",
				"leavesAt": "07:09",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Joia Mare hc.",
				"to": "Almaş h.",
				"leavesAt": "07:14",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Almaş h.",
				"to": "Bonţeşti h.",
				"leavesAt": "07:20",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bonţeşti h.",
				"to": "Gurahonţ",
				"leavesAt": "07:26",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Gurahonţ",
				"to": "Romaniţa h.",
				"leavesAt": "07:33",
				"arrivesAt": "07:41",
				"waitsAtSource": 180,
				"distance": 6100
			},
			{
				"from": "Romaniţa h.",
				"to": "Aciuţa h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aciuţa h.",
				"to": "Tălagiu h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tălagiu h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "07:54",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:20",
				"waitsAtSource": 960,
				"distance": 3600
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "08:21",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Ocişor h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:32",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ocişor h.",
				"to": "Ociu h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ociu h.",
				"to": "Vaţa h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:42",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Vaţa h.",
				"to": "Birtin h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:49",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Birtin h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "08:50",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Baia de Criş h.",
				"leavesAt": "08:56",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Baia de Criş h.",
				"to": "Ţebea h",
				"leavesAt": "09:00",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ţebea h",
				"to": "Ribiţa h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ribiţa h.",
				"to": "Brad",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14298",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:37",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Canton Nr. 9 h.",
				"leavesAt": "05:49",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Canton Nr. 9 h.",
				"to": "Pecica",
				"leavesAt": "06:01",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "06:35",
				"arrivesAt": "06:41",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "06:44",
				"arrivesAt": "06:53",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14391",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "16:17",
				"arrivesAt": "16:23",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:26",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "16:27",
				"arrivesAt": "16:29",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "16:38",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Biled",
				"leavesAt": "16:49",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Biled",
				"to": "Şandra h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şandra h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "17:36",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lovrin",
				"to": "Tomnaticu h.",
				"leavesAt": "17:52",
				"arrivesAt": "18:03",
				"waitsAtSource": 540,
				"distance": 7700
			},
			{
				"from": "Tomnaticu h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "18:04",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Sânnicolau Mare",
				"to": "Sânnicolau Nord h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:44",
				"waitsAtSource": 1020,
				"distance": 5400
			},
			{
				"from": "Sânnicolau Nord h.",
				"to": "Cenad h.",
				"leavesAt": "18:45",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14735",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:00",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "16:01",
				"arrivesAt": "16:06",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "16:07",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "16:13",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:25",
				"waitsAtSource": 360,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "16:26",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "16:31",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Angheluş h.",
				"leavesAt": "16:39",
				"arrivesAt": "16:48",
				"waitsAtSource": 120,
				"distance": 6500
			},
			{
				"from": "Angheluş h.",
				"to": "Moacşa hcv",
				"leavesAt": "16:49",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Moacşa hcv",
				"to": "Biţa h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:01",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Biţa h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:07",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Ţufalău h.",
				"leavesAt": "17:08",
				"arrivesAt": "17:11",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ţufalău h.",
				"to": "Brateş h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Brateş h.",
				"to": "Covasna Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:26",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Covasna Hm.",
				"to": "Zăbala h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Zăbala h.",
				"to": "Imeci Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Imeci Hm.",
				"to": "Cătălina h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Cătălina h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Sânzieni h.",
				"leavesAt": "17:49",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sânzieni h.",
				"to": "Poieniţa h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Poieniţa h.",
				"to": "Bălani h.",
				"leavesAt": "18:08",
				"arrivesAt": "18:13",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bălani h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Lemnia h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:26",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lemnia h.",
				"to": "Breţcu Hm.",
				"leavesAt": "18:27",
				"arrivesAt": "18:34",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18244",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "12:11",
				"arrivesAt": "12:21",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:31",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "12:32",
				"arrivesAt": "12:39",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "12:40",
				"arrivesAt": "12:50",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "12:51",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "12:55",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "13:00",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "13:04",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "13:18",
				"arrivesAt": "13:22",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "13:23",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "13:36",
				"arrivesAt": "13:43",
				"waitsAtSource": 180,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14675",
		"segments": [
			{
				"from": "Zlatna hcv.",
				"to": "Zlatna h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:07",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "17:08",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Feneş h.",
				"leavesAt": "17:17",
				"arrivesAt": "17:21",
				"waitsAtSource": 180,
				"distance": 2400
			},
			{
				"from": "Feneş h.",
				"to": "Prisaca h.",
				"leavesAt": "17:22",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Prisaca h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:34",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Ampoiţa h.",
				"leavesAt": "17:47",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ampoiţa h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "17:53",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:05",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:10",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "18:11",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "18:16",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14846",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "13:17",
				"arrivesAt": "13:22",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Ciurea Hm.",
				"leavesAt": "13:23",
				"arrivesAt": "13:29",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Ciurea Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "13:30",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Bârnova Hm.",
				"leavesAt": "13:40",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Grajduri",
				"leavesAt": "13:52",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Grajduri",
				"to": "Scânteia Hm.",
				"leavesAt": "13:59",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Scânteia Hm.",
				"to": "Rebricea Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Rebricea Hm.",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Buhăieşti",
				"leavesAt": "14:18",
				"arrivesAt": "14:26",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Buhăieşti",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "14:32",
				"arrivesAt": "14:46",
				"waitsAtSource": 360,
				"distance": 10700
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Rafaila h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Rafaila h.",
				"to": "Dumeşti h.",
				"leavesAt": "14:54",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Dumeşti h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Suhuleţ h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Suhuleţ h.",
				"to": "Băluşeşti h",
				"leavesAt": "15:17",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Băluşeşti h",
				"to": "Dagâţa",
				"leavesAt": "15:21",
				"arrivesAt": "15:25",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Dagâţa",
				"to": "Zece Prăjini h",
				"leavesAt": "15:27",
				"arrivesAt": "15:31",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Zece Prăjini h",
				"to": "Piscu Rusului h.",
				"leavesAt": "15:32",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Stăniţa h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Stăniţa h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "15:53",
				"arrivesAt": "16:00",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Sagna h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Sagna h.",
				"to": "Roman",
				"leavesAt": "16:12",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14759",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:13",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "16:14",
				"arrivesAt": "16:19",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "16:20",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "16:48",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14451",
		"segments": [
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "19:48",
				"arrivesAt": "19:56",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Utviniş h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Utviniş h.",
				"to": "Zimandu Nou h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:06",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "20:07",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Şiria Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Şiria Hm.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Pâncota h.",
				"leavesAt": "20:36",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pâncota h.",
				"to": "Seleuş h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:44",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Seleuş h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Mocrea h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mocrea h.",
				"to": "Ineu",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Ineu",
				"to": "Tămand h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:12",
				"waitsAtSource": 60,
				"distance": 8400
			},
			{
				"from": "Tămand h.",
				"to": "Bocsig  h",
				"leavesAt": "21:13",
				"arrivesAt": "21:17",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bocsig  h",
				"to": "Răpsig h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răpsig h.",
				"to": "Sebiş",
				"leavesAt": "21:25",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Sebiş",
				"to": "Paulian h.",
				"leavesAt": "21:36",
				"arrivesAt": "21:41",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Paulian h.",
				"to": "Joia Mare hc.",
				"leavesAt": "21:42",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Joia Mare hc.",
				"to": "Almaş h.",
				"leavesAt": "21:47",
				"arrivesAt": "21:52",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Almaş h.",
				"to": "Bonţeşti h.",
				"leavesAt": "21:53",
				"arrivesAt": "21:58",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bonţeşti h.",
				"to": "Gurahonţ",
				"leavesAt": "21:59",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14015",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:36",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărata h.",
				"leavesAt": "14:37",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel",
				"to": "Arcalia hc.",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "14:56",
				"arrivesAt": "14:59",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Chintelnic h.",
				"leavesAt": "15:00",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Chintelnic h.",
				"to": "Chiraleş h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 2276
			},
			{
				"from": "Chiraleş h.",
				"to": "Ţigău h.",
				"leavesAt": "15:09",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ţigău h.",
				"to": "Lechinţa",
				"leavesAt": "15:15",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lechinţa",
				"to": "Vermeş h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:27",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Vermeş h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Brăteni h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Brăteni h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:53",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:59",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Ţagu h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ţagu h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "16:20",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţăgşor h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ţăgşor h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "16:31",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 2000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14972",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:04",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "06:05",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:17",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "06:18",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "06:32",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "06:38",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:48",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "06:49",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "07:03",
				"arrivesAt": "07:07",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "07:08",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "07:14",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14505",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "07:22",
				"arrivesAt": "07:30",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "07:31",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "07:35",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "07:41",
				"arrivesAt": "07:46",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "07:47",
				"arrivesAt": "07:52",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "07:53",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Birda hcv.",
				"leavesAt": "08:04",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Birda hcv.",
				"to": "Gătaia",
				"leavesAt": "08:13",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Gătaia",
				"to": "Măureni hc.",
				"leavesAt": "08:35",
				"arrivesAt": "08:42",
				"waitsAtSource": 840,
				"distance": 6700
			},
			{
				"from": "Măureni hc.",
				"to": "Gherteniş hc.",
				"leavesAt": "08:43",
				"arrivesAt": "08:49",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gherteniş hc.",
				"to": "Berzovia",
				"leavesAt": "08:50",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "08:55",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "09:06",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "09:13",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:24",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "09:25",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:39",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "09:40",
				"arrivesAt": "09:44",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14501",
		"segments": [
			{
				"from": "Gătaia",
				"to": "Măureni hc.",
				"leavesAt": "05:58",
				"arrivesAt": "06:05",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Măureni hc.",
				"to": "Gherteniş hc.",
				"leavesAt": "06:06",
				"arrivesAt": "06:12",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gherteniş hc.",
				"to": "Berzovia",
				"leavesAt": "06:13",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "06:18",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "06:29",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "06:36",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:54",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "06:55",
				"arrivesAt": "07:03",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "07:04",
				"arrivesAt": "07:08",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14609",
		"segments": [
			{
				"from": "Blaj",
				"to": "Sâncel h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:35",
				"waitsAtSource": 0,
				"distance": 4246
			},
			{
				"from": "Sâncel h.",
				"to": "Pănade h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Pănade h.",
				"to": "Şona h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Şona h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Bălcaci h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bălcaci h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "14:57",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "15:07",
				"arrivesAt": "15:11",
				"waitsAtSource": 30,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Adămuş h.",
				"leavesAt": "15:19",
				"arrivesAt": "15:24",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Adămuş h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "15:25",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "15:30",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Târnaveni",
				"to": "Şeuca h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:47",
				"waitsAtSource": 300,
				"distance": 2600
			},
			{
				"from": "Şeuca h.",
				"to": "Găneşti h.",
				"leavesAt": "15:48",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Găneşti h.",
				"to": "Deaj h.",
				"leavesAt": "15:54",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Deaj h.",
				"to": "Mica h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:03",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Mica h.",
				"to": "Bernadea h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:08",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bernadea h.",
				"to": "Bahnea h.",
				"leavesAt": "16:09",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bahnea h.",
				"to": "Laslău h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Laslău h.",
				"to": "Şoimuş h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şoimuş h.",
				"to": "Coroiu h.",
				"leavesAt": "16:32",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Coroiu h.",
				"to": "Bălăuşeri hcv.",
				"leavesAt": "16:36",
				"arrivesAt": "16:47",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bălăuşeri hcv.",
				"to": "Fântânele h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Fântânele h.",
				"to": "Sângeorgiu de Pădure h.",
				"leavesAt": "16:58",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sângeorgiu de Pădure h.",
				"to": "Cioc h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Cioc h.",
				"to": "Ghindari h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ghindari h.",
				"to": "Chibed h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:23",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Chibed h.",
				"to": "Sărăţeni h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:29",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sărăţeni h.",
				"to": "Sovata  hcv.",
				"leavesAt": "17:30",
				"arrivesAt": "17:37",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sovata  hcv.",
				"to": "Praid",
				"leavesAt": "17:38",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14671",
		"segments": [
			{
				"from": "Zlatna hcv.",
				"to": "Zlatna h.",
				"leavesAt": "05:00",
				"arrivesAt": "05:03",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "05:04",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Feneş h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:18",
				"waitsAtSource": 180,
				"distance": 2400
			},
			{
				"from": "Feneş h.",
				"to": "Prisaca h.",
				"leavesAt": "05:19",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Prisaca h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "05:24",
				"arrivesAt": "05:31",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:36",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Ampoiţa h.",
				"leavesAt": "05:44",
				"arrivesAt": "05:49",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ampoiţa h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:07",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "06:08",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "06:13",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14806",
		"segments": [
			{
				"from": "Hârlău",
				"to": "Bădeni hc.",
				"leavesAt": "11:23",
				"arrivesAt": "11:27",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Bădeni hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "11:28",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Cotnari hc.",
				"leavesAt": "11:33",
				"arrivesAt": "11:37",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cotnari hc.",
				"to": "Hodora h.",
				"leavesAt": "11:38",
				"arrivesAt": "11:43",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hodora h.",
				"to": "Podu Ulmi h.",
				"leavesAt": "11:44",
				"arrivesAt": "11:49",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Belceşti Hm.",
				"leavesAt": "11:50",
				"arrivesAt": "11:54",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Belceşti Hm.",
				"to": "Spinoasa h.",
				"leavesAt": "11:55",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spinoasa h.",
				"to": "Erbiceni hc.",
				"leavesAt": "12:07",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Erbiceni hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "12:15",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "12:29",
				"arrivesAt": "12:37",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "12:38",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14302",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "12:35",
				"arrivesAt": "12:46",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "12:47",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Pecica",
				"leavesAt": "13:00",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:36",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:43",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "13:44",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "13:53",
				"arrivesAt": "14:02",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14035",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "18:08",
				"arrivesAt": "18:25",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 360,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "18:35",
				"arrivesAt": "18:43",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "18:44",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "18:49",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "18:54",
				"arrivesAt": "19:02",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Vest",
				"leavesAt": "19:03",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "19:21",
				"arrivesAt": "19:27",
				"waitsAtSource": 480,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "19:28",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "19:38",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:04",
				"waitsAtSource": 480,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "20:13",
				"arrivesAt": "20:17",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Valea Largă Hm.",
				"leavesAt": "20:18",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "20:33",
				"arrivesAt": "20:36",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "20:37",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "20:43",
				"arrivesAt": "20:47",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "20:54",
				"arrivesAt": "21:05",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Dârste",
				"leavesAt": "21:06",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 20100
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "21:34",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14430",
		"segments": [
			{
				"from": "Cermei hcv",
				"to": "Teuz h.",
				"leavesAt": "18:32",
				"arrivesAt": "18:37",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Teuz h.",
				"to": "Ineu",
				"leavesAt": "18:38",
				"arrivesAt": "18:50",
				"waitsAtSource": 30,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18236",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "12:50",
				"arrivesAt": "12:53",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "12:54",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "13:10",
				"arrivesAt": "13:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "13:18",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "13:23",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "13:29",
				"arrivesAt": "13:39",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "13:50",
				"arrivesAt": "13:54",
				"waitsAtSource": 660,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "13:55",
				"arrivesAt": "14:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "14:02",
				"arrivesAt": "14:09",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Gătaia",
				"to": "Birda hcv.",
				"leavesAt": "14:10",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Birda hcv.",
				"to": "Voiteni",
				"leavesAt": "14:20",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "14:42",
				"arrivesAt": "14:52",
				"waitsAtSource": 780,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "14:53",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "14:58",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "15:17",
				"arrivesAt": "15:22",
				"waitsAtSource": 780,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "15:23",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "15:27",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14088",
		"segments": [
			{
				"from": "Braşov",
				"to": "Predeal",
				"leavesAt": "06:20",
				"arrivesAt": "06:55",
				"waitsAtSource": 0,
				"distance": 26300
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "06:56",
				"arrivesAt": "07:04",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "07:05",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Sinaia",
				"leavesAt": "07:11",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sinaia",
				"to": "Comarnic",
				"leavesAt": "07:20",
				"arrivesAt": "07:34",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Comarnic",
				"to": "Breaza hc.",
				"leavesAt": "07:35",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "07:43",
				"arrivesAt": "07:51",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "07:52",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Ploieşti Vest",
				"leavesAt": "08:04",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 18600
			},
			{
				"from": "Ploieşti Vest",
				"to": "Chitila",
				"leavesAt": "08:23",
				"arrivesAt": "09:00",
				"waitsAtSource": 180,
				"distance": 49500
			},
			{
				"from": "Chitila",
				"to": "Bucureşti Băneasa",
				"leavesAt": "09:01",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Feteşti",
				"leavesAt": "09:19",
				"arrivesAt": "10:49",
				"waitsAtSource": 300,
				"distance": 139800
			},
			{
				"from": "Feteşti",
				"to": "Constanţa",
				"leavesAt": "10:53",
				"arrivesAt": "12:00",
				"waitsAtSource": 240,
				"distance": 78600
			}
		],
		"restrictions": [
			{
				"from": "20170616",
				"to": "20170903",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18232",
		"segments": [
			{
				"from": "Cruceni hcv.",
				"to": "Rudna hc.",
				"leavesAt": "15:20",
				"arrivesAt": "15:37",
				"waitsAtSource": 0,
				"distance": 11000
			},
			{
				"from": "Rudna hc.",
				"to": "Giulvăz h",
				"leavesAt": "15:38",
				"arrivesAt": "15:45",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Giulvăz h",
				"to": "Cebza h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:49",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Cebza h.",
				"to": "Peciu Nou h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Peciu Nou h.",
				"to": "Parţa h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Parţa h.",
				"to": "Sânmihai h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sânmihai h.",
				"to": "Utvin h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Utvin h.",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "16:24",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "16:43",
				"arrivesAt": "16:54",
				"waitsAtSource": 780,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14813",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "05:18",
				"arrivesAt": "05:31",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "05:32",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "05:43",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "05:50",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "05:57",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 480,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "06:24",
				"arrivesAt": "06:29",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "06:30",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "06:36",
				"arrivesAt": "06:40",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "06:41",
				"arrivesAt": "06:46",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "06:47",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "07:05",
				"arrivesAt": "07:13",
				"waitsAtSource": 720,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "07:14",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "07:20",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 9400
			}
		],
		"restrictions": [
			{
				"from": "20170107",
				"to": "20170205",
				"daysOfWeek": 799
			},
			{
				"from": "20170211",
				"to": "20170418",
				"daysOfWeek": 799
			},
			{
				"from": "20170422",
				"to": "20170423",
				"daysOfWeek": 799
			},
			{
				"from": "20170429",
				"to": "20170618",
				"daysOfWeek": 799
			},
			{
				"from": "20170624",
				"to": "20170625",
				"daysOfWeek": 799
			},
			{
				"from": "20170701",
				"to": "20170702",
				"daysOfWeek": 799
			},
			{
				"from": "20170708",
				"to": "20170709",
				"daysOfWeek": 799
			},
			{
				"from": "20170715",
				"to": "20170716",
				"daysOfWeek": 799
			},
			{
				"from": "20170722",
				"to": "20170723",
				"daysOfWeek": 799
			},
			{
				"from": "20170729",
				"to": "20170730",
				"daysOfWeek": 799
			},
			{
				"from": "20170805",
				"to": "20170806",
				"daysOfWeek": 799
			},
			{
				"from": "20170812",
				"to": "20170813",
				"daysOfWeek": 799
			},
			{
				"from": "20170819",
				"to": "20170820",
				"daysOfWeek": 799
			},
			{
				"from": "20170826",
				"to": "20170827",
				"daysOfWeek": 799
			},
			{
				"from": "20170902",
				"to": "20170903",
				"daysOfWeek": 799
			},
			{
				"from": "20170909",
				"to": "20171209",
				"daysOfWeek": 799
			},
			{
				"from": "20161211",
				"to": "20161225",
				"daysOfWeek": 799
			},
			{
				"from": "20161231",
				"to": "20170101",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14019",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:43",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărata h.",
				"leavesAt": "20:44",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel",
				"to": "Arcalia hc.",
				"leavesAt": "20:58",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "21:03",
				"arrivesAt": "21:06",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Chintelnic h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:11",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Chintelnic h.",
				"to": "Chiraleş h.",
				"leavesAt": "21:12",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 2276
			},
			{
				"from": "Chiraleş h.",
				"to": "Ţigău h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:21",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ţigău h.",
				"to": "Lechinţa",
				"leavesAt": "21:22",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lechinţa",
				"to": "Vermeş h.",
				"leavesAt": "21:30",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Vermeş h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "21:34",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Brăteni h.",
				"leavesAt": "21:44",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Brăteni h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "21:51",
				"arrivesAt": "21:58",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "21:59",
				"arrivesAt": "22:04",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "22:05",
				"arrivesAt": "22:15",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Ţagu h.",
				"leavesAt": "22:16",
				"arrivesAt": "22:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ţagu h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "22:25",
				"arrivesAt": "22:28",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţăgşor h.",
				"leavesAt": "22:29",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ţăgşor h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "22:36",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 2000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14327",
		"segments": [
			{
				"from": "Lovrin",
				"to": "Gotlob h.",
				"leavesAt": "21:27",
				"arrivesAt": "21:33",
				"waitsAtSource": 0,
				"distance": 6400
			},
			{
				"from": "Gotlob h.",
				"to": "Comloşu Mare h.",
				"leavesAt": "21:34",
				"arrivesAt": "21:42",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Teremia Banat hc.",
				"leavesAt": "21:43",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Nerău hcv.",
				"leavesAt": "21:54",
				"arrivesAt": "22:02",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14437",
		"segments": [
			{
				"from": "Vârfurile Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:54",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Ocişor h.",
				"leavesAt": "06:01",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ocişor h.",
				"to": "Ociu h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ociu h.",
				"to": "Vaţa h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:15",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Vaţa h.",
				"to": "Birtin h.",
				"leavesAt": "06:16",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Birtin h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Baia de Criş h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:31",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Baia de Criş h.",
				"to": "Ţebea h",
				"leavesAt": "06:32",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ţebea h",
				"to": "Ribiţa h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:39",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ribiţa h.",
				"to": "Brad",
				"leavesAt": "06:40",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14513",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "16:14",
				"arrivesAt": "16:24",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "16:26",
				"arrivesAt": "16:29",
				"waitsAtSource": 120,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:36",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "16:37",
				"arrivesAt": "16:43",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "16:44",
				"arrivesAt": "16:50",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "16:51",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Birda hcv.",
				"leavesAt": "17:03",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Birda hcv.",
				"to": "Gătaia",
				"leavesAt": "17:15",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Gătaia",
				"to": "Măureni hc.",
				"leavesAt": "17:48",
				"arrivesAt": "17:55",
				"waitsAtSource": 1440,
				"distance": 6700
			},
			{
				"from": "Măureni hc.",
				"to": "Gherteniş hc.",
				"leavesAt": "17:56",
				"arrivesAt": "18:02",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gherteniş hc.",
				"to": "Berzovia",
				"leavesAt": "18:03",
				"arrivesAt": "18:07",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "18:08",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "18:19",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "18:26",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "18:54",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14428",
		"segments": [
			{
				"from": "Cermei hcv",
				"to": "Teuz h.",
				"leavesAt": "16:40",
				"arrivesAt": "16:45",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Teuz h.",
				"to": "Ineu",
				"leavesAt": "16:46",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14600",
		"segments": [
			{
				"from": "Târnaveni",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:53",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Adămuş h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Adămuş h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Crăieşti h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:05",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Crăieşti h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "05:06",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 5160
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Feisa h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Feisa h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "05:18",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Bălcaci h.",
				"leavesAt": "05:30",
				"arrivesAt": "05:33",
				"waitsAtSource": 480,
				"distance": 2800
			},
			{
				"from": "Bălcaci h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Şona h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Şona h.",
				"to": "Pănade h.",
				"leavesAt": "05:43",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pănade h.",
				"to": "Sâncel h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Sâncel h.",
				"to": "Blaj",
				"leavesAt": "05:53",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 4246
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14701",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "06:00",
				"arrivesAt": "06:05",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "06:06",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "06:33",
				"arrivesAt": "06:35",
				"waitsAtSource": 540,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "06:36",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "06:42",
				"arrivesAt": "06:45",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "06:46",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14971",
		"segments": [
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 0,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "05:15",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "05:22",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "05:28",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "05:35",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "05:46",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14322",
		"segments": [
			{
				"from": "Nerău hcv.",
				"to": "Teremia Banat hc.",
				"leavesAt": "16:42",
				"arrivesAt": "16:48",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Comloşu Mare h.",
				"leavesAt": "16:49",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Gotlob h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:06",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Gotlob h.",
				"to": "Lovrin",
				"leavesAt": "17:07",
				"arrivesAt": "17:14",
				"waitsAtSource": 30,
				"distance": 6400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14677",
		"segments": [
			{
				"from": "Zlatna hcv.",
				"to": "Zlatna h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:14",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "21:15",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Feneş h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:29",
				"waitsAtSource": 180,
				"distance": 2400
			},
			{
				"from": "Feneş h.",
				"to": "Prisaca h.",
				"leavesAt": "21:30",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Prisaca h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "21:35",
				"arrivesAt": "21:42",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "21:43",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "21:48",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Ampoiţa h.",
				"leavesAt": "21:55",
				"arrivesAt": "22:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ampoiţa h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "22:01",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "22:06",
				"arrivesAt": "22:13",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "22:14",
				"arrivesAt": "22:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "22:19",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "22:28",
				"arrivesAt": "22:35",
				"waitsAtSource": 300,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14067",
		"segments": [
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "09:28",
				"arrivesAt": "09:33",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "09:34",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "10:07",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "10:42",
				"arrivesAt": "11:12",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "11:13",
				"arrivesAt": "11:51",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "11:52",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "12:20",
				"arrivesAt": "12:43",
				"waitsAtSource": 360,
				"distance": 17800
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Bârlad",
				"leavesAt": "12:44",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 48600
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "13:28",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "13:57",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "14:12",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "14:31",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "14:57",
				"arrivesAt": "15:12",
				"waitsAtSource": 120,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "15:14",
				"arrivesAt": "15:22",
				"waitsAtSource": 120,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 353
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14825",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "18:49",
				"arrivesAt": "19:02",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "19:03",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "19:14",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "19:21",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "19:28",
				"arrivesAt": "19:40",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "19:41",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "19:47",
				"arrivesAt": "19:52",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "19:53",
				"arrivesAt": "19:58",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "19:59",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "20:04",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "20:10",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:33",
				"waitsAtSource": 480,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "20:34",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "20:40",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Truşeşti",
				"to": "Buhăceni h.",
				"leavesAt": "20:49",
				"arrivesAt": "20:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Buhăceni h.",
				"to": "Dângeni",
				"leavesAt": "20:56",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dângeni",
				"to": "Dângeni Nord h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:09",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Ungureni Hm.",
				"leavesAt": "21:10",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Ungureni Hm.",
				"to": "Mândreşti h.",
				"leavesAt": "21:19",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mândreşti h.",
				"to": "Vorniceni h.",
				"leavesAt": "21:25",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vorniceni h.",
				"to": "Mateieni h.",
				"leavesAt": "21:33",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Mateieni h.",
				"to": "Corlăteni h",
				"leavesAt": "21:38",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Corlăteni h",
				"to": "Carasa h.",
				"leavesAt": "21:43",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Carasa h.",
				"to": "Broscăuţi h.",
				"leavesAt": "21:47",
				"arrivesAt": "21:53",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Broscăuţi h.",
				"to": "Dorohoi",
				"leavesAt": "21:54",
				"arrivesAt": "22:04",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14816",
		"segments": [
			{
				"from": "Dorohoi",
				"to": "Broscăuţi h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:28",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Broscăuţi h.",
				"to": "Carasa h.",
				"leavesAt": "05:29",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Carasa h.",
				"to": "Corlăteni h",
				"leavesAt": "05:37",
				"arrivesAt": "05:40",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Corlăteni h",
				"to": "Mateieni h.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mateieni h.",
				"to": "Vorniceni h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vorniceni h.",
				"to": "Mândreşti h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:59",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mândreşti h.",
				"to": "Ungureni Hm.",
				"leavesAt": "06:00",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ungureni Hm.",
				"to": "Dângeni Nord h.",
				"leavesAt": "06:07",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Dângeni",
				"leavesAt": "06:16",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni",
				"to": "Buhăceni h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:28",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Buhăceni h.",
				"to": "Truşeşti",
				"leavesAt": "06:29",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "06:36",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:52",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "06:53",
				"arrivesAt": "07:01",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:09",
				"waitsAtSource": 120,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "07:10",
				"arrivesAt": "07:15",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "07:16",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "07:22",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "07:28",
				"arrivesAt": "07:33",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "07:48",
				"arrivesAt": "07:59",
				"waitsAtSource": 480,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "08:00",
				"arrivesAt": "08:06",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "08:07",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "08:16",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "08:27",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14018",
		"segments": [
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "12:50",
				"arrivesAt": "12:55",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Brăteni h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:03",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Brăteni h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "13:04",
				"arrivesAt": "13:10",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Vermeş h.",
				"leavesAt": "13:11",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vermeş h.",
				"to": "Lechinţa",
				"leavesAt": "13:20",
				"arrivesAt": "13:24",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Lechinţa",
				"to": "Ţigău h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ţigău h.",
				"to": "Chiraleş h.",
				"leavesAt": "13:33",
				"arrivesAt": "13:37",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiraleş h.",
				"to": "Chintelnic h.",
				"leavesAt": "13:38",
				"arrivesAt": "13:42",
				"waitsAtSource": 30,
				"distance": 2276
			},
			{
				"from": "Chintelnic h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "13:43",
				"arrivesAt": "13:47",
				"waitsAtSource": 30,
				"distance": 2314
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "13:48",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel",
				"leavesAt": "13:51",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel",
				"to": "Sărata h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "14:12",
				"arrivesAt": "14:15",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14553",
		"segments": [
			{
				"from": "Sărmăşel hcv .",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "06:10",
				"arrivesAt": "06:13",
				"waitsAtSource": 0,
				"distance": 2000
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmaşu h.",
				"leavesAt": "06:14",
				"arrivesAt": "06:18",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Balda h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Balda h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:44",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bota Sat h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Tăureni h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:59",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Tăureni h.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Luduş Sat hc.",
				"leavesAt": "07:09",
				"arrivesAt": "07:20",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Luduş",
				"leavesAt": "07:21",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14367",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "19:42",
				"arrivesAt": "19:49",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Zădăreni Hm.",
				"leavesAt": "19:50",
				"arrivesAt": "20:00",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "20:01",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Felnac hc.",
				"leavesAt": "20:05",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Felnac hc.",
				"to": "Sânpetru German h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sânpetru German h.",
				"to": "Munor h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Munor h.",
				"to": "Secusigiu h",
				"leavesAt": "20:24",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Secusigiu h",
				"to": "Aranca h.",
				"leavesAt": "20:29",
				"arrivesAt": "20:32",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Aranca h.",
				"to": "Periam",
				"leavesAt": "20:33",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Periam",
				"to": "Sânpetru h.",
				"leavesAt": "20:57",
				"arrivesAt": "21:03",
				"waitsAtSource": 720,
				"distance": 4500
			},
			{
				"from": "Sânpetru h.",
				"to": "Saravale h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Saravale h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "21:13",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14364",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "12:04",
				"arrivesAt": "12:14",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:24",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "12:25",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "12:40",
				"arrivesAt": "12:50",
				"waitsAtSource": 480,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "12:51",
				"arrivesAt": "12:54",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "12:55",
				"arrivesAt": "12:59",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "13:00",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "13:04",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "13:12",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "13:18",
				"arrivesAt": "13:22",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "13:23",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "13:36",
				"arrivesAt": "13:43",
				"waitsAtSource": 180,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14717",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "22:30",
				"arrivesAt": "22:36",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "22:38",
				"arrivesAt": "22:46",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "22:47",
				"arrivesAt": "22:50",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "22:51",
				"arrivesAt": "22:55",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "22:56",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "22:59",
				"arrivesAt": "23:04",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "23:05",
				"arrivesAt": "23:08",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "23:09",
				"arrivesAt": "23:12",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14500",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:04",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "04:05",
				"arrivesAt": "04:13",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "04:14",
				"arrivesAt": "04:19",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "04:20",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "04:28",
				"arrivesAt": "04:32",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "04:33",
				"arrivesAt": "04:38",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "04:39",
				"arrivesAt": "04:49",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "04:50",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "04:55",
				"arrivesAt": "05:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "05:02",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Gătaia",
				"to": "Birda hcv.",
				"leavesAt": "05:11",
				"arrivesAt": "05:20",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Birda hcv.",
				"to": "Voiteni",
				"leavesAt": "05:21",
				"arrivesAt": "05:30",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "05:33",
				"arrivesAt": "05:43",
				"waitsAtSource": 180,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "05:49",
				"arrivesAt": "05:55",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "05:56",
				"arrivesAt": "06:01",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "06:02",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "06:06",
				"arrivesAt": "06:15",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14420",
		"segments": [
			{
				"from": "Cermei hcv",
				"to": "Teuz h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:15",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Teuz h.",
				"to": "Ineu",
				"leavesAt": "07:16",
				"arrivesAt": "07:28",
				"waitsAtSource": 30,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 895
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14089",
		"segments": [
			{
				"from": "Constanţa",
				"to": "Bucureşti Băneasa",
				"leavesAt": "16:30",
				"arrivesAt": "18:57",
				"waitsAtSource": 0,
				"distance": 218400
			},
			{
				"from": "Bucureşti Băneasa",
				"to": "Ploieşti Vest",
				"leavesAt": "18:59",
				"arrivesAt": "19:50",
				"waitsAtSource": 120,
				"distance": 58100
			},
			{
				"from": "Ploieşti Vest",
				"to": "Floreşti Prahova",
				"leavesAt": "20:08",
				"arrivesAt": "20:22",
				"waitsAtSource": 1080,
				"distance": 18600
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "20:23",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "20:36",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Comarnic",
				"leavesAt": "20:42",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 9000
			},
			{
				"from": "Comarnic",
				"to": "Sinaia",
				"leavesAt": "20:50",
				"arrivesAt": "21:03",
				"waitsAtSource": 60,
				"distance": 15100
			},
			{
				"from": "Sinaia",
				"to": "Buşteni",
				"leavesAt": "21:05",
				"arrivesAt": "21:13",
				"waitsAtSource": 120,
				"distance": 7600
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "21:14",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "21:20",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Braşov",
				"leavesAt": "21:33",
				"arrivesAt": "22:10",
				"waitsAtSource": 120,
				"distance": 26300
			}
		],
		"restrictions": [
			{
				"from": "20170616",
				"to": "20170903",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14736",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "15:00",
				"arrivesAt": "15:06",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "15:07",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "15:12",
				"arrivesAt": "15:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:29",
				"waitsAtSource": 420,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "15:30",
				"arrivesAt": "15:36",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:41",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "15:42",
				"arrivesAt": "15:46",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14740",
		"segments": [
			{
				"from": "Breţcu Hm.",
				"to": "Lemnia h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:49",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lemnia h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "19:50",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Bălani h.",
				"leavesAt": "19:56",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bălani h.",
				"to": "Poieniţa h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:07",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Poieniţa h.",
				"to": "Sânzieni h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Sânzieni h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "20:13",
				"arrivesAt": "20:25",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Cătălina h.",
				"leavesAt": "20:51",
				"arrivesAt": "20:56",
				"waitsAtSource": 1560,
				"distance": 4400
			},
			{
				"from": "Cătălina h.",
				"to": "Imeci Hm.",
				"leavesAt": "20:57",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Imeci Hm.",
				"to": "Zăbala h.",
				"leavesAt": "21:01",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Zăbala h.",
				"to": "Covasna Hm.",
				"leavesAt": "21:08",
				"arrivesAt": "21:13",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Covasna Hm.",
				"to": "Brateş h.",
				"leavesAt": "21:14",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Brateş h.",
				"to": "Ţufalău h.",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Ţufalău h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:31",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Biţa h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Biţa h.",
				"to": "Moacşa hcv",
				"leavesAt": "21:38",
				"arrivesAt": "21:43",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Moacşa hcv",
				"to": "Angheluş h.",
				"leavesAt": "21:44",
				"arrivesAt": "21:50",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Angheluş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "21:51",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14320",
		"segments": [
			{
				"from": "Nerău hcv.",
				"to": "Teremia Banat hc.",
				"leavesAt": "11:27",
				"arrivesAt": "11:35",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Comloşu Mare h.",
				"leavesAt": "11:36",
				"arrivesAt": "11:45",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Gotlob h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:54",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Gotlob h.",
				"to": "Lovrin",
				"leavesAt": "11:55",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "12:07",
				"arrivesAt": "12:14",
				"waitsAtSource": 300,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "12:24",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "12:37",
				"arrivesAt": "12:46",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "12:47",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "12:54",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:08",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "13:09",
				"arrivesAt": "13:17",
				"waitsAtSource": 30,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "13:26",
				"arrivesAt": "13:31",
				"waitsAtSource": 540,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "13:32",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "13:34",
				"arrivesAt": "13:36",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "13:37",
				"arrivesAt": "13:44",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14425",
		"segments": [
			{
				"from": "Ineu",
				"to": "Teuz h.",
				"leavesAt": "14:20",
				"arrivesAt": "14:31",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Teuz h.",
				"to": "Cermei hcv",
				"leavesAt": "14:32",
				"arrivesAt": "14:38",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14012",
		"segments": [
			{
				"from": "Sărmăşel hcv .",
				"to": "Ţăgşor h.",
				"leavesAt": "04:00",
				"arrivesAt": "04:04",
				"waitsAtSource": 0,
				"distance": 2000
			},
			{
				"from": "Ţăgşor h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "04:05",
				"arrivesAt": "04:11",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţagu h.",
				"leavesAt": "04:12",
				"arrivesAt": "04:15",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "04:16",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "04:25",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Brăteni h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Brăteni h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "04:51",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Vermeş h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vermeş h.",
				"to": "Lechinţa",
				"leavesAt": "05:08",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Lechinţa",
				"to": "Ţigău h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:24",
				"waitsAtSource": 300,
				"distance": 5000
			},
			{
				"from": "Ţigău h.",
				"to": "Chiraleş h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:30",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiraleş h.",
				"to": "Chintelnic h.",
				"leavesAt": "05:31",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 2276
			},
			{
				"from": "Chintelnic h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "05:36",
				"arrivesAt": "05:41",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "05:42",
				"arrivesAt": "05:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel",
				"leavesAt": "05:45",
				"arrivesAt": "05:51",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel",
				"to": "Sărata h.",
				"leavesAt": "05:53",
				"arrivesAt": "05:58",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "05:59",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "06:07",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14802",
		"segments": [
			{
				"from": "Hârlău",
				"to": "Bădeni hc.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Bădeni hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "05:10",
				"arrivesAt": "05:14",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Cotnari hc.",
				"leavesAt": "05:15",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cotnari hc.",
				"to": "Hodora h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hodora h.",
				"to": "Podu Ulmi h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Belceşti Hm.",
				"leavesAt": "05:32",
				"arrivesAt": "05:36",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Belceşti Hm.",
				"to": "Spinoasa h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spinoasa h.",
				"to": "Erbiceni hc.",
				"leavesAt": "05:49",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Erbiceni hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "05:57",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "06:11",
				"arrivesAt": "06:19",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "06:20",
				"arrivesAt": "06:35",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14803",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "09:24",
				"arrivesAt": "09:35",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "09:36",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Erbiceni hc.",
				"leavesAt": "09:52",
				"arrivesAt": "10:01",
				"waitsAtSource": 480,
				"distance": 6000
			},
			{
				"from": "Erbiceni hc.",
				"to": "Spinoasa h.",
				"leavesAt": "10:02",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Spinoasa h.",
				"to": "Belceşti Hm.",
				"leavesAt": "10:11",
				"arrivesAt": "10:22",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Belceşti Hm.",
				"to": "Podu Ulmi h.",
				"leavesAt": "10:23",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Hodora h.",
				"leavesAt": "10:29",
				"arrivesAt": "10:34",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Hodora h.",
				"to": "Cotnari hc.",
				"leavesAt": "10:35",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Cotnari hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "10:41",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Bădeni hc.",
				"leavesAt": "10:46",
				"arrivesAt": "10:51",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bădeni hc.",
				"to": "Hârlău",
				"leavesAt": "10:52",
				"arrivesAt": "10:57",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14033",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "11:40",
				"arrivesAt": "11:55",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "11:56",
				"arrivesAt": "12:00",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "12:01",
				"arrivesAt": "12:09",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "12:10",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "12:16",
				"arrivesAt": "12:20",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "12:21",
				"arrivesAt": "12:30",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Vest",
				"leavesAt": "12:31",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "12:50",
				"arrivesAt": "12:57",
				"waitsAtSource": 540,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "12:58",
				"arrivesAt": "13:07",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "13:13",
				"arrivesAt": "13:26",
				"waitsAtSource": 360,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "13:27",
				"arrivesAt": "13:32",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "13:33",
				"arrivesAt": "13:36",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:40",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "13:41",
				"arrivesAt": "13:45",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Valea Largă Hm.",
				"leavesAt": "13:46",
				"arrivesAt": "13:55",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "13:56",
				"arrivesAt": "14:00",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "14:01",
				"arrivesAt": "14:04",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "14:05",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "14:11",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "14:16",
				"arrivesAt": "14:21",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "14:22",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Dârste",
				"leavesAt": "14:35",
				"arrivesAt": "15:04",
				"waitsAtSource": 120,
				"distance": 20100
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "15:05",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14981",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "15:47",
				"arrivesAt": "15:52",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "15:53",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:07",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "16:08",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "16:28",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "16:35",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "16:40",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "16:47",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 799
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14392",
		"segments": [
			{
				"from": "Cenad h.",
				"to": "Sânnicolau Nord h.",
				"leavesAt": "16:47",
				"arrivesAt": "17:09",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Sânnicolau Nord h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "17:10",
				"arrivesAt": "17:22",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Sânnicolau Mare",
				"to": "Tomnaticu h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Tomnaticu h.",
				"to": "Lovrin",
				"leavesAt": "17:34",
				"arrivesAt": "17:47",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "17:48",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Şandra h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şandra h.",
				"to": "Biled",
				"leavesAt": "18:12",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Biled",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "18:25",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "18:46",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "18:59",
				"arrivesAt": "19:06",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "19:10",
				"arrivesAt": "19:14",
				"waitsAtSource": 240,
				"distance": 2500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "19:15",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14393",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "19:43",
				"arrivesAt": "19:53",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "20:02",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Biled",
				"leavesAt": "20:13",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Biled",
				"to": "Şandra h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:44",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şandra h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "20:45",
				"arrivesAt": "20:58",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "20:59",
				"arrivesAt": "21:06",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lovrin",
				"to": "Tomnaticu h.",
				"leavesAt": "21:07",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Tomnaticu h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "21:19",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14426",
		"segments": [
			{
				"from": "Cermei hcv",
				"to": "Teuz h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Teuz h.",
				"to": "Ineu",
				"leavesAt": "14:51",
				"arrivesAt": "15:03",
				"waitsAtSource": 30,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14542",
		"segments": [
			{
				"from": "Cruceni hcv.",
				"to": "Rudna hc.",
				"leavesAt": "09:10",
				"arrivesAt": "09:28",
				"waitsAtSource": 0,
				"distance": 11000
			},
			{
				"from": "Rudna hc.",
				"to": "Giulvăz h",
				"leavesAt": "09:29",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Giulvăz h",
				"to": "Cebza h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Cebza h.",
				"to": "Peciu Nou h.",
				"leavesAt": "09:42",
				"arrivesAt": "09:51",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Peciu Nou h.",
				"to": "Parţa h.",
				"leavesAt": "09:52",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Parţa h.",
				"to": "Sânmihai h.",
				"leavesAt": "10:03",
				"arrivesAt": "10:10",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sânmihai h.",
				"to": "Utvin h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:15",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Utvin h.",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "10:16",
				"arrivesAt": "10:22",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "10:25",
				"arrivesAt": "10:36",
				"waitsAtSource": 180,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14801",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "05:49",
				"arrivesAt": "06:00",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "06:01",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Erbiceni hc.",
				"leavesAt": "06:14",
				"arrivesAt": "06:23",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Erbiceni hc.",
				"to": "Spinoasa h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Spinoasa h.",
				"to": "Belceşti Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "06:44",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Belceşti Hm.",
				"to": "Podu Ulmi h.",
				"leavesAt": "06:45",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Hodora h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:56",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Hodora h.",
				"to": "Cotnari hc.",
				"leavesAt": "06:57",
				"arrivesAt": "07:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Cotnari hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:07",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Bădeni hc.",
				"leavesAt": "07:08",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bădeni hc.",
				"to": "Hârlău",
				"leavesAt": "07:14",
				"arrivesAt": "07:19",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14507",
		"segments": [
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "12:58",
				"arrivesAt": "13:08",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "13:09",
				"arrivesAt": "13:15",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "13:16",
				"arrivesAt": "13:19",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "13:20",
				"arrivesAt": "13:27",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "13:28",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "13:34",
				"arrivesAt": "13:43",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "13:44",
				"arrivesAt": "13:47",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14326",
		"segments": [
			{
				"from": "Nerău hcv.",
				"to": "Teremia Banat hc.",
				"leavesAt": "19:27",
				"arrivesAt": "19:34",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Comloşu Mare h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Gotlob h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gotlob h.",
				"to": "Lovrin",
				"leavesAt": "19:55",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "20:03",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "20:21",
				"arrivesAt": "20:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "20:48",
				"arrivesAt": "20:57",
				"waitsAtSource": 900,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "20:58",
				"arrivesAt": "21:04",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:16",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "21:17",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "21:23",
				"arrivesAt": "21:33",
				"waitsAtSource": 30,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "21:36",
				"arrivesAt": "21:42",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Timişoara Nord",
				"leavesAt": "21:43",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14731",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "07:11",
				"arrivesAt": "07:15",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "07:16",
				"arrivesAt": "07:22",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:33",
				"waitsAtSource": 300,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "07:34",
				"arrivesAt": "07:36",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "07:47",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Angheluş h.",
				"leavesAt": "07:56",
				"arrivesAt": "08:05",
				"waitsAtSource": 180,
				"distance": 6500
			},
			{
				"from": "Angheluş h.",
				"to": "Moacşa hcv",
				"leavesAt": "08:06",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Moacşa hcv",
				"to": "Biţa h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Biţa h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Ţufalău h.",
				"leavesAt": "08:24",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ţufalău h.",
				"to": "Brateş h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Brateş h.",
				"to": "Covasna Hm.",
				"leavesAt": "08:33",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Covasna Hm.",
				"to": "Zăbala h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Zăbala h.",
				"to": "Imeci Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Imeci Hm.",
				"to": "Cătălina h.",
				"leavesAt": "08:56",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Cătălina h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "08:59",
				"arrivesAt": "09:04",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Sânzieni h.",
				"leavesAt": "09:05",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sânzieni h.",
				"to": "Poieniţa h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:22",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Poieniţa h.",
				"to": "Bălani h.",
				"leavesAt": "09:23",
				"arrivesAt": "09:28",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bălani h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "09:29",
				"arrivesAt": "09:35",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Lemnia h.",
				"leavesAt": "09:36",
				"arrivesAt": "09:41",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lemnia h.",
				"to": "Breţcu Hm.",
				"leavesAt": "09:42",
				"arrivesAt": "09:49",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14730",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "05:42",
				"arrivesAt": "05:48",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "05:53",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "06:01",
				"arrivesAt": "06:08",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:18",
				"waitsAtSource": 300,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "06:19",
				"arrivesAt": "06:23",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14818",
		"segments": [
			{
				"from": "Dorohoi",
				"to": "Broscăuţi h.",
				"leavesAt": "10:15",
				"arrivesAt": "10:21",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Broscăuţi h.",
				"to": "Carasa h.",
				"leavesAt": "10:22",
				"arrivesAt": "10:29",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Carasa h.",
				"to": "Corlăteni h",
				"leavesAt": "10:30",
				"arrivesAt": "10:33",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Corlăteni h",
				"to": "Mateieni h.",
				"leavesAt": "10:34",
				"arrivesAt": "10:38",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mateieni h.",
				"to": "Vorniceni h.",
				"leavesAt": "10:39",
				"arrivesAt": "10:43",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vorniceni h.",
				"to": "Mândreşti h.",
				"leavesAt": "10:44",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mândreşti h.",
				"to": "Ungureni Hm.",
				"leavesAt": "10:53",
				"arrivesAt": "10:59",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ungureni Hm.",
				"to": "Dângeni Nord h.",
				"leavesAt": "11:00",
				"arrivesAt": "11:08",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Dângeni",
				"leavesAt": "11:09",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni",
				"to": "Buhăceni h.",
				"leavesAt": "11:16",
				"arrivesAt": "11:22",
				"waitsAtSource": 120,
				"distance": 6000
			},
			{
				"from": "Buhăceni h.",
				"to": "Truşeşti",
				"leavesAt": "11:23",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "11:39",
				"arrivesAt": "11:48",
				"waitsAtSource": 600,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "11:56",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "12:05",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "12:12",
				"arrivesAt": "12:17",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "12:18",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "12:24",
				"arrivesAt": "12:29",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "12:30",
				"arrivesAt": "12:35",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "12:36",
				"arrivesAt": "12:42",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "12:50",
				"arrivesAt": "13:01",
				"waitsAtSource": 480,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "13:02",
				"arrivesAt": "13:08",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "13:09",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "13:18",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "13:29",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14389",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj h",
				"leavesAt": "14:10",
				"arrivesAt": "14:16",
				"waitsAtSource": 0,
				"distance": 5900
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "14:17",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "14:20",
				"arrivesAt": "14:27",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "14:28",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Biled",
				"leavesAt": "14:40",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Biled",
				"to": "Şandra h.",
				"leavesAt": "15:01",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şandra h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "15:11",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "15:27",
				"arrivesAt": "15:34",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lovrin",
				"to": "Tomnaticu h.",
				"leavesAt": "15:37",
				"arrivesAt": "15:47",
				"waitsAtSource": 180,
				"distance": 7700
			},
			{
				"from": "Tomnaticu h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "15:48",
				"arrivesAt": "15:59",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Sânnicolau Mare",
				"to": "Sânnicolau Nord h.",
				"leavesAt": "16:00",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Sânnicolau Nord h.",
				"to": "Cenad h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:35",
				"waitsAtSource": 30,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14980",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:16",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:29",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "17:30",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "17:49",
				"arrivesAt": "17:52",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "17:57",
				"arrivesAt": "18:02",
				"waitsAtSource": 300,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "18:03",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:12",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "18:22",
				"arrivesAt": "18:27",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "18:28",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14390",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Tomnaticu h.",
				"leavesAt": "11:51",
				"arrivesAt": "12:02",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Tomnaticu h.",
				"to": "Lovrin",
				"leavesAt": "12:03",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "12:16",
				"arrivesAt": "12:24",
				"waitsAtSource": 120,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Şandra h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şandra h.",
				"to": "Biled",
				"leavesAt": "12:41",
				"arrivesAt": "12:53",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Biled",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "12:54",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "13:15",
				"arrivesAt": "13:25",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "13:26",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "13:37",
				"arrivesAt": "13:39",
				"waitsAtSource": 180,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Timişoara Nord",
				"leavesAt": "13:40",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14450",
		"segments": [
			{
				"from": "Brad",
				"to": "Ribiţa h.",
				"leavesAt": "14:16",
				"arrivesAt": "14:21",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Ribiţa h.",
				"to": "Ţebea h",
				"leavesAt": "14:22",
				"arrivesAt": "14:25",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ţebea h",
				"to": "Baia de Criş h.",
				"leavesAt": "14:26",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Baia de Criş h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "14:30",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Birtin h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Birtin h.",
				"to": "Vaţa h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Vaţa h.",
				"to": "Ociu h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ociu h.",
				"to": "Ocişor h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ocişor h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "14:58",
				"arrivesAt": "15:03",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "15:04",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "15:09",
				"arrivesAt": "15:13",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Tălagiu h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:35",
				"waitsAtSource": 1020,
				"distance": 4500
			},
			{
				"from": "Tălagiu h.",
				"to": "Aciuţa h.",
				"leavesAt": "15:36",
				"arrivesAt": "15:43",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Aciuţa h.",
				"to": "Romaniţa h.",
				"leavesAt": "15:44",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Romaniţa h.",
				"to": "Gurahonţ",
				"leavesAt": "15:48",
				"arrivesAt": "15:58",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gurahonţ",
				"to": "Bonţeşti h.",
				"leavesAt": "15:59",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bonţeşti h.",
				"to": "Almaş h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Almaş h.",
				"to": "Joia Mare hc.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Joia Mare hc.",
				"to": "Paulian h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paulian h.",
				"to": "Sebiş",
				"leavesAt": "16:21",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sebiş",
				"to": "Răpsig h.",
				"leavesAt": "16:37",
				"arrivesAt": "16:47",
				"waitsAtSource": 600,
				"distance": 10000
			},
			{
				"from": "Răpsig h.",
				"to": "Bocsig  h",
				"leavesAt": "16:48",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bocsig  h",
				"to": "Tămand h.",
				"leavesAt": "16:56",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Tămand h.",
				"to": "Ineu",
				"leavesAt": "17:00",
				"arrivesAt": "17:08",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Ineu",
				"to": "Mocrea h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mocrea h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Seleuş h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Seleuş h.",
				"to": "Pâncota h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pâncota h.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Şiria Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Şiria Hm.",
				"to": "Sântana",
				"leavesAt": "17:46",
				"arrivesAt": "17:58",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Sântana",
				"to": "Utvinişu Nou",
				"leavesAt": "18:01",
				"arrivesAt": "18:16",
				"waitsAtSource": 180,
				"distance": 17000
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "18:17",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14844",
		"segments": [
			{
				"from": "Dagâţa",
				"to": "Zece Prăjini h",
				"leavesAt": "10:42",
				"arrivesAt": "10:45",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Zece Prăjini h",
				"to": "Piscu Rusului h.",
				"leavesAt": "10:46",
				"arrivesAt": "10:55",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Stăniţa h.",
				"leavesAt": "10:56",
				"arrivesAt": "11:06",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stăniţa h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "11:07",
				"arrivesAt": "11:14",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Sagna h.",
				"leavesAt": "11:15",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Sagna h.",
				"to": "Roman",
				"leavesAt": "11:26",
				"arrivesAt": "11:39",
				"waitsAtSource": 60,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14734",
		"segments": [
			{
				"from": "Breţcu Hm.",
				"to": "Lemnia h.",
				"leavesAt": "10:18",
				"arrivesAt": "10:24",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lemnia h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "10:25",
				"arrivesAt": "10:30",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Bălani h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:36",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bălani h.",
				"to": "Poieniţa h.",
				"leavesAt": "10:37",
				"arrivesAt": "10:42",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Poieniţa h.",
				"to": "Sânzieni h.",
				"leavesAt": "10:43",
				"arrivesAt": "10:47",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sânzieni h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "10:48",
				"arrivesAt": "11:00",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Cătălina h.",
				"leavesAt": "11:01",
				"arrivesAt": "11:06",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Cătălina h.",
				"to": "Imeci Hm.",
				"leavesAt": "11:07",
				"arrivesAt": "11:10",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Imeci Hm.",
				"to": "Zăbala h.",
				"leavesAt": "11:11",
				"arrivesAt": "11:17",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Zăbala h.",
				"to": "Covasna Hm.",
				"leavesAt": "11:18",
				"arrivesAt": "11:23",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Covasna Hm.",
				"to": "Brateş h.",
				"leavesAt": "11:24",
				"arrivesAt": "11:32",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Brateş h.",
				"to": "Ţufalău h.",
				"leavesAt": "11:33",
				"arrivesAt": "11:37",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Ţufalău h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "11:38",
				"arrivesAt": "11:41",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Biţa h.",
				"leavesAt": "11:42",
				"arrivesAt": "11:47",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Biţa h.",
				"to": "Moacşa hcv",
				"leavesAt": "11:48",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moacşa hcv",
				"to": "Angheluş h.",
				"leavesAt": "11:53",
				"arrivesAt": "11:58",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Angheluş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "11:59",
				"arrivesAt": "12:22",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Ozun Hm.",
				"leavesAt": "12:26",
				"arrivesAt": "12:33",
				"waitsAtSource": 240,
				"distance": 7600
			},
			{
				"from": "Ozun Hm.",
				"to": "Chichiş h.",
				"leavesAt": "12:34",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Prejmer Hm.",
				"leavesAt": "12:38",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Prejmer Hm.",
				"to": "Ilieni h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:50",
				"waitsAtSource": 360,
				"distance": 1800
			},
			{
				"from": "Ilieni h.",
				"to": "Hărman",
				"leavesAt": "12:51",
				"arrivesAt": "12:57",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "13:03",
				"arrivesAt": "13:08",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14445",
		"segments": [
			{
				"from": "Sebiş",
				"to": "Paulian h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:33",
				"waitsAtSource": 0,
				"distance": 4900
			},
			{
				"from": "Paulian h.",
				"to": "Joia Mare hc.",
				"leavesAt": "14:34",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Joia Mare hc.",
				"to": "Almaş h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:44",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Almaş h.",
				"to": "Bonţeşti h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:50",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bonţeşti h.",
				"to": "Gurahonţ",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Gurahonţ",
				"to": "Romaniţa h.",
				"leavesAt": "14:56",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Romaniţa h.",
				"to": "Aciuţa h.",
				"leavesAt": "15:05",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aciuţa h.",
				"to": "Tălagiu h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tălagiu h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "15:17",
				"arrivesAt": "15:23",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "15:24",
				"arrivesAt": "15:28",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "15:29",
				"arrivesAt": "15:34",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Ocişor h.",
				"leavesAt": "15:35",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ocişor h.",
				"to": "Ociu h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ociu h.",
				"to": "Vaţa h.",
				"leavesAt": "15:45",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Vaţa h.",
				"to": "Birtin h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Birtin h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Baia de Criş h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Baia de Criş h.",
				"to": "Ţebea h",
				"leavesAt": "16:08",
				"arrivesAt": "16:11",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ţebea h",
				"to": "Ribiţa h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:15",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ribiţa h.",
				"to": "Brad",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14840",
		"segments": [
			{
				"from": "Dagâţa",
				"to": "Zece Prăjini h",
				"leavesAt": "04:14",
				"arrivesAt": "04:17",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Zece Prăjini h",
				"to": "Piscu Rusului h.",
				"leavesAt": "04:18",
				"arrivesAt": "04:27",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Stăniţa h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:38",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Stăniţa h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "04:39",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Sagna h.",
				"leavesAt": "04:47",
				"arrivesAt": "04:57",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Sagna h.",
				"to": "Roman",
				"leavesAt": "04:58",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14438",
		"segments": [
			{
				"from": "Gurahonţ",
				"to": "Bonţeşti h.",
				"leavesAt": "03:34",
				"arrivesAt": "03:38",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Bonţeşti h.",
				"to": "Almaş h.",
				"leavesAt": "03:39",
				"arrivesAt": "03:44",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Almaş h.",
				"to": "Joia Mare hc.",
				"leavesAt": "03:45",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Joia Mare hc.",
				"to": "Paulian h.",
				"leavesAt": "03:51",
				"arrivesAt": "03:55",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paulian h.",
				"to": "Sebiş",
				"leavesAt": "03:56",
				"arrivesAt": "04:01",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sebiş",
				"to": "Răpsig h.",
				"leavesAt": "04:02",
				"arrivesAt": "04:12",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Răpsig h.",
				"to": "Bocsig  h",
				"leavesAt": "04:13",
				"arrivesAt": "04:20",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bocsig  h",
				"to": "Tămand h.",
				"leavesAt": "04:21",
				"arrivesAt": "04:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Tămand h.",
				"to": "Ineu",
				"leavesAt": "04:25",
				"arrivesAt": "04:33",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Ineu",
				"to": "Mocrea h.",
				"leavesAt": "04:34",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mocrea h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 30,
				"distance": 6200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Seleuş h.",
				"leavesAt": "04:48",
				"arrivesAt": "04:55",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Seleuş h.",
				"to": "Pâncota h.",
				"leavesAt": "04:56",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pâncota h.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:04",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Şiria Hm.",
				"leavesAt": "05:05",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Şiria Hm.",
				"to": "Sântana",
				"leavesAt": "05:10",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:36",
				"waitsAtSource": 180,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utvinişu Nou",
				"leavesAt": "05:37",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "05:44",
				"arrivesAt": "05:53",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14711",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "16:15",
				"arrivesAt": "16:20",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:28",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "16:29",
				"arrivesAt": "16:32",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "16:33",
				"arrivesAt": "16:37",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "16:41",
				"arrivesAt": "16:46",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "16:47",
				"arrivesAt": "16:50",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "16:51",
				"arrivesAt": "16:54",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14452",
		"segments": [
			{
				"from": "Brad",
				"to": "Ribiţa h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:43",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Ribiţa h.",
				"to": "Ţebea h",
				"leavesAt": "16:44",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ţebea h",
				"to": "Baia de Criş h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:51",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Baia de Criş h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Birtin h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Birtin h.",
				"to": "Vaţa h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:09",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Vaţa h.",
				"to": "Ociu h.",
				"leavesAt": "17:10",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ociu h.",
				"to": "Ocişor h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ocişor h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Tălagiu h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:43",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tălagiu h.",
				"to": "Aciuţa h.",
				"leavesAt": "17:44",
				"arrivesAt": "17:51",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Aciuţa h.",
				"to": "Romaniţa h.",
				"leavesAt": "17:52",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Romaniţa h.",
				"to": "Gurahonţ",
				"leavesAt": "17:56",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gurahonţ",
				"to": "Bonţeşti h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bonţeşti h.",
				"to": "Almaş h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Almaş h.",
				"to": "Joia Mare hc.",
				"leavesAt": "18:18",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Joia Mare hc.",
				"to": "Paulian h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paulian h.",
				"to": "Sebiş",
				"leavesAt": "18:29",
				"arrivesAt": "18:35",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sebiş",
				"to": "Răpsig h.",
				"leavesAt": "18:36",
				"arrivesAt": "18:46",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Răpsig h.",
				"to": "Bocsig  h",
				"leavesAt": "18:47",
				"arrivesAt": "18:54",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bocsig  h",
				"to": "Tămand h.",
				"leavesAt": "18:55",
				"arrivesAt": "18:58",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Tămand h.",
				"to": "Ineu",
				"leavesAt": "18:59",
				"arrivesAt": "19:07",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Ineu",
				"to": "Mocrea h.",
				"leavesAt": "19:14",
				"arrivesAt": "19:21",
				"waitsAtSource": 420,
				"distance": 4600
			},
			{
				"from": "Mocrea h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "19:22",
				"arrivesAt": "19:28",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Seleuş h.",
				"leavesAt": "19:29",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Seleuş h.",
				"to": "Pâncota h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pâncota h.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Şiria Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Şiria Hm.",
				"to": "Sântana",
				"leavesAt": "19:52",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:18",
				"waitsAtSource": 180,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Utvinişu Nou",
				"leavesAt": "20:23",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "20:27",
				"arrivesAt": "20:36",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18260",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "08:56",
				"arrivesAt": "09:07",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "09:21",
				"arrivesAt": "09:27",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "09:28",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Braşov Triaj",
				"leavesAt": "09:39",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Braşov Triaj",
				"to": "Braşov",
				"leavesAt": "09:48",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 256
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14758",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:16",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:21",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "15:22",
				"arrivesAt": "15:26",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "15:27",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "15:33",
				"arrivesAt": "15:42",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "15:48",
				"arrivesAt": "15:52",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14422",
		"segments": [
			{
				"from": "Cermei hcv",
				"to": "Teuz h.",
				"leavesAt": "10:10",
				"arrivesAt": "10:15",
				"waitsAtSource": 0,
				"distance": 3800
			},
			{
				"from": "Teuz h.",
				"to": "Ineu",
				"leavesAt": "10:16",
				"arrivesAt": "10:28",
				"waitsAtSource": 30,
				"distance": 10600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14549",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "20:06",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Utvin h.",
				"leavesAt": "20:07",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Utvin h.",
				"to": "Sânmihai h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sânmihai h.",
				"to": "Parţa h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:27",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Parţa h.",
				"to": "Peciu Nou h.",
				"leavesAt": "20:28",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Peciu Nou h.",
				"to": "Cebza h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cebza h.",
				"to": "Giulvăz h",
				"leavesAt": "20:49",
				"arrivesAt": "20:53",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Giulvăz h",
				"to": "Rudna hc.",
				"leavesAt": "20:54",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Rudna hc.",
				"to": "Cruceni hcv.",
				"leavesAt": "21:03",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 11000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14312",
		"segments": [
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "04:01",
				"arrivesAt": "04:08",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "04:09",
				"arrivesAt": "04:17",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "04:18",
				"arrivesAt": "04:31",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "04:32",
				"arrivesAt": "04:41",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "04:42",
				"arrivesAt": "04:48",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "04:49",
				"arrivesAt": "04:54",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "04:55",
				"arrivesAt": "05:00",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "05:07",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "05:19",
				"arrivesAt": "05:25",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Timişoara Nord",
				"leavesAt": "05:26",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14607",
		"segments": [
			{
				"from": "Blaj",
				"to": "Sâncel h.",
				"leavesAt": "11:20",
				"arrivesAt": "11:25",
				"waitsAtSource": 0,
				"distance": 4246
			},
			{
				"from": "Sâncel h.",
				"to": "Pănade h.",
				"leavesAt": "11:26",
				"arrivesAt": "11:29",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Pănade h.",
				"to": "Şona h.",
				"leavesAt": "11:30",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Şona h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "11:36",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "11:41",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "11:48",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "11:53",
				"arrivesAt": "11:56",
				"waitsAtSource": 30,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "11:57",
				"arrivesAt": "12:02",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "12:03",
				"arrivesAt": "12:11",
				"waitsAtSource": 30,
				"distance": 6900
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "12:12",
				"arrivesAt": "12:17",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Târnaveni",
				"to": "Şeuca h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:26",
				"waitsAtSource": 300,
				"distance": 2600
			},
			{
				"from": "Şeuca h.",
				"to": "Găneşti h.",
				"leavesAt": "12:27",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Găneşti h.",
				"to": "Deaj h.",
				"leavesAt": "12:33",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Deaj h.",
				"to": "Mica h.",
				"leavesAt": "12:38",
				"arrivesAt": "12:42",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Mica h.",
				"to": "Bernadea h.",
				"leavesAt": "12:43",
				"arrivesAt": "12:47",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bernadea h.",
				"to": "Bahnea h.",
				"leavesAt": "12:48",
				"arrivesAt": "12:54",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bahnea h.",
				"to": "Laslău h.",
				"leavesAt": "12:55",
				"arrivesAt": "13:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Laslău h.",
				"to": "Şoimuş h.",
				"leavesAt": "13:03",
				"arrivesAt": "13:10",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şoimuş h.",
				"to": "Coroiu h.",
				"leavesAt": "13:11",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Coroiu h.",
				"to": "Bălăuşeri hcv.",
				"leavesAt": "13:15",
				"arrivesAt": "13:26",
				"waitsAtSource": 30,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14384",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Tomnaticu h.",
				"leavesAt": "04:05",
				"arrivesAt": "04:16",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Tomnaticu h.",
				"to": "Lovrin",
				"leavesAt": "04:17",
				"arrivesAt": "04:28",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:36",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Şandra h.",
				"leavesAt": "04:37",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şandra h.",
				"to": "Biled",
				"leavesAt": "04:54",
				"arrivesAt": "05:05",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Biled",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "05:06",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h",
				"leavesAt": "05:50",
				"arrivesAt": "05:52",
				"waitsAtSource": 180,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Timişoara Nord",
				"leavesAt": "05:53",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14821",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "14:22",
				"arrivesAt": "14:35",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "14:36",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "14:47",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "14:54",
				"arrivesAt": "15:00",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "15:01",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "15:21",
				"arrivesAt": "15:27",
				"waitsAtSource": 480,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "15:28",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "15:34",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "15:40",
				"arrivesAt": "15:44",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "15:45",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "15:51",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:06",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "16:07",
				"arrivesAt": "16:12",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "16:13",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Truşeşti",
				"to": "Buhăceni h.",
				"leavesAt": "16:35",
				"arrivesAt": "16:41",
				"waitsAtSource": 840,
				"distance": 4700
			},
			{
				"from": "Buhăceni h.",
				"to": "Dângeni",
				"leavesAt": "16:42",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dângeni",
				"to": "Dângeni Nord h.",
				"leavesAt": "16:50",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Ungureni Hm.",
				"leavesAt": "16:56",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Ungureni Hm.",
				"to": "Mândreşti h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mândreşti h.",
				"to": "Vorniceni h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vorniceni h.",
				"to": "Mateieni h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Mateieni h.",
				"to": "Corlăteni h",
				"leavesAt": "17:24",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Corlăteni h",
				"to": "Carasa h.",
				"leavesAt": "17:29",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Carasa h.",
				"to": "Broscăuţi h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Broscăuţi h.",
				"to": "Dorohoi",
				"leavesAt": "17:40",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18235",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "13:45",
				"arrivesAt": "13:57",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Utvin h.",
				"leavesAt": "13:59",
				"arrivesAt": "14:05",
				"waitsAtSource": 120,
				"distance": 3800
			},
			{
				"from": "Utvin h.",
				"to": "Sânmihai h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sânmihai h.",
				"to": "Parţa h.",
				"leavesAt": "14:11",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Parţa h.",
				"to": "Peciu Nou h.",
				"leavesAt": "14:19",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Peciu Nou h.",
				"to": "Cebza h.",
				"leavesAt": "14:31",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cebza h.",
				"to": "Giulvăz h",
				"leavesAt": "14:40",
				"arrivesAt": "14:43",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Giulvăz h",
				"to": "Rudna hc.",
				"leavesAt": "14:44",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Rudna hc.",
				"to": "Cruceni hcv.",
				"leavesAt": "14:52",
				"arrivesAt": "15:11",
				"waitsAtSource": 30,
				"distance": 11000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14708",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "12:55",
				"arrivesAt": "12:58",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "12:59",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "13:02",
				"arrivesAt": "13:07",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "13:08",
				"arrivesAt": "13:11",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "13:12",
				"arrivesAt": "13:16",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Bartolomeu",
				"leavesAt": "13:17",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "13:28",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14068",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Nicolina",
				"leavesAt": "15:31",
				"arrivesAt": "15:36",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Nicolina",
				"to": "Bârnova Hm.",
				"leavesAt": "15:38",
				"arrivesAt": "16:03",
				"waitsAtSource": 120,
				"distance": 16300
			},
			{
				"from": "Bârnova Hm.",
				"to": "Buhăieşti",
				"leavesAt": "16:04",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 25700
			},
			{
				"from": "Buhăieşti",
				"to": "Vaslui",
				"leavesAt": "16:31",
				"arrivesAt": "16:52",
				"waitsAtSource": 420,
				"distance": 23500
			},
			{
				"from": "Vaslui",
				"to": "Crasna",
				"leavesAt": "16:54",
				"arrivesAt": "17:06",
				"waitsAtSource": 120,
				"distance": 15500
			},
			{
				"from": "Crasna",
				"to": "Bârlad",
				"leavesAt": "17:07",
				"arrivesAt": "17:39",
				"waitsAtSource": 60,
				"distance": 36600
			},
			{
				"from": "Bârlad",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "17:40",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 48600
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Mărăşeşti",
				"leavesAt": "18:25",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 17800
			},
			{
				"from": "Mărăşeşti",
				"to": "Focşani",
				"leavesAt": "18:57",
				"arrivesAt": "19:21",
				"waitsAtSource": 360,
				"distance": 19700
			},
			{
				"from": "Focşani",
				"to": "Râmnicu Sărat",
				"leavesAt": "19:22",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Buzău",
				"leavesAt": "19:59",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 33500
			},
			{
				"from": "Buzău",
				"to": "Mizil",
				"leavesAt": "20:30",
				"arrivesAt": "21:01",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Mizil",
				"to": "Ploieşti Sud",
				"leavesAt": "21:02",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Ploieşti Sud",
				"to": "Ploieşti Vest",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 3000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 368
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14810",
		"segments": [
			{
				"from": "Hârlău",
				"to": "Bădeni hc.",
				"leavesAt": "18:24",
				"arrivesAt": "18:27",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Bădeni hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "18:28",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Cotnari hc.",
				"leavesAt": "18:33",
				"arrivesAt": "18:37",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cotnari hc.",
				"to": "Hodora h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hodora h.",
				"to": "Podu Ulmi h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Belceşti Hm.",
				"leavesAt": "18:49",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Belceşti Hm.",
				"to": "Spinoasa h.",
				"leavesAt": "18:54",
				"arrivesAt": "19:05",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spinoasa h.",
				"to": "Erbiceni hc.",
				"leavesAt": "19:06",
				"arrivesAt": "19:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Erbiceni hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "19:14",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "19:28",
				"arrivesAt": "19:36",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "19:37",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14676",
		"segments": [
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "23:30",
				"arrivesAt": "23:38",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "23:39",
				"arrivesAt": "23:41",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "23:42",
				"arrivesAt": "23:46",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "23:47",
				"arrivesAt": "23:54",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Ampoiţa h.",
				"leavesAt": "23:55",
				"arrivesAt": "23:59",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ampoiţa h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "00:00",
				"arrivesAt": "00:04",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "00:05",
				"arrivesAt": "00:11",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "00:12",
				"arrivesAt": "00:16",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Prisaca h.",
				"leavesAt": "00:17",
				"arrivesAt": "00:24",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Prisaca h.",
				"to": "Feneş h.",
				"leavesAt": "00:25",
				"arrivesAt": "00:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Feneş h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "00:30",
				"arrivesAt": "00:35",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Zlatna h.",
				"leavesAt": "00:38",
				"arrivesAt": "00:44",
				"waitsAtSource": 180,
				"distance": 4000
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna hcv.",
				"leavesAt": "00:45",
				"arrivesAt": "00:51",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14509",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "13:53",
				"arrivesAt": "14:02",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "14:03",
				"arrivesAt": "14:06",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "14:07",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "14:13",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "14:19",
				"arrivesAt": "14:24",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "14:25",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Birda hcv.",
				"leavesAt": "14:36",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Birda hcv.",
				"to": "Gătaia",
				"leavesAt": "14:47",
				"arrivesAt": "14:55",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Gătaia",
				"to": "Măureni hc.",
				"leavesAt": "14:56",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Măureni hc.",
				"to": "Gherteniş hc.",
				"leavesAt": "15:05",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Gherteniş hc.",
				"to": "Berzovia",
				"leavesAt": "15:13",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "15:34",
				"arrivesAt": "15:43",
				"waitsAtSource": 1020,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "15:44",
				"arrivesAt": "15:49",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "15:50",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "15:54",
				"arrivesAt": "16:01",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:16",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "16:17",
				"arrivesAt": "16:20",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14700",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "05:00",
				"arrivesAt": "05:03",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "05:04",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:12",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "05:13",
				"arrivesAt": "05:16",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "05:17",
				"arrivesAt": "05:21",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "05:22",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "05:26",
				"arrivesAt": "05:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "05:34",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14303",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "17:50",
				"arrivesAt": "17:59",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:12",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "18:13",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Semlac h.",
				"leavesAt": "18:38",
				"arrivesAt": "19:02",
				"waitsAtSource": 780,
				"distance": 17200
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "19:03",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "19:13",
				"arrivesAt": "19:26",
				"waitsAtSource": 30,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14606",
		"segments": [
			{
				"from": "Târnaveni",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "13:15",
				"arrivesAt": "13:20",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Crăieşti h.",
				"leavesAt": "13:21",
				"arrivesAt": "13:28",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Crăieşti h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "13:29",
				"arrivesAt": "13:35",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Feisa h.",
				"leavesAt": "13:36",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Feisa h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "13:40",
				"arrivesAt": "13:44",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "13:45",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Şona h.",
				"leavesAt": "13:51",
				"arrivesAt": "13:55",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Şona h.",
				"to": "Pănade h.",
				"leavesAt": "13:56",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Pănade h.",
				"to": "Sâncel h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:05",
				"waitsAtSource": 30,
				"distance": 1654
			},
			{
				"from": "Sâncel h.",
				"to": "Blaj",
				"leavesAt": "14:06",
				"arrivesAt": "14:13",
				"waitsAtSource": 30,
				"distance": 4246
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14449",
		"segments": [
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "16:13",
				"arrivesAt": "16:21",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Zimandu Nou h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "16:30",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Şiria Hm.",
				"leavesAt": "16:41",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Şiria Hm.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Pâncota h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pâncota h.",
				"to": "Seleuş h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Seleuş h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "17:08",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Mocrea h.",
				"leavesAt": "17:35",
				"arrivesAt": "17:41",
				"waitsAtSource": 1200,
				"distance": 6200
			},
			{
				"from": "Mocrea h.",
				"to": "Ineu",
				"leavesAt": "17:42",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ineu",
				"to": "Tămand h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:03",
				"waitsAtSource": 420,
				"distance": 8400
			},
			{
				"from": "Tămand h.",
				"to": "Bocsig  h",
				"leavesAt": "18:04",
				"arrivesAt": "18:08",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bocsig  h",
				"to": "Răpsig h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:15",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răpsig h.",
				"to": "Sebiş",
				"leavesAt": "18:16",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Sebiş",
				"to": "Paulian h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:46",
				"waitsAtSource": 900,
				"distance": 4900
			},
			{
				"from": "Paulian h.",
				"to": "Joia Mare hc.",
				"leavesAt": "18:47",
				"arrivesAt": "18:51",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Joia Mare hc.",
				"to": "Almaş h.",
				"leavesAt": "18:52",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Almaş h.",
				"to": "Bonţeşti h.",
				"leavesAt": "18:58",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bonţeşti h.",
				"to": "Gurahonţ",
				"leavesAt": "19:04",
				"arrivesAt": "19:08",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Gurahonţ",
				"to": "Romaniţa h.",
				"leavesAt": "19:09",
				"arrivesAt": "19:17",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Romaniţa h.",
				"to": "Aciuţa h.",
				"leavesAt": "19:18",
				"arrivesAt": "19:22",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aciuţa h.",
				"to": "Tălagiu h.",
				"leavesAt": "19:23",
				"arrivesAt": "19:29",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tălagiu h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:36",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "19:37",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "19:42",
				"arrivesAt": "19:47",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Ocişor h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ocişor h.",
				"to": "Ociu h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ociu h.",
				"to": "Vaţa h.",
				"leavesAt": "19:58",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Vaţa h.",
				"to": "Birtin h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Birtin h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Baia de Criş h.",
				"leavesAt": "20:17",
				"arrivesAt": "20:20",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Baia de Criş h.",
				"to": "Ţebea h",
				"leavesAt": "20:21",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ţebea h",
				"to": "Ribiţa h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ribiţa h.",
				"to": "Brad",
				"leavesAt": "20:29",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14317",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "07:18",
				"arrivesAt": "07:24",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "07:25",
				"arrivesAt": "07:27",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "07:28",
				"arrivesAt": "07:30",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "07:40",
				"arrivesAt": "07:46",
				"waitsAtSource": 600,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Hodoni h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Hodoni h.",
				"to": "Chinezu h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Chinezu h.",
				"to": "Bărăteaz h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:07",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Bărăteaz h.",
				"to": "Gelu hc.",
				"leavesAt": "08:08",
				"arrivesAt": "08:12",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Gelu hc.",
				"to": "Variaş hc.",
				"leavesAt": "08:13",
				"arrivesAt": "08:19",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Variaş hc.",
				"to": "Periam",
				"leavesAt": "08:20",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Periam",
				"to": "Pesac h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:53",
				"waitsAtSource": 780,
				"distance": 6700
			},
			{
				"from": "Pesac h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "08:54",
				"arrivesAt": "09:02",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "09:03",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lovrin",
				"to": "Gotlob h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:35",
				"waitsAtSource": 1080,
				"distance": 6400
			},
			{
				"from": "Gotlob h.",
				"to": "Comloşu Mare h.",
				"leavesAt": "09:36",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Teremia Banat hc.",
				"leavesAt": "09:45",
				"arrivesAt": "09:55",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Nerău hcv.",
				"leavesAt": "09:56",
				"arrivesAt": "10:04",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14296",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:12",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "04:13",
				"arrivesAt": "04:22",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Pecica",
				"leavesAt": "04:23",
				"arrivesAt": "04:45",
				"waitsAtSource": 30,
				"distance": 17200
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "04:46",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:04",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "05:05",
				"arrivesAt": "05:11",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "05:14",
				"arrivesAt": "05:23",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14601",
		"segments": [
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "05:28",
				"arrivesAt": "05:33",
				"waitsAtSource": 0,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "05:34",
				"arrivesAt": "05:37",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "05:38",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:49",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Adămuş h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Adămuş h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "05:54",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "05:59",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14808",
		"segments": [
			{
				"from": "Hârlău",
				"to": "Bădeni hc.",
				"leavesAt": "14:52",
				"arrivesAt": "14:55",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Bădeni hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "14:56",
				"arrivesAt": "15:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Cotnari hc.",
				"leavesAt": "15:01",
				"arrivesAt": "15:05",
				"waitsAtSource": 30,
				"distance": 3700
			},
			{
				"from": "Cotnari hc.",
				"to": "Hodora h.",
				"leavesAt": "15:06",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hodora h.",
				"to": "Podu Ulmi h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Belceşti Hm.",
				"leavesAt": "15:18",
				"arrivesAt": "15:22",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Belceşti Hm.",
				"to": "Spinoasa h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:33",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spinoasa h.",
				"to": "Erbiceni hc.",
				"leavesAt": "15:34",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Erbiceni hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "15:42",
				"arrivesAt": "15:51",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "15:56",
				"arrivesAt": "16:04",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "16:05",
				"arrivesAt": "16:20",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14845",
		"segments": [
			{
				"from": "Roman",
				"to": "Sagna h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:27",
				"waitsAtSource": 0,
				"distance": 8700
			},
			{
				"from": "Sagna h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Stăniţa h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Stăniţa h.",
				"to": "Piscu Rusului h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:58",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Zece Prăjini h",
				"leavesAt": "08:59",
				"arrivesAt": "09:08",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zece Prăjini h",
				"to": "Dagâţa",
				"leavesAt": "09:09",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14544",
		"segments": [
			{
				"from": "Cruceni hcv.",
				"to": "Rudna hc.",
				"leavesAt": "12:43",
				"arrivesAt": "13:01",
				"waitsAtSource": 0,
				"distance": 11000
			},
			{
				"from": "Rudna hc.",
				"to": "Giulvăz h",
				"leavesAt": "13:02",
				"arrivesAt": "13:09",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Giulvăz h",
				"to": "Cebza h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:13",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Cebza h.",
				"to": "Peciu Nou h.",
				"leavesAt": "13:14",
				"arrivesAt": "13:23",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Peciu Nou h.",
				"to": "Parţa h.",
				"leavesAt": "13:24",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Parţa h.",
				"to": "Sânmihai h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:42",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sânmihai h.",
				"to": "Utvin h.",
				"leavesAt": "13:43",
				"arrivesAt": "13:47",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Utvin h.",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "13:48",
				"arrivesAt": "13:54",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "13:58",
				"arrivesAt": "14:09",
				"waitsAtSource": 240,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14804",
		"segments": [
			{
				"from": "Hârlău",
				"to": "Bădeni hc.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Bădeni hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Cotnari hc.",
				"leavesAt": "07:52",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cotnari hc.",
				"to": "Hodora h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hodora h.",
				"to": "Podu Ulmi h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Belceşti Hm.",
				"leavesAt": "08:09",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Belceşti Hm.",
				"to": "Spinoasa h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spinoasa h.",
				"to": "Erbiceni hc.",
				"leavesAt": "08:26",
				"arrivesAt": "08:33",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Erbiceni hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "08:34",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "08:48",
				"arrivesAt": "08:56",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "08:57",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14670",
		"segments": [
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "07:30",
				"arrivesAt": "07:38",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "07:47",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Ampoiţa h.",
				"leavesAt": "07:55",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ampoiţa h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:04",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:11",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:16",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Prisaca h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:24",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Prisaca h.",
				"to": "Feneş h.",
				"leavesAt": "08:25",
				"arrivesAt": "08:29",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Feneş h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "08:30",
				"arrivesAt": "08:35",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Zlatna h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:44",
				"waitsAtSource": 180,
				"distance": 4000
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna hcv.",
				"leavesAt": "08:45",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14360",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "04:50",
				"arrivesAt": "05:00",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:10",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "05:11",
				"arrivesAt": "05:18",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "05:27",
				"arrivesAt": "05:37",
				"waitsAtSource": 540,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "05:38",
				"arrivesAt": "05:42",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "05:43",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "05:52",
				"arrivesAt": "05:59",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "06:06",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "06:11",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "06:24",
				"arrivesAt": "06:31",
				"waitsAtSource": 180,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14318",
		"segments": [
			{
				"from": "Nerău hcv.",
				"to": "Teremia Banat hc.",
				"leavesAt": "07:19",
				"arrivesAt": "07:27",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Comloşu Mare h.",
				"leavesAt": "07:28",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Gotlob h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Gotlob h.",
				"to": "Lovrin",
				"leavesAt": "07:48",
				"arrivesAt": "07:55",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "07:56",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "08:04",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "08:13",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "08:38",
				"arrivesAt": "08:47",
				"waitsAtSource": 780,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "08:48",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "09:07",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "09:13",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "09:26",
				"arrivesAt": "09:32",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Timişoara Nord",
				"leavesAt": "09:33",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14605",
		"segments": [
			{
				"from": "Blaj",
				"to": "Sâncel h.",
				"leavesAt": "08:05",
				"arrivesAt": "08:12",
				"waitsAtSource": 0,
				"distance": 4246
			},
			{
				"from": "Sâncel h.",
				"to": "Pănade h.",
				"leavesAt": "08:13",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Pănade h.",
				"to": "Şona h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Şona h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Bălcaci h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bălcaci h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:43",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "08:44",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "08:56",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Adămuş h.",
				"leavesAt": "09:00",
				"arrivesAt": "09:03",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Adămuş h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "09:04",
				"arrivesAt": "09:08",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "09:09",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14851",
		"segments": [
			{
				"from": "Roman",
				"to": "Sagna h.",
				"leavesAt": "19:22",
				"arrivesAt": "19:31",
				"waitsAtSource": 0,
				"distance": 8700
			},
			{
				"from": "Sagna h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "19:32",
				"arrivesAt": "19:42",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Stăniţa h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:50",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Stăniţa h.",
				"to": "Piscu Rusului h.",
				"leavesAt": "19:51",
				"arrivesAt": "20:02",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Zece Prăjini h",
				"leavesAt": "20:03",
				"arrivesAt": "20:12",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zece Prăjini h",
				"to": "Dagâţa",
				"leavesAt": "20:13",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14800",
		"segments": [
			{
				"from": "Hârlău",
				"to": "Bădeni hc.",
				"leavesAt": "03:56",
				"arrivesAt": "04:00",
				"waitsAtSource": 0,
				"distance": 2600
			},
			{
				"from": "Bădeni hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "04:01",
				"arrivesAt": "04:05",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Cotnari hc.",
				"leavesAt": "04:06",
				"arrivesAt": "04:10",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cotnari hc.",
				"to": "Hodora h.",
				"leavesAt": "04:11",
				"arrivesAt": "04:16",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hodora h.",
				"to": "Podu Ulmi h.",
				"leavesAt": "04:17",
				"arrivesAt": "04:22",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Belceşti Hm.",
				"leavesAt": "04:23",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Belceşti Hm.",
				"to": "Spinoasa h.",
				"leavesAt": "04:28",
				"arrivesAt": "04:39",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Spinoasa h.",
				"to": "Erbiceni hc.",
				"leavesAt": "04:40",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Erbiceni hc.",
				"to": "Podu Iloaiei",
				"leavesAt": "04:48",
				"arrivesAt": "04:57",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Podu Iloaiei",
				"to": "Leţcani",
				"leavesAt": "05:02",
				"arrivesAt": "05:10",
				"waitsAtSource": 300,
				"distance": 8800
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "05:11",
				"arrivesAt": "05:27",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14850",
		"segments": [
			{
				"from": "Buhăieşti",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "19:30",
				"arrivesAt": "19:44",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Rafaila h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Rafaila h.",
				"to": "Dumeşti h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:59",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Dumeşti h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "20:00",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Suhuleţ h.",
				"leavesAt": "20:08",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Suhuleţ h.",
				"to": "Băluşeşti h",
				"leavesAt": "20:15",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Băluşeşti h",
				"to": "Dagâţa",
				"leavesAt": "20:20",
				"arrivesAt": "20:24",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14421",
		"segments": [
			{
				"from": "Ineu",
				"to": "Teuz h.",
				"leavesAt": "09:40",
				"arrivesAt": "09:51",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Teuz h.",
				"to": "Cermei hcv",
				"leavesAt": "09:52",
				"arrivesAt": "09:58",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14757",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "14:00",
				"arrivesAt": "14:04",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "14:05",
				"arrivesAt": "14:10",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "14:11",
				"arrivesAt": "14:21",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "14:22",
				"arrivesAt": "14:28",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "14:40",
				"arrivesAt": "14:53",
				"waitsAtSource": 30,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14386",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Tomnaticu h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:15",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Tomnaticu h.",
				"to": "Lovrin",
				"leavesAt": "05:16",
				"arrivesAt": "05:27",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "05:28",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Şandra h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şandra h.",
				"to": "Biled",
				"leavesAt": "05:51",
				"arrivesAt": "06:02",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Biled",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "06:03",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "06:23",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "06:36",
				"arrivesAt": "06:43",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:47",
				"waitsAtSource": 180,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:50",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "06:51",
				"arrivesAt": "06:57",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14545",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "11:00",
				"arrivesAt": "11:11",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Utvin h.",
				"leavesAt": "11:12",
				"arrivesAt": "11:18",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Utvin h.",
				"to": "Sânmihai h.",
				"leavesAt": "11:19",
				"arrivesAt": "11:23",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sânmihai h.",
				"to": "Parţa h.",
				"leavesAt": "11:24",
				"arrivesAt": "11:31",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Parţa h.",
				"to": "Peciu Nou h.",
				"leavesAt": "11:32",
				"arrivesAt": "11:43",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Peciu Nou h.",
				"to": "Cebza h.",
				"leavesAt": "11:44",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cebza h.",
				"to": "Giulvăz h",
				"leavesAt": "11:53",
				"arrivesAt": "11:56",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Giulvăz h",
				"to": "Rudna hc.",
				"leavesAt": "11:57",
				"arrivesAt": "12:04",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Rudna hc.",
				"to": "Cruceni hcv.",
				"leavesAt": "12:05",
				"arrivesAt": "12:24",
				"waitsAtSource": 30,
				"distance": 11000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14307",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "22:05",
				"arrivesAt": "22:14",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "22:15",
				"arrivesAt": "22:20",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "22:21",
				"arrivesAt": "22:27",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "22:28",
				"arrivesAt": "22:40",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Semlac h.",
				"leavesAt": "22:41",
				"arrivesAt": "23:04",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "23:05",
				"arrivesAt": "23:14",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "23:15",
				"arrivesAt": "23:28",
				"waitsAtSource": 30,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14394",
		"segments": [
			{
				"from": "Cenad h.",
				"to": "Sânnicolau Nord h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:43",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Sânnicolau Nord h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "19:44",
				"arrivesAt": "19:57",
				"waitsAtSource": 60,
				"distance": 5400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14602",
		"segments": [
			{
				"from": "Bălăuşeri hcv.",
				"to": "Coroiu h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:12",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Coroiu h.",
				"to": "Şoimuş h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:16",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Şoimuş h.",
				"to": "Laslău h.",
				"leavesAt": "05:17",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Laslău h.",
				"to": "Bahnea h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:32",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bahnea h.",
				"to": "Bernadea h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:39",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bernadea h.",
				"to": "Mica h.",
				"leavesAt": "05:40",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mica h.",
				"to": "Deaj h.",
				"leavesAt": "05:46",
				"arrivesAt": "05:51",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Deaj h.",
				"to": "Găneşti h.",
				"leavesAt": "05:52",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Găneşti h.",
				"to": "Şeuca h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:03",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Şeuca h.",
				"to": "Târnaveni",
				"leavesAt": "06:04",
				"arrivesAt": "06:09",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Târnaveni",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:16",
				"waitsAtSource": 120,
				"distance": 2400
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Adămuş h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:21",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Adămuş h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "06:22",
				"arrivesAt": "06:26",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Crăieşti h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Crăieşti h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 5160
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Feisa h.",
				"leavesAt": "06:39",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Feisa h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "06:43",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Bălcaci h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Bălcaci h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "06:52",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Şona h.",
				"leavesAt": "06:56",
				"arrivesAt": "07:00",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Şona h.",
				"to": "Pănade h.",
				"leavesAt": "07:01",
				"arrivesAt": "07:06",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pănade h.",
				"to": "Sâncel h.",
				"leavesAt": "07:07",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 1654
			},
			{
				"from": "Sâncel h.",
				"to": "Blaj",
				"leavesAt": "07:11",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 4246
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14805",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "13:07",
				"arrivesAt": "13:18",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "13:19",
				"arrivesAt": "13:27",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Erbiceni hc.",
				"leavesAt": "13:32",
				"arrivesAt": "13:40",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Erbiceni hc.",
				"to": "Spinoasa h.",
				"leavesAt": "13:41",
				"arrivesAt": "13:49",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Spinoasa h.",
				"to": "Belceşti Hm.",
				"leavesAt": "13:50",
				"arrivesAt": "14:01",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Belceşti Hm.",
				"to": "Podu Ulmi h.",
				"leavesAt": "14:02",
				"arrivesAt": "14:07",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Hodora h.",
				"leavesAt": "14:08",
				"arrivesAt": "14:13",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Hodora h.",
				"to": "Cotnari hc.",
				"leavesAt": "14:14",
				"arrivesAt": "14:19",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Cotnari hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "14:20",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Bădeni hc.",
				"leavesAt": "14:25",
				"arrivesAt": "14:29",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bădeni hc.",
				"to": "Hârlău",
				"leavesAt": "14:30",
				"arrivesAt": "14:35",
				"waitsAtSource": 30,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14499",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "03:02",
				"arrivesAt": "03:14",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "03:15",
				"arrivesAt": "03:18",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "03:19",
				"arrivesAt": "03:26",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Jebel",
				"leavesAt": "03:27",
				"arrivesAt": "03:39",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "03:40",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Gătaia",
				"leavesAt": "03:51",
				"arrivesAt": "04:09",
				"waitsAtSource": 60,
				"distance": 18200
			},
			{
				"from": "Gătaia",
				"to": "Măureni hc.",
				"leavesAt": "04:24",
				"arrivesAt": "04:32",
				"waitsAtSource": 900,
				"distance": 6700
			},
			{
				"from": "Măureni hc.",
				"to": "Gherteniş hc.",
				"leavesAt": "04:33",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Gherteniş hc.",
				"to": "Berzovia",
				"leavesAt": "04:41",
				"arrivesAt": "04:45",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "04:55",
				"arrivesAt": "05:05",
				"waitsAtSource": 600,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "05:06",
				"arrivesAt": "05:12",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "05:13",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "05:18",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "05:32",
				"arrivesAt": "05:40",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14841",
		"segments": [
			{
				"from": "Dagâţa",
				"to": "Băluşeşti h",
				"leavesAt": "04:26",
				"arrivesAt": "04:30",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Băluşeşti h",
				"to": "Suhuleţ h.",
				"leavesAt": "04:31",
				"arrivesAt": "04:35",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Suhuleţ h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "04:36",
				"arrivesAt": "04:42",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Dumeşti h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumeşti h.",
				"to": "Rafaila h.",
				"leavesAt": "04:51",
				"arrivesAt": "04:58",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Rafaila h.",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "04:59",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Buhăieşti",
				"leavesAt": "05:07",
				"arrivesAt": "05:23",
				"waitsAtSource": 60,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14065",
		"segments": [
			{
				"from": "Braşov",
				"to": "Augustin Hm.",
				"leavesAt": "07:44",
				"arrivesAt": "08:39",
				"waitsAtSource": 0,
				"distance": 49100
			},
			{
				"from": "Augustin Hm.",
				"to": "Rupea",
				"leavesAt": "08:40",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 24700
			},
			{
				"from": "Rupea",
				"to": "Sighişoara",
				"leavesAt": "09:16",
				"arrivesAt": "10:28",
				"waitsAtSource": 60,
				"distance": 53600
			},
			{
				"from": "Sighişoara",
				"to": "Mediaş",
				"leavesAt": "10:32",
				"arrivesAt": "11:20",
				"waitsAtSource": 240,
				"distance": 38400
			},
			{
				"from": "Mediaş",
				"to": "Copşa Mică",
				"leavesAt": "11:22",
				"arrivesAt": "11:38",
				"waitsAtSource": 120,
				"distance": 10400
			},
			{
				"from": "Copşa Mică",
				"to": "Valea Lungă",
				"leavesAt": "11:39",
				"arrivesAt": "12:05",
				"waitsAtSource": 60,
				"distance": 17900
			},
			{
				"from": "Valea Lungă",
				"to": "Blaj",
				"leavesAt": "12:13",
				"arrivesAt": "12:27",
				"waitsAtSource": 480,
				"distance": 12100
			},
			{
				"from": "Blaj",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "12:39",
				"arrivesAt": "13:02",
				"waitsAtSource": 720,
				"distance": 17900
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Coşlariu",
				"leavesAt": "13:10",
				"arrivesAt": "13:16",
				"waitsAtSource": 480,
				"distance": 1500
			},
			{
				"from": "Coşlariu",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "13:21",
				"arrivesAt": "13:42",
				"waitsAtSource": 300,
				"distance": 11100
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "13:50",
				"arrivesAt": "13:58",
				"waitsAtSource": 480,
				"distance": 4500
			},
			{
				"from": "Alba Iulia",
				"to": "Vinţu de Jos",
				"leavesAt": "14:06",
				"arrivesAt": "14:20",
				"waitsAtSource": 480,
				"distance": 9800
			},
			{
				"from": "Vinţu de Jos",
				"to": "Şibot",
				"leavesAt": "14:21",
				"arrivesAt": "14:43",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Şibot",
				"to": "Orăştie",
				"leavesAt": "14:44",
				"arrivesAt": "14:59",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Orăştie",
				"to": "Simeria",
				"leavesAt": "15:05",
				"arrivesAt": "15:28",
				"waitsAtSource": 360,
				"distance": 16500
			},
			{
				"from": "Simeria",
				"to": "Deva",
				"leavesAt": "15:30",
				"arrivesAt": "15:42",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Deva",
				"to": "Ilia",
				"leavesAt": "15:44",
				"arrivesAt": "16:14",
				"waitsAtSource": 120,
				"distance": 23600
			},
			{
				"from": "Ilia",
				"to": "Săvârşin",
				"leavesAt": "16:15",
				"arrivesAt": "16:56",
				"waitsAtSource": 60,
				"distance": 40400
			},
			{
				"from": "Săvârşin",
				"to": "Radna",
				"leavesAt": "16:57",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 49700
			},
			{
				"from": "Radna",
				"to": "Arad",
				"leavesAt": "17:43",
				"arrivesAt": "18:19",
				"waitsAtSource": 60,
				"distance": 34500
			},
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "18:39",
				"arrivesAt": "18:46",
				"waitsAtSource": 1200,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Timişoara Nord",
				"leavesAt": "18:51",
				"arrivesAt": "19:41",
				"waitsAtSource": 300,
				"distance": 51000
			}
		],
		"restrictions": [
			{
				"from": "20170107",
				"to": "20170107",
				"daysOfWeek": 288
			},
			{
				"from": "20170114",
				"to": "20170114",
				"daysOfWeek": 288
			},
			{
				"from": "20170121",
				"to": "20170121",
				"daysOfWeek": 288
			},
			{
				"from": "20170128",
				"to": "20170128",
				"daysOfWeek": 288
			},
			{
				"from": "20170204",
				"to": "20170204",
				"daysOfWeek": 288
			},
			{
				"from": "20170211",
				"to": "20170211",
				"daysOfWeek": 288
			},
			{
				"from": "20170218",
				"to": "20170218",
				"daysOfWeek": 288
			},
			{
				"from": "20170225",
				"to": "20170225",
				"daysOfWeek": 288
			},
			{
				"from": "20170304",
				"to": "20170304",
				"daysOfWeek": 288
			},
			{
				"from": "20170311",
				"to": "20170311",
				"daysOfWeek": 288
			},
			{
				"from": "20170318",
				"to": "20170318",
				"daysOfWeek": 288
			},
			{
				"from": "20170325",
				"to": "20170325",
				"daysOfWeek": 288
			},
			{
				"from": "20170401",
				"to": "20170401",
				"daysOfWeek": 288
			},
			{
				"from": "20170408",
				"to": "20170408",
				"daysOfWeek": 288
			},
			{
				"from": "20170415",
				"to": "20170415",
				"daysOfWeek": 288
			},
			{
				"from": "20170422",
				"to": "20170422",
				"daysOfWeek": 288
			},
			{
				"from": "20170429",
				"to": "20170429",
				"daysOfWeek": 288
			},
			{
				"from": "20170506",
				"to": "20170506",
				"daysOfWeek": 288
			},
			{
				"from": "20170513",
				"to": "20170513",
				"daysOfWeek": 288
			},
			{
				"from": "20170520",
				"to": "20170520",
				"daysOfWeek": 288
			},
			{
				"from": "20170527",
				"to": "20170527",
				"daysOfWeek": 288
			},
			{
				"from": "20170603",
				"to": "20170603",
				"daysOfWeek": 288
			},
			{
				"from": "20170610",
				"to": "20170610",
				"daysOfWeek": 288
			},
			{
				"from": "20170617",
				"to": "20170617",
				"daysOfWeek": 288
			},
			{
				"from": "20170624",
				"to": "20170624",
				"daysOfWeek": 288
			},
			{
				"from": "20170701",
				"to": "20170701",
				"daysOfWeek": 288
			},
			{
				"from": "20170708",
				"to": "20170708",
				"daysOfWeek": 288
			},
			{
				"from": "20170715",
				"to": "20170715",
				"daysOfWeek": 288
			},
			{
				"from": "20170722",
				"to": "20170722",
				"daysOfWeek": 288
			},
			{
				"from": "20170729",
				"to": "20170729",
				"daysOfWeek": 288
			},
			{
				"from": "20170805",
				"to": "20170805",
				"daysOfWeek": 288
			},
			{
				"from": "20170812",
				"to": "20170812",
				"daysOfWeek": 288
			},
			{
				"from": "20170819",
				"to": "20170819",
				"daysOfWeek": 288
			},
			{
				"from": "20170826",
				"to": "20170826",
				"daysOfWeek": 288
			},
			{
				"from": "20170902",
				"to": "20170902",
				"daysOfWeek": 288
			},
			{
				"from": "20170909",
				"to": "20170909",
				"daysOfWeek": 288
			},
			{
				"from": "20170916",
				"to": "20170916",
				"daysOfWeek": 288
			},
			{
				"from": "20170923",
				"to": "20170923",
				"daysOfWeek": 288
			},
			{
				"from": "20170930",
				"to": "20170930",
				"daysOfWeek": 288
			},
			{
				"from": "20171007",
				"to": "20171007",
				"daysOfWeek": 288
			},
			{
				"from": "20171014",
				"to": "20171014",
				"daysOfWeek": 288
			},
			{
				"from": "20171021",
				"to": "20171021",
				"daysOfWeek": 288
			},
			{
				"from": "20171028",
				"to": "20171028",
				"daysOfWeek": 288
			},
			{
				"from": "20171104",
				"to": "20171104",
				"daysOfWeek": 288
			},
			{
				"from": "20171111",
				"to": "20171111",
				"daysOfWeek": 288
			},
			{
				"from": "20171118",
				"to": "20171118",
				"daysOfWeek": 288
			},
			{
				"from": "20171125",
				"to": "20171125",
				"daysOfWeek": 288
			},
			{
				"from": "20171202",
				"to": "20171202",
				"daysOfWeek": 288
			},
			{
				"from": "20171209",
				"to": "20171209",
				"daysOfWeek": 288
			},
			{
				"from": "20161217",
				"to": "20161217",
				"daysOfWeek": 288
			},
			{
				"from": "20161224",
				"to": "20161224",
				"daysOfWeek": 288
			},
			{
				"from": "20161231",
				"to": "20161231",
				"daysOfWeek": 288
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14300",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:52",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "07:53",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Pecica",
				"leavesAt": "08:04",
				"arrivesAt": "08:28",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:54",
				"waitsAtSource": 840,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "09:02",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "09:11",
				"arrivesAt": "09:20",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14295",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "05:35",
				"arrivesAt": "05:44",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "05:45",
				"arrivesAt": "05:50",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "05:58",
				"arrivesAt": "06:10",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Canton Nr. 9 h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:36",
				"waitsAtSource": 780,
				"distance": 9600
			},
			{
				"from": "Canton Nr. 9 h.",
				"to": "Semlac h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:47",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "06:48",
				"arrivesAt": "06:58",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "06:59",
				"arrivesAt": "07:12",
				"waitsAtSource": 60,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14703",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "07:55",
				"arrivesAt": "08:01",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "08:10",
				"arrivesAt": "08:13",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "08:14",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "08:22",
				"arrivesAt": "08:27",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "08:28",
				"arrivesAt": "08:31",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "08:32",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14440",
		"segments": [
			{
				"from": "Brad",
				"to": "Ribiţa h.",
				"leavesAt": "04:50",
				"arrivesAt": "04:54",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Ribiţa h.",
				"to": "Ţebea h",
				"leavesAt": "04:55",
				"arrivesAt": "04:58",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Ţebea h",
				"to": "Baia de Criş h.",
				"leavesAt": "04:59",
				"arrivesAt": "05:02",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Baia de Criş h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "05:03",
				"arrivesAt": "05:06",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Birtin h.",
				"leavesAt": "05:07",
				"arrivesAt": "05:12",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Birtin h.",
				"to": "Vaţa h.",
				"leavesAt": "05:13",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Vaţa h.",
				"to": "Ociu h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ociu h.",
				"to": "Ocişor h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:29",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Ocişor h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "05:30",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "05:36",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "05:41",
				"arrivesAt": "05:45",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Tălagiu h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:02",
				"waitsAtSource": 720,
				"distance": 4500
			},
			{
				"from": "Tălagiu h.",
				"to": "Aciuţa h.",
				"leavesAt": "06:03",
				"arrivesAt": "06:10",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Aciuţa h.",
				"to": "Romaniţa h.",
				"leavesAt": "06:11",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Romaniţa h.",
				"to": "Gurahonţ",
				"leavesAt": "06:15",
				"arrivesAt": "06:25",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gurahonţ",
				"to": "Bonţeşti h.",
				"leavesAt": "06:26",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Bonţeşti h.",
				"to": "Almaş h.",
				"leavesAt": "06:31",
				"arrivesAt": "06:36",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Almaş h.",
				"to": "Joia Mare hc.",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Joia Mare hc.",
				"to": "Paulian h.",
				"leavesAt": "06:43",
				"arrivesAt": "06:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paulian h.",
				"to": "Sebiş",
				"leavesAt": "06:48",
				"arrivesAt": "06:54",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sebiş",
				"to": "Răpsig h.",
				"leavesAt": "07:08",
				"arrivesAt": "07:18",
				"waitsAtSource": 840,
				"distance": 10000
			},
			{
				"from": "Răpsig h.",
				"to": "Bocsig  h",
				"leavesAt": "07:19",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bocsig  h",
				"to": "Tămand h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Tămand h.",
				"to": "Ineu",
				"leavesAt": "07:31",
				"arrivesAt": "07:39",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Ineu",
				"to": "Mocrea h.",
				"leavesAt": "07:40",
				"arrivesAt": "07:47",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mocrea h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "07:48",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Seleuş h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:02",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Seleuş h.",
				"to": "Pâncota h.",
				"leavesAt": "08:03",
				"arrivesAt": "08:08",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pâncota h.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:12",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Şiria Hm.",
				"leavesAt": "08:13",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Şiria Hm.",
				"to": "Sântana",
				"leavesAt": "08:18",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:44",
				"waitsAtSource": 180,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utviniş h.",
				"leavesAt": "08:45",
				"arrivesAt": "08:48",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Utviniş h.",
				"to": "Utvinişu Nou",
				"leavesAt": "08:49",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "08:53",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14738",
		"segments": [
			{
				"from": "Breţcu Hm.",
				"to": "Lemnia h.",
				"leavesAt": "16:53",
				"arrivesAt": "16:59",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lemnia h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:05",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Bălani h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bălani h.",
				"to": "Poieniţa h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Poieniţa h.",
				"to": "Sânzieni h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Sânzieni h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "17:23",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Cătălina h.",
				"leavesAt": "18:00",
				"arrivesAt": "18:05",
				"waitsAtSource": 1500,
				"distance": 4400
			},
			{
				"from": "Cătălina h.",
				"to": "Imeci Hm.",
				"leavesAt": "18:06",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Imeci Hm.",
				"to": "Zăbala h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Zăbala h.",
				"to": "Covasna Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Covasna Hm.",
				"to": "Brateş h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Brateş h.",
				"to": "Ţufalău h.",
				"leavesAt": "18:34",
				"arrivesAt": "18:38",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Ţufalău h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "18:39",
				"arrivesAt": "18:42",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Biţa h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Biţa h.",
				"to": "Moacşa hcv",
				"leavesAt": "18:49",
				"arrivesAt": "18:54",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Moacşa hcv",
				"to": "Angheluş h.",
				"leavesAt": "18:55",
				"arrivesAt": "19:01",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Angheluş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "19:02",
				"arrivesAt": "19:11",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14442",
		"segments": [
			{
				"from": "Brad",
				"to": "Ribiţa h.",
				"leavesAt": "07:12",
				"arrivesAt": "07:17",
				"waitsAtSource": 0,
				"distance": 3400
			},
			{
				"from": "Ribiţa h.",
				"to": "Ţebea h",
				"leavesAt": "07:18",
				"arrivesAt": "07:21",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ţebea h",
				"to": "Baia de Criş h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:25",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Baia de Criş h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "07:26",
				"arrivesAt": "07:29",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Birtin h.",
				"leavesAt": "07:30",
				"arrivesAt": "07:35",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Birtin h.",
				"to": "Vaţa h.",
				"leavesAt": "07:36",
				"arrivesAt": "07:42",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Vaţa h.",
				"to": "Ociu h.",
				"leavesAt": "07:43",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Ociu h.",
				"to": "Ocişor h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ocişor h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "07:54",
				"arrivesAt": "07:59",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:05",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "08:06",
				"arrivesAt": "08:10",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Tălagiu h.",
				"leavesAt": "08:11",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tălagiu h.",
				"to": "Aciuţa h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Aciuţa h.",
				"to": "Romaniţa h.",
				"leavesAt": "08:26",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Romaniţa h.",
				"to": "Gurahonţ",
				"leavesAt": "08:31",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 6100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18231",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "13:23",
				"arrivesAt": "13:30",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Zădăreni Hm.",
				"leavesAt": "13:37",
				"arrivesAt": "13:47",
				"waitsAtSource": 420,
				"distance": 9600
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:50",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Felnac hc.",
				"leavesAt": "13:51",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Felnac hc.",
				"to": "Sânpetru German h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sânpetru German h.",
				"to": "Munor h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:07",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Munor h.",
				"to": "Secusigiu h",
				"leavesAt": "14:08",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Secusigiu h",
				"to": "Aranca h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Aranca h.",
				"to": "Periam",
				"leavesAt": "14:17",
				"arrivesAt": "14:28",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Periam",
				"to": "Sânpetru h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:35",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sânpetru h.",
				"to": "Saravale h.",
				"leavesAt": "14:36",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Saravale h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "14:45",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14707",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "12:00",
				"arrivesAt": "12:06",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "12:07",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "12:16",
				"arrivesAt": "12:19",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "12:20",
				"arrivesAt": "12:24",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "12:25",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "12:28",
				"arrivesAt": "12:33",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "12:34",
				"arrivesAt": "12:37",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "12:38",
				"arrivesAt": "12:41",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14359",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "07:15",
				"arrivesAt": "07:22",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Zădăreni Hm.",
				"leavesAt": "07:26",
				"arrivesAt": "07:36",
				"waitsAtSource": 240,
				"distance": 9600
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Felnac hc.",
				"leavesAt": "07:42",
				"arrivesAt": "07:48",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Felnac hc.",
				"to": "Sânpetru German h.",
				"leavesAt": "07:49",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sânpetru German h.",
				"to": "Munor h.",
				"leavesAt": "07:57",
				"arrivesAt": "08:00",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Munor h.",
				"to": "Secusigiu h",
				"leavesAt": "08:01",
				"arrivesAt": "08:05",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Secusigiu h",
				"to": "Aranca h.",
				"leavesAt": "08:06",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Aranca h.",
				"to": "Periam",
				"leavesAt": "08:10",
				"arrivesAt": "08:21",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Periam",
				"to": "Sânpetru h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:42",
				"waitsAtSource": 840,
				"distance": 4500
			},
			{
				"from": "Sânpetru h.",
				"to": "Saravale h.",
				"leavesAt": "08:43",
				"arrivesAt": "08:52",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Saravale h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "08:53",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14305",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "19:40",
				"arrivesAt": "19:49",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "19:50",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "20:05",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Semlac h.",
				"leavesAt": "20:32",
				"arrivesAt": "20:56",
				"waitsAtSource": 780,
				"distance": 17200
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "20:57",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "21:08",
				"arrivesAt": "21:21",
				"waitsAtSource": 60,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14427",
		"segments": [
			{
				"from": "Ineu",
				"to": "Teuz h.",
				"leavesAt": "16:12",
				"arrivesAt": "16:23",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Teuz h.",
				"to": "Cermei hcv",
				"leavesAt": "16:24",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14970",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "04:24",
				"arrivesAt": "04:28",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "04:29",
				"arrivesAt": "04:34",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "04:35",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "04:41",
				"arrivesAt": "04:47",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "04:48",
				"arrivesAt": "04:53",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "04:54",
				"arrivesAt": "04:59",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "05:00",
				"arrivesAt": "05:03",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "05:04",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "05:10",
				"arrivesAt": "05:15",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "05:16",
				"arrivesAt": "05:19",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:24",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "05:25",
				"arrivesAt": "05:28",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "05:29",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "05:35",
				"arrivesAt": "05:40",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14610",
		"segments": [
			{
				"from": "Praid",
				"to": "Sovata  hcv.",
				"leavesAt": "15:30",
				"arrivesAt": "15:50",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Sovata  hcv.",
				"to": "Sărăţeni h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sărăţeni h.",
				"to": "Chibed h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:02",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Chibed h.",
				"to": "Ghindari h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:08",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ghindari h.",
				"to": "Cioc h.",
				"leavesAt": "16:09",
				"arrivesAt": "16:13",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Cioc h.",
				"to": "Sângeorgiu de Pădure h.",
				"leavesAt": "16:14",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 6600
			},
			{
				"from": "Sângeorgiu de Pădure h.",
				"to": "Fântânele h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Fântânele h.",
				"to": "Bălăuşeri hcv.",
				"leavesAt": "16:30",
				"arrivesAt": "16:40",
				"waitsAtSource": 30,
				"distance": 4900
			},
			{
				"from": "Bălăuşeri hcv.",
				"to": "Coroiu h.",
				"leavesAt": "17:00",
				"arrivesAt": "17:10",
				"waitsAtSource": 1200,
				"distance": 6700
			},
			{
				"from": "Coroiu h.",
				"to": "Şoimuş h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:14",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Şoimuş h.",
				"to": "Laslău h.",
				"leavesAt": "17:15",
				"arrivesAt": "17:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Laslău h.",
				"to": "Bahnea h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bahnea h.",
				"to": "Bernadea h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bernadea h.",
				"to": "Mica h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:42",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mica h.",
				"to": "Deaj h.",
				"leavesAt": "17:43",
				"arrivesAt": "17:47",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Deaj h.",
				"to": "Găneşti h.",
				"leavesAt": "17:48",
				"arrivesAt": "17:52",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Găneşti h.",
				"to": "Şeuca h.",
				"leavesAt": "17:53",
				"arrivesAt": "17:58",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Şeuca h.",
				"to": "Târnaveni",
				"leavesAt": "17:59",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Târnaveni",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "18:07",
				"arrivesAt": "18:12",
				"waitsAtSource": 180,
				"distance": 2400
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Adămuş h.",
				"leavesAt": "18:13",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Adămuş h.",
				"to": "Crăieşti h.",
				"leavesAt": "18:17",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Crăieşti h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:30",
				"waitsAtSource": 60,
				"distance": 5160
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Feisa h.",
				"leavesAt": "18:31",
				"arrivesAt": "18:34",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Feisa h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "18:35",
				"arrivesAt": "18:39",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Bălcaci h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:44",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Bălcaci h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "18:45",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Şona h.",
				"leavesAt": "18:49",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Şona h.",
				"to": "Pănade h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:59",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pănade h.",
				"to": "Sâncel h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:03",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Sâncel h.",
				"to": "Blaj",
				"leavesAt": "19:04",
				"arrivesAt": "19:10",
				"waitsAtSource": 30,
				"distance": 4246
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14673",
		"segments": [
			{
				"from": "Zlatna hcv.",
				"to": "Zlatna h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:14",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "13:15",
				"arrivesAt": "13:21",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Feneş h.",
				"leavesAt": "13:24",
				"arrivesAt": "13:29",
				"waitsAtSource": 180,
				"distance": 2400
			},
			{
				"from": "Feneş h.",
				"to": "Prisaca h.",
				"leavesAt": "13:30",
				"arrivesAt": "13:34",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Prisaca h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:42",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "13:43",
				"arrivesAt": "13:47",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "13:48",
				"arrivesAt": "13:54",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Ampoiţa h.",
				"leavesAt": "13:55",
				"arrivesAt": "14:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ampoiţa h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "14:01",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:13",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "14:14",
				"arrivesAt": "14:18",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "14:19",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Alba Iulia",
				"leavesAt": "14:24",
				"arrivesAt": "14:32",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14448",
		"segments": [
			{
				"from": "Gurahonţ",
				"to": "Bonţeşti h.",
				"leavesAt": "13:55",
				"arrivesAt": "13:59",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Bonţeşti h.",
				"to": "Almaş h.",
				"leavesAt": "14:00",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Almaş h.",
				"to": "Joia Mare hc.",
				"leavesAt": "14:06",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Joia Mare hc.",
				"to": "Paulian h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Paulian h.",
				"to": "Sebiş",
				"leavesAt": "14:17",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Sebiş",
				"to": "Răpsig h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:50",
				"waitsAtSource": 1020,
				"distance": 10000
			},
			{
				"from": "Răpsig h.",
				"to": "Bocsig  h",
				"leavesAt": "14:51",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bocsig  h",
				"to": "Tămand h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Tămand h.",
				"to": "Ineu",
				"leavesAt": "15:03",
				"arrivesAt": "15:11",
				"waitsAtSource": 30,
				"distance": 8400
			},
			{
				"from": "Ineu",
				"to": "Mocrea h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:33",
				"waitsAtSource": 900,
				"distance": 4600
			},
			{
				"from": "Mocrea h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "15:34",
				"arrivesAt": "15:40",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Seleuş h.",
				"leavesAt": "15:41",
				"arrivesAt": "15:48",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Seleuş h.",
				"to": "Pâncota h.",
				"leavesAt": "15:49",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Pâncota h.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "15:55",
				"arrivesAt": "15:58",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Şiria Hm.",
				"leavesAt": "15:59",
				"arrivesAt": "16:03",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Şiria Hm.",
				"to": "Sântana",
				"leavesAt": "16:04",
				"arrivesAt": "16:16",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Sântana",
				"to": "Zimandu Nou h.",
				"leavesAt": "16:21",
				"arrivesAt": "16:32",
				"waitsAtSource": 300,
				"distance": 10700
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Utvinişu Nou",
				"leavesAt": "16:33",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Utvinişu Nou",
				"to": "Arad",
				"leavesAt": "16:40",
				"arrivesAt": "16:49",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14365",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "16:18",
				"arrivesAt": "16:26",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Zădăreni Hm.",
				"leavesAt": "16:30",
				"arrivesAt": "16:41",
				"waitsAtSource": 240,
				"distance": 9600
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "16:43",
				"arrivesAt": "16:47",
				"waitsAtSource": 120,
				"distance": 1900
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Felnac hc.",
				"leavesAt": "16:49",
				"arrivesAt": "16:55",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Felnac hc.",
				"to": "Sânpetru German h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:04",
				"waitsAtSource": 120,
				"distance": 6700
			},
			{
				"from": "Sânpetru German h.",
				"to": "Munor h.",
				"leavesAt": "17:06",
				"arrivesAt": "17:10",
				"waitsAtSource": 120,
				"distance": 2600
			},
			{
				"from": "Munor h.",
				"to": "Secusigiu h",
				"leavesAt": "17:12",
				"arrivesAt": "17:17",
				"waitsAtSource": 120,
				"distance": 2800
			},
			{
				"from": "Secusigiu h",
				"to": "Aranca h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:24",
				"waitsAtSource": 120,
				"distance": 2000
			},
			{
				"from": "Aranca h.",
				"to": "Periam",
				"leavesAt": "17:25",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Periam",
				"to": "Sânpetru h.",
				"leavesAt": "17:59",
				"arrivesAt": "18:06",
				"waitsAtSource": 1320,
				"distance": 4500
			},
			{
				"from": "Sânpetru h.",
				"to": "Saravale h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:16",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Saravale h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "18:17",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14379",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Sânnicolau Nord h.",
				"leavesAt": "06:05",
				"arrivesAt": "06:17",
				"waitsAtSource": 0,
				"distance": 5400
			},
			{
				"from": "Sânnicolau Nord h.",
				"to": "Cenad h.",
				"leavesAt": "06:18",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14820",
		"segments": [
			{
				"from": "Dorohoi",
				"to": "Broscăuţi h.",
				"leavesAt": "12:46",
				"arrivesAt": "12:52",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Broscăuţi h.",
				"to": "Carasa h.",
				"leavesAt": "12:53",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Carasa h.",
				"to": "Corlăteni h",
				"leavesAt": "13:01",
				"arrivesAt": "13:04",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Corlăteni h",
				"to": "Mateieni h.",
				"leavesAt": "13:05",
				"arrivesAt": "13:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mateieni h.",
				"to": "Vorniceni h.",
				"leavesAt": "13:10",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vorniceni h.",
				"to": "Mândreşti h.",
				"leavesAt": "13:15",
				"arrivesAt": "13:23",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mândreşti h.",
				"to": "Ungureni Hm.",
				"leavesAt": "13:24",
				"arrivesAt": "13:30",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ungureni Hm.",
				"to": "Dângeni Nord h.",
				"leavesAt": "13:31",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Dângeni",
				"leavesAt": "13:40",
				"arrivesAt": "13:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni",
				"to": "Buhăceni h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:52",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Buhăceni h.",
				"to": "Truşeşti",
				"leavesAt": "13:53",
				"arrivesAt": "13:59",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "14:14",
				"arrivesAt": "14:23",
				"waitsAtSource": 900,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "14:31",
				"arrivesAt": "14:39",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "14:40",
				"arrivesAt": "14:46",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "14:47",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "14:53",
				"arrivesAt": "14:58",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "14:59",
				"arrivesAt": "15:04",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "15:05",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "15:11",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "15:19",
				"arrivesAt": "15:30",
				"waitsAtSource": 120,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "15:31",
				"arrivesAt": "15:37",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "15:38",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "15:47",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "15:59",
				"arrivesAt": "16:15",
				"waitsAtSource": 120,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14297",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "08:00",
				"arrivesAt": "08:09",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:16",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "08:17",
				"arrivesAt": "08:23",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "08:24",
				"arrivesAt": "08:36",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Semlac h.",
				"leavesAt": "08:37",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "09:13",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14811",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "20:30",
				"arrivesAt": "20:41",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "20:42",
				"arrivesAt": "20:50",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Erbiceni hc.",
				"leavesAt": "20:55",
				"arrivesAt": "21:04",
				"waitsAtSource": 300,
				"distance": 6000
			},
			{
				"from": "Erbiceni hc.",
				"to": "Spinoasa h.",
				"leavesAt": "21:05",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Spinoasa h.",
				"to": "Belceşti Hm.",
				"leavesAt": "21:14",
				"arrivesAt": "21:25",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Belceşti Hm.",
				"to": "Podu Ulmi h.",
				"leavesAt": "21:26",
				"arrivesAt": "21:31",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Hodora h.",
				"leavesAt": "21:32",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Hodora h.",
				"to": "Cotnari hc.",
				"leavesAt": "21:38",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Cotnari hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "21:44",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Bădeni hc.",
				"leavesAt": "21:49",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bădeni hc.",
				"to": "Hârlău",
				"leavesAt": "21:55",
				"arrivesAt": "22:00",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14362",
		"segments": [
			{
				"from": "Vălcani hcv.",
				"to": "Dudeştii Vechi  h",
				"leavesAt": "06:55",
				"arrivesAt": "07:04",
				"waitsAtSource": 0,
				"distance": 7000
			},
			{
				"from": "Dudeştii Vechi  h",
				"to": "Sânnicolau Mare",
				"leavesAt": "07:05",
				"arrivesAt": "07:23",
				"waitsAtSource": 60,
				"distance": 14000
			},
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "07:37",
				"arrivesAt": "07:47",
				"waitsAtSource": 840,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:56",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "07:57",
				"arrivesAt": "08:03",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:42",
				"waitsAtSource": 1740,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "08:43",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:54",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "08:55",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "09:12",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "09:25",
				"arrivesAt": "09:32",
				"waitsAtSource": 180,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14761",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "20:01",
				"arrivesAt": "20:07",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "20:08",
				"arrivesAt": "20:18",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "20:19",
				"arrivesAt": "20:25",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "20:26",
				"arrivesAt": "20:31",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "20:32",
				"arrivesAt": "20:38",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "20:39",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14611",
		"segments": [
			{
				"from": "Blaj",
				"to": "Sâncel h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 4246
			},
			{
				"from": "Sâncel h.",
				"to": "Pănade h.",
				"leavesAt": "16:52",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Pănade h.",
				"to": "Şona h.",
				"leavesAt": "16:56",
				"arrivesAt": "17:01",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Şona h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Bălcaci h.",
				"leavesAt": "17:07",
				"arrivesAt": "17:10",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bălcaci h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "17:11",
				"arrivesAt": "17:15",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:24",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "17:25",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Adămuş h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:40",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Adămuş h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "17:41",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "17:46",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14515",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Sud",
				"leavesAt": "20:02",
				"arrivesAt": "20:12",
				"waitsAtSource": 0,
				"distance": 5600
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara C.E.T.",
				"leavesAt": "20:13",
				"arrivesAt": "20:16",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişeni Hm.",
				"leavesAt": "20:17",
				"arrivesAt": "20:22",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişeni Hm.",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "20:23",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Jebel",
				"leavesAt": "20:29",
				"arrivesAt": "20:34",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Jebel",
				"to": "Voiteni",
				"leavesAt": "20:35",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Voiteni",
				"to": "Birda hcv.",
				"leavesAt": "20:53",
				"arrivesAt": "21:02",
				"waitsAtSource": 480,
				"distance": 9500
			},
			{
				"from": "Birda hcv.",
				"to": "Gătaia",
				"leavesAt": "21:03",
				"arrivesAt": "21:12",
				"waitsAtSource": 30,
				"distance": 8700
			},
			{
				"from": "Gătaia",
				"to": "Măureni hc.",
				"leavesAt": "21:13",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Măureni hc.",
				"to": "Gherteniş hc.",
				"leavesAt": "21:21",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Gherteniş hc.",
				"to": "Berzovia",
				"leavesAt": "21:29",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "21:34",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "21:44",
				"arrivesAt": "21:50",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "21:51",
				"arrivesAt": "21:54",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "21:55",
				"arrivesAt": "22:02",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "22:03",
				"arrivesAt": "22:08",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "22:09",
				"arrivesAt": "22:17",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "22:18",
				"arrivesAt": "22:21",
				"waitsAtSource": 30,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14020",
		"segments": [
			{
				"from": "Luduş",
				"to": "Luduş Sat hc.",
				"leavesAt": "17:14",
				"arrivesAt": "17:18",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "17:19",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 8080
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Tăureni h.",
				"leavesAt": "17:31",
				"arrivesAt": "17:39",
				"waitsAtSource": 30,
				"distance": 5620
			},
			{
				"from": "Tăureni h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "17:40",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Bota Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "17:55",
				"arrivesAt": "18:01",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:08",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Balda h.",
				"leavesAt": "18:09",
				"arrivesAt": "18:15",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Balda h.",
				"to": "Sărmaşu h.",
				"leavesAt": "18:16",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "18:21",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "18:26",
				"arrivesAt": "18:30",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Sărmăşel hcv .",
				"to": "Ţăgşor h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:36",
				"waitsAtSource": 180,
				"distance": 2000
			},
			{
				"from": "Ţăgşor h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "18:37",
				"arrivesAt": "18:42",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţagu h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 1400
			},
			{
				"from": "Ţagu h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "18:46",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "18:54",
				"arrivesAt": "19:03",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "19:04",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Brăteni h.",
				"leavesAt": "19:10",
				"arrivesAt": "19:16",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Brăteni h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "19:17",
				"arrivesAt": "19:23",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Vermeş h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:32",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vermeş h.",
				"to": "Lechinţa",
				"leavesAt": "19:33",
				"arrivesAt": "19:37",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Lechinţa",
				"to": "Ţigău h.",
				"leavesAt": "19:38",
				"arrivesAt": "19:45",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ţigău h.",
				"to": "Chiraleş h.",
				"leavesAt": "19:46",
				"arrivesAt": "19:50",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Chiraleş h.",
				"to": "Chintelnic h.",
				"leavesAt": "19:51",
				"arrivesAt": "19:54",
				"waitsAtSource": 30,
				"distance": 2276
			},
			{
				"from": "Chintelnic h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "19:55",
				"arrivesAt": "19:59",
				"waitsAtSource": 30,
				"distance": 2314
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "20:00",
				"arrivesAt": "20:02",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel",
				"leavesAt": "20:03",
				"arrivesAt": "20:09",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel",
				"to": "Sărata h.",
				"leavesAt": "20:10",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:23",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "20:24",
				"arrivesAt": "20:27",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14984",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:44",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "20:45",
				"arrivesAt": "20:50",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "20:51",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "20:58",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "21:05",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "21:17",
				"arrivesAt": "21:22",
				"waitsAtSource": 420,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "21:28",
				"arrivesAt": "21:32",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "21:33",
				"arrivesAt": "21:39",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "21:40",
				"arrivesAt": "21:43",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "21:44",
				"arrivesAt": "21:48",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "21:49",
				"arrivesAt": "21:53",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "21:54",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "22:00",
				"arrivesAt": "22:05",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14368",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:19",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "20:20",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "20:30",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "20:54",
				"arrivesAt": "21:05",
				"waitsAtSource": 1020,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "21:06",
				"arrivesAt": "21:10",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "21:11",
				"arrivesAt": "21:15",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "21:16",
				"arrivesAt": "21:20",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "21:21",
				"arrivesAt": "21:28",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "21:29",
				"arrivesAt": "21:34",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "21:35",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "21:39",
				"arrivesAt": "21:49",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "21:52",
				"arrivesAt": "21:59",
				"waitsAtSource": 180,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14366",
		"segments": [
			{
				"from": "Vălcani hcv.",
				"to": "Dudeştii Vechi  h",
				"leavesAt": "16:50",
				"arrivesAt": "16:59",
				"waitsAtSource": 0,
				"distance": 7000
			},
			{
				"from": "Dudeştii Vechi  h",
				"to": "Sânnicolau Mare",
				"leavesAt": "17:00",
				"arrivesAt": "17:18",
				"waitsAtSource": 60,
				"distance": 14000
			},
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:37",
				"waitsAtSource": 540,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "17:38",
				"arrivesAt": "17:46",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "17:47",
				"arrivesAt": "17:54",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "18:07",
				"arrivesAt": "18:17",
				"waitsAtSource": 780,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "18:18",
				"arrivesAt": "18:22",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "18:23",
				"arrivesAt": "18:26",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "18:27",
				"arrivesAt": "18:31",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "18:32",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "18:40",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "18:46",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "18:50",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "19:03",
				"arrivesAt": "19:10",
				"waitsAtSource": 180,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14674",
		"segments": [
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "19:25",
				"arrivesAt": "19:32",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "19:36",
				"arrivesAt": "19:38",
				"waitsAtSource": 240,
				"distance": 1400
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "19:39",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:51",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Ampoiţa h.",
				"leavesAt": "19:52",
				"arrivesAt": "19:56",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ampoiţa h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:01",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "20:02",
				"arrivesAt": "20:08",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:13",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Prisaca h.",
				"leavesAt": "20:14",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Prisaca h.",
				"to": "Feneş h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:26",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Feneş h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "20:27",
				"arrivesAt": "20:32",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Zlatna h.",
				"leavesAt": "20:35",
				"arrivesAt": "20:41",
				"waitsAtSource": 180,
				"distance": 4000
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna hcv.",
				"leavesAt": "20:42",
				"arrivesAt": "20:48",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14380",
		"segments": [
			{
				"from": "Cenad h.",
				"to": "Sânnicolau Nord h.",
				"leavesAt": "06:51",
				"arrivesAt": "07:14",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Sânnicolau Nord h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "07:15",
				"arrivesAt": "07:28",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Sânnicolau Mare",
				"to": "Tomnaticu h.",
				"leavesAt": "07:29",
				"arrivesAt": "07:39",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Tomnaticu h.",
				"to": "Lovrin",
				"leavesAt": "07:40",
				"arrivesAt": "07:50",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "08:08",
				"arrivesAt": "08:15",
				"waitsAtSource": 1080,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Şandra h.",
				"leavesAt": "08:16",
				"arrivesAt": "08:30",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şandra h.",
				"to": "Biled",
				"leavesAt": "08:31",
				"arrivesAt": "08:42",
				"waitsAtSource": 30,
				"distance": 5900
			},
			{
				"from": "Biled",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "08:54",
				"arrivesAt": "09:14",
				"waitsAtSource": 720,
				"distance": 10500
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "09:15",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "09:28",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "09:38",
				"arrivesAt": "09:39",
				"waitsAtSource": 180,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "09:40",
				"arrivesAt": "09:42",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "09:43",
				"arrivesAt": "09:50",
				"waitsAtSource": 30,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14429",
		"segments": [
			{
				"from": "Ineu",
				"to": "Teuz h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:13",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Teuz h.",
				"to": "Cermei hcv",
				"leavesAt": "18:14",
				"arrivesAt": "18:20",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14732",
		"segments": [
			{
				"from": "Breţcu Hm.",
				"to": "Lemnia h.",
				"leavesAt": "05:35",
				"arrivesAt": "05:41",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Lemnia h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "05:42",
				"arrivesAt": "05:47",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Bălani h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:53",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bălani h.",
				"to": "Poieniţa h.",
				"leavesAt": "05:54",
				"arrivesAt": "05:59",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Poieniţa h.",
				"to": "Sânzieni h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:04",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Sânzieni h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "06:05",
				"arrivesAt": "06:17",
				"waitsAtSource": 30,
				"distance": 7000
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Cătălina h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 120,
				"distance": 4400
			},
			{
				"from": "Cătălina h.",
				"to": "Imeci Hm.",
				"leavesAt": "06:25",
				"arrivesAt": "06:27",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Imeci Hm.",
				"to": "Zăbala h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:35",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Zăbala h.",
				"to": "Covasna Hm.",
				"leavesAt": "06:36",
				"arrivesAt": "06:41",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Covasna Hm.",
				"to": "Brateş h.",
				"leavesAt": "06:42",
				"arrivesAt": "06:50",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Brateş h.",
				"to": "Ţufalău h.",
				"leavesAt": "06:51",
				"arrivesAt": "06:55",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Ţufalău h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "06:56",
				"arrivesAt": "06:59",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Biţa h.",
				"leavesAt": "07:00",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Biţa h.",
				"to": "Moacşa hcv",
				"leavesAt": "07:06",
				"arrivesAt": "07:10",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Moacşa hcv",
				"to": "Angheluş h.",
				"leavesAt": "07:11",
				"arrivesAt": "07:17",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Angheluş h.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "07:18",
				"arrivesAt": "07:27",
				"waitsAtSource": 60,
				"distance": 6500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14827",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "20:13",
				"arrivesAt": "20:26",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "20:27",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "20:38",
				"arrivesAt": "20:44",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "20:45",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "20:52",
				"arrivesAt": "21:04",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "21:06",
				"arrivesAt": "21:12",
				"waitsAtSource": 120,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "21:13",
				"arrivesAt": "21:18",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "21:19",
				"arrivesAt": "21:24",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "21:25",
				"arrivesAt": "21:29",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "21:30",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "21:36",
				"arrivesAt": "21:42",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "21:43",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "21:52",
				"arrivesAt": "21:57",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "21:58",
				"arrivesAt": "22:06",
				"waitsAtSource": 60,
				"distance": 9400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18251",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "08:35",
				"arrivesAt": "08:38",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărata h.",
				"leavesAt": "08:39",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel",
				"leavesAt": "08:47",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel",
				"to": "Arcalia hc.",
				"leavesAt": "08:58",
				"arrivesAt": "09:03",
				"waitsAtSource": 360,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "09:04",
				"arrivesAt": "09:07",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Chintelnic h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:12",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Chintelnic h.",
				"to": "Chiraleş h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 2276
			},
			{
				"from": "Chiraleş h.",
				"to": "Ţigău h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ţigău h.",
				"to": "Lechinţa",
				"leavesAt": "09:24",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lechinţa",
				"to": "Vermeş h.",
				"leavesAt": "12:01",
				"arrivesAt": "12:04",
				"waitsAtSource": 9000,
				"distance": 2200
			},
			{
				"from": "Vermeş h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "12:05",
				"arrivesAt": "12:14",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Brăteni h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Brăteni h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:29",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:36",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14387",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "07:53",
				"arrivesAt": "08:00",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "08:04",
				"arrivesAt": "08:06",
				"waitsAtSource": 30,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "08:07",
				"arrivesAt": "08:14",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "08:15",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Biled",
				"leavesAt": "08:27",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Biled",
				"to": "Şandra h.",
				"leavesAt": "08:48",
				"arrivesAt": "08:59",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Şandra h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "09:00",
				"arrivesAt": "09:15",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "09:16",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lovrin",
				"to": "Tomnaticu h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 7700
			},
			{
				"from": "Tomnaticu h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "09:36",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 8200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14319",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "14:15",
				"arrivesAt": "14:24",
				"waitsAtSource": 0,
				"distance": 6900
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "14:25",
				"arrivesAt": "14:31",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Hodoni h.",
				"leavesAt": "14:32",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Hodoni h.",
				"to": "Chinezu h.",
				"leavesAt": "14:43",
				"arrivesAt": "14:49",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Chinezu h.",
				"to": "Bărăteaz h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Bărăteaz h.",
				"to": "Gelu hc.",
				"leavesAt": "14:56",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Gelu hc.",
				"to": "Variaş hc.",
				"leavesAt": "15:02",
				"arrivesAt": "15:08",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Variaş hc.",
				"to": "Periam",
				"leavesAt": "15:09",
				"arrivesAt": "15:18",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Periam",
				"to": "Pesac h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:38",
				"waitsAtSource": 540,
				"distance": 6700
			},
			{
				"from": "Pesac h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:47",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "15:48",
				"arrivesAt": "15:56",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14031",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "08:50",
				"arrivesAt": "09:05",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "09:06",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "09:11",
				"arrivesAt": "09:19",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "09:20",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "09:26",
				"arrivesAt": "09:31",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "09:32",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Vest",
				"leavesAt": "09:42",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "10:10",
				"arrivesAt": "10:17",
				"waitsAtSource": 1080,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "10:18",
				"arrivesAt": "10:27",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "10:28",
				"arrivesAt": "10:40",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "10:41",
				"arrivesAt": "10:46",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:50",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "10:51",
				"arrivesAt": "10:54",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "10:55",
				"arrivesAt": "10:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Valea Largă Hm.",
				"leavesAt": "11:00",
				"arrivesAt": "11:09",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "11:10",
				"arrivesAt": "11:14",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "11:15",
				"arrivesAt": "11:18",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "11:19",
				"arrivesAt": "11:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "11:25",
				"arrivesAt": "11:29",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "11:30",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "11:36",
				"arrivesAt": "11:47",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Dârste",
				"leavesAt": "11:48",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 20100
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "12:17",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14715",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "20:22",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "20:31",
				"arrivesAt": "20:34",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "20:35",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:42",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "20:43",
				"arrivesAt": "20:48",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "20:49",
				"arrivesAt": "20:52",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "20:53",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14363",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "14:18",
				"arrivesAt": "14:27",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Zădăreni Hm.",
				"leavesAt": "14:28",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:42",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Felnac hc.",
				"leavesAt": "14:43",
				"arrivesAt": "14:49",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Felnac hc.",
				"to": "Sânpetru German h.",
				"leavesAt": "14:50",
				"arrivesAt": "14:57",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sânpetru German h.",
				"to": "Munor h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Munor h.",
				"to": "Secusigiu h",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Secusigiu h",
				"to": "Aranca h.",
				"leavesAt": "15:07",
				"arrivesAt": "15:10",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Aranca h.",
				"to": "Periam",
				"leavesAt": "15:11",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 11100
			},
			{
				"from": "Periam",
				"to": "Sânpetru h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Sânpetru h.",
				"to": "Saravale h.",
				"leavesAt": "15:31",
				"arrivesAt": "15:39",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Saravale h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "15:40",
				"arrivesAt": "15:51",
				"waitsAtSource": 30,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14316",
		"segments": [
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "04:52",
				"arrivesAt": "05:00",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:09",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "05:10",
				"arrivesAt": "05:22",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "05:23",
				"arrivesAt": "05:34",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "05:35",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "05:43",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:54",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "05:55",
				"arrivesAt": "06:02",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "06:03",
				"arrivesAt": "06:14",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:26",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "06:27",
				"arrivesAt": "06:30",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "06:31",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14603",
		"segments": [
			{
				"from": "Blaj",
				"to": "Sâncel h.",
				"leavesAt": "06:12",
				"arrivesAt": "06:18",
				"waitsAtSource": 0,
				"distance": 4246
			},
			{
				"from": "Sâncel h.",
				"to": "Pănade h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:22",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Pănade h.",
				"to": "Şona h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:28",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Şona h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "06:29",
				"arrivesAt": "06:34",
				"waitsAtSource": 30,
				"distance": 3100
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Bălcaci h.",
				"leavesAt": "06:35",
				"arrivesAt": "06:38",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bălcaci h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "06:39",
				"arrivesAt": "06:43",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:54",
				"waitsAtSource": 420,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "06:59",
				"arrivesAt": "07:05",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:09",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Adămuş h.",
				"leavesAt": "07:10",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Adămuş h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "07:14",
				"arrivesAt": "07:18",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "07:19",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Târnaveni",
				"to": "Şeuca h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:32",
				"waitsAtSource": 180,
				"distance": 2600
			},
			{
				"from": "Şeuca h.",
				"to": "Găneşti h.",
				"leavesAt": "07:33",
				"arrivesAt": "07:38",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Găneşti h.",
				"to": "Deaj h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:43",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Deaj h.",
				"to": "Mica h.",
				"leavesAt": "07:44",
				"arrivesAt": "07:49",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Mica h.",
				"to": "Bernadea h.",
				"leavesAt": "07:50",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 2100
			},
			{
				"from": "Bernadea h.",
				"to": "Bahnea h.",
				"leavesAt": "07:55",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bahnea h.",
				"to": "Laslău h.",
				"leavesAt": "08:02",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Laslău h.",
				"to": "Şoimuş h.",
				"leavesAt": "08:10",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Şoimuş h.",
				"to": "Coroiu h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Coroiu h.",
				"to": "Bălăuşeri hcv.",
				"leavesAt": "08:22",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bălăuşeri hcv.",
				"to": "Fântânele h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:46",
				"waitsAtSource": 240,
				"distance": 4900
			},
			{
				"from": "Fântânele h.",
				"to": "Sângeorgiu de Pădure h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:54",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sângeorgiu de Pădure h.",
				"to": "Cioc h.",
				"leavesAt": "08:55",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 6600
			},
			{
				"from": "Cioc h.",
				"to": "Ghindari h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:06",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Ghindari h.",
				"to": "Chibed h.",
				"leavesAt": "09:07",
				"arrivesAt": "09:12",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Chibed h.",
				"to": "Sărăţeni h.",
				"leavesAt": "09:13",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sărăţeni h.",
				"to": "Sovata  hcv.",
				"leavesAt": "09:19",
				"arrivesAt": "09:26",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sovata  hcv.",
				"to": "Praid",
				"leavesAt": "09:27",
				"arrivesAt": "09:47",
				"waitsAtSource": 60,
				"distance": 6900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18234",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Tomnaticu h.",
				"leavesAt": "12:36",
				"arrivesAt": "12:46",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Tomnaticu h.",
				"to": "Lovrin",
				"leavesAt": "12:47",
				"arrivesAt": "12:58",
				"waitsAtSource": 30,
				"distance": 7700
			},
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "12:59",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Şandra h.",
				"leavesAt": "13:07",
				"arrivesAt": "13:22",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Şandra h.",
				"to": "Biled",
				"leavesAt": "13:23",
				"arrivesAt": "13:35",
				"waitsAtSource": 60,
				"distance": 5900
			},
			{
				"from": "Biled",
				"to": "Pescăreţu Mic hc.",
				"leavesAt": "13:36",
				"arrivesAt": "13:56",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Pescăreţu Mic hc.",
				"to": "Dudeştii Noi Hm.",
				"leavesAt": "13:57",
				"arrivesAt": "14:08",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dudeştii Noi Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "14:09",
				"arrivesAt": "14:16",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h",
				"leavesAt": "14:21",
				"arrivesAt": "14:22",
				"waitsAtSource": 300,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h",
				"to": "Timişoara Nord",
				"leavesAt": "14:23",
				"arrivesAt": "14:30",
				"waitsAtSource": 30,
				"distance": 5900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14819",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "11:55",
				"arrivesAt": "12:08",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "12:09",
				"arrivesAt": "12:19",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "12:20",
				"arrivesAt": "12:26",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "12:27",
				"arrivesAt": "12:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "12:34",
				"arrivesAt": "12:46",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "12:48",
				"arrivesAt": "12:54",
				"waitsAtSource": 120,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "12:55",
				"arrivesAt": "13:00",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "13:01",
				"arrivesAt": "13:06",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "13:07",
				"arrivesAt": "13:11",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "13:12",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "13:18",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "13:25",
				"arrivesAt": "13:33",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "13:34",
				"arrivesAt": "13:39",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "13:40",
				"arrivesAt": "13:48",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Truşeşti",
				"to": "Buhăceni h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:10",
				"waitsAtSource": 960,
				"distance": 4700
			},
			{
				"from": "Buhăceni h.",
				"to": "Dângeni",
				"leavesAt": "14:11",
				"arrivesAt": "14:18",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dângeni",
				"to": "Dângeni Nord h.",
				"leavesAt": "14:19",
				"arrivesAt": "14:24",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Ungureni Hm.",
				"leavesAt": "14:25",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Ungureni Hm.",
				"to": "Mândreşti h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:38",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mândreşti h.",
				"to": "Vorniceni h.",
				"leavesAt": "14:39",
				"arrivesAt": "14:46",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Vorniceni h.",
				"to": "Mateieni h.",
				"leavesAt": "14:47",
				"arrivesAt": "14:50",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Mateieni h.",
				"to": "Corlăteni h",
				"leavesAt": "14:51",
				"arrivesAt": "14:55",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Corlăteni h",
				"to": "Carasa h.",
				"leavesAt": "14:56",
				"arrivesAt": "14:58",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Carasa h.",
				"to": "Broscăuţi h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:05",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Broscăuţi h.",
				"to": "Dorohoi",
				"leavesAt": "15:06",
				"arrivesAt": "15:16",
				"waitsAtSource": 30,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14037",
		"segments": [
			{
				"from": "Bucureşti Nord",
				"to": "Buftea",
				"leavesAt": "20:45",
				"arrivesAt": "20:58",
				"waitsAtSource": 0,
				"distance": 16900
			},
			{
				"from": "Buftea",
				"to": "Dârza h.",
				"leavesAt": "20:59",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Dârza h.",
				"to": "Periş",
				"leavesAt": "21:03",
				"arrivesAt": "21:11",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Periş",
				"to": "Scroviştea h.",
				"leavesAt": "21:17",
				"arrivesAt": "21:22",
				"waitsAtSource": 360,
				"distance": 5200
			},
			{
				"from": "Scroviştea h.",
				"to": "Crivina",
				"leavesAt": "21:23",
				"arrivesAt": "21:27",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Crivina",
				"to": "Brazi",
				"leavesAt": "21:28",
				"arrivesAt": "21:37",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Brazi",
				"to": "Ploieşti Vest",
				"leavesAt": "21:38",
				"arrivesAt": "21:47",
				"waitsAtSource": 60,
				"distance": 7500
			},
			{
				"from": "Ploieşti Vest",
				"to": "Buda",
				"leavesAt": "22:00",
				"arrivesAt": "22:06",
				"waitsAtSource": 780,
				"distance": 6900
			},
			{
				"from": "Buda",
				"to": "Floreşti Prahova",
				"leavesAt": "22:07",
				"arrivesAt": "22:16",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Floreşti Prahova",
				"to": "Câmpina",
				"leavesAt": "22:17",
				"arrivesAt": "22:29",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Câmpina",
				"to": "Breaza hc.",
				"leavesAt": "22:30",
				"arrivesAt": "22:35",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Breaza hc.",
				"to": "Nistoreşti h.",
				"leavesAt": "22:36",
				"arrivesAt": "22:39",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza Nord h.",
				"leavesAt": "22:40",
				"arrivesAt": "22:43",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Breaza Nord h.",
				"to": "Comarnic",
				"leavesAt": "22:44",
				"arrivesAt": "22:48",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Comarnic",
				"to": "Valea Largă Hm.",
				"leavesAt": "22:49",
				"arrivesAt": "22:58",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Sinaia Sud h.",
				"leavesAt": "22:59",
				"arrivesAt": "23:03",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Sinaia",
				"leavesAt": "23:04",
				"arrivesAt": "23:07",
				"waitsAtSource": 30,
				"distance": 1600
			},
			{
				"from": "Sinaia",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "23:08",
				"arrivesAt": "23:12",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Buşteni",
				"leavesAt": "23:13",
				"arrivesAt": "23:17",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Buşteni",
				"to": "Azuga",
				"leavesAt": "23:18",
				"arrivesAt": "23:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Azuga",
				"to": "Predeal",
				"leavesAt": "23:24",
				"arrivesAt": "23:34",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Predeal",
				"to": "Dârste",
				"leavesAt": "23:36",
				"arrivesAt": "00:04",
				"waitsAtSource": 120,
				"distance": 20100
			},
			{
				"from": "Dârste",
				"to": "Braşov",
				"leavesAt": "00:05",
				"arrivesAt": "00:14",
				"waitsAtSource": 60,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14733",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "13:47",
				"arrivesAt": "13:50",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "13:51",
				"arrivesAt": "13:56",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Ilieni h.",
				"leavesAt": "13:57",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ilieni h.",
				"to": "Prejmer Hm.",
				"leavesAt": "14:03",
				"arrivesAt": "14:05",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Prejmer Hm.",
				"to": "Chichiş h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:10",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Chichiş h.",
				"to": "Ozun Hm.",
				"leavesAt": "14:11",
				"arrivesAt": "14:15",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Ozun Hm.",
				"to": "Sfântu Gheorghe",
				"leavesAt": "14:16",
				"arrivesAt": "14:22",
				"waitsAtSource": 60,
				"distance": 7600
			},
			{
				"from": "Sfântu Gheorghe",
				"to": "Angheluş h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:38",
				"waitsAtSource": 420,
				"distance": 6500
			},
			{
				"from": "Angheluş h.",
				"to": "Moacşa hcv",
				"leavesAt": "14:39",
				"arrivesAt": "14:45",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Moacşa hcv",
				"to": "Biţa h.",
				"leavesAt": "14:46",
				"arrivesAt": "14:51",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Biţa h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Ţufalău h.",
				"leavesAt": "14:58",
				"arrivesAt": "15:01",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Ţufalău h.",
				"to": "Brateş h.",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 3020
			},
			{
				"from": "Brateş h.",
				"to": "Covasna Hm.",
				"leavesAt": "15:07",
				"arrivesAt": "15:15",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Covasna Hm.",
				"to": "Zăbala h.",
				"leavesAt": "15:16",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Zăbala h.",
				"to": "Imeci Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:29",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Imeci Hm.",
				"to": "Cătălina h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:32",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cătălina h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "15:33",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Sânzieni h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:52",
				"waitsAtSource": 120,
				"distance": 7000
			},
			{
				"from": "Sânzieni h.",
				"to": "Poieniţa h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:57",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Poieniţa h.",
				"to": "Bălani h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:03",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bălani h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "16:04",
				"arrivesAt": "16:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Lemnia h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lemnia h.",
				"to": "Breţcu Hm.",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14814",
		"segments": [
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "05:10",
				"arrivesAt": "05:19",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "05:20",
				"arrivesAt": "05:26",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "05:27",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "05:36",
				"arrivesAt": "05:42",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "05:43",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "05:49",
				"arrivesAt": "05:54",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "05:55",
				"arrivesAt": "06:00",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "06:01",
				"arrivesAt": "06:06",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "06:07",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "06:15",
				"arrivesAt": "06:26",
				"waitsAtSource": 120,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "06:27",
				"arrivesAt": "06:33",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "06:34",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "06:43",
				"arrivesAt": "06:53",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "06:54",
				"arrivesAt": "07:10",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14514",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "19:55",
				"arrivesAt": "19:58",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "19:59",
				"arrivesAt": "20:08",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "20:09",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "20:16",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "20:24",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "20:29",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "20:35",
				"arrivesAt": "20:45",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "20:46",
				"arrivesAt": "20:49",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "20:50",
				"arrivesAt": "20:56",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "20:57",
				"arrivesAt": "21:05",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Gătaia",
				"to": "Birda hcv.",
				"leavesAt": "21:17",
				"arrivesAt": "21:27",
				"waitsAtSource": 720,
				"distance": 8700
			},
			{
				"from": "Birda hcv.",
				"to": "Voiteni",
				"leavesAt": "21:28",
				"arrivesAt": "21:37",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "21:40",
				"arrivesAt": "21:50",
				"waitsAtSource": 180,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "21:51",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "21:56",
				"arrivesAt": "22:02",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "22:03",
				"arrivesAt": "22:08",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "22:09",
				"arrivesAt": "22:12",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "22:13",
				"arrivesAt": "22:23",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14064",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Sânandrei Hm.",
				"leavesAt": "06:40",
				"arrivesAt": "06:54",
				"waitsAtSource": 0,
				"distance": 13300
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Orţişoara",
				"leavesAt": "06:59",
				"arrivesAt": "07:13",
				"waitsAtSource": 300,
				"distance": 13100
			},
			{
				"from": "Orţişoara",
				"to": "Valea Viilor Hm.",
				"leavesAt": "07:23",
				"arrivesAt": "07:43",
				"waitsAtSource": 600,
				"distance": 19100
			},
			{
				"from": "Valea Viilor Hm.",
				"to": "Aradu Nou",
				"leavesAt": "07:49",
				"arrivesAt": "07:54",
				"waitsAtSource": 360,
				"distance": 5500
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "08:00",
				"arrivesAt": "08:07",
				"waitsAtSource": 360,
				"distance": 6200
			},
			{
				"from": "Arad",
				"to": "Radna",
				"leavesAt": "08:30",
				"arrivesAt": "09:04",
				"waitsAtSource": 1380,
				"distance": 34500
			},
			{
				"from": "Radna",
				"to": "Săvârşin",
				"leavesAt": "09:06",
				"arrivesAt": "09:48",
				"waitsAtSource": 120,
				"distance": 49700
			},
			{
				"from": "Săvârşin",
				"to": "Ilia",
				"leavesAt": "09:50",
				"arrivesAt": "10:28",
				"waitsAtSource": 120,
				"distance": 40400
			},
			{
				"from": "Ilia",
				"to": "Deva",
				"leavesAt": "10:30",
				"arrivesAt": "11:01",
				"waitsAtSource": 120,
				"distance": 23600
			},
			{
				"from": "Deva",
				"to": "Simeria",
				"leavesAt": "11:03",
				"arrivesAt": "11:16",
				"waitsAtSource": 120,
				"distance": 9200
			},
			{
				"from": "Simeria",
				"to": "Orăştie",
				"leavesAt": "11:24",
				"arrivesAt": "11:45",
				"waitsAtSource": 480,
				"distance": 16500
			},
			{
				"from": "Orăştie",
				"to": "Şibot",
				"leavesAt": "11:46",
				"arrivesAt": "12:01",
				"waitsAtSource": 60,
				"distance": 12300
			},
			{
				"from": "Şibot",
				"to": "Vinţu de Jos",
				"leavesAt": "12:02",
				"arrivesAt": "12:23",
				"waitsAtSource": 60,
				"distance": 15000
			},
			{
				"from": "Vinţu de Jos",
				"to": "Alba Iulia",
				"leavesAt": "12:24",
				"arrivesAt": "12:37",
				"waitsAtSource": 60,
				"distance": 9800
			},
			{
				"from": "Alba Iulia",
				"to": "Coşlariu",
				"leavesAt": "12:44",
				"arrivesAt": "13:05",
				"waitsAtSource": 420,
				"distance": 15600
			},
			{
				"from": "Coşlariu",
				"to": "Coşlariu Gr. P. Mureş",
				"leavesAt": "13:26",
				"arrivesAt": "13:32",
				"waitsAtSource": 1260,
				"distance": 1500
			},
			{
				"from": "Coşlariu Gr. P. Mureş",
				"to": "Blaj",
				"leavesAt": "13:44",
				"arrivesAt": "14:10",
				"waitsAtSource": 720,
				"distance": 17900
			},
			{
				"from": "Blaj",
				"to": "Copşa Mică",
				"leavesAt": "14:22",
				"arrivesAt": "14:58",
				"waitsAtSource": 720,
				"distance": 30000
			},
			{
				"from": "Copşa Mică",
				"to": "Mediaş",
				"leavesAt": "14:59",
				"arrivesAt": "15:12",
				"waitsAtSource": 60,
				"distance": 10400
			},
			{
				"from": "Mediaş",
				"to": "Dumbrăveni",
				"leavesAt": "15:13",
				"arrivesAt": "15:35",
				"waitsAtSource": 60,
				"distance": 18000
			},
			{
				"from": "Dumbrăveni",
				"to": "Sighişoara",
				"leavesAt": "15:40",
				"arrivesAt": "16:07",
				"waitsAtSource": 300,
				"distance": 20400
			},
			{
				"from": "Sighişoara",
				"to": "Rupea",
				"leavesAt": "16:11",
				"arrivesAt": "17:18",
				"waitsAtSource": 240,
				"distance": 53600
			},
			{
				"from": "Rupea",
				"to": "Augustin Hm.",
				"leavesAt": "17:20",
				"arrivesAt": "17:53",
				"waitsAtSource": 120,
				"distance": 24700
			},
			{
				"from": "Augustin Hm.",
				"to": "Braşov",
				"leavesAt": "17:54",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 49100
			}
		],
		"restrictions": [
			{
				"from": "20170101",
				"to": "20170101",
				"daysOfWeek": 320
			},
			{
				"from": "20170108",
				"to": "20170108",
				"daysOfWeek": 320
			},
			{
				"from": "20170115",
				"to": "20170115",
				"daysOfWeek": 320
			},
			{
				"from": "20170122",
				"to": "20170122",
				"daysOfWeek": 320
			},
			{
				"from": "20170129",
				"to": "20170129",
				"daysOfWeek": 320
			},
			{
				"from": "20170205",
				"to": "20170205",
				"daysOfWeek": 320
			},
			{
				"from": "20170212",
				"to": "20170212",
				"daysOfWeek": 320
			},
			{
				"from": "20170219",
				"to": "20170219",
				"daysOfWeek": 320
			},
			{
				"from": "20170226",
				"to": "20170226",
				"daysOfWeek": 320
			},
			{
				"from": "20170305",
				"to": "20170305",
				"daysOfWeek": 320
			},
			{
				"from": "20170312",
				"to": "20170312",
				"daysOfWeek": 320
			},
			{
				"from": "20170319",
				"to": "20170319",
				"daysOfWeek": 320
			},
			{
				"from": "20170326",
				"to": "20170326",
				"daysOfWeek": 320
			},
			{
				"from": "20170402",
				"to": "20170402",
				"daysOfWeek": 320
			},
			{
				"from": "20170409",
				"to": "20170409",
				"daysOfWeek": 320
			},
			{
				"from": "20170416",
				"to": "20170416",
				"daysOfWeek": 320
			},
			{
				"from": "20170423",
				"to": "20170423",
				"daysOfWeek": 320
			},
			{
				"from": "20170430",
				"to": "20170430",
				"daysOfWeek": 320
			},
			{
				"from": "20170507",
				"to": "20170507",
				"daysOfWeek": 320
			},
			{
				"from": "20170514",
				"to": "20170514",
				"daysOfWeek": 320
			},
			{
				"from": "20170521",
				"to": "20170521",
				"daysOfWeek": 320
			},
			{
				"from": "20170528",
				"to": "20170528",
				"daysOfWeek": 320
			},
			{
				"from": "20170604",
				"to": "20170604",
				"daysOfWeek": 320
			},
			{
				"from": "20170611",
				"to": "20170611",
				"daysOfWeek": 320
			},
			{
				"from": "20170618",
				"to": "20170618",
				"daysOfWeek": 320
			},
			{
				"from": "20170625",
				"to": "20170625",
				"daysOfWeek": 320
			},
			{
				"from": "20170702",
				"to": "20170702",
				"daysOfWeek": 320
			},
			{
				"from": "20170709",
				"to": "20170709",
				"daysOfWeek": 320
			},
			{
				"from": "20170716",
				"to": "20170716",
				"daysOfWeek": 320
			},
			{
				"from": "20170723",
				"to": "20170723",
				"daysOfWeek": 320
			},
			{
				"from": "20170730",
				"to": "20170730",
				"daysOfWeek": 320
			},
			{
				"from": "20170806",
				"to": "20170806",
				"daysOfWeek": 320
			},
			{
				"from": "20170813",
				"to": "20170813",
				"daysOfWeek": 320
			},
			{
				"from": "20170820",
				"to": "20170820",
				"daysOfWeek": 320
			},
			{
				"from": "20170827",
				"to": "20170827",
				"daysOfWeek": 320
			},
			{
				"from": "20170903",
				"to": "20170903",
				"daysOfWeek": 320
			},
			{
				"from": "20170910",
				"to": "20170910",
				"daysOfWeek": 320
			},
			{
				"from": "20170917",
				"to": "20170917",
				"daysOfWeek": 320
			},
			{
				"from": "20170924",
				"to": "20170924",
				"daysOfWeek": 320
			},
			{
				"from": "20171001",
				"to": "20171001",
				"daysOfWeek": 320
			},
			{
				"from": "20171008",
				"to": "20171008",
				"daysOfWeek": 320
			},
			{
				"from": "20171015",
				"to": "20171015",
				"daysOfWeek": 320
			},
			{
				"from": "20171022",
				"to": "20171022",
				"daysOfWeek": 320
			},
			{
				"from": "20171029",
				"to": "20171029",
				"daysOfWeek": 320
			},
			{
				"from": "20171105",
				"to": "20171105",
				"daysOfWeek": 320
			},
			{
				"from": "20171112",
				"to": "20171112",
				"daysOfWeek": 320
			},
			{
				"from": "20171119",
				"to": "20171119",
				"daysOfWeek": 320
			},
			{
				"from": "20171126",
				"to": "20171126",
				"daysOfWeek": 320
			},
			{
				"from": "20171203",
				"to": "20171203",
				"daysOfWeek": 320
			},
			{
				"from": "20161211",
				"to": "20161211",
				"daysOfWeek": 320
			},
			{
				"from": "20161218",
				"to": "20161218",
				"daysOfWeek": 320
			},
			{
				"from": "20161225",
				"to": "20161225",
				"daysOfWeek": 320
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14017",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:56",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărata h.",
				"leavesAt": "15:57",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel",
				"leavesAt": "16:06",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărăţel",
				"to": "Arcalia hc.",
				"leavesAt": "16:12",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:21",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Chintelnic h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Chintelnic h.",
				"to": "Chiraleş h.",
				"leavesAt": "16:27",
				"arrivesAt": "16:30",
				"waitsAtSource": 60,
				"distance": 2276
			},
			{
				"from": "Chiraleş h.",
				"to": "Ţigău h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ţigău h.",
				"to": "Lechinţa",
				"leavesAt": "16:37",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lechinţa",
				"to": "Vermeş h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Vermeş h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "16:51",
				"arrivesAt": "17:00",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Brăteni h.",
				"leavesAt": "17:01",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Brăteni h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "17:18",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "17:24",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Ţagu h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ţagu h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "17:41",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţăgşor h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ţăgşor h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "17:52",
				"arrivesAt": "17:56",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Sărmăşel hcv .",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "18:38",
				"arrivesAt": "18:42",
				"waitsAtSource": 2520,
				"distance": 2000
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmaşu h.",
				"leavesAt": "18:43",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Balda h.",
				"leavesAt": "18:49",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Balda h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "18:54",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "19:01",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "19:08",
				"arrivesAt": "19:13",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bota Sat h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "19:14",
				"arrivesAt": "19:19",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "19:20",
				"arrivesAt": "19:23",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Tăureni h.",
				"leavesAt": "19:24",
				"arrivesAt": "19:28",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Tăureni h.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "19:29",
				"arrivesAt": "19:37",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Luduş Sat hc.",
				"leavesAt": "19:38",
				"arrivesAt": "19:49",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Luduş",
				"leavesAt": "19:50",
				"arrivesAt": "19:54",
				"waitsAtSource": 60,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14812",
		"segments": [
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "03:18",
				"arrivesAt": "03:27",
				"waitsAtSource": 0,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "03:28",
				"arrivesAt": "03:34",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "03:35",
				"arrivesAt": "03:43",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "03:44",
				"arrivesAt": "03:50",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "03:51",
				"arrivesAt": "03:56",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "03:57",
				"arrivesAt": "04:02",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "04:03",
				"arrivesAt": "04:08",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "04:09",
				"arrivesAt": "04:14",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "04:15",
				"arrivesAt": "04:21",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "04:22",
				"arrivesAt": "04:33",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "04:34",
				"arrivesAt": "04:40",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "04:41",
				"arrivesAt": "04:49",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "04:50",
				"arrivesAt": "05:00",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "05:01",
				"arrivesAt": "05:17",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": []
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14314",
		"segments": [
			{
				"from": "Nerău hcv.",
				"to": "Teremia Banat hc.",
				"leavesAt": "04:12",
				"arrivesAt": "04:20",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Comloşu Mare h.",
				"leavesAt": "04:21",
				"arrivesAt": "04:30",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Gotlob h.",
				"leavesAt": "04:31",
				"arrivesAt": "04:38",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Gotlob h.",
				"to": "Lovrin",
				"leavesAt": "04:39",
				"arrivesAt": "04:46",
				"waitsAtSource": 30,
				"distance": 6400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14849",
		"segments": [
			{
				"from": "Roman",
				"to": "Sagna h.",
				"leavesAt": "16:41",
				"arrivesAt": "16:51",
				"waitsAtSource": 0,
				"distance": 8700
			},
			{
				"from": "Sagna h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "16:52",
				"arrivesAt": "17:02",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Stăniţa h.",
				"leavesAt": "17:03",
				"arrivesAt": "17:11",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stăniţa h.",
				"to": "Piscu Rusului h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:23",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Zece Prăjini h",
				"leavesAt": "17:24",
				"arrivesAt": "17:33",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zece Prăjini h",
				"to": "Dagâţa",
				"leavesAt": "17:34",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dagâţa",
				"to": "Băluşeşti h",
				"leavesAt": "17:42",
				"arrivesAt": "17:45",
				"waitsAtSource": 120,
				"distance": 3400
			},
			{
				"from": "Băluşeşti h",
				"to": "Suhuleţ h.",
				"leavesAt": "17:46",
				"arrivesAt": "17:50",
				"waitsAtSource": 30,
				"distance": 3000
			},
			{
				"from": "Suhuleţ h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "17:51",
				"arrivesAt": "17:57",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Dumeşti h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumeşti h.",
				"to": "Rafaila h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:13",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Rafaila h.",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "18:14",
				"arrivesAt": "18:21",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Buhăieşti",
				"leavesAt": "18:22",
				"arrivesAt": "18:38",
				"waitsAtSource": 60,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14299",
		"segments": [
			{
				"from": "Arad",
				"to": "Arad Vest",
				"leavesAt": "14:18",
				"arrivesAt": "14:27",
				"waitsAtSource": 0,
				"distance": 4800
			},
			{
				"from": "Arad Vest",
				"to": "Ferma Ciala h.",
				"leavesAt": "14:28",
				"arrivesAt": "14:33",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Sântoma h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:40",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Sântoma h.",
				"to": "Pecica",
				"leavesAt": "14:41",
				"arrivesAt": "14:53",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Pecica",
				"to": "Semlac h.",
				"leavesAt": "14:54",
				"arrivesAt": "15:17",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Semlac h.",
				"to": "Şeitin h.",
				"leavesAt": "15:18",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Şeitin h.",
				"to": "Nădlac",
				"leavesAt": "15:28",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 8100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14315",
		"segments": [
			{
				"from": "Lovrin",
				"to": "Gotlob h.",
				"leavesAt": "06:15",
				"arrivesAt": "06:22",
				"waitsAtSource": 0,
				"distance": 6400
			},
			{
				"from": "Gotlob h.",
				"to": "Comloşu Mare h.",
				"leavesAt": "06:23",
				"arrivesAt": "06:31",
				"waitsAtSource": 60,
				"distance": 7200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Teremia Banat hc.",
				"leavesAt": "06:32",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Nerău hcv.",
				"leavesAt": "06:43",
				"arrivesAt": "06:51",
				"waitsAtSource": 60,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14737",
		"segments": [
			{
				"from": "Sfântu Gheorghe",
				"to": "Angheluş h.",
				"leavesAt": "19:25",
				"arrivesAt": "19:34",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Angheluş h.",
				"to": "Moacşa hcv",
				"leavesAt": "19:35",
				"arrivesAt": "19:41",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Moacşa hcv",
				"to": "Biţa h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Biţa h.",
				"to": "Boroşneu Mare h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Boroşneu Mare h.",
				"to": "Ţufalău h.",
				"leavesAt": "19:54",
				"arrivesAt": "19:58",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Ţufalău h.",
				"to": "Brateş h.",
				"leavesAt": "19:59",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 3020
			},
			{
				"from": "Brateş h.",
				"to": "Covasna Hm.",
				"leavesAt": "20:05",
				"arrivesAt": "20:13",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Covasna Hm.",
				"to": "Zăbala h.",
				"leavesAt": "20:15",
				"arrivesAt": "20:21",
				"waitsAtSource": 120,
				"distance": 4200
			},
			{
				"from": "Zăbala h.",
				"to": "Imeci Hm.",
				"leavesAt": "20:22",
				"arrivesAt": "20:30",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Imeci Hm.",
				"to": "Cătălina h.",
				"leavesAt": "20:31",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Cătălina h.",
				"to": "Târgu Secuiesc",
				"leavesAt": "20:34",
				"arrivesAt": "20:39",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Târgu Secuiesc",
				"to": "Sânzieni h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:52",
				"waitsAtSource": 60,
				"distance": 7000
			},
			{
				"from": "Sânzieni h.",
				"to": "Poieniţa h.",
				"leavesAt": "20:53",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Poieniţa h.",
				"to": "Bălani h.",
				"leavesAt": "20:58",
				"arrivesAt": "21:03",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Bălani h.",
				"to": "Mereni Lutoasa h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:09",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Mereni Lutoasa h.",
				"to": "Lemnia h.",
				"leavesAt": "21:10",
				"arrivesAt": "21:15",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Lemnia h.",
				"to": "Breţcu Hm.",
				"leavesAt": "21:16",
				"arrivesAt": "21:23",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "IR",
		"operator": "RGT",
		"number": "14069",
		"segments": [
			{
				"from": "Ploieşti Vest",
				"to": "Ploieşti Sud",
				"leavesAt": "16:24",
				"arrivesAt": "16:29",
				"waitsAtSource": 0,
				"distance": 3000
			},
			{
				"from": "Ploieşti Sud",
				"to": "Mizil",
				"leavesAt": "16:30",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 33600
			},
			{
				"from": "Mizil",
				"to": "Buzău",
				"leavesAt": "17:05",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 35000
			},
			{
				"from": "Buzău",
				"to": "Râmnicu Sărat",
				"leavesAt": "17:43",
				"arrivesAt": "18:13",
				"waitsAtSource": 120,
				"distance": 33500
			},
			{
				"from": "Râmnicu Sărat",
				"to": "Focşani",
				"leavesAt": "18:14",
				"arrivesAt": "18:52",
				"waitsAtSource": 60,
				"distance": 37300
			},
			{
				"from": "Focşani",
				"to": "Mărăşeşti",
				"leavesAt": "18:54",
				"arrivesAt": "19:17",
				"waitsAtSource": 120,
				"distance": 19700
			},
			{
				"from": "Mărăşeşti",
				"to": "Tecuci Nord hc.(605)",
				"leavesAt": "19:22",
				"arrivesAt": "19:47",
				"waitsAtSource": 300,
				"distance": 17800
			},
			{
				"from": "Tecuci Nord hc.(605)",
				"to": "Bârlad",
				"leavesAt": "19:48",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 48600
			},
			{
				"from": "Bârlad",
				"to": "Crasna",
				"leavesAt": "20:39",
				"arrivesAt": "21:06",
				"waitsAtSource": 360,
				"distance": 36600
			},
			{
				"from": "Crasna",
				"to": "Vaslui",
				"leavesAt": "21:08",
				"arrivesAt": "21:22",
				"waitsAtSource": 120,
				"distance": 15500
			},
			{
				"from": "Vaslui",
				"to": "Buhăieşti",
				"leavesAt": "21:26",
				"arrivesAt": "21:45",
				"waitsAtSource": 240,
				"distance": 23500
			},
			{
				"from": "Buhăieşti",
				"to": "Bârnova Hm.",
				"leavesAt": "21:48",
				"arrivesAt": "22:12",
				"waitsAtSource": 180,
				"distance": 25700
			},
			{
				"from": "Bârnova Hm.",
				"to": "Nicolina",
				"leavesAt": "22:13",
				"arrivesAt": "22:28",
				"waitsAtSource": 60,
				"distance": 16300
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "22:29",
				"arrivesAt": "22:37",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14756",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "12:41",
				"arrivesAt": "12:51",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "12:52",
				"arrivesAt": "12:57",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "13:03",
				"arrivesAt": "13:08",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "13:09",
				"arrivesAt": "13:20",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "13:21",
				"arrivesAt": "13:26",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "13:27",
				"arrivesAt": "13:31",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14032",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "05:00",
				"arrivesAt": "05:07",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Predeal",
				"leavesAt": "05:08",
				"arrivesAt": "05:35",
				"waitsAtSource": 60,
				"distance": 20100
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "05:36",
				"arrivesAt": "05:43",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "05:44",
				"arrivesAt": "05:48",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "05:49",
				"arrivesAt": "05:52",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "05:53",
				"arrivesAt": "05:58",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "06:00",
				"arrivesAt": "06:02",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "06:03",
				"arrivesAt": "06:07",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "06:08",
				"arrivesAt": "06:16",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "06:17",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "06:21",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "06:25",
				"arrivesAt": "06:28",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "06:29",
				"arrivesAt": "06:37",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "06:38",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "06:50",
				"arrivesAt": "06:59",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "07:00",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "07:14",
				"arrivesAt": "07:21",
				"waitsAtSource": 360,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "07:22",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:36",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "07:37",
				"arrivesAt": "07:42",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "07:48",
				"arrivesAt": "07:56",
				"waitsAtSource": 360,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "07:57",
				"arrivesAt": "08:01",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "08:02",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14987",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "20:26",
				"arrivesAt": "20:31",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "20:32",
				"arrivesAt": "20:37",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "20:38",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "20:48",
				"arrivesAt": "20:51",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "20:52",
				"arrivesAt": "20:57",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "20:58",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "21:03",
				"arrivesAt": "21:07",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "21:08",
				"arrivesAt": "21:14",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "21:15",
				"arrivesAt": "21:19",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "21:20",
				"arrivesAt": "21:26",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "21:27",
				"arrivesAt": "21:33",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "21:34",
				"arrivesAt": "21:38",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "21:39",
				"arrivesAt": "21:44",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14823",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "16:49",
				"arrivesAt": "17:02",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "17:03",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "17:14",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "17:28",
				"arrivesAt": "17:40",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "17:48",
				"arrivesAt": "17:54",
				"waitsAtSource": 480,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "17:55",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "18:01",
				"arrivesAt": "18:06",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "18:07",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "18:12",
				"arrivesAt": "18:17",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:33",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "18:34",
				"arrivesAt": "18:39",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "18:40",
				"arrivesAt": "18:48",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Truşeşti",
				"to": "Buhăceni h.",
				"leavesAt": "18:53",
				"arrivesAt": "18:58",
				"waitsAtSource": 300,
				"distance": 4700
			},
			{
				"from": "Buhăceni h.",
				"to": "Dângeni",
				"leavesAt": "18:59",
				"arrivesAt": "19:06",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Dângeni",
				"to": "Dângeni Nord h.",
				"leavesAt": "19:07",
				"arrivesAt": "19:12",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Ungureni Hm.",
				"leavesAt": "19:13",
				"arrivesAt": "19:21",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Ungureni Hm.",
				"to": "Mândreşti h.",
				"leavesAt": "19:29",
				"arrivesAt": "19:34",
				"waitsAtSource": 480,
				"distance": 4600
			},
			{
				"from": "Mândreşti h.",
				"to": "Vorniceni h.",
				"leavesAt": "19:35",
				"arrivesAt": "19:42",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vorniceni h.",
				"to": "Mateieni h.",
				"leavesAt": "19:43",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Mateieni h.",
				"to": "Corlăteni h",
				"leavesAt": "19:48",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Corlăteni h",
				"to": "Carasa h.",
				"leavesAt": "19:53",
				"arrivesAt": "19:56",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Carasa h.",
				"to": "Broscăuţi h.",
				"leavesAt": "19:57",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Broscăuţi h.",
				"to": "Dorohoi",
				"leavesAt": "20:04",
				"arrivesAt": "20:14",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14979",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "14:00",
				"arrivesAt": "14:05",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "14:06",
				"arrivesAt": "14:11",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:14",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "14:15",
				"arrivesAt": "14:19",
				"waitsAtSource": 30,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "14:20",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:29",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "14:30",
				"arrivesAt": "14:34",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "14:35",
				"arrivesAt": "14:37",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "14:38",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "14:45",
				"arrivesAt": "14:48",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "14:49",
				"arrivesAt": "14:56",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:07",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "15:08",
				"arrivesAt": "15:13",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14510",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:37",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "16:38",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:54",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "16:55",
				"arrivesAt": "17:02",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "17:03",
				"arrivesAt": "17:07",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "17:08",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "17:14",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "17:25",
				"arrivesAt": "17:28",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "17:29",
				"arrivesAt": "17:35",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "17:36",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Gătaia",
				"to": "Birda hcv.",
				"leavesAt": "17:54",
				"arrivesAt": "18:04",
				"waitsAtSource": 600,
				"distance": 8700
			},
			{
				"from": "Birda hcv.",
				"to": "Voiteni",
				"leavesAt": "18:05",
				"arrivesAt": "18:14",
				"waitsAtSource": 30,
				"distance": 9500
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "18:17",
				"arrivesAt": "18:27",
				"waitsAtSource": 180,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "18:28",
				"arrivesAt": "18:32",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "18:33",
				"arrivesAt": "18:39",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "18:40",
				"arrivesAt": "18:45",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "18:46",
				"arrivesAt": "18:49",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "18:50",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14608",
		"segments": [
			{
				"from": "Bălăuşeri hcv.",
				"to": "Coroiu h.",
				"leavesAt": "13:35",
				"arrivesAt": "13:45",
				"waitsAtSource": 0,
				"distance": 6700
			},
			{
				"from": "Coroiu h.",
				"to": "Şoimuş h.",
				"leavesAt": "13:46",
				"arrivesAt": "13:49",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Şoimuş h.",
				"to": "Laslău h.",
				"leavesAt": "13:50",
				"arrivesAt": "13:57",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Laslău h.",
				"to": "Bahnea h.",
				"leavesAt": "13:58",
				"arrivesAt": "14:05",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bahnea h.",
				"to": "Bernadea h.",
				"leavesAt": "14:06",
				"arrivesAt": "14:12",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Bernadea h.",
				"to": "Mica h.",
				"leavesAt": "14:13",
				"arrivesAt": "14:17",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Mica h.",
				"to": "Deaj h.",
				"leavesAt": "14:18",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Deaj h.",
				"to": "Găneşti h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:28",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Găneşti h.",
				"to": "Şeuca h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:34",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Şeuca h.",
				"to": "Târnaveni",
				"leavesAt": "14:35",
				"arrivesAt": "14:40",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Târnaveni",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "15:37",
				"arrivesAt": "15:42",
				"waitsAtSource": 3420,
				"distance": 2400
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Adămuş h.",
				"leavesAt": "15:43",
				"arrivesAt": "15:46",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Adămuş h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Crăieşti h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:54",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Crăieşti h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "15:55",
				"arrivesAt": "16:01",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Feisa h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Feisa h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "16:06",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Bălcaci h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:14",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Bălcaci h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "16:15",
				"arrivesAt": "16:18",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Şona h.",
				"leavesAt": "16:19",
				"arrivesAt": "16:23",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Şona h.",
				"to": "Pănade h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:29",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pănade h.",
				"to": "Sâncel h.",
				"leavesAt": "16:30",
				"arrivesAt": "16:33",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Sâncel h.",
				"to": "Blaj",
				"leavesAt": "16:34",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 4246
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14982",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "18:50",
				"arrivesAt": "18:54",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "18:55",
				"arrivesAt": "19:00",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "19:01",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "19:08",
				"arrivesAt": "19:14",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "19:15",
				"arrivesAt": "19:20",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "19:21",
				"arrivesAt": "19:26",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "19:27",
				"arrivesAt": "19:31",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "19:32",
				"arrivesAt": "19:36",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "19:37",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "19:44",
				"arrivesAt": "19:47",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "19:48",
				"arrivesAt": "19:52",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "19:53",
				"arrivesAt": "19:57",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "19:58",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "20:04",
				"arrivesAt": "20:09",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14672",
		"segments": [
			{
				"from": "Alba Iulia",
				"to": "Bărăbanţ Hm.",
				"leavesAt": "15:42",
				"arrivesAt": "15:49",
				"waitsAtSource": 0,
				"distance": 4500
			},
			{
				"from": "Bărăbanţ Hm.",
				"to": "Antestaţie Bărăbanţ h.",
				"leavesAt": "15:50",
				"arrivesAt": "15:52",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Antestaţie Bărăbanţ h.",
				"to": "Bărăbanţ Nord h.",
				"leavesAt": "15:53",
				"arrivesAt": "15:57",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Bărăbanţ Nord h.",
				"to": "Şard Ighiu h.",
				"leavesAt": "15:58",
				"arrivesAt": "16:05",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Şard Ighiu h.",
				"to": "Ampoiţa h.",
				"leavesAt": "16:06",
				"arrivesAt": "16:10",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Ampoiţa h.",
				"to": "Tăutu Ampoiului h.",
				"leavesAt": "16:11",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Tăutu Ampoiului h.",
				"to": "Văleni Meteş h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:22",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Văleni Meteş h.",
				"to": "Poiana Ampoiului h.",
				"leavesAt": "16:23",
				"arrivesAt": "16:27",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Poiana Ampoiului h.",
				"to": "Prisaca h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:35",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Prisaca h.",
				"to": "Feneş h.",
				"leavesAt": "16:36",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Feneş h.",
				"to": "Zlatna Tehnică",
				"leavesAt": "16:41",
				"arrivesAt": "16:45",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Zlatna Tehnică",
				"to": "Zlatna h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:54",
				"waitsAtSource": 180,
				"distance": 4000
			},
			{
				"from": "Zlatna h.",
				"to": "Zlatna hcv.",
				"leavesAt": "16:55",
				"arrivesAt": "16:59",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14815",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "06:53",
				"arrivesAt": "07:06",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Movileni h",
				"leavesAt": "07:07",
				"arrivesAt": "07:17",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Movileni h",
				"to": "Potângeni hc.",
				"leavesAt": "07:18",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Potângeni hc.",
				"to": "Larga Jijia Hm.",
				"leavesAt": "07:25",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Vlădeni",
				"leavesAt": "07:32",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 10800
			},
			{
				"from": "Vlădeni",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "07:46",
				"arrivesAt": "07:52",
				"waitsAtSource": 120,
				"distance": 5600
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Şoldana hc.",
				"leavesAt": "07:53",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Şoldana hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "07:59",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "08:05",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Rediu hc.",
				"to": "Răuşeni hc.",
				"leavesAt": "08:10",
				"arrivesAt": "08:15",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Răuşeni hc.",
				"to": "Todireni Hm.",
				"leavesAt": "08:16",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Todireni Hm.",
				"to": "Jijia h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Jijia h.",
				"to": "Zlătunoaia h",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Zlătunoaia h",
				"to": "Truşeşti",
				"leavesAt": "08:38",
				"arrivesAt": "08:46",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Truşeşti",
				"to": "Buhăceni h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Buhăceni h.",
				"to": "Dângeni",
				"leavesAt": "08:54",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Dângeni",
				"to": "Dângeni Nord h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Ungureni Hm.",
				"leavesAt": "09:08",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Ungureni Hm.",
				"to": "Mândreşti h.",
				"leavesAt": "09:17",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Mândreşti h.",
				"to": "Vorniceni h.",
				"leavesAt": "09:23",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Vorniceni h.",
				"to": "Mateieni h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:35",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Mateieni h.",
				"to": "Corlăteni h",
				"leavesAt": "09:36",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Corlăteni h",
				"to": "Carasa h.",
				"leavesAt": "09:41",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Carasa h.",
				"to": "Broscăuţi h.",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Broscăuţi h.",
				"to": "Dorohoi",
				"leavesAt": "09:52",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 5800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14540",
		"segments": [
			{
				"from": "Cruceni hcv.",
				"to": "Rudna hc.",
				"leavesAt": "04:34",
				"arrivesAt": "04:52",
				"waitsAtSource": 0,
				"distance": 11000
			},
			{
				"from": "Rudna hc.",
				"to": "Giulvăz h",
				"leavesAt": "04:53",
				"arrivesAt": "05:00",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Giulvăz h",
				"to": "Cebza h.",
				"leavesAt": "05:01",
				"arrivesAt": "05:04",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Cebza h.",
				"to": "Peciu Nou h.",
				"leavesAt": "05:05",
				"arrivesAt": "05:13",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Peciu Nou h.",
				"to": "Parţa h.",
				"leavesAt": "05:14",
				"arrivesAt": "05:24",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Parţa h.",
				"to": "Sânmihai h.",
				"leavesAt": "05:25",
				"arrivesAt": "05:32",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sânmihai h.",
				"to": "Utvin h.",
				"leavesAt": "05:33",
				"arrivesAt": "05:37",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Utvin h.",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "05:38",
				"arrivesAt": "05:44",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "05:47",
				"arrivesAt": "05:58",
				"waitsAtSource": 180,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14546",
		"segments": [
			{
				"from": "Cruceni hcv.",
				"to": "Rudna hc.",
				"leavesAt": "17:55",
				"arrivesAt": "18:13",
				"waitsAtSource": 0,
				"distance": 11000
			},
			{
				"from": "Rudna hc.",
				"to": "Giulvăz h",
				"leavesAt": "18:14",
				"arrivesAt": "18:21",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Giulvăz h",
				"to": "Cebza h.",
				"leavesAt": "18:22",
				"arrivesAt": "18:25",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Cebza h.",
				"to": "Peciu Nou h.",
				"leavesAt": "18:26",
				"arrivesAt": "18:34",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Peciu Nou h.",
				"to": "Parţa h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:45",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Parţa h.",
				"to": "Sânmihai h.",
				"leavesAt": "18:46",
				"arrivesAt": "18:53",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Sânmihai h.",
				"to": "Utvin h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:57",
				"waitsAtSource": 30,
				"distance": 2400
			},
			{
				"from": "Utvin h.",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "18:58",
				"arrivesAt": "19:04",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Timişoara Nord",
				"leavesAt": "19:07",
				"arrivesAt": "19:18",
				"waitsAtSource": 180,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14705",
		"segments": [
			{
				"from": "Braşov",
				"to": "Bartolomeu",
				"leavesAt": "09:25",
				"arrivesAt": "09:31",
				"waitsAtSource": 0,
				"distance": 3100
			},
			{
				"from": "Bartolomeu",
				"to": "Lustic h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:40",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Lustic h.",
				"to": "Cristian Hm.",
				"leavesAt": "09:41",
				"arrivesAt": "09:44",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Cristian Hm.",
				"to": "Râşnov",
				"leavesAt": "09:45",
				"arrivesAt": "09:49",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Râşnov",
				"to": "Râşnov h.",
				"leavesAt": "09:50",
				"arrivesAt": "09:52",
				"waitsAtSource": 60,
				"distance": 1800
			},
			{
				"from": "Râşnov h.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "09:53",
				"arrivesAt": "09:58",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "09:59",
				"arrivesAt": "10:02",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Zărneşti",
				"leavesAt": "10:03",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 1800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14324",
		"segments": [
			{
				"from": "Lovrin",
				"to": "Satu Nou Hm.",
				"leavesAt": "17:19",
				"arrivesAt": "17:27",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Pesac h.",
				"leavesAt": "17:28",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pesac h.",
				"to": "Periam",
				"leavesAt": "17:37",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Periam",
				"to": "Variaş hc.",
				"leavesAt": "17:56",
				"arrivesAt": "18:05",
				"waitsAtSource": 360,
				"distance": 7600
			},
			{
				"from": "Variaş hc.",
				"to": "Gelu hc.",
				"leavesAt": "18:06",
				"arrivesAt": "18:13",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Gelu hc.",
				"to": "Bărăteaz h.",
				"leavesAt": "18:14",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Bărăteaz h.",
				"to": "Chinezu h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:24",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Chinezu h.",
				"to": "Hodoni h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:31",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Hodoni h.",
				"to": "Sânandrei Hm.",
				"leavesAt": "18:32",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "18:44",
				"arrivesAt": "18:50",
				"waitsAtSource": 180,
				"distance": 6400
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "18:51",
				"arrivesAt": "18:53",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "18:54",
				"arrivesAt": "18:57",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Timişoara Nord",
				"leavesAt": "18:58",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 4400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14754",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "08:56",
				"arrivesAt": "09:07",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:14",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "09:15",
				"arrivesAt": "09:20",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "09:21",
				"arrivesAt": "09:27",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "09:28",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "09:46",
				"arrivesAt": "09:53",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14976",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "11:50",
				"arrivesAt": "11:54",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "11:55",
				"arrivesAt": "12:00",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "12:01",
				"arrivesAt": "12:07",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "12:08",
				"arrivesAt": "12:14",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "12:15",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:27",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "12:28",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "12:42",
				"arrivesAt": "12:46",
				"waitsAtSource": 600,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "12:47",
				"arrivesAt": "12:53",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "12:54",
				"arrivesAt": "12:57",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "12:58",
				"arrivesAt": "13:02",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "13:03",
				"arrivesAt": "13:06",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "13:07",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "13:13",
				"arrivesAt": "13:17",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18261",
		"segments": [
			{
				"from": "Braşov",
				"to": "Braşov Triaj",
				"leavesAt": "11:23",
				"arrivesAt": "11:27",
				"waitsAtSource": 0,
				"distance": 2200
			},
			{
				"from": "Braşov Triaj",
				"to": "Hărman",
				"leavesAt": "11:28",
				"arrivesAt": "11:35",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "11:36",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "11:54",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "12:00",
				"arrivesAt": "12:05",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "12:06",
				"arrivesAt": "12:18",
				"waitsAtSource": 30,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 256
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14807",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "16:35",
				"arrivesAt": "16:46",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "16:47",
				"arrivesAt": "16:55",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Erbiceni hc.",
				"leavesAt": "17:02",
				"arrivesAt": "17:11",
				"waitsAtSource": 420,
				"distance": 6000
			},
			{
				"from": "Erbiceni hc.",
				"to": "Spinoasa h.",
				"leavesAt": "17:12",
				"arrivesAt": "17:20",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Spinoasa h.",
				"to": "Belceşti Hm.",
				"leavesAt": "17:21",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Belceşti Hm.",
				"to": "Podu Ulmi h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Hodora h.",
				"leavesAt": "17:39",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Hodora h.",
				"to": "Cotnari hc.",
				"leavesAt": "17:45",
				"arrivesAt": "17:50",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Cotnari hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "17:51",
				"arrivesAt": "17:55",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Bădeni hc.",
				"leavesAt": "17:56",
				"arrivesAt": "18:00",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Bădeni hc.",
				"to": "Hârlău",
				"leavesAt": "18:01",
				"arrivesAt": "18:06",
				"waitsAtSource": 30,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14983",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "17:11",
				"arrivesAt": "17:16",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "17:17",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "17:23",
				"arrivesAt": "17:26",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "17:27",
				"arrivesAt": "17:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "17:33",
				"arrivesAt": "17:36",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "17:37",
				"arrivesAt": "17:42",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "17:43",
				"arrivesAt": "17:48",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "17:54",
				"arrivesAt": "17:57",
				"waitsAtSource": 360,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "17:58",
				"arrivesAt": "18:04",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "18:05",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "18:18",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "18:30",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14361",
		"segments": [
			{
				"from": "Arad",
				"to": "Aradu Nou",
				"leavesAt": "11:24",
				"arrivesAt": "11:31",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Aradu Nou",
				"to": "Zădăreni Hm.",
				"leavesAt": "11:32",
				"arrivesAt": "11:42",
				"waitsAtSource": 60,
				"distance": 9600
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "11:43",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Felnac hc.",
				"leavesAt": "11:48",
				"arrivesAt": "11:53",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Felnac hc.",
				"to": "Sânpetru German h.",
				"leavesAt": "11:54",
				"arrivesAt": "12:01",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Sânpetru German h.",
				"to": "Munor h.",
				"leavesAt": "12:02",
				"arrivesAt": "12:06",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Munor h.",
				"to": "Secusigiu h",
				"leavesAt": "12:07",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Secusigiu h",
				"to": "Aranca h.",
				"leavesAt": "12:12",
				"arrivesAt": "12:16",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Aranca h.",
				"to": "Periam",
				"leavesAt": "12:17",
				"arrivesAt": "12:28",
				"waitsAtSource": 60,
				"distance": 11100
			},
			{
				"from": "Periam",
				"to": "Sânpetru h.",
				"leavesAt": "12:44",
				"arrivesAt": "12:51",
				"waitsAtSource": 960,
				"distance": 4500
			},
			{
				"from": "Sânpetru h.",
				"to": "Saravale h.",
				"leavesAt": "12:52",
				"arrivesAt": "13:01",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Saravale h.",
				"to": "Sânnicolau Mare",
				"leavesAt": "13:02",
				"arrivesAt": "13:12",
				"waitsAtSource": 60,
				"distance": 7600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14847",
		"segments": [
			{
				"from": "Roman",
				"to": "Sagna h.",
				"leavesAt": "14:24",
				"arrivesAt": "14:33",
				"waitsAtSource": 0,
				"distance": 8700
			},
			{
				"from": "Sagna h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "14:34",
				"arrivesAt": "14:44",
				"waitsAtSource": 30,
				"distance": 8300
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Stăniţa h.",
				"leavesAt": "14:45",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Stăniţa h.",
				"to": "Piscu Rusului h.",
				"leavesAt": "14:53",
				"arrivesAt": "15:04",
				"waitsAtSource": 30,
				"distance": 5100
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Zece Prăjini h",
				"leavesAt": "15:05",
				"arrivesAt": "15:14",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Zece Prăjini h",
				"to": "Dagâţa",
				"leavesAt": "15:15",
				"arrivesAt": "15:21",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dagâţa",
				"to": "Băluşeşti h",
				"leavesAt": "15:29",
				"arrivesAt": "15:33",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Băluşeşti h",
				"to": "Suhuleţ h.",
				"leavesAt": "15:34",
				"arrivesAt": "15:38",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Suhuleţ h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "15:39",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Dumeşti h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumeşti h.",
				"to": "Rafaila h.",
				"leavesAt": "15:54",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Rafaila h.",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "16:02",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Buhăieşti",
				"leavesAt": "16:10",
				"arrivesAt": "16:26",
				"waitsAtSource": 60,
				"distance": 10700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14308",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:51",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "19:52",
				"arrivesAt": "20:01",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Pecica",
				"leavesAt": "20:02",
				"arrivesAt": "20:26",
				"waitsAtSource": 30,
				"distance": 17200
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "20:27",
				"arrivesAt": "20:39",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "20:40",
				"arrivesAt": "20:46",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "20:47",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "20:56",
				"arrivesAt": "21:05",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14704",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "08:39",
				"arrivesAt": "08:42",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "08:43",
				"arrivesAt": "08:45",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "08:46",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "08:52",
				"arrivesAt": "08:55",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "08:56",
				"arrivesAt": "09:00",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "09:01",
				"arrivesAt": "09:04",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "09:05",
				"arrivesAt": "09:12",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "09:13",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14702",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "06:59",
				"arrivesAt": "07:02",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "07:03",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:11",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "07:12",
				"arrivesAt": "07:15",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "07:16",
				"arrivesAt": "07:20",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "07:21",
				"arrivesAt": "07:24",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "07:25",
				"arrivesAt": "07:33",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "07:34",
				"arrivesAt": "07:40",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14543",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "07:27",
				"arrivesAt": "07:38",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Utvin h.",
				"leavesAt": "07:39",
				"arrivesAt": "07:45",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Utvin h.",
				"to": "Sânmihai h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sânmihai h.",
				"to": "Parţa h.",
				"leavesAt": "07:51",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Parţa h.",
				"to": "Peciu Nou h.",
				"leavesAt": "08:00",
				"arrivesAt": "08:11",
				"waitsAtSource": 60,
				"distance": 8000
			},
			{
				"from": "Peciu Nou h.",
				"to": "Cebza h.",
				"leavesAt": "08:12",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 5700
			},
			{
				"from": "Cebza h.",
				"to": "Giulvăz h",
				"leavesAt": "08:21",
				"arrivesAt": "08:24",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Giulvăz h",
				"to": "Rudna hc.",
				"leavesAt": "08:25",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Rudna hc.",
				"to": "Cruceni hcv.",
				"leavesAt": "08:33",
				"arrivesAt": "08:52",
				"waitsAtSource": 30,
				"distance": 11000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14613",
		"segments": [
			{
				"from": "Blaj",
				"to": "Sâncel h.",
				"leavesAt": "19:55",
				"arrivesAt": "20:00",
				"waitsAtSource": 0,
				"distance": 4246
			},
			{
				"from": "Sâncel h.",
				"to": "Pănade h.",
				"leavesAt": "20:01",
				"arrivesAt": "20:04",
				"waitsAtSource": 60,
				"distance": 1654
			},
			{
				"from": "Pănade h.",
				"to": "Şona h.",
				"leavesAt": "20:05",
				"arrivesAt": "20:10",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Şona h.",
				"to": "Sfântu Nicolae h.",
				"leavesAt": "20:11",
				"arrivesAt": "20:15",
				"waitsAtSource": 60,
				"distance": 3100
			},
			{
				"from": "Sfântu Nicolae h.",
				"to": "Bălcaci h.",
				"leavesAt": "20:16",
				"arrivesAt": "20:19",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bălcaci h.",
				"to": "Jidvei  hcv.",
				"leavesAt": "20:20",
				"arrivesAt": "20:24",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Jidvei  hcv.",
				"to": "Feisa h.",
				"leavesAt": "20:25",
				"arrivesAt": "20:29",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Feisa h.",
				"to": "Cetatea de Baltă h.",
				"leavesAt": "20:30",
				"arrivesAt": "20:33",
				"waitsAtSource": 60,
				"distance": 2540
			},
			{
				"from": "Cetatea de Baltă h.",
				"to": "Crăieşti h.",
				"leavesAt": "20:34",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 5160
			},
			{
				"from": "Crăieşti h.",
				"to": "Corneşti Târnava h.",
				"leavesAt": "20:42",
				"arrivesAt": "20:45",
				"waitsAtSource": 60,
				"distance": 1500
			},
			{
				"from": "Corneşti Târnava h.",
				"to": "Adămuş h.",
				"leavesAt": "20:46",
				"arrivesAt": "20:51",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Adămuş h.",
				"to": "Târnaveni Vest Hm.",
				"leavesAt": "20:52",
				"arrivesAt": "20:56",
				"waitsAtSource": 60,
				"distance": 2800
			},
			{
				"from": "Târnaveni Vest Hm.",
				"to": "Târnaveni",
				"leavesAt": "20:57",
				"arrivesAt": "21:02",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Târnaveni",
				"to": "Şeuca h.",
				"leavesAt": "21:04",
				"arrivesAt": "21:11",
				"waitsAtSource": 120,
				"distance": 2600
			},
			{
				"from": "Şeuca h.",
				"to": "Găneşti h.",
				"leavesAt": "21:12",
				"arrivesAt": "21:17",
				"waitsAtSource": 30,
				"distance": 2800
			},
			{
				"from": "Găneşti h.",
				"to": "Deaj h.",
				"leavesAt": "21:18",
				"arrivesAt": "21:23",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Deaj h.",
				"to": "Mica h.",
				"leavesAt": "21:24",
				"arrivesAt": "21:28",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Mica h.",
				"to": "Bernadea h.",
				"leavesAt": "21:29",
				"arrivesAt": "21:33",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Bernadea h.",
				"to": "Bahnea h.",
				"leavesAt": "21:34",
				"arrivesAt": "21:40",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Bahnea h.",
				"to": "Laslău h.",
				"leavesAt": "21:41",
				"arrivesAt": "21:47",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Laslău h.",
				"to": "Şoimuş h.",
				"leavesAt": "21:48",
				"arrivesAt": "21:55",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Şoimuş h.",
				"to": "Coroiu h.",
				"leavesAt": "21:56",
				"arrivesAt": "21:59",
				"waitsAtSource": 60,
				"distance": 1300
			},
			{
				"from": "Coroiu h.",
				"to": "Bălăuşeri hcv.",
				"leavesAt": "22:00",
				"arrivesAt": "22:10",
				"waitsAtSource": 30,
				"distance": 6700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14822",
		"segments": [
			{
				"from": "Dorohoi",
				"to": "Broscăuţi h.",
				"leavesAt": "15:20",
				"arrivesAt": "15:25",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Broscăuţi h.",
				"to": "Carasa h.",
				"leavesAt": "15:26",
				"arrivesAt": "15:33",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Carasa h.",
				"to": "Corlăteni h",
				"leavesAt": "15:34",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Corlăteni h",
				"to": "Mateieni h.",
				"leavesAt": "15:38",
				"arrivesAt": "15:41",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Mateieni h.",
				"to": "Vorniceni h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:46",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Vorniceni h.",
				"to": "Mândreşti h.",
				"leavesAt": "15:47",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 7400
			},
			{
				"from": "Mândreşti h.",
				"to": "Ungureni Hm.",
				"leavesAt": "15:56",
				"arrivesAt": "16:02",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ungureni Hm.",
				"to": "Dângeni Nord h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Dângeni",
				"leavesAt": "16:12",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni",
				"to": "Buhăceni h.",
				"leavesAt": "16:18",
				"arrivesAt": "16:24",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Buhăceni h.",
				"to": "Truşeşti",
				"leavesAt": "16:25",
				"arrivesAt": "16:31",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "16:41",
				"arrivesAt": "16:50",
				"waitsAtSource": 600,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "16:51",
				"arrivesAt": "16:57",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "16:58",
				"arrivesAt": "17:06",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "17:07",
				"arrivesAt": "17:13",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "17:14",
				"arrivesAt": "17:19",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "17:20",
				"arrivesAt": "17:25",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "17:26",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "17:32",
				"arrivesAt": "17:37",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "17:38",
				"arrivesAt": "17:44",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "17:46",
				"arrivesAt": "17:57",
				"waitsAtSource": 120,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "17:58",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "18:05",
				"arrivesAt": "18:14",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "18:15",
				"arrivesAt": "18:25",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "18:26",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14506",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "11:39",
				"arrivesAt": "11:45",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "11:46",
				"arrivesAt": "11:55",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "11:56",
				"arrivesAt": "12:02",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "12:03",
				"arrivesAt": "12:10",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "12:11",
				"arrivesAt": "12:15",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "12:16",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "12:22",
				"arrivesAt": "12:32",
				"waitsAtSource": 30,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "12:42",
				"arrivesAt": "12:46",
				"waitsAtSource": 600,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "12:47",
				"arrivesAt": "12:54",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "12:55",
				"arrivesAt": "13:03",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Gătaia",
				"to": "Birda hcv.",
				"leavesAt": "13:04",
				"arrivesAt": "13:14",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Birda hcv.",
				"to": "Voiteni",
				"leavesAt": "13:15",
				"arrivesAt": "13:24",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "13:27",
				"arrivesAt": "13:37",
				"waitsAtSource": 180,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "13:38",
				"arrivesAt": "13:44",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "13:45",
				"arrivesAt": "13:51",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "13:52",
				"arrivesAt": "13:58",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "13:59",
				"arrivesAt": "14:02",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "14:07",
				"arrivesAt": "14:17",
				"waitsAtSource": 300,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14504",
		"segments": [
			{
				"from": "Reşiţa Nord",
				"to": "Câlnic h.",
				"leavesAt": "07:18",
				"arrivesAt": "07:21",
				"waitsAtSource": 0,
				"distance": 1600
			},
			{
				"from": "Câlnic h.",
				"to": "Moniom h.",
				"leavesAt": "07:22",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Moniom h.",
				"to": "Colţan h.",
				"leavesAt": "07:32",
				"arrivesAt": "07:38",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Colţan h.",
				"to": "Bocşa Montană hc.",
				"leavesAt": "07:39",
				"arrivesAt": "07:46",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Vasiova",
				"leavesAt": "07:47",
				"arrivesAt": "07:51",
				"waitsAtSource": 30,
				"distance": 1700
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Română hc.",
				"leavesAt": "07:52",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Berzovia",
				"leavesAt": "07:59",
				"arrivesAt": "08:09",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Berzovia",
				"to": "Gherteniş hc.",
				"leavesAt": "08:10",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 3500
			},
			{
				"from": "Gherteniş hc.",
				"to": "Măureni hc.",
				"leavesAt": "08:14",
				"arrivesAt": "08:20",
				"waitsAtSource": 30,
				"distance": 6100
			},
			{
				"from": "Măureni hc.",
				"to": "Gătaia",
				"leavesAt": "08:21",
				"arrivesAt": "08:29",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Gătaia",
				"to": "Birda hcv.",
				"leavesAt": "08:30",
				"arrivesAt": "08:40",
				"waitsAtSource": 60,
				"distance": 8700
			},
			{
				"from": "Birda hcv.",
				"to": "Voiteni",
				"leavesAt": "08:41",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Voiteni",
				"to": "Jebel",
				"leavesAt": "08:53",
				"arrivesAt": "09:03",
				"waitsAtSource": 180,
				"distance": 9200
			},
			{
				"from": "Jebel",
				"to": "Pădureni Timiş  P.M.",
				"leavesAt": "09:04",
				"arrivesAt": "09:09",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Pădureni Timiş  P.M.",
				"to": "Timişeni Hm.",
				"leavesAt": "09:10",
				"arrivesAt": "09:16",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Timişeni Hm.",
				"to": "Timişoara C.E.T.",
				"leavesAt": "09:17",
				"arrivesAt": "09:22",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Timişoara C.E.T.",
				"to": "Timişoara Sud",
				"leavesAt": "09:23",
				"arrivesAt": "09:26",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Timişoara Sud",
				"to": "Timişoara Nord",
				"leavesAt": "09:27",
				"arrivesAt": "09:37",
				"waitsAtSource": 60,
				"distance": 5600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14753",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "07:58",
				"arrivesAt": "08:02",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "08:03",
				"arrivesAt": "08:09",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "08:10",
				"arrivesAt": "08:20",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "08:21",
				"arrivesAt": "08:26",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "08:27",
				"arrivesAt": "08:32",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:38",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "08:39",
				"arrivesAt": "08:51",
				"waitsAtSource": 30,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14547",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Timişoara Vest Hm.",
				"leavesAt": "16:21",
				"arrivesAt": "16:33",
				"waitsAtSource": 0,
				"distance": 5000
			},
			{
				"from": "Timişoara Vest Hm.",
				"to": "Utvin h.",
				"leavesAt": "16:34",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Utvin h.",
				"to": "Sânmihai h.",
				"leavesAt": "16:41",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Sânmihai h.",
				"to": "Parţa h.",
				"leavesAt": "16:45",
				"arrivesAt": "16:52",
				"waitsAtSource": 30,
				"distance": 5800
			},
			{
				"from": "Parţa h.",
				"to": "Peciu Nou h.",
				"leavesAt": "16:53",
				"arrivesAt": "17:03",
				"waitsAtSource": 30,
				"distance": 8000
			},
			{
				"from": "Peciu Nou h.",
				"to": "Cebza h.",
				"leavesAt": "17:04",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Cebza h.",
				"to": "Giulvăz h",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Giulvăz h",
				"to": "Rudna hc.",
				"leavesAt": "17:17",
				"arrivesAt": "17:24",
				"waitsAtSource": 30,
				"distance": 5300
			},
			{
				"from": "Rudna hc.",
				"to": "Cruceni hcv.",
				"leavesAt": "17:25",
				"arrivesAt": "17:44",
				"waitsAtSource": 30,
				"distance": 11000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18250",
		"segments": [
			{
				"from": "Luduş",
				"to": "Luduş Sat hc.",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Tăureni h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Tăureni h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Bota Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Balda h.",
				"leavesAt": "09:11",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Balda h.",
				"to": "Sărmaşu h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "09:29",
				"arrivesAt": "09:33",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Sărmăşel hcv .",
				"to": "Ţăgşor h.",
				"leavesAt": "09:55",
				"arrivesAt": "09:59",
				"waitsAtSource": 1320,
				"distance": 2000
			},
			{
				"from": "Ţăgşor h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "10:00",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţagu h.",
				"leavesAt": "10:07",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Brăteni h.",
				"leavesAt": "10:38",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Brăteni h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "10:46",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Vermeş h.",
				"leavesAt": "10:53",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vermeş h.",
				"to": "Lechinţa",
				"leavesAt": "11:02",
				"arrivesAt": "11:06",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Lechinţa",
				"to": "Ţigău h.",
				"leavesAt": "11:08",
				"arrivesAt": "11:15",
				"waitsAtSource": 120,
				"distance": 5000
			},
			{
				"from": "Ţigău h.",
				"to": "Chiraleş h.",
				"leavesAt": "11:16",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiraleş h.",
				"to": "Chintelnic h.",
				"leavesAt": "11:21",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 2276
			},
			{
				"from": "Chintelnic h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "11:26",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "12:30",
				"arrivesAt": "12:33",
				"waitsAtSource": 3600,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel",
				"leavesAt": "12:34",
				"arrivesAt": "12:40",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel",
				"to": "Sărata h.",
				"leavesAt": "12:50",
				"arrivesAt": "12:55",
				"waitsAtSource": 600,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "12:56",
				"arrivesAt": "13:03",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "13:04",
				"arrivesAt": "13:07",
				"waitsAtSource": 30,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14752",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:55",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "06:56",
				"arrivesAt": "07:02",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "07:03",
				"arrivesAt": "07:08",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "07:09",
				"arrivesAt": "07:14",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "07:15",
				"arrivesAt": "07:25",
				"waitsAtSource": 30,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "07:26",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "07:32",
				"arrivesAt": "07:37",
				"waitsAtSource": 30,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14016",
		"segments": [
			{
				"from": "Luduş",
				"to": "Luduş Sat hc.",
				"leavesAt": "08:18",
				"arrivesAt": "08:21",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "08:22",
				"arrivesAt": "08:33",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Tăureni h.",
				"leavesAt": "08:34",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Tăureni h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "08:51",
				"arrivesAt": "08:56",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Bota Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "08:57",
				"arrivesAt": "09:03",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "09:04",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Balda h.",
				"leavesAt": "09:11",
				"arrivesAt": "09:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Balda h.",
				"to": "Sărmaşu h.",
				"leavesAt": "09:18",
				"arrivesAt": "09:23",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "09:24",
				"arrivesAt": "09:28",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "09:29",
				"arrivesAt": "09:33",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Sărmăşel hcv .",
				"to": "Ţăgşor h.",
				"leavesAt": "09:55",
				"arrivesAt": "09:59",
				"waitsAtSource": 1320,
				"distance": 2000
			},
			{
				"from": "Ţăgşor h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "10:00",
				"arrivesAt": "10:06",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţagu h.",
				"leavesAt": "10:07",
				"arrivesAt": "10:10",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:19",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "10:20",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "10:31",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Brăteni h.",
				"leavesAt": "10:38",
				"arrivesAt": "10:45",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Brăteni h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "10:46",
				"arrivesAt": "10:52",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Vermeş h.",
				"leavesAt": "10:53",
				"arrivesAt": "11:01",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Vermeş h.",
				"to": "Lechinţa",
				"leavesAt": "11:02",
				"arrivesAt": "11:06",
				"waitsAtSource": 30,
				"distance": 2200
			},
			{
				"from": "Lechinţa",
				"to": "Ţigău h.",
				"leavesAt": "11:08",
				"arrivesAt": "11:15",
				"waitsAtSource": 120,
				"distance": 5000
			},
			{
				"from": "Ţigău h.",
				"to": "Chiraleş h.",
				"leavesAt": "11:16",
				"arrivesAt": "11:20",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Chiraleş h.",
				"to": "Chintelnic h.",
				"leavesAt": "11:21",
				"arrivesAt": "11:25",
				"waitsAtSource": 30,
				"distance": 2276
			},
			{
				"from": "Chintelnic h.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "11:26",
				"arrivesAt": "11:30",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Arcalia hc.",
				"leavesAt": "11:37",
				"arrivesAt": "11:39",
				"waitsAtSource": 420,
				"distance": 2000
			},
			{
				"from": "Arcalia hc.",
				"to": "Sărăţel",
				"leavesAt": "11:40",
				"arrivesAt": "11:46",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Sărăţel",
				"to": "Sărata h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:52",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Sărata h.",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "11:53",
				"arrivesAt": "12:00",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Bistriţa Nord",
				"leavesAt": "12:01",
				"arrivesAt": "12:04",
				"waitsAtSource": 60,
				"distance": 900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14750",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "04:43",
				"arrivesAt": "04:54",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "04:55",
				"arrivesAt": "05:01",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "05:02",
				"arrivesAt": "05:07",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "05:08",
				"arrivesAt": "05:14",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "05:15",
				"arrivesAt": "05:25",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:31",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "05:32",
				"arrivesAt": "05:38",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14977",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "11:33",
				"arrivesAt": "11:38",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "11:39",
				"arrivesAt": "11:44",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:48",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "11:49",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "11:54",
				"arrivesAt": "11:57",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "11:58",
				"arrivesAt": "12:03",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "12:04",
				"arrivesAt": "12:08",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "12:09",
				"arrivesAt": "12:11",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "12:12",
				"arrivesAt": "12:18",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "12:19",
				"arrivesAt": "12:22",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "12:23",
				"arrivesAt": "12:30",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "12:31",
				"arrivesAt": "12:36",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "12:37",
				"arrivesAt": "12:40",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "12:41",
				"arrivesAt": "12:46",
				"waitsAtSource": 30,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14751",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "05:50",
				"arrivesAt": "05:54",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "05:55",
				"arrivesAt": "06:01",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "06:02",
				"arrivesAt": "06:12",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "06:13",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "06:19",
				"arrivesAt": "06:24",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "06:25",
				"arrivesAt": "06:30",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "06:31",
				"arrivesAt": "06:42",
				"waitsAtSource": 30,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14755",
		"segments": [
			{
				"from": "Braşov",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "11:23",
				"arrivesAt": "11:28",
				"waitsAtSource": 0,
				"distance": 2900
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Hărman",
				"leavesAt": "11:29",
				"arrivesAt": "11:35",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Hărman",
				"to": "Budila hcv.",
				"leavesAt": "11:36",
				"arrivesAt": "11:46",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Budila hcv.",
				"to": "Teliu h.",
				"leavesAt": "11:47",
				"arrivesAt": "11:53",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Teliu h.",
				"to": "Valea Teliului h.",
				"leavesAt": "11:54",
				"arrivesAt": "11:59",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Valea Teliului h.",
				"to": "Poiana Florilor h.",
				"leavesAt": "12:00",
				"arrivesAt": "12:05",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Întorsura Buzăului Hm",
				"leavesAt": "12:06",
				"arrivesAt": "12:18",
				"waitsAtSource": 30,
				"distance": 7500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14760",
		"segments": [
			{
				"from": "Întorsura Buzăului Hm",
				"to": "Poiana Florilor h.",
				"leavesAt": "17:14",
				"arrivesAt": "17:25",
				"waitsAtSource": 0,
				"distance": 7500
			},
			{
				"from": "Poiana Florilor h.",
				"to": "Valea Teliului h.",
				"leavesAt": "17:26",
				"arrivesAt": "17:32",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Teliului h.",
				"to": "Teliu h.",
				"leavesAt": "17:33",
				"arrivesAt": "17:38",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Teliu h.",
				"to": "Budila hcv.",
				"leavesAt": "17:39",
				"arrivesAt": "17:45",
				"waitsAtSource": 30,
				"distance": 4300
			},
			{
				"from": "Budila hcv.",
				"to": "Hărman",
				"leavesAt": "17:46",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 10500
			},
			{
				"from": "Hărman",
				"to": "Pav. CFR Braşov Triaj h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Pav. CFR Braşov Triaj h.",
				"to": "Braşov",
				"leavesAt": "18:05",
				"arrivesAt": "18:10",
				"waitsAtSource": 60,
				"distance": 2900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14843",
		"segments": [
			{
				"from": "Roman",
				"to": "Sagna h.",
				"leavesAt": "05:26",
				"arrivesAt": "05:36",
				"waitsAtSource": 0,
				"distance": 8700
			},
			{
				"from": "Sagna h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "05:37",
				"arrivesAt": "05:47",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Stăniţa h.",
				"leavesAt": "05:48",
				"arrivesAt": "05:56",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Stăniţa h.",
				"to": "Piscu Rusului h.",
				"leavesAt": "05:57",
				"arrivesAt": "06:08",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Zece Prăjini h",
				"leavesAt": "06:09",
				"arrivesAt": "06:18",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Zece Prăjini h",
				"to": "Dagâţa",
				"leavesAt": "06:19",
				"arrivesAt": "06:25",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Dagâţa",
				"to": "Băluşeşti h",
				"leavesAt": "06:33",
				"arrivesAt": "06:37",
				"waitsAtSource": 480,
				"distance": 3400
			},
			{
				"from": "Băluşeşti h",
				"to": "Suhuleţ h.",
				"leavesAt": "06:38",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Suhuleţ h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:49",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Dumeşti h.",
				"leavesAt": "06:50",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Dumeşti h.",
				"to": "Rafaila h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Rafaila h.",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "07:06",
				"arrivesAt": "07:13",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Buhăieşti",
				"leavesAt": "07:14",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 10700
			},
			{
				"from": "Buhăieşti",
				"to": "Rateşu Cuzei h.",
				"leavesAt": "07:31",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rateşu Cuzei h.",
				"to": "Rebricea Hm.",
				"leavesAt": "07:36",
				"arrivesAt": "07:41",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Rebricea Hm.",
				"to": "Scânteia Hm.",
				"leavesAt": "07:46",
				"arrivesAt": "07:51",
				"waitsAtSource": 300,
				"distance": 5500
			},
			{
				"from": "Scânteia Hm.",
				"to": "Grajduri",
				"leavesAt": "07:52",
				"arrivesAt": "07:58",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Grajduri",
				"to": "Bârnova Hm.",
				"leavesAt": "07:59",
				"arrivesAt": "08:07",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Bârnova Hm.",
				"to": "Picioru Lupului h.",
				"leavesAt": "08:08",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Picioru Lupului h.",
				"to": "Ciurea Hm.",
				"leavesAt": "08:14",
				"arrivesAt": "08:19",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ciurea Hm.",
				"to": "Nicolina",
				"leavesAt": "08:20",
				"arrivesAt": "08:25",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Nicolina",
				"to": "Iaşi",
				"leavesAt": "08:26",
				"arrivesAt": "08:35",
				"waitsAtSource": 60,
				"distance": 2200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14716",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "21:30",
				"arrivesAt": "21:33",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "21:34",
				"arrivesAt": "21:36",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "21:37",
				"arrivesAt": "21:42",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "21:43",
				"arrivesAt": "21:46",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "21:47",
				"arrivesAt": "21:51",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "21:52",
				"arrivesAt": "21:55",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "21:56",
				"arrivesAt": "22:03",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "22:04",
				"arrivesAt": "22:10",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14419",
		"segments": [
			{
				"from": "Ineu",
				"to": "Teuz h.",
				"leavesAt": "06:40",
				"arrivesAt": "06:51",
				"waitsAtSource": 0,
				"distance": 10600
			},
			{
				"from": "Teuz h.",
				"to": "Cermei hcv",
				"leavesAt": "06:52",
				"arrivesAt": "06:58",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 511
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14304",
		"segments": [
			{
				"from": "Nădlac",
				"to": "Şeitin h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:08",
				"waitsAtSource": 0,
				"distance": 8100
			},
			{
				"from": "Şeitin h.",
				"to": "Semlac h.",
				"leavesAt": "16:09",
				"arrivesAt": "16:19",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Semlac h.",
				"to": "Pecica",
				"leavesAt": "16:20",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 17200
			},
			{
				"from": "Pecica",
				"to": "Sântoma h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:08",
				"waitsAtSource": 780,
				"distance": 8000
			},
			{
				"from": "Sântoma h.",
				"to": "Ferma Ciala h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 4400
			},
			{
				"from": "Ferma Ciala h.",
				"to": "Arad Vest",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Arad Vest",
				"to": "Arad",
				"leavesAt": "17:25",
				"arrivesAt": "17:34",
				"waitsAtSource": 180,
				"distance": 4800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14555",
		"segments": [
			{
				"from": "Sărmăşel hcv .",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "15:42",
				"arrivesAt": "15:45",
				"waitsAtSource": 0,
				"distance": 2000
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmaşu h.",
				"leavesAt": "15:46",
				"arrivesAt": "15:50",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Balda h.",
				"leavesAt": "15:51",
				"arrivesAt": "15:55",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Balda h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "15:56",
				"arrivesAt": "16:02",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "16:03",
				"arrivesAt": "16:09",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "16:10",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bota Sat h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "16:16",
				"arrivesAt": "16:21",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "16:22",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Tăureni h.",
				"leavesAt": "16:26",
				"arrivesAt": "16:30",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Tăureni h.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Luduş Sat hc.",
				"leavesAt": "16:40",
				"arrivesAt": "16:50",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Luduş",
				"leavesAt": "16:51",
				"arrivesAt": "16:55",
				"waitsAtSource": 30,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20170101",
				"to": "20171209",
				"daysOfWeek": 383
			},
			{
				"from": "20161211",
				"to": "20161223",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14343",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Dudeştii Vechi  h",
				"leavesAt": "16:10",
				"arrivesAt": "16:27",
				"waitsAtSource": 0,
				"distance": 14000
			},
			{
				"from": "Dudeştii Vechi  h",
				"to": "Vălcani hcv.",
				"leavesAt": "16:28",
				"arrivesAt": "16:37",
				"waitsAtSource": 30,
				"distance": 7000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14038",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "15:50",
				"arrivesAt": "15:57",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Predeal",
				"leavesAt": "15:58",
				"arrivesAt": "16:25",
				"waitsAtSource": 60,
				"distance": 20100
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "16:26",
				"arrivesAt": "16:34",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "16:35",
				"arrivesAt": "16:40",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "16:41",
				"arrivesAt": "16:44",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "16:45",
				"arrivesAt": "16:50",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "16:51",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "16:59",
				"arrivesAt": "17:08",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "17:09",
				"arrivesAt": "17:12",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "17:13",
				"arrivesAt": "17:16",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "17:17",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "17:21",
				"arrivesAt": "17:29",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "17:30",
				"arrivesAt": "17:41",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "17:42",
				"arrivesAt": "17:51",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "17:52",
				"arrivesAt": "18:00",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "18:06",
				"arrivesAt": "18:13",
				"waitsAtSource": 360,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "18:14",
				"arrivesAt": "18:23",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "18:24",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "18:29",
				"arrivesAt": "18:34",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "18:35",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "18:44",
				"arrivesAt": "18:48",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "18:49",
				"arrivesAt": "19:07",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14034",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "07:00",
				"arrivesAt": "07:07",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Predeal",
				"leavesAt": "07:08",
				"arrivesAt": "07:35",
				"waitsAtSource": 60,
				"distance": 20100
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "07:36",
				"arrivesAt": "07:44",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "07:45",
				"arrivesAt": "07:50",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "07:51",
				"arrivesAt": "07:54",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "07:55",
				"arrivesAt": "08:00",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "08:01",
				"arrivesAt": "08:03",
				"waitsAtSource": 60,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "08:04",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "08:09",
				"arrivesAt": "08:18",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "08:19",
				"arrivesAt": "08:22",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "08:23",
				"arrivesAt": "08:26",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "08:27",
				"arrivesAt": "08:30",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "08:31",
				"arrivesAt": "08:39",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "08:40",
				"arrivesAt": "08:51",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "08:52",
				"arrivesAt": "09:01",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "09:02",
				"arrivesAt": "09:10",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "09:21",
				"arrivesAt": "09:28",
				"waitsAtSource": 660,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "09:29",
				"arrivesAt": "09:38",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "09:39",
				"arrivesAt": "09:44",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "09:45",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "09:58",
				"arrivesAt": "10:05",
				"waitsAtSource": 420,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "10:06",
				"arrivesAt": "10:10",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "10:11",
				"arrivesAt": "10:30",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14975",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "08:15",
				"arrivesAt": "08:20",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "08:21",
				"arrivesAt": "08:27",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "08:28",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "08:32",
				"arrivesAt": "08:37",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "08:38",
				"arrivesAt": "08:41",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "08:42",
				"arrivesAt": "08:47",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "08:48",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "08:54",
				"arrivesAt": "08:58",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "08:59",
				"arrivesAt": "09:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "09:06",
				"arrivesAt": "09:11",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "09:12",
				"arrivesAt": "09:18",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "09:19",
				"arrivesAt": "09:24",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "09:25",
				"arrivesAt": "09:29",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "09:30",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14842",
		"segments": [
			{
				"from": "Buhăieşti",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "05:36",
				"arrivesAt": "05:50",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Rafaila h.",
				"leavesAt": "05:51",
				"arrivesAt": "05:57",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Rafaila h.",
				"to": "Dumeşti h.",
				"leavesAt": "05:58",
				"arrivesAt": "06:05",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Dumeşti h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "06:06",
				"arrivesAt": "06:13",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Suhuleţ h.",
				"leavesAt": "06:14",
				"arrivesAt": "06:20",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Suhuleţ h.",
				"to": "Băluşeşti h",
				"leavesAt": "06:21",
				"arrivesAt": "06:24",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Băluşeşti h",
				"to": "Dagâţa",
				"leavesAt": "06:25",
				"arrivesAt": "06:29",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Dagâţa",
				"to": "Zece Prăjini h",
				"leavesAt": "06:31",
				"arrivesAt": "06:35",
				"waitsAtSource": 120,
				"distance": 3600
			},
			{
				"from": "Zece Prăjini h",
				"to": "Piscu Rusului h.",
				"leavesAt": "06:36",
				"arrivesAt": "06:45",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Stăniţa h.",
				"leavesAt": "06:46",
				"arrivesAt": "06:57",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Stăniţa h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "06:58",
				"arrivesAt": "07:05",
				"waitsAtSource": 60,
				"distance": 3800
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Sagna h.",
				"leavesAt": "07:06",
				"arrivesAt": "07:16",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Sagna h.",
				"to": "Roman",
				"leavesAt": "07:17",
				"arrivesAt": "07:30",
				"waitsAtSource": 60,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14325",
		"segments": [
			{
				"from": "Timişoara Nord",
				"to": "Ronaţ Triaj Cab.1 h.",
				"leavesAt": "19:33",
				"arrivesAt": "19:39",
				"waitsAtSource": 0,
				"distance": 4400
			},
			{
				"from": "Ronaţ Triaj Cab.1 h.",
				"to": "Ronaţ Triaj h.",
				"leavesAt": "19:40",
				"arrivesAt": "19:43",
				"waitsAtSource": 30,
				"distance": 1500
			},
			{
				"from": "Ronaţ Triaj h.",
				"to": "Ronaţ Triaj Gr. D",
				"leavesAt": "19:44",
				"arrivesAt": "19:46",
				"waitsAtSource": 60,
				"distance": 1000
			},
			{
				"from": "Ronaţ Triaj Gr. D",
				"to": "Sânandrei Hm.",
				"leavesAt": "19:47",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sânandrei Hm.",
				"to": "Hodoni h.",
				"leavesAt": "19:54",
				"arrivesAt": "20:03",
				"waitsAtSource": 60,
				"distance": 8600
			},
			{
				"from": "Hodoni h.",
				"to": "Chinezu h.",
				"leavesAt": "20:04",
				"arrivesAt": "20:11",
				"waitsAtSource": 30,
				"distance": 5700
			},
			{
				"from": "Chinezu h.",
				"to": "Bărăteaz h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Bărăteaz h.",
				"to": "Gelu hc.",
				"leavesAt": "20:18",
				"arrivesAt": "20:23",
				"waitsAtSource": 30,
				"distance": 3500
			},
			{
				"from": "Gelu hc.",
				"to": "Variaş hc.",
				"leavesAt": "20:24",
				"arrivesAt": "20:30",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Variaş hc.",
				"to": "Periam",
				"leavesAt": "20:31",
				"arrivesAt": "20:41",
				"waitsAtSource": 30,
				"distance": 7600
			},
			{
				"from": "Periam",
				"to": "Pesac h.",
				"leavesAt": "20:51",
				"arrivesAt": "21:04",
				"waitsAtSource": 600,
				"distance": 6700
			},
			{
				"from": "Pesac h.",
				"to": "Satu Nou Hm.",
				"leavesAt": "21:05",
				"arrivesAt": "21:13",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Satu Nou Hm.",
				"to": "Lovrin",
				"leavesAt": "21:14",
				"arrivesAt": "21:22",
				"waitsAtSource": 60,
				"distance": 5000
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14848",
		"segments": [
			{
				"from": "Buhăieşti",
				"to": "Negreşti Vaslui Hm.",
				"leavesAt": "16:44",
				"arrivesAt": "16:58",
				"waitsAtSource": 0,
				"distance": 10700
			},
			{
				"from": "Negreşti Vaslui Hm.",
				"to": "Rafaila h.",
				"leavesAt": "16:59",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Rafaila h.",
				"to": "Dumeşti h.",
				"leavesAt": "17:05",
				"arrivesAt": "17:12",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Dumeşti h.",
				"to": "Mareşal C-tin Prezan Hm.",
				"leavesAt": "17:13",
				"arrivesAt": "17:20",
				"waitsAtSource": 30,
				"distance": 5500
			},
			{
				"from": "Mareşal C-tin Prezan Hm.",
				"to": "Suhuleţ h.",
				"leavesAt": "17:21",
				"arrivesAt": "17:27",
				"waitsAtSource": 60,
				"distance": 5500
			},
			{
				"from": "Suhuleţ h.",
				"to": "Băluşeşti h",
				"leavesAt": "17:28",
				"arrivesAt": "17:31",
				"waitsAtSource": 60,
				"distance": 3000
			},
			{
				"from": "Băluşeşti h",
				"to": "Dagâţa",
				"leavesAt": "17:32",
				"arrivesAt": "17:36",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Dagâţa",
				"to": "Zece Prăjini h",
				"leavesAt": "17:44",
				"arrivesAt": "17:48",
				"waitsAtSource": 480,
				"distance": 3600
			},
			{
				"from": "Zece Prăjini h",
				"to": "Piscu Rusului h.",
				"leavesAt": "17:49",
				"arrivesAt": "17:57",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Piscu Rusului h.",
				"to": "Stăniţa h.",
				"leavesAt": "17:58",
				"arrivesAt": "18:09",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Stăniţa h.",
				"to": "Vulpăşeşti h.",
				"leavesAt": "18:10",
				"arrivesAt": "18:17",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Vulpăşeşti h.",
				"to": "Sagna h.",
				"leavesAt": "18:18",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 8300
			},
			{
				"from": "Sagna h.",
				"to": "Roman",
				"leavesAt": "18:29",
				"arrivesAt": "18:42",
				"waitsAtSource": 60,
				"distance": 8700
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14036",
		"segments": [
			{
				"from": "Braşov",
				"to": "Dârste",
				"leavesAt": "13:55",
				"arrivesAt": "14:02",
				"waitsAtSource": 0,
				"distance": 6200
			},
			{
				"from": "Dârste",
				"to": "Predeal",
				"leavesAt": "14:03",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 20100
			},
			{
				"from": "Predeal",
				"to": "Azuga",
				"leavesAt": "14:32",
				"arrivesAt": "14:41",
				"waitsAtSource": 120,
				"distance": 7400
			},
			{
				"from": "Azuga",
				"to": "Buşteni",
				"leavesAt": "14:42",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Buşteni",
				"to": "Poiana Ţapului hc.",
				"leavesAt": "14:48",
				"arrivesAt": "14:51",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Poiana Ţapului hc.",
				"to": "Sinaia",
				"leavesAt": "14:52",
				"arrivesAt": "14:57",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sinaia",
				"to": "Sinaia Sud h.",
				"leavesAt": "14:59",
				"arrivesAt": "15:01",
				"waitsAtSource": 120,
				"distance": 1600
			},
			{
				"from": "Sinaia Sud h.",
				"to": "Valea Largă Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:06",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Valea Largă Hm.",
				"to": "Comarnic",
				"leavesAt": "15:07",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 9700
			},
			{
				"from": "Comarnic",
				"to": "Breaza Nord h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:20",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Breaza Nord h.",
				"to": "Nistoreşti h.",
				"leavesAt": "15:21",
				"arrivesAt": "15:24",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Nistoreşti h.",
				"to": "Breaza hc.",
				"leavesAt": "15:25",
				"arrivesAt": "15:28",
				"waitsAtSource": 30,
				"distance": 2700
			},
			{
				"from": "Breaza hc.",
				"to": "Câmpina",
				"leavesAt": "15:29",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Câmpina",
				"to": "Floreşti Prahova",
				"leavesAt": "15:38",
				"arrivesAt": "15:50",
				"waitsAtSource": 60,
				"distance": 14200
			},
			{
				"from": "Floreşti Prahova",
				"to": "Buda",
				"leavesAt": "15:51",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Buda",
				"to": "Ploieşti Vest",
				"leavesAt": "16:01",
				"arrivesAt": "16:10",
				"waitsAtSource": 60,
				"distance": 6900
			},
			{
				"from": "Ploieşti Vest",
				"to": "Brazi",
				"leavesAt": "16:21",
				"arrivesAt": "16:28",
				"waitsAtSource": 660,
				"distance": 7500
			},
			{
				"from": "Brazi",
				"to": "Crivina",
				"leavesAt": "16:29",
				"arrivesAt": "16:39",
				"waitsAtSource": 60,
				"distance": 11700
			},
			{
				"from": "Crivina",
				"to": "Scroviştea h.",
				"leavesAt": "16:46",
				"arrivesAt": "16:50",
				"waitsAtSource": 420,
				"distance": 4300
			},
			{
				"from": "Scroviştea h.",
				"to": "Periş",
				"leavesAt": "16:51",
				"arrivesAt": "16:56",
				"waitsAtSource": 30,
				"distance": 5200
			},
			{
				"from": "Periş",
				"to": "Dârza h.",
				"leavesAt": "16:57",
				"arrivesAt": "17:04",
				"waitsAtSource": 60,
				"distance": 9200
			},
			{
				"from": "Dârza h.",
				"to": "Buftea",
				"leavesAt": "17:05",
				"arrivesAt": "17:09",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Buftea",
				"to": "Bucureşti Nord",
				"leavesAt": "17:10",
				"arrivesAt": "17:30",
				"waitsAtSource": 60,
				"distance": 16900
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "18237",
		"segments": [
			{
				"from": "Berzovia",
				"to": "Bocşa Română hc.",
				"leavesAt": "13:45",
				"arrivesAt": "13:53",
				"waitsAtSource": 0,
				"distance": 8200
			},
			{
				"from": "Bocşa Română hc.",
				"to": "Vasiova",
				"leavesAt": "13:54",
				"arrivesAt": "13:59",
				"waitsAtSource": 30,
				"distance": 4200
			},
			{
				"from": "Vasiova",
				"to": "Bocşa Montană hc.",
				"leavesAt": "14:00",
				"arrivesAt": "14:03",
				"waitsAtSource": 60,
				"distance": 1700
			},
			{
				"from": "Bocşa Montană hc.",
				"to": "Colţan h.",
				"leavesAt": "14:04",
				"arrivesAt": "14:11",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Colţan h.",
				"to": "Moniom h.",
				"leavesAt": "14:12",
				"arrivesAt": "14:17",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Moniom h.",
				"to": "Câlnic h.",
				"leavesAt": "14:18",
				"arrivesAt": "14:26",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Câlnic h.",
				"to": "Reşiţa Nord",
				"leavesAt": "14:27",
				"arrivesAt": "14:30",
				"waitsAtSource": 60,
				"distance": 1600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14710",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "15:05",
				"arrivesAt": "15:08",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "15:09",
				"arrivesAt": "15:11",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "15:12",
				"arrivesAt": "15:17",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "15:18",
				"arrivesAt": "15:21",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "15:22",
				"arrivesAt": "15:26",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "15:27",
				"arrivesAt": "15:30",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "15:31",
				"arrivesAt": "15:38",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "15:39",
				"arrivesAt": "15:45",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14974",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "08:38",
				"arrivesAt": "08:42",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "08:43",
				"arrivesAt": "08:48",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "08:49",
				"arrivesAt": "08:55",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "08:56",
				"arrivesAt": "09:02",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "09:03",
				"arrivesAt": "09:08",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "09:09",
				"arrivesAt": "09:14",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "09:15",
				"arrivesAt": "09:19",
				"waitsAtSource": 60,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "09:20",
				"arrivesAt": "09:25",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "09:26",
				"arrivesAt": "09:31",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "09:32",
				"arrivesAt": "09:36",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "09:37",
				"arrivesAt": "09:41",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "09:42",
				"arrivesAt": "09:45",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "09:46",
				"arrivesAt": "09:51",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "09:52",
				"arrivesAt": "09:56",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14011",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "07:42",
				"arrivesAt": "07:45",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărata h.",
				"leavesAt": "07:46",
				"arrivesAt": "07:53",
				"waitsAtSource": 60,
				"distance": 6400
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel",
				"leavesAt": "07:54",
				"arrivesAt": "07:59",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel",
				"to": "Arcalia hc.",
				"leavesAt": "08:00",
				"arrivesAt": "08:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "08:05",
				"arrivesAt": "08:08",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Chintelnic h.",
				"leavesAt": "08:09",
				"arrivesAt": "08:13",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Chintelnic h.",
				"to": "Chiraleş h.",
				"leavesAt": "08:14",
				"arrivesAt": "08:17",
				"waitsAtSource": 60,
				"distance": 2276
			},
			{
				"from": "Chiraleş h.",
				"to": "Ţigău h.",
				"leavesAt": "08:18",
				"arrivesAt": "08:23",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ţigău h.",
				"to": "Lechinţa",
				"leavesAt": "08:24",
				"arrivesAt": "08:31",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lechinţa",
				"to": "Vermeş h.",
				"leavesAt": "08:33",
				"arrivesAt": "08:36",
				"waitsAtSource": 120,
				"distance": 2200
			},
			{
				"from": "Vermeş h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "08:37",
				"arrivesAt": "08:46",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Brăteni h.",
				"leavesAt": "08:47",
				"arrivesAt": "08:53",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Brăteni h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "08:54",
				"arrivesAt": "09:01",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "09:02",
				"arrivesAt": "09:07",
				"waitsAtSource": 30,
				"distance": 3800
			},
			{
				"from": "Miceştii de Câmpie h.",
				"to": "Budeşti Cluj h.",
				"leavesAt": "09:08",
				"arrivesAt": "09:18",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Budeşti Cluj h.",
				"to": "Ţagu h.",
				"leavesAt": "09:19",
				"arrivesAt": "09:27",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Ţagu h.",
				"to": "Ţagu Sat h.",
				"leavesAt": "09:28",
				"arrivesAt": "09:30",
				"waitsAtSource": 60,
				"distance": 1400
			},
			{
				"from": "Ţagu Sat h.",
				"to": "Ţăgşor h.",
				"leavesAt": "09:31",
				"arrivesAt": "09:37",
				"waitsAtSource": 30,
				"distance": 4100
			},
			{
				"from": "Ţăgşor h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "09:38",
				"arrivesAt": "09:42",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Sărmăşel hcv .",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "09:57",
				"arrivesAt": "10:00",
				"waitsAtSource": 900,
				"distance": 2000
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmaşu h.",
				"leavesAt": "10:01",
				"arrivesAt": "10:05",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Balda h.",
				"leavesAt": "10:06",
				"arrivesAt": "10:10",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Balda h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "10:11",
				"arrivesAt": "10:17",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "10:18",
				"arrivesAt": "10:24",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "10:25",
				"arrivesAt": "10:31",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Bota Sat h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "10:32",
				"arrivesAt": "10:37",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "10:38",
				"arrivesAt": "10:41",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Tăureni h.",
				"leavesAt": "10:42",
				"arrivesAt": "10:46",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Tăureni h.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "10:47",
				"arrivesAt": "10:55",
				"waitsAtSource": 60,
				"distance": 5620
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Luduş Sat hc.",
				"leavesAt": "10:56",
				"arrivesAt": "11:07",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Luduş",
				"leavesAt": "11:08",
				"arrivesAt": "11:12",
				"waitsAtSource": 60,
				"distance": 2400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14013",
		"segments": [
			{
				"from": "Bistriţa Nord",
				"to": "Bistriţa Fabrici h.",
				"leavesAt": "11:10",
				"arrivesAt": "11:12",
				"waitsAtSource": 0,
				"distance": 900
			},
			{
				"from": "Bistriţa Fabrici h.",
				"to": "Sărata h.",
				"leavesAt": "11:13",
				"arrivesAt": "11:20",
				"waitsAtSource": 30,
				"distance": 6400
			},
			{
				"from": "Sărata h.",
				"to": "Sărăţel",
				"leavesAt": "11:21",
				"arrivesAt": "11:26",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Sărăţel",
				"to": "Arcalia hc.",
				"leavesAt": "11:27",
				"arrivesAt": "11:31",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Arcalia hc.",
				"to": "Măgheruş Şieu Hm.",
				"leavesAt": "11:32",
				"arrivesAt": "11:35",
				"waitsAtSource": 30,
				"distance": 2000
			},
			{
				"from": "Măgheruş Şieu Hm.",
				"to": "Chintelnic h.",
				"leavesAt": "11:36",
				"arrivesAt": "11:40",
				"waitsAtSource": 60,
				"distance": 2314
			},
			{
				"from": "Chintelnic h.",
				"to": "Chiraleş h.",
				"leavesAt": "11:41",
				"arrivesAt": "11:44",
				"waitsAtSource": 30,
				"distance": 2276
			},
			{
				"from": "Chiraleş h.",
				"to": "Ţigău h.",
				"leavesAt": "11:45",
				"arrivesAt": "11:50",
				"waitsAtSource": 30,
				"distance": 3200
			},
			{
				"from": "Ţigău h.",
				"to": "Lechinţa",
				"leavesAt": "11:51",
				"arrivesAt": "11:58",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Lechinţa",
				"to": "Vermeş h.",
				"leavesAt": "12:01",
				"arrivesAt": "12:04",
				"waitsAtSource": 180,
				"distance": 2200
			},
			{
				"from": "Vermeş h.",
				"to": "Sângiorgiu Nou h.",
				"leavesAt": "12:05",
				"arrivesAt": "12:14",
				"waitsAtSource": 30,
				"distance": 6000
			},
			{
				"from": "Sângiorgiu Nou h.",
				"to": "Brăteni h.",
				"leavesAt": "12:15",
				"arrivesAt": "12:21",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Brăteni h.",
				"to": "Sânmihaiu de Câmpie h.",
				"leavesAt": "12:22",
				"arrivesAt": "12:29",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Sânmihaiu de Câmpie h.",
				"to": "Miceştii de Câmpie h.",
				"leavesAt": "12:30",
				"arrivesAt": "12:36",
				"waitsAtSource": 30,
				"distance": 3800
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14550",
		"segments": [
			{
				"from": "Luduş",
				"to": "Luduş Sat hc.",
				"leavesAt": "14:25",
				"arrivesAt": "14:28",
				"waitsAtSource": 0,
				"distance": 2400
			},
			{
				"from": "Luduş Sat hc.",
				"to": "Sânger Tăureni h.",
				"leavesAt": "14:29",
				"arrivesAt": "14:39",
				"waitsAtSource": 30,
				"distance": 8080
			},
			{
				"from": "Sânger Tăureni h.",
				"to": "Tăureni h.",
				"leavesAt": "14:40",
				"arrivesAt": "14:47",
				"waitsAtSource": 30,
				"distance": 5620
			},
			{
				"from": "Tăureni h.",
				"to": "Melini Valea Largă h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:52",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Melini Valea Largă h.",
				"to": "Zau de Câmpie h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Zau de Câmpie h.",
				"to": "Bota Sat h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:02",
				"waitsAtSource": 30,
				"distance": 3300
			},
			{
				"from": "Bota Sat h.",
				"to": "Miheşu de Câmpie h.",
				"leavesAt": "15:03",
				"arrivesAt": "15:09",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Miheşu de Câmpie h.",
				"to": "Miheşu de Câmpie Sat h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:16",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Miheşu de Câmpie Sat h.",
				"to": "Balda h.",
				"leavesAt": "15:17",
				"arrivesAt": "15:22",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Balda h.",
				"to": "Sărmaşu h.",
				"leavesAt": "15:23",
				"arrivesAt": "15:27",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmaşu h.",
				"to": "Sărmăşel Gaz Metan h.",
				"leavesAt": "15:28",
				"arrivesAt": "15:32",
				"waitsAtSource": 30,
				"distance": 2900
			},
			{
				"from": "Sărmăşel Gaz Metan h.",
				"to": "Sărmăşel hcv .",
				"leavesAt": "15:33",
				"arrivesAt": "15:37",
				"waitsAtSource": 30,
				"distance": 2000
			}
		],
		"restrictions": [
			{
				"from": "20170101",
				"to": "20171209",
				"daysOfWeek": 383
			},
			{
				"from": "20161211",
				"to": "20161223",
				"daysOfWeek": 383
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14973",
		"segments": [
			{
				"from": "Ploieşti Sud",
				"to": "Dâmbu Hm.",
				"leavesAt": "06:11",
				"arrivesAt": "06:16",
				"waitsAtSource": 0,
				"distance": 3600
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "06:17",
				"arrivesAt": "06:23",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Râfov h.",
				"leavesAt": "06:24",
				"arrivesAt": "06:27",
				"waitsAtSource": 60,
				"distance": 1900
			},
			{
				"from": "Râfov h.",
				"to": "Trestieni h.",
				"leavesAt": "06:28",
				"arrivesAt": "06:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Trestieni h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "06:33",
				"arrivesAt": "06:36",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Cornurile h.",
				"leavesAt": "06:37",
				"arrivesAt": "06:42",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Cornurile h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "06:43",
				"arrivesAt": "06:48",
				"waitsAtSource": 30,
				"distance": 4000
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "06:55",
				"arrivesAt": "06:58",
				"waitsAtSource": 420,
				"distance": 2500
			},
			{
				"from": "Hătcărău h.",
				"to": "Ciorani Hm.",
				"leavesAt": "06:59",
				"arrivesAt": "07:06",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Ciorani Hm.",
				"to": "Fulga hc.",
				"leavesAt": "07:07",
				"arrivesAt": "07:11",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Fulga hc.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "07:12",
				"arrivesAt": "07:19",
				"waitsAtSource": 30,
				"distance": 6500
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "07:20",
				"arrivesAt": "07:26",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Bărbuleşti h.",
				"leavesAt": "07:27",
				"arrivesAt": "07:31",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Urziceni",
				"leavesAt": "07:32",
				"arrivesAt": "07:37",
				"waitsAtSource": 60,
				"distance": 3500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14824",
		"segments": [
			{
				"from": "Dorohoi",
				"to": "Broscăuţi h.",
				"leavesAt": "18:41",
				"arrivesAt": "18:47",
				"waitsAtSource": 0,
				"distance": 5800
			},
			{
				"from": "Broscăuţi h.",
				"to": "Carasa h.",
				"leavesAt": "18:48",
				"arrivesAt": "18:55",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Carasa h.",
				"to": "Corlăteni h",
				"leavesAt": "18:56",
				"arrivesAt": "18:59",
				"waitsAtSource": 30,
				"distance": 2300
			},
			{
				"from": "Corlăteni h",
				"to": "Mateieni h.",
				"leavesAt": "19:00",
				"arrivesAt": "19:04",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Mateieni h.",
				"to": "Vorniceni h.",
				"leavesAt": "19:05",
				"arrivesAt": "19:09",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Vorniceni h.",
				"to": "Mândreşti h.",
				"leavesAt": "19:10",
				"arrivesAt": "19:18",
				"waitsAtSource": 60,
				"distance": 7400
			},
			{
				"from": "Mândreşti h.",
				"to": "Ungureni Hm.",
				"leavesAt": "19:19",
				"arrivesAt": "19:25",
				"waitsAtSource": 60,
				"distance": 4600
			},
			{
				"from": "Ungureni Hm.",
				"to": "Dângeni Nord h.",
				"leavesAt": "19:27",
				"arrivesAt": "19:35",
				"waitsAtSource": 120,
				"distance": 8700
			},
			{
				"from": "Dângeni Nord h.",
				"to": "Dângeni",
				"leavesAt": "19:36",
				"arrivesAt": "19:41",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Dângeni",
				"to": "Buhăceni h.",
				"leavesAt": "19:42",
				"arrivesAt": "19:48",
				"waitsAtSource": 60,
				"distance": 6000
			},
			{
				"from": "Buhăceni h.",
				"to": "Truşeşti",
				"leavesAt": "19:49",
				"arrivesAt": "19:55",
				"waitsAtSource": 60,
				"distance": 4700
			},
			{
				"from": "Truşeşti",
				"to": "Zlătunoaia h",
				"leavesAt": "19:56",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 9400
			},
			{
				"from": "Zlătunoaia h",
				"to": "Jijia h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:12",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Jijia h.",
				"to": "Todireni Hm.",
				"leavesAt": "20:13",
				"arrivesAt": "20:21",
				"waitsAtSource": 60,
				"distance": 8200
			},
			{
				"from": "Todireni Hm.",
				"to": "Răuşeni hc.",
				"leavesAt": "20:23",
				"arrivesAt": "20:29",
				"waitsAtSource": 120,
				"distance": 6400
			},
			{
				"from": "Răuşeni hc.",
				"to": "Rediu hc.",
				"leavesAt": "20:30",
				"arrivesAt": "20:35",
				"waitsAtSource": 60,
				"distance": 3900
			},
			{
				"from": "Rediu hc.",
				"to": "Andrieşeni hc.",
				"leavesAt": "20:36",
				"arrivesAt": "20:41",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Andrieşeni hc.",
				"to": "Şoldana hc.",
				"leavesAt": "20:42",
				"arrivesAt": "20:47",
				"waitsAtSource": 60,
				"distance": 4200
			},
			{
				"from": "Şoldana hc.",
				"to": "Iacobenii Vechi hc.",
				"leavesAt": "20:48",
				"arrivesAt": "20:53",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Iacobenii Vechi hc.",
				"to": "Vlădeni",
				"leavesAt": "20:54",
				"arrivesAt": "21:00",
				"waitsAtSource": 60,
				"distance": 5600
			},
			{
				"from": "Vlădeni",
				"to": "Larga Jijia Hm.",
				"leavesAt": "21:08",
				"arrivesAt": "21:19",
				"waitsAtSource": 480,
				"distance": 10800
			},
			{
				"from": "Larga Jijia Hm.",
				"to": "Potângeni hc.",
				"leavesAt": "21:20",
				"arrivesAt": "21:26",
				"waitsAtSource": 60,
				"distance": 4900
			},
			{
				"from": "Potângeni hc.",
				"to": "Movileni h",
				"leavesAt": "21:27",
				"arrivesAt": "21:35",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Movileni h",
				"to": "Leţcani",
				"leavesAt": "21:36",
				"arrivesAt": "21:46",
				"waitsAtSource": 60,
				"distance": 9300
			},
			{
				"from": "Leţcani",
				"to": "Iaşi",
				"leavesAt": "21:47",
				"arrivesAt": "22:03",
				"waitsAtSource": 60,
				"distance": 14100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14809",
		"segments": [
			{
				"from": "Iaşi",
				"to": "Leţcani",
				"leavesAt": "19:07",
				"arrivesAt": "19:18",
				"waitsAtSource": 0,
				"distance": 14100
			},
			{
				"from": "Leţcani",
				"to": "Podu Iloaiei",
				"leavesAt": "19:19",
				"arrivesAt": "19:27",
				"waitsAtSource": 60,
				"distance": 8800
			},
			{
				"from": "Podu Iloaiei",
				"to": "Erbiceni hc.",
				"leavesAt": "19:35",
				"arrivesAt": "19:44",
				"waitsAtSource": 480,
				"distance": 6000
			},
			{
				"from": "Erbiceni hc.",
				"to": "Spinoasa h.",
				"leavesAt": "19:45",
				"arrivesAt": "19:53",
				"waitsAtSource": 60,
				"distance": 5100
			},
			{
				"from": "Spinoasa h.",
				"to": "Belceşti Hm.",
				"leavesAt": "19:54",
				"arrivesAt": "20:05",
				"waitsAtSource": 60,
				"distance": 9500
			},
			{
				"from": "Belceşti Hm.",
				"to": "Podu Ulmi h.",
				"leavesAt": "20:06",
				"arrivesAt": "20:11",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Podu Ulmi h.",
				"to": "Hodora h.",
				"leavesAt": "20:12",
				"arrivesAt": "20:17",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Hodora h.",
				"to": "Cotnari hc.",
				"leavesAt": "20:18",
				"arrivesAt": "20:23",
				"waitsAtSource": 60,
				"distance": 4300
			},
			{
				"from": "Cotnari hc.",
				"to": "Cepleniţa hc.",
				"leavesAt": "20:24",
				"arrivesAt": "20:28",
				"waitsAtSource": 60,
				"distance": 3700
			},
			{
				"from": "Cepleniţa hc.",
				"to": "Bădeni hc.",
				"leavesAt": "20:29",
				"arrivesAt": "20:34",
				"waitsAtSource": 60,
				"distance": 3200
			},
			{
				"from": "Bădeni hc.",
				"to": "Hârlău",
				"leavesAt": "20:35",
				"arrivesAt": "20:40",
				"waitsAtSource": 60,
				"distance": 2600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14358",
		"segments": [
			{
				"from": "Sânnicolau Mare",
				"to": "Saravale h.",
				"leavesAt": "04:01",
				"arrivesAt": "04:11",
				"waitsAtSource": 0,
				"distance": 7600
			},
			{
				"from": "Saravale h.",
				"to": "Sânpetru h.",
				"leavesAt": "04:12",
				"arrivesAt": "04:20",
				"waitsAtSource": 60,
				"distance": 6100
			},
			{
				"from": "Sânpetru h.",
				"to": "Periam",
				"leavesAt": "04:21",
				"arrivesAt": "04:27",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Periam",
				"to": "Aranca h.",
				"leavesAt": "04:36",
				"arrivesAt": "04:46",
				"waitsAtSource": 540,
				"distance": 11100
			},
			{
				"from": "Aranca h.",
				"to": "Secusigiu h",
				"leavesAt": "04:47",
				"arrivesAt": "04:50",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Secusigiu h",
				"to": "Munor h.",
				"leavesAt": "04:52",
				"arrivesAt": "04:56",
				"waitsAtSource": 120,
				"distance": 2800
			},
			{
				"from": "Munor h.",
				"to": "Sânpetru German h.",
				"leavesAt": "04:58",
				"arrivesAt": "05:02",
				"waitsAtSource": 120,
				"distance": 2600
			},
			{
				"from": "Sânpetru German h.",
				"to": "Felnac hc.",
				"leavesAt": "05:03",
				"arrivesAt": "05:10",
				"waitsAtSource": 60,
				"distance": 6700
			},
			{
				"from": "Felnac hc.",
				"to": "Bodrogu Nou h.",
				"leavesAt": "05:12",
				"arrivesAt": "05:18",
				"waitsAtSource": 120,
				"distance": 5200
			},
			{
				"from": "Bodrogu Nou h.",
				"to": "Zădăreni Hm.",
				"leavesAt": "05:20",
				"arrivesAt": "05:24",
				"waitsAtSource": 120,
				"distance": 1900
			},
			{
				"from": "Zădăreni Hm.",
				"to": "Aradu Nou",
				"leavesAt": "05:26",
				"arrivesAt": "05:36",
				"waitsAtSource": 120,
				"distance": 9600
			},
			{
				"from": "Aradu Nou",
				"to": "Arad",
				"leavesAt": "05:40",
				"arrivesAt": "05:47",
				"waitsAtSource": 240,
				"distance": 6200
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14321",
		"segments": [
			{
				"from": "Lovrin",
				"to": "Gotlob h.",
				"leavesAt": "16:01",
				"arrivesAt": "16:07",
				"waitsAtSource": 0,
				"distance": 6400
			},
			{
				"from": "Gotlob h.",
				"to": "Comloşu Mare h.",
				"leavesAt": "16:08",
				"arrivesAt": "16:15",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Comloşu Mare h.",
				"to": "Teremia Banat hc.",
				"leavesAt": "16:16",
				"arrivesAt": "16:25",
				"waitsAtSource": 30,
				"distance": 9200
			},
			{
				"from": "Teremia Banat hc.",
				"to": "Nerău hcv.",
				"leavesAt": "16:26",
				"arrivesAt": "16:33",
				"waitsAtSource": 30,
				"distance": 4500
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14978",
		"segments": [
			{
				"from": "Urziceni",
				"to": "Bărbuleşti h.",
				"leavesAt": "15:30",
				"arrivesAt": "15:34",
				"waitsAtSource": 0,
				"distance": 3500
			},
			{
				"from": "Bărbuleşti h.",
				"to": "Armăşeşti Hm.",
				"leavesAt": "15:35",
				"arrivesAt": "15:40",
				"waitsAtSource": 30,
				"distance": 3400
			},
			{
				"from": "Armăşeşti Hm.",
				"to": "Ialomiţa Hm.",
				"leavesAt": "15:41",
				"arrivesAt": "15:47",
				"waitsAtSource": 60,
				"distance": 5000
			},
			{
				"from": "Ialomiţa Hm.",
				"to": "Fulga hc.",
				"leavesAt": "15:48",
				"arrivesAt": "15:54",
				"waitsAtSource": 60,
				"distance": 6500
			},
			{
				"from": "Fulga hc.",
				"to": "Ciorani Hm.",
				"leavesAt": "15:55",
				"arrivesAt": "16:01",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Ciorani Hm.",
				"to": "Hătcărău h.",
				"leavesAt": "16:02",
				"arrivesAt": "16:07",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Hătcărău h.",
				"to": "Drăgăneşti Prahova Hm.",
				"leavesAt": "16:08",
				"arrivesAt": "16:12",
				"waitsAtSource": 30,
				"distance": 2500
			},
			{
				"from": "Drăgăneşti Prahova Hm.",
				"to": "Cornurile h.",
				"leavesAt": "16:13",
				"arrivesAt": "16:17",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Cornurile h.",
				"to": "Zănoaga Hm.",
				"leavesAt": "16:18",
				"arrivesAt": "16:23",
				"waitsAtSource": 30,
				"distance": 4700
			},
			{
				"from": "Zănoaga Hm.",
				"to": "Trestieni h.",
				"leavesAt": "16:24",
				"arrivesAt": "16:27",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Trestieni h.",
				"to": "Râfov h.",
				"leavesAt": "16:28",
				"arrivesAt": "16:32",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Râfov h.",
				"to": "Corlăteşti Hm.",
				"leavesAt": "16:33",
				"arrivesAt": "16:36",
				"waitsAtSource": 30,
				"distance": 1900
			},
			{
				"from": "Corlăteşti Hm.",
				"to": "Dâmbu Hm.",
				"leavesAt": "16:37",
				"arrivesAt": "16:42",
				"waitsAtSource": 60,
				"distance": 4500
			},
			{
				"from": "Dâmbu Hm.",
				"to": "Ploieşti Sud",
				"leavesAt": "16:43",
				"arrivesAt": "16:48",
				"waitsAtSource": 60,
				"distance": 3600
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14447",
		"segments": [
			{
				"from": "Arad",
				"to": "Utvinişu Nou",
				"leavesAt": "14:08",
				"arrivesAt": "14:16",
				"waitsAtSource": 0,
				"distance": 6500
			},
			{
				"from": "Utvinişu Nou",
				"to": "Zimandu Nou h.",
				"leavesAt": "14:17",
				"arrivesAt": "14:23",
				"waitsAtSource": 60,
				"distance": 6300
			},
			{
				"from": "Zimandu Nou h.",
				"to": "Sântana",
				"leavesAt": "14:24",
				"arrivesAt": "14:34",
				"waitsAtSource": 30,
				"distance": 10700
			},
			{
				"from": "Sântana",
				"to": "Şiria Hm.",
				"leavesAt": "14:35",
				"arrivesAt": "14:47",
				"waitsAtSource": 60,
				"distance": 11900
			},
			{
				"from": "Şiria Hm.",
				"to": "Mâsca Măderat h.",
				"leavesAt": "14:48",
				"arrivesAt": "14:52",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Mâsca Măderat h.",
				"to": "Pâncota h.",
				"leavesAt": "14:53",
				"arrivesAt": "14:56",
				"waitsAtSource": 60,
				"distance": 2700
			},
			{
				"from": "Pâncota h.",
				"to": "Seleuş h.",
				"leavesAt": "14:57",
				"arrivesAt": "15:01",
				"waitsAtSource": 60,
				"distance": 3300
			},
			{
				"from": "Seleuş h.",
				"to": "Târnova Zărand Hm.",
				"leavesAt": "15:02",
				"arrivesAt": "15:09",
				"waitsAtSource": 30,
				"distance": 7200
			},
			{
				"from": "Târnova Zărand Hm.",
				"to": "Mocrea h.",
				"leavesAt": "15:10",
				"arrivesAt": "15:15",
				"waitsAtSource": 60,
				"distance": 6200
			},
			{
				"from": "Mocrea h.",
				"to": "Ineu",
				"leavesAt": "15:16",
				"arrivesAt": "15:21",
				"waitsAtSource": 30,
				"distance": 4600
			},
			{
				"from": "Ineu",
				"to": "Tămand h.",
				"leavesAt": "15:40",
				"arrivesAt": "15:48",
				"waitsAtSource": 1140,
				"distance": 8400
			},
			{
				"from": "Tămand h.",
				"to": "Bocsig  h",
				"leavesAt": "15:49",
				"arrivesAt": "15:53",
				"waitsAtSource": 60,
				"distance": 3600
			},
			{
				"from": "Bocsig  h",
				"to": "Răpsig h.",
				"leavesAt": "15:54",
				"arrivesAt": "16:00",
				"waitsAtSource": 60,
				"distance": 5200
			},
			{
				"from": "Răpsig h.",
				"to": "Sebiş",
				"leavesAt": "16:01",
				"arrivesAt": "16:11",
				"waitsAtSource": 60,
				"distance": 10000
			},
			{
				"from": "Sebiş",
				"to": "Paulian h.",
				"leavesAt": "16:31",
				"arrivesAt": "16:36",
				"waitsAtSource": 1200,
				"distance": 4900
			},
			{
				"from": "Paulian h.",
				"to": "Joia Mare hc.",
				"leavesAt": "16:37",
				"arrivesAt": "16:41",
				"waitsAtSource": 60,
				"distance": 4100
			},
			{
				"from": "Joia Mare hc.",
				"to": "Almaş h.",
				"leavesAt": "16:42",
				"arrivesAt": "16:47",
				"waitsAtSource": 60,
				"distance": 5300
			},
			{
				"from": "Almaş h.",
				"to": "Bonţeşti h.",
				"leavesAt": "16:48",
				"arrivesAt": "16:53",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Bonţeşti h.",
				"to": "Gurahonţ",
				"leavesAt": "16:54",
				"arrivesAt": "16:58",
				"waitsAtSource": 60,
				"distance": 2900
			},
			{
				"from": "Gurahonţ",
				"to": "Romaniţa h.",
				"leavesAt": "17:02",
				"arrivesAt": "17:10",
				"waitsAtSource": 240,
				"distance": 6100
			},
			{
				"from": "Romaniţa h.",
				"to": "Aciuţa h.",
				"leavesAt": "17:11",
				"arrivesAt": "17:15",
				"waitsAtSource": 30,
				"distance": 2600
			},
			{
				"from": "Aciuţa h.",
				"to": "Tălagiu h.",
				"leavesAt": "17:16",
				"arrivesAt": "17:22",
				"waitsAtSource": 60,
				"distance": 5400
			},
			{
				"from": "Tălagiu h.",
				"to": "Vârfurile Hm.",
				"leavesAt": "17:23",
				"arrivesAt": "17:29",
				"waitsAtSource": 30,
				"distance": 4500
			},
			{
				"from": "Vârfurile Hm.",
				"to": "Cariera Leasa h.",
				"leavesAt": "17:45",
				"arrivesAt": "17:49",
				"waitsAtSource": 960,
				"distance": 3600
			},
			{
				"from": "Cariera Leasa h.",
				"to": "Hălmagiu Hm.",
				"leavesAt": "17:50",
				"arrivesAt": "17:55",
				"waitsAtSource": 30,
				"distance": 3900
			},
			{
				"from": "Hălmagiu Hm.",
				"to": "Ocişor h.",
				"leavesAt": "17:56",
				"arrivesAt": "18:01",
				"waitsAtSource": 60,
				"distance": 4400
			},
			{
				"from": "Ocişor h.",
				"to": "Ociu h.",
				"leavesAt": "18:02",
				"arrivesAt": "18:05",
				"waitsAtSource": 60,
				"distance": 2000
			},
			{
				"from": "Ociu h.",
				"to": "Vaţa h.",
				"leavesAt": "18:06",
				"arrivesAt": "18:11",
				"waitsAtSource": 60,
				"distance": 4000
			},
			{
				"from": "Vaţa h.",
				"to": "Birtin h.",
				"leavesAt": "18:12",
				"arrivesAt": "18:18",
				"waitsAtSource": 60,
				"distance": 4800
			},
			{
				"from": "Birtin h.",
				"to": "Lunca Moţilor h.",
				"leavesAt": "18:19",
				"arrivesAt": "18:24",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Lunca Moţilor h.",
				"to": "Baia de Criş h.",
				"leavesAt": "18:25",
				"arrivesAt": "18:28",
				"waitsAtSource": 60,
				"distance": 2400
			},
			{
				"from": "Baia de Criş h.",
				"to": "Ţebea h",
				"leavesAt": "18:29",
				"arrivesAt": "18:32",
				"waitsAtSource": 30,
				"distance": 2100
			},
			{
				"from": "Ţebea h",
				"to": "Ribiţa h.",
				"leavesAt": "18:33",
				"arrivesAt": "18:36",
				"waitsAtSource": 60,
				"distance": 2300
			},
			{
				"from": "Ribiţa h.",
				"to": "Brad",
				"leavesAt": "18:37",
				"arrivesAt": "18:43",
				"waitsAtSource": 60,
				"distance": 3400
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	},
	{
		"type": "R",
		"operator": "RGT",
		"number": "14714",
		"segments": [
			{
				"from": "Zărneşti",
				"to": "G-ral T.Moşoiu hc.",
				"leavesAt": "18:35",
				"arrivesAt": "18:38",
				"waitsAtSource": 0,
				"distance": 1800
			},
			{
				"from": "G-ral T.Moşoiu hc.",
				"to": "Tohanu Vechi hc.",
				"leavesAt": "18:39",
				"arrivesAt": "18:41",
				"waitsAtSource": 60,
				"distance": 2200
			},
			{
				"from": "Tohanu Vechi hc.",
				"to": "Râşnov h.",
				"leavesAt": "18:42",
				"arrivesAt": "18:47",
				"waitsAtSource": 30,
				"distance": 5400
			},
			{
				"from": "Râşnov h.",
				"to": "Râşnov",
				"leavesAt": "18:48",
				"arrivesAt": "18:51",
				"waitsAtSource": 30,
				"distance": 1800
			},
			{
				"from": "Râşnov",
				"to": "Cristian Hm.",
				"leavesAt": "18:52",
				"arrivesAt": "18:56",
				"waitsAtSource": 60,
				"distance": 3400
			},
			{
				"from": "Cristian Hm.",
				"to": "Lustic h.",
				"leavesAt": "18:57",
				"arrivesAt": "19:00",
				"waitsAtSource": 60,
				"distance": 2600
			},
			{
				"from": "Lustic h.",
				"to": "Bartolomeu",
				"leavesAt": "19:01",
				"arrivesAt": "19:08",
				"waitsAtSource": 30,
				"distance": 6700
			},
			{
				"from": "Bartolomeu",
				"to": "Braşov",
				"leavesAt": "19:09",
				"arrivesAt": "19:15",
				"waitsAtSource": 60,
				"distance": 3100
			}
		],
		"restrictions": [
			{
				"from": "20161211",
				"to": "20171209",
				"daysOfWeek": 16767
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/trains.json
 ** module id = 296
 ** module chunks = 0
 **/